// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var data = [
  {
    pdg: 1,
    name: "d",
    latex: "d",
    mass: 4.7,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -1,
    name: "d~",
    latex: "\\overline{d}",
    mass: 4.7,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 2,
    name: "u",
    latex: "u",
    mass: 2.16,
    width: undefined,
    charge: 0.6666666666666666,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -2,
    name: "u~",
    latex: "\\overline{u}",
    mass: 2.16,
    width: undefined,
    charge: -0.6666666666666666,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 3,
    name: "s",
    latex: "s",
    mass: 92.9,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3,
    name: "s~",
    latex: "\\overline{s}",
    mass: 92.9,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 4,
    name: "c",
    latex: "c",
    mass: 1273.0,
    width: undefined,
    charge: 0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4,
    name: "c~",
    latex: "\\overline{c}",
    mass: 1273.0,
    width: undefined,
    charge: -0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 5,
    name: "b",
    latex: "b",
    mass: 4186.0,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -5,
    name: "b~",
    latex: "\\overline{b}",
    mass: 4186.0,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 6,
    name: "t",
    latex: "t",
    mass: 172600.0,
    width: 1420.0,
    charge: 0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -6,
    name: "t~",
    latex: "\\overline{t}",
    mass: 172600.0,
    width: 1420.0,
    charge: -0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 11,
    name: "e-",
    latex: "e^{-}",
    mass: 0.51099895069,
    width: 0.0,
    charge: -1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -11,
    name: "e+",
    latex: "e^{+}",
    mass: 0.51099895069,
    width: 0.0,
    charge: 1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 12,
    name: "nu(e)",
    latex: "\\nu_{e}",
    mass: undefined,
    width: 0.0,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -12,
    name: "nu(e)~",
    latex: "\\overline{\\nu}_{e}",
    mass: undefined,
    width: 0.0,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 13,
    name: "mu-",
    latex: "\\mu^{-}",
    mass: 105.6583755,
    width: 2.9959836e-16,
    charge: -1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -13,
    name: "mu+",
    latex: "\\mu^{+}",
    mass: 105.6583755,
    width: 2.9959836e-16,
    charge: 1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 14,
    name: "nu(mu)",
    latex: "\\nu_{\\mu}",
    mass: undefined,
    width: 0.0,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -14,
    name: "nu(mu)~",
    latex: "\\overline{\\nu}_{\\mu}",
    mass: undefined,
    width: 0.0,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 15,
    name: "tau-",
    latex: "\\tau^{-}",
    mass: 1776.93,
    width: 2.267e-09,
    charge: -1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -15,
    name: "tau+",
    latex: "\\tau^{+}",
    mass: 1776.93,
    width: 2.267e-09,
    charge: 1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 16,
    name: "nu(tau)",
    latex: "\\nu_{\\tau}",
    mass: undefined,
    width: 0.0,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -16,
    name: "nu(tau)~",
    latex: "\\overline{\\nu}_{\\tau}",
    mass: undefined,
    width: 0.0,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 17,
    name: "tau'-",
    latex: "\\tau^{\\prime -}",
    mass: undefined,
    width: undefined,
    charge: -1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -17,
    name: "tau'+",
    latex: "\\tau^{\\prime +}",
    mass: undefined,
    width: undefined,
    charge: 1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 18,
    name: "nu(tau')",
    latex: "\\nu_{\\tau^\\prime}",
    mass: undefined,
    width: undefined,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -18,
    name: "nu(tau')~",
    latex: "\\overline{\\nu}_{\\tau^\\prime}",
    mass: undefined,
    width: undefined,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 21,
    name: "g",
    latex: "g",
    mass: 0.0,
    width: 0.0,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: false
  },
  {
    pdg: 22,
    name: "gamma",
    latex: "\\gamma",
    mass: 0.0,
    width: 0.0,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 23,
    name: "Z0",
    latex: "Z^{0}",
    mass: 91187.9,
    width: 2495.5,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: false
  },
  {
    pdg: 24,
    name: "W+",
    latex: "W^{+}",
    mass: 80362.0,
    width: 2140.0,
    charge: 1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -24,
    name: "W-",
    latex: "W^{-}",
    mass: 80362.0,
    width: 2140.0,
    charge: -1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 25,
    name: "H0",
    latex: "H^{0}",
    mass: 125130.0,
    width: 3.0,
    charge: 0.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: false
  },
  {
    pdg: 111,
    name: "pi0",
    latex: "\\pi^{0}",
    mass: 134.9768,
    width: 7.81e-06,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 113,
    name: "rho(770)0",
    latex: "\\rho(770)^{0}",
    mass: 775.26,
    width: 147.4,
    charge: 0.0,
    iValue: 1.0,
    gValue: 1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 115,
    name: "a(2)(1320)0",
    latex: "a_{2}(1320)^{0}",
    mass: 1318.2,
    width: 107.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 117,
    name: "rho(3)(1690)0",
    latex: "\\rho_{3}(1690)^{0}",
    mass: 1688.8,
    width: 161.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 119,
    name: "a(4)(1970)0",
    latex: "a_{4}(1970)^{0}",
    mass: 1967.0,
    width: 324.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 130,
    name: "K(L)0",
    latex: "K_{L}^{0}",
    mass: 497.611,
    width: 1.287e-14,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: false
  },
  {
    pdg: 211,
    name: "pi+",
    latex: "\\pi^{+}",
    mass: 139.57039,
    width: 2.5284e-14,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -211,
    name: "pi-",
    latex: "\\pi^{-}",
    mass: 139.57039,
    width: 2.5284e-14,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 213,
    name: "rho(770)+",
    latex: "\\rho(770)^{+}",
    mass: 775.11,
    width: 149.1,
    charge: 1.0,
    iValue: 1.0,
    gValue: 1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -213,
    name: "rho(770)-",
    latex: "\\rho(770)^{-}",
    mass: 775.11,
    width: 149.1,
    charge: -1.0,
    iValue: 1.0,
    gValue: 1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 215,
    name: "a(2)(1320)+",
    latex: "a_{2}(1320)^{+}",
    mass: 1318.2,
    width: 107.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -215,
    name: "a(2)(1320)-",
    latex: "a_{2}(1320)^{-}",
    mass: 1318.2,
    width: 107.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 217,
    name: "rho(3)(1690)+",
    latex: "\\rho_{3}(1690)^{+}",
    mass: 1688.8,
    width: 161.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -217,
    name: "rho(3)(1690)-",
    latex: "\\rho_{3}(1690)^{-}",
    mass: 1688.8,
    width: 161.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 219,
    name: "a(4)(1970)+",
    latex: "a_{4}(1970)^{+}",
    mass: 1967.0,
    width: 324.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -219,
    name: "a(4)(1970)-",
    latex: "a_{4}(1970)^{-}",
    mass: 1967.0,
    width: 324.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 221,
    name: "eta",
    latex: "\\eta",
    mass: 547.862,
    width: 0.00131,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 223,
    name: "omega(782)",
    latex: "\\omega(782)",
    mass: 782.66,
    width: 8.68,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 225,
    name: "f(2)(1270)",
    latex: "f_{2}(1270)",
    mass: 1275.4,
    width: 186.6,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 227,
    name: "omega(3)(1670)",
    latex: "\\omega_{3}(1670)",
    mass: 1667.0,
    width: 168.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 229,
    name: "f(4)(2050)",
    latex: "f_{4}(2050)",
    mass: 2018.0,
    width: 237.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 310,
    name: "K(S)0",
    latex: "K_{S}^{0}",
    mass: 497.611,
    width: 7.3508e-12,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: false
  },
  {
    pdg: 311,
    name: "K0",
    latex: "K^{0}",
    mass: 497.611,
    width: undefined,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -311,
    name: "K~0",
    latex: "\\overline{K}^{0}",
    mass: 497.611,
    width: undefined,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 313,
    name: "K*(892)0",
    latex: "K^{*}(892)^{0}",
    mass: 895.56,
    width: 47.1,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -313,
    name: "K*(892)~0",
    latex: "\\overline{K}^{*}(892)^{0}",
    mass: 895.56,
    width: 47.1,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 315,
    name: "K(2)*(1430)0",
    latex: "K_{2}^{*}(1430)^{0}",
    mass: 1432.4,
    width: 109.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -315,
    name: "K(2)*(1430)~0",
    latex: "\\overline{K}_{2}^{*}(1430)^{0}",
    mass: 1432.4,
    width: 109.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 317,
    name: "K(3)*(1780)0",
    latex: "K_{3}^{*}(1780)^{0}",
    mass: 1779.0,
    width: 161.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -317,
    name: "K(3)*(1780)~0",
    latex: "\\overline{K}_{3}^{*}(1780)^{0}",
    mass: 1779.0,
    width: 161.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 319,
    name: "K(4)*(2045)0",
    latex: "K_{4}^{*}(2045)^{0}",
    mass: 2048.0,
    width: 199.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -319,
    name: "K(4)*(2045)~0",
    latex: "\\overline{K}_{4}^{*}(2045)^{0}",
    mass: 2048.0,
    width: 199.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 321,
    name: "K+",
    latex: "K^{+}",
    mass: 493.677,
    width: 5.317e-14,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -321,
    name: "K-",
    latex: "K^{-}",
    mass: 493.677,
    width: 5.317e-14,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 323,
    name: "K*(892)+",
    latex: "K^{*}(892)^{+}",
    mass: 891.88,
    width: 48.5,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -323,
    name: "K*(892)-",
    latex: "K^{*}(892)^{-}",
    mass: 891.88,
    width: 48.5,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 325,
    name: "K(2)*(1430)+",
    latex: "K_{2}^{*}(1430)^{+}",
    mass: 1427.3,
    width: 100.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -325,
    name: "K(2)*(1430)-",
    latex: "K_{2}^{*}(1430)^{-}",
    mass: 1427.3,
    width: 100.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 327,
    name: "K(3)*(1780)+",
    latex: "K_{3}^{*}(1780)^{+}",
    mass: 1779.0,
    width: 161.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -327,
    name: "K(3)*(1780)-",
    latex: "K_{3}^{*}(1780)^{-}",
    mass: 1779.0,
    width: 161.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 329,
    name: "K(4)*(2045)+",
    latex: "K_{4}^{*}(2045)^{+}",
    mass: 2048.0,
    width: 199.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -329,
    name: "K(4)*(2045)-",
    latex: "K_{4}^{*}(2045)^{-}",
    mass: 2048.0,
    width: 199.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 331,
    name: "eta'(958)",
    latex: "\\eta^\\prime(958)",
    mass: 957.78,
    width: 0.188,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 333,
    name: "phi(1020)",
    latex: "\\phi(1020)",
    mass: 1019.46,
    width: 4.249,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 335,
    name: "f(2)'(1525)",
    latex: "f_{2}^\\prime(1525)",
    mass: 1517.3,
    width: 72.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 337,
    name: "phi(3)(1850)",
    latex: "\\phi_{3}(1850)",
    mass: 1854.0,
    width: 87.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 411,
    name: "D+",
    latex: "D^{+}",
    mass: 1869.66,
    width: 6.37e-10,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -411,
    name: "D-",
    latex: "D^{-}",
    mass: 1869.66,
    width: 6.37e-10,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 413,
    name: "D*(2010)+",
    latex: "D^{*}(2010)^{+}",
    mass: 2010.27,
    width: 0.0834,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -413,
    name: "D*(2010)-",
    latex: "D^{*}(2010)^{-}",
    mass: 2010.27,
    width: 0.0834,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 415,
    name: "D(2)*(2460)+",
    latex: "D_{2}^{*}(2460)^{+}",
    mass: 2461.1,
    width: 47.3,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -415,
    name: "D(2)*(2460)-",
    latex: "D_{2}^{*}(2460)^{-}",
    mass: 2461.1,
    width: 47.3,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 421,
    name: "D0",
    latex: "D^{0}",
    mass: 1864.84,
    width: 1.604e-09,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -421,
    name: "D~0",
    latex: "\\overline{D}^{0}",
    mass: 1864.84,
    width: 1.604e-09,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 423,
    name: "D*(2007)0",
    latex: "D^{*}(2007)^{0}",
    mass: 2006.86,
    width: 2.1,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -423,
    name: "D*(2007)~0",
    latex: "\\overline{D}^{*}(2007)^{0}",
    mass: 2006.86,
    width: 2.1,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 425,
    name: "D(2)*(2460)0",
    latex: "D_{2}^{*}(2460)^{0}",
    mass: 2461.1,
    width: 47.3,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -425,
    name: "D(2)*(2460)~0",
    latex: "\\overline{D}_{2}^{*}(2460)^{0}",
    mass: 2461.1,
    width: 47.3,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 431,
    name: "D(s)+",
    latex: "D_{s}^{+}",
    mass: 1968.35,
    width: 1.313e-09,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -431,
    name: "D(s)-",
    latex: "D_{s}^{-}",
    mass: 1968.35,
    width: 1.313e-09,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 433,
    name: "D(s)*+",
    latex: "D_{s}^{*+}",
    mass: 2112.2,
    width: undefined,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -433,
    name: "D(s)*-",
    latex: "D_{s}^{*-}",
    mass: 2112.2,
    width: undefined,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 435,
    name: "D(s2)*(2573)+",
    latex: "D_{s2}^{*}(2573)^{+}",
    mass: 2569.1,
    width: 16.9,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -435,
    name: "D(s2)*(2573)-",
    latex: "D_{s2}^{*}(2573)^{-}",
    mass: 2569.1,
    width: 16.9,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 441,
    name: "eta(c)(1S)",
    latex: "\\eta_{c}(1S)",
    mass: 2984.09,
    width: 30.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 443,
    name: "J/psi(1S)",
    latex: "J/\\psi(1S)",
    mass: 3096.9,
    width: 0.0926,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 445,
    name: "chi(c2)(1P)",
    latex: "\\chi_{c2}(1P)",
    mass: 3556.17,
    width: 1.94,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 511,
    name: "B0",
    latex: "B^{0}",
    mass: 5279.72,
    width: 4.355e-10,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -511,
    name: "B~0",
    latex: "\\overline{B}^{0}",
    mass: 5279.72,
    width: 4.355e-10,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 513,
    name: "B*0",
    latex: "B^{*0}",
    mass: 5324.75,
    width: undefined,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -513,
    name: "B*~0",
    latex: "\\overline{B}^{*0}",
    mass: 5324.75,
    width: undefined,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 515,
    name: "B(2)*(5747)0",
    latex: "B_{2}^{*}(5747)^{0}",
    mass: 5739.6,
    width: 24.2,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -515,
    name: "B(2)*(5747)~0",
    latex: "\\overline{B}_{2}^{*}(5747)^{0}",
    mass: 5739.6,
    width: 24.2,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 521,
    name: "B+",
    latex: "B^{+}",
    mass: 5279.41,
    width: 4.021e-10,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -521,
    name: "B-",
    latex: "B^{-}",
    mass: 5279.41,
    width: 4.021e-10,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 523,
    name: "B*+",
    latex: "B^{*+}",
    mass: 5324.75,
    width: undefined,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -523,
    name: "B*-",
    latex: "B^{*-}",
    mass: 5324.75,
    width: undefined,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 525,
    name: "B(2)*(5747)+",
    latex: "B_{2}^{*}(5747)^{+}",
    mass: 5737.3,
    width: 20.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -525,
    name: "B(2)*(5747)-",
    latex: "B_{2}^{*}(5747)^{-}",
    mass: 5737.3,
    width: 20.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 531,
    name: "B(s)0",
    latex: "B_{s}^{0}",
    mass: 5366.93,
    width: 4.345e-10,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -531,
    name: "B(s)~0",
    latex: "\\overline{B}_{s}^{0}",
    mass: 5366.93,
    width: 4.345e-10,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 533,
    name: "B(s)*0",
    latex: "B_{s}^{*0}",
    mass: 5415.4,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -533,
    name: "B(s)*~0",
    latex: "\\overline{B}_{s}^{*0}",
    mass: 5415.4,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 535,
    name: "B(s2)*(5840)0",
    latex: "B_{s2}^{*}(5840)^{0}",
    mass: 5839.88,
    width: 1.49,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -535,
    name: "B(s2)*(5840)~0",
    latex: "\\overline{B}_{s2}^{*}(5840)^{0}",
    mass: 5839.88,
    width: 1.49,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 541,
    name: "B(c)+",
    latex: "B_{c}^{+}",
    mass: 6274.47,
    width: 1.291e-09,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -541,
    name: "B(c)-",
    latex: "B_{c}^{-}",
    mass: 6274.47,
    width: 1.291e-09,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 551,
    name: "eta(b)(1S)",
    latex: "\\eta_{b}(1S)",
    mass: 9398.7,
    width: 10.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 553,
    name: "Upsilon(1S)",
    latex: "\\Upsilon(1S)",
    mass: 9460.4,
    width: 0.054,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 555,
    name: "chi(b2)(1P)",
    latex: "\\chi_{b2}(1P)",
    mass: 9912.2,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 1103,
    name: "(dd)(1)",
    latex: "(dd)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.6666666666666666,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1103,
    name: "(dd)(1)~",
    latex: "(dd)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.6666666666666666,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1112,
    name: "Delta(1620)-",
    latex: "\\Delta(1620)^{-}",
    mass: 1610.0,
    width: 130.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -1112,
    name: "Delta(1620)~+",
    latex: "\\overline{\\Delta}(1620)^{+}",
    mass: 1610.0,
    width: 130.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 1114,
    name: "Delta(1232)-",
    latex: "\\Delta(1232)^{-}",
    mass: 1232.0,
    width: 117.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -1114,
    name: "Delta(1232)~+",
    latex: "\\overline{\\Delta}(1232)^{+}",
    mass: 1232.0,
    width: 117.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 1116,
    name: "Delta(1905)-",
    latex: "\\Delta(1905)^{-}",
    mass: 1880.0,
    width: 330.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -1116,
    name: "Delta(1905)~+",
    latex: "\\overline{\\Delta}(1905)^{+}",
    mass: 1880.0,
    width: 330.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 1118,
    name: "Delta(1950)-",
    latex: "\\Delta(1950)^{-}",
    mass: 1930.0,
    width: 280.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -1118,
    name: "Delta(1950)~+",
    latex: "\\overline{\\Delta}(1950)^{+}",
    mass: 1930.0,
    width: 280.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 1212,
    name: "Delta(1620)0",
    latex: "\\Delta(1620)^{0}",
    mass: 1610.0,
    width: 130.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -1212,
    name: "Delta(1620)~0",
    latex: "\\overline{\\Delta}(1620)^{0}",
    mass: 1610.0,
    width: 130.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 1214,
    name: "N(1520)0",
    latex: "N(1520)^{0}",
    mass: 1515.0,
    width: 110.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -1214,
    name: "N(1520)~0",
    latex: "\\overline{N}(1520)^{0}",
    mass: 1515.0,
    width: 110.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 1216,
    name: "Delta(1905)0",
    latex: "\\Delta(1905)^{0}",
    mass: 1880.0,
    width: 330.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -1216,
    name: "Delta(1905)~0",
    latex: "\\overline{\\Delta}(1905)^{0}",
    mass: 1880.0,
    width: 330.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 1218,
    name: "N(2190)0",
    latex: "N(2190)^{0}",
    mass: 2180.0,
    width: 400.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -1218,
    name: "N(2190)~0",
    latex: "\\overline{N}(2190)^{0}",
    mass: 2180.0,
    width: 400.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 2101,
    name: "(ud)(0)",
    latex: "(ud)_{0}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -2101,
    name: "(ud)(0)~",
    latex: "(ud)_{0}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 2103,
    name: "(ud)(1)",
    latex: "(ud)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -2103,
    name: "(ud)(1)~",
    latex: "(ud)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 2112,
    name: "n",
    latex: "n",
    mass: 939.5654219,
    width: 7.494e-25,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -2112,
    name: "n~",
    latex: "\\overline{n}",
    mass: 939.5654219,
    width: 7.494e-25,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 2114,
    name: "Delta(1232)0",
    latex: "\\Delta(1232)^{0}",
    mass: 1232.0,
    width: 117.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -2114,
    name: "Delta(1232)~0",
    latex: "\\overline{\\Delta}(1232)^{0}",
    mass: 1232.0,
    width: 117.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 2116,
    name: "N(1675)0",
    latex: "N(1675)^{0}",
    mass: 1675.0,
    width: 145.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -2116,
    name: "N(1675)~0",
    latex: "\\overline{N}(1675)^{0}",
    mass: 1675.0,
    width: 145.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 2118,
    name: "Delta(1950)0",
    latex: "\\Delta(1950)^{0}",
    mass: 1930.0,
    width: 280.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -2118,
    name: "Delta(1950)~0",
    latex: "\\overline{\\Delta}(1950)^{0}",
    mass: 1930.0,
    width: 280.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 2122,
    name: "Delta(1620)+",
    latex: "\\Delta(1620)^{+}",
    mass: 1610.0,
    width: 130.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -2122,
    name: "Delta(1620)~-",
    latex: "\\overline{\\Delta}(1620)^{-}",
    mass: 1610.0,
    width: 130.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 2124,
    name: "N(1520)+",
    latex: "N(1520)^{+}",
    mass: 1515.0,
    width: 110.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -2124,
    name: "N(1520)~-",
    latex: "\\overline{N}(1520)^{-}",
    mass: 1515.0,
    width: 110.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 2126,
    name: "Delta(1905)+",
    latex: "\\Delta(1905)^{+}",
    mass: 1880.0,
    width: 330.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -2126,
    name: "Delta(1905)~-",
    latex: "\\overline{\\Delta}(1905)^{-}",
    mass: 1880.0,
    width: 330.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 2128,
    name: "N(2190)+",
    latex: "N(2190)^{+}",
    mass: 2180.0,
    width: 400.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -2128,
    name: "N(2190)~-",
    latex: "\\overline{N}(2190)^{-}",
    mass: 2180.0,
    width: 400.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 2203,
    name: "(uu)(1)",
    latex: "(uu)_{1}",
    mass: undefined,
    width: undefined,
    charge: 1.3333333333333333,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -2203,
    name: "(uu)(1)~",
    latex: "(uu)_{1}",
    mass: undefined,
    width: undefined,
    charge: -1.3333333333333333,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 2212,
    name: "p",
    latex: "p",
    mass: 938.27208943,
    width: 0.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -2212,
    name: "p~",
    latex: "\\overline{p}",
    mass: 938.27208943,
    width: 0.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 2214,
    name: "Delta(1232)+",
    latex: "\\Delta(1232)^{+}",
    mass: 1232.0,
    width: 117.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -2214,
    name: "Delta(1232)~-",
    latex: "\\overline{\\Delta}(1232)^{-}",
    mass: 1232.0,
    width: 117.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 2216,
    name: "N(1675)+",
    latex: "N(1675)^{+}",
    mass: 1675.0,
    width: 145.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -2216,
    name: "N(1675)~-",
    latex: "\\overline{N}(1675)^{-}",
    mass: 1675.0,
    width: 145.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 2218,
    name: "Delta(1950)+",
    latex: "\\Delta(1950)^{+}",
    mass: 1930.0,
    width: 280.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -2218,
    name: "Delta(1950)~-",
    latex: "\\overline{\\Delta}(1950)^{-}",
    mass: 1930.0,
    width: 280.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 2222,
    name: "Delta(1620)++",
    latex: "\\Delta(1620)^{++}",
    mass: 1610.0,
    width: 130.0,
    charge: 2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -2222,
    name: "Delta(1620)~--",
    latex: "\\overline{\\Delta}(1620)^{--}",
    mass: 1610.0,
    width: 130.0,
    charge: -2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 2224,
    name: "Delta(1232)++",
    latex: "\\Delta(1232)^{++}",
    mass: 1232.0,
    width: 117.0,
    charge: 2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -2224,
    name: "Delta(1232)~--",
    latex: "\\overline{\\Delta}(1232)^{--}",
    mass: 1232.0,
    width: 117.0,
    charge: -2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 2226,
    name: "Delta(1905)++",
    latex: "\\Delta(1905)^{++}",
    mass: 1880.0,
    width: 330.0,
    charge: 2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -2226,
    name: "Delta(1905)~--",
    latex: "\\overline{\\Delta}(1905)^{--}",
    mass: 1880.0,
    width: 330.0,
    charge: -2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 2228,
    name: "Delta(1950)++",
    latex: "\\Delta(1950)^{++}",
    mass: 1930.0,
    width: 280.0,
    charge: 2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -2228,
    name: "Delta(1950)~--",
    latex: "\\overline{\\Delta}(1950)^{--}",
    mass: 1930.0,
    width: 280.0,
    charge: -2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3101,
    name: "(sd)(0)",
    latex: "(sd)_{0}",
    mass: undefined,
    width: undefined,
    charge: -0.6666666666666666,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -3101,
    name: "(sd)(0)~",
    latex: "(sd)_{0}",
    mass: undefined,
    width: undefined,
    charge: 0.6666666666666666,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 3103,
    name: "(sd)(1)",
    latex: "(sd)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.6666666666666666,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -3103,
    name: "(sd)(1)~",
    latex: "(sd)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.6666666666666666,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 3112,
    name: "Sigma-",
    latex: "\\Sigma^{-}",
    mass: 1197.449,
    width: 4.45e-12,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3112,
    name: "Sigma~+",
    latex: "\\overline{\\Sigma}^{+}",
    mass: 1197.449,
    width: 4.45e-12,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3114,
    name: "Sigma(1385)-",
    latex: "\\Sigma(1385)^{-}",
    mass: 1387.2,
    width: 39.4,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3114,
    name: "Sigma(1385)~+",
    latex: "\\overline{\\Sigma}(1385)^{+}",
    mass: 1387.2,
    width: 39.4,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3116,
    name: "Sigma(1775)-",
    latex: "\\Sigma(1775)^{-}",
    mass: 1775.0,
    width: 120.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -3116,
    name: "Sigma(1775)~+",
    latex: "\\overline{\\Sigma}(1775)^{+}",
    mass: 1775.0,
    width: 120.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 3118,
    name: "Sigma(2030)-",
    latex: "\\Sigma(2030)^{-}",
    mass: 2030.0,
    width: 180.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3118,
    name: "Sigma(2030)~+",
    latex: "\\overline{\\Sigma}(2030)^{+}",
    mass: 2030.0,
    width: 180.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3122,
    name: "Lambda",
    latex: "\\Lambda",
    mass: 1115.683,
    width: 2.515e-12,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3122,
    name: "Lambda~",
    latex: "\\overline{\\Lambda}",
    mass: 1115.683,
    width: 2.515e-12,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3124,
    name: "Lambda(1520)",
    latex: "\\Lambda(1520)",
    mass: 1519.0,
    width: 16.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -3124,
    name: "Lambda(1520)~",
    latex: "\\overline{\\Lambda}(1520)",
    mass: 1519.0,
    width: 16.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 3126,
    name: "Lambda(1820)",
    latex: "\\Lambda(1820)",
    mass: 1820.0,
    width: 80.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3126,
    name: "Lambda(1820)~",
    latex: "\\overline{\\Lambda}(1820)",
    mass: 1820.0,
    width: 80.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3128,
    name: "Lambda(2100)",
    latex: "\\Lambda(2100)",
    mass: 2100.0,
    width: 200.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -3128,
    name: "Lambda(2100)~",
    latex: "\\overline{\\Lambda}(2100)",
    mass: 2100.0,
    width: 200.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 3201,
    name: "(su)(0)",
    latex: "(su)_{0}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -3201,
    name: "(su)(0)~",
    latex: "(su)_{0}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 3203,
    name: "(su)(1)",
    latex: "(su)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -3203,
    name: "(su)(1)~",
    latex: "(su)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 3212,
    name: "Sigma0",
    latex: "\\Sigma^{0}",
    mass: 1192.642,
    width: 0.0089,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3212,
    name: "Sigma~0",
    latex: "\\overline{\\Sigma}^{0}",
    mass: 1192.642,
    width: 0.0089,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3214,
    name: "Sigma(1385)0",
    latex: "\\Sigma(1385)^{0}",
    mass: 1383.8,
    width: 44.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3214,
    name: "Sigma(1385)~0",
    latex: "\\overline{\\Sigma}(1385)^{0}",
    mass: 1383.8,
    width: 44.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3216,
    name: "Sigma(1775)0",
    latex: "\\Sigma(1775)^{0}",
    mass: 1775.0,
    width: 120.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -3216,
    name: "Sigma(1775)~0",
    latex: "\\overline{\\Sigma}(1775)^{0}",
    mass: 1775.0,
    width: 120.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 3218,
    name: "Sigma(2030)0",
    latex: "\\Sigma(2030)^{0}",
    mass: 2030.0,
    width: 180.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3218,
    name: "Sigma(2030)~0",
    latex: "\\overline{\\Sigma}(2030)^{0}",
    mass: 2030.0,
    width: 180.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3222,
    name: "Sigma+",
    latex: "\\Sigma^{+}",
    mass: 1189.37,
    width: 8.209e-12,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3222,
    name: "Sigma~-",
    latex: "\\overline{\\Sigma}^{-}",
    mass: 1189.37,
    width: 8.209e-12,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3224,
    name: "Sigma(1385)+",
    latex: "\\Sigma(1385)^{+}",
    mass: 1382.83,
    width: 36.2,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3224,
    name: "Sigma(1385)~-",
    latex: "\\overline{\\Sigma}(1385)^{-}",
    mass: 1382.83,
    width: 36.2,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3226,
    name: "Sigma(1775)+",
    latex: "\\Sigma(1775)^{+}",
    mass: 1775.0,
    width: 120.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -3226,
    name: "Sigma(1775)~-",
    latex: "\\overline{\\Sigma}(1775)^{-}",
    mass: 1775.0,
    width: 120.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 3228,
    name: "Sigma(2030)+",
    latex: "\\Sigma(2030)^{+}",
    mass: 2030.0,
    width: 180.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3228,
    name: "Sigma(2030)~-",
    latex: "\\overline{\\Sigma}(2030)^{-}",
    mass: 2030.0,
    width: 180.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3303,
    name: "(ss)(1)",
    latex: "(ss)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -3303,
    name: "(ss)(1)~",
    latex: "(ss)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 3312,
    name: "Xi-",
    latex: "\\Xi^{-}",
    mass: 1321.71,
    width: 4.02e-12,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3312,
    name: "Xi~+",
    latex: "\\overline{\\Xi}^{+}",
    mass: 1321.71,
    width: 4.02e-12,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3314,
    name: "Xi(1530)-",
    latex: "\\Xi(1530)^{-}",
    mass: 1535.0,
    width: 9.9,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3314,
    name: "Xi(1530)~+",
    latex: "\\overline{\\Xi}(1530)^{+}",
    mass: 1535.0,
    width: 9.9,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3322,
    name: "Xi0",
    latex: "\\Xi^{0}",
    mass: 1314.86,
    width: 2.27e-12,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3322,
    name: "Xi~0",
    latex: "\\overline{\\Xi}^{0}",
    mass: 1314.86,
    width: 2.27e-12,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3324,
    name: "Xi(1530)0",
    latex: "\\Xi(1530)^{0}",
    mass: 1531.8,
    width: 9.1,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3324,
    name: "Xi(1530)~0",
    latex: "\\overline{\\Xi}(1530)^{0}",
    mass: 1531.8,
    width: 9.1,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 3334,
    name: "Omega-",
    latex: "\\Omega^{-}",
    mass: 1672.45,
    width: 8.02e-12,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -3334,
    name: "Omega~+",
    latex: "\\overline{\\Omega}^{+}",
    mass: 1672.45,
    width: 8.02e-12,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4101,
    name: "(cd)(0)",
    latex: "(cd)_{0}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -4101,
    name: "(cd)(0)~",
    latex: "(cd)_{0}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 4103,
    name: "(cd)(1)",
    latex: "(cd)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -4103,
    name: "(cd)(1)~",
    latex: "(cd)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 4112,
    name: "Sigma(c)(2455)0",
    latex: "\\Sigma_{c}^{0}",
    mass: 2453.75,
    width: 1.83,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4112,
    name: "Sigma(c)(2455)~0",
    latex: "\\overline{\\Sigma}_{c}^{0}",
    mass: 2453.75,
    width: 1.83,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4114,
    name: "Sigma(c)(2520)0",
    latex: "\\Sigma_{c}(2520)^{0}",
    mass: 2518.48,
    width: 15.3,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4114,
    name: "Sigma(c)(2520)~0",
    latex: "\\overline{\\Sigma}_{c}(2520)^{0}",
    mass: 2518.48,
    width: 15.3,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4122,
    name: "Lambda(c)+",
    latex: "\\Lambda_{c}^{+}",
    mass: 2286.46,
    width: 3.248e-09,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4122,
    name: "Lambda(c)~-",
    latex: "\\overline{\\Lambda}_{c}^{-}",
    mass: 2286.46,
    width: 3.248e-09,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4132,
    name: "Xi(c)0",
    latex: "\\Xi_{c}^{0}",
    mass: 2470.5,
    width: 4.39e-09,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4132,
    name: "Xi(c)~0",
    latex: "\\overline{\\Xi}_{c}^{0}",
    mass: 2470.5,
    width: 4.39e-09,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4201,
    name: "(cu)(0)",
    latex: "(cu)_{0}",
    mass: undefined,
    width: undefined,
    charge: 1.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -4201,
    name: "(cu)(0)~",
    latex: "(cu)_{0}",
    mass: undefined,
    width: undefined,
    charge: -1.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 4203,
    name: "(cu)(1)",
    latex: "(cu)_{1}",
    mass: undefined,
    width: undefined,
    charge: 1.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -4203,
    name: "(cu)(1)~",
    latex: "(cu)_{1}",
    mass: undefined,
    width: undefined,
    charge: -1.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 4212,
    name: "Sigma(c)(2455)+",
    latex: "\\Sigma_{c}(2455)^{+}",
    mass: 2452.65,
    width: 2.3,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4212,
    name: "Sigma(c)(2455)~-",
    latex: "\\overline{\\Sigma}_{c}(2455)^{-}",
    mass: 2452.65,
    width: 2.3,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4214,
    name: "Sigma(c)(2520)+",
    latex: "\\Sigma_{c}(2520)^{+}",
    mass: 2517.4,
    width: 17.2,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4214,
    name: "Sigma(c)(2520)~-",
    latex: "\\overline{\\Sigma}_{c}(2520)^{-}",
    mass: 2517.4,
    width: 17.2,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4222,
    name: "Sigma(c)(2455)++",
    latex: "\\Sigma_{c}(2455)^{++}",
    mass: 2453.97,
    width: 1.89,
    charge: 2.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4222,
    name: "Sigma(c)(2455)~--",
    latex: "\\overline{\\Sigma}_{c}(2455)^{--}",
    mass: 2453.97,
    width: 1.89,
    charge: -2.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4224,
    name: "Sigma(c)(2520)++",
    latex: "\\Sigma_{c}(2520)^{++}",
    mass: 2518.41,
    width: 14.78,
    charge: 2.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4224,
    name: "Sigma(c)(2520)~--",
    latex: "\\overline{\\Sigma}_{c}(2520)^{--}",
    mass: 2518.41,
    width: 14.78,
    charge: -2.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4232,
    name: "Xi(c)+",
    latex: "\\Xi_{c}^{+}",
    mass: 2467.79,
    width: 1.453e-09,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4232,
    name: "Xi(c)~-",
    latex: "\\overline{\\Xi}_{c}^{-}",
    mass: 2467.79,
    width: 1.453e-09,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4301,
    name: "(cs)(0)",
    latex: "(cs)_{0}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -4301,
    name: "(cs)(0)~",
    latex: "(cs)_{0}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 4303,
    name: "(cs)(1)",
    latex: "(cs)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -4303,
    name: "(cs)(1)~",
    latex: "(cs)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 4312,
    name: "Xi(c)'0",
    latex: "\\Xi_{c}^{\\prime 0}",
    mass: 2578.8,
    width: undefined,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4312,
    name: "Xi(c)'~0",
    latex: "\\overline{\\Xi}_{c}^{\\prime 0}",
    mass: 2578.8,
    width: undefined,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4314,
    name: "Xi(c)(2645)0",
    latex: "\\Xi_{c}(2645)^{0}",
    mass: 2646.24,
    width: 2.35,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4314,
    name: "Xi(c)(2645)~0",
    latex: "\\overline{\\Xi}_{c}(2645)^{0}",
    mass: 2646.24,
    width: 2.35,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4322,
    name: "Xi(c)'+",
    latex: "\\Xi_{c}^{\\prime +}",
    mass: 2578.3,
    width: undefined,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4322,
    name: "Xi(c)'~-",
    latex: "\\overline{\\Xi}_{c}^{\\prime -}",
    mass: 2578.3,
    width: undefined,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4324,
    name: "Xi(c)(2645)+",
    latex: "\\Xi_{c}(2645)^{+}",
    mass: 2645.17,
    width: 2.14,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4324,
    name: "Xi(c)(2645)~-",
    latex: "\\overline{\\Xi}_{c}(2645)^{-}",
    mass: 2645.17,
    width: 2.14,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4332,
    name: "Omega(c)0",
    latex: "\\Omega_{c}^{0}",
    mass: 2695.3,
    width: 2.41e-09,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4332,
    name: "Omega(c)~0",
    latex: "\\overline{\\Omega}_{c}^{0}",
    mass: 2695.3,
    width: 2.41e-09,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4334,
    name: "Omega(c)(2770)0",
    latex: "\\Omega_{c}(2770)^{0}",
    mass: 2766.0,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -4334,
    name: "Omega(c)(2770)~0",
    latex: "\\overline{\\Omega}_{c}(2770)^{0}",
    mass: 2766.0,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 4403,
    name: "(cc)(1)",
    latex: "(cc)_{1}",
    mass: undefined,
    width: undefined,
    charge: 1.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -4403,
    name: "(cc)(1)~",
    latex: "(cc)_{1}",
    mass: undefined,
    width: undefined,
    charge: -1.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 5101,
    name: "(bd)(0)",
    latex: "(bd)_{0}",
    mass: undefined,
    width: undefined,
    charge: -0.6666666666666666,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -5101,
    name: "(bd)(0)~",
    latex: "(bd)_{0}",
    mass: undefined,
    width: undefined,
    charge: 0.6666666666666666,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 5103,
    name: "(bd)(1)",
    latex: "(bd)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.6666666666666666,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -5103,
    name: "(bd)(1)~",
    latex: "(bd)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.6666666666666666,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 5112,
    name: "Sigma(b)-",
    latex: "\\Sigma_{b}^{-}",
    mass: 5815.64,
    width: 5.3,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -5112,
    name: "Sigma(b)~+",
    latex: "\\overline{\\Sigma}_{b}^{+}",
    mass: 5815.64,
    width: 5.3,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 5114,
    name: "Sigma(b)*-",
    latex: "\\Sigma_{b}^{*-}",
    mass: 5834.74,
    width: 10.4,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -5114,
    name: "Sigma(b)*~+",
    latex: "\\overline{\\Sigma}_{b}^{*+}",
    mass: 5834.74,
    width: 10.4,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 5122,
    name: "Lambda(b)0",
    latex: "\\Lambda_{b}^{0}",
    mass: 5619.57,
    width: 4.493e-10,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -5122,
    name: "Lambda(b)~0",
    latex: "\\overline{\\Lambda}_{b}^{0}",
    mass: 5619.57,
    width: 4.493e-10,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 5132,
    name: "Xi(b)-",
    latex: "\\Xi_{b}^{-}",
    mass: 5797.0,
    width: 4.18e-10,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -5132,
    name: "Xi(b)~+",
    latex: "\\overline{\\Xi}_{b}^{+}",
    mass: 5797.0,
    width: 4.18e-10,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 5201,
    name: "(bu)(0)",
    latex: "(bu)_{0}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -5201,
    name: "(bu)(0)~",
    latex: "(bu)_{0}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 5203,
    name: "(bu)(1)",
    latex: "(bu)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -5203,
    name: "(bu)(1)~",
    latex: "(bu)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 5222,
    name: "Sigma(b)+",
    latex: "\\Sigma_{b}^{+}",
    mass: 5810.56,
    width: 5.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -5222,
    name: "Sigma(b)~-",
    latex: "\\overline{\\Sigma}_{b}^{-}",
    mass: 5810.56,
    width: 5.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 5224,
    name: "Sigma(b)*+",
    latex: "\\Sigma_{b}^{*+}",
    mass: 5830.32,
    width: 9.4,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -5224,
    name: "Sigma(b)*~-",
    latex: "\\overline{\\Sigma}_{b}^{*-}",
    mass: 5830.32,
    width: 9.4,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 5232,
    name: "Xi(b)0",
    latex: "\\Xi_{b}^{0}",
    mass: 5791.7,
    width: 4.47e-10,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -5232,
    name: "Xi(b)~0",
    latex: "\\overline{\\Xi}_{b}^{0}",
    mass: 5791.7,
    width: 4.47e-10,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 5301,
    name: "(bs)(0)",
    latex: "(bs)_{0}",
    mass: undefined,
    width: undefined,
    charge: -0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -5301,
    name: "(bs)(0)~",
    latex: "(bs)_{0}",
    mass: undefined,
    width: undefined,
    charge: 0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 5303,
    name: "(bs)(1)",
    latex: "(bs)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -5303,
    name: "(bs)(1)~",
    latex: "(bs)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 5332,
    name: "Omega(b)-",
    latex: "\\Omega_{b}^{-}",
    mass: 6045.8,
    width: 4e-10,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -5332,
    name: "Omega(b)~+",
    latex: "\\overline{\\Omega}_{b}^{+}",
    mass: 6045.8,
    width: 4e-10,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 5401,
    name: "(bc)(0)",
    latex: "(bc)_{0}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -5401,
    name: "(bc)(0)~",
    latex: "(bc)_{0}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 5403,
    name: "(bc)(1)",
    latex: "(bc)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -5403,
    name: "(bc)(1)~",
    latex: "(bc)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.3333333333333333,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 5503,
    name: "(bb)(1)",
    latex: "(bb)_{1}",
    mass: undefined,
    width: undefined,
    charge: -0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -5503,
    name: "(bb)(1)~",
    latex: "(bb)_{1}",
    mass: undefined,
    width: undefined,
    charge: 0.6666666666666666,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 10111,
    name: "a(0)(1450)0",
    latex: "a_{0}(1450)^{0}",
    mass: 1439.0,
    width: 258.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 10113,
    name: "b(1)(1235)0",
    latex: "b_{1}(1235)^{0}",
    mass: 1229.5,
    width: 142.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 1,
    cValue: -1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 10115,
    name: "pi(2)(1670)0",
    latex: "\\pi_{2}(1670)^{0}",
    mass: 1670.6,
    width: 258.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 10211,
    name: "a(0)(1450)+",
    latex: "a_{0}(1450)^{+}",
    mass: 1439.0,
    width: 258.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -10211,
    name: "a(0)(1450)-",
    latex: "a_{0}(1450)^{-}",
    mass: 1439.0,
    width: 258.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 10213,
    name: "b(1)(1235)+",
    latex: "b_{1}(1235)^{+}",
    mass: 1229.5,
    width: 142.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -10213,
    name: "b(1)(1235)-",
    latex: "b_{1}(1235)^{-}",
    mass: 1229.5,
    width: 142.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 10215,
    name: "pi(2)(1670)+",
    latex: "\\pi_{2}(1670)^{+}",
    mass: 1670.6,
    width: 258.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -10215,
    name: "pi(2)(1670)-",
    latex: "\\pi_{2}(1670)^{-}",
    mass: 1670.6,
    width: 258.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 10221,
    name: "f(0)(1370)",
    latex: "f_{0}(1370)",
    mass: 1350.0,
    width: 350.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 10223,
    name: "h(1)(1170)",
    latex: "h_{1}(1170)",
    mass: 1166.0,
    width: 375.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 10225,
    name: "eta(2)(1645)",
    latex: "\\eta_{2}(1645)",
    mass: 1617.0,
    width: 181.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 10311,
    name: "K(0)*(1430)0",
    latex: "K_{0}^{*}(1430)^{0}",
    mass: 1430.0,
    width: 270.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -10311,
    name: "K(0)*(1430)~0",
    latex: "\\overline{K}_{0}^{*}(1430)^{0}",
    mass: 1430.0,
    width: 270.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 10313,
    name: "K(1)(1270)0",
    latex: "K_{1}(1270)^{0}",
    mass: 1256.0,
    width: 90.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -10313,
    name: "K(1)(1270)~0",
    latex: "\\overline{K}_{1}(1270)^{0}",
    mass: 1256.0,
    width: 90.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 10315,
    name: "K(2)(1770)0",
    latex: "K_{2}(1770)^{0}",
    mass: 1773.0,
    width: 186.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -10315,
    name: "K(2)(1770)~0",
    latex: "\\overline{K}_{2}(1770)^{0}",
    mass: 1773.0,
    width: 186.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 10321,
    name: "K(0)*(1430)+",
    latex: "K_{0}^{*}(1430)^{+}",
    mass: 1430.0,
    width: 270.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -10321,
    name: "K(0)*(1430)-",
    latex: "K_{0}^{*}(1430)^{-}",
    mass: 1430.0,
    width: 270.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 10323,
    name: "K(1)(1270)+",
    latex: "K_{1}(1270)^{+}",
    mass: 1256.0,
    width: 90.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -10323,
    name: "K(1)(1270)-",
    latex: "K_{1}(1270)^{-}",
    mass: 1256.0,
    width: 90.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 10325,
    name: "K(2)(1770)+",
    latex: "K_{2}(1770)^{+}",
    mass: 1773.0,
    width: 186.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -10325,
    name: "K(2)(1770)-",
    latex: "K_{2}(1770)^{-}",
    mass: 1773.0,
    width: 186.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 10331,
    name: "f(0)(1710)",
    latex: "f_{0}(1710)",
    mass: 1723.0,
    width: 149.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 10333,
    name: "h(1)(1415)",
    latex: "h_{1}(1415)",
    mass: 1409.0,
    width: 78.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 10335,
    name: "eta(2)(1870)",
    latex: "\\eta_{2}(1870)",
    mass: 1842.0,
    width: 225.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 10411,
    name: "D(0)*(2300)+",
    latex: "D_{0}^{*}(2300)^{+}",
    mass: 2343.0,
    width: 229.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -10411,
    name: "D(0)*(2300)-",
    latex: "D_{0}^{*}(2300)^{-}",
    mass: 2343.0,
    width: 229.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 10413,
    name: "D(1)(2420)+",
    latex: "D_{1}(2420)^{+}",
    mass: 2422.1,
    width: 31.3,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -10413,
    name: "D(1)(2420)-",
    latex: "D_{1}(2420)^{-}",
    mass: 2422.1,
    width: 31.3,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 10421,
    name: "D(0)*(2300)0",
    latex: "D_{0}^{*}(2300)^{0}",
    mass: 2343.0,
    width: 229.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -10421,
    name: "D(0)*(2300)~0",
    latex: "\\overline{D}_{0}^{*}(2300)^{0}",
    mass: 2343.0,
    width: 229.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 10423,
    name: "D(1)(2420)0",
    latex: "D_{1}(2420)^{0}",
    mass: 2422.1,
    width: 31.3,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -10423,
    name: "D(1)(2420)~0",
    latex: "\\overline{D}_{1}(2420)^{0}",
    mass: 2422.1,
    width: 31.3,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 10431,
    name: "D(s0)*(2317)+",
    latex: "D_{s0}^{*}(2317)^{+}",
    mass: 2317.8,
    width: 10.0,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -10431,
    name: "D(s0)*(2317)-",
    latex: "D_{s0}^{*}(2317)^{-}",
    mass: 2317.8,
    width: 10.0,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 10433,
    name: "D(s1)(2536)+",
    latex: "D_{s1}(2536)^{+}",
    mass: 2535.12,
    width: 0.92,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -10433,
    name: "D(s1)(2536)-",
    latex: "D_{s1}(2536)^{-}",
    mass: 2535.12,
    width: 0.92,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 10441,
    name: "chi(c0)(1P)",
    latex: "\\chi_{c0}(1P)",
    mass: 3415.5,
    width: 12.4,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 10443,
    name: "h(c)(1P)",
    latex: "h_{c}(1P)",
    mass: 3525.37,
    width: 0.78,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 10551,
    name: "chi(b0)(1P)",
    latex: "\\chi_{b0}(1P)",
    mass: 9859.4,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 10553,
    name: "h(b)(1P)",
    latex: "h_{b}(1P)",
    mass: 9899.3,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 11112,
    name: "Delta(1900)-",
    latex: "\\Delta(1900)^{-}",
    mass: 1860.0,
    width: 250.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -11112,
    name: "Delta(1900)~+",
    latex: "\\overline{\\Delta}(1900)^{+}",
    mass: 1860.0,
    width: 250.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 11114,
    name: "Delta(1700)-",
    latex: "\\Delta(1700)^{-}",
    mass: 1710.0,
    width: 300.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -11114,
    name: "Delta(1700)~+",
    latex: "\\overline{\\Delta}(1700)^{+}",
    mass: 1710.0,
    width: 300.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 11116,
    name: "Delta(1930)-",
    latex: "\\Delta(1930)^{-}",
    mass: 1950.0,
    width: 300.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -11116,
    name: "Delta(1930)~+",
    latex: "\\overline{\\Delta}(1930)^{+}",
    mass: 1950.0,
    width: 300.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 11212,
    name: "Delta(1900)0",
    latex: "\\Delta(1900)^{0}",
    mass: 1860.0,
    width: 250.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -11212,
    name: "Delta(1900)~0",
    latex: "\\overline{\\Delta}(1900)^{0}",
    mass: 1860.0,
    width: 250.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 11216,
    name: "Delta(1930)0",
    latex: "\\Delta(1930)^{0}",
    mass: 1950.0,
    width: 300.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -11216,
    name: "Delta(1930)~0",
    latex: "\\overline{\\Delta}(1930)^{0}",
    mass: 1950.0,
    width: 300.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 12112,
    name: "N(1440)0",
    latex: "N(1440)^{0}",
    mass: 1440.0,
    width: 350.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -12112,
    name: "N(1440)~0",
    latex: "\\overline{N}(1440)^{0}",
    mass: 1440.0,
    width: 350.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 12114,
    name: "Delta(1700)0",
    latex: "\\Delta(1700)^{0}",
    mass: 1710.0,
    width: 300.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -12114,
    name: "Delta(1700)~0",
    latex: "\\overline{\\Delta}(1700)^{0}",
    mass: 1710.0,
    width: 300.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 12116,
    name: "N(1680)0",
    latex: "N(1680)^{0}",
    mass: 1685.0,
    width: 120.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -12116,
    name: "N(1680)~0",
    latex: "\\overline{N}(1680)^{0}",
    mass: 1685.0,
    width: 120.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 12122,
    name: "Delta(1900)+",
    latex: "\\Delta(1900)^{+}",
    mass: 1860.0,
    width: 250.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -12122,
    name: "Delta(1900)~-",
    latex: "\\overline{\\Delta}(1900)^{-}",
    mass: 1860.0,
    width: 250.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 12126,
    name: "Delta(1930)+",
    latex: "\\Delta(1930)^{+}",
    mass: 1950.0,
    width: 300.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -12126,
    name: "Delta(1930)~-",
    latex: "\\overline{\\Delta}(1930)^{-}",
    mass: 1950.0,
    width: 300.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 12212,
    name: "N(1440)+",
    latex: "N(1440)^{+}",
    mass: 1440.0,
    width: 350.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -12212,
    name: "N(1440)~-",
    latex: "\\overline{N}(1440)^{-}",
    mass: 1440.0,
    width: 350.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 12214,
    name: "Delta(1700)+",
    latex: "\\Delta(1700)^{+}",
    mass: 1710.0,
    width: 300.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -12214,
    name: "Delta(1700)~-",
    latex: "\\overline{\\Delta}(1700)^{-}",
    mass: 1710.0,
    width: 300.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 12216,
    name: "N(1680)+",
    latex: "N(1680)^{+}",
    mass: 1685.0,
    width: 120.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -12216,
    name: "N(1680)~-",
    latex: "\\overline{N}(1680)^{-}",
    mass: 1685.0,
    width: 120.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 12222,
    name: "Delta(1900)++",
    latex: "\\Delta(1900)^{++}",
    mass: 1860.0,
    width: 250.0,
    charge: 2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -12222,
    name: "Delta(1900)~--",
    latex: "\\overline{\\Delta}(1900)^{--}",
    mass: 1860.0,
    width: 250.0,
    charge: -2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 12224,
    name: "Delta(1700)++",
    latex: "\\Delta(1700)^{++}",
    mass: 1710.0,
    width: 300.0,
    charge: 2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -12224,
    name: "Delta(1700)~--",
    latex: "\\overline{\\Delta}(1700)^{--}",
    mass: 1710.0,
    width: 300.0,
    charge: -2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 12226,
    name: "Delta(1930)++",
    latex: "\\Delta(1930)^{++}",
    mass: 1950.0,
    width: 300.0,
    charge: 2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -12226,
    name: "Delta(1930)~--",
    latex: "\\overline{\\Delta}(1930)^{--}",
    mass: 1950.0,
    width: 300.0,
    charge: -2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 13112,
    name: "Sigma(1660)-",
    latex: "\\Sigma(1660)^{-}",
    mass: 1660.0,
    width: 200.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -13112,
    name: "Sigma(1660)~+",
    latex: "\\overline{\\Sigma}(1660)^{+}",
    mass: 1660.0,
    width: 200.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 13114,
    name: "Sigma(1670)-",
    latex: "\\Sigma(1670)^{-}",
    mass: 1675.0,
    width: 70.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -13114,
    name: "Sigma(1670)~+",
    latex: "\\overline{\\Sigma}(1670)^{+}",
    mass: 1675.0,
    width: 70.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 13116,
    name: "Sigma(1915)-",
    latex: "\\Sigma(1915)^{-}",
    mass: 1915.0,
    width: 120.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -13116,
    name: "Sigma(1915)~+",
    latex: "\\overline{\\Sigma}(1915)^{+}",
    mass: 1915.0,
    width: 120.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 13122,
    name: "Lambda(1405)",
    latex: "\\Lambda(1405)",
    mass: 1405.1,
    width: 50.5,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -13122,
    name: "Lambda(1405)~",
    latex: "\\overline{\\Lambda}(1405)",
    mass: 1405.1,
    width: 50.5,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 13124,
    name: "Lambda(1690)",
    latex: "\\Lambda(1690)",
    mass: 1690.0,
    width: 70.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -13124,
    name: "Lambda(1690)~",
    latex: "\\overline{\\Lambda}(1690)",
    mass: 1690.0,
    width: 70.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 13126,
    name: "Lambda(1830)",
    latex: "\\Lambda(1830)",
    mass: 1825.0,
    width: 90.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -13126,
    name: "Lambda(1830)~",
    latex: "\\overline{\\Lambda}(1830)",
    mass: 1825.0,
    width: 90.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 13212,
    name: "Sigma(1660)0",
    latex: "\\Sigma(1660)^{0}",
    mass: 1660.0,
    width: 200.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -13212,
    name: "Sigma(1660)~0",
    latex: "\\overline{\\Sigma}(1660)^{0}",
    mass: 1660.0,
    width: 200.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 13214,
    name: "Sigma(1670)0",
    latex: "\\Sigma(1670)^{0}",
    mass: 1675.0,
    width: 70.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -13214,
    name: "Sigma(1670)~0",
    latex: "\\overline{\\Sigma}(1670)^{0}",
    mass: 1675.0,
    width: 70.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 13216,
    name: "Sigma(1915)0",
    latex: "\\Sigma(1915)^{0}",
    mass: 1915.0,
    width: 120.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -13216,
    name: "Sigma(1915)~0",
    latex: "\\overline{\\Sigma}(1915)^{0}",
    mass: 1915.0,
    width: 120.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 13222,
    name: "Sigma(1660)+",
    latex: "\\Sigma(1660)^{+}",
    mass: 1660.0,
    width: 200.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -13222,
    name: "Sigma(1660)~-",
    latex: "\\overline{\\Sigma}(1660)^{-}",
    mass: 1660.0,
    width: 200.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 13224,
    name: "Sigma(1670)+",
    latex: "\\Sigma(1670)^{+}",
    mass: 1675.0,
    width: 70.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -13224,
    name: "Sigma(1670)~-",
    latex: "\\overline{\\Sigma}(1670)^{-}",
    mass: 1675.0,
    width: 70.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 13226,
    name: "Sigma(1915)+",
    latex: "\\Sigma(1915)^{+}",
    mass: 1915.0,
    width: 120.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -13226,
    name: "Sigma(1915)~-",
    latex: "\\overline{\\Sigma}(1915)^{-}",
    mass: 1915.0,
    width: 120.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 13314,
    name: "Xi(1820)-",
    latex: "\\Xi(1820)^{-}",
    mass: 1823.0,
    width: 24.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -13314,
    name: "Xi(1820)~+",
    latex: "\\overline{\\Xi}(1820)^{+}",
    mass: 1823.0,
    width: 24.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 13324,
    name: "Xi(1820)0",
    latex: "\\Xi(1820)^{0}",
    mass: 1823.0,
    width: 24.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -13324,
    name: "Xi(1820)~0",
    latex: "\\overline{\\Xi}(1820)^{0}",
    mass: 1823.0,
    width: 24.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 14122,
    name: "Lambda(c)(2595)+",
    latex: "\\Lambda_{c}(2593)^{+}",
    mass: 2592.25,
    width: 2.6,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -14122,
    name: "Lambda(c)(2595)~-",
    latex: "\\overline{\\Lambda}_{c}(2593)^{-}",
    mass: 2592.25,
    width: 2.6,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 20113,
    name: "a(1)(1260)0",
    latex: "a_{1}(1260)^{0}",
    mass: 1230.0,
    width: 420.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 20213,
    name: "a(1)(1260)+",
    latex: "a_{1}(1260)^{+}",
    mass: 1230.0,
    width: 420.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -20213,
    name: "a(1)(1260)-",
    latex: "a_{1}(1260)^{-}",
    mass: 1230.0,
    width: 420.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 20223,
    name: "f(1)(1285)",
    latex: "f_{1}(1285)",
    mass: 1281.8,
    width: 23.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 20313,
    name: "K(1)(1400)0",
    latex: "K_{1}(1400)^{0}",
    mass: 1403.0,
    width: 174.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -20313,
    name: "K(1)(1400)~0",
    latex: "\\overline{K}_{1}(1400)^{0}",
    mass: 1403.0,
    width: 174.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 20315,
    name: "K(2)(1820)0",
    latex: "K_{2}(1820)^{0}",
    mass: 1819.0,
    width: 264.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -20315,
    name: "K(2)(1820)~0",
    latex: "\\overline{K}_{2}(1820)^{0}",
    mass: 1819.0,
    width: 264.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 20323,
    name: "K(1)(1400)+",
    latex: "K_{1}(1400)^{+}",
    mass: 1403.0,
    width: 174.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -20323,
    name: "K(1)(1400)-",
    latex: "K_{1}(1400)^{-}",
    mass: 1403.0,
    width: 174.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 20325,
    name: "K(2)(1820)+",
    latex: "K_{2}(1820)^{+}",
    mass: 1819.0,
    width: 264.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -20325,
    name: "K(2)(1820)-",
    latex: "K_{2}(1820)^{-}",
    mass: 1819.0,
    width: 264.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 20333,
    name: "f(1)(1420)",
    latex: "f_{1}(1420)",
    mass: 1427.7,
    width: 55.4,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 20423,
    name: "D(1)(2430)0",
    latex: "D_{1}(2430)^{0}",
    mass: 2412.0,
    width: 314.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -20423,
    name: "D(1)(2430)~0",
    latex: "\\overline{D}_{1}(2430)^{0}",
    mass: 2412.0,
    width: 314.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 20433,
    name: "D(s1)(2460)+",
    latex: "D_{s1}(2460)^{+}",
    mass: 2459.5,
    width: 6.3,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -20433,
    name: "D(s1)(2460)-",
    latex: "D_{s1}(2460)^{-}",
    mass: 2459.5,
    width: 6.3,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 20443,
    name: "chi(c1)(1P)",
    latex: "\\chi_{c1}(1P)",
    mass: 3510.67,
    width: 0.82,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 20553,
    name: "chi(b1)(1P)",
    latex: "\\chi_{b1}(1P)",
    mass: 9892.8,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 20555,
    name: "Upsilon(2)(1D)",
    latex: "\\Upsilon_{2}(1D)",
    mass: 10163.7,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 21112,
    name: "Delta(1910)-",
    latex: "\\Delta(1910)^{-}",
    mass: 1900.0,
    width: 300.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -21112,
    name: "Delta(1910)~+",
    latex: "\\overline{\\Delta}(1910)^{+}",
    mass: 1900.0,
    width: 300.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 21114,
    name: "Delta(1920)-",
    latex: "\\Delta(1920)^{-}",
    mass: 1920.0,
    width: 300.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -21114,
    name: "Delta(1920)~+",
    latex: "\\overline{\\Delta}(1920)^{+}",
    mass: 1920.0,
    width: 300.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 21212,
    name: "Delta(1910)0",
    latex: "\\Delta(1910)^{0}",
    mass: 1900.0,
    width: 300.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -21212,
    name: "Delta(1910)~0",
    latex: "\\overline{\\Delta}(1910)^{0}",
    mass: 1900.0,
    width: 300.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 21214,
    name: "N(1700)0",
    latex: "N(1700)^{0}",
    mass: 1720.0,
    width: 200.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -21214,
    name: "N(1700)~0",
    latex: "\\overline{N}(1700)^{0}",
    mass: 1720.0,
    width: 200.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 22112,
    name: "N(1535)0",
    latex: "\\Delta(1910)^{0}",
    mass: 1530.0,
    width: 150.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -22112,
    name: "N(1535)~0",
    latex: "\\overline{\\Delta}(1910)^{0}",
    mass: 1530.0,
    width: 150.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 22114,
    name: "Delta(1920)0",
    latex: "\\Delta(1920)^{0}",
    mass: 1920.0,
    width: 300.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -22114,
    name: "Delta(1920)~0",
    latex: "\\overline{\\Delta}(1920)^{0}",
    mass: 1920.0,
    width: 300.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 22122,
    name: "Delta(1910)+",
    latex: "\\Delta(1910)^{+}",
    mass: 1900.0,
    width: 300.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -22122,
    name: "Delta(1910)~-",
    latex: "\\overline{\\Delta}(1910)^{-}",
    mass: 1900.0,
    width: 300.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 22124,
    name: "N(1700)+",
    latex: "N(1700)^{+}",
    mass: 1720.0,
    width: 200.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -22124,
    name: "N(1700)~-",
    latex: "\\overline{N}(1700)^{-}",
    mass: 1720.0,
    width: 200.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 22212,
    name: "N(1535)+",
    latex: "N(1535)^{+}",
    mass: 1530.0,
    width: 150.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -22212,
    name: "N(1535)~-",
    latex: "\\overline{N}(1535)^{-}",
    mass: 1530.0,
    width: 150.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 22214,
    name: "Delta(1920)+",
    latex: "\\Delta(1920)^{+}",
    mass: 1920.0,
    width: 300.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -22214,
    name: "Delta(1920)~-",
    latex: "\\overline{\\Delta}(1920)^{-}",
    mass: 1920.0,
    width: 300.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 22222,
    name: "Delta(1910)++",
    latex: "\\Delta(1910)^{++}",
    mass: 1900.0,
    width: 300.0,
    charge: 2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -22222,
    name: "Delta(1910)~--",
    latex: "\\overline{\\Delta}(1910)^{--}",
    mass: 1900.0,
    width: 300.0,
    charge: -2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 22224,
    name: "Delta(1920)++",
    latex: "\\Delta(1920)^{++}",
    mass: 1920.0,
    width: 300.0,
    charge: 2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -22224,
    name: "Delta(1920)~--",
    latex: "\\overline{\\Delta}(1920)^{--}",
    mass: 1920.0,
    width: 300.0,
    charge: -2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 23112,
    name: "Sigma(1750)-",
    latex: "\\Sigma(1750)^{-}",
    mass: 1750.0,
    width: 150.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -23112,
    name: "Sigma(1750)~+",
    latex: "\\overline{\\Sigma}(1750)^{+}",
    mass: 1750.0,
    width: 150.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 23114,
    name: "Sigma(1910)-",
    latex: "\\Sigma(1940)^{-}",
    mass: 1910.0,
    width: 220.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -23114,
    name: "Sigma(1910)~+",
    latex: "\\overline{\\Sigma}(1940)^{+}",
    mass: 1910.0,
    width: 220.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 23122,
    name: "Lambda(1600)",
    latex: "\\Lambda(1600)",
    mass: 1600.0,
    width: 200.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -23122,
    name: "Lambda(1600)~",
    latex: "\\overline{\\Lambda}(1600)",
    mass: 1600.0,
    width: 200.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 23124,
    name: "Lambda(1890)",
    latex: "\\Lambda(1890)",
    mass: 1890.0,
    width: 120.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -23124,
    name: "Lambda(1890)~",
    latex: "\\overline{\\Lambda}(1890)",
    mass: 1890.0,
    width: 120.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 23126,
    name: "Lambda(2110)",
    latex: "\\Lambda(2110)",
    mass: 2090.0,
    width: 250.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -23126,
    name: "Lambda(2110)~",
    latex: "\\overline{\\Lambda}(2110)",
    mass: 2090.0,
    width: 250.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 23212,
    name: "Sigma(1750)0",
    latex: "\\Sigma(1750)^{0}",
    mass: 1750.0,
    width: 150.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -23212,
    name: "Sigma(1750)~0",
    latex: "\\overline{\\Sigma}(1750)^{0}",
    mass: 1750.0,
    width: 150.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 23214,
    name: "Sigma(1910)0",
    latex: "\\Sigma(1940)^{0}",
    mass: 1910.0,
    width: 220.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -23214,
    name: "Sigma(1910)~0",
    latex: "\\overline{\\Sigma}(1940)^{0}",
    mass: 1910.0,
    width: 220.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 23222,
    name: "Sigma(1750)+",
    latex: "\\Sigma(1750)^{+}",
    mass: 1750.0,
    width: 150.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -23222,
    name: "Sigma(1750)~-",
    latex: "\\overline{\\Sigma}(1750)^{-}",
    mass: 1750.0,
    width: 150.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 23224,
    name: "Sigma(1910)+",
    latex: "\\Sigma(1940)^{+}",
    mass: 1910.0,
    width: 220.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -23224,
    name: "Sigma(1910)~-",
    latex: "\\overline{\\Sigma}(1940)^{-}",
    mass: 1910.0,
    width: 220.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 30113,
    name: "rho(1700)0",
    latex: "\\rho(1700)^{0}",
    mass: 1720.0,
    width: 250.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 30213,
    name: "rho(1700)+",
    latex: "\\rho(1700)^{+}",
    mass: 1720.0,
    width: 250.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -30213,
    name: "rho(1700)-",
    latex: "\\rho(1700)^{-}",
    mass: 1720.0,
    width: 250.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 30223,
    name: "omega(1650)",
    latex: "\\omega(1650)",
    mass: 1670.0,
    width: 150.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 30313,
    name: "K*(1680)0",
    latex: "K^{*}(1680)^{0}",
    mass: 1718.0,
    width: 320.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -30313,
    name: "K*(1680)~0",
    latex: "\\overline{K}^{*}(1680)^{0}",
    mass: 1718.0,
    width: 320.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 30323,
    name: "K*(1680)+",
    latex: "K^{*}(1680)^{+}",
    mass: 1718.0,
    width: 320.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -30323,
    name: "K*(1680)-",
    latex: "K^{*}(1680)^{-}",
    mass: 1718.0,
    width: 320.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 30443,
    name: "psi(3770)",
    latex: "\\psi(3770)",
    mass: 3773.7,
    width: 27.2,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 31114,
    name: "Delta(1600)-",
    latex: "\\Delta(1600)^{-}",
    mass: 1570.0,
    width: 250.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -31114,
    name: "Delta(1600)~+",
    latex: "\\overline{\\Delta}(1600)^{+}",
    mass: 1570.0,
    width: 250.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 31214,
    name: "N(1720)0",
    latex: "N(1720)^{0}",
    mass: 1720.0,
    width: 250.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -31214,
    name: "N(1720)~0",
    latex: "\\overline{N}(1720)^{0}",
    mass: 1720.0,
    width: 250.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 32112,
    name: "N(1650)0",
    latex: "N(1650)^{0}",
    mass: 1650.0,
    width: 125.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -32112,
    name: "N(1650)~0",
    latex: "\\overline{N}(1650)^{0}",
    mass: 1650.0,
    width: 125.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 32114,
    name: "Delta(1600)0",
    latex: "\\Delta(1600)^{0}",
    mass: 1570.0,
    width: 250.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -32114,
    name: "Delta(1600)~0",
    latex: "\\overline{\\Delta}(1600)^{0}",
    mass: 1570.0,
    width: 250.0,
    charge: 0.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 32124,
    name: "N(1720)+",
    latex: "N(1720)^{+}",
    mass: 1720.0,
    width: 250.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -32124,
    name: "N(1720)~-",
    latex: "\\overline{N}(1720)^{-}",
    mass: 1720.0,
    width: 250.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 32212,
    name: "N(1650)+",
    latex: "N(1650)^{+}",
    mass: 1650.0,
    width: 125.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -32212,
    name: "N(1650)~-",
    latex: "\\overline{N}(1650)^{-}",
    mass: 1650.0,
    width: 125.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 32214,
    name: "Delta(1600)+",
    latex: "\\Delta(1600)^{+}",
    mass: 1570.0,
    width: 250.0,
    charge: 1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -32214,
    name: "Delta(1600)~-",
    latex: "\\overline{\\Delta}(1600)^{-}",
    mass: 1570.0,
    width: 250.0,
    charge: -1.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 32224,
    name: "Delta(1600)++",
    latex: "\\Delta(1600)^{++}",
    mass: 1570.0,
    width: 250.0,
    charge: 2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -32224,
    name: "Delta(1600)~--",
    latex: "\\overline{\\Delta}(1600)^{--}",
    mass: 1570.0,
    width: 250.0,
    charge: -2.0,
    iValue: 1.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 33122,
    name: "Lambda(1670)",
    latex: "\\Lambda(1670)",
    mass: 1674.0,
    width: 30.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -33122,
    name: "Lambda(1670)~",
    latex: "\\overline{\\Lambda}(1670)",
    mass: 1674.0,
    width: 30.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 42112,
    name: "N(1710)0",
    latex: "N(1710)^{0}",
    mass: 1710.0,
    width: 140.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -42112,
    name: "N(1710)~0",
    latex: "\\overline{N}(1710)^{0}",
    mass: 1710.0,
    width: 140.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 42212,
    name: "N(1710)+",
    latex: "N(1710)^{+}",
    mass: 1710.0,
    width: 140.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -42212,
    name: "N(1710)~-",
    latex: "\\overline{N}(1710)^{-}",
    mass: 1710.0,
    width: 140.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 43122,
    name: "Lambda(1800)",
    latex: "\\Lambda(1800)",
    mass: 1800.0,
    width: 200.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -43122,
    name: "Lambda(1800)~",
    latex: "\\overline{\\Lambda}(1800)",
    mass: 1800.0,
    width: 200.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 53122,
    name: "Lambda(1810)",
    latex: "\\Lambda(1810)",
    mass: 1790.0,
    width: 110.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -53122,
    name: "Lambda(1810)~",
    latex: "\\overline{\\Lambda}(1810)",
    mass: 1790.0,
    width: 110.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 100111,
    name: "pi(1300)0",
    latex: "\\pi(1300)^{0}",
    mass: 1300.0,
    width: 400.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 100113,
    name: "rho(1450)0",
    latex: "\\rho(1450)^{0}",
    mass: 1465.0,
    width: 400.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: 1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 100211,
    name: "pi(1300)+",
    latex: "\\pi(1300)^{+}",
    mass: 1300.0,
    width: 400.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -100211,
    name: "pi(1300)-",
    latex: "\\pi(1300)^{-}",
    mass: 1300.0,
    width: 400.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 100213,
    name: "rho(1450)+",
    latex: "\\rho(1450)^{+}",
    mass: 1465.0,
    width: 400.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: 1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -100213,
    name: "rho(1450)-",
    latex: "\\rho(1450)^{-}",
    mass: 1465.0,
    width: 400.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: 1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 100221,
    name: "eta(1295)",
    latex: "\\eta(1295)",
    mass: 1294.0,
    width: 55.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 100223,
    name: "omega(1420)",
    latex: "\\omega(1420)",
    mass: 1410.0,
    width: 290.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 100313,
    name: "K*(1410)0",
    latex: "K^{*}(1410)^{0}",
    mass: 1414.0,
    width: 232.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -100313,
    name: "K*(1410)~0",
    latex: "\\overline{K}^{*}(1410)^{0}",
    mass: 1414.0,
    width: 232.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 100321,
    name: "K(1460)+",
    latex: "K(1460)^{+}",
    mass: undefined,
    width: undefined,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -100321,
    name: "K(1460)-",
    latex: "K(1460)^{-}",
    mass: undefined,
    width: undefined,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 100323,
    name: "K*(1410)+",
    latex: "K^{*}(1410)^{+}",
    mass: 1414.0,
    width: 232.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -100323,
    name: "K*(1410)-",
    latex: "K^{*}(1410)^{-}",
    mass: 1414.0,
    width: 232.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 100331,
    name: "eta(1475)",
    latex: "\\eta(1475)",
    mass: 1476.0,
    width: 96.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 100333,
    name: "phi(1680)",
    latex: "\\phi(1680)",
    mass: 1680.0,
    width: 150.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 100441,
    name: "eta(c)(2S)",
    latex: "\\eta_{c}(2S)",
    mass: 3637.8,
    width: 11.6,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 100443,
    name: "psi(2S)",
    latex: "\\psi(2S)",
    mass: 3686.097,
    width: 0.293,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 100445,
    name: "chi(c2)(3930)",
    latex: "\\chi_{c2}(2P)",
    mass: 3922.5,
    width: 35.2,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 100553,
    name: "Upsilon(2S)",
    latex: "\\Upsilon(2S)",
    mass: 10023.4,
    width: 0.032,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 100555,
    name: "chi(b2)(2P)",
    latex: "\\chi_{b2}(2P)",
    mass: 10268.6,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 103316,
    name: "Xi(1950)-",
    latex: "\\Xi(1950)^{-}",
    mass: 1950.0,
    width: 60.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -103316,
    name: "Xi(1950)~+",
    latex: "\\overline{\\Xi}(1950)^{+}",
    mass: 1950.0,
    width: 60.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 103326,
    name: "Xi(1950)0",
    latex: "\\Xi(1950)^{0}",
    mass: 1950.0,
    width: 60.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -103326,
    name: "Xi(1950)~0",
    latex: "\\overline{\\Xi}(1950)^{0}",
    mass: 1950.0,
    width: 60.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 104122,
    name: "Lambda(c)(2625)+",
    latex: "\\Lambda_{c}(2625)^{+}",
    mass: 2628.0,
    width: undefined,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -104122,
    name: "Lambda(c)(2625)~-",
    latex: "\\overline{\\Lambda}_{c}(2625)^{-}",
    mass: 2628.0,
    width: undefined,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 104312,
    name: "Xi(c)(2815)0",
    latex: "\\Xi_{c}(2815)^{0}",
    mass: 2819.85,
    width: 2.54,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -104312,
    name: "Xi(c)(2815)~0",
    latex: "\\overline{\\Xi}_{c}(2815)^{0}",
    mass: 2819.85,
    width: 2.54,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 104314,
    name: "Xi(c)(2790)0",
    latex: "\\Xi_{c}(2790)^{0}",
    mass: 2794.0,
    width: 10.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -104314,
    name: "Xi(c)(2790)~0",
    latex: "\\overline{\\Xi}_{c}(2790)^{0}",
    mass: 2794.0,
    width: 10.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 104322,
    name: "Xi(c)(2815)+",
    latex: "\\Xi_{c}(2815)^{+}",
    mass: 2816.6,
    width: 2.15,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -104322,
    name: "Xi(c)(2815)~-",
    latex: "\\overline{\\Xi}_{c}(2815)^{-}",
    mass: 2816.6,
    width: 2.15,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 104324,
    name: "Xi(c)(2790)+",
    latex: "\\Xi_{c}(2790)^{+}",
    mass: 2792.0,
    width: 8.9,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -104324,
    name: "Xi(c)(2790)~-",
    latex: "\\overline{\\Xi}_{c}(2790)^{-}",
    mass: 2792.0,
    width: 8.9,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 110551,
    name: "chi(b0)(2P)",
    latex: "\\chi_{b0}(2P)",
    mass: 10232.5,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 110553,
    name: "h(b)(2P)",
    latex: "h_{b}(2P)",
    mass: 10259.8,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 120553,
    name: "chi(b1)(2P)",
    latex: "\\chi_{b1}(2P)",
    mass: 10255.5,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 200553,
    name: "Upsilon(3S)",
    latex: "\\Upsilon(3S)",
    mass: 10355.1,
    width: 0.0203,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 200555,
    name: "chi(b2)(3P)",
    latex: "\\chi_{b2}(3P)",
    mass: 10524.0,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 203312,
    name: "Xi(1690)-",
    latex: "\\Xi(1690)^{-}",
    mass: 1690.0,
    width: 20.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -203312,
    name: "Xi(1690)~+",
    latex: "\\overline{\\Xi}(1690)^{+}",
    mass: 1690.0,
    width: 20.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 203316,
    name: "Xi(2030)-",
    latex: "\\Xi(2030)^{-}",
    mass: 2025.0,
    width: 20.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -203316,
    name: "Xi(2030)~+",
    latex: "\\overline{\\Xi}(2030)^{+}",
    mass: 2025.0,
    width: 20.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 203322,
    name: "Xi(1690)0",
    latex: "\\Xi(1690)^{0}",
    mass: 1690.0,
    width: 20.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -203322,
    name: "Xi(1690)~0",
    latex: "\\overline{\\Xi}(1690)^{0}",
    mass: 1690.0,
    width: 20.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 203326,
    name: "Xi(2030)0",
    latex: "\\Xi(2030)^{0}",
    mass: 2025.0,
    width: 20.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -203326,
    name: "Xi(2030)~0",
    latex: "\\overline{\\Xi}(2030)^{0}",
    mass: 2025.0,
    width: 20.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 203338,
    name: "Omega(2250)-",
    latex: "\\Omega(2250)^{-}",
    mass: 2252.0,
    width: 55.0,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -203338,
    name: "Omega(2250)~+",
    latex: "\\overline{\\Omega}(2250)^{+}",
    mass: 2252.0,
    width: 55.0,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 204126,
    name: "Lambda(c)(2880)+",
    latex: "\\Lambda_{c}(2880)^{+}",
    mass: 2881.63,
    width: 5.6,
    charge: 1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -204126,
    name: "Lambda(c)(2880)~-",
    latex: "\\overline{\\Lambda}_{c}(2880)^{-}",
    mass: 2881.63,
    width: 5.6,
    charge: -1.0,
    iValue: 0.0,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 220553,
    name: "chi(b1)(3P)",
    latex: "\\chi_{b1}(3P)",
    mass: 10513.4,
    width: undefined,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 300553,
    name: "Upsilon(4S)",
    latex: "\\Upsilon(4S)",
    mass: 10579.4,
    width: 20.5,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 9000111,
    name: "a(0)(980)0",
    latex: "a_{0}(980)^{0}",
    mass: 980.0,
    width: 75.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9000113,
    name: "pi(1)(1400)0",
    latex: "\\pi_{1}(1400)^{0}",
    mass: undefined,
    width: undefined,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 9000115,
    name: "a(2)(1700)0",
    latex: "a_{2}(1700)^{0}",
    mass: 1706.0,
    width: 380.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9000211,
    name: "a(0)(980)+",
    latex: "a_{0}(980)^{+}",
    mass: 980.0,
    width: 75.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -9000211,
    name: "a(0)(980)-",
    latex: "a_{0}(980)^{-}",
    mass: 980.0,
    width: 75.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 9000213,
    name: "pi(1)(1400)+",
    latex: "\\pi_{1}(1400)^{+}",
    mass: undefined,
    width: undefined,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -9000213,
    name: "pi(1)(1400)-",
    latex: "\\pi_{1}(1400)^{-}",
    mass: undefined,
    width: undefined,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 9000215,
    name: "a(2)(1700)+",
    latex: "a_{2}(1700)^{+}",
    mass: 1706.0,
    width: 380.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -9000215,
    name: "a(2)(1700)-",
    latex: "a_{2}(1700)^{-}",
    mass: 1706.0,
    width: 380.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 9000221,
    name: "f(0)(500)",
    latex: "f_{0}(500)",
    mass: 600.0,
    width: 450.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9000311,
    name: "K(0)*(700)0",
    latex: "K_{0}^{*}(700)^{0}",
    mass: 838.0,
    width: 463.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -9000311,
    name: "K(0)*(700)~0",
    latex: "\\overline{K}_{0}^{*}(700)^{0}",
    mass: 838.0,
    width: 463.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 9000313,
    name: "K(1)(1650)0",
    latex: "K_{1}(1650)^{0}",
    mass: 1650.0,
    width: 150.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -9000313,
    name: "K(1)(1650)~0",
    latex: "\\overline{K}_{1}(1650)^{0}",
    mass: 1650.0,
    width: 150.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 9000321,
    name: "K(0)*(700)+",
    latex: "K_{0}^{*}(700)^{+}",
    mass: 838.0,
    width: 463.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -9000321,
    name: "K(0)*(700)-",
    latex: "K_{0}^{*}(700)^{-}",
    mass: 838.0,
    width: 463.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 9000323,
    name: "K(1)(1650)+",
    latex: "K_{1}(1650)^{+}",
    mass: 1650.0,
    width: 150.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -9000323,
    name: "K(1)(1650)-",
    latex: "K_{1}(1650)^{-}",
    mass: 1650.0,
    width: 150.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 9000325,
    name: "K(2)(1580)+",
    latex: "K_{2}(1580)^{+}",
    mass: undefined,
    width: undefined,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -9000325,
    name: "K(2)(1580)-",
    latex: "K_{2}(1580)^{-}",
    mass: undefined,
    width: undefined,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 9000329,
    name: "K(4)(2500)+",
    latex: "K_{4}(2500)^{+}",
    mass: undefined,
    width: undefined,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -9000329,
    name: "K(4)(2500)-",
    latex: "K_{4}(2500)^{-}",
    mass: undefined,
    width: undefined,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 9000443,
    name: "psi(4040)",
    latex: "\\psi(4040)",
    mass: 4040.0,
    width: 85.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 9000553,
    name: "Upsilon(10860)",
    latex: "\\Upsilon(10860)",
    mass: 10885.2,
    width: 37.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 9010111,
    name: "pi(1800)0",
    latex: "\\pi(1800)^{0}",
    mass: 1810.0,
    width: 215.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 9010113,
    name: "pi(1)(1600)0",
    latex: "\\pi_{1}(1600)^{0}",
    mass: 1645.0,
    width: 370.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 9010211,
    name: "pi(1800)+",
    latex: "\\pi(1800)^{+}",
    mass: 1810.0,
    width: 215.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -9010211,
    name: "pi(1800)-",
    latex: "\\pi(1800)^{-}",
    mass: 1810.0,
    width: 215.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 9010213,
    name: "pi(1)(1600)+",
    latex: "\\pi_{1}(1600)^{+}",
    mass: 1645.0,
    width: 370.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -9010213,
    name: "pi(1)(1600)-",
    latex: "\\pi_{1}(1600)^{-}",
    mass: 1645.0,
    width: 370.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 9010221,
    name: "f(0)(980)",
    latex: "f_{0}(980)",
    mass: 990.0,
    width: 60.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9010225,
    name: "f(2)(1565)",
    latex: "f_{2}(1565)",
    mass: 1571.0,
    width: 133.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9010315,
    name: "K(2)*(1980)0",
    latex: "K_{2}^{*}(1980)^{0}",
    mass: 1990.0,
    width: 348.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -9010315,
    name: "K(2)*(1980)~0",
    latex: "\\overline{K}_{2}^{*}(1980)^{0}",
    mass: 1990.0,
    width: 348.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 9010321,
    name: "K(1830)+",
    latex: "K(1830)^{+}",
    mass: undefined,
    width: undefined,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -9010321,
    name: "K(1830)-",
    latex: "K(1830)^{-}",
    mass: undefined,
    width: undefined,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 9010325,
    name: "K(2)*(1980)+",
    latex: "K_{2}^{*}(1980)^{+}",
    mass: 1990.0,
    width: 348.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -9010325,
    name: "K(2)*(1980)-",
    latex: "K_{2}^{*}(1980)^{-}",
    mass: 1990.0,
    width: 348.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 9010327,
    name: "K(3)(2320)+",
    latex: "K_{3}(2320)^{+}",
    mass: undefined,
    width: undefined,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -9010327,
    name: "K(3)(2320)-",
    latex: "K_{3}(2320)^{-}",
    mass: undefined,
    width: undefined,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 9010443,
    name: "psi(4160)",
    latex: "\\psi(4160)",
    mass: 4191.0,
    width: 69.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 9010553,
    name: "Upsilon(11020)",
    latex: "\\Upsilon(11020)",
    mass: 11000.0,
    width: 24.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 9020113,
    name: "a(1)(1640)0",
    latex: "a_{1}(1640)^{0}",
    mass: 1655.0,
    width: 250.0,
    charge: 0.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9020213,
    name: "a(1)(1640)+",
    latex: "a_{1}(1640)^{+}",
    mass: 1655.0,
    width: 250.0,
    charge: 1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -9020213,
    name: "a(1)(1640)-",
    latex: "a_{1}(1640)^{-}",
    mass: 1655.0,
    width: 250.0,
    charge: -1.0,
    iValue: 1.0,
    gValue: -1,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 9020221,
    name: "eta(1405)",
    latex: "\\eta(1405)",
    mass: 1408.0,
    width: 49.8,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 9020311,
    name: "K(0)*(1950)0",
    latex: "K_{0}^{*}(1950)^{0}",
    mass: 1957.0,
    width: 170.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -9020311,
    name: "K(0)*(1950)~0",
    latex: "\\overline{K}_{0}^{*}(1950)^{0}",
    mass: 1957.0,
    width: 170.0,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 9020321,
    name: "K(0)*(1950)+",
    latex: "K_{0}^{*}(1950)^{+}",
    mass: 1957.0,
    width: 170.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -9020321,
    name: "K(0)*(1950)-",
    latex: "K_{0}^{*}(1950)^{-}",
    mass: 1957.0,
    width: 170.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: 9020325,
    name: "K(2)(2250)+",
    latex: "K_{2}(2250)^{+}",
    mass: undefined,
    width: undefined,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: -9020325,
    name: "K(2)(2250)-",
    latex: "K_{2}(2250)^{-}",
    mass: undefined,
    width: undefined,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 9020443,
    name: "psi(4415)",
    latex: "\\psi(4415)",
    mass: 4415.0,
    width: 110.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: -1,
    cValue: -1,
    pValue: -1,
    anti: false
  },
  {
    pdg: 9030221,
    name: "f(0)(1500)",
    latex: "f_{0}(1500)",
    mass: 1522.0,
    width: 108.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9050221,
    name: "f(0)(2020)",
    latex: "f_{0}(2020)",
    mass: 1982.0,
    width: 440.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9050225,
    name: "f(2)(1950)",
    latex: "f_{2}(1950)",
    mass: 1936.0,
    width: 464.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9060225,
    name: "f(2)(2010)",
    latex: "f_{2}(2010)",
    mass: 2010.0,
    width: 200.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9070225,
    name: "f(2)(2150)",
    latex: "f_{2}(2150)",
    mass: 2157.0,
    width: 152.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9080225,
    name: "f(2)(2300)",
    latex: "f_{2}(2300)",
    mass: 2297.0,
    width: 150.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 9090225,
    name: "f(2)(2340)",
    latex: "f_{2}(2340)",
    mass: 2346.0,
    width: 331.0,
    charge: 0.0,
    iValue: 0.0,
    gValue: 1,
    cValue: 1,
    pValue: 1,
    anti: false
  },
  {
    pdg: 1000000010,
    name: "n",
    latex: "n",
    mass: 939.5654219,
    width: 7.494e-25,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -1000000010,
    name: "n~",
    latex: "\\overline{n}",
    mass: 939.5654219,
    width: 7.494e-25,
    charge: 0.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 1000010010,
    name: "p",
    latex: "p",
    mass: 938.27208943,
    width: 0.0,
    charge: 1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: 1,
    anti: true
  },
  {
    pdg: -1000010010,
    name: "p~",
    latex: "\\overline{p}",
    mass: 938.27208943,
    width: 0.0,
    charge: -1.0,
    iValue: 0.5,
    gValue: 5,
    cValue: 5,
    pValue: -1,
    anti: true
  },
  {
    pdg: 1000010020,
    name: "D2",
    latex: "^{2}\\mathrm{D}",
    mass: 1876.1239303,
    width: undefined,
    charge: 1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000010020,
    name: "D2~",
    latex: "^{2}\\mathrm{\\overline{D}}",
    mass: 1876.1239303,
    width: undefined,
    charge: -1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000010030,
    name: "T3",
    latex: "^{3}\\mathrm{T}",
    mass: 2809.4321221,
    width: undefined,
    charge: 1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000010030,
    name: "T3~",
    latex: "^{3}\\mathrm{\\overline{T}}",
    mass: 2809.4321221,
    width: undefined,
    charge: -1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000010040,
    name: "H4",
    latex: "^{4}\\mathrm{H}",
    mass: 3750.595804,
    width: undefined,
    charge: 1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000010040,
    name: "H4~",
    latex: "^{4}\\mathrm{\\overline{H}}",
    mass: 3750.595804,
    width: undefined,
    charge: -1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000010050,
    name: "H5",
    latex: "^{5}\\mathrm{H}",
    mass: 4690.3615754,
    width: undefined,
    charge: 1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000010050,
    name: "H5~",
    latex: "^{5}\\mathrm{\\overline{H}}",
    mass: 4690.3615754,
    width: undefined,
    charge: -1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000010060,
    name: "H6",
    latex: "^{6}\\mathrm{H}",
    mass: 5630.8445972,
    width: undefined,
    charge: 1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000010060,
    name: "H6~",
    latex: "^{6}\\mathrm{\\overline{H}}",
    mass: 5630.8445972,
    width: undefined,
    charge: -1.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000020030,
    name: "He3",
    latex: "^{3}\\mathrm{He}",
    mass: 2809.4135301,
    width: undefined,
    charge: 2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000020030,
    name: "He3~",
    latex: "^{3}\\mathrm{\\overline{He}}",
    mass: 2809.4135301,
    width: undefined,
    charge: -2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000020040,
    name: "He4",
    latex: "^{4}\\mathrm{He}",
    mass: 3728.4013307,
    width: undefined,
    charge: 2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000020040,
    name: "He4~",
    latex: "^{4}\\mathrm{\\overline{He}}",
    mass: 3728.4013307,
    width: undefined,
    charge: -2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000020050,
    name: "He5",
    latex: "^{5}\\mathrm{He}",
    mass: 4668.701543,
    width: undefined,
    charge: 2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000020050,
    name: "He5~",
    latex: "^{5}\\mathrm{\\overline{He}}",
    mass: 4668.701543,
    width: undefined,
    charge: -2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000020060,
    name: "He6",
    latex: "^{6}\\mathrm{He}",
    mass: 5606.5567175,
    width: undefined,
    charge: 2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000020060,
    name: "He6~",
    latex: "^{6}\\mathrm{\\overline{He}}",
    mass: 5606.5567175,
    width: undefined,
    charge: -2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000020070,
    name: "He7",
    latex: "^{7}\\mathrm{He}",
    mass: 6546.5321775,
    width: undefined,
    charge: 2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000020070,
    name: "He7~",
    latex: "^{7}\\mathrm{\\overline{He}}",
    mass: 6546.5321775,
    width: undefined,
    charge: -2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000020080,
    name: "He8",
    latex: "^{8}\\mathrm{He}",
    mass: 7483.5625139,
    width: undefined,
    charge: 2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000020080,
    name: "He8~",
    latex: "^{8}\\mathrm{\\overline{He}}",
    mass: 7483.5625139,
    width: undefined,
    charge: -2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000020090,
    name: "He9",
    latex: "^{9}\\mathrm{He}",
    mass: 8424.3860993,
    width: undefined,
    charge: 2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000020090,
    name: "He9~",
    latex: "^{9}\\mathrm{\\overline{He}}",
    mass: 8424.3860993,
    width: undefined,
    charge: -2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000020100,
    name: "He10",
    latex: "^{10}\\mathrm{He}",
    mass: 9364.1425557,
    width: undefined,
    charge: 2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000020100,
    name: "He10~",
    latex: "^{10}\\mathrm{\\overline{He}}",
    mass: 9364.1425557,
    width: undefined,
    charge: -2.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000030040,
    name: "Li4",
    latex: "^{4}\\mathrm{Li}",
    mass: 3751.3037396,
    width: undefined,
    charge: 3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000030040,
    name: "Li4~",
    latex: "^{4}\\mathrm{\\overline{Li}}",
    mass: 3751.3037396,
    width: undefined,
    charge: -3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000030050,
    name: "Li5",
    latex: "^{5}\\mathrm{Li}",
    mass: 4669.1514547,
    width: undefined,
    charge: 3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000030050,
    name: "Li5~",
    latex: "^{5}\\mathrm{\\overline{Li}}",
    mass: 4669.1514547,
    width: undefined,
    charge: -3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000030060,
    name: "Li6",
    latex: "^{6}\\mathrm{Li}",
    mass: 5603.0515028,
    width: undefined,
    charge: 3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000030060,
    name: "Li6~",
    latex: "^{6}\\mathrm{\\overline{Li}}",
    mass: 5603.0515028,
    width: undefined,
    charge: -3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000030070,
    name: "Li7",
    latex: "^{7}\\mathrm{Li}",
    mass: 6535.3658304,
    width: undefined,
    charge: 3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000030070,
    name: "Li7~",
    latex: "^{7}\\mathrm{\\overline{Li}}",
    mass: 6535.3658304,
    width: undefined,
    charge: -3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000030080,
    name: "Li8",
    latex: "^{8}\\mathrm{Li}",
    mass: 7472.8986297,
    width: undefined,
    charge: 3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000030080,
    name: "Li8~",
    latex: "^{8}\\mathrm{\\overline{Li}}",
    mass: 7472.8986297,
    width: undefined,
    charge: -3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000030090,
    name: "Li9",
    latex: "^{9}\\mathrm{Li}",
    mass: 8408.4018375,
    width: undefined,
    charge: 3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000030090,
    name: "Li9~",
    latex: "^{9}\\mathrm{\\overline{Li}}",
    mass: 8408.4018375,
    width: undefined,
    charge: -3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000030100,
    name: "Li10",
    latex: "^{10}\\mathrm{Li}",
    mass: 9347.9932425,
    width: undefined,
    charge: 3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000030100,
    name: "Li10~",
    latex: "^{10}\\mathrm{\\overline{Li}}",
    mass: 9347.9932425,
    width: undefined,
    charge: -3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000030110,
    name: "Li11",
    latex: "^{11}\\mathrm{Li}",
    mass: 10287.1634165,
    width: undefined,
    charge: 3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000030110,
    name: "Li11~",
    latex: "^{11}\\mathrm{\\overline{Li}}",
    mass: 10287.1634165,
    width: undefined,
    charge: -3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000030120,
    name: "Li12",
    latex: "^{12}\\mathrm{Li}",
    mass: 11226.9351494,
    width: undefined,
    charge: 3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000030120,
    name: "Li12~",
    latex: "^{12}\\mathrm{\\overline{Li}}",
    mass: 11226.9351494,
    width: undefined,
    charge: -3.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000040050,
    name: "Be5",
    latex: "^{5}\\mathrm{Be}",
    mass: 4694.6091885,
    width: undefined,
    charge: 4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000040050,
    name: "Be5~",
    latex: "^{5}\\mathrm{\\overline{Be}}",
    mass: 4694.6091885,
    width: undefined,
    charge: -4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000040060,
    name: "Be6",
    latex: "^{6}\\mathrm{Be}",
    mass: 5607.339275,
    width: undefined,
    charge: 4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000040060,
    name: "Be6~",
    latex: "^{6}\\mathrm{\\overline{Be}}",
    mass: 5607.339275,
    width: undefined,
    charge: -4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000040070,
    name: "Be7",
    latex: "^{7}\\mathrm{Be}",
    mass: 6536.2277196,
    width: undefined,
    charge: 4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000040070,
    name: "Be7~",
    latex: "^{7}\\mathrm{\\overline{Be}}",
    mass: 6536.2277196,
    width: undefined,
    charge: -4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000040080,
    name: "Be8",
    latex: "^{8}\\mathrm{Be}",
    mass: 7456.8944991,
    width: undefined,
    charge: 4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000040080,
    name: "Be8~",
    latex: "^{8}\\mathrm{\\overline{Be}}",
    mass: 7456.8944991,
    width: undefined,
    charge: -4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000040090,
    name: "Be9",
    latex: "^{9}\\mathrm{Be}",
    mass: 8394.795382,
    width: undefined,
    charge: 4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000040090,
    name: "Be9~",
    latex: "^{9}\\mathrm{\\overline{Be}}",
    mass: 8394.795382,
    width: undefined,
    charge: -4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000040100,
    name: "Be10",
    latex: "^{10}\\mathrm{Be}",
    mass: 9327.5485211,
    width: undefined,
    charge: 4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000040100,
    name: "Be10~",
    latex: "^{10}\\mathrm{\\overline{Be}}",
    mass: 9327.5485211,
    width: undefined,
    charge: -4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000040110,
    name: "Be11",
    latex: "^{11}\\mathrm{Be}",
    mass: 10266.6123092,
    width: undefined,
    charge: 4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000040110,
    name: "Be11~",
    latex: "^{11}\\mathrm{\\overline{Be}}",
    mass: 10266.6123092,
    width: undefined,
    charge: -4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000040120,
    name: "Be12",
    latex: "^{12}\\mathrm{Be}",
    mass: 11203.007022,
    width: undefined,
    charge: 4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000040120,
    name: "Be12~",
    latex: "^{12}\\mathrm{\\overline{Be}}",
    mass: 11203.007022,
    width: undefined,
    charge: -4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000040130,
    name: "Be13",
    latex: "^{13}\\mathrm{Be}",
    mass: 12143.0828878,
    width: undefined,
    charge: 4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000040130,
    name: "Be13~",
    latex: "^{13}\\mathrm{\\overline{Be}}",
    mass: 12143.0828878,
    width: undefined,
    charge: -4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000040140,
    name: "Be14",
    latex: "^{14}\\mathrm{Be}",
    mass: 13080.8692342,
    width: undefined,
    charge: 4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000040140,
    name: "Be14~",
    latex: "^{14}\\mathrm{\\overline{Be}}",
    mass: 13080.8692342,
    width: undefined,
    charge: -4.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050070,
    name: "B7",
    latex: "^{7}\\mathrm{B}",
    mass: 6548.1352788,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050070,
    name: "B7~",
    latex: "^{7}\\mathrm{\\overline{B}}",
    mass: 6548.1352788,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050080,
    name: "B8",
    latex: "^{8}\\mathrm{B}",
    mass: 7474.8743846,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050080,
    name: "B8~",
    latex: "^{8}\\mathrm{\\overline{B}}",
    mass: 7474.8743846,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050090,
    name: "B9",
    latex: "^{9}\\mathrm{B}",
    mass: 8395.8633773,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050090,
    name: "B9~",
    latex: "^{9}\\mathrm{\\overline{B}}",
    mass: 8395.8633773,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050100,
    name: "B10",
    latex: "^{10}\\mathrm{B}",
    mass: 9326.9916479,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050100,
    name: "B10~",
    latex: "^{10}\\mathrm{\\overline{B}}",
    mass: 9326.9916479,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050110,
    name: "B11",
    latex: "^{11}\\mathrm{B}",
    mass: 10255.1028491,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050110,
    name: "B11~",
    latex: "^{11}\\mathrm{\\overline{B}}",
    mass: 10255.1028491,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050120,
    name: "B12",
    latex: "^{12}\\mathrm{B}",
    mass: 11191.2986069,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050120,
    name: "B12~",
    latex: "^{12}\\mathrm{\\overline{B}}",
    mass: 11191.2986069,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050130,
    name: "B13",
    latex: "^{13}\\mathrm{B}",
    mass: 12125.9853135,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050130,
    name: "B13~",
    latex: "^{13}\\mathrm{\\overline{B}}",
    mass: 12125.9853135,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050140,
    name: "B14",
    latex: "^{14}\\mathrm{B}",
    mass: 13064.5811283,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050140,
    name: "B14~",
    latex: "^{14}\\mathrm{\\overline{B}}",
    mass: 13064.5811283,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050150,
    name: "B15",
    latex: "^{15}\\mathrm{B}",
    mass: 14001.368913,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050150,
    name: "B15~",
    latex: "^{15}\\mathrm{\\overline{B}}",
    mass: 14001.368913,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050160,
    name: "B16",
    latex: "^{16}\\mathrm{B}",
    mass: 14941.0173161,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050160,
    name: "B16~",
    latex: "^{16}\\mathrm{\\overline{B}}",
    mass: 14941.0173161,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050170,
    name: "B17",
    latex: "^{17}\\mathrm{B}",
    mass: 15879.1147815,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050170,
    name: "B17~",
    latex: "^{17}\\mathrm{\\overline{B}}",
    mass: 15879.1147815,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050180,
    name: "B18",
    latex: "^{18}\\mathrm{B}",
    mass: 16818.6849391,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050180,
    name: "B18~",
    latex: "^{18}\\mathrm{\\overline{B}}",
    mass: 16818.6849391,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000050190,
    name: "B19",
    latex: "^{19}\\mathrm{B}",
    mass: 17758.1619473,
    width: undefined,
    charge: 5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000050190,
    name: "B19~",
    latex: "^{19}\\mathrm{\\overline{B}}",
    mass: 17758.1619473,
    width: undefined,
    charge: -5.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060080,
    name: "C8",
    latex: "^{8}\\mathrm{C}",
    mass: 7487.0170623,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060080,
    name: "C8~",
    latex: "^{8}\\mathrm{\\overline{C}}",
    mass: 7487.0170623,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060090,
    name: "C9",
    latex: "^{9}\\mathrm{C}",
    mass: 8412.3579023,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060090,
    name: "C9~",
    latex: "^{9}\\mathrm{\\overline{C}}",
    mass: 8412.3579023,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060100,
    name: "C10",
    latex: "^{10}\\mathrm{C}",
    mass: 9330.6397122,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060100,
    name: "C10~",
    latex: "^{10}\\mathrm{\\overline{C}}",
    mass: 9330.6397122,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060110,
    name: "C11",
    latex: "^{11}\\mathrm{C}",
    mass: 10257.0845404,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060110,
    name: "C11~",
    latex: "^{11}\\mathrm{\\overline{C}}",
    mass: 10257.0845404,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060120,
    name: "C12",
    latex: "^{12}\\mathrm{C}",
    mass: 11177.9292446,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060120,
    name: "C12~",
    latex: "^{12}\\mathrm{\\overline{C}}",
    mass: 11177.9292446,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060130,
    name: "C13",
    latex: "^{13}\\mathrm{C}",
    mass: 12112.5483577,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060130,
    name: "C13~",
    latex: "^{13}\\mathrm{\\overline{C}}",
    mass: 12112.5483577,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060140,
    name: "C14",
    latex: "^{14}\\mathrm{C}",
    mass: 13043.9373457,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060140,
    name: "C14~",
    latex: "^{14}\\mathrm{\\overline{C}}",
    mass: 13043.9373457,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060150,
    name: "C15",
    latex: "^{15}\\mathrm{C}",
    mass: 13982.2847412,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060150,
    name: "C15~",
    latex: "^{15}\\mathrm{\\overline{C}}",
    mass: 13982.2847412,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060160,
    name: "C16",
    latex: "^{16}\\mathrm{C}",
    mass: 14917.5995543,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060160,
    name: "C16~",
    latex: "^{16}\\mathrm{\\overline{C}}",
    mass: 14917.5995543,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060170,
    name: "C17",
    latex: "^{17}\\mathrm{C}",
    mass: 15856.4319686,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060170,
    name: "C17~",
    latex: "^{17}\\mathrm{\\overline{C}}",
    mass: 15856.4319686,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060180,
    name: "C18",
    latex: "^{18}\\mathrm{C}",
    mass: 16791.8113342,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060180,
    name: "C18~",
    latex: "^{18}\\mathrm{\\overline{C}}",
    mass: 16791.8113342,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060190,
    name: "C19",
    latex: "^{19}\\mathrm{C}",
    mass: 17730.8039655,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060190,
    name: "C19~",
    latex: "^{19}\\mathrm{\\overline{C}}",
    mass: 17730.8039655,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060200,
    name: "C20",
    latex: "^{20}\\mathrm{C}",
    mass: 18667.384027,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060200,
    name: "C20~",
    latex: "^{20}\\mathrm{\\overline{C}}",
    mass: 18667.384027,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060210,
    name: "C21",
    latex: "^{21}\\mathrm{C}",
    mass: 19607.0193892,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060210,
    name: "C21~",
    latex: "^{21}\\mathrm{\\overline{C}}",
    mass: 19607.0193892,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000060220,
    name: "C22",
    latex: "^{22}\\mathrm{C}",
    mass: 20546.4777675,
    width: undefined,
    charge: 6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000060220,
    name: "C22~",
    latex: "^{22}\\mathrm{\\overline{C}}",
    mass: 20546.4777675,
    width: undefined,
    charge: -6.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070100,
    name: "N10",
    latex: "^{10}\\mathrm{N}",
    mass: 9353.7377666,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070100,
    name: "N10~",
    latex: "^{10}\\mathrm{\\overline{N}}",
    mass: 9353.7377666,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070110,
    name: "N11",
    latex: "^{11}\\mathrm{N}",
    mass: 10270.8011637,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070110,
    name: "N11~",
    latex: "^{11}\\mathrm{\\overline{N}}",
    mass: 10270.8011637,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070120,
    name: "N12",
    latex: "^{12}\\mathrm{N}",
    mass: 11195.2673307,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070120,
    name: "N12~",
    latex: "^{12}\\mathrm{\\overline{N}}",
    mass: 11195.2673307,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070130,
    name: "N13",
    latex: "^{13}\\mathrm{N}",
    mass: 12114.7688297,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070130,
    name: "N13~",
    latex: "^{13}\\mathrm{\\overline{N}}",
    mass: 12114.7688297,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070140,
    name: "N14",
    latex: "^{14}\\mathrm{N}",
    mass: 13043.7808689,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070140,
    name: "N14~",
    latex: "^{14}\\mathrm{\\overline{N}}",
    mass: 13043.7808689,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070150,
    name: "N15",
    latex: "^{15}\\mathrm{N}",
    mass: 13972.5129939,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070150,
    name: "N15~",
    latex: "^{15}\\mathrm{\\overline{N}}",
    mass: 13972.5129939,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070160,
    name: "N16",
    latex: "^{16}\\mathrm{N}",
    mass: 14909.5895434,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070160,
    name: "N16~",
    latex: "^{16}\\mathrm{\\overline{N}}",
    mass: 14909.5895434,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070170,
    name: "N17",
    latex: "^{17}\\mathrm{N}",
    mass: 15843.2699569,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070170,
    name: "N17~",
    latex: "^{17}\\mathrm{\\overline{N}}",
    mass: 15843.2699569,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070180,
    name: "N18",
    latex: "^{18}\\mathrm{N}",
    mass: 16780.0074409,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070180,
    name: "N18~",
    latex: "^{18}\\mathrm{\\overline{N}}",
    mass: 16780.0074409,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070190,
    name: "N19",
    latex: "^{19}\\mathrm{N}",
    mass: 17714.2438633,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070190,
    name: "N19~",
    latex: "^{19}\\mathrm{\\overline{N}}",
    mass: 17714.2438633,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070200,
    name: "N20",
    latex: "^{20}\\mathrm{N}",
    mass: 18651.6510916,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070200,
    name: "N20~",
    latex: "^{20}\\mathrm{\\overline{N}}",
    mass: 18651.6510916,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070210,
    name: "N21",
    latex: "^{21}\\mathrm{N}",
    mass: 19586.6103534,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070210,
    name: "N21~",
    latex: "^{21}\\mathrm{\\overline{N}}",
    mass: 19586.6103534,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070220,
    name: "N22",
    latex: "^{22}\\mathrm{N}",
    mass: 20524.6342307,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070220,
    name: "N22~",
    latex: "^{22}\\mathrm{\\overline{N}}",
    mass: 20524.6342307,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070230,
    name: "N23",
    latex: "^{23}\\mathrm{N}",
    mass: 21461.0838831,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070230,
    name: "N23~",
    latex: "^{23}\\mathrm{\\overline{N}}",
    mass: 21461.0838831,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000070240,
    name: "N24",
    latex: "^{24}\\mathrm{N}",
    mass: 22402.7964771,
    width: undefined,
    charge: 7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000070240,
    name: "N24~",
    latex: "^{24}\\mathrm{\\overline{N}}",
    mass: 22402.7964771,
    width: undefined,
    charge: -7.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080120,
    name: "O12",
    latex: "^{12}\\mathrm{O}",
    mass: 11209.942834,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080120,
    name: "O12~",
    latex: "^{12}\\mathrm{\\overline{O}}",
    mass: 11209.942834,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080130,
    name: "O13",
    latex: "^{13}\\mathrm{O}",
    mass: 12132.5383745,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080130,
    name: "O13~",
    latex: "^{13}\\mathrm{\\overline{O}}",
    mass: 12132.5383745,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080140,
    name: "O14",
    latex: "^{14}\\mathrm{O}",
    mass: 13048.925233,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080140,
    name: "O14~",
    latex: "^{14}\\mathrm{\\overline{O}}",
    mass: 13048.925233,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080150,
    name: "O15",
    latex: "^{15}\\mathrm{O}",
    mass: 13975.2671441,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080150,
    name: "O15~",
    latex: "^{15}\\mathrm{\\overline{O}}",
    mass: 13975.2671441,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080160,
    name: "O16",
    latex: "^{16}\\mathrm{O}",
    mass: 14899.1686574,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080160,
    name: "O16~",
    latex: "^{16}\\mathrm{\\overline{O}}",
    mass: 14899.1686574,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080170,
    name: "O17",
    latex: "^{17}\\mathrm{O}",
    mass: 15834.590999,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080170,
    name: "O17~",
    latex: "^{17}\\mathrm{\\overline{O}}",
    mass: 15834.590999,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080180,
    name: "O18",
    latex: "^{18}\\mathrm{O}",
    mass: 16766.1110506,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080180,
    name: "O18~",
    latex: "^{18}\\mathrm{\\overline{O}}",
    mass: 16766.1110506,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080190,
    name: "O19",
    latex: "^{19}\\mathrm{O}",
    mass: 17701.7208566,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080190,
    name: "O19~",
    latex: "^{19}\\mathrm{\\overline{O}}",
    mass: 17701.7208566,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080200,
    name: "O20",
    latex: "^{20}\\mathrm{O}",
    mass: 18633.6782854,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080200,
    name: "O20~",
    latex: "^{20}\\mathrm{\\overline{O}}",
    mass: 18633.6782854,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080210,
    name: "O21",
    latex: "^{21}\\mathrm{O}",
    mass: 19569.4382596,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080210,
    name: "O21~",
    latex: "^{21}\\mathrm{\\overline{O}}",
    mass: 19569.4382596,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080220,
    name: "O22",
    latex: "^{22}\\mathrm{O}",
    mass: 20502.157278,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080220,
    name: "O22~",
    latex: "^{22}\\mathrm{\\overline{O}}",
    mass: 20502.157278,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080230,
    name: "O23",
    latex: "^{23}\\mathrm{O}",
    mass: 21438.988843,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080230,
    name: "O23~",
    latex: "^{23}\\mathrm{\\overline{O}}",
    mass: 21438.988843,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080240,
    name: "O24",
    latex: "^{24}\\mathrm{O}",
    mass: 22374.3579621,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080240,
    name: "O24~",
    latex: "^{24}\\mathrm{\\overline{O}}",
    mass: 22374.3579621,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080250,
    name: "O25",
    latex: "^{25}\\mathrm{O}",
    mass: 23314.68263,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080250,
    name: "O25~",
    latex: "^{25}\\mathrm{\\overline{O}}",
    mass: 23314.68263,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000080260,
    name: "O26",
    latex: "^{26}\\mathrm{O}",
    mass: 24253.5075923,
    width: undefined,
    charge: 8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000080260,
    name: "O26~",
    latex: "^{26}\\mathrm{\\overline{O}}",
    mass: 24253.5075923,
    width: undefined,
    charge: -8.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090140,
    name: "F14",
    latex: "^{14}\\mathrm{F}",
    mass: 13072.8863297,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090140,
    name: "F14~",
    latex: "^{14}\\mathrm{\\overline{F}}",
    mass: 13072.8863297,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090150,
    name: "F15",
    latex: "^{15}\\mathrm{F}",
    mass: 13988.9781784,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090150,
    name: "F15~",
    latex: "^{15}\\mathrm{\\overline{F}}",
    mass: 13988.9781784,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090160,
    name: "F16",
    latex: "^{16}\\mathrm{F}",
    mass: 14914.5805819,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090160,
    name: "F16~",
    latex: "^{16}\\mathrm{\\overline{F}}",
    mass: 14914.5805819,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090170,
    name: "F17",
    latex: "^{17}\\mathrm{F}",
    mass: 15837.3514669,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090170,
    name: "F17~",
    latex: "^{17}\\mathrm{\\overline{F}}",
    mass: 15837.3514669,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090180,
    name: "F18",
    latex: "^{18}\\mathrm{F}",
    mass: 16767.7669564,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090180,
    name: "F18~",
    latex: "^{18}\\mathrm{\\overline{F}}",
    mass: 16767.7669564,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090190,
    name: "F19",
    latex: "^{19}\\mathrm{F}",
    mass: 17696.9005256,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090190,
    name: "F19~",
    latex: "^{19}\\mathrm{\\overline{F}}",
    mass: 17696.9005256,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090200,
    name: "F20",
    latex: "^{20}\\mathrm{F}",
    mass: 18629.8646089,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090200,
    name: "F20~",
    latex: "^{20}\\mathrm{\\overline{F}}",
    mass: 18629.8646089,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090210,
    name: "F21",
    latex: "^{21}\\mathrm{F}",
    mass: 19561.3285787,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090210,
    name: "F21~",
    latex: "^{21}\\mathrm{\\overline{F}}",
    mass: 19561.3285787,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090220,
    name: "F22",
    latex: "^{22}\\mathrm{F}",
    mass: 20495.6638326,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090220,
    name: "F22~",
    latex: "^{22}\\mathrm{\\overline{F}}",
    mass: 20495.6638326,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090230,
    name: "F23",
    latex: "^{23}\\mathrm{F}",
    mass: 21427.6525597,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090230,
    name: "F23~",
    latex: "^{23}\\mathrm{\\overline{F}}",
    mass: 21427.6525597,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090240,
    name: "F24",
    latex: "^{24}\\mathrm{F}",
    mass: 22363.4035915,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090240,
    name: "F24~",
    latex: "^{24}\\mathrm{\\overline{F}}",
    mass: 22363.4035915,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090250,
    name: "F25",
    latex: "^{25}\\mathrm{F}",
    mass: 23298.6888762,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090250,
    name: "F25~",
    latex: "^{25}\\mathrm{\\overline{F}}",
    mass: 23298.6888762,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090260,
    name: "F26",
    latex: "^{26}\\mathrm{F}",
    mass: 24237.5231535,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090260,
    name: "F26~",
    latex: "^{26}\\mathrm{\\overline{F}}",
    mass: 24237.5231535,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090270,
    name: "F27",
    latex: "^{27}\\mathrm{F}",
    mass: 25175.4725113,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090270,
    name: "F27~",
    latex: "^{27}\\mathrm{\\overline{F}}",
    mass: 25175.4725113,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090280,
    name: "F28",
    latex: "^{28}\\mathrm{F}",
    mass: 26115.2382827,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090280,
    name: "F28~",
    latex: "^{28}\\mathrm{\\overline{F}}",
    mass: 26115.2382827,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000090290,
    name: "F29",
    latex: "^{29}\\mathrm{F}",
    mass: 27053.4764037,
    width: undefined,
    charge: 9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000090290,
    name: "F29~",
    latex: "^{29}\\mathrm{\\overline{F}}",
    mass: 27053.4764037,
    width: undefined,
    charge: -9.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100160,
    name: "Ne16",
    latex: "^{16}\\mathrm{Ne}",
    mass: 14927.8925642,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100160,
    name: "Ne16~",
    latex: "^{16}\\mathrm{\\overline{Ne}}",
    mass: 14927.8925642,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100170,
    name: "Ne17",
    latex: "^{17}\\mathrm{Ne}",
    mass: 15851.9002498,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100170,
    name: "Ne17~",
    latex: "^{17}\\mathrm{\\overline{Ne}}",
    mass: 15851.9002498,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100180,
    name: "Ne18",
    latex: "^{18}\\mathrm{Ne}",
    mass: 16772.2114873,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100180,
    name: "Ne18~",
    latex: "^{18}\\mathrm{\\overline{Ne}}",
    mass: 16772.2114873,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100190,
    name: "Ne19",
    latex: "^{19}\\mathrm{Ne}",
    mass: 17700.1400272,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100190,
    name: "Ne19~",
    latex: "^{19}\\mathrm{\\overline{Ne}}",
    mass: 17700.1400272,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100200,
    name: "Ne20",
    latex: "^{20}\\mathrm{Ne}",
    mass: 18622.8401422,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100200,
    name: "Ne20~",
    latex: "^{20}\\mathrm{\\overline{Ne}}",
    mass: 18622.8401422,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100210,
    name: "Ne21",
    latex: "^{21}\\mathrm{Ne}",
    mass: 19555.6444061,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100210,
    name: "Ne21~",
    latex: "^{21}\\mathrm{\\overline{Ne}}",
    mass: 19555.6444061,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100220,
    name: "Ne22",
    latex: "^{22}\\mathrm{Ne}",
    mass: 20484.8455663,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100220,
    name: "Ne22~",
    latex: "^{22}\\mathrm{\\overline{Ne}}",
    mass: 20484.8455663,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100230,
    name: "Ne23",
    latex: "^{23}\\mathrm{Ne}",
    mass: 21419.2103448,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100230,
    name: "Ne23~",
    latex: "^{23}\\mathrm{\\overline{Ne}}",
    mass: 21419.2103448,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100240,
    name: "Ne24",
    latex: "^{24}\\mathrm{Ne}",
    mass: 22349.9068008,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100240,
    name: "Ne24~",
    latex: "^{24}\\mathrm{\\overline{Ne}}",
    mass: 22349.9068008,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100250,
    name: "Ne25",
    latex: "^{25}\\mathrm{Ne}",
    mass: 23285.3126209,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100250,
    name: "Ne25~",
    latex: "^{25}\\mathrm{\\overline{Ne}}",
    mass: 23285.3126209,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100260,
    name: "Ne26",
    latex: "^{26}\\mathrm{Ne}",
    mass: 24219.3273476,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100260,
    name: "Ne26~",
    latex: "^{26}\\mathrm{\\overline{Ne}}",
    mass: 24219.3273476,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100270,
    name: "Ne27",
    latex: "^{27}\\mathrm{Ne}",
    mass: 25157.3922108,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100270,
    name: "Ne27~",
    latex: "^{27}\\mathrm{\\overline{Ne}}",
    mass: 25157.3922108,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100280,
    name: "Ne28",
    latex: "^{28}\\mathrm{Ne}",
    mass: 26093.1339276,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100280,
    name: "Ne28~",
    latex: "^{28}\\mathrm{\\overline{Ne}}",
    mass: 26093.1339276,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100290,
    name: "Ne29",
    latex: "^{29}\\mathrm{Ne}",
    mass: 27031.7260164,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100290,
    name: "Ne29~",
    latex: "^{29}\\mathrm{\\overline{Ne}}",
    mass: 27031.7260164,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100300,
    name: "Ne30",
    latex: "^{30}\\mathrm{Ne}",
    mass: 27968.1011492,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100300,
    name: "Ne30~",
    latex: "^{30}\\mathrm{\\overline{Ne}}",
    mass: 27968.1011492,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100310,
    name: "Ne31",
    latex: "^{31}\\mathrm{Ne}",
    mass: 28907.4943229,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100310,
    name: "Ne31~",
    latex: "^{31}\\mathrm{\\overline{Ne}}",
    mass: 28907.4943229,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000100320,
    name: "Ne32",
    latex: "^{32}\\mathrm{Ne}",
    mass: 29844.8102648,
    width: undefined,
    charge: 10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000100320,
    name: "Ne32~",
    latex: "^{32}\\mathrm{\\overline{Ne}}",
    mass: 29844.8102648,
    width: undefined,
    charge: -10.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110180,
    name: "Na18",
    latex: "^{18}\\mathrm{Na}",
    mass: 16791.9324284,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110180,
    name: "Na18~",
    latex: "^{18}\\mathrm{\\overline{Na}}",
    mass: 16791.9324284,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110190,
    name: "Na19",
    latex: "^{19}\\mathrm{Na}",
    mass: 17711.3171088,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110190,
    name: "Na19~",
    latex: "^{19}\\mathrm{\\overline{Na}}",
    mass: 17711.3171088,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110200,
    name: "Na20",
    latex: "^{20}\\mathrm{Na}",
    mass: 18636.7325615,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110200,
    name: "Na20~",
    latex: "^{20}\\mathrm{\\overline{Na}}",
    mass: 18636.7325615,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110210,
    name: "Na21",
    latex: "^{21}\\mathrm{Na}",
    mass: 19559.1913214,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110210,
    name: "Na21~",
    latex: "^{21}\\mathrm{\\overline{Na}}",
    mass: 19559.1913214,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110220,
    name: "Na22",
    latex: "^{22}\\mathrm{Na}",
    mass: 20487.6888924,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110220,
    name: "Na22~",
    latex: "^{22}\\mathrm{\\overline{Na}}",
    mass: 20487.6888924,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110230,
    name: "Na23",
    latex: "^{23}\\mathrm{Na}",
    mass: 21414.834532,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110230,
    name: "Na23~",
    latex: "^{23}\\mathrm{\\overline{Na}}",
    mass: 21414.834532,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110240,
    name: "Na24",
    latex: "^{24}\\mathrm{Na}",
    mass: 22347.4405882,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110240,
    name: "Na24~",
    latex: "^{24}\\mathrm{\\overline{Na}}",
    mass: 22347.4405882,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110250,
    name: "Na25",
    latex: "^{25}\\mathrm{Na}",
    mass: 23277.9948032,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110250,
    name: "Na25~",
    latex: "^{25}\\mathrm{\\overline{Na}}",
    mass: 23277.9948032,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110260,
    name: "Na26",
    latex: "^{26}\\mathrm{Na}",
    mass: 24211.9862426,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110260,
    name: "Na26~",
    latex: "^{26}\\mathrm{\\overline{Na}}",
    mass: 24211.9862426,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110270,
    name: "Na27",
    latex: "^{27}\\mathrm{Na}",
    mass: 25144.8226293,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110270,
    name: "Na27~",
    latex: "^{27}\\mathrm{\\overline{Na}}",
    mass: 25144.8226293,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110280,
    name: "Na28",
    latex: "^{28}\\mathrm{Na}",
    mass: 26080.8465889,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110280,
    name: "Na28~",
    latex: "^{28}\\mathrm{\\overline{Na}}",
    mass: 26080.8465889,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110290,
    name: "Na29",
    latex: "^{29}\\mathrm{Na}",
    mass: 27016.0089164,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110290,
    name: "Na29~",
    latex: "^{29}\\mathrm{\\overline{Na}}",
    mass: 27016.0089164,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110300,
    name: "Na30",
    latex: "^{30}\\mathrm{Na}",
    mass: 27953.2978449,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110300,
    name: "Na30~",
    latex: "^{30}\\mathrm{\\overline{Na}}",
    mass: 27953.2978449,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110310,
    name: "Na31",
    latex: "^{31}\\mathrm{Na}",
    mass: 28888.5635683,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110310,
    name: "Na31~",
    latex: "^{31}\\mathrm{\\overline{Na}}",
    mass: 28888.5635683,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110320,
    name: "Na32",
    latex: "^{32}\\mathrm{Na}",
    mass: 29826.450516,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110320,
    name: "Na32~",
    latex: "^{32}\\mathrm{\\overline{Na}}",
    mass: 29826.450516,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110330,
    name: "Na33",
    latex: "^{33}\\mathrm{Na}",
    mass: 30763.0864672,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110330,
    name: "Na33~",
    latex: "^{33}\\mathrm{\\overline{Na}}",
    mass: 30763.0864672,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110340,
    name: "Na34",
    latex: "^{34}\\mathrm{Na}",
    mass: 31702.4796409,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110340,
    name: "Na34~",
    latex: "^{34}\\mathrm{\\overline{Na}}",
    mass: 31702.4796409,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000110350,
    name: "Na35",
    latex: "^{35}\\mathrm{Na}",
    mass: 32640.1216057,
    width: undefined,
    charge: 11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000110350,
    name: "Na35~",
    latex: "^{35}\\mathrm{\\overline{Na}}",
    mass: 32640.1216057,
    width: undefined,
    charge: -11.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120200,
    name: "Mg20",
    latex: "^{20}\\mathrm{Mg}",
    mass: 18647.3597914,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120200,
    name: "Mg20~",
    latex: "^{20}\\mathrm{\\overline{Mg}}",
    mass: 18647.3597914,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120210,
    name: "Mg21",
    latex: "^{21}\\mathrm{Mg}",
    mass: 19572.2800618,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120210,
    name: "Mg21~",
    latex: "^{21}\\mathrm{\\overline{Mg}}",
    mass: 19572.2800618,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120220,
    name: "Mg22",
    latex: "^{22}\\mathrm{Mg}",
    mass: 20492.4702982,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120220,
    name: "Mg22~",
    latex: "^{22}\\mathrm{\\overline{Mg}}",
    mass: 20492.4702982,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120230,
    name: "Mg23",
    latex: "^{23}\\mathrm{Mg}",
    mass: 21418.8907119,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120230,
    name: "Mg23~",
    latex: "^{23}\\mathrm{\\overline{Mg}}",
    mass: 21418.8907119,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120240,
    name: "Mg24",
    latex: "^{24}\\mathrm{Mg}",
    mass: 22341.9249107,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120240,
    name: "Mg24~",
    latex: "^{24}\\mathrm{\\overline{Mg}}",
    mass: 22341.9249107,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120250,
    name: "Mg25",
    latex: "^{25}\\mathrm{Mg}",
    mass: 23274.159814,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120250,
    name: "Mg25~",
    latex: "^{25}\\mathrm{\\overline{Mg}}",
    mass: 23274.159814,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120260,
    name: "Mg26",
    latex: "^{26}\\mathrm{Mg}",
    mass: 24202.6321509,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120260,
    name: "Mg26~",
    latex: "^{26}\\mathrm{\\overline{Mg}}",
    mass: 24202.6321509,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120270,
    name: "Mg27",
    latex: "^{27}\\mathrm{Mg}",
    mass: 25135.7542082,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120270,
    name: "Mg27~",
    latex: "^{27}\\mathrm{\\overline{Mg}}",
    mass: 25135.7542082,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120280,
    name: "Mg28",
    latex: "^{28}\\mathrm{Mg}",
    mass: 26066.8149622,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120280,
    name: "Mg28~",
    latex: "^{28}\\mathrm{\\overline{Mg}}",
    mass: 26066.8149622,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120290,
    name: "Mg29",
    latex: "^{29}\\mathrm{Mg}",
    mass: 27002.7166818,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120290,
    name: "Mg29~",
    latex: "^{29}\\mathrm{\\overline{Mg}}",
    mass: 27002.7166818,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120300,
    name: "Mg30",
    latex: "^{30}\\mathrm{Mg}",
    mass: 27935.941781,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120300,
    name: "Mg30~",
    latex: "^{30}\\mathrm{\\overline{Mg}}",
    mass: 27935.941781,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120310,
    name: "Mg31",
    latex: "^{31}\\mathrm{Mg}",
    mass: 28873.194847,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120310,
    name: "Mg31~",
    latex: "^{31}\\mathrm{\\overline{Mg}}",
    mass: 28873.194847,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120320,
    name: "Mg32",
    latex: "^{32}\\mathrm{Mg}",
    mass: 29806.9822892,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120320,
    name: "Mg32~",
    latex: "^{32}\\mathrm{\\overline{Mg}}",
    mass: 29806.9822892,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120330,
    name: "Mg33",
    latex: "^{33}\\mathrm{Mg}",
    mass: 30744.2683301,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120330,
    name: "Mg33~",
    latex: "^{33}\\mathrm{\\overline{Mg}}",
    mass: 30744.2683301,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120340,
    name: "Mg34",
    latex: "^{34}\\mathrm{Mg}",
    mass: 31679.1224262,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120340,
    name: "Mg34~",
    latex: "^{34}\\mathrm{\\overline{Mg}}",
    mass: 31679.1224262,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120350,
    name: "Mg35",
    latex: "^{35}\\mathrm{Mg}",
    mass: 32617.9334162,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120350,
    name: "Mg35~",
    latex: "^{35}\\mathrm{\\overline{Mg}}",
    mass: 32617.9334162,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120360,
    name: "Mg36",
    latex: "^{36}\\mathrm{Mg}",
    mass: 33554.1688249,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120360,
    name: "Mg36~",
    latex: "^{36}\\mathrm{\\overline{Mg}}",
    mass: 33554.1688249,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000120370,
    name: "Mg37",
    latex: "^{37}\\mathrm{Mg}",
    mass: 34493.496794,
    width: undefined,
    charge: 12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000120370,
    name: "Mg37~",
    latex: "^{37}\\mathrm{\\overline{Mg}}",
    mass: 34493.496794,
    width: undefined,
    charge: -12.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130210,
    name: "Al21",
    latex: "^{21}\\mathrm{Al}",
    mass: 19588.4640266,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130210,
    name: "Al21~",
    latex: "^{21}\\mathrm{\\overline{Al}}",
    mass: 19588.4640266,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130220,
    name: "Al22",
    latex: "^{22}\\mathrm{Al}",
    mass: 20511.0716766,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130220,
    name: "Al22~",
    latex: "^{22}\\mathrm{\\overline{Al}}",
    mass: 20511.0716766,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130230,
    name: "Al23",
    latex: "^{23}\\mathrm{Al}",
    mass: 21431.1125014,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130230,
    name: "Al23~",
    latex: "^{23}\\mathrm{\\overline{Al}}",
    mass: 21431.1125014,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130240,
    name: "Al24",
    latex: "^{24}\\mathrm{Al}",
    mass: 22355.809679,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130240,
    name: "Al24~",
    latex: "^{24}\\mathrm{\\overline{Al}}",
    mass: 22355.809679,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130250,
    name: "Al25",
    latex: "^{25}\\mathrm{Al}",
    mass: 23278.4366202,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130250,
    name: "Al25~",
    latex: "^{25}\\mathrm{\\overline{Al}}",
    mass: 23278.4366202,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130260,
    name: "Al26",
    latex: "^{26}\\mathrm{Al}",
    mass: 24206.6365602,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130260,
    name: "Al26~",
    latex: "^{26}\\mathrm{\\overline{Al}}",
    mass: 24206.6365602,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130270,
    name: "Al27",
    latex: "^{27}\\mathrm{Al}",
    mass: 25133.1439382,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130270,
    name: "Al27~",
    latex: "^{27}\\mathrm{\\overline{Al}}",
    mass: 25133.1439382,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130280,
    name: "Al28",
    latex: "^{28}\\mathrm{Al}",
    mass: 26064.9841851,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130280,
    name: "Al28~",
    latex: "^{28}\\mathrm{\\overline{Al}}",
    mass: 26064.9841851,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130290,
    name: "Al29",
    latex: "^{29}\\mathrm{Al}",
    mass: 26995.1212789,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130290,
    name: "Al29~",
    latex: "^{29}\\mathrm{\\overline{Al}}",
    mass: 26995.1212789,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130300,
    name: "Al30",
    latex: "^{30}\\mathrm{Al}",
    mass: 27928.9590218,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130300,
    name: "Al30~",
    latex: "^{30}\\mathrm{\\overline{Al}}",
    mass: 27928.9590218,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130310,
    name: "Al31",
    latex: "^{31}\\mathrm{Al}",
    mass: 28861.3665486,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130310,
    name: "Al31~",
    latex: "^{31}\\mathrm{\\overline{Al}}",
    mass: 28861.3665486,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130320,
    name: "Al32",
    latex: "^{32}\\mathrm{Al}",
    mass: 29796.7116353,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130320,
    name: "Al32~",
    latex: "^{32}\\mathrm{\\overline{Al}}",
    mass: 29796.7116353,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130330,
    name: "Al33",
    latex: "^{33}\\mathrm{Al}",
    mass: 30730.8083335,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130330,
    name: "Al33~",
    latex: "^{33}\\mathrm{\\overline{Al}}",
    mass: 30730.8083335,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130340,
    name: "Al34",
    latex: "^{34}\\mathrm{Al}",
    mass: 31667.8018853,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130340,
    name: "Al34~",
    latex: "^{34}\\mathrm{\\overline{Al}}",
    mass: 31667.8018853,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130350,
    name: "Al35",
    latex: "^{35}\\mathrm{Al}",
    mass: 32602.0700716,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130350,
    name: "Al35~",
    latex: "^{35}\\mathrm{\\overline{Al}}",
    mass: 32602.0700716,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130360,
    name: "Al36",
    latex: "^{36}\\mathrm{Al}",
    mass: 33539.7399812,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130360,
    name: "Al36~",
    latex: "^{36}\\mathrm{\\overline{Al}}",
    mass: 33539.7399812,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130370,
    name: "Al37",
    latex: "^{37}\\mathrm{Al}",
    mass: 34475.0904705,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130370,
    name: "Al37~",
    latex: "^{37}\\mathrm{\\overline{Al}}",
    mass: 34475.0904705,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130380,
    name: "Al38",
    latex: "^{38}\\mathrm{Al}",
    mass: 35413.2447571,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130380,
    name: "Al38~",
    latex: "^{38}\\mathrm{\\overline{Al}}",
    mass: 35413.2447571,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000130390,
    name: "Al39",
    latex: "^{39}\\mathrm{Al}",
    mass: 36349.759614,
    width: undefined,
    charge: 13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000130390,
    name: "Al39~",
    latex: "^{39}\\mathrm{\\overline{Al}}",
    mass: 36349.759614,
    width: undefined,
    charge: -13.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140220,
    name: "Si22",
    latex: "^{22}\\mathrm{Si}",
    mass: 20526.5065339,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140220,
    name: "Si22~",
    latex: "^{22}\\mathrm{\\overline{Si}}",
    mass: 20526.5065339,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140230,
    name: "Si23",
    latex: "^{23}\\mathrm{Si}",
    mass: 21448.3130989,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140230,
    name: "Si23~",
    latex: "^{23}\\mathrm{\\overline{Si}}",
    mass: 21448.3130989,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140240,
    name: "Si24",
    latex: "^{24}\\mathrm{Si}",
    mass: 22366.6032737,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140240,
    name: "Si24~",
    latex: "^{24}\\mathrm{\\overline{Si}}",
    mass: 22366.6032737,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140250,
    name: "Si25",
    latex: "^{25}\\mathrm{Si}",
    mass: 23291.1801022,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140250,
    name: "Si25~",
    latex: "^{25}\\mathrm{\\overline{Si}}",
    mass: 23291.1801022,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140260,
    name: "Si26",
    latex: "^{26}\\mathrm{Si}",
    mass: 24211.7056952,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140260,
    name: "Si26~",
    latex: "^{26}\\mathrm{\\overline{Si}}",
    mass: 24211.7056952,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140270,
    name: "Si27",
    latex: "^{27}\\mathrm{Si}",
    mass: 25137.9562975,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140270,
    name: "Si27~",
    latex: "^{27}\\mathrm{\\overline{Si}}",
    mass: 25137.9562975,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140280,
    name: "Si28",
    latex: "^{28}\\mathrm{Si}",
    mass: 26060.342107,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140280,
    name: "Si28~",
    latex: "^{28}\\mathrm{\\overline{Si}}",
    mass: 26060.342107,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140290,
    name: "Si29",
    latex: "^{29}\\mathrm{Si}",
    mass: 26991.4339262,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140290,
    name: "Si29~",
    latex: "^{29}\\mathrm{\\overline{Si}}",
    mass: 26991.4339262,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140300,
    name: "Si30",
    latex: "^{30}\\mathrm{Si}",
    mass: 27920.3901488,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140300,
    name: "Si30~",
    latex: "^{30}\\mathrm{\\overline{Si}}",
    mass: 27920.3901488,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140310,
    name: "Si31",
    latex: "^{31}\\mathrm{Si}",
    mass: 28853.3681813,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140310,
    name: "Si31~",
    latex: "^{31}\\mathrm{\\overline{Si}}",
    mass: 28853.3681813,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140320,
    name: "Si32",
    latex: "^{32}\\mathrm{Si}",
    mass: 29783.7335937,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140320,
    name: "Si32~",
    latex: "^{32}\\mathrm{\\overline{Si}}",
    mass: 29783.7335937,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140330,
    name: "Si33",
    latex: "^{33}\\mathrm{Si}",
    mass: 30718.7911281,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140330,
    name: "Si33~",
    latex: "^{33}\\mathrm{\\overline{Si}}",
    mass: 30718.7911281,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140340,
    name: "Si34",
    latex: "^{34}\\mathrm{Si}",
    mass: 31650.8078,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140340,
    name: "Si34~",
    latex: "^{34}\\mathrm{\\overline{Si}}",
    mass: 31650.8078,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140350,
    name: "Si35",
    latex: "^{35}\\mathrm{Si}",
    mass: 32587.9020462,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140350,
    name: "Si35~",
    latex: "^{35}\\mathrm{\\overline{Si}}",
    mass: 32587.9020462,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140360,
    name: "Si36",
    latex: "^{36}\\mathrm{Si}",
    mass: 33521.3522876,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140360,
    name: "Si36~",
    latex: "^{36}\\mathrm{\\overline{Si}}",
    mass: 33521.3522876,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140370,
    name: "Si37",
    latex: "^{37}\\mathrm{Si}",
    mass: 34458.7148042,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140370,
    name: "Si37~",
    latex: "^{37}\\mathrm{\\overline{Si}}",
    mass: 34458.7148042,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140380,
    name: "Si38",
    latex: "^{38}\\mathrm{Si}",
    mass: 35392.6028477,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140380,
    name: "Si38~",
    latex: "^{38}\\mathrm{\\overline{Si}}",
    mass: 35392.6028477,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140390,
    name: "Si39",
    latex: "^{39}\\mathrm{Si}",
    mass: 36330.5894653,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140390,
    name: "Si39~",
    latex: "^{39}\\mathrm{\\overline{Si}}",
    mass: 36330.5894653,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140400,
    name: "Si40",
    latex: "^{40}\\mathrm{Si}",
    mass: 37265.4276329,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140400,
    name: "Si40~",
    latex: "^{40}\\mathrm{\\overline{Si}}",
    mass: 37265.4276329,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140410,
    name: "Si41",
    latex: "^{41}\\mathrm{Si}",
    mass: 38204.4575239,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140410,
    name: "Si41~",
    latex: "^{41}\\mathrm{\\overline{Si}}",
    mass: 38204.4575239,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000140420,
    name: "Si42",
    latex: "^{42}\\mathrm{Si}",
    mass: 39139.5937696,
    width: undefined,
    charge: 14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000140420,
    name: "Si42~",
    latex: "^{42}\\mathrm{\\overline{Si}}",
    mass: 39139.5937696,
    width: undefined,
    charge: -14.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150240,
    name: "P24",
    latex: "^{24}\\mathrm{P}",
    mass: 22389.8766539,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150240,
    name: "P24~",
    latex: "^{24}\\mathrm{\\overline{P}}",
    mass: 22389.8766539,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150250,
    name: "P25",
    latex: "^{25}\\mathrm{P}",
    mass: 23307.5473851,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150250,
    name: "P25~",
    latex: "^{25}\\mathrm{\\overline{P}}",
    mass: 23307.5473851,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150260,
    name: "P26",
    latex: "^{26}\\mathrm{P}",
    mass: 24229.8196972,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150260,
    name: "P26~",
    latex: "^{26}\\mathrm{\\overline{P}}",
    mass: 24229.8196972,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150270,
    name: "P27",
    latex: "^{27}\\mathrm{P}",
    mass: 25149.6813026,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150270,
    name: "P27~",
    latex: "^{27}\\mathrm{\\overline{P}}",
    mass: 25149.6813026,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150280,
    name: "P28",
    latex: "^{28}\\mathrm{P}",
    mass: 26074.6870841,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150280,
    name: "P28~",
    latex: "^{28}\\mathrm{\\overline{P}}",
    mass: 26074.6870841,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150290,
    name: "P29",
    latex: "^{29}\\mathrm{P}",
    mass: 26996.3761877,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150290,
    name: "P29~",
    latex: "^{29}\\mathrm{\\overline{P}}",
    mass: 26996.3761877,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150300,
    name: "P30",
    latex: "^{30}\\mathrm{P}",
    mass: 27924.6222554,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150300,
    name: "P30~",
    latex: "^{30}\\mathrm{\\overline{P}}",
    mass: 27924.6222554,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150310,
    name: "P31",
    latex: "^{31}\\mathrm{P}",
    mass: 28851.8766708,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150310,
    name: "P31~",
    latex: "^{31}\\mathrm{\\overline{P}}",
    mass: 28851.8766708,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150320,
    name: "P32",
    latex: "^{32}\\mathrm{P}",
    mass: 29783.5064395,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150320,
    name: "P32~",
    latex: "^{32}\\mathrm{\\overline{P}}",
    mass: 29783.5064395,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150330,
    name: "P33",
    latex: "^{33}\\mathrm{P}",
    mass: 30712.968079,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150330,
    name: "P33~",
    latex: "^{33}\\mathrm{\\overline{P}}",
    mass: 30712.968079,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150340,
    name: "P34",
    latex: "^{34}\\mathrm{P}",
    mass: 31646.2508377,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150340,
    name: "P34~",
    latex: "^{34}\\mathrm{\\overline{P}}",
    mass: 31646.2508377,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150350,
    name: "P35",
    latex: "^{35}\\mathrm{P}",
    mass: 32577.4357785,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150350,
    name: "P35~",
    latex: "^{35}\\mathrm{\\overline{P}}",
    mass: 32577.4357785,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150360,
    name: "P36",
    latex: "^{36}\\mathrm{P}",
    mass: 33513.5370521,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150360,
    name: "P36~",
    latex: "^{36}\\mathrm{\\overline{P}}",
    mass: 33513.5370521,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150370,
    name: "P37",
    latex: "^{37}\\mathrm{P}",
    mass: 34446.2886728,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150370,
    name: "P37~",
    latex: "^{37}\\mathrm{\\overline{P}}",
    mass: 34446.2886728,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150380,
    name: "P38",
    latex: "^{38}\\mathrm{P}",
    mass: 35382.1514839,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150380,
    name: "P38~",
    latex: "^{38}\\mathrm{\\overline{P}}",
    mass: 35382.1514839,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150390,
    name: "P39",
    latex: "^{39}\\mathrm{P}",
    mass: 36315.4992609,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150390,
    name: "P39~",
    latex: "^{39}\\mathrm{\\overline{P}}",
    mass: 36315.4992609,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150400,
    name: "P40",
    latex: "^{40}\\mathrm{P}",
    mass: 37251.6228903,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150400,
    name: "P40~",
    latex: "^{40}\\mathrm{\\overline{P}}",
    mass: 37251.6228903,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150410,
    name: "P41",
    latex: "^{41}\\mathrm{P}",
    mass: 38186.274759,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150410,
    name: "P41~",
    latex: "^{41}\\mathrm{\\overline{P}}",
    mass: 38186.274759,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150420,
    name: "P42",
    latex: "^{42}\\mathrm{P}",
    mass: 39123.8422043,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150420,
    name: "P42~",
    latex: "^{42}\\mathrm{\\overline{P}}",
    mass: 39123.8422043,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150430,
    name: "P43",
    latex: "^{43}\\mathrm{P}",
    mass: 40059.285843,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150430,
    name: "P43~",
    latex: "^{43}\\mathrm{\\overline{P}}",
    mass: 40059.285843,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150440,
    name: "P44",
    latex: "^{44}\\mathrm{P}",
    mass: 40996.8532883,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150440,
    name: "P44~",
    latex: "^{44}\\mathrm{\\overline{P}}",
    mass: 40996.8532883,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150450,
    name: "P45",
    latex: "^{45}\\mathrm{P}",
    mass: 41933.1911613,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150450,
    name: "P45~",
    latex: "^{45}\\mathrm{\\overline{P}}",
    mass: 41933.1911613,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000150460,
    name: "P46",
    latex: "^{46}\\mathrm{P}",
    mass: 42871.5690065,
    width: undefined,
    charge: 15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000150460,
    name: "P46~",
    latex: "^{46}\\mathrm{\\overline{P}}",
    mass: 42871.5690065,
    width: undefined,
    charge: -15.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160260,
    name: "S26",
    latex: "^{26}\\mathrm{S}",
    mass: 24246.5307014,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160260,
    name: "S26~",
    latex: "^{26}\\mathrm{\\overline{S}}",
    mass: 24246.5307014,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160270,
    name: "S27",
    latex: "^{27}\\mathrm{S}",
    mass: 25167.8342597,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160270,
    name: "S27~",
    latex: "^{27}\\mathrm{\\overline{S}}",
    mass: 25167.8342597,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160280,
    name: "S28",
    latex: "^{28}\\mathrm{S}",
    mass: 26085.9055334,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160280,
    name: "S28~",
    latex: "^{28}\\mathrm{\\overline{S}}",
    mass: 26085.9055334,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160290,
    name: "S29",
    latex: "^{29}\\mathrm{S}",
    mass: 27010.2345844,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160290,
    name: "S29~",
    latex: "^{29}\\mathrm{\\overline{S}}",
    mass: 27010.2345844,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160300,
    name: "S30",
    latex: "^{30}\\mathrm{S}",
    mass: 27930.7638568,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160300,
    name: "S30~",
    latex: "^{30}\\mathrm{\\overline{S}}",
    mass: 27930.7638568,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160310,
    name: "S31",
    latex: "^{31}\\mathrm{S}",
    mass: 28857.2746813,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160310,
    name: "S31~",
    latex: "^{31}\\mathrm{\\overline{S}}",
    mass: 28857.2746813,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160320,
    name: "S32",
    latex: "^{32}\\mathrm{S}",
    mass: 29781.7957818,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160320,
    name: "S32~",
    latex: "^{32}\\mathrm{\\overline{S}}",
    mass: 29781.7957818,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160330,
    name: "S33",
    latex: "^{33}\\mathrm{S}",
    mass: 30712.7195644,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160330,
    name: "S33~",
    latex: "^{33}\\mathrm{\\overline{S}}",
    mass: 30712.7195644,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160340,
    name: "S34",
    latex: "^{34}\\mathrm{S}",
    mass: 31640.8678357,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160340,
    name: "S34~",
    latex: "^{34}\\mathrm{\\overline{S}}",
    mass: 31640.8678357,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160350,
    name: "S35",
    latex: "^{35}\\mathrm{S}",
    mass: 32573.4474188,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160350,
    name: "S35~",
    latex: "^{35}\\mathrm{\\overline{S}}",
    mass: 32573.4474188,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160360,
    name: "S36",
    latex: "^{36}\\mathrm{S}",
    mass: 33503.1235907,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160360,
    name: "S36~",
    latex: "^{36}\\mathrm{\\overline{S}}",
    mass: 33503.1235907,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160370,
    name: "S37",
    latex: "^{37}\\mathrm{S}",
    mass: 34438.3854111,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160370,
    name: "S37~",
    latex: "^{37}\\mathrm{\\overline{S}}",
    mass: 34438.3854111,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160380,
    name: "S38",
    latex: "^{38}\\mathrm{S}",
    mass: 35369.9144458,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160380,
    name: "S38~",
    latex: "^{38}\\mathrm{\\overline{S}}",
    mass: 35369.9144458,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160390,
    name: "S39",
    latex: "^{39}\\mathrm{S}",
    mass: 36305.1037867,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160390,
    name: "S39~",
    latex: "^{39}\\mathrm{\\overline{S}}",
    mass: 36305.1037867,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160400,
    name: "S40",
    latex: "^{40}\\mathrm{S}",
    mass: 37236.9267078,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160400,
    name: "S40~",
    latex: "^{40}\\mathrm{\\overline{S}}",
    mass: 37236.9267078,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160410,
    name: "S41",
    latex: "^{41}\\mathrm{S}",
    mass: 38172.2492523,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160410,
    name: "S41~",
    latex: "^{41}\\mathrm{\\overline{S}}",
    mass: 38172.2492523,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160420,
    name: "S42",
    latex: "^{42}\\mathrm{S}",
    mass: 39105.1145153,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160420,
    name: "S42~",
    latex: "^{42}\\mathrm{\\overline{S}}",
    mass: 39105.1145153,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160430,
    name: "S43",
    latex: "^{43}\\mathrm{S}",
    mass: 40042.0513391,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160430,
    name: "S43~",
    latex: "^{43}\\mathrm{\\overline{S}}",
    mass: 40042.0513391,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160440,
    name: "S44",
    latex: "^{44}\\mathrm{S}",
    mass: 40976.5364704,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160440,
    name: "S44~",
    latex: "^{44}\\mathrm{\\overline{S}}",
    mass: 40976.5364704,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160450,
    name: "S45",
    latex: "^{45}\\mathrm{S}",
    mass: 41913.8906035,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160450,
    name: "S45~",
    latex: "^{45}\\mathrm{\\overline{S}}",
    mass: 41913.8906035,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160460,
    name: "S46",
    latex: "^{46}\\mathrm{S}",
    mass: 42849.371502,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160460,
    name: "S46~",
    latex: "^{46}\\mathrm{\\overline{S}}",
    mass: 42849.371502,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160470,
    name: "S47",
    latex: "^{47}\\mathrm{S}",
    mass: 43787.4233242,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160470,
    name: "S47~",
    latex: "^{47}\\mathrm{\\overline{S}}",
    mass: 43787.4233242,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160480,
    name: "S48",
    latex: "^{48}\\mathrm{S}",
    mass: 44724.1058501,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160480,
    name: "S48~",
    latex: "^{48}\\mathrm{\\overline{S}}",
    mass: 44724.1058501,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000160490,
    name: "S49",
    latex: "^{49}\\mathrm{S}",
    mass: 45663.6014881,
    width: undefined,
    charge: 16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000160490,
    name: "S49~",
    latex: "^{49}\\mathrm{\\overline{S}}",
    mass: 45663.6014881,
    width: undefined,
    charge: -16.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170280,
    name: "Cl28",
    latex: "^{28}\\mathrm{Cl}",
    mass: 26110.1057502,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170280,
    name: "Cl28~",
    latex: "^{28}\\mathrm{\\overline{Cl}}",
    mass: 26110.1057502,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170290,
    name: "Cl29",
    latex: "^{29}\\mathrm{Cl}",
    mass: 27027.3479941,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170290,
    name: "Cl29~",
    latex: "^{29}\\mathrm{\\overline{Cl}}",
    mass: 27027.3479941,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170300,
    name: "Cl30",
    latex: "^{30}\\mathrm{Cl}",
    mass: 27949.497349,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170300,
    name: "Cl30~",
    latex: "^{30}\\mathrm{\\overline{Cl}}",
    mass: 27949.497349,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170310,
    name: "Cl31",
    latex: "^{31}\\mathrm{Cl}",
    mass: 28869.2825718,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170310,
    name: "Cl31~",
    latex: "^{31}\\mathrm{\\overline{Cl}}",
    mass: 28869.2825718,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170320,
    name: "Cl32",
    latex: "^{32}\\mathrm{Cl}",
    mass: 29794.4766083,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170320,
    name: "Cl32~",
    latex: "^{32}\\mathrm{\\overline{Cl}}",
    mass: 29794.4766083,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170330,
    name: "Cl33",
    latex: "^{33}\\mathrm{Cl}",
    mass: 30718.3020937,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170330,
    name: "Cl33~",
    latex: "^{33}\\mathrm{\\overline{Cl}}",
    mass: 30718.3020937,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170340,
    name: "Cl34",
    latex: "^{34}\\mathrm{Cl}",
    mass: 31646.3594406,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170340,
    name: "Cl34~",
    latex: "^{34}\\mathrm{\\overline{Cl}}",
    mass: 31646.3594406,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170350,
    name: "Cl35",
    latex: "^{35}\\mathrm{Cl}",
    mass: 32573.2800945,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170350,
    name: "Cl35~",
    latex: "^{35}\\mathrm{\\overline{Cl}}",
    mass: 32573.2800945,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170360,
    name: "Cl36",
    latex: "^{36}\\mathrm{Cl}",
    mass: 33504.2657236,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170360,
    name: "Cl36~",
    latex: "^{36}\\mathrm{\\overline{Cl}}",
    mass: 33504.2657236,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170370,
    name: "Cl37",
    latex: "^{37}\\mathrm{Cl}",
    mass: 34433.5202826,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170370,
    name: "Cl37~",
    latex: "^{37}\\mathrm{\\overline{Cl}}",
    mass: 34433.5202826,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170380,
    name: "Cl38",
    latex: "^{38}\\mathrm{Cl}",
    mass: 35366.9778268,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170380,
    name: "Cl38~",
    latex: "^{38}\\mathrm{\\overline{Cl}}",
    mass: 35366.9778268,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170390,
    name: "Cl39",
    latex: "^{39}\\mathrm{Cl}",
    mass: 36298.469872,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170390,
    name: "Cl39~",
    latex: "^{39}\\mathrm{\\overline{Cl}}",
    mass: 36298.469872,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170400,
    name: "Cl40",
    latex: "^{40}\\mathrm{Cl}",
    mass: 37232.2105532,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170400,
    name: "Cl40~",
    latex: "^{40}\\mathrm{\\overline{Cl}}",
    mass: 37232.2105532,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170410,
    name: "Cl41",
    latex: "^{41}\\mathrm{Cl}",
    mass: 38163.9468453,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170410,
    name: "Cl41~",
    latex: "^{41}\\mathrm{\\overline{Cl}}",
    mass: 38163.9468453,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170420,
    name: "Cl42",
    latex: "^{42}\\mathrm{Cl}",
    mass: 39097.9187234,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170420,
    name: "Cl42~",
    latex: "^{42}\\mathrm{\\overline{Cl}}",
    mass: 39097.9187234,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170430,
    name: "Cl43",
    latex: "^{43}\\mathrm{Cl}",
    mass: 40030.0835028,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170430,
    name: "Cl43~",
    latex: "^{43}\\mathrm{\\overline{Cl}}",
    mass: 40030.0835028,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170440,
    name: "Cl44",
    latex: "^{44}\\mathrm{Cl}",
    mass: 40965.2570083,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170440,
    name: "Cl44~",
    latex: "^{44}\\mathrm{\\overline{Cl}}",
    mass: 40965.2570083,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170450,
    name: "Cl45",
    latex: "^{45}\\mathrm{Cl}",
    mass: 41898.968068,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170450,
    name: "Cl45~",
    latex: "^{45}\\mathrm{\\overline{Cl}}",
    mass: 41898.968068,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170460,
    name: "Cl46",
    latex: "^{46}\\mathrm{Cl}",
    mass: 42834.989233,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170460,
    name: "Cl46~",
    latex: "^{46}\\mathrm{\\overline{Cl}}",
    mass: 42834.989233,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170470,
    name: "Cl47",
    latex: "^{47}\\mathrm{Cl}",
    mass: 43770.6471154,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170470,
    name: "Cl47~",
    latex: "^{47}\\mathrm{\\overline{Cl}}",
    mass: 43770.6471154,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170480,
    name: "Cl48",
    latex: "^{48}\\mathrm{Cl}",
    mass: 44707.4414206,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170480,
    name: "Cl48~",
    latex: "^{48}\\mathrm{\\overline{Cl}}",
    mass: 44707.4414206,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170490,
    name: "Cl49",
    latex: "^{49}\\mathrm{Cl}",
    mass: 45643.9469626,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170490,
    name: "Cl49~",
    latex: "^{49}\\mathrm{\\overline{Cl}}",
    mass: 45643.9469626,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170500,
    name: "Cl50",
    latex: "^{50}\\mathrm{Cl}",
    mass: 46582.4086422,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170500,
    name: "Cl50~",
    latex: "^{50}\\mathrm{\\overline{Cl}}",
    mass: 46582.4086422,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000170510,
    name: "Cl51",
    latex: "^{51}\\mathrm{Cl}",
    mass: 47520.4884092,
    width: undefined,
    charge: 17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000170510,
    name: "Cl51~",
    latex: "^{51}\\mathrm{\\overline{Cl}}",
    mass: 47520.4884092,
    width: undefined,
    charge: -17.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180300,
    name: "Ar30",
    latex: "^{30}\\mathrm{Ar}",
    mass: 27966.8902069,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180300,
    name: "Ar30~",
    latex: "^{30}\\mathrm{\\overline{Ar}}",
    mass: 27966.8902069,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180310,
    name: "Ar31",
    latex: "^{31}\\mathrm{Ar}",
    mass: 28887.6441836,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180310,
    name: "Ar31~",
    latex: "^{31}\\mathrm{\\overline{Ar}}",
    mass: 28887.6441836,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180320,
    name: "Ar32",
    latex: "^{32}\\mathrm{Ar}",
    mass: 29805.6109436,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180320,
    name: "Ar32~",
    latex: "^{32}\\mathrm{\\overline{Ar}}",
    mass: 29805.6109436,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180330,
    name: "Ar33",
    latex: "^{33}\\mathrm{Ar}",
    mass: 30729.9210854,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180330,
    name: "Ar33~",
    latex: "^{33}\\mathrm{\\overline{Ar}}",
    mass: 30729.9210854,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180340,
    name: "Ar34",
    latex: "^{34}\\mathrm{Ar}",
    mass: 31652.4212316,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180340,
    name: "Ar34~",
    latex: "^{34}\\mathrm{\\overline{Ar}}",
    mass: 31652.4212316,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180350,
    name: "Ar35",
    latex: "^{35}\\mathrm{Ar}",
    mass: 32579.2463236,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180350,
    name: "Ar35~",
    latex: "^{35}\\mathrm{\\overline{Ar}}",
    mass: 32579.2463236,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180360,
    name: "Ar36",
    latex: "^{36}\\mathrm{Ar}",
    mass: 33503.5561915,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180360,
    name: "Ar36~",
    latex: "^{36}\\mathrm{\\overline{Ar}}",
    mass: 33503.5561915,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180370,
    name: "Ar37",
    latex: "^{37}\\mathrm{Ar}",
    mass: 34434.3341569,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180370,
    name: "Ar37~",
    latex: "^{37}\\mathrm{\\overline{Ar}}",
    mass: 34434.3341569,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180380,
    name: "Ar38",
    latex: "^{38}\\mathrm{Ar}",
    mass: 35362.0611122,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180380,
    name: "Ar38~",
    latex: "^{38}\\mathrm{\\overline{Ar}}",
    mass: 35362.0611122,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180390,
    name: "Ar39",
    latex: "^{39}\\mathrm{Ar}",
    mass: 36295.0278149,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180390,
    name: "Ar39~",
    latex: "^{39}\\mathrm{\\overline{Ar}}",
    mass: 36295.0278149,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180400,
    name: "Ar40",
    latex: "^{40}\\mathrm{Ar}",
    mass: 37224.7242487,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180400,
    name: "Ar40~",
    latex: "^{40}\\mathrm{\\overline{Ar}}",
    mass: 37224.7242487,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180410,
    name: "Ar41",
    latex: "^{41}\\mathrm{Ar}",
    mass: 38158.1907707,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180410,
    name: "Ar41~",
    latex: "^{41}\\mathrm{\\overline{Ar}}",
    mass: 38158.1907707,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180420,
    name: "Ar42",
    latex: "^{42}\\mathrm{Ar}",
    mass: 39088.3299231,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180420,
    name: "Ar42~",
    latex: "^{42}\\mathrm{\\overline{Ar}}",
    mass: 39088.3299231,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180430,
    name: "Ar43",
    latex: "^{43}\\mathrm{Ar}",
    mass: 40022.2365965,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180430,
    name: "Ar43~",
    latex: "^{43}\\mathrm{\\overline{Ar}}",
    mass: 40022.2365965,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180440,
    name: "Ar44",
    latex: "^{44}\\mathrm{Ar}",
    mass: 40953.0672901,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180440,
    name: "Ar44~",
    latex: "^{44}\\mathrm{\\overline{Ar}}",
    mass: 40953.0672901,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180450,
    name: "Ar45",
    latex: "^{45}\\mathrm{Ar}",
    mass: 41887.4638363,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180450,
    name: "Ar45~",
    latex: "^{45}\\mathrm{\\overline{Ar}}",
    mass: 41887.4638363,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180460,
    name: "Ar46",
    latex: "^{46}\\mathrm{Ar}",
    mass: 42818.9574743,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180460,
    name: "Ar46~",
    latex: "^{46}\\mathrm{\\overline{Ar}}",
    mass: 42818.9574743,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180470,
    name: "Ar47",
    latex: "^{47}\\mathrm{Ar}",
    mass: 43754.855589,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180470,
    name: "Ar47~",
    latex: "^{47}\\mathrm{\\overline{Ar}}",
    mass: 43754.855589,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180480,
    name: "Ar48",
    latex: "^{48}\\mathrm{Ar}",
    mass: 44689.3620515,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180480,
    name: "Ar48~",
    latex: "^{48}\\mathrm{\\overline{Ar}}",
    mass: 44689.3620515,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180490,
    name: "Ar49",
    latex: "^{49}\\mathrm{Ar}",
    mass: 45626.1554252,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180490,
    name: "Ar49~",
    latex: "^{49}\\mathrm{\\overline{Ar}}",
    mass: 45626.1554252,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180500,
    name: "Ar50",
    latex: "^{50}\\mathrm{Ar}",
    mass: 46561.4779697,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180500,
    name: "Ar50~",
    latex: "^{50}\\mathrm{\\overline{Ar}}",
    mass: 46561.4779697,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180510,
    name: "Ar51",
    latex: "^{51}\\mathrm{Ar}",
    mass: 47499.7067757,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180510,
    name: "Ar51~",
    latex: "^{51}\\mathrm{\\overline{Ar}}",
    mass: 47499.7067757,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180520,
    name: "Ar52",
    latex: "^{52}\\mathrm{Ar}",
    mass: 48436.3147821,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180520,
    name: "Ar52~",
    latex: "^{52}\\mathrm{\\overline{Ar}}",
    mass: 48436.3147821,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000180530,
    name: "Ar53",
    latex: "^{53}\\mathrm{Ar}",
    mass: 49375.9780891,
    width: undefined,
    charge: 18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000180530,
    name: "Ar53~",
    latex: "^{53}\\mathrm{\\overline{Ar}}",
    mass: 49375.9780891,
    width: undefined,
    charge: -18.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190320,
    name: "K32",
    latex: "^{32}\\mathrm{K}",
    mass: 29829.8038948,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190320,
    name: "K32~",
    latex: "^{32}\\mathrm{\\overline{K}}",
    mass: 29829.8038948,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190330,
    name: "K33",
    latex: "^{33}\\mathrm{K}",
    mass: 30746.850525,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190330,
    name: "K33~",
    latex: "^{33}\\mathrm{\\overline{K}}",
    mass: 30746.850525,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190340,
    name: "K34",
    latex: "^{34}\\mathrm{K}",
    mass: 31669.5792692,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190340,
    name: "K34~",
    latex: "^{34}\\mathrm{\\overline{K}}",
    mass: 31669.5792692,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190350,
    name: "K35",
    latex: "^{35}\\mathrm{K}",
    mass: 32591.120731,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190350,
    name: "K35~",
    latex: "^{35}\\mathrm{\\overline{K}}",
    mass: 32591.120731,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190360,
    name: "K36",
    latex: "^{36}\\mathrm{K}",
    mass: 33516.370564,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190360,
    name: "K36~",
    latex: "^{36}\\mathrm{\\overline{K}}",
    mass: 33516.370564,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190370,
    name: "K37",
    latex: "^{37}\\mathrm{K}",
    mass: 34440.4816361,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190370,
    name: "K37~",
    latex: "^{37}\\mathrm{\\overline{K}}",
    mass: 34440.4816361,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190380,
    name: "K38",
    latex: "^{38}\\mathrm{K}",
    mass: 35367.9751776,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190380,
    name: "K38~",
    latex: "^{38}\\mathrm{\\overline{K}}",
    mass: 35367.9751776,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190390,
    name: "K39",
    latex: "^{39}\\mathrm{K}",
    mass: 36294.4628498,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190390,
    name: "K39~",
    latex: "^{39}\\mathrm{\\overline{K}}",
    mass: 36294.4628498,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190400,
    name: "K40",
    latex: "^{40}\\mathrm{K}",
    mass: 37226.2286564,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190400,
    name: "K40~",
    latex: "^{40}\\mathrm{\\overline{K}}",
    mass: 37226.2286564,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190410,
    name: "K41",
    latex: "^{41}\\mathrm{K}",
    mass: 38155.6987035,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190410,
    name: "K41~",
    latex: "^{41}\\mathrm{\\overline{K}}",
    mass: 38155.6987035,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190420,
    name: "K42",
    latex: "^{42}\\mathrm{K}",
    mass: 39087.7303296,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190420,
    name: "K42~",
    latex: "^{42}\\mathrm{\\overline{K}}",
    mass: 39087.7303296,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190430,
    name: "K43",
    latex: "^{43}\\mathrm{K}",
    mass: 40017.6710645,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190430,
    name: "K43~",
    latex: "^{43}\\mathrm{\\overline{K}}",
    mass: 40017.6710645,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190440,
    name: "K44",
    latex: "^{44}\\mathrm{K}",
    mass: 40949.9590806,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190440,
    name: "K44~",
    latex: "^{44}\\mathrm{\\overline{K}}",
    mass: 40949.9590806,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190450,
    name: "K45",
    latex: "^{45}\\mathrm{K}",
    mass: 41880.6190314,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190450,
    name: "K45~",
    latex: "^{45}\\mathrm{\\overline{K}}",
    mass: 41880.6190314,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190460,
    name: "K46",
    latex: "^{46}\\mathrm{K}",
    mass: 42813.3148556,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190460,
    name: "K46~",
    latex: "^{46}\\mathrm{\\overline{K}}",
    mass: 42813.3148556,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190470,
    name: "K47",
    latex: "^{47}\\mathrm{K}",
    mass: 43744.5108812,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190470,
    name: "K47~",
    latex: "^{47}\\mathrm{\\overline{K}}",
    mass: 43744.5108812,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190480,
    name: "K48",
    latex: "^{48}\\mathrm{K}",
    mass: 44679.4325106,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190480,
    name: "K48~",
    latex: "^{48}\\mathrm{\\overline{K}}",
    mass: 44679.4325106,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190490,
    name: "K49",
    latex: "^{49}\\mathrm{K}",
    mass: 45613.5996298,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190490,
    name: "K49~",
    latex: "^{49}\\mathrm{\\overline{K}}",
    mass: 45613.5996298,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190500,
    name: "K50",
    latex: "^{50}\\mathrm{K}",
    mass: 46548.9773188,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190500,
    name: "K50~",
    latex: "^{50}\\mathrm{\\overline{K}}",
    mass: 46548.9773188,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190510,
    name: "K51",
    latex: "^{51}\\mathrm{K}",
    mass: 47483.6841457,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190510,
    name: "K51~",
    latex: "^{51}\\mathrm{\\overline{K}}",
    mass: 47483.6841457,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190520,
    name: "K52",
    latex: "^{52}\\mathrm{K}",
    mass: 48420.5539019,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190520,
    name: "K52~",
    latex: "^{52}\\mathrm{\\overline{K}}",
    mass: 48420.5539019,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190530,
    name: "K53",
    latex: "^{53}\\mathrm{K}",
    mass: 49356.8917749,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190530,
    name: "K53~",
    latex: "^{53}\\mathrm{\\overline{K}}",
    mass: 49356.8917749,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190540,
    name: "K54",
    latex: "^{54}\\mathrm{K}",
    mass: 50295.5304384,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190540,
    name: "K54~",
    latex: "^{54}\\mathrm{\\overline{K}}",
    mass: 50295.5304384,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000190550,
    name: "K55",
    latex: "^{55}\\mathrm{K}",
    mass: 51232.6507665,
    width: undefined,
    charge: 19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000190550,
    name: "K55~",
    latex: "^{55}\\mathrm{\\overline{K}}",
    mass: 51232.6507665,
    width: undefined,
    charge: -19.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200340,
    name: "Ca34",
    latex: "^{34}\\mathrm{Ca}",
    mass: 31685.6941171,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200340,
    name: "Ca34~",
    latex: "^{34}\\mathrm{\\overline{Ca}}",
    mass: 31685.6941171,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200350,
    name: "Ca35",
    latex: "^{35}\\mathrm{Ca}",
    mass: 32607.4820523,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200350,
    name: "Ca35~",
    latex: "^{35}\\mathrm{\\overline{Ca}}",
    mass: 32607.4820523,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200360,
    name: "Ca36",
    latex: "^{36}\\mathrm{Ca}",
    mass: 33527.3324797,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200360,
    name: "Ca36~",
    latex: "^{36}\\mathrm{\\overline{Ca}}",
    mass: 33527.3324797,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200370,
    name: "Ca37",
    latex: "^{37}\\mathrm{Ca}",
    mass: 34452.1457214,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200370,
    name: "Ca37~",
    latex: "^{37}\\mathrm{\\overline{Ca}}",
    mass: 34452.1457214,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200380,
    name: "Ca38",
    latex: "^{38}\\mathrm{Ca}",
    mass: 35374.7174344,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200380,
    name: "Ca38~",
    latex: "^{38}\\mathrm{\\overline{Ca}}",
    mass: 35374.7174344,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200390,
    name: "Ca39",
    latex: "^{39}\\mathrm{Ca}",
    mass: 36300.9873279,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200390,
    name: "Ca39~",
    latex: "^{39}\\mathrm{\\overline{Ca}}",
    mass: 36300.9873279,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200400,
    name: "Ca40",
    latex: "^{40}\\mathrm{Ca}",
    mass: 37224.917747,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200400,
    name: "Ca40~",
    latex: "^{40}\\mathrm{\\overline{Ca}}",
    mass: 37224.917747,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200410,
    name: "Ca41",
    latex: "^{41}\\mathrm{Ca}",
    mass: 38156.120348,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200410,
    name: "Ca41~",
    latex: "^{41}\\mathrm{\\overline{Ca}}",
    mass: 38156.120348,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200420,
    name: "Ca42",
    latex: "^{42}\\mathrm{Ca}",
    mass: 39084.2050623,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200420,
    name: "Ca42~",
    latex: "^{42}\\mathrm{\\overline{Ca}}",
    mass: 39084.2050623,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200430,
    name: "Ca43",
    latex: "^{43}\\mathrm{Ca}",
    mass: 40015.837586,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200430,
    name: "Ca43~",
    latex: "^{43}\\mathrm{\\overline{Ca}}",
    mass: 40015.837586,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200440,
    name: "Ca44",
    latex: "^{44}\\mathrm{Ca}",
    mass: 40944.2718434,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200440,
    name: "Ca44~",
    latex: "^{44}\\mathrm{\\overline{Ca}}",
    mass: 40944.2718434,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200450,
    name: "Ca45",
    latex: "^{45}\\mathrm{Ca}",
    mass: 41876.4224641,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200450,
    name: "Ca45~",
    latex: "^{45}\\mathrm{\\overline{Ca}}",
    mass: 41876.4224641,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200460,
    name: "Ca46",
    latex: "^{46}\\mathrm{Ca}",
    mass: 42805.5891367,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200460,
    name: "Ca46~",
    latex: "^{46}\\mathrm{\\overline{Ca}}",
    mass: 42805.5891367,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200470,
    name: "Ca47",
    latex: "^{47}\\mathrm{Ca}",
    mass: 43737.8781775,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200470,
    name: "Ca47~",
    latex: "^{47}\\mathrm{\\overline{Ca}}",
    mass: 43737.8781775,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200480,
    name: "Ca48",
    latex: "^{48}\\mathrm{Ca}",
    mass: 44667.4921106,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200480,
    name: "Ca48~",
    latex: "^{48}\\mathrm{\\overline{Ca}}",
    mass: 44667.4921106,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200490,
    name: "Ca49",
    latex: "^{49}\\mathrm{Ca}",
    mass: 45601.9110835,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200490,
    name: "Ca49~",
    latex: "^{49}\\mathrm{\\overline{Ca}}",
    mass: 45601.9110835,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200500,
    name: "Ca50",
    latex: "^{50}\\mathrm{Ca}",
    mass: 46535.1159413,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200500,
    name: "Ca50~",
    latex: "^{50}\\mathrm{\\overline{Ca}}",
    mass: 46535.1159413,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200510,
    name: "Ca51",
    latex: "^{51}\\mathrm{Ca}",
    mass: 47469.8670142,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200510,
    name: "Ca51~",
    latex: "^{51}\\mathrm{\\overline{Ca}}",
    mass: 47469.8670142,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200520,
    name: "Ca52",
    latex: "^{52}\\mathrm{Ca}",
    mass: 48403.4270787,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200520,
    name: "Ca52~",
    latex: "^{52}\\mathrm{\\overline{Ca}}",
    mass: 48403.4270787,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200530,
    name: "Ca53",
    latex: "^{53}\\mathrm{Ca}",
    mass: 49339.7988581,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200530,
    name: "Ca53~",
    latex: "^{53}\\mathrm{\\overline{Ca}}",
    mass: 49339.7988581,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200540,
    name: "Ca54",
    latex: "^{54}\\mathrm{Ca}",
    mass: 50275.5219451,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200540,
    name: "Ca54~",
    latex: "^{54}\\mathrm{\\overline{Ca}}",
    mass: 50275.5219451,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200550,
    name: "Ca55",
    latex: "^{55}\\mathrm{Ca}",
    mass: 51213.5271926,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200550,
    name: "Ca55~",
    latex: "^{55}\\mathrm{\\overline{Ca}}",
    mass: 51213.5271926,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200560,
    name: "Ca56",
    latex: "^{56}\\mathrm{Ca}",
    mass: 52150.1631437,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200560,
    name: "Ca56~",
    latex: "^{56}\\mathrm{\\overline{Ca}}",
    mass: 52150.1631437,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000200570,
    name: "Ca57",
    latex: "^{57}\\mathrm{Ca}",
    mass: 53088.6061935,
    width: undefined,
    charge: 20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000200570,
    name: "Ca57~",
    latex: "^{57}\\mathrm{\\overline{Ca}}",
    mass: 53088.6061935,
    width: undefined,
    charge: -20.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210360,
    name: "Sc36",
    latex: "^{36}\\mathrm{Sc}",
    mass: 33549.9398416,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210360,
    name: "Sc36~",
    latex: "^{36}\\mathrm{\\overline{Sc}}",
    mass: 33549.9398416,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210370,
    name: "Sc37",
    latex: "^{37}\\mathrm{Sc}",
    mass: 34469.0637036,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210370,
    name: "Sc37~",
    latex: "^{37}\\mathrm{\\overline{Sc}}",
    mass: 34469.0637036,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210380,
    name: "Sc38",
    latex: "^{38}\\mathrm{Sc}",
    mass: 35392.5283282,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210380,
    name: "Sc38~",
    latex: "^{38}\\mathrm{\\overline{Sc}}",
    mass: 35392.5283282,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210390,
    name: "Sc39",
    latex: "^{39}\\mathrm{Sc}",
    mass: 36314.0973622,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210390,
    name: "Sc39~",
    latex: "^{39}\\mathrm{\\overline{Sc}}",
    mass: 36314.0973622,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210400,
    name: "Sc40",
    latex: "^{40}\\mathrm{Sc}",
    mass: 37239.2405392,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210400,
    name: "Sc40~",
    latex: "^{40}\\mathrm{\\overline{Sc}}",
    mass: 37239.2405392,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210410,
    name: "Sc41",
    latex: "^{41}\\mathrm{Sc}",
    mass: 38162.6158893,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210410,
    name: "Sc41~",
    latex: "^{41}\\mathrm{\\overline{Sc}}",
    mass: 38162.6158893,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210420,
    name: "Sc42",
    latex: "^{42}\\mathrm{Sc}",
    mass: 39090.6313562,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210420,
    name: "Sc42~",
    latex: "^{42}\\mathrm{\\overline{Sc}}",
    mass: 39090.6313562,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210430,
    name: "Sc43",
    latex: "^{43}\\mathrm{Sc}",
    mass: 40018.0582866,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210430,
    name: "Sc43~",
    latex: "^{43}\\mathrm{\\overline{Sc}}",
    mass: 40018.0582866,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210440,
    name: "Sc44",
    latex: "^{44}\\mathrm{Sc}",
    mass: 40947.9245112,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210440,
    name: "Sc44~",
    latex: "^{44}\\mathrm{\\overline{Sc}}",
    mass: 40947.9245112,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210450,
    name: "Sc45",
    latex: "^{45}\\mathrm{Sc}",
    mass: 41876.162391,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210450,
    name: "Sc45~",
    latex: "^{45}\\mathrm{\\overline{Sc}}",
    mass: 41876.162391,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210460,
    name: "Sc46",
    latex: "^{46}\\mathrm{Sc}",
    mass: 42806.9670959,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210460,
    name: "Sc46~",
    latex: "^{46}\\mathrm{\\overline{Sc}}",
    mass: 42806.9670959,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210470,
    name: "Sc47",
    latex: "^{47}\\mathrm{Sc}",
    mass: 43735.885991,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210470,
    name: "Sc47~",
    latex: "^{47}\\mathrm{\\overline{Sc}}",
    mass: 43735.885991,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210480,
    name: "Sc48",
    latex: "^{48}\\mathrm{Sc}",
    mass: 44667.2129847,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210480,
    name: "Sc48~",
    latex: "^{48}\\mathrm{\\overline{Sc}}",
    mass: 44667.2129847,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210490,
    name: "Sc49",
    latex: "^{49}\\mathrm{Sc}",
    mass: 45596.6486727,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210490,
    name: "Sc49~",
    latex: "^{49}\\mathrm{\\overline{Sc}}",
    mass: 45596.6486727,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210500,
    name: "Sc50",
    latex: "^{50}\\mathrm{Sc}",
    mass: 46530.1680309,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210500,
    name: "Sc50~",
    latex: "^{50}\\mathrm{\\overline{Sc}}",
    mass: 46530.1680309,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210510,
    name: "Sc51",
    latex: "^{51}\\mathrm{Sc}",
    mass: 47462.9489006,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210510,
    name: "Sc51~",
    latex: "^{51}\\mathrm{\\overline{Sc}}",
    mass: 47462.9489006,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210520,
    name: "Sc52",
    latex: "^{52}\\mathrm{Sc}",
    mass: 48397.1696739,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210520,
    name: "Sc52~",
    latex: "^{52}\\mathrm{\\overline{Sc}}",
    mass: 48397.1696739,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210530,
    name: "Sc53",
    latex: "^{53}\\mathrm{Sc}",
    mass: 49330.417781,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210530,
    name: "Sc53~",
    latex: "^{53}\\mathrm{\\overline{Sc}}",
    mass: 49330.417781,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210540,
    name: "Sc54",
    latex: "^{54}\\mathrm{Sc}",
    mass: 50266.2433323,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210540,
    name: "Sc54~",
    latex: "^{54}\\mathrm{\\overline{Sc}}",
    mass: 50266.2433323,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210550,
    name: "Sc55",
    latex: "^{55}\\mathrm{Sc}",
    mass: 51201.3339347,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210550,
    name: "Sc55~",
    latex: "^{55}\\mathrm{\\overline{Sc}}",
    mass: 51201.3339347,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210560,
    name: "Sc56",
    latex: "^{56}\\mathrm{Sc}",
    mass: 52138.1561847,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210560,
    name: "Sc56~",
    latex: "^{56}\\mathrm{\\overline{Sc}}",
    mass: 52138.1561847,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210570,
    name: "Sc57",
    latex: "^{57}\\mathrm{Sc}",
    mass: 53073.7861223,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210570,
    name: "Sc57~",
    latex: "^{57}\\mathrm{\\overline{Sc}}",
    mass: 53073.7861223,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210580,
    name: "Sc58",
    latex: "^{58}\\mathrm{Sc}",
    mass: 54011.1765837,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210580,
    name: "Sc58~",
    latex: "^{58}\\mathrm{\\overline{Sc}}",
    mass: 54011.1765837,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000210590,
    name: "Sc59",
    latex: "^{59}\\mathrm{Sc}",
    mass: 54947.318843,
    width: undefined,
    charge: 21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000210590,
    name: "Sc59~",
    latex: "^{59}\\mathrm{\\overline{Sc}}",
    mass: 54947.318843,
    width: undefined,
    charge: -21.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220380,
    name: "Ti38",
    latex: "^{38}\\mathrm{Ti}",
    mass: 35408.1494843,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220380,
    name: "Ti38~",
    latex: "^{38}\\mathrm{\\overline{Ti}}",
    mass: 35408.1494843,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220390,
    name: "Ti39",
    latex: "^{39}\\mathrm{Ti}",
    mass: 36330.7664492,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220390,
    name: "Ti39~",
    latex: "^{39}\\mathrm{\\overline{Ti}}",
    mass: 36330.7664492,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220400,
    name: "Ti40",
    latex: "^{40}\\mathrm{Ti}",
    mass: 37250.7752306,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220400,
    name: "Ti40~",
    latex: "^{40}\\mathrm{\\overline{Ti}}",
    mass: 37250.7752306,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220410,
    name: "Ti41",
    latex: "^{41}\\mathrm{Ti}",
    mass: 38175.5625768,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220410,
    name: "Ti41~",
    latex: "^{41}\\mathrm{\\overline{Ti}}",
    mass: 38175.5625768,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220420,
    name: "Ti42",
    latex: "^{42}\\mathrm{Ti}",
    mass: 39097.6480032,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220420,
    name: "Ti42~",
    latex: "^{42}\\mathrm{\\overline{Ti}}",
    mass: 39097.6480032,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220430,
    name: "Ti43",
    latex: "^{43}\\mathrm{Ti}",
    mass: 40024.9304775,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220430,
    name: "Ti43~",
    latex: "^{43}\\mathrm{\\overline{Ti}}",
    mass: 40024.9304775,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220440,
    name: "Ti44",
    latex: "^{44}\\mathrm{Ti}",
    mass: 40948.1919431,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220440,
    name: "Ti44~",
    latex: "^{44}\\mathrm{\\overline{Ti}}",
    mass: 40948.1919431,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220450,
    name: "Ti45",
    latex: "^{45}\\mathrm{Ti}",
    mass: 41878.2244395,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220450,
    name: "Ti45~",
    latex: "^{45}\\mathrm{\\overline{Ti}}",
    mass: 41878.2244395,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220460,
    name: "Ti46",
    latex: "^{46}\\mathrm{Ti}",
    mass: 42804.6005047,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220460,
    name: "Ti46~",
    latex: "^{46}\\mathrm{\\overline{Ti}}",
    mass: 42804.6005047,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220470,
    name: "Ti47",
    latex: "^{47}\\mathrm{Ti}",
    mass: 43735.2852612,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220470,
    name: "Ti47~",
    latex: "^{47}\\mathrm{\\overline{Ti}}",
    mass: 43735.2852612,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220480,
    name: "Ti48",
    latex: "^{48}\\mathrm{Ti}",
    mass: 44663.2240289,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220480,
    name: "Ti48~",
    latex: "^{48}\\mathrm{\\overline{Ti}}",
    mass: 44663.2240289,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220490,
    name: "Ti49",
    latex: "^{49}\\mathrm{Ti}",
    mass: 45594.6470689,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220490,
    name: "Ti49~",
    latex: "^{49}\\mathrm{\\overline{Ti}}",
    mass: 45594.6470689,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220500,
    name: "Ti50",
    latex: "^{50}\\mathrm{Ti}",
    mass: 46523.2733165,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220500,
    name: "Ti50~",
    latex: "^{50}\\mathrm{\\overline{Ti}}",
    mass: 46523.2733165,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220510,
    name: "Ti51",
    latex: "^{51}\\mathrm{Ti}",
    mass: 47456.4663537,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220510,
    name: "Ti51~",
    latex: "^{51}\\mathrm{\\overline{Ti}}",
    mass: 47456.4663537,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220520,
    name: "Ti52",
    latex: "^{52}\\mathrm{Ti}",
    mass: 48388.2156868,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220520,
    name: "Ti52~",
    latex: "^{52}\\mathrm{\\overline{Ti}}",
    mass: 48388.2156868,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220530,
    name: "Ti53",
    latex: "^{53}\\mathrm{Ti}",
    mass: 49322.3063303,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220530,
    name: "Ti53~",
    latex: "^{53}\\mathrm{\\overline{Ti}}",
    mass: 49322.3063303,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220540,
    name: "Ti54",
    latex: "^{54}\\mathrm{Ti}",
    mass: 50254.9377884,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220540,
    name: "Ti54~",
    latex: "^{54}\\mathrm{\\overline{Ti}}",
    mass: 50254.9377884,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220550,
    name: "Ti55",
    latex: "^{55}\\mathrm{Ti}",
    mass: 51190.3423043,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220550,
    name: "Ti55~",
    latex: "^{55}\\mathrm{\\overline{Ti}}",
    mass: 51190.3423043,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220560,
    name: "Ti56",
    latex: "^{56}\\mathrm{Ti}",
    mass: 52124.2489778,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220560,
    name: "Ti56~",
    latex: "^{56}\\mathrm{\\overline{Ti}}",
    mass: 52124.2489778,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220570,
    name: "Ti57",
    latex: "^{57}\\mathrm{Ti}",
    mass: 53060.7638347,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220570,
    name: "Ti57~",
    latex: "^{57}\\mathrm{\\overline{Ti}}",
    mass: 53060.7638347,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220580,
    name: "Ti58",
    latex: "^{58}\\mathrm{Ti}",
    mass: 53995.7417264,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220580,
    name: "Ti58~",
    latex: "^{58}\\mathrm{\\overline{Ti}}",
    mass: 53995.7417264,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220590,
    name: "Ti59",
    latex: "^{59}\\mathrm{Ti}",
    mass: 54932.2752132,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220590,
    name: "Ti59~",
    latex: "^{59}\\mathrm{\\overline{Ti}}",
    mass: 54932.2752132,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220600,
    name: "Ti60",
    latex: "^{60}\\mathrm{Ti}",
    mass: 55867.551183,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220600,
    name: "Ti60~",
    latex: "^{60}\\mathrm{\\overline{Ti}}",
    mass: 55867.551183,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000220610,
    name: "Ti61",
    latex: "^{61}\\mathrm{Ti}",
    mass: 56804.7739754,
    width: undefined,
    charge: 22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000220610,
    name: "Ti61~",
    latex: "^{61}\\mathrm{\\overline{Ti}}",
    mass: 56804.7739754,
    width: undefined,
    charge: -22.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230400,
    name: "V40",
    latex: "^{40}\\mathrm{V}",
    mass: 37272.2368548,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230400,
    name: "V40~",
    latex: "^{40}\\mathrm{\\overline{V}}",
    mass: 37272.2368548,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230410,
    name: "V41",
    latex: "^{41}\\mathrm{V}",
    mass: 38191.5656455,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230410,
    name: "V41~",
    latex: "^{41}\\mathrm{\\overline{V}}",
    mass: 38191.5656455,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230420,
    name: "V42",
    latex: "^{42}\\mathrm{V}",
    mass: 39115.1327344,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230420,
    name: "V42~",
    latex: "^{42}\\mathrm{\\overline{V}}",
    mass: 39115.1327344,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230430,
    name: "V43",
    latex: "^{43}\\mathrm{V}",
    mass: 40036.3338283,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230430,
    name: "V43~",
    latex: "^{43}\\mathrm{\\overline{V}}",
    mass: 40036.3338283,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230440,
    name: "V44",
    latex: "^{44}\\mathrm{V}",
    mass: 40961.9325058,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230440,
    name: "V44~",
    latex: "^{44}\\mathrm{\\overline{V}}",
    mass: 40961.9325058,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230450,
    name: "V45",
    latex: "^{45}\\mathrm{V}",
    mass: 41885.3482269,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230450,
    name: "V45~",
    latex: "^{45}\\mathrm{\\overline{V}}",
    mass: 41885.3482269,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230460,
    name: "V46",
    latex: "^{46}\\mathrm{V}",
    mass: 42811.6528745,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230460,
    name: "V46~",
    latex: "^{46}\\mathrm{\\overline{V}}",
    mass: 42811.6528745,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230470,
    name: "V47",
    latex: "^{47}\\mathrm{V}",
    mass: 43738.2158068,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230470,
    name: "V47~",
    latex: "^{47}\\mathrm{\\overline{V}}",
    mass: 43738.2158068,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230480,
    name: "V48",
    latex: "^{48}\\mathrm{V}",
    mass: 44667.2389734,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230480,
    name: "V48~",
    latex: "^{48}\\mathrm{\\overline{V}}",
    mass: 44667.2389734,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230490,
    name: "V49",
    latex: "^{49}\\mathrm{V}",
    mass: 45595.2489166,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230490,
    name: "V49~",
    latex: "^{49}\\mathrm{\\overline{V}}",
    mass: 45595.2489166,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230500,
    name: "V50",
    latex: "^{50}\\mathrm{V}",
    mass: 46525.4819449,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230500,
    name: "V50~",
    latex: "^{50}\\mathrm{\\overline{V}}",
    mass: 46525.4819449,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230510,
    name: "V51",
    latex: "^{51}\\mathrm{V}",
    mass: 47453.9961804,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230510,
    name: "V51~",
    latex: "^{51}\\mathrm{\\overline{V}}",
    mass: 47453.9961804,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230520,
    name: "V52",
    latex: "^{52}\\mathrm{V}",
    mass: 48386.2503647,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230520,
    name: "V52~",
    latex: "^{52}\\mathrm{\\overline{V}}",
    mass: 48386.2503647,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230530,
    name: "V53",
    latex: "^{53}\\mathrm{V}",
    mass: 49317.3358778,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230530,
    name: "V53~",
    latex: "^{53}\\mathrm{\\overline{V}}",
    mass: 49317.3358778,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230540,
    name: "V54",
    latex: "^{54}\\mathrm{V}",
    mass: 50250.7833247,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230540,
    name: "V54~",
    latex: "^{54}\\mathrm{\\overline{V}}",
    mass: 50250.7833247,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230550,
    name: "V55",
    latex: "^{55}\\mathrm{V}",
    mass: 51183.0505685,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230550,
    name: "V55~",
    latex: "^{55}\\mathrm{\\overline{V}}",
    mass: 51183.0505685,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230560,
    name: "V56",
    latex: "^{56}\\mathrm{V}",
    mass: 52117.4863306,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230560,
    name: "V56~",
    latex: "^{56}\\mathrm{\\overline{V}}",
    mass: 52117.4863306,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230570,
    name: "V57",
    latex: "^{57}\\mathrm{V}",
    mass: 53050.7316432,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230570,
    name: "V57~",
    latex: "^{57}\\mathrm{\\overline{V}}",
    mass: 53050.7316432,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230580,
    name: "V58",
    latex: "^{58}\\mathrm{V}",
    mass: 53986.2311716,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230580,
    name: "V58~",
    latex: "^{58}\\mathrm{\\overline{V}}",
    mass: 53986.2311716,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230590,
    name: "V59",
    latex: "^{59}\\mathrm{V}",
    mass: 54920.5383875,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230590,
    name: "V59~",
    latex: "^{59}\\mathrm{\\overline{V}}",
    mass: 54920.5383875,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230600,
    name: "V60",
    latex: "^{60}\\mathrm{V}",
    mass: 55856.5595526,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230600,
    name: "V60~",
    latex: "^{60}\\mathrm{\\overline{V}}",
    mass: 55856.5595526,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230610,
    name: "V61",
    latex: "^{61}\\mathrm{V}",
    mass: 56790.9599179,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230610,
    name: "V61~",
    latex: "^{61}\\mathrm{\\overline{V}}",
    mass: 56790.9599179,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230620,
    name: "V62",
    latex: "^{62}\\mathrm{V}",
    mass: 57727.4188852,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230620,
    name: "V62~",
    latex: "^{62}\\mathrm{\\overline{V}}",
    mass: 57727.4188852,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000230630,
    name: "V63",
    latex: "^{63}\\mathrm{V}",
    mass: 58662.3874619,
    width: undefined,
    charge: 23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000230630,
    name: "V63~",
    latex: "^{63}\\mathrm{\\overline{V}}",
    mass: 58662.3874619,
    width: undefined,
    charge: -23.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240420,
    name: "Cr42",
    latex: "^{42}\\mathrm{Cr}",
    mass: 39129.8130815,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240420,
    name: "Cr42~",
    latex: "^{42}\\mathrm{\\overline{Cr}}",
    mass: 39129.8130815,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240430,
    name: "Cr43",
    latex: "^{43}\\mathrm{Cr}",
    mass: 40052.2810073,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240430,
    name: "Cr43~",
    latex: "^{43}\\mathrm{\\overline{Cr}}",
    mass: 40052.2810073,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240440,
    name: "Cr44",
    latex: "^{44}\\mathrm{Cr}",
    mass: 40972.3177336,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240440,
    name: "Cr44~",
    latex: "^{44}\\mathrm{\\overline{Cr}}",
    mass: 40972.3177336,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240450,
    name: "Cr45",
    latex: "^{45}\\mathrm{Cr}",
    mass: 41897.7198659,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240450,
    name: "Cr45~",
    latex: "^{45}\\mathrm{\\overline{Cr}}",
    mass: 41897.7198659,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240460,
    name: "Cr46",
    latex: "^{46}\\mathrm{Cr}",
    mass: 42819.2572291,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240460,
    name: "Cr46~",
    latex: "^{46}\\mathrm{\\overline{Cr}}",
    mass: 42819.2572291,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240470,
    name: "Cr47",
    latex: "^{47}\\mathrm{Cr}",
    mass: 43745.6597861,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240470,
    name: "Cr47~",
    latex: "^{47}\\mathrm{\\overline{Cr}}",
    mass: 43745.6597861,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240480,
    name: "Cr48",
    latex: "^{48}\\mathrm{Cr}",
    mass: 44668.895263,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240480,
    name: "Cr48~",
    latex: "^{48}\\mathrm{\\overline{Cr}}",
    mass: 44668.895263,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240490,
    name: "Cr49",
    latex: "^{49}\\mathrm{Cr}",
    mass: 45597.8787107,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240490,
    name: "Cr49~",
    latex: "^{49}\\mathrm{\\overline{Cr}}",
    mass: 45597.8787107,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240500,
    name: "Cr50",
    latex: "^{50}\\mathrm{Cr}",
    mass: 46524.4438227,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240500,
    name: "Cr50~",
    latex: "^{50}\\mathrm{\\overline{Cr}}",
    mass: 46524.4438227,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240510,
    name: "Cr51",
    latex: "^{51}\\mathrm{Cr}",
    mass: 47454.7485761,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240510,
    name: "Cr51~",
    latex: "^{51}\\mathrm{\\overline{Cr}}",
    mass: 47454.7485761,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240520,
    name: "Cr52",
    latex: "^{52}\\mathrm{Cr}",
    mass: 48382.2738815,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240520,
    name: "Cr52~",
    latex: "^{52}\\mathrm{\\overline{Cr}}",
    mass: 48382.2738815,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240530,
    name: "Cr53",
    latex: "^{53}\\mathrm{Cr}",
    mass: 49313.8998755,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240530,
    name: "Cr53~",
    latex: "^{53}\\mathrm{\\overline{Cr}}",
    mass: 49313.8998755,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240540,
    name: "Cr54",
    latex: "^{54}\\mathrm{Cr}",
    mass: 50243.746222,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240540,
    name: "Cr54~",
    latex: "^{54}\\mathrm{\\overline{Cr}}",
    mass: 50243.746222,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240550,
    name: "Cr55",
    latex: "^{55}\\mathrm{Cr}",
    mass: 51177.0653835,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240550,
    name: "Cr55~",
    latex: "^{55}\\mathrm{\\overline{Cr}}",
    mass: 51177.0653835,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240560,
    name: "Cr56",
    latex: "^{56}\\mathrm{Cr}",
    mass: 52108.3847017,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240560,
    name: "Cr56~",
    latex: "^{56}\\mathrm{\\overline{Cr}}",
    mass: 52108.3847017,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240570,
    name: "Cr57",
    latex: "^{57}\\mathrm{Cr}",
    mass: 53042.6389156,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240570,
    name: "Cr57~",
    latex: "^{57}\\mathrm{\\overline{Cr}}",
    mass: 53042.6389156,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240580,
    name: "Cr58",
    latex: "^{58}\\mathrm{Cr}",
    mass: 53974.6666723,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240580,
    name: "Cr58~",
    latex: "^{58}\\mathrm{\\overline{Cr}}",
    mass: 53974.6666723,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240590,
    name: "Cr59",
    latex: "^{59}\\mathrm{Cr}",
    mass: 54910.0361641,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240590,
    name: "Cr59~",
    latex: "^{59}\\mathrm{\\overline{Cr}}",
    mass: 54910.0361641,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240600,
    name: "Cr60",
    latex: "^{60}\\mathrm{Cr}",
    mass: 55842.7377636,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240600,
    name: "Cr60~",
    latex: "^{60}\\mathrm{\\overline{Cr}}",
    mass: 55842.7377636,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240610,
    name: "Cr61",
    latex: "^{61}\\mathrm{Cr}",
    mass: 56778.643796,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240610,
    name: "Cr61~",
    latex: "^{61}\\mathrm{\\overline{Cr}}",
    mass: 56778.643796,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240620,
    name: "Cr62",
    latex: "^{62}\\mathrm{Cr}",
    mass: 57711.7818936,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240620,
    name: "Cr62~",
    latex: "^{62}\\mathrm{\\overline{Cr}}",
    mass: 57711.7818936,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240630,
    name: "Cr63",
    latex: "^{63}\\mathrm{Cr}",
    mass: 58647.9493033,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240630,
    name: "Cr63~",
    latex: "^{63}\\mathrm{\\overline{Cr}}",
    mass: 58647.9493033,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240640,
    name: "Cr64",
    latex: "^{64}\\mathrm{Cr}",
    mass: 59581.9863859,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240640,
    name: "Cr64~",
    latex: "^{64}\\mathrm{\\overline{Cr}}",
    mass: 59581.9863859,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000240650,
    name: "Cr65",
    latex: "^{65}\\mathrm{Cr}",
    mass: 60518.8086359,
    width: undefined,
    charge: 24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000240650,
    name: "Cr65~",
    latex: "^{65}\\mathrm{\\overline{Cr}}",
    mass: 60518.8086359,
    width: undefined,
    charge: -24.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250440,
    name: "Mn44",
    latex: "^{44}\\mathrm{Mn}",
    mass: 40993.2018314,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250440,
    name: "Mn44~",
    latex: "^{44}\\mathrm{\\overline{Mn}}",
    mass: 40993.2018314,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250450,
    name: "Mn45",
    latex: "^{45}\\mathrm{Mn}",
    mass: 41912.2511739,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250450,
    name: "Mn45~",
    latex: "^{45}\\mathrm{\\overline{Mn}}",
    mass: 41912.2511739,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250460,
    name: "Mn46",
    latex: "^{46}\\mathrm{Mn}",
    mass: 42836.3119547,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250460,
    name: "Mn46~",
    latex: "^{46}\\mathrm{\\overline{Mn}}",
    mass: 42836.3119547,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250470,
    name: "Mn47",
    latex: "^{47}\\mathrm{Mn}",
    mass: 43757.6527726,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250470,
    name: "Mn47~",
    latex: "^{47}\\mathrm{\\overline{Mn}}",
    mass: 43757.6527726,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250480,
    name: "Mn48",
    latex: "^{48}\\mathrm{Mn}",
    mass: 44682.4205574,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250480,
    name: "Mn48~",
    latex: "^{48}\\mathrm{\\overline{Mn}}",
    mass: 44682.4205574,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250490,
    name: "Mn49",
    latex: "^{49}\\mathrm{Mn}",
    mass: 45605.5912024,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250490,
    name: "Mn49~",
    latex: "^{49}\\mathrm{\\overline{Mn}}",
    mass: 45605.5912024,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250500,
    name: "Mn50",
    latex: "^{50}\\mathrm{Mn}",
    mass: 46532.0783018,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250500,
    name: "Mn50~",
    latex: "^{50}\\mathrm{\\overline{Mn}}",
    mass: 46532.0783018,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250510,
    name: "Mn51",
    latex: "^{51}\\mathrm{Mn}",
    mass: 47457.9560922,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250510,
    name: "Mn51~",
    latex: "^{51}\\mathrm{\\overline{Mn}}",
    mass: 47457.9560922,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250520,
    name: "Mn52",
    latex: "^{52}\\mathrm{Mn}",
    mass: 48386.9820067,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250520,
    name: "Mn52~",
    latex: "^{52}\\mathrm{\\overline{Mn}}",
    mass: 48386.9820067,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250530,
    name: "Mn53",
    latex: "^{53}\\mathrm{Mn}",
    mass: 49314.4971495,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250530,
    name: "Mn53~",
    latex: "^{53}\\mathrm{\\overline{Mn}}",
    mass: 49314.4971495,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250540,
    name: "Mn54",
    latex: "^{54}\\mathrm{Mn}",
    mass: 50245.1233802,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250540,
    name: "Mn54~",
    latex: "^{54}\\mathrm{\\overline{Mn}}",
    mass: 50245.1233802,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250550,
    name: "Mn55",
    latex: "^{55}\\mathrm{Mn}",
    mass: 51174.4631616,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250550,
    name: "Mn55~",
    latex: "^{55}\\mathrm{\\overline{Mn}}",
    mass: 51174.4631616,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250560,
    name: "Mn56",
    latex: "^{56}\\mathrm{Mn}",
    mass: 52106.7581267,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250560,
    name: "Mn56~",
    latex: "^{56}\\mathrm{\\overline{Mn}}",
    mass: 52106.7581267,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250570,
    name: "Mn57",
    latex: "^{57}\\mathrm{Mn}",
    mass: 53037.6775917,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250570,
    name: "Mn57~",
    latex: "^{57}\\mathrm{\\overline{Mn}}",
    mass: 53037.6775917,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250580,
    name: "Mn58",
    latex: "^{58}\\mathrm{Mn}",
    mass: 53970.830407,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250580,
    name: "Mn58~",
    latex: "^{58}\\mathrm{\\overline{Mn}}",
    mass: 53970.830407,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250590,
    name: "Mn59",
    latex: "^{59}\\mathrm{Mn}",
    mass: 54902.6267805,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250590,
    name: "Mn59~",
    latex: "^{59}\\mathrm{\\overline{Mn}}",
    mass: 54902.6267805,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250600,
    name: "Mn60",
    latex: "^{60}\\mathrm{Mn}",
    mass: 55836.6783013,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250600,
    name: "Mn60~",
    latex: "^{60}\\mathrm{\\overline{Mn}}",
    mass: 55836.6783013,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250610,
    name: "Mn61",
    latex: "^{61}\\mathrm{Mn}",
    mass: 56769.3981581,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250610,
    name: "Mn61~",
    latex: "^{61}\\mathrm{\\overline{Mn}}",
    mass: 56769.3981581,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250620,
    name: "Mn62",
    latex: "^{62}\\mathrm{Mn}",
    mass: 57704.1101082,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250620,
    name: "Mn62~",
    latex: "^{62}\\mathrm{\\overline{Mn}}",
    mass: 57704.1101082,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250630,
    name: "Mn63",
    latex: "^{63}\\mathrm{Mn}",
    mass: 58637.2417786,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250630,
    name: "Mn63~",
    latex: "^{63}\\mathrm{\\overline{Mn}}",
    mass: 58637.2417786,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250640,
    name: "Mn64",
    latex: "^{64}\\mathrm{Mn}",
    mass: 59572.6332536,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250640,
    name: "Mn64~",
    latex: "^{64}\\mathrm{\\overline{Mn}}",
    mass: 59572.6332536,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250650,
    name: "Mn65",
    latex: "^{65}\\mathrm{Mn}",
    mass: 60506.149631,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250650,
    name: "Mn65~",
    latex: "^{65}\\mathrm{\\overline{Mn}}",
    mass: 60506.149631,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250660,
    name: "Mn66",
    latex: "^{66}\\mathrm{Mn}",
    mass: 61441.8606086,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250660,
    name: "Mn66~",
    latex: "^{66}\\mathrm{\\overline{Mn}}",
    mass: 61441.8606086,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000250670,
    name: "Mn67",
    latex: "^{67}\\mathrm{Mn}",
    mass: 62376.5245867,
    width: undefined,
    charge: 25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000250670,
    name: "Mn67~",
    latex: "^{67}\\mathrm{\\overline{Mn}}",
    mass: 62376.5245867,
    width: undefined,
    charge: -25.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260450,
    name: "Fe45",
    latex: "^{45}\\mathrm{Fe}",
    mass: 41931.6448811,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260450,
    name: "Fe45~",
    latex: "^{45}\\mathrm{\\overline{Fe}}",
    mass: 41931.6448811,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260460,
    name: "Fe46",
    latex: "^{46}\\mathrm{Fe}",
    mass: 42849.9397134,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260460,
    name: "Fe46~",
    latex: "^{46}\\mathrm{\\overline{Fe}}",
    mass: 42849.9397134,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260470,
    name: "Fe47",
    latex: "^{47}\\mathrm{Fe}",
    mass: 43773.0969449,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260470,
    name: "Fe47~",
    latex: "^{47}\\mathrm{\\overline{Fe}}",
    mass: 43773.0969449,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260480,
    name: "Fe48",
    latex: "^{48}\\mathrm{Fe}",
    mass: 44693.7111975,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260480,
    name: "Fe48~",
    latex: "^{48}\\mathrm{\\overline{Fe}}",
    mass: 44693.7111975,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260490,
    name: "Fe49",
    latex: "^{49}\\mathrm{Fe}",
    mass: 45618.4603524,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260490,
    name: "Fe49~",
    latex: "^{49}\\mathrm{\\overline{Fe}}",
    mass: 45618.4603524,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260500,
    name: "Fe50",
    latex: "^{50}\\mathrm{Fe}",
    mass: 46540.2287262,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260500,
    name: "Fe50~",
    latex: "^{50}\\mathrm{\\overline{Fe}}",
    mass: 46540.2287262,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260510,
    name: "Fe51",
    latex: "^{51}\\mathrm{Fe}",
    mass: 47466.0100697,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260510,
    name: "Fe51~",
    latex: "^{51}\\mathrm{\\overline{Fe}}",
    mass: 47466.0100697,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260520,
    name: "Fe52",
    latex: "^{52}\\mathrm{Fe}",
    mass: 48389.3612941,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260520,
    name: "Fe52~",
    latex: "^{52}\\mathrm{\\overline{Fe}}",
    mass: 48389.3612941,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260530,
    name: "Fe53",
    latex: "^{53}\\mathrm{Fe}",
    mass: 49318.239986,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260530,
    name: "Fe53~",
    latex: "^{53}\\mathrm{\\overline{Fe}}",
    mass: 49318.239986,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260540,
    name: "Fe54",
    latex: "^{54}\\mathrm{Fe}",
    mass: 50244.4269952,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260540,
    name: "Fe54~",
    latex: "^{54}\\mathrm{\\overline{Fe}}",
    mass: 50244.4269952,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260550,
    name: "Fe55",
    latex: "^{55}\\mathrm{Fe}",
    mass: 51174.6943212,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260550,
    name: "Fe55~",
    latex: "^{55}\\mathrm{\\overline{Fe}}",
    mass: 51174.6943212,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260560,
    name: "Fe56",
    latex: "^{56}\\mathrm{Fe}",
    mass: 52103.0626474,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260560,
    name: "Fe56~",
    latex: "^{56}\\mathrm{\\overline{Fe}}",
    mass: 52103.0626474,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260570,
    name: "Fe57",
    latex: "^{57}\\mathrm{Fe}",
    mass: 53034.9818943,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260570,
    name: "Fe57~",
    latex: "^{57}\\mathrm{\\overline{Fe}}",
    mass: 53034.9818943,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260580,
    name: "Fe58",
    latex: "^{58}\\mathrm{Fe}",
    mass: 53964.5027675,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260580,
    name: "Fe58~",
    latex: "^{58}\\mathrm{\\overline{Fe}}",
    mass: 53964.5027675,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260590,
    name: "Fe59",
    latex: "^{59}\\mathrm{Fe}",
    mass: 54897.4871686,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260590,
    name: "Fe59~",
    latex: "^{59}\\mathrm{\\overline{Fe}}",
    mass: 54897.4871686,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260600,
    name: "Fe60",
    latex: "^{60}\\mathrm{Fe}",
    mass: 55828.2328169,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260600,
    name: "Fe60~",
    latex: "^{60}\\mathrm{\\overline{Fe}}",
    mass: 55828.2328169,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260610,
    name: "Fe61",
    latex: "^{61}\\mathrm{Fe}",
    mass: 56762.2197851,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260610,
    name: "Fe61~",
    latex: "^{61}\\mathrm{\\overline{Fe}}",
    mass: 56762.2197851,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260620,
    name: "Fe62",
    latex: "^{62}\\mathrm{Fe}",
    mass: 57693.7565512,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260620,
    name: "Fe62~",
    latex: "^{62}\\mathrm{\\overline{Fe}}",
    mass: 57693.7565512,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260630,
    name: "Fe63",
    latex: "^{63}\\mathrm{Fe}",
    mass: 58628.4931859,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260630,
    name: "Fe63~",
    latex: "^{63}\\mathrm{\\overline{Fe}}",
    mass: 58628.4931859,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260640,
    name: "Fe64",
    latex: "^{64}\\mathrm{Fe}",
    mass: 59560.6533079,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260640,
    name: "Fe64~",
    latex: "^{64}\\mathrm{\\overline{Fe}}",
    mass: 59560.6533079,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260650,
    name: "Fe65",
    latex: "^{65}\\mathrm{Fe}",
    mass: 60495.8985384,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260650,
    name: "Fe65~",
    latex: "^{65}\\mathrm{\\overline{Fe}}",
    mass: 60495.8985384,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260660,
    name: "Fe66",
    latex: "^{66}\\mathrm{Fe}",
    mass: 61428.5430374,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260660,
    name: "Fe66~",
    latex: "^{66}\\mathrm{\\overline{Fe}}",
    mass: 61428.5430374,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260670,
    name: "Fe67",
    latex: "^{67}\\mathrm{Fe}",
    mass: 62364.3965335,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260670,
    name: "Fe67~",
    latex: "^{67}\\mathrm{\\overline{Fe}}",
    mass: 62364.3965335,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260680,
    name: "Fe68",
    latex: "^{68}\\mathrm{Fe}",
    mass: 63297.7070507,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260680,
    name: "Fe68~",
    latex: "^{68}\\mathrm{\\overline{Fe}}",
    mass: 63297.7070507,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000260690,
    name: "Fe69",
    latex: "^{69}\\mathrm{Fe}",
    mass: 64233.8958847,
    width: undefined,
    charge: 26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000260690,
    name: "Fe69~",
    latex: "^{69}\\mathrm{\\overline{Fe}}",
    mass: 64233.8958847,
    width: undefined,
    charge: -26.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270480,
    name: "Co48",
    latex: "^{48}\\mathrm{Co}",
    mass: 44713.4495575,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270480,
    name: "Co48~",
    latex: "^{48}\\mathrm{\\overline{Co}}",
    mass: 44713.4495575,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270490,
    name: "Co49",
    latex: "^{49}\\mathrm{Co}",
    mass: 45633.4303941,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270490,
    name: "Co49~",
    latex: "^{49}\\mathrm{\\overline{Co}}",
    mass: 45633.4303941,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270500,
    name: "Co50",
    latex: "^{50}\\mathrm{Co}",
    mass: 46557.1185773,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270500,
    name: "Co50~",
    latex: "^{50}\\mathrm{\\overline{Co}}",
    mass: 46557.1185773,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270510,
    name: "Co51",
    latex: "^{51}\\mathrm{Co}",
    mass: 47478.8599377,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270510,
    name: "Co51~",
    latex: "^{51}\\mathrm{\\overline{Co}}",
    mass: 47478.8599377,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270520,
    name: "Co52",
    latex: "^{52}\\mathrm{Co}",
    mass: 48403.3492058,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270520,
    name: "Co52~",
    latex: "^{52}\\mathrm{\\overline{Co}}",
    mass: 48403.3492058,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270530,
    name: "Co53",
    latex: "^{53}\\mathrm{Co}",
    mass: 49326.5281411,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270530,
    name: "Co53~",
    latex: "^{53}\\mathrm{\\overline{Co}}",
    mass: 49326.5281411,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270540,
    name: "Co54",
    latex: "^{54}\\mathrm{Co}",
    mass: 50252.6715564,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270540,
    name: "Co54~",
    latex: "^{54}\\mathrm{\\overline{Co}}",
    mass: 50252.6715564,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270550,
    name: "Co55",
    latex: "^{55}\\mathrm{Co}",
    mass: 51178.1456931,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270550,
    name: "Co55~",
    latex: "^{55}\\mathrm{\\overline{Co}}",
    mass: 51178.1456931,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270560,
    name: "Co56",
    latex: "^{56}\\mathrm{Co}",
    mass: 52107.62926,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270560,
    name: "Co56~",
    latex: "^{56}\\mathrm{\\overline{Co}}",
    mass: 52107.62926,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270570,
    name: "Co57",
    latex: "^{57}\\mathrm{Co}",
    mass: 53035.8182363,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270570,
    name: "Co57~",
    latex: "^{57}\\mathrm{\\overline{Co}}",
    mass: 53035.8182363,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270580,
    name: "Co58",
    latex: "^{58}\\mathrm{Co}",
    mass: 53966.8107305,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270580,
    name: "Co58~",
    latex: "^{58}\\mathrm{\\overline{Co}}",
    mass: 53966.8107305,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270590,
    name: "Co59",
    latex: "^{59}\\mathrm{Co}",
    mass: 54895.9222586,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270590,
    name: "Co59~",
    latex: "^{59}\\mathrm{\\overline{Co}}",
    mass: 54895.9222586,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270600,
    name: "Co60",
    latex: "^{60}\\mathrm{Co}",
    mass: 55827.9957516,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270600,
    name: "Co60~",
    latex: "^{60}\\mathrm{\\overline{Co}}",
    mass: 55827.9957516,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270610,
    name: "Co61",
    latex: "^{61}\\mathrm{Co}",
    mass: 56758.242119,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270610,
    name: "Co61~",
    latex: "^{61}\\mathrm{\\overline{Co}}",
    mass: 56758.242119,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270620,
    name: "Co62",
    latex: "^{62}\\mathrm{Co}",
    mass: 57691.2098464,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270620,
    name: "Co62~",
    latex: "^{62}\\mathrm{\\overline{Co}}",
    mass: 57691.2098464,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270630,
    name: "Co63",
    latex: "^{63}\\mathrm{Co}",
    mass: 58622.2773258,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270630,
    name: "Co63~",
    latex: "^{63}\\mathrm{\\overline{Co}}",
    mass: 58622.2773258,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270640,
    name: "Co64",
    latex: "^{64}\\mathrm{Co}",
    mass: 59555.8300315,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270640,
    name: "Co64~",
    latex: "^{64}\\mathrm{\\overline{Co}}",
    mass: 59555.8300315,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270650,
    name: "Co65",
    latex: "^{65}\\mathrm{Co}",
    mass: 60487.9315625,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270650,
    name: "Co65~",
    latex: "^{65}\\mathrm{\\overline{Co}}",
    mass: 60487.9315625,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270660,
    name: "Co66",
    latex: "^{66}\\mathrm{Co}",
    mass: 61422.202357,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270660,
    name: "Co66~",
    latex: "^{66}\\mathrm{\\overline{Co}}",
    mass: 61422.202357,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270670,
    name: "Co67",
    latex: "^{67}\\mathrm{Co}",
    mass: 62354.7835143,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270670,
    name: "Co67~",
    latex: "^{67}\\mathrm{\\overline{Co}}",
    mass: 62354.7835143,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270680,
    name: "Co68",
    latex: "^{68}\\mathrm{Co}",
    mass: 63289.9560883,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270680,
    name: "Co68~",
    latex: "^{68}\\mathrm{\\overline{Co}}",
    mass: 63289.9560883,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270690,
    name: "Co69",
    latex: "^{69}\\mathrm{Co}",
    mass: 64222.7086405,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270690,
    name: "Co69~",
    latex: "^{69}\\mathrm{\\overline{Co}}",
    mass: 64222.7086405,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270700,
    name: "Co70",
    latex: "^{70}\\mathrm{Co}",
    mass: 65158.0619243,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270700,
    name: "Co70~",
    latex: "^{70}\\mathrm{\\overline{Co}}",
    mass: 65158.0619243,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270710,
    name: "Co71",
    latex: "^{71}\\mathrm{Co}",
    mass: 66091.7142999,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270710,
    name: "Co71~",
    latex: "^{71}\\mathrm{\\overline{Co}}",
    mass: 66091.7142999,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000270720,
    name: "Co72",
    latex: "^{72}\\mathrm{Co}",
    mass: 67027.2790328,
    width: undefined,
    charge: 27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000270720,
    name: "Co72~",
    latex: "^{72}\\mathrm{\\overline{Co}}",
    mass: 67027.2790328,
    width: undefined,
    charge: -27.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280500,
    name: "Ni50",
    latex: "^{50}\\mathrm{Ni}",
    mass: 46571.2493428,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280500,
    name: "Ni50~",
    latex: "^{50}\\mathrm{\\overline{Ni}}",
    mass: 46571.2493428,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280510,
    name: "Ni51",
    latex: "^{51}\\mathrm{Ni}",
    mass: 47494.5462984,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280510,
    name: "Ni51~",
    latex: "^{51}\\mathrm{\\overline{Ni}}",
    mass: 47494.5462984,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280520,
    name: "Ni52",
    latex: "^{52}\\mathrm{Ni}",
    mass: 48415.1326062,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280520,
    name: "Ni52~",
    latex: "^{52}\\mathrm{\\overline{Ni}}",
    mass: 48415.1326062,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280530,
    name: "Ni53",
    latex: "^{53}\\mathrm{Ni}",
    mass: 49339.5566696,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280530,
    name: "Ni53~",
    latex: "^{53}\\mathrm{\\overline{Ni}}",
    mass: 49339.5566696,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280540,
    name: "Ni54",
    latex: "^{54}\\mathrm{Ni}",
    mass: 50261.4032889,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280540,
    name: "Ni54~",
    latex: "^{54}\\mathrm{\\overline{Ni}}",
    mass: 50261.4032889,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280550,
    name: "Ni55",
    latex: "^{55}\\mathrm{Ni}",
    mass: 51186.8397002,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280550,
    name: "Ni55~",
    latex: "^{55}\\mathrm{\\overline{Ni}}",
    mass: 51186.8397002,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280560,
    name: "Ni56",
    latex: "^{56}\\mathrm{Ni}",
    mass: 52109.7621952,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280560,
    name: "Ni56~",
    latex: "^{56}\\mathrm{\\overline{Ni}}",
    mass: 52109.7621952,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280570,
    name: "Ni57",
    latex: "^{57}\\mathrm{Ni}",
    mass: 53039.0799561,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280570,
    name: "Ni57~",
    latex: "^{57}\\mathrm{\\overline{Ni}}",
    mass: 53039.0799561,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280580,
    name: "Ni58",
    latex: "^{58}\\mathrm{Ni}",
    mass: 53966.4291905,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280580,
    name: "Ni58~",
    latex: "^{58}\\mathrm{\\overline{Ni}}",
    mass: 53966.4291905,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280590,
    name: "Ni59",
    latex: "^{59}\\mathrm{Ni}",
    mass: 54896.9952466,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280590,
    name: "Ni59~",
    latex: "^{59}\\mathrm{\\overline{Ni}}",
    mass: 54896.9952466,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280600,
    name: "Ni60",
    latex: "^{60}\\mathrm{Ni}",
    mass: 55825.1729519,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280600,
    name: "Ni60~",
    latex: "^{60}\\mathrm{\\overline{Ni}}",
    mass: 55825.1729519,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280610,
    name: "Ni61",
    latex: "^{61}\\mathrm{Ni}",
    mass: 56756.9182796,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280610,
    name: "Ni61~",
    latex: "^{61}\\mathrm{\\overline{Ni}}",
    mass: 56756.9182796,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280620,
    name: "Ni62",
    latex: "^{62}\\mathrm{Ni}",
    mass: 57685.8880343,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280620,
    name: "Ni62~",
    latex: "^{62}\\mathrm{\\overline{Ni}}",
    mass: 57685.8880343,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280630,
    name: "Ni63",
    latex: "^{63}\\mathrm{Ni}",
    mass: 58618.6156225,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280630,
    name: "Ni63~",
    latex: "^{63}\\mathrm{\\overline{Ni}}",
    mass: 58618.6156225,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280640,
    name: "Ni64",
    latex: "^{64}\\mathrm{Ni}",
    mass: 59548.523578,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280640,
    name: "Ni64~",
    latex: "^{64}\\mathrm{\\overline{Ni}}",
    mass: 59548.523578,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280650,
    name: "Ni65",
    latex: "^{65}\\mathrm{Ni}",
    mass: 60481.9909588,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280650,
    name: "Ni65~",
    latex: "^{65}\\mathrm{\\overline{Ni}}",
    mass: 60481.9909588,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280660,
    name: "Ni66",
    latex: "^{66}\\mathrm{Ni}",
    mass: 61412.6045212,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280660,
    name: "Ni66~",
    latex: "^{66}\\mathrm{\\overline{Ni}}",
    mass: 61412.6045212,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280670,
    name: "Ni67",
    latex: "^{67}\\mathrm{Ni}",
    mass: 62346.3618761,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280670,
    name: "Ni67~",
    latex: "^{67}\\mathrm{\\overline{Ni}}",
    mass: 62346.3618761,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280680,
    name: "Ni68",
    latex: "^{68}\\mathrm{Ni}",
    mass: 63278.1354281,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280680,
    name: "Ni68~",
    latex: "^{68}\\mathrm{\\overline{Ni}}",
    mass: 63278.1354281,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280690,
    name: "Ni69",
    latex: "^{69}\\mathrm{Ni}",
    mass: 64213.1142512,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280690,
    name: "Ni69~",
    latex: "^{69}\\mathrm{\\overline{Ni}}",
    mass: 64213.1142512,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280700,
    name: "Ni70",
    latex: "^{70}\\mathrm{Ni}",
    mass: 65145.3733911,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280700,
    name: "Ni70~",
    latex: "^{70}\\mathrm{\\overline{Ni}}",
    mass: 65145.3733911,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280710,
    name: "Ni71",
    latex: "^{71}\\mathrm{Ni}",
    mass: 66080.6751632,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280710,
    name: "Ni71~",
    latex: "^{71}\\mathrm{\\overline{Ni}}",
    mass: 66080.6751632,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280720,
    name: "Ni72",
    latex: "^{72}\\mathrm{Ni}",
    mass: 67013.3493768,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280720,
    name: "Ni72~",
    latex: "^{72}\\mathrm{\\overline{Ni}}",
    mass: 67013.3493768,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280730,
    name: "Ni73",
    latex: "^{73}\\mathrm{Ni}",
    mass: 67948.9614297,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280730,
    name: "Ni73~",
    latex: "^{73}\\mathrm{\\overline{Ni}}",
    mass: 67948.9614297,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280740,
    name: "Ni74",
    latex: "^{74}\\mathrm{Ni}",
    mass: 68881.8651634,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280740,
    name: "Ni74~",
    latex: "^{74}\\mathrm{\\overline{Ni}}",
    mass: 68881.8651634,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280750,
    name: "Ni75",
    latex: "^{75}\\mathrm{Ni}",
    mass: 69817.8211239,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280750,
    name: "Ni75~",
    latex: "^{75}\\mathrm{\\overline{Ni}}",
    mass: 69817.8211239,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280760,
    name: "Ni76",
    latex: "^{76}\\mathrm{Ni}",
    mass: 70751.3645147,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280760,
    name: "Ni76~",
    latex: "^{76}\\mathrm{\\overline{Ni}}",
    mass: 70751.3645147,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280770,
    name: "Ni77",
    latex: "^{77}\\mathrm{Ni}",
    mass: 71687.6930728,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280770,
    name: "Ni77~",
    latex: "^{77}\\mathrm{\\overline{Ni}}",
    mass: 71687.6930728,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000280780,
    name: "Ni78",
    latex: "^{78}\\mathrm{Ni}",
    mass: 72621.6649508,
    width: undefined,
    charge: 28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000280780,
    name: "Ni78~",
    latex: "^{78}\\mathrm{\\overline{Ni}}",
    mass: 72621.6649508,
    width: undefined,
    charge: -28.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290520,
    name: "Cu52",
    latex: "^{52}\\mathrm{Cu}",
    mass: 48435.8117753,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290520,
    name: "Cu52~",
    latex: "^{52}\\mathrm{\\overline{Cu}}",
    mass: 48435.8117753,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290530,
    name: "Cu53",
    latex: "^{53}\\mathrm{Cu}",
    mass: 49356.0441153,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290530,
    name: "Cu53~",
    latex: "^{53}\\mathrm{\\overline{Cu}}",
    mass: 49356.0441153,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290540,
    name: "Cu54",
    latex: "^{54}\\mathrm{Cu}",
    mass: 50279.4435352,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290540,
    name: "Cu54~",
    latex: "^{54}\\mathrm{\\overline{Cu}}",
    mass: 50279.4435352,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290550,
    name: "Cu55",
    latex: "^{55}\\mathrm{Cu}",
    mass: 51200.5421648,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290550,
    name: "Cu55~",
    latex: "^{55}\\mathrm{\\overline{Cu}}",
    mass: 51200.5421648,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290560,
    name: "Cu56",
    latex: "^{56}\\mathrm{Cu}",
    mass: 52125.0398163,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290560,
    name: "Cu56~",
    latex: "^{56}\\mathrm{\\overline{Cu}}",
    mass: 52125.0398163,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290570,
    name: "Cu57",
    latex: "^{57}\\mathrm{Cu}",
    mass: 53047.85491,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290570,
    name: "Cu57~",
    latex: "^{57}\\mathrm{\\overline{Cu}}",
    mass: 53047.85491,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290580,
    name: "Cu58",
    latex: "^{58}\\mathrm{Cu}",
    mass: 53974.9901802,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290580,
    name: "Cu58~",
    latex: "^{58}\\mathrm{\\overline{Cu}}",
    mass: 53974.9901802,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290590,
    name: "Cu59",
    latex: "^{59}\\mathrm{Cu}",
    mass: 54901.7936522,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290590,
    name: "Cu59~",
    latex: "^{59}\\mathrm{\\overline{Cu}}",
    mass: 54901.7936522,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290600,
    name: "Cu60",
    latex: "^{60}\\mathrm{Cu}",
    mass: 55831.3009721,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290600,
    name: "Cu60~",
    latex: "^{60}\\mathrm{\\overline{Cu}}",
    mass: 55831.3009721,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290610,
    name: "Cu61",
    latex: "^{61}\\mathrm{Cu}",
    mass: 56759.1562873,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290610,
    name: "Cu61~",
    latex: "^{61}\\mathrm{\\overline{Cu}}",
    mass: 56759.1562873,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290620,
    name: "Cu62",
    latex: "^{62}\\mathrm{Cu}",
    mass: 57689.8468842,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290620,
    name: "Cu62~",
    latex: "^{62}\\mathrm{\\overline{Cu}}",
    mass: 57689.8468842,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290630,
    name: "Cu63",
    latex: "^{63}\\mathrm{Cu}",
    mass: 58618.548648,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290630,
    name: "Cu63~",
    latex: "^{63}\\mathrm{\\overline{Cu}}",
    mass: 58618.548648,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290640,
    name: "Cu64",
    latex: "^{64}\\mathrm{Cu}",
    mass: 59550.1982181,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290640,
    name: "Cu64~",
    latex: "^{64}\\mathrm{\\overline{Cu}}",
    mass: 59550.1982181,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290650,
    name: "Cu65",
    latex: "^{65}\\mathrm{Cu}",
    mass: 60479.8530867,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290650,
    name: "Cu65~",
    latex: "^{65}\\mathrm{\\overline{Cu}}",
    mass: 60479.8530867,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290660,
    name: "Cu66",
    latex: "^{66}\\mathrm{Cu}",
    mass: 61412.352552,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290660,
    name: "Cu66~",
    latex: "^{66}\\mathrm{\\overline{Cu}}",
    mass: 61412.352552,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290670,
    name: "Cu67",
    latex: "^{67}\\mathrm{Cu}",
    mass: 62342.7854045,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290670,
    name: "Cu67~",
    latex: "^{67}\\mathrm{\\overline{Cu}}",
    mass: 62342.7854045,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290680,
    name: "Cu68",
    latex: "^{68}\\mathrm{Cu}",
    mass: 63276.0320212,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290680,
    name: "Cu68~",
    latex: "^{68}\\mathrm{\\overline{Cu}}",
    mass: 63276.0320212,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290690,
    name: "Cu69",
    latex: "^{69}\\mathrm{Cu}",
    mass: 64207.3569656,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290690,
    name: "Cu69~",
    latex: "^{69}\\mathrm{\\overline{Cu}}",
    mass: 64207.3569656,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290700,
    name: "Cu70",
    latex: "^{70}\\mathrm{Cu}",
    mass: 65141.6109001,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290700,
    name: "Cu70~",
    latex: "^{70}\\mathrm{\\overline{Cu}}",
    mass: 65141.6109001,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290710,
    name: "Cu71",
    latex: "^{71}\\mathrm{Cu}",
    mass: 66073.3702002,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290710,
    name: "Cu71~",
    latex: "^{71}\\mathrm{\\overline{Cu}}",
    mass: 66073.3702002,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290720,
    name: "Cu72",
    latex: "^{72}\\mathrm{Cu}",
    mass: 67007.7924556,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290720,
    name: "Cu72~",
    latex: "^{72}\\mathrm{\\overline{Cu}}",
    mass: 67007.7924556,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290730,
    name: "Cu73",
    latex: "^{73}\\mathrm{Cu}",
    mass: 67940.0821484,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290730,
    name: "Cu73~",
    latex: "^{73}\\mathrm{\\overline{Cu}}",
    mass: 67940.0821484,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290740,
    name: "Cu74",
    latex: "^{74}\\mathrm{Cu}",
    mass: 68874.5575922,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290740,
    name: "Cu74~",
    latex: "^{74}\\mathrm{\\overline{Cu}}",
    mass: 68874.5575922,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290750,
    name: "Cu75",
    latex: "^{75}\\mathrm{Cu}",
    mass: 69807.5875434,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290750,
    name: "Cu75~",
    latex: "^{75}\\mathrm{\\overline{Cu}}",
    mass: 69807.5875434,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290760,
    name: "Cu76",
    latex: "^{76}\\mathrm{Cu}",
    mass: 70742.5702788,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290760,
    name: "Cu76~",
    latex: "^{76}\\mathrm{\\overline{Cu}}",
    mass: 70742.5702788,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290770,
    name: "Cu77",
    latex: "^{77}\\mathrm{Cu}",
    mass: 71676.183159,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290770,
    name: "Cu77~",
    latex: "^{77}\\mathrm{\\overline{Cu}}",
    mass: 71676.183159,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290780,
    name: "Cu78",
    latex: "^{78}\\mathrm{Cu}",
    mass: 72611.7510591,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290780,
    name: "Cu78~",
    latex: "^{78}\\mathrm{\\overline{Cu}}",
    mass: 72611.7510591,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290790,
    name: "Cu79",
    latex: "^{79}\\mathrm{Cu}",
    mass: 73545.6232672,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290790,
    name: "Cu79~",
    latex: "^{79}\\mathrm{\\overline{Cu}}",
    mass: 73545.6232672,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000290800,
    name: "Cu80",
    latex: "^{80}\\mathrm{Cu}",
    mass: 74482.8460597,
    width: undefined,
    charge: 29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000290800,
    name: "Cu80~",
    latex: "^{80}\\mathrm{\\overline{Cu}}",
    mass: 74482.8460597,
    width: undefined,
    charge: -29.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300540,
    name: "Zn54",
    latex: "^{54}\\mathrm{Zn}",
    mass: 50294.9808569,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300540,
    name: "Zn54~",
    latex: "^{54}\\mathrm{\\overline{Zn}}",
    mass: 50294.9808569,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300550,
    name: "Zn55",
    latex: "^{55}\\mathrm{Zn}",
    mass: 51217.9052149,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300550,
    name: "Zn55~",
    latex: "^{55}\\mathrm{\\overline{Zn}}",
    mass: 51217.9052149,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300560,
    name: "Zn56",
    latex: "^{56}\\mathrm{Zn}",
    mass: 52138.277279,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300560,
    name: "Zn56~",
    latex: "^{56}\\mathrm{\\overline{Zn}}",
    mass: 52138.277279,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300570,
    name: "Zn57",
    latex: "^{57}\\mathrm{Zn}",
    mass: 53062.617508,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300570,
    name: "Zn57~",
    latex: "^{57}\\mathrm{\\overline{Zn}}",
    mass: 53062.617508,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300580,
    name: "Zn58",
    latex: "^{58}\\mathrm{Zn}",
    mass: 53984.3588684,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300580,
    name: "Zn58~",
    latex: "^{58}\\mathrm{\\overline{Zn}}",
    mass: 53984.3588684,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300590,
    name: "Zn59",
    latex: "^{59}\\mathrm{Zn}",
    mass: 54910.9364531,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300590,
    name: "Zn59~",
    latex: "^{59}\\mathrm{\\overline{Zn}}",
    mass: 54910.9364531,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300600,
    name: "Zn60",
    latex: "^{60}\\mathrm{Zn}",
    mass: 55835.471737,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300600,
    name: "Zn60~",
    latex: "^{60}\\mathrm{\\overline{Zn}}",
    mass: 55835.471737,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300610,
    name: "Zn61",
    latex: "^{61}\\mathrm{Zn}",
    mass: 56764.791454,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300610,
    name: "Zn61~",
    latex: "^{61}\\mathrm{\\overline{Zn}}",
    mass: 56764.791454,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300620,
    name: "Zn62",
    latex: "^{62}\\mathrm{Zn}",
    mass: 57691.4663798,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300620,
    name: "Zn62~",
    latex: "^{62}\\mathrm{\\overline{Zn}}",
    mass: 57691.4663798,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300630,
    name: "Zn63",
    latex: "^{63}\\mathrm{Zn}",
    mass: 58621.9150677,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300630,
    name: "Zn63~",
    latex: "^{63}\\mathrm{\\overline{Zn}}",
    mass: 58621.9150677,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300640,
    name: "Zn64",
    latex: "^{64}\\mathrm{Zn}",
    mass: 59549.6186425,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300640,
    name: "Zn64~",
    latex: "^{64}\\mathrm{\\overline{Zn}}",
    mass: 59549.6186425,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300650,
    name: "Zn65",
    latex: "^{65}\\mathrm{Zn}",
    mass: 60481.2046847,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300650,
    name: "Zn65~",
    latex: "^{65}\\mathrm{\\overline{Zn}}",
    mass: 60481.2046847,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300660,
    name: "Zn66",
    latex: "^{66}\\mathrm{Zn}",
    mass: 61409.71158,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300660,
    name: "Zn66~",
    latex: "^{66}\\mathrm{\\overline{Zn}}",
    mass: 61409.71158,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300670,
    name: "Zn67",
    latex: "^{67}\\mathrm{Zn}",
    mass: 62342.2245519,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300670,
    name: "Zn67~",
    latex: "^{67}\\mathrm{\\overline{Zn}}",
    mass: 62342.2245519,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300680,
    name: "Zn68",
    latex: "^{68}\\mathrm{Zn}",
    mass: 63271.5918683,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300680,
    name: "Zn68~",
    latex: "^{68}\\mathrm{\\overline{Zn}}",
    mass: 63271.5918683,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300690,
    name: "Zn69",
    latex: "^{69}\\mathrm{Zn}",
    mass: 64204.6752873,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300690,
    name: "Zn69~",
    latex: "^{69}\\mathrm{\\overline{Zn}}",
    mass: 64204.6752873,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300700,
    name: "Zn70",
    latex: "^{70}\\mathrm{Zn}",
    mass: 65135.0225354,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300700,
    name: "Zn70~",
    latex: "^{70}\\mathrm{\\overline{Zn}}",
    mass: 65135.0225354,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300710,
    name: "Zn71",
    latex: "^{71}\\mathrm{Zn}",
    mass: 66068.7525976,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300710,
    name: "Zn71~",
    latex: "^{71}\\mathrm{\\overline{Zn}}",
    mass: 66068.7525976,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300720,
    name: "Zn72",
    latex: "^{72}\\mathrm{Zn}",
    mass: 66999.4299673,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300720,
    name: "Zn72~",
    latex: "^{72}\\mathrm{\\overline{Zn}}",
    mass: 66999.4299673,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300730,
    name: "Zn73",
    latex: "^{73}\\mathrm{Zn}",
    mass: 67933.4761786,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300730,
    name: "Zn73~",
    latex: "^{73}\\mathrm{\\overline{Zn}}",
    mass: 67933.4761786,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300740,
    name: "Zn74",
    latex: "^{74}\\mathrm{Zn}",
    mass: 68864.8069914,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300740,
    name: "Zn74~",
    latex: "^{74}\\mathrm{\\overline{Zn}}",
    mass: 68864.8069914,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300750,
    name: "Zn75",
    latex: "^{75}\\mathrm{Zn}",
    mass: 69799.4988212,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300750,
    name: "Zn75~",
    latex: "^{75}\\mathrm{\\overline{Zn}}",
    mass: 69799.4988212,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300760,
    name: "Zn76",
    latex: "^{76}\\mathrm{Zn}",
    mass: 70731.2488995,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300760,
    name: "Zn76~",
    latex: "^{76}\\mathrm{\\overline{Zn}}",
    mass: 70731.2488995,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300770,
    name: "Zn77",
    latex: "^{77}\\mathrm{Zn}",
    mass: 71666.2567853,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300770,
    name: "Zn77~",
    latex: "^{77}\\mathrm{\\overline{Zn}}",
    mass: 71666.2567853,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300780,
    name: "Zn78",
    latex: "^{78}\\mathrm{Zn}",
    mass: 72599.0568437,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300780,
    name: "Zn78~",
    latex: "^{78}\\mathrm{\\overline{Zn}}",
    mass: 72599.0568437,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300790,
    name: "Zn79",
    latex: "^{79}\\mathrm{Zn}",
    mass: 73534.6019221,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300790,
    name: "Zn79~",
    latex: "^{79}\\mathrm{\\overline{Zn}}",
    mass: 73534.6019221,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300800,
    name: "Zn80",
    latex: "^{80}\\mathrm{Zn}",
    mass: 74467.8796508,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300800,
    name: "Zn80~",
    latex: "^{80}\\mathrm{\\overline{Zn}}",
    mass: 74467.8796508,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300810,
    name: "Zn81",
    latex: "^{81}\\mathrm{Zn}",
    mass: 75404.8230881,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300810,
    name: "Zn81~",
    latex: "^{81}\\mathrm{\\overline{Zn}}",
    mass: 75404.8230881,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000300820,
    name: "Zn82",
    latex: "^{82}\\mathrm{Zn}",
    mass: 76340.2024538,
    width: undefined,
    charge: 30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000300820,
    name: "Zn82~",
    latex: "^{82}\\mathrm{\\overline{Zn}}",
    mass: 76340.2024538,
    width: undefined,
    charge: -30.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310560,
    name: "Ga56",
    latex: "^{56}\\mathrm{Ga}",
    mass: 52159.8320525,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310560,
    name: "Ga56~",
    latex: "^{56}\\mathrm{\\overline{Ga}}",
    mass: 52159.8320525,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310570,
    name: "Ga57",
    latex: "^{57}\\mathrm{Ga}",
    mass: 53079.7569995,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310570,
    name: "Ga57~",
    latex: "^{57}\\mathrm{\\overline{Ga}}",
    mass: 53079.7569995,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310580,
    name: "Ga58",
    latex: "^{58}\\mathrm{Ga}",
    mass: 54003.1191597,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310580,
    name: "Ga58~",
    latex: "^{58}\\mathrm{\\overline{Ga}}",
    mass: 54003.1191597,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310590,
    name: "Ga59",
    latex: "^{59}\\mathrm{Ga}",
    mass: 54924.3947731,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310590,
    name: "Ga59~",
    latex: "^{59}\\mathrm{\\overline{Ga}}",
    mass: 54924.3947731,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310600,
    name: "Ga60",
    latex: "^{60}\\mathrm{Ga}",
    mass: 55850.0577237,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310600,
    name: "Ga60~",
    latex: "^{60}\\mathrm{\\overline{Ga}}",
    mass: 55850.0577237,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310610,
    name: "Ga61",
    latex: "^{61}\\mathrm{Ga}",
    mass: 56774.0067252,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310610,
    name: "Ga61~",
    latex: "^{61}\\mathrm{\\overline{Ga}}",
    mass: 56774.0067252,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310620,
    name: "Ga62",
    latex: "^{62}\\mathrm{Ga}",
    mass: 57700.647372,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310620,
    name: "Ga62~",
    latex: "^{62}\\mathrm{\\overline{Ga}}",
    mass: 57700.647372,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310630,
    name: "Ga63",
    latex: "^{63}\\mathrm{Ga}",
    mass: 58627.5814395,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310630,
    name: "Ga63~",
    latex: "^{63}\\mathrm{\\overline{Ga}}",
    mass: 58627.5814395,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310640,
    name: "Ga64",
    latex: "^{64}\\mathrm{Ga}",
    mass: 59556.789843,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310640,
    name: "Ga64~",
    latex: "^{64}\\mathrm{\\overline{Ga}}",
    mass: 59556.789843,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310650,
    name: "Ga65",
    latex: "^{65}\\mathrm{Ga}",
    mass: 60484.4592319,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310650,
    name: "Ga65~",
    latex: "^{65}\\mathrm{\\overline{Ga}}",
    mass: 60484.4592319,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310660,
    name: "Ga66",
    latex: "^{66}\\mathrm{Ga}",
    mass: 61414.8871475,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310660,
    name: "Ga66~",
    latex: "^{66}\\mathrm{\\overline{Ga}}",
    mass: 61414.8871475,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310670,
    name: "Ga67",
    latex: "^{67}\\mathrm{Ga}",
    mass: 62343.2258149,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310670,
    name: "Ga67~",
    latex: "^{67}\\mathrm{\\overline{Ga}}",
    mass: 62343.2258149,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310680,
    name: "Ga68",
    latex: "^{68}\\mathrm{Ga}",
    mass: 63274.5130338,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310680,
    name: "Ga68~",
    latex: "^{68}\\mathrm{\\overline{Ga}}",
    mass: 63274.5130338,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310690,
    name: "Ga69",
    latex: "^{69}\\mathrm{Ga}",
    mass: 64203.7653107,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310690,
    name: "Ga69~",
    latex: "^{69}\\mathrm{\\overline{Ga}}",
    mass: 64203.7653107,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310700,
    name: "Ga70",
    latex: "^{70}\\mathrm{Ga}",
    mass: 65135.6770963,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310700,
    name: "Ga70~",
    latex: "^{70}\\mathrm{\\overline{Ga}}",
    mass: 65135.6770963,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310710,
    name: "Ga71",
    latex: "^{71}\\mathrm{Ga}",
    mass: 66065.9422799,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310710,
    name: "Ga71~",
    latex: "^{71}\\mathrm{\\overline{Ga}}",
    mass: 66065.9422799,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310720,
    name: "Ga72",
    latex: "^{72}\\mathrm{Ga}",
    mass: 66998.9872281,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310720,
    name: "Ga72~",
    latex: "^{72}\\mathrm{\\overline{Ga}}",
    mass: 66998.9872281,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310730,
    name: "Ga73",
    latex: "^{73}\\mathrm{Ga}",
    mass: 67929.3702457,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310730,
    name: "Ga73~",
    latex: "^{73}\\mathrm{\\overline{Ga}}",
    mass: 67929.3702457,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310740,
    name: "Ga74",
    latex: "^{74}\\mathrm{Ga}",
    mass: 68862.5143049,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310740,
    name: "Ga74~",
    latex: "^{74}\\mathrm{\\overline{Ga}}",
    mass: 68862.5143049,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310750,
    name: "Ga75",
    latex: "^{75}\\mathrm{Ga}",
    mass: 69793.597154,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310750,
    name: "Ga75~",
    latex: "^{75}\\mathrm{\\overline{Ga}}",
    mass: 69793.597154,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310760,
    name: "Ga76",
    latex: "^{76}\\mathrm{Ga}",
    mass: 70727.2552117,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310760,
    name: "Ga76~",
    latex: "^{76}\\mathrm{\\overline{Ga}}",
    mass: 70727.2552117,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310770,
    name: "Ga77",
    latex: "^{77}\\mathrm{Ga}",
    mass: 71659.0536345,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310770,
    name: "Ga77~",
    latex: "^{77}\\mathrm{\\overline{Ga}}",
    mass: 71659.0536345,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310780,
    name: "Ga78",
    latex: "^{78}\\mathrm{Ga}",
    mass: 72592.8360466,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310780,
    name: "Ga78~",
    latex: "^{78}\\mathrm{\\overline{Ga}}",
    mass: 72592.8360466,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310790,
    name: "Ga79",
    latex: "^{79}\\mathrm{Ga}",
    mass: 73525.4858551,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310790,
    name: "Ga79~",
    latex: "^{79}\\mathrm{\\overline{Ga}}",
    mass: 73525.4858551,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310800,
    name: "Ga80",
    latex: "^{80}\\mathrm{Ga}",
    mass: 74460.3048339,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310800,
    name: "Ga80~",
    latex: "^{80}\\mathrm{\\overline{Ga}}",
    mass: 74460.3048339,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310810,
    name: "Ga81",
    latex: "^{81}\\mathrm{Ga}",
    mass: 75393.394587,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310810,
    name: "Ga81~",
    latex: "^{81}\\mathrm{\\overline{Ga}}",
    mass: 75393.394587,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310820,
    name: "Ga82",
    latex: "^{82}\\mathrm{Ga}",
    mass: 76329.5857497,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310820,
    name: "Ga82~",
    latex: "^{82}\\mathrm{\\overline{Ga}}",
    mass: 76329.5857497,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310830,
    name: "Ga83",
    latex: "^{83}\\mathrm{Ga}",
    mass: 77264.7534799,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310830,
    name: "Ga83~",
    latex: "^{83}\\mathrm{\\overline{Ga}}",
    mass: 77264.7534799,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000310840,
    name: "Ga84",
    latex: "^{84}\\mathrm{Ga}",
    mass: 78201.4077815,
    width: undefined,
    charge: 31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000310840,
    name: "Ga84~",
    latex: "^{84}\\mathrm{\\overline{Ga}}",
    mass: 78201.4077815,
    width: undefined,
    charge: -31.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320580,
    name: "Ge58",
    latex: "^{58}\\mathrm{Ge}",
    mass: 54019.0756537,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320580,
    name: "Ge58~",
    latex: "^{58}\\mathrm{\\overline{Ge}}",
    mass: 54019.0756537,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320590,
    name: "Ge59",
    latex: "^{59}\\mathrm{Ge}",
    mass: 54941.785768,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320590,
    name: "Ge59~",
    latex: "^{59}\\mathrm{\\overline{Ge}}",
    mass: 54941.785768,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320600,
    name: "Ge60",
    latex: "^{60}\\mathrm{Ge}",
    mass: 55862.1205723,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320600,
    name: "Ge60~",
    latex: "^{60}\\mathrm{\\overline{Ge}}",
    mass: 55862.1205723,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320610,
    name: "Ge61",
    latex: "^{61}\\mathrm{Ge}",
    mass: 56787.3550357,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320610,
    name: "Ge61~",
    latex: "^{61}\\mathrm{\\overline{Ge}}",
    mass: 56787.3550357,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320620,
    name: "Ge62",
    latex: "^{62}\\mathrm{Ge}",
    mass: 57710.4936373,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320620,
    name: "Ge62~",
    latex: "^{62}\\mathrm{\\overline{Ge}}",
    mass: 57710.4936373,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320630,
    name: "Ge63",
    latex: "^{63}\\mathrm{Ge}",
    mass: 58637.2091763,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320630,
    name: "Ge63~",
    latex: "^{63}\\mathrm{\\overline{Ge}}",
    mass: 58637.2091763,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320640,
    name: "Ge64",
    latex: "^{64}\\mathrm{Ge}",
    mass: 59561.3072168,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320640,
    name: "Ge64~",
    latex: "^{64}\\mathrm{\\overline{Ge}}",
    mass: 59561.3072168,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320650,
    name: "Ge65",
    latex: "^{65}\\mathrm{Ge}",
    mass: 60490.6384844,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320650,
    name: "Ge65~",
    latex: "^{65}\\mathrm{\\overline{Ge}}",
    mass: 60490.6384844,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320660,
    name: "Ge66",
    latex: "^{66}\\mathrm{Ge}",
    mass: 61417.0037815,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320660,
    name: "Ge66~",
    latex: "^{66}\\mathrm{\\overline{Ge}}",
    mass: 61417.0037815,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320670,
    name: "Ge67",
    latex: "^{67}\\mathrm{Ge}",
    mass: 62347.4312314,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320670,
    name: "Ge67~",
    latex: "^{67}\\mathrm{\\overline{Ge}}",
    mass: 62347.4312314,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320680,
    name: "Ge68",
    latex: "^{68}\\mathrm{Ge}",
    mass: 63274.6202488,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320680,
    name: "Ge68~",
    latex: "^{68}\\mathrm{\\overline{Ge}}",
    mass: 63274.6202488,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320690,
    name: "Ge69",
    latex: "^{69}\\mathrm{Ge}",
    mass: 64205.9925131,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320690,
    name: "Ge69~",
    latex: "^{69}\\mathrm{\\overline{Ge}}",
    mass: 64205.9925131,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320700,
    name: "Ge70",
    latex: "^{70}\\mathrm{Ge}",
    mass: 65134.0251847,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320700,
    name: "Ge70~",
    latex: "^{70}\\mathrm{\\overline{Ge}}",
    mass: 65134.0251847,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320710,
    name: "Ge71",
    latex: "^{71}\\mathrm{Ge}",
    mass: 66066.1746877,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320710,
    name: "Ge71~",
    latex: "^{71}\\mathrm{\\overline{Ge}}",
    mass: 66066.1746877,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320720,
    name: "Ge72",
    latex: "^{72}\\mathrm{Ge}",
    mass: 66994.9895535,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320720,
    name: "Ge72~",
    latex: "^{72}\\mathrm{\\overline{Ge}}",
    mass: 66994.9895535,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320730,
    name: "Ge73",
    latex: "^{73}\\mathrm{Ge}",
    mass: 67927.7720347,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320730,
    name: "Ge73~",
    latex: "^{73}\\mathrm{\\overline{Ge}}",
    mass: 67927.7720347,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320740,
    name: "Ge74",
    latex: "^{74}\\mathrm{Ge}",
    mass: 68857.1412243,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320740,
    name: "Ge74~",
    latex: "^{74}\\mathrm{\\overline{Ge}}",
    mass: 68857.1412243,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320750,
    name: "Ge75",
    latex: "^{75}\\mathrm{Ge}",
    mass: 69790.2008054,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320750,
    name: "Ge75~",
    latex: "^{75}\\mathrm{\\overline{Ge}}",
    mass: 69790.2008054,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320760,
    name: "Ge76",
    latex: "^{76}\\mathrm{Ge}",
    mass: 70720.3389844,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320760,
    name: "Ge76~",
    latex: "^{76}\\mathrm{\\overline{Ge}}",
    mass: 70720.3389844,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320770,
    name: "Ge77",
    latex: "^{77}\\mathrm{Ge}",
    mass: 71653.8331131,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320770,
    name: "Ge77~",
    latex: "^{77}\\mathrm{\\overline{Ge}}",
    mass: 71653.8331131,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320780,
    name: "Ge78",
    latex: "^{78}\\mathrm{Ge}",
    mass: 72584.6781144,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320780,
    name: "Ge78~",
    latex: "^{78}\\mathrm{\\overline{Ge}}",
    mass: 72584.6781144,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320790,
    name: "Ge79",
    latex: "^{79}\\mathrm{Ge}",
    mass: 73518.5074739,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320790,
    name: "Ge79~",
    latex: "^{79}\\mathrm{\\overline{Ge}}",
    mass: 73518.5074739,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320800,
    name: "Ge80",
    latex: "^{80}\\mathrm{Ge}",
    mass: 74449.9930078,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320800,
    name: "Ge80~",
    latex: "^{80}\\mathrm{\\overline{Ge}}",
    mass: 74449.9930078,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320810,
    name: "Ge81",
    latex: "^{81}\\mathrm{Ge}",
    mass: 75384.7306672,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320810,
    name: "Ge81~",
    latex: "^{81}\\mathrm{\\overline{Ge}}",
    mass: 75384.7306672,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320820,
    name: "Ge82",
    latex: "^{82}\\mathrm{Ge}",
    mass: 76317.1014,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320820,
    name: "Ge82~",
    latex: "^{82}\\mathrm{\\overline{Ge}}",
    mass: 76317.1014,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320830,
    name: "Ge83",
    latex: "^{83}\\mathrm{Ge}",
    mass: 77253.0341663,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320830,
    name: "Ge83~",
    latex: "^{83}\\mathrm{\\overline{Ge}}",
    mass: 77253.0341663,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320840,
    name: "Ge84",
    latex: "^{84}\\mathrm{Ge}",
    mass: 78187.3561929,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320840,
    name: "Ge84~",
    latex: "^{84}\\mathrm{\\overline{Ge}}",
    mass: 78187.3561929,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320850,
    name: "Ge85",
    latex: "^{85}\\mathrm{Ge}",
    mass: 79123.8757073,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320850,
    name: "Ge85~",
    latex: "^{85}\\mathrm{\\overline{Ge}}",
    mass: 79123.8757073,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000320860,
    name: "Ge86",
    latex: "^{86}\\mathrm{Ge}",
    mass: 80059.0957875,
    width: undefined,
    charge: 32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000320860,
    name: "Ge86~",
    latex: "^{86}\\mathrm{\\overline{Ge}}",
    mass: 80059.0957875,
    width: undefined,
    charge: -32.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330600,
    name: "As60",
    latex: "^{60}\\mathrm{As}",
    mass: 55884.0106838,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330600,
    name: "As60~",
    latex: "^{60}\\mathrm{\\overline{As}}",
    mass: 55884.0106838,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330610,
    name: "As61",
    latex: "^{61}\\mathrm{As}",
    mass: 56803.9449457,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330610,
    name: "As61~",
    latex: "^{61}\\mathrm{\\overline{As}}",
    mass: 56803.9449457,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330620,
    name: "As62",
    latex: "^{62}\\mathrm{As}",
    mass: 57728.2106552,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330620,
    name: "As62~",
    latex: "^{62}\\mathrm{\\overline{As}}",
    mass: 57728.2106552,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330630,
    name: "As63",
    latex: "^{63}\\mathrm{As}",
    mass: 58650.6320063,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330630,
    name: "As63~",
    latex: "^{63}\\mathrm{\\overline{As}}",
    mass: 58650.6320063,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330640,
    name: "As64",
    latex: "^{64}\\mathrm{As}",
    mass: 59576.0900282,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330640,
    name: "As64~",
    latex: "^{64}\\mathrm{\\overline{As}}",
    mass: 59576.0900282,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330650,
    name: "As65",
    latex: "^{65}\\mathrm{As}",
    mass: 60500.1787538,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330650,
    name: "As65~",
    latex: "^{65}\\mathrm{\\overline{As}}",
    mass: 60500.1787538,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330660,
    name: "As66",
    latex: "^{66}\\mathrm{As}",
    mass: 61426.5859682,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330660,
    name: "As66~",
    latex: "^{66}\\mathrm{\\overline{As}}",
    mass: 61426.5859682,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330670,
    name: "As67",
    latex: "^{67}\\mathrm{As}",
    mass: 62353.517707,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330670,
    name: "As67~",
    latex: "^{67}\\mathrm{\\overline{As}}",
    mass: 62353.517707,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330680,
    name: "As68",
    latex: "^{68}\\mathrm{As}",
    mass: 63282.7044998,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330680,
    name: "As68~",
    latex: "^{68}\\mathrm{\\overline{As}}",
    mass: 63282.7044998,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330690,
    name: "As69",
    latex: "^{69}\\mathrm{As}",
    mass: 64209.9844311,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330690,
    name: "As69~",
    latex: "^{69}\\mathrm{\\overline{As}}",
    mass: 64209.9844311,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330700,
    name: "As70",
    latex: "^{70}\\mathrm{As}",
    mass: 65140.2532474,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330700,
    name: "As70~",
    latex: "^{70}\\mathrm{\\overline{As}}",
    mass: 65140.2532474,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330710,
    name: "As71",
    latex: "^{71}\\mathrm{As}",
    mass: 66068.1884848,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330710,
    name: "As71~",
    latex: "^{71}\\mathrm{\\overline{As}}",
    mass: 66068.1884848,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330720,
    name: "As72",
    latex: "^{72}\\mathrm{As}",
    mass: 66999.3453876,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330720,
    name: "As72~",
    latex: "^{72}\\mathrm{\\overline{As}}",
    mass: 66999.3453876,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330730,
    name: "As73",
    latex: "^{73}\\mathrm{As}",
    mass: 67928.1167341,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330730,
    name: "As73~",
    latex: "^{73}\\mathrm{\\overline{As}}",
    mass: 67928.1167341,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330740,
    name: "As74",
    latex: "^{74}\\mathrm{As}",
    mass: 68859.7036146,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330740,
    name: "As74~",
    latex: "^{74}\\mathrm{\\overline{As}}",
    mass: 68859.7036146,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330750,
    name: "As75",
    latex: "^{75}\\mathrm{As}",
    mass: 69789.0236111,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330750,
    name: "As75~",
    latex: "^{75}\\mathrm{\\overline{As}}",
    mass: 69789.0236111,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330760,
    name: "As76",
    latex: "^{76}\\mathrm{As}",
    mass: 70721.2604882,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330760,
    name: "As76~",
    latex: "^{76}\\mathrm{\\overline{As}}",
    mass: 70721.2604882,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330770,
    name: "As77",
    latex: "^{77}\\mathrm{As}",
    mass: 71651.1296936,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330770,
    name: "As77~",
    latex: "^{77}\\mathrm{\\overline{As}}",
    mass: 71651.1296936,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330780,
    name: "As78",
    latex: "^{78}\\mathrm{As}",
    mass: 72583.723333,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330780,
    name: "As78~",
    latex: "^{78}\\mathrm{\\overline{As}}",
    mass: 72583.723333,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330790,
    name: "As79",
    latex: "^{79}\\mathrm{As}",
    mass: 73514.3977219,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330790,
    name: "As79~",
    latex: "^{79}\\mathrm{\\overline{As}}",
    mass: 73514.3977219,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330800,
    name: "As80",
    latex: "^{80}\\mathrm{As}",
    mass: 74447.3132856,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330800,
    name: "As80~",
    latex: "^{80}\\mathrm{\\overline{As}}",
    mass: 74447.3132856,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330810,
    name: "As81",
    latex: "^{81}\\mathrm{As}",
    mass: 75378.4890978,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330810,
    name: "As81~",
    latex: "^{81}\\mathrm{\\overline{As}}",
    mass: 75378.4890978,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330820,
    name: "As82",
    latex: "^{82}\\mathrm{As}",
    mass: 76312.4113272,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330820,
    name: "As82~",
    latex: "^{82}\\mathrm{\\overline{As}}",
    mass: 76312.4113272,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330830,
    name: "As83",
    latex: "^{83}\\mathrm{As}",
    mass: 77244.3413701,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330830,
    name: "As83~",
    latex: "^{83}\\mathrm{\\overline{As}}",
    mass: 77244.3413701,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330840,
    name: "As84",
    latex: "^{84}\\mathrm{As}",
    mass: 78179.6508737,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330840,
    name: "As84~",
    latex: "^{84}\\mathrm{\\overline{As}}",
    mass: 78179.6508737,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330850,
    name: "As85",
    latex: "^{85}\\mathrm{As}",
    mass: 79113.8099821,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330850,
    name: "As85~",
    latex: "^{85}\\mathrm{\\overline{As}}",
    mass: 79113.8099821,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330860,
    name: "As86",
    latex: "^{86}\\mathrm{As}",
    mass: 80049.531206,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330860,
    name: "As86~",
    latex: "^{86}\\mathrm{\\overline{As}}",
    mass: 80049.531206,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330870,
    name: "As87",
    latex: "^{87}\\mathrm{As}",
    mass: 80984.3693736,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330870,
    name: "As87~",
    latex: "^{87}\\mathrm{\\overline{As}}",
    mass: 80984.3693736,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330880,
    name: "As88",
    latex: "^{88}\\mathrm{As}",
    mass: 81921.0314066,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330880,
    name: "As88~",
    latex: "^{88}\\mathrm{\\overline{As}}",
    mass: 81921.0314066,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000330890,
    name: "As89",
    latex: "^{89}\\mathrm{As}",
    mass: 82856.4471005,
    width: undefined,
    charge: 33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000330890,
    name: "As89~",
    latex: "^{89}\\mathrm{\\overline{As}}",
    mass: 82856.4471005,
    width: undefined,
    charge: -33.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340650,
    name: "Se65",
    latex: "^{65}\\mathrm{Se}",
    mass: 60514.0952757,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340650,
    name: "Se65~",
    latex: "^{65}\\mathrm{\\overline{Se}}",
    mass: 60514.0952757,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340660,
    name: "Se66",
    latex: "^{66}\\mathrm{Se}",
    mass: 61436.9544291,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340660,
    name: "Se66~",
    latex: "^{66}\\mathrm{\\overline{Se}}",
    mass: 61436.9544291,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340670,
    name: "Se67",
    latex: "^{67}\\mathrm{Se}",
    mass: 62363.520929,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340670,
    name: "Se67~",
    latex: "^{67}\\mathrm{\\overline{Se}}",
    mass: 62363.520929,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340680,
    name: "Se68",
    latex: "^{68}\\mathrm{Se}",
    mass: 63287.4095697,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340680,
    name: "Se68~",
    latex: "^{68}\\mathrm{\\overline{Se}}",
    mass: 63287.4095697,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340690,
    name: "Se69",
    latex: "^{69}\\mathrm{Se}",
    mass: 64216.6584,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340690,
    name: "Se69~",
    latex: "^{69}\\mathrm{\\overline{Se}}",
    mass: 64216.6584,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340700,
    name: "Se70",
    latex: "^{70}\\mathrm{Se}",
    mass: 65142.6573406,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340700,
    name: "Se70~",
    latex: "^{70}\\mathrm{\\overline{Se}}",
    mass: 65142.6573406,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340710,
    name: "Se71",
    latex: "^{71}\\mathrm{Se}",
    mass: 66072.9344472,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340710,
    name: "Se71~",
    latex: "^{71}\\mathrm{\\overline{Se}}",
    mass: 66072.9344472,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340720,
    name: "Se72",
    latex: "^{72}\\mathrm{Se}",
    mass: 66999.7072731,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340720,
    name: "Se72~",
    latex: "^{72}\\mathrm{\\overline{Se}}",
    mass: 66999.7072731,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340730,
    name: "Se73",
    latex: "^{73}\\mathrm{Se}",
    mass: 67930.8422858,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340730,
    name: "Se73~",
    latex: "^{73}\\mathrm{\\overline{Se}}",
    mass: 67930.8422858,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340740,
    name: "Se74",
    latex: "^{74}\\mathrm{Se}",
    mass: 68858.3504648,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340740,
    name: "Se74~",
    latex: "^{74}\\mathrm{\\overline{Se}}",
    mass: 68858.3504648,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340750,
    name: "Se75",
    latex: "^{75}\\mathrm{Se}",
    mass: 69789.8882891,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340750,
    name: "Se75~",
    latex: "^{75}\\mathrm{\\overline{Se}}",
    mass: 69789.8882891,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340760,
    name: "Se76",
    latex: "^{76}\\mathrm{Se}",
    mass: 70718.2999233,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340760,
    name: "Se76~",
    latex: "^{76}\\mathrm{\\overline{Se}}",
    mass: 70718.2999233,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340770,
    name: "Se77",
    latex: "^{77}\\mathrm{Se}",
    mass: 71650.4464893,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340770,
    name: "Se77~",
    latex: "^{77}\\mathrm{\\overline{Se}}",
    mass: 71650.4464893,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340780,
    name: "Se78",
    latex: "^{78}\\mathrm{Se}",
    mass: 72579.5141347,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340780,
    name: "Se78~",
    latex: "^{78}\\mathrm{\\overline{Se}}",
    mass: 72579.5141347,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340790,
    name: "Se79",
    latex: "^{79}\\mathrm{Se}",
    mass: 73512.1167257,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340790,
    name: "Se79~",
    latex: "^{79}\\mathrm{\\overline{Se}}",
    mass: 73512.1167257,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340800,
    name: "Se80",
    latex: "^{80}\\mathrm{Se}",
    mass: 74441.7688464,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340800,
    name: "Se80~",
    latex: "^{80}\\mathrm{\\overline{Se}}",
    mass: 74441.7688464,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340810,
    name: "Se81",
    latex: "^{81}\\mathrm{Se}",
    mass: 75374.6333642,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340810,
    name: "Se81~",
    latex: "^{81}\\mathrm{\\overline{Se}}",
    mass: 75374.6333642,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340820,
    name: "Se82",
    latex: "^{82}\\mathrm{Se}",
    mass: 76304.9225803,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340820,
    name: "Se82~",
    latex: "^{82}\\mathrm{\\overline{Se}}",
    mass: 76304.9225803,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340830,
    name: "Se83",
    latex: "^{83}\\mathrm{Se}",
    mass: 77238.670434,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340830,
    name: "Se83~",
    latex: "^{83}\\mathrm{\\overline{Se}}",
    mass: 77238.670434,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340840,
    name: "Se84",
    latex: "^{84}\\mathrm{Se}",
    mass: 78169.5570173,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340840,
    name: "Se84~",
    latex: "^{84}\\mathrm{\\overline{Se}}",
    mass: 78169.5570173,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340850,
    name: "Se85",
    latex: "^{85}\\mathrm{Se}",
    mass: 79104.5852097,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340850,
    name: "Se85~",
    latex: "^{85}\\mathrm{\\overline{Se}}",
    mass: 79104.5852097,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340860,
    name: "Se86",
    latex: "^{86}\\mathrm{Se}",
    mass: 80037.9897146,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340860,
    name: "Se86~",
    latex: "^{86}\\mathrm{\\overline{Se}}",
    mass: 80037.9897146,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340870,
    name: "Se87",
    latex: "^{87}\\mathrm{Se}",
    mass: 80973.5608749,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340870,
    name: "Se87~",
    latex: "^{87}\\mathrm{\\overline{Se}}",
    mass: 80973.5608749,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340880,
    name: "Se88",
    latex: "^{88}\\mathrm{Se}",
    mass: 81907.5964671,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340880,
    name: "Se88~",
    latex: "^{88}\\mathrm{\\overline{Se}}",
    mass: 81907.5964671,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340890,
    name: "Se89",
    latex: "^{89}\\mathrm{Se}",
    mass: 82843.9827779,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340890,
    name: "Se89~",
    latex: "^{89}\\mathrm{\\overline{Se}}",
    mass: 82843.9827779,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340900,
    name: "Se90",
    latex: "^{90}\\mathrm{Se}",
    mass: 83778.6728379,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340900,
    name: "Se90~",
    latex: "^{90}\\mathrm{\\overline{Se}}",
    mass: 83778.6728379,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340910,
    name: "Se91",
    latex: "^{91}\\mathrm{Se}",
    mass: 84715.3833086,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340910,
    name: "Se91~",
    latex: "^{91}\\mathrm{\\overline{Se}}",
    mass: 84715.3833086,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000340920,
    name: "Se92",
    latex: "^{92}\\mathrm{Se}",
    mass: 85650.7337979,
    width: undefined,
    charge: 34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000340920,
    name: "Se92~",
    latex: "^{92}\\mathrm{\\overline{Se}}",
    mass: 85650.7337979,
    width: undefined,
    charge: -34.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350670,
    name: "Br67",
    latex: "^{67}\\mathrm{Br}",
    mass: 62377.577175,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350670,
    name: "Br67~",
    latex: "^{67}\\mathrm{\\overline{Br}}",
    mass: 62377.577175,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350680,
    name: "Br68",
    latex: "^{68}\\mathrm{Br}",
    mass: 63302.8116384,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350680,
    name: "Br68~",
    latex: "^{68}\\mathrm{\\overline{Br}}",
    mass: 63302.8116384,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350690,
    name: "Br69",
    latex: "^{69}\\mathrm{Br}",
    mass: 64226.8351594,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350690,
    name: "Br69~",
    latex: "^{69}\\mathrm{\\overline{Br}}",
    mass: 64226.8351594,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350700,
    name: "Br70",
    latex: "^{70}\\mathrm{Br}",
    mass: 65153.1613338,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350700,
    name: "Br70~",
    latex: "^{70}\\mathrm{\\overline{Br}}",
    mass: 65153.1613338,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350710,
    name: "Br71",
    latex: "^{71}\\mathrm{Br}",
    mass: 66079.5787947,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350710,
    name: "Br71~",
    latex: "^{71}\\mathrm{\\overline{Br}}",
    mass: 66079.5787947,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350720,
    name: "Br72",
    latex: "^{72}\\mathrm{Br}",
    mass: 67008.5137115,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350720,
    name: "Br72~",
    latex: "^{72}\\mathrm{\\overline{Br}}",
    mass: 67008.5137115,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350730,
    name: "Br73",
    latex: "^{73}\\mathrm{Br}",
    mass: 67935.4233738,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350730,
    name: "Br73~",
    latex: "^{73}\\mathrm{\\overline{Br}}",
    mass: 67935.4233738,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350740,
    name: "Br74",
    latex: "^{74}\\mathrm{Br}",
    mass: 68865.2752534,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350740,
    name: "Br74~",
    latex: "^{74}\\mathrm{\\overline{Br}}",
    mass: 68865.2752534,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350750,
    name: "Br75",
    latex: "^{75}\\mathrm{Br}",
    mass: 69792.9511628,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350750,
    name: "Br75~",
    latex: "^{75}\\mathrm{\\overline{Br}}",
    mass: 69792.9511628,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350760,
    name: "Br76",
    latex: "^{76}\\mathrm{Br}",
    mass: 70723.2632005,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350760,
    name: "Br76~",
    latex: "^{76}\\mathrm{\\overline{Br}}",
    mass: 70723.2632005,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350770,
    name: "Br77",
    latex: "^{77}\\mathrm{Br}",
    mass: 71651.8109884,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350770,
    name: "Br77~",
    latex: "^{77}\\mathrm{\\overline{Br}}",
    mass: 71651.8109884,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350780,
    name: "Br78",
    latex: "^{78}\\mathrm{Br}",
    mass: 72583.088054,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350780,
    name: "Br78~",
    latex: "^{78}\\mathrm{\\overline{Br}}",
    mass: 72583.088054,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350790,
    name: "Br79",
    latex: "^{79}\\mathrm{Br}",
    mass: 73511.9661497,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350790,
    name: "Br79~",
    latex: "^{79}\\mathrm{\\overline{Br}}",
    mass: 73511.9661497,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350800,
    name: "Br80",
    latex: "^{80}\\mathrm{Br}",
    mass: 74443.6392866,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350800,
    name: "Br80~",
    latex: "^{80}\\mathrm{\\overline{Br}}",
    mass: 74443.6392866,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350810,
    name: "Br81",
    latex: "^{81}\\mathrm{Br}",
    mass: 75373.0453531,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350810,
    name: "Br81~",
    latex: "^{81}\\mathrm{\\overline{Br}}",
    mass: 75373.0453531,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350820,
    name: "Br82",
    latex: "^{82}\\mathrm{Br}",
    mass: 76305.0178722,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350820,
    name: "Br82~",
    latex: "^{82}\\mathrm{\\overline{Br}}",
    mass: 76305.0178722,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350830,
    name: "Br83",
    latex: "^{83}\\mathrm{Br}",
    mass: 77234.9966213,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350830,
    name: "Br83~",
    latex: "^{83}\\mathrm{\\overline{Br}}",
    mass: 77234.9966213,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350840,
    name: "Br84",
    latex: "^{84}\\mathrm{Br}",
    mass: 78167.7212287,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350840,
    name: "Br84~",
    latex: "^{84}\\mathrm{\\overline{Br}}",
    mass: 78167.7212287,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350850,
    name: "Br85",
    latex: "^{85}\\mathrm{Br}",
    mass: 79098.4235625,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350850,
    name: "Br85~",
    latex: "^{85}\\mathrm{\\overline{Br}}",
    mass: 79098.4235625,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350860,
    name: "Br86",
    latex: "^{86}\\mathrm{Br}",
    mass: 80032.860256,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350860,
    name: "Br86~",
    latex: "^{86}\\mathrm{\\overline{Br}}",
    mass: 80032.860256,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350870,
    name: "Br87",
    latex: "^{87}\\mathrm{Br}",
    mass: 80966.0953222,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350870,
    name: "Br87~",
    latex: "^{87}\\mathrm{\\overline{Br}}",
    mass: 80966.0953222,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350880,
    name: "Br88",
    latex: "^{88}\\mathrm{Br}",
    mass: 81900.7648894,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350880,
    name: "Br88~",
    latex: "^{88}\\mathrm{\\overline{Br}}",
    mass: 81900.7648894,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350890,
    name: "Br89",
    latex: "^{89}\\mathrm{Br}",
    mass: 82834.7013706,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350890,
    name: "Br89~",
    latex: "^{89}\\mathrm{\\overline{Br}}",
    mass: 82834.7013706,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350900,
    name: "Br90",
    latex: "^{90}\\mathrm{Br}",
    mass: 83770.4691693,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350900,
    name: "Br90~",
    latex: "^{90}\\mathrm{\\overline{Br}}",
    mass: 83770.4691693,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350910,
    name: "Br91",
    latex: "^{91}\\mathrm{Br}",
    mass: 84704.8564937,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350910,
    name: "Br91~",
    latex: "^{91}\\mathrm{\\overline{Br}}",
    mass: 84704.8564937,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350920,
    name: "Br92",
    latex: "^{92}\\mathrm{Br}",
    mass: 85641.2251061,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350920,
    name: "Br92~",
    latex: "^{92}\\mathrm{\\overline{Br}}",
    mass: 85641.2251061,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350930,
    name: "Br93",
    latex: "^{93}\\mathrm{Br}",
    mass: 86576.0614106,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350930,
    name: "Br93~",
    latex: "^{93}\\mathrm{\\overline{Br}}",
    mass: 86576.0614106,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000350940,
    name: "Br94",
    latex: "^{94}\\mathrm{Br}",
    mass: 87512.7998261,
    width: undefined,
    charge: 35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000350940,
    name: "Br94~",
    latex: "^{94}\\mathrm{\\overline{Br}}",
    mass: 87512.7998261,
    width: undefined,
    charge: -35.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360690,
    name: "Kr69",
    latex: "^{69}\\mathrm{Kr}",
    mass: 64240.95661,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360690,
    name: "Kr69~",
    latex: "^{69}\\mathrm{\\overline{Kr}}",
    mass: 64240.95661,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360700,
    name: "Kr70",
    latex: "^{70}\\mathrm{Kr}",
    mass: 65163.4897404,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360700,
    name: "Kr70~",
    latex: "^{70}\\mathrm{\\overline{Kr}}",
    mass: 65163.4897404,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360710,
    name: "Kr71",
    latex: "^{71}\\mathrm{Kr}",
    mass: 66089.7581622,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360710,
    name: "Kr71~",
    latex: "^{71}\\mathrm{\\overline{Kr}}",
    mass: 66089.7581622,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360720,
    name: "Kr72",
    latex: "^{72}\\mathrm{Kr}",
    mass: 67013.6345072,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360720,
    name: "Kr72~",
    latex: "^{72}\\mathrm{\\overline{Kr}}",
    mass: 67013.6345072,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360730,
    name: "Kr73",
    latex: "^{73}\\mathrm{Kr}",
    mass: 67942.5176329,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360730,
    name: "Kr73~",
    latex: "^{73}\\mathrm{\\overline{Kr}}",
    mass: 67942.5176329,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360740,
    name: "Kr74",
    latex: "^{74}\\mathrm{Kr}",
    mass: 68868.2318157,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360740,
    name: "Kr74~",
    latex: "^{74}\\mathrm{\\overline{Kr}}",
    mass: 68868.2318157,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360750,
    name: "Kr75",
    latex: "^{75}\\mathrm{Kr}",
    mass: 69797.7343851,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360750,
    name: "Kr75~",
    latex: "^{75}\\mathrm{\\overline{Kr}}",
    mass: 69797.7343851,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360760,
    name: "Kr76",
    latex: "^{76}\\mathrm{Kr}",
    mass: 70724.538416,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360760,
    name: "Kr76~",
    latex: "^{76}\\mathrm{\\overline{Kr}}",
    mass: 70724.538416,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360770,
    name: "Kr77",
    latex: "^{77}\\mathrm{Kr}",
    mass: 71654.8765355,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360770,
    name: "Kr77~",
    latex: "^{77}\\mathrm{\\overline{Kr}}",
    mass: 71654.8765355,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360780,
    name: "Kr78",
    latex: "^{78}\\mathrm{Kr}",
    mass: 72582.361768,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360780,
    name: "Kr78~",
    latex: "^{78}\\mathrm{\\overline{Kr}}",
    mass: 72582.361768,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360790,
    name: "Kr79",
    latex: "^{79}\\mathrm{Kr}",
    mass: 73513.5919795,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360790,
    name: "Kr79~",
    latex: "^{79}\\mathrm{\\overline{Kr}}",
    mass: 73513.5919795,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360800,
    name: "Kr80",
    latex: "^{80}\\mathrm{Kr}",
    mass: 74441.6348044,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360800,
    name: "Kr80~",
    latex: "^{80}\\mathrm{\\overline{Kr}}",
    mass: 74441.6348044,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360810,
    name: "Kr81",
    latex: "^{81}\\mathrm{Kr}",
    mass: 75373.3261986,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360810,
    name: "Kr81~",
    latex: "^{81}\\mathrm{\\overline{Kr}}",
    mass: 75373.3261986,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360820,
    name: "Kr82",
    latex: "^{82}\\mathrm{Kr}",
    mass: 76301.92471,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360820,
    name: "Kr82~",
    latex: "^{82}\\mathrm{\\overline{Kr}}",
    mass: 76301.92471,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360830,
    name: "Kr83",
    latex: "^{83}\\mathrm{Kr}",
    mass: 77234.0199656,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360830,
    name: "Kr83~",
    latex: "^{83}\\mathrm{\\overline{Kr}}",
    mass: 77234.0199656,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360840,
    name: "Kr84",
    latex: "^{84}\\mathrm{Kr}",
    mass: 78163.0653669,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360840,
    name: "Kr84~",
    latex: "^{84}\\mathrm{\\overline{Kr}}",
    mass: 78163.0653669,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360850,
    name: "Kr85",
    latex: "^{85}\\mathrm{Kr}",
    mass: 79095.5185118,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360850,
    name: "Kr85~",
    latex: "^{85}\\mathrm{\\overline{Kr}}",
    mass: 79095.5185118,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360860,
    name: "Kr86",
    latex: "^{86}\\mathrm{Kr}",
    mass: 80025.227244,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360860,
    name: "Kr86~",
    latex: "^{86}\\mathrm{\\overline{Kr}}",
    mass: 80025.227244,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360870,
    name: "Kr87",
    latex: "^{87}\\mathrm{Kr}",
    mass: 80959.2774933,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360870,
    name: "Kr87~",
    latex: "^{87}\\mathrm{\\overline{Kr}}",
    mass: 80959.2774933,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360880,
    name: "Kr88",
    latex: "^{88}\\mathrm{Kr}",
    mass: 81891.7898505,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360880,
    name: "Kr88~",
    latex: "^{88}\\mathrm{\\overline{Kr}}",
    mass: 81891.7898505,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360890,
    name: "Kr89",
    latex: "^{89}\\mathrm{Kr}",
    mass: 82826.4393905,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360890,
    name: "Kr89~",
    latex: "^{89}\\mathrm{\\overline{Kr}}",
    mass: 82826.4393905,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360900,
    name: "Kr90",
    latex: "^{90}\\mathrm{Kr}",
    mass: 83759.510048,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360900,
    name: "Kr90~",
    latex: "^{90}\\mathrm{\\overline{Kr}}",
    mass: 83759.510048,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360910,
    name: "Kr91",
    latex: "^{91}\\mathrm{Kr}",
    mass: 84694.9894561,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360910,
    name: "Kr91~",
    latex: "^{91}\\mathrm{\\overline{Kr}}",
    mass: 84694.9894561,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360920,
    name: "Kr92",
    latex: "^{92}\\mathrm{Kr}",
    mass: 85628.6882201,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360920,
    name: "Kr92~",
    latex: "^{92}\\mathrm{\\overline{Kr}}",
    mass: 85628.6882201,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360930,
    name: "Kr93",
    latex: "^{93}\\mathrm{Kr}",
    mass: 86564.8156686,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360930,
    name: "Kr93~",
    latex: "^{93}\\mathrm{\\overline{Kr}}",
    mass: 86564.8156686,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360940,
    name: "Kr94",
    latex: "^{94}\\mathrm{Kr}",
    mass: 87499.0975479,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360940,
    name: "Kr94~",
    latex: "^{94}\\mathrm{\\overline{Kr}}",
    mass: 87499.0975479,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360950,
    name: "Kr95",
    latex: "^{95}\\mathrm{Kr}",
    mass: 88435.7810052,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360950,
    name: "Kr95~",
    latex: "^{95}\\mathrm{\\overline{Kr}}",
    mass: 88435.7810052,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360960,
    name: "Kr96",
    latex: "^{96}\\mathrm{Kr}",
    mass: 89370.351834,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360960,
    name: "Kr96~",
    latex: "^{96}\\mathrm{\\overline{Kr}}",
    mass: 89370.351834,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000360970,
    name: "Kr97",
    latex: "^{97}\\mathrm{Kr}",
    mass: 90307.5056959,
    width: undefined,
    charge: 36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000360970,
    name: "Kr97~",
    latex: "^{97}\\mathrm{\\overline{Kr}}",
    mass: 90307.5056959,
    width: undefined,
    charge: -36.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370710,
    name: "Rb71",
    latex: "^{71}\\mathrm{Rb}",
    mass: 66103.7957784,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370710,
    name: "Rb71~",
    latex: "^{71}\\mathrm{\\overline{Rb}}",
    mass: 66103.7957784,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370720,
    name: "Rb72",
    latex: "^{72}\\mathrm{Rb}",
    mass: 67029.2444854,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370720,
    name: "Rb72~",
    latex: "^{72}\\mathrm{\\overline{Rb}}",
    mass: 67029.2444854,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370730,
    name: "Rb73",
    latex: "^{73}\\mathrm{Rb}",
    mass: 67953.0537627,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370730,
    name: "Rb73~",
    latex: "^{73}\\mathrm{\\overline{Rb}}",
    mass: 67953.0537627,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370740,
    name: "Rb74",
    latex: "^{74}\\mathrm{Rb}",
    mass: 68878.6477828,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370740,
    name: "Rb74~",
    latex: "^{74}\\mathrm{\\overline{Rb}}",
    mass: 68878.6477828,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370750,
    name: "Rb75",
    latex: "^{75}\\mathrm{Rb}",
    mass: 69804.8390769,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370750,
    name: "Rb75~",
    latex: "^{75}\\mathrm{\\overline{Rb}}",
    mass: 69804.8390769,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370760,
    name: "Rb76",
    latex: "^{76}\\mathrm{Rb}",
    mass: 70733.0727649,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370760,
    name: "Rb76~",
    latex: "^{76}\\mathrm{\\overline{Rb}}",
    mass: 70733.0727649,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370770,
    name: "Rb77",
    latex: "^{77}\\mathrm{Rb}",
    mass: 71660.2154871,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370770,
    name: "Rb77~",
    latex: "^{77}\\mathrm{\\overline{Rb}}",
    mass: 71660.2154871,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370780,
    name: "Rb78",
    latex: "^{78}\\mathrm{Rb}",
    mass: 72589.6047867,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370780,
    name: "Rb78~",
    latex: "^{78}\\mathrm{\\overline{Rb}}",
    mass: 72589.6047867,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370790,
    name: "Rb79",
    latex: "^{79}\\mathrm{Rb}",
    mass: 73517.2314201,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370790,
    name: "Rb79~",
    latex: "^{79}\\mathrm{\\overline{Rb}}",
    mass: 73517.2314201,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370800,
    name: "Rb80",
    latex: "^{80}\\mathrm{Rb}",
    mass: 74447.352781,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370800,
    name: "Rb80~",
    latex: "^{80}\\mathrm{\\overline{Rb}}",
    mass: 74447.352781,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370810,
    name: "Rb81",
    latex: "^{81}\\mathrm{Rb}",
    mass: 75375.5657898,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370810,
    name: "Rb81~",
    latex: "^{81}\\mathrm{\\overline{Rb}}",
    mass: 75375.5657898,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370820,
    name: "Rb82",
    latex: "^{82}\\mathrm{Rb}",
    mass: 76306.3286707,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370820,
    name: "Rb82~",
    latex: "^{82}\\mathrm{\\overline{Rb}}",
    mass: 76306.3286707,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370830,
    name: "Rb83",
    latex: "^{83}\\mathrm{Rb}",
    mass: 77234.9399865,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370830,
    name: "Rb83~",
    latex: "^{83}\\mathrm{\\overline{Rb}}",
    mass: 77234.9399865,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370840,
    name: "Rb84",
    latex: "^{84}\\mathrm{Rb}",
    mass: 78165.745716,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370840,
    name: "Rb84~",
    latex: "^{84}\\mathrm{\\overline{Rb}}",
    mass: 78165.745716,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370850,
    name: "Rb85",
    latex: "^{85}\\mathrm{Rb}",
    mass: 79094.8314753,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370850,
    name: "Rb85~",
    latex: "^{85}\\mathrm{\\overline{Rb}}",
    mass: 79094.8314753,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370860,
    name: "Rb86",
    latex: "^{86}\\mathrm{Rb}",
    mass: 80025.7459139,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370860,
    name: "Rb86~",
    latex: "^{86}\\mathrm{\\overline{Rb}}",
    mass: 80025.7459139,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370870,
    name: "Rb87",
    latex: "^{87}\\mathrm{Rb}",
    mass: 80955.3892218,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370870,
    name: "Rb87~",
    latex: "^{87}\\mathrm{\\overline{Rb}}",
    mass: 80955.3892218,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370880,
    name: "Rb88",
    latex: "^{88}\\mathrm{Rb}",
    mass: 81888.8721222,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370880,
    name: "Rb88~",
    latex: "^{88}\\mathrm{\\overline{Rb}}",
    mass: 81888.8721222,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370890,
    name: "Rb89",
    latex: "^{89}\\mathrm{Rb}",
    mass: 82821.2627052,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370890,
    name: "Rb89~",
    latex: "^{89}\\mathrm{\\overline{Rb}}",
    mass: 82821.2627052,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370900,
    name: "Rb90",
    latex: "^{90}\\mathrm{Rb}",
    mass: 83755.104174,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370900,
    name: "Rb90~",
    latex: "^{90}\\mathrm{\\overline{Rb}}",
    mass: 83755.104174,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370910,
    name: "Rb91",
    latex: "^{91}\\mathrm{Rb}",
    mass: 84688.218146,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370910,
    name: "Rb91~",
    latex: "^{91}\\mathrm{\\overline{Rb}}",
    mass: 84688.218146,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370920,
    name: "Rb92",
    latex: "^{92}\\mathrm{Rb}",
    mass: 85622.6846474,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370920,
    name: "Rb92~",
    latex: "^{92}\\mathrm{\\overline{Rb}}",
    mass: 85622.6846474,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370930,
    name: "Rb93",
    latex: "^{93}\\mathrm{Rb}",
    mass: 86556.331434,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370930,
    name: "Rb93~",
    latex: "^{93}\\mathrm{\\overline{Rb}}",
    mass: 86556.331434,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370940,
    name: "Rb94",
    latex: "^{94}\\mathrm{Rb}",
    mass: 87491.8829397,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370940,
    name: "Rb94~",
    latex: "^{94}\\mathrm{\\overline{Rb}}",
    mass: 87491.8829397,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370950,
    name: "Rb95",
    latex: "^{95}\\mathrm{Rb}",
    mass: 88426.0496863,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370950,
    name: "Rb95~",
    latex: "^{95}\\mathrm{\\overline{Rb}}",
    mass: 88426.0496863,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370960,
    name: "Rb96",
    latex: "^{96}\\mathrm{Rb}",
    mass: 89362.0792349,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370960,
    name: "Rb96~",
    latex: "^{96}\\mathrm{\\overline{Rb}}",
    mass: 89362.0792349,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370970,
    name: "Rb97",
    latex: "^{97}\\mathrm{Rb}",
    mass: 90296.4088998,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370970,
    name: "Rb97~",
    latex: "^{97}\\mathrm{\\overline{Rb}}",
    mass: 90296.4088998,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370980,
    name: "Rb98",
    latex: "^{98}\\mathrm{Rb}",
    mass: 91232.0527166,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370980,
    name: "Rb98~",
    latex: "^{98}\\mathrm{\\overline{Rb}}",
    mass: 91232.0527166,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000370990,
    name: "Rb99",
    latex: "^{99}\\mathrm{Rb}",
    mass: 92166.7949402,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000370990,
    name: "Rb99~",
    latex: "^{99}\\mathrm{\\overline{Rb}}",
    mass: 92166.7949402,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000371000,
    name: "Rb100",
    latex: "^{100}\\mathrm{Rb}",
    mass: 93103.1449227,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000371000,
    name: "Rb100~",
    latex: "^{100}\\mathrm{\\overline{Rb}}",
    mass: 93103.1449227,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000371010,
    name: "Rb101",
    latex: "^{101}\\mathrm{Rb}",
    mass: 94038.337058,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000371010,
    name: "Rb101~",
    latex: "^{101}\\mathrm{\\overline{Rb}}",
    mass: 94038.337058,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000371020,
    name: "Rb102",
    latex: "^{102}\\mathrm{Rb}",
    mass: 94975.1481301,
    width: undefined,
    charge: 37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000371020,
    name: "Rb102~",
    latex: "^{102}\\mathrm{\\overline{Rb}}",
    mass: 94975.1481301,
    width: undefined,
    charge: -37.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380730,
    name: "Sr73",
    latex: "^{73}\\mathrm{Sr}",
    mass: 67967.1193237,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380730,
    name: "Sr73~",
    latex: "^{73}\\mathrm{\\overline{Sr}}",
    mass: 67967.1193237,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380740,
    name: "Sr74",
    latex: "^{74}\\mathrm{Sr}",
    mass: 68889.7362886,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380740,
    name: "Sr74~",
    latex: "^{74}\\mathrm{\\overline{Sr}}",
    mass: 68889.7362886,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380750,
    name: "Sr75",
    latex: "^{75}\\mathrm{Sr}",
    mass: 69815.436499,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380750,
    name: "Sr75~",
    latex: "^{75}\\mathrm{\\overline{Sr}}",
    mass: 69815.436499,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380760,
    name: "Sr76",
    latex: "^{76}\\mathrm{Sr}",
    mass: 70739.301666,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380760,
    name: "Sr76~",
    latex: "^{76}\\mathrm{\\overline{Sr}}",
    mass: 70739.301666,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380770,
    name: "Sr77",
    latex: "^{77}\\mathrm{Sr}",
    mass: 71667.2421197,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380770,
    name: "Sr77~",
    latex: "^{77}\\mathrm{\\overline{Sr}}",
    mass: 71667.2421197,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380780,
    name: "Sr78",
    latex: "^{78}\\mathrm{Sr}",
    mass: 72593.3661599,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380780,
    name: "Sr78~",
    latex: "^{78}\\mathrm{\\overline{Sr}}",
    mass: 72593.3661599,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380790,
    name: "Sr79",
    latex: "^{79}\\mathrm{Sr}",
    mass: 73522.5548157,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380790,
    name: "Sr79~",
    latex: "^{79}\\mathrm{\\overline{Sr}}",
    mass: 73522.5548157,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380800,
    name: "Sr80",
    latex: "^{80}\\mathrm{Sr}",
    mass: 74449.2172595,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380800,
    name: "Sr80~",
    latex: "^{80}\\mathrm{\\overline{Sr}}",
    mass: 74449.2172595,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380810,
    name: "Sr81",
    latex: "^{81}\\mathrm{Sr}",
    mass: 75379.4939005,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380810,
    name: "Sr81~",
    latex: "^{81}\\mathrm{\\overline{Sr}}",
    mass: 75379.4939005,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380820,
    name: "Sr82",
    latex: "^{82}\\mathrm{Sr}",
    mass: 76306.5065861,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380820,
    name: "Sr82~",
    latex: "^{82}\\mathrm{\\overline{Sr}}",
    mass: 76306.5065861,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380830,
    name: "Sr83",
    latex: "^{83}\\mathrm{Sr}",
    mass: 77237.2126458,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380830,
    name: "Sr83~",
    latex: "^{83}\\mathrm{\\overline{Sr}}",
    mass: 77237.2126458,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380840,
    name: "Sr84",
    latex: "^{84}\\mathrm{Sr}",
    mass: 78164.8551145,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380840,
    name: "Sr84~",
    latex: "^{84}\\mathrm{\\overline{Sr}}",
    mass: 78164.8551145,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380850,
    name: "Sr85",
    latex: "^{85}\\mathrm{Sr}",
    mass: 79095.8954875,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380850,
    name: "Sr85~",
    latex: "^{85}\\mathrm{\\overline{Sr}}",
    mass: 79095.8954875,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380860,
    name: "Sr86",
    latex: "^{86}\\mathrm{Sr}",
    mass: 80023.9698202,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380860,
    name: "Sr86~",
    latex: "^{86}\\mathrm{\\overline{Sr}}",
    mass: 80023.9698202,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380870,
    name: "Sr87",
    latex: "^{87}\\mathrm{Sr}",
    mass: 80955.1069474,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380870,
    name: "Sr87~",
    latex: "^{87}\\mathrm{\\overline{Sr}}",
    mass: 80955.1069474,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380880,
    name: "Sr88",
    latex: "^{88}\\mathrm{Sr}",
    mass: 81883.5594984,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380880,
    name: "Sr88~",
    latex: "^{88}\\mathrm{\\overline{Sr}}",
    mass: 81883.5594984,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380890,
    name: "Sr89",
    latex: "^{89}\\mathrm{Sr}",
    mass: 82816.7662062,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380890,
    name: "Sr89~",
    latex: "^{89}\\mathrm{\\overline{Sr}}",
    mass: 82816.7662062,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380900,
    name: "Sr90",
    latex: "^{90}\\mathrm{Sr}",
    mass: 83748.5184176,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380900,
    name: "Sr90~",
    latex: "^{90}\\mathrm{\\overline{Sr}}",
    mass: 83748.5184176,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380910,
    name: "Sr91",
    latex: "^{91}\\mathrm{Sr}",
    mass: 84682.3115419,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380910,
    name: "Sr91~",
    latex: "^{91}\\mathrm{\\overline{Sr}}",
    mass: 84682.3115419,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380920,
    name: "Sr92",
    latex: "^{92}\\mathrm{Sr}",
    mass: 85614.5899637,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380920,
    name: "Sr92~",
    latex: "^{92}\\mathrm{\\overline{Sr}}",
    mass: 85614.5899637,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380930,
    name: "Sr93",
    latex: "^{93}\\mathrm{Sr}",
    mass: 86548.8655088,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380930,
    name: "Sr93~",
    latex: "^{93}\\mathrm{\\overline{Sr}}",
    mass: 86548.8655088,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380940,
    name: "Sr94",
    latex: "^{94}\\mathrm{Sr}",
    mass: 87481.59999,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380940,
    name: "Sr94~",
    latex: "^{94}\\mathrm{\\overline{Sr}}",
    mass: 87481.59999,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380950,
    name: "Sr95",
    latex: "^{95}\\mathrm{Sr}",
    mass: 88416.8223058,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380950,
    name: "Sr95~",
    latex: "^{95}\\mathrm{\\overline{Sr}}",
    mass: 88416.8223058,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380960,
    name: "Sr96",
    latex: "^{96}\\mathrm{Sr}",
    mass: 89350.515667,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380960,
    name: "Sr96~",
    latex: "^{96}\\mathrm{\\overline{Sr}}",
    mass: 89350.515667,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380970,
    name: "Sr97",
    latex: "^{97}\\mathrm{Sr}",
    mass: 90286.3477388,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380970,
    name: "Sr97~",
    latex: "^{97}\\mathrm{\\overline{Sr}}",
    mass: 90286.3477388,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380980,
    name: "Sr98",
    latex: "^{98}\\mathrm{Sr}",
    mass: 91220.0001144,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380980,
    name: "Sr98~",
    latex: "^{98}\\mathrm{\\overline{Sr}}",
    mass: 91220.0001144,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000380990,
    name: "Sr99",
    latex: "^{99}\\mathrm{Sr}",
    mass: 92155.3981099,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000380990,
    name: "Sr99~",
    latex: "^{99}\\mathrm{\\overline{Sr}}",
    mass: 92155.3981099,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000381000,
    name: "Sr100",
    latex: "^{100}\\mathrm{Sr}",
    mass: 93089.592615,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000381000,
    name: "Sr100~",
    latex: "^{100}\\mathrm{\\overline{Sr}}",
    mass: 93089.592615,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000381010,
    name: "Sr101",
    latex: "^{101}\\mathrm{Sr}",
    mass: 94025.5793148,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000381010,
    name: "Sr101~",
    latex: "^{101}\\mathrm{\\overline{Sr}}",
    mass: 94025.5793148,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000381020,
    name: "Sr102",
    latex: "^{102}\\mathrm{Sr}",
    mass: 94960.2349095,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000381020,
    name: "Sr102~",
    latex: "^{102}\\mathrm{\\overline{Sr}}",
    mass: 94960.2349095,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000381030,
    name: "Sr103",
    latex: "^{103}\\mathrm{Sr}",
    mass: 95896.6100423,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000381030,
    name: "Sr103~",
    latex: "^{103}\\mathrm{\\overline{Sr}}",
    mass: 95896.6100423,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000381040,
    name: "Sr104",
    latex: "^{104}\\mathrm{Sr}",
    mass: 96831.6251937,
    width: undefined,
    charge: 38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000381040,
    name: "Sr104~",
    latex: "^{104}\\mathrm{\\overline{Sr}}",
    mass: 96831.6251937,
    width: undefined,
    charge: -38.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390770,
    name: "Y77",
    latex: "^{77}\\mathrm{Y}",
    mass: 71678.6110053,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390770,
    name: "Y77~",
    latex: "^{77}\\mathrm{\\overline{Y}}",
    mass: 71678.6110053,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390780,
    name: "Y78",
    latex: "^{78}\\mathrm{Y}",
    mass: 72604.3671053,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390780,
    name: "Y78~",
    latex: "^{78}\\mathrm{\\overline{Y}}",
    mass: 72604.3671053,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390790,
    name: "Y79",
    latex: "^{79}\\mathrm{Y}",
    mass: 73530.2349846,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390790,
    name: "Y79~",
    latex: "^{79}\\mathrm{\\overline{Y}}",
    mass: 73530.2349846,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390800,
    name: "Y80",
    latex: "^{80}\\mathrm{Y}",
    mass: 74458.380367,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390800,
    name: "Y80~",
    latex: "^{80}\\mathrm{\\overline{Y}}",
    mass: 74458.380367,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390810,
    name: "Y81",
    latex: "^{81}\\mathrm{Y}",
    mass: 75385.3092182,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390810,
    name: "Y81~",
    latex: "^{81}\\mathrm{\\overline{Y}}",
    mass: 75385.3092182,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390820,
    name: "Y82",
    latex: "^{82}\\mathrm{Y}",
    mass: 76314.4522308,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390820,
    name: "Y82~",
    latex: "^{82}\\mathrm{\\overline{Y}}",
    mass: 76314.4522308,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390830,
    name: "Y83",
    latex: "^{83}\\mathrm{Y}",
    mass: 77241.8049117,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390830,
    name: "Y83~",
    latex: "^{83}\\mathrm{\\overline{Y}}",
    mass: 77241.8049117,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390840,
    name: "Y84",
    latex: "^{84}\\mathrm{Y}",
    mass: 78171.6102166,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390840,
    name: "Y84~",
    latex: "^{84}\\mathrm{\\overline{Y}}",
    mass: 78171.6102166,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390850,
    name: "Y85",
    latex: "^{85}\\mathrm{Y}",
    mass: 79099.1566483,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390850,
    name: "Y85~",
    latex: "^{85}\\mathrm{\\overline{Y}}",
    mass: 79099.1566483,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390860,
    name: "Y86",
    latex: "^{86}\\mathrm{Y}",
    mass: 80029.2097307,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390860,
    name: "Y86~",
    latex: "^{86}\\mathrm{\\overline{Y}}",
    mass: 80029.2097307,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390870,
    name: "Y87",
    latex: "^{87}\\mathrm{Y}",
    mass: 80956.9686362,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390870,
    name: "Y87~",
    latex: "^{87}\\mathrm{\\overline{Y}}",
    mass: 80956.9686362,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390880,
    name: "Y88",
    latex: "^{88}\\mathrm{Y}",
    mass: 81887.1821218,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390880,
    name: "Y88~",
    latex: "^{88}\\mathrm{\\overline{Y}}",
    mass: 81887.1821218,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390890,
    name: "Y89",
    latex: "^{89}\\mathrm{Y}",
    mass: 82815.2640695,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390890,
    name: "Y89~",
    latex: "^{89}\\mathrm{\\overline{Y}}",
    mass: 82815.2640695,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390900,
    name: "Y90",
    latex: "^{90}\\mathrm{Y}",
    mass: 83747.9723757,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390900,
    name: "Y90~",
    latex: "^{90}\\mathrm{\\overline{Y}}",
    mass: 83747.9723757,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390910,
    name: "Y91",
    latex: "^{91}\\mathrm{Y}",
    mass: 84679.612072,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390910,
    name: "Y91~",
    latex: "^{91}\\mathrm{\\overline{Y}}",
    mass: 84679.612072,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390920,
    name: "Y92",
    latex: "^{92}\\mathrm{Y}",
    mass: 85612.641278,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390920,
    name: "Y92~",
    latex: "^{92}\\mathrm{\\overline{Y}}",
    mass: 85612.641278,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390930,
    name: "Y93",
    latex: "^{93}\\mathrm{Y}",
    mass: 86544.724086,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390930,
    name: "Y93~",
    latex: "^{93}\\mathrm{\\overline{Y}}",
    mass: 86544.724086,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390940,
    name: "Y94",
    latex: "^{94}\\mathrm{Y}",
    mass: 87478.0942188,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390940,
    name: "Y94~",
    latex: "^{94}\\mathrm{\\overline{Y}}",
    mass: 87478.0942188,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390950,
    name: "Y95",
    latex: "^{95}\\mathrm{Y}",
    mass: 88410.7321973,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390950,
    name: "Y95~",
    latex: "^{95}\\mathrm{\\overline{Y}}",
    mass: 88410.7321973,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390960,
    name: "Y96",
    latex: "^{96}\\mathrm{Y}",
    mass: 89345.1036863,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390960,
    name: "Y96~",
    latex: "^{96}\\mathrm{\\overline{Y}}",
    mass: 89345.1036863,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390970,
    name: "Y97",
    latex: "^{97}\\mathrm{Y}",
    mass: 90278.812883,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390970,
    name: "Y97~",
    latex: "^{97}\\mathrm{\\overline{Y}}",
    mass: 90278.812883,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390980,
    name: "Y98",
    latex: "^{98}\\mathrm{Y}",
    mass: 91214.1335645,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390980,
    name: "Y98~",
    latex: "^{98}\\mathrm{\\overline{Y}}",
    mass: 91214.1335645,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000390990,
    name: "Y99",
    latex: "^{99}\\mathrm{Y}",
    mass: 92147.2726868,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000390990,
    name: "Y99~",
    latex: "^{99}\\mathrm{\\overline{Y}}",
    mass: 92147.2726868,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000391000,
    name: "Y100",
    latex: "^{100}\\mathrm{Y}",
    mass: 93082.08943,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000391000,
    name: "Y100~",
    latex: "^{100}\\mathrm{\\overline{Y}}",
    mass: 93082.08943,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000391010,
    name: "Y101",
    latex: "^{101}\\mathrm{Y}",
    mass: 94015.8498589,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000391010,
    name: "Y101~",
    latex: "^{101}\\mathrm{\\overline{Y}}",
    mass: 94015.8498589,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000391020,
    name: "Y102",
    latex: "^{102}\\mathrm{Y}",
    mass: 94951.2254985,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000391020,
    name: "Y102~",
    latex: "^{102}\\mathrm{\\overline{Y}}",
    mass: 94951.2254985,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000391030,
    name: "Y103",
    latex: "^{103}\\mathrm{Y}",
    mass: 95885.435839,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000391030,
    name: "Y103~",
    latex: "^{103}\\mathrm{\\overline{Y}}",
    mass: 95885.435839,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000391040,
    name: "Y104",
    latex: "^{104}\\mathrm{Y}",
    mass: 96821.3042391,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000391040,
    name: "Y104~",
    latex: "^{104}\\mathrm{\\overline{Y}}",
    mass: 96821.3042391,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000391050,
    name: "Y105",
    latex: "^{105}\\mathrm{Y}",
    mass: 97756.3100756,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000391050,
    name: "Y105~",
    latex: "^{105}\\mathrm{\\overline{Y}}",
    mass: 97756.3100756,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000391060,
    name: "Y106",
    latex: "^{106}\\mathrm{Y}",
    mass: 98692.582744,
    width: undefined,
    charge: 39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000391060,
    name: "Y106~",
    latex: "^{106}\\mathrm{\\overline{Y}}",
    mass: 98692.582744,
    width: undefined,
    charge: -39.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400790,
    name: "Zr79",
    latex: "^{79}\\mathrm{Zr}",
    mass: 73541.2638748,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400790,
    name: "Zr79~",
    latex: "^{79}\\mathrm{\\overline{Zr}}",
    mass: 73541.2638748,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400800,
    name: "Zr80",
    latex: "^{80}\\mathrm{Zr}",
    mass: 74464.7657591,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400800,
    name: "Zr80~",
    latex: "^{80}\\mathrm{\\overline{Zr}}",
    mass: 74464.7657591,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400810,
    name: "Zr81",
    latex: "^{81}\\mathrm{Zr}",
    mass: 75393.5026403,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400810,
    name: "Zr81~",
    latex: "^{81}\\mathrm{\\overline{Zr}}",
    mass: 75393.5026403,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400820,
    name: "Zr82",
    latex: "^{82}\\mathrm{Zr}",
    mass: 76318.9024438,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400820,
    name: "Zr82~",
    latex: "^{82}\\mathrm{\\overline{Zr}}",
    mass: 76318.9024438,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400830,
    name: "Zr83",
    latex: "^{83}\\mathrm{Zr}",
    mass: 77248.0990174,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400830,
    name: "Zr83~",
    latex: "^{83}\\mathrm{\\overline{Zr}}",
    mass: 77248.0990174,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400840,
    name: "Zr84",
    latex: "^{84}\\mathrm{Zr}",
    mass: 78174.0833335,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400840,
    name: "Zr84~",
    latex: "^{84}\\mathrm{\\overline{Zr}}",
    mass: 78174.0833335,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400850,
    name: "Zr85",
    latex: "^{85}\\mathrm{Zr}",
    mass: 79103.8234338,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400850,
    name: "Zr85~",
    latex: "^{85}\\mathrm{\\overline{Zr}}",
    mass: 79103.8234338,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400860,
    name: "Zr86",
    latex: "^{86}\\mathrm{Zr}",
    mass: 80030.5240688,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400860,
    name: "Zr86~",
    latex: "^{86}\\mathrm{\\overline{Zr}}",
    mass: 80030.5240688,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400870,
    name: "Zr87",
    latex: "^{87}\\mathrm{Zr}",
    mass: 80960.6395613,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400870,
    name: "Zr87~",
    latex: "^{87}\\mathrm{\\overline{Zr}}",
    mass: 80960.6395613,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400880,
    name: "Zr88",
    latex: "^{88}\\mathrm{Zr}",
    mass: 81887.8525181,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400880,
    name: "Zr88~",
    latex: "^{88}\\mathrm{\\overline{Zr}}",
    mass: 81887.8525181,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400890,
    name: "Zr89",
    latex: "^{89}\\mathrm{Zr}",
    mass: 82818.0973019,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400890,
    name: "Zr89~",
    latex: "^{89}\\mathrm{\\overline{Zr}}",
    mass: 82818.0973019,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400900,
    name: "Zr90",
    latex: "^{90}\\mathrm{Zr}",
    mass: 83745.6967915,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400900,
    name: "Zr90~",
    latex: "^{90}\\mathrm{\\overline{Zr}}",
    mass: 83745.6967915,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400910,
    name: "Zr91",
    latex: "^{91}\\mathrm{Zr}",
    mass: 84678.0678504,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400910,
    name: "Zr91~",
    latex: "^{91}\\mathrm{\\overline{Zr}}",
    mass: 84678.0678504,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400920,
    name: "Zr92",
    latex: "^{92}\\mathrm{Zr}",
    mass: 85608.9985213,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400920,
    name: "Zr92~",
    latex: "^{92}\\mathrm{\\overline{Zr}}",
    mass: 85608.9985213,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400930,
    name: "Zr93",
    latex: "^{93}\\mathrm{Zr}",
    mass: 86541.8296544,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400930,
    name: "Zr93~",
    latex: "^{93}\\mathrm{\\overline{Zr}}",
    mass: 86541.8296544,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400940,
    name: "Zr94",
    latex: "^{94}\\mathrm{Zr}",
    mass: 87473.1764143,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400940,
    name: "Zr94~",
    latex: "^{94}\\mathrm{\\overline{Zr}}",
    mass: 87473.1764143,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400950,
    name: "Zr95",
    latex: "^{95}\\mathrm{Zr}",
    mass: 88406.2799349,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400950,
    name: "Zr95~",
    latex: "^{95}\\mathrm{\\overline{Zr}}",
    mass: 88406.2799349,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400960,
    name: "Zr96",
    latex: "^{96}\\mathrm{Zr}",
    mass: 89337.9951008,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400960,
    name: "Zr96~",
    latex: "^{96}\\mathrm{\\overline{Zr}}",
    mass: 89337.9951008,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400970,
    name: "Zr97",
    latex: "^{97}\\mathrm{Zr}",
    mass: 90271.9913654,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400970,
    name: "Zr97~",
    latex: "^{97}\\mathrm{\\overline{Zr}}",
    mass: 90271.9913654,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400980,
    name: "Zr98",
    latex: "^{98}\\mathrm{Zr}",
    mass: 91205.1399889,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400980,
    name: "Zr98~",
    latex: "^{98}\\mathrm{\\overline{Zr}}",
    mass: 91205.1399889,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000400990,
    name: "Zr99",
    latex: "^{99}\\mathrm{Zr}",
    mass: 92140.2995219,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000400990,
    name: "Zr99~",
    latex: "^{99}\\mathrm{\\overline{Zr}}",
    mass: 92140.2995219,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000401000,
    name: "Zr100",
    latex: "^{100}\\mathrm{Zr}",
    mass: 93073.0371703,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000401000,
    name: "Zr100~",
    latex: "^{100}\\mathrm{\\overline{Zr}}",
    mass: 93073.0371703,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000401010,
    name: "Zr101",
    latex: "^{101}\\mathrm{Zr}",
    mass: 94007.7430657,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000401010,
    name: "Zr101~",
    latex: "^{101}\\mathrm{\\overline{Zr}}",
    mass: 94007.7430657,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000401020,
    name: "Zr102",
    latex: "^{102}\\mathrm{Zr}",
    mass: 94940.8169834,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000401020,
    name: "Zr102~",
    latex: "^{102}\\mathrm{\\overline{Zr}}",
    mass: 94940.8169834,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000401030,
    name: "Zr103",
    latex: "^{103}\\mathrm{Zr}",
    mass: 95876.0836382,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000401030,
    name: "Zr103~",
    latex: "^{103}\\mathrm{\\overline{Zr}}",
    mass: 95876.0836382,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000401040,
    name: "Zr104",
    latex: "^{104}\\mathrm{Zr}",
    mass: 96809.6689462,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000401040,
    name: "Zr104~",
    latex: "^{104}\\mathrm{\\overline{Zr}}",
    mass: 96809.6689462,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000401050,
    name: "Zr105",
    latex: "^{105}\\mathrm{Zr}",
    mass: 97745.4227725,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000401050,
    name: "Zr105~",
    latex: "^{105}\\mathrm{\\overline{Zr}}",
    mass: 97745.4227725,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000401060,
    name: "Zr106",
    latex: "^{106}\\mathrm{Zr}",
    mass: 98679.625661,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000401060,
    name: "Zr106~",
    latex: "^{106}\\mathrm{\\overline{Zr}}",
    mass: 98679.625661,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000401070,
    name: "Zr107",
    latex: "^{107}\\mathrm{Zr}",
    mass: 99615.8517548,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000401070,
    name: "Zr107~",
    latex: "^{107}\\mathrm{\\overline{Zr}}",
    mass: 99615.8517548,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000401080,
    name: "Zr108",
    latex: "^{108}\\mathrm{Zr}",
    mass: 100550.4104741,
    width: undefined,
    charge: 40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000401080,
    name: "Zr108~",
    latex: "^{108}\\mathrm{\\overline{Zr}}",
    mass: 100550.4104741,
    width: undefined,
    charge: -40.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410810,
    name: "Nb81",
    latex: "^{81}\\mathrm{Nb}",
    mass: 75404.6619397,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410810,
    name: "Nb81~",
    latex: "^{81}\\mathrm{\\overline{Nb}}",
    mass: 75404.6619397,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410820,
    name: "Nb82",
    latex: "^{82}\\mathrm{Nb}",
    mass: 76330.7068029,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410820,
    name: "Nb82~",
    latex: "^{82}\\mathrm{\\overline{Nb}}",
    mass: 76330.7068029,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410830,
    name: "Nb83",
    latex: "^{83}\\mathrm{Nb}",
    mass: 77256.3976983,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410830,
    name: "Nb83~",
    latex: "^{83}\\mathrm{\\overline{Nb}}",
    mass: 77256.3976983,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410840,
    name: "Nb84",
    latex: "^{84}\\mathrm{Nb}",
    mass: 78184.3108593,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410840,
    name: "Nb84~",
    latex: "^{84}\\mathrm{\\overline{Nb}}",
    mass: 78184.3108593,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410850,
    name: "Nb85",
    latex: "^{85}\\mathrm{Nb}",
    mass: 79110.7192846,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410850,
    name: "Nb85~",
    latex: "^{85}\\mathrm{\\overline{Nb}}",
    mass: 79110.7192846,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410860,
    name: "Nb86",
    latex: "^{86}\\mathrm{Nb}",
    mass: 80039.3592904,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410860,
    name: "Nb86~",
    latex: "^{86}\\mathrm{\\overline{Nb}}",
    mass: 80039.3592904,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410870,
    name: "Nb87",
    latex: "^{87}\\mathrm{Nb}",
    mass: 80966.1120891,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410870,
    name: "Nb87~",
    latex: "^{87}\\mathrm{\\overline{Nb}}",
    mass: 80966.1120891,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410880,
    name: "Nb88",
    latex: "^{88}\\mathrm{Nb}",
    mass: 81895.3128544,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410880,
    name: "Nb88~",
    latex: "^{88}\\mathrm{\\overline{Nb}}",
    mass: 81895.3128544,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410890,
    name: "Nb89",
    latex: "^{89}\\mathrm{Nb}",
    mass: 82822.3497588,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410890,
    name: "Nb89~",
    latex: "^{89}\\mathrm{\\overline{Nb}}",
    mass: 82822.3497588,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410900,
    name: "Nb90",
    latex: "^{90}\\mathrm{Nb}",
    mass: 83751.8076164,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410900,
    name: "Nb90~",
    latex: "^{90}\\mathrm{\\overline{Nb}}",
    mass: 83751.8076164,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410910,
    name: "Nb91",
    latex: "^{91}\\mathrm{Nb}",
    mass: 84679.3251718,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410910,
    name: "Nb91~",
    latex: "^{91}\\mathrm{\\overline{Nb}}",
    mass: 84679.3251718,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410920,
    name: "Nb92",
    latex: "^{92}\\mathrm{Nb}",
    mass: 85611.0042703,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410920,
    name: "Nb92~",
    latex: "^{92}\\mathrm{\\overline{Nb}}",
    mass: 85611.0042703,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410930,
    name: "Nb93",
    latex: "^{93}\\mathrm{Nb}",
    mass: 86541.7388337,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410930,
    name: "Nb93~",
    latex: "^{93}\\mathrm{\\overline{Nb}}",
    mass: 86541.7388337,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410940,
    name: "Nb94",
    latex: "^{94}\\mathrm{Nb}",
    mass: 87474.0766848,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410940,
    name: "Nb94~",
    latex: "^{94}\\mathrm{\\overline{Nb}}",
    mass: 87474.0766848,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410950,
    name: "Nb95",
    latex: "^{95}\\mathrm{Nb}",
    mass: 88405.1535723,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410950,
    name: "Nb95~",
    latex: "^{95}\\mathrm{\\overline{Nb}}",
    mass: 88405.1535723,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410960,
    name: "Nb96",
    latex: "^{96}\\mathrm{Nb}",
    mass: 89337.8311299,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410960,
    name: "Nb96~",
    latex: "^{96}\\mathrm{\\overline{Nb}}",
    mass: 89337.8311299,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410970,
    name: "Nb97",
    latex: "^{97}\\mathrm{Nb}",
    mass: 90269.3256156,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410970,
    name: "Nb97~",
    latex: "^{97}\\mathrm{\\overline{Nb}}",
    mass: 90269.3256156,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410980,
    name: "Nb98",
    latex: "^{98}\\mathrm{Nb}",
    mass: 91202.8978826,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410980,
    name: "Nb98~",
    latex: "^{98}\\mathrm{\\overline{Nb}}",
    mass: 91202.8978826,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000410990,
    name: "Nb99",
    latex: "^{99}\\mathrm{Nb}",
    mass: 92135.5805728,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000410990,
    name: "Nb99~",
    latex: "^{99}\\mathrm{\\overline{Nb}}",
    mass: 92135.5805728,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000411000,
    name: "Nb100",
    latex: "^{100}\\mathrm{Nb}",
    mass: 93069.6195184,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000411000,
    name: "Nb100~",
    latex: "^{100}\\mathrm{\\overline{Nb}}",
    mass: 93069.6195184,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000411010,
    name: "Nb101",
    latex: "^{101}\\mathrm{Nb}",
    mass: 94002.0134454,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000411010,
    name: "Nb101~",
    latex: "^{101}\\mathrm{\\overline{Nb}}",
    mass: 94002.0134454,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000411020,
    name: "Nb102",
    latex: "^{102}\\mathrm{Nb}",
    mass: 94936.1002699,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000411020,
    name: "Nb102~",
    latex: "^{102}\\mathrm{\\overline{Nb}}",
    mass: 94936.1002699,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000411030,
    name: "Nb103",
    latex: "^{103}\\mathrm{Nb}",
    mass: 95868.8636274,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000411030,
    name: "Nb103~",
    latex: "^{103}\\mathrm{\\overline{Nb}}",
    mass: 95868.8636274,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000411040,
    name: "Nb104",
    latex: "^{104}\\mathrm{Nb}",
    mass: 96803.5757638,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000411040,
    name: "Nb104~",
    latex: "^{104}\\mathrm{\\overline{Nb}}",
    mass: 96803.5757638,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000411050,
    name: "Nb105",
    latex: "^{105}\\mathrm{Nb}",
    mass: 97736.9657375,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000411050,
    name: "Nb105~",
    latex: "^{105}\\mathrm{\\overline{Nb}}",
    mass: 97736.9657375,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000411060,
    name: "Nb106",
    latex: "^{106}\\mathrm{Nb}",
    mass: 98672.172311,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000411060,
    name: "Nb106~",
    latex: "^{106}\\mathrm{\\overline{Nb}}",
    mass: 98672.172311,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000411070,
    name: "Nb107",
    latex: "^{107}\\mathrm{Nb}",
    mass: 99606.1455863,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000411070,
    name: "Nb107~",
    latex: "^{107}\\mathrm{\\overline{Nb}}",
    mass: 99606.1455863,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000411080,
    name: "Nb108",
    latex: "^{108}\\mathrm{Nb}",
    mass: 100541.8183725,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000411080,
    name: "Nb108~",
    latex: "^{108}\\mathrm{\\overline{Nb}}",
    mass: 100541.8183725,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000411090,
    name: "Nb109",
    latex: "^{109}\\mathrm{Nb}",
    mass: 101476.1665742,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000411090,
    name: "Nb109~",
    latex: "^{109}\\mathrm{\\overline{Nb}}",
    mass: 101476.1665742,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000411100,
    name: "Nb110",
    latex: "^{110}\\mathrm{Nb}",
    mass: 102412.0387002,
    width: undefined,
    charge: 41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000411100,
    name: "Nb110~",
    latex: "^{110}\\mathrm{\\overline{Nb}}",
    mass: 102412.0387002,
    width: undefined,
    charge: -41.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420830,
    name: "Mo83",
    latex: "^{83}\\mathrm{Mo}",
    mass: 77267.668777,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420830,
    name: "Mo83~",
    latex: "^{83}\\mathrm{\\overline{Mo}}",
    mass: 77267.668777,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420840,
    name: "Mo84",
    latex: "^{84}\\mathrm{Mo}",
    mass: 78191.3383302,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420840,
    name: "Mo84~",
    latex: "^{84}\\mathrm{\\overline{Mo}}",
    mass: 78191.3383302,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420850,
    name: "Mo85",
    latex: "^{85}\\mathrm{Mo}",
    mass: 79119.4893016,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420850,
    name: "Mo85~",
    latex: "^{85}\\mathrm{\\overline{Mo}}",
    mass: 79119.4893016,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420860,
    name: "Mo86",
    latex: "^{86}\\mathrm{Mo}",
    mass: 80044.3819066,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420860,
    name: "Mo86~",
    latex: "^{86}\\mathrm{\\overline{Mo}}",
    mass: 80044.3819066,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420870,
    name: "Mo87",
    latex: "^{87}\\mathrm{Mo}",
    mass: 80973.1020209,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420870,
    name: "Mo87~",
    latex: "^{87}\\mathrm{\\overline{Mo}}",
    mass: 80973.1020209,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420880,
    name: "Mo88",
    latex: "^{88}\\mathrm{Mo}",
    mass: 81898.7947793,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420880,
    name: "Mo88~",
    latex: "^{88}\\mathrm{\\overline{Mo}}",
    mass: 81898.7947793,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420890,
    name: "Mo89",
    latex: "^{89}\\mathrm{Mo}",
    mass: 82827.9601478,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420890,
    name: "Mo89~",
    latex: "^{89}\\mathrm{\\overline{Mo}}",
    mass: 82827.9601478,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420900,
    name: "Mo90",
    latex: "^{90}\\mathrm{Mo}",
    mass: 83754.2965687,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420900,
    name: "Mo90~",
    latex: "^{90}\\mathrm{\\overline{Mo}}",
    mass: 83754.2965687,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420910,
    name: "Mo91",
    latex: "^{91}\\mathrm{Mo}",
    mass: 84683.7544263,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420910,
    name: "Mo91~",
    latex: "^{91}\\mathrm{\\overline{Mo}}",
    mass: 84683.7544263,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420920,
    name: "Mo92",
    latex: "^{92}\\mathrm{Mo}",
    mass: 85610.6489518,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420920,
    name: "Mo92~",
    latex: "^{92}\\mathrm{\\overline{Mo}}",
    mass: 85610.6489518,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420930,
    name: "Mo93",
    latex: "^{93}\\mathrm{Mo}",
    mass: 86542.1445646,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420930,
    name: "Mo93~",
    latex: "^{93}\\mathrm{\\overline{Mo}}",
    mass: 86542.1445646,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420940,
    name: "Mo94",
    latex: "^{94}\\mathrm{Mo}",
    mass: 87472.0316733,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420940,
    name: "Mo94~",
    latex: "^{94}\\mathrm{\\overline{Mo}}",
    mass: 87472.0316733,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420950,
    name: "Mo95",
    latex: "^{95}\\mathrm{Mo}",
    mass: 88404.2279838,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420950,
    name: "Mo95~",
    latex: "^{95}\\mathrm{\\overline{Mo}}",
    mass: 88404.2279838,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420960,
    name: "Mo96",
    latex: "^{96}\\mathrm{Mo}",
    mass: 89334.6390673,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420960,
    name: "Mo96~",
    latex: "^{96}\\mathrm{\\overline{Mo}}",
    mass: 89334.6390673,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420970,
    name: "Mo97",
    latex: "^{97}\\mathrm{Mo}",
    mass: 90267.3833572,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420970,
    name: "Mo97~",
    latex: "^{97}\\mathrm{\\overline{Mo}}",
    mass: 90267.3833572,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420980,
    name: "Mo98",
    latex: "^{98}\\mathrm{Mo}",
    mass: 91198.3061849,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420980,
    name: "Mo98~",
    latex: "^{98}\\mathrm{\\overline{Mo}}",
    mass: 91198.3061849,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000420990,
    name: "Mo99",
    latex: "^{99}\\mathrm{Mo}",
    mass: 92131.9461623,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000420990,
    name: "Mo99~",
    latex: "^{99}\\mathrm{\\overline{Mo}}",
    mass: 92131.9461623,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421000,
    name: "Mo100",
    latex: "^{100}\\mathrm{Mo}",
    mass: 93063.2173595,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421000,
    name: "Mo100~",
    latex: "^{100}\\mathrm{\\overline{Mo}}",
    mass: 93063.2173595,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421010,
    name: "Mo101",
    latex: "^{101}\\mathrm{Mo}",
    mass: 93997.3844787,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421010,
    name: "Mo101~",
    latex: "^{101}\\mathrm{\\overline{Mo}}",
    mass: 93997.3844787,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421020,
    name: "Mo102",
    latex: "^{102}\\mathrm{Mo}",
    mass: 94928.8379692,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421020,
    name: "Mo102~",
    latex: "^{102}\\mathrm{\\overline{Mo}}",
    mass: 94928.8379692,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421030,
    name: "Mo103",
    latex: "^{103}\\mathrm{Mo}",
    mass: 95862.9383934,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421030,
    name: "Mo103~",
    latex: "^{103}\\mathrm{\\overline{Mo}}",
    mass: 95862.9383934,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421040,
    name: "Mo104",
    latex: "^{104}\\mathrm{Mo}",
    mass: 96795.0426258,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421040,
    name: "Mo104~",
    latex: "^{104}\\mathrm{\\overline{Mo}}",
    mass: 96795.0426258,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421050,
    name: "Mo105",
    latex: "^{105}\\mathrm{Mo}",
    mass: 97729.5501129,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421050,
    name: "Mo105~",
    latex: "^{105}\\mathrm{\\overline{Mo}}",
    mass: 97729.5501129,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421060,
    name: "Mo106",
    latex: "^{106}\\mathrm{Mo}",
    mass: 98662.2467756,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421060,
    name: "Mo106~",
    latex: "^{106}\\mathrm{\\overline{Mo}}",
    mass: 98662.2467756,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421070,
    name: "Mo107",
    latex: "^{107}\\mathrm{Mo}",
    mass: 99597.3243371,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421070,
    name: "Mo107~",
    latex: "^{107}\\mathrm{\\overline{Mo}}",
    mass: 99597.3243371,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421080,
    name: "Mo108",
    latex: "^{108}\\mathrm{Mo}",
    mass: 100530.6143614,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421080,
    name: "Mo108~",
    latex: "^{108}\\mathrm{\\overline{Mo}}",
    mass: 100530.6143614,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421090,
    name: "Mo109",
    latex: "^{109}\\mathrm{Mo}",
    mass: 101466.1977243,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421090,
    name: "Mo109~",
    latex: "^{109}\\mathrm{\\overline{Mo}}",
    mass: 101466.1977243,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421100,
    name: "Mo110",
    latex: "^{110}\\mathrm{Mo}",
    mass: 102399.8156345,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421100,
    name: "Mo110~",
    latex: "^{110}\\mathrm{\\overline{Mo}}",
    mass: 102399.8156345,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421110,
    name: "Mo111",
    latex: "^{111}\\mathrm{Mo}",
    mass: 103335.9057302,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421110,
    name: "Mo111~",
    latex: "^{111}\\mathrm{\\overline{Mo}}",
    mass: 103335.9057302,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421120,
    name: "Mo112",
    latex: "^{112}\\mathrm{Mo}",
    mass: 104269.8571153,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421120,
    name: "Mo112~",
    latex: "^{112}\\mathrm{\\overline{Mo}}",
    mass: 104269.8571153,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000421130,
    name: "Mo113",
    latex: "^{113}\\mathrm{Mo}",
    mass: 105206.1856735,
    width: undefined,
    charge: 42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000421130,
    name: "Mo113~",
    latex: "^{113}\\mathrm{\\overline{Mo}}",
    mass: 105206.1856735,
    width: undefined,
    charge: -42.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430850,
    name: "Tc85",
    latex: "^{85}\\mathrm{Tc}",
    mass: 79131.1506763,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430850,
    name: "Tc85~",
    latex: "^{85}\\mathrm{\\overline{Tc}}",
    mass: 79131.1506763,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430860,
    name: "Tc86",
    latex: "^{86}\\mathrm{Tc}",
    mass: 80056.9254062,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430860,
    name: "Tc86~",
    latex: "^{86}\\mathrm{\\overline{Tc}}",
    mass: 80056.9254062,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430870,
    name: "Tc87",
    latex: "^{87}\\mathrm{Tc}",
    mass: 80982.2967992,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430870,
    name: "Tc87~",
    latex: "^{87}\\mathrm{\\overline{Tc}}",
    mass: 80982.2967992,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430880,
    name: "Tc88",
    latex: "^{88}\\mathrm{Tc}",
    mass: 81909.8106286,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430880,
    name: "Tc88~",
    latex: "^{88}\\mathrm{\\overline{Tc}}",
    mass: 81909.8106286,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430890,
    name: "Tc89",
    latex: "^{89}\\mathrm{Tc}",
    mass: 82835.5807011,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430890,
    name: "Tc89~",
    latex: "^{89}\\mathrm{\\overline{Tc}}",
    mass: 82835.5807011,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430900,
    name: "Tc90",
    latex: "^{90}\\mathrm{Tc}",
    mass: 83763.7446202,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430900,
    name: "Tc90~",
    latex: "^{90}\\mathrm{\\overline{Tc}}",
    mass: 83763.7446202,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430910,
    name: "Tc91",
    latex: "^{91}\\mathrm{Tc}",
    mass: 84689.9768069,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430910,
    name: "Tc91~",
    latex: "^{91}\\mathrm{\\overline{Tc}}",
    mass: 84689.9768069,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430920,
    name: "Tc92",
    latex: "^{92}\\mathrm{Tc}",
    mass: 85618.5320467,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430920,
    name: "Tc92~",
    latex: "^{92}\\mathrm{\\overline{Tc}}",
    mass: 85618.5320467,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430930,
    name: "Tc93",
    latex: "^{93}\\mathrm{Tc}",
    mass: 86545.3454857,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430930,
    name: "Tc93~",
    latex: "^{93}\\mathrm{\\overline{Tc}}",
    mass: 86545.3454857,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430940,
    name: "Tc94",
    latex: "^{94}\\mathrm{Tc}",
    mass: 87476.2871203,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430940,
    name: "Tc94~",
    latex: "^{94}\\mathrm{\\overline{Tc}}",
    mass: 87476.2871203,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430950,
    name: "Tc95",
    latex: "^{95}\\mathrm{Tc}",
    mass: 88405.9182358,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430950,
    name: "Tc95~",
    latex: "^{95}\\mathrm{\\overline{Tc}}",
    mass: 88405.9182358,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430960,
    name: "Tc96",
    latex: "^{96}\\mathrm{Tc}",
    mass: 89337.6126107,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430960,
    name: "Tc96~",
    latex: "^{96}\\mathrm{\\overline{Tc}}",
    mass: 89337.6126107,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430970,
    name: "Tc97",
    latex: "^{97}\\mathrm{Tc}",
    mass: 90267.7038843,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430970,
    name: "Tc97~",
    latex: "^{97}\\mathrm{\\overline{Tc}}",
    mass: 90267.7038843,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430980,
    name: "Tc98",
    latex: "^{98}\\mathrm{Tc}",
    mass: 91199.989758,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430980,
    name: "Tc98~",
    latex: "^{98}\\mathrm{\\overline{Tc}}",
    mass: 91199.989758,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000430990,
    name: "Tc99",
    latex: "^{99}\\mathrm{Tc}",
    mass: 92130.5884165,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000430990,
    name: "Tc99~",
    latex: "^{99}\\mathrm{\\overline{Tc}}",
    mass: 92130.5884165,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431000,
    name: "Tc100",
    latex: "^{100}\\mathrm{Tc}",
    mass: 93063.3894064,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431000,
    name: "Tc100~",
    latex: "^{100}\\mathrm{\\overline{Tc}}",
    mass: 93063.3894064,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431010,
    name: "Tc101",
    latex: "^{101}\\mathrm{Tc}",
    mass: 93994.5596296,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431010,
    name: "Tc101~",
    latex: "^{101}\\mathrm{\\overline{Tc}}",
    mass: 93994.5596296,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431020,
    name: "Tc102",
    latex: "^{102}\\mathrm{Tc}",
    mass: 94927.8254351,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431020,
    name: "Tc102~",
    latex: "^{102}\\mathrm{\\overline{Tc}}",
    mass: 94927.8254351,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431030,
    name: "Tc103",
    latex: "^{103}\\mathrm{Tc}",
    mass: 95859.2887995,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431030,
    name: "Tc103~",
    latex: "^{103}\\mathrm{\\overline{Tc}}",
    mass: 95859.2887995,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431040,
    name: "Tc104",
    latex: "^{104}\\mathrm{Tc}",
    mass: 96792.8880799,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431040,
    name: "Tc104~",
    latex: "^{104}\\mathrm{\\overline{Tc}}",
    mass: 96792.8880799,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431050,
    name: "Tc105",
    latex: "^{105}\\mathrm{Tc}",
    mass: 97724.5927013,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431050,
    name: "Tc105~",
    latex: "^{105}\\mathrm{\\overline{Tc}}",
    mass: 97724.5927013,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431060,
    name: "Tc106",
    latex: "^{106}\\mathrm{Tc}",
    mass: 98658.5990446,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431060,
    name: "Tc106~",
    latex: "^{106}\\mathrm{\\overline{Tc}}",
    mass: 98658.5990446,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431070,
    name: "Tc107",
    latex: "^{107}\\mathrm{Tc}",
    mass: 99591.1187234,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431070,
    name: "Tc107~",
    latex: "^{107}\\mathrm{\\overline{Tc}}",
    mass: 99591.1187234,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431080,
    name: "Tc108",
    latex: "^{108}\\mathrm{Tc}",
    mass: 100525.4399117,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431080,
    name: "Tc108~",
    latex: "^{108}\\mathrm{\\overline{Tc}}",
    mass: 100525.4399117,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431090,
    name: "Tc109",
    latex: "^{109}\\mathrm{Tc}",
    mass: 101458.5743765,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431090,
    name: "Tc109~",
    latex: "^{109}\\mathrm{\\overline{Tc}}",
    mass: 101458.5743765,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431100,
    name: "Tc110",
    latex: "^{110}\\mathrm{Tc}",
    mass: 102393.3166002,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431100,
    name: "Tc110~",
    latex: "^{110}\\mathrm{\\overline{Tc}}",
    mass: 102393.3166002,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431110,
    name: "Tc111",
    latex: "^{111}\\mathrm{Tc}",
    mass: 103326.8208682,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431110,
    name: "Tc111~",
    latex: "^{111}\\mathrm{\\overline{Tc}}",
    mass: 103326.8208682,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431120,
    name: "Tc112",
    latex: "^{112}\\mathrm{Tc}",
    mass: 104262.0810026,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431120,
    name: "Tc112~",
    latex: "^{112}\\mathrm{\\overline{Tc}}",
    mass: 104262.0810026,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431130,
    name: "Tc113",
    latex: "^{113}\\mathrm{Tc}",
    mass: 105196.0221413,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431130,
    name: "Tc113~",
    latex: "^{113}\\mathrm{\\overline{Tc}}",
    mass: 105196.0221413,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431140,
    name: "Tc114",
    latex: "^{114}\\mathrm{Tc}",
    mass: 106131.7275299,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431140,
    name: "Tc114~",
    latex: "^{114}\\mathrm{\\overline{Tc}}",
    mass: 106131.7275299,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000431150,
    name: "Tc115",
    latex: "^{115}\\mathrm{Tc}",
    mass: 107066.0254308,
    width: undefined,
    charge: 43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000431150,
    name: "Tc115~",
    latex: "^{115}\\mathrm{\\overline{Tc}}",
    mass: 107066.0254308,
    width: undefined,
    charge: -43.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440870,
    name: "Ru87",
    latex: "^{87}\\mathrm{Ru}",
    mass: 80994.259978,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440870,
    name: "Ru87~",
    latex: "^{87}\\mathrm{\\overline{Ru}}",
    mass: 80994.259978,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440880,
    name: "Ru88",
    latex: "^{88}\\mathrm{Ru}",
    mass: 81917.1377612,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440880,
    name: "Ru88~",
    latex: "^{88}\\mathrm{\\overline{Ru}}",
    mass: 81917.1377612,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440890,
    name: "Ru89",
    latex: "^{89}\\mathrm{Ru}",
    mass: 82844.6059474,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440890,
    name: "Ru89~",
    latex: "^{89}\\mathrm{\\overline{Ru}}",
    mass: 82844.6059474,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440900,
    name: "Ru90",
    latex: "^{90}\\mathrm{Ru}",
    mass: 83769.5851814,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440900,
    name: "Ru90~",
    latex: "^{90}\\mathrm{\\overline{Ru}}",
    mass: 83769.5851814,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440910,
    name: "Ru91",
    latex: "^{91}\\mathrm{Ru}",
    mass: 84697.7235776,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440910,
    name: "Ru91~",
    latex: "^{91}\\mathrm{\\overline{Ru}}",
    mass: 84697.7235776,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440920,
    name: "Ru92",
    latex: "^{92}\\mathrm{Ru}",
    mass: 85623.156356,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440920,
    name: "Ru92~",
    latex: "^{92}\\mathrm{\\overline{Ru}}",
    mass: 85623.156356,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440930,
    name: "Ru93",
    latex: "^{93}\\mathrm{Ru}",
    mass: 86551.7348832,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440930,
    name: "Ru93~",
    latex: "^{93}\\mathrm{\\overline{Ru}}",
    mass: 86551.7348832,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440940,
    name: "Ru94",
    latex: "^{94}\\mathrm{Ru}",
    mass: 87477.8622768,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440940,
    name: "Ru94~",
    latex: "^{94}\\mathrm{\\overline{Ru}}",
    mass: 87477.8622768,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440950,
    name: "Ru95",
    latex: "^{95}\\mathrm{Ru}",
    mass: 88408.4817075,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440950,
    name: "Ru95~",
    latex: "^{95}\\mathrm{\\overline{Ru}}",
    mass: 88408.4817075,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440960,
    name: "Ru96",
    latex: "^{96}\\mathrm{Ru}",
    mass: 89337.3535715,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440960,
    name: "Ru96~",
    latex: "^{96}\\mathrm{\\overline{Ru}}",
    mass: 89337.3535715,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440970,
    name: "Ru97",
    latex: "^{97}\\mathrm{Ru}",
    mass: 90268.8075185,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440970,
    name: "Ru97~",
    latex: "^{97}\\mathrm{\\overline{Ru}}",
    mass: 90268.8075185,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440980,
    name: "Ru98",
    latex: "^{98}\\mathrm{Ru}",
    mass: 91198.1975634,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440980,
    name: "Ru98~",
    latex: "^{98}\\mathrm{\\overline{Ru}}",
    mass: 91198.1975634,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000440990,
    name: "Ru99",
    latex: "^{99}\\mathrm{Ru}",
    mass: 92130.2908972,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000440990,
    name: "Ru99~",
    latex: "^{99}\\mathrm{\\overline{Ru}}",
    mass: 92130.2908972,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441000,
    name: "Ru100",
    latex: "^{100}\\mathrm{Ru}",
    mass: 93060.1830174,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441000,
    name: "Ru100~",
    latex: "^{100}\\mathrm{\\overline{Ru}}",
    mass: 93060.1830174,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441010,
    name: "Ru101",
    latex: "^{101}\\mathrm{Ru}",
    mass: 93992.946375,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441010,
    name: "Ru101~",
    latex: "^{101}\\mathrm{\\overline{Ru}}",
    mass: 93992.946375,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441020,
    name: "Ru102",
    latex: "^{102}\\mathrm{Ru}",
    mass: 94923.2921328,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441020,
    name: "Ru102~",
    latex: "^{102}\\mathrm{\\overline{Ru}}",
    mass: 94923.2921328,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441030,
    name: "Ru103",
    latex: "^{103}\\mathrm{Ru}",
    mass: 95856.6254716,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441030,
    name: "Ru103~",
    latex: "^{103}\\mathrm{\\overline{Ru}}",
    mass: 95856.6254716,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441040,
    name: "Ru104",
    latex: "^{104}\\mathrm{Ru}",
    mass: 96787.2910113,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441040,
    name: "Ru104~",
    latex: "^{104}\\mathrm{\\overline{Ru}}",
    mass: 96787.2910113,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441050,
    name: "Ru105",
    latex: "^{105}\\mathrm{Ru}",
    mass: 97720.9463677,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441050,
    name: "Ru105~",
    latex: "^{105}\\mathrm{\\overline{Ru}}",
    mass: 97720.9463677,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441060,
    name: "Ru106",
    latex: "^{106}\\mathrm{Ru}",
    mass: 98652.0515726,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441060,
    name: "Ru106~",
    latex: "^{106}\\mathrm{\\overline{Ru}}",
    mass: 98652.0515726,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441070,
    name: "Ru107",
    latex: "^{107}\\mathrm{Ru}",
    mass: 99586.0066837,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441070,
    name: "Ru107~",
    latex: "^{107}\\mathrm{\\overline{Ru}}",
    mass: 99586.0066837,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441080,
    name: "Ru108",
    latex: "^{108}\\mathrm{Ru}",
    mass: 100517.7019902,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441080,
    name: "Ru108~",
    latex: "^{108}\\mathrm{\\overline{Ru}}",
    mass: 100517.7019902,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441090,
    name: "Ru109",
    latex: "^{109}\\mathrm{Ru}",
    mass: 101452.1191224,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441090,
    name: "Ru109~",
    latex: "^{109}\\mathrm{\\overline{Ru}}",
    mass: 101452.1191224,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441100,
    name: "Ru110",
    latex: "^{110}\\mathrm{Ru}",
    mass: 102384.2792444,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441100,
    name: "Ru110~",
    latex: "^{110}\\mathrm{\\overline{Ru}}",
    mass: 102384.2792444,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441110,
    name: "Ru111",
    latex: "^{111}\\mathrm{Ru}",
    mass: 103319.0605908,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441110,
    name: "Ru111~",
    latex: "^{111}\\mathrm{\\overline{Ru}}",
    mass: 103319.0605908,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441120,
    name: "Ru112",
    latex: "^{112}\\mathrm{Ru}",
    mass: 104251.7088157,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441120,
    name: "Ru112~",
    latex: "^{112}\\mathrm{\\overline{Ru}}",
    mass: 104251.7088157,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441130,
    name: "Ru113",
    latex: "^{113}\\mathrm{Ru}",
    mass: 105186.9689501,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441130,
    name: "Ru113~",
    latex: "^{113}\\mathrm{\\overline{Ru}}",
    mass: 105186.9689501,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441140,
    name: "Ru114",
    latex: "^{114}\\mathrm{Ru}",
    mass: 106120.1062094,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441140,
    name: "Ru114~",
    latex: "^{114}\\mathrm{\\overline{Ru}}",
    mass: 106120.1062094,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441150,
    name: "Ru115",
    latex: "^{115}\\mathrm{Ru}",
    mass: 107055.7165856,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441150,
    name: "Ru115~",
    latex: "^{115}\\mathrm{\\overline{Ru}}",
    mass: 107055.7165856,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441160,
    name: "Ru116",
    latex: "^{116}\\mathrm{Ru}",
    mass: 107989.2469354,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441160,
    name: "Ru116~",
    latex: "^{116}\\mathrm{\\overline{Ru}}",
    mass: 107989.2469354,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441170,
    name: "Ru117",
    latex: "^{117}\\mathrm{Ru}",
    mass: 108925.3249216,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441170,
    name: "Ru117~",
    latex: "^{117}\\mathrm{\\overline{Ru}}",
    mass: 108925.3249216,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000441180,
    name: "Ru118",
    latex: "^{118}\\mathrm{Ru}",
    mass: 109859.3061146,
    width: undefined,
    charge: 44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000441180,
    name: "Ru118~",
    latex: "^{118}\\mathrm{\\overline{Ru}}",
    mass: 109859.3061146,
    width: undefined,
    charge: -44.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000450890,
    name: "Rh89",
    latex: "^{89}\\mathrm{Rh}",
    mass: 82857.3227049,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000450890,
    name: "Rh89~",
    latex: "^{89}\\mathrm{\\overline{Rh}}",
    mass: 82857.3227049,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000450900,
    name: "Rh90",
    latex: "^{90}\\mathrm{Rh}",
    mass: 83782.8366165,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000450900,
    name: "Rh90~",
    latex: "^{90}\\mathrm{\\overline{Rh}}",
    mass: 83782.8366165,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000450910,
    name: "Rh91",
    latex: "^{91}\\mathrm{Rh}",
    mass: 84707.3910891,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000450910,
    name: "Rh91~",
    latex: "^{91}\\mathrm{\\overline{Rh}}",
    mass: 84707.3910891,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000450920,
    name: "Rh92",
    latex: "^{92}\\mathrm{Rh}",
    mass: 85634.4587329,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000450920,
    name: "Rh92~",
    latex: "^{92}\\mathrm{\\overline{Rh}}",
    mass: 85634.4587329,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000450930,
    name: "Rh93",
    latex: "^{93}\\mathrm{Rh}",
    mass: 86559.9398559,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000450930,
    name: "Rh93~",
    latex: "^{93}\\mathrm{\\overline{Rh}}",
    mass: 86559.9398559,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000450940,
    name: "Rh94",
    latex: "^{94}\\mathrm{Rh}",
    mass: 87487.537706,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000450940,
    name: "Rh94~",
    latex: "^{94}\\mathrm{\\overline{Rh}}",
    mass: 87487.537706,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000450950,
    name: "Rh95",
    latex: "^{95}\\mathrm{Rh}",
    mass: 88413.5993362,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000450950,
    name: "Rh95~",
    latex: "^{95}\\mathrm{\\overline{Rh}}",
    mass: 88413.5993362,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000450960,
    name: "Rh96",
    latex: "^{96}\\mathrm{Rh}",
    mass: 89343.7464994,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000450960,
    name: "Rh96~",
    latex: "^{96}\\mathrm{\\overline{Rh}}",
    mass: 89343.7464994,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000450970,
    name: "Rh97",
    latex: "^{97}\\mathrm{Rh}",
    mass: 90272.3324785,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000450970,
    name: "Rh97~",
    latex: "^{97}\\mathrm{\\overline{Rh}}",
    mass: 90272.3324785,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000450980,
    name: "Rh98",
    latex: "^{98}\\mathrm{Rh}",
    mass: 91203.2471929,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000450980,
    name: "Rh98~",
    latex: "^{98}\\mathrm{\\overline{Rh}}",
    mass: 91203.2471929,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000450990,
    name: "Rh99",
    latex: "^{99}\\mathrm{Rh}",
    mass: 92132.3315214,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000450990,
    name: "Rh99~",
    latex: "^{99}\\mathrm{\\overline{Rh}}",
    mass: 92132.3315214,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451000,
    name: "Rh100",
    latex: "^{100}\\mathrm{Rh}",
    mass: 93063.8191046,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451000,
    name: "Rh100~",
    latex: "^{100}\\mathrm{\\overline{Rh}}",
    mass: 93063.8191046,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451010,
    name: "Rh101",
    latex: "^{101}\\mathrm{Rh}",
    mass: 93993.4921374,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451010,
    name: "Rh101~",
    latex: "^{101}\\mathrm{\\overline{Rh}}",
    mass: 93993.4921374,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451020,
    name: "Rh102",
    latex: "^{102}\\mathrm{Rh}",
    mass: 94925.6149996,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451020,
    name: "Rh102~",
    latex: "^{102}\\mathrm{\\overline{Rh}}",
    mass: 94925.6149996,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451030,
    name: "Rh103",
    latex: "^{103}\\mathrm{Rh}",
    mass: 95855.8609944,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451030,
    name: "Rh103~",
    latex: "^{103}\\mathrm{\\overline{Rh}}",
    mass: 95855.8609944,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451040,
    name: "Rh104",
    latex: "^{104}\\mathrm{Rh}",
    mass: 96788.4274341,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451040,
    name: "Rh104~",
    latex: "^{104}\\mathrm{\\overline{Rh}}",
    mass: 96788.4274341,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451050,
    name: "Rh105",
    latex: "^{105}\\mathrm{Rh}",
    mass: 97719.0296322,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451050,
    name: "Rh105~",
    latex: "^{105}\\mathrm{\\overline{Rh}}",
    mass: 97719.0296322,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451060,
    name: "Rh106",
    latex: "^{106}\\mathrm{Rh}",
    mass: 98652.0124498,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451060,
    name: "Rh106~",
    latex: "^{106}\\mathrm{\\overline{Rh}}",
    mass: 98652.0124498,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451070,
    name: "Rh107",
    latex: "^{107}\\mathrm{Rh}",
    mass: 99583.0054097,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451070,
    name: "Rh107~",
    latex: "^{107}\\mathrm{\\overline{Rh}}",
    mass: 99583.0054097,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451080,
    name: "Rh108",
    latex: "^{108}\\mathrm{Rh}",
    mass: 100516.3317623,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451080,
    name: "Rh108~",
    latex: "^{108}\\mathrm{\\overline{Rh}}",
    mass: 100516.3317623,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451090,
    name: "Rh109",
    latex: "^{109}\\mathrm{Rh}",
    mass: 101447.8584684,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451090,
    name: "Rh109~",
    latex: "^{109}\\mathrm{\\overline{Rh}}",
    mass: 101447.8584684,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451100,
    name: "Rh110",
    latex: "^{110}\\mathrm{Rh}",
    mass: 102381.5229533,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451100,
    name: "Rh110~",
    latex: "^{110}\\mathrm{\\overline{Rh}}",
    mass: 102381.5229533,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451110,
    name: "Rh111",
    latex: "^{111}\\mathrm{Rh}",
    mass: 103313.5414882,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451110,
    name: "Rh111~",
    latex: "^{111}\\mathrm{\\overline{Rh}}",
    mass: 103313.5414882,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451120,
    name: "Rh112",
    latex: "^{112}\\mathrm{Rh}",
    mass: 104247.6130361,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451120,
    name: "Rh112~",
    latex: "^{112}\\mathrm{\\overline{Rh}}",
    mass: 104247.6130361,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451130,
    name: "Rh113",
    latex: "^{113}\\mathrm{Rh}",
    mass: 105180.0665788,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451130,
    name: "Rh113~",
    latex: "^{113}\\mathrm{\\overline{Rh}}",
    mass: 105180.0665788,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451140,
    name: "Rh114",
    latex: "^{114}\\mathrm{Rh}",
    mass: 106114.6159832,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451140,
    name: "Rh114~",
    latex: "^{114}\\mathrm{\\overline{Rh}}",
    mass: 106114.6159832,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451150,
    name: "Rh115",
    latex: "^{115}\\mathrm{Rh}",
    mass: 107047.5930255,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451150,
    name: "Rh115~",
    latex: "^{115}\\mathrm{\\overline{Rh}}",
    mass: 107047.5930255,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451160,
    name: "Rh116",
    latex: "^{116}\\mathrm{Rh}",
    mass: 107982.5783691,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451160,
    name: "Rh116~",
    latex: "^{116}\\mathrm{\\overline{Rh}}",
    mass: 107982.5783691,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451170,
    name: "Rh117",
    latex: "^{117}\\mathrm{Rh}",
    mass: 108915.9131052,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451170,
    name: "Rh117~",
    latex: "^{117}\\mathrm{\\overline{Rh}}",
    mass: 108915.9131052,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451180,
    name: "Rh118",
    latex: "^{118}\\mathrm{Rh}",
    mass: 109851.417291,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451180,
    name: "Rh118~",
    latex: "^{118}\\mathrm{\\overline{Rh}}",
    mass: 109851.417291,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451190,
    name: "Rh119",
    latex: "^{119}\\mathrm{Rh}",
    mass: 110784.9755857,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451190,
    name: "Rh119~",
    latex: "^{119}\\mathrm{\\overline{Rh}}",
    mass: 110784.9755857,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451200,
    name: "Rh120",
    latex: "^{120}\\mathrm{Rh}",
    mass: 111720.6735223,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451200,
    name: "Rh120~",
    latex: "^{120}\\mathrm{\\overline{Rh}}",
    mass: 111720.6735223,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000451210,
    name: "Rh121",
    latex: "^{121}\\mathrm{Rh}",
    mass: 112654.533621,
    width: undefined,
    charge: 45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000451210,
    name: "Rh121~",
    latex: "^{121}\\mathrm{\\overline{Rh}}",
    mass: 112654.533621,
    width: undefined,
    charge: -45.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000460910,
    name: "Pd91",
    latex: "^{91}\\mathrm{Pd}",
    mass: 84719.7985906,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000460910,
    name: "Pd91~",
    latex: "^{91}\\mathrm{\\overline{Pd}}",
    mass: 84719.7985906,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000460920,
    name: "Pd92",
    latex: "^{92}\\mathrm{Pd}",
    mass: 85642.6763739,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000460920,
    name: "Pd92~",
    latex: "^{92}\\mathrm{\\overline{Pd}}",
    mass: 85642.6763739,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000460930,
    name: "Pd93",
    latex: "^{93}\\mathrm{Pd}",
    mass: 86569.9694392,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000460930,
    name: "Pd93~",
    latex: "^{93}\\mathrm{\\overline{Pd}}",
    mass: 86569.9694392,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000460940,
    name: "Pd94",
    latex: "^{94}\\mathrm{Pd}",
    mass: 87494.343202,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000460940,
    name: "Pd94~",
    latex: "^{94}\\mathrm{\\overline{Pd}}",
    mass: 87494.343202,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000460950,
    name: "Pd95",
    latex: "^{95}\\mathrm{Pd}",
    mass: 88421.9743996,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000460950,
    name: "Pd95~",
    latex: "^{95}\\mathrm{\\overline{Pd}}",
    mass: 88421.9743996,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000460960,
    name: "Pd96",
    latex: "^{96}\\mathrm{Pd}",
    mass: 89347.2507802,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000460960,
    name: "Pd96~",
    latex: "^{96}\\mathrm{\\overline{Pd}}",
    mass: 89347.2507802,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000460970,
    name: "Pd97",
    latex: "^{97}\\mathrm{Pd}",
    mass: 90277.1222212,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000460970,
    name: "Pd97~",
    latex: "^{97}\\mathrm{\\overline{Pd}}",
    mass: 90277.1222212,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000460980,
    name: "Pd98",
    latex: "^{98}\\mathrm{Pd}",
    mass: 91205.1008662,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000460980,
    name: "Pd98~",
    latex: "^{98}\\mathrm{\\overline{Pd}}",
    mass: 91205.1008662,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000460990,
    name: "Pd99",
    latex: "^{99}\\mathrm{Pd}",
    mass: 92135.7333378,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000460990,
    name: "Pd99~",
    latex: "^{99}\\mathrm{\\overline{Pd}}",
    mass: 92135.7333378,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461000,
    name: "Pd100",
    latex: "^{100}\\mathrm{Pd}",
    mass: 93064.1972912,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461000,
    name: "Pd100~",
    latex: "^{100}\\mathrm{\\overline{Pd}}",
    mass: 93064.1972912,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461010,
    name: "Pd101",
    latex: "^{101}\\mathrm{Pd}",
    mass: 93995.4724939,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461010,
    name: "Pd101~",
    latex: "^{101}\\mathrm{\\overline{Pd}}",
    mass: 93995.4724939,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461020,
    name: "Pd102",
    latex: "^{102}\\mathrm{Pd}",
    mass: 94924.4956232,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461020,
    name: "Pd102~",
    latex: "^{102}\\mathrm{\\overline{Pd}}",
    mass: 94924.4956232,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461030,
    name: "Pd103",
    latex: "^{103}\\mathrm{Pd}",
    mass: 95856.4357263,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461030,
    name: "Pd103~",
    latex: "^{103}\\mathrm{\\overline{Pd}}",
    mass: 95856.4357263,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461040,
    name: "Pd104",
    latex: "^{104}\\mathrm{Pd}",
    mass: 96785.9916702,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461040,
    name: "Pd104~",
    latex: "^{104}\\mathrm{\\overline{Pd}}",
    mass: 96785.9916702,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461050,
    name: "Pd105",
    latex: "^{105}\\mathrm{Pd}",
    mass: 97718.4630044,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461050,
    name: "Pd105~",
    latex: "^{105}\\mathrm{\\overline{Pd}}",
    mass: 97718.4630044,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461060,
    name: "Pd106",
    latex: "^{106}\\mathrm{Pd}",
    mass: 98648.4674627,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461060,
    name: "Pd106~",
    latex: "^{106}\\mathrm{\\overline{Pd}}",
    mass: 98648.4674627,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461070,
    name: "Pd107",
    latex: "^{107}\\mathrm{Pd}",
    mass: 99581.4964824,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461070,
    name: "Pd107~",
    latex: "^{107}\\mathrm{\\overline{Pd}}",
    mass: 99581.4964824,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461080,
    name: "Pd108",
    latex: "^{108}\\mathrm{Pd}",
    mass: 100511.83898,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461080,
    name: "Pd108~",
    latex: "^{108}\\mathrm{\\overline{Pd}}",
    mass: 100511.83898,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461090,
    name: "Pd109",
    latex: "^{109}\\mathrm{Pd}",
    mass: 101445.2508438,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461090,
    name: "Pd109~",
    latex: "^{109}\\mathrm{\\overline{Pd}}",
    mass: 101445.2508438,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461100,
    name: "Pd110",
    latex: "^{110}\\mathrm{Pd}",
    mass: 102376.0205245,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461100,
    name: "Pd110~",
    latex: "^{110}\\mathrm{\\overline{Pd}}",
    mass: 102376.0205245,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461110,
    name: "Pd111",
    latex: "^{111}\\mathrm{Pd}",
    mass: 103309.8596646,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461110,
    name: "Pd111~",
    latex: "^{111}\\mathrm{\\overline{Pd}}",
    mass: 103309.8596646,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461120,
    name: "Pd112",
    latex: "^{112}\\mathrm{Pd}",
    mass: 104241.0189894,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461120,
    name: "Pd112~",
    latex: "^{112}\\mathrm{\\overline{Pd}}",
    mass: 104241.0189894,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461130,
    name: "Pd113",
    latex: "^{113}\\mathrm{Pd}",
    mass: 105175.2433023,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461130,
    name: "Pd113~",
    latex: "^{113}\\mathrm{\\overline{Pd}}",
    mass: 105175.2433023,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461140,
    name: "Pd114",
    latex: "^{114}\\mathrm{Pd}",
    mass: 106106.8370759,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461140,
    name: "Pd114~",
    latex: "^{114}\\mathrm{\\overline{Pd}}",
    mass: 106106.8370759,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461150,
    name: "Pd115",
    latex: "^{115}\\mathrm{Pd}",
    mass: 107041.3957952,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461150,
    name: "Pd115~",
    latex: "^{115}\\mathrm{\\overline{Pd}}",
    mass: 107041.3957952,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461160,
    name: "Pd116",
    latex: "^{116}\\mathrm{Pd}",
    mass: 107973.4851237,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461160,
    name: "Pd116~",
    latex: "^{116}\\mathrm{\\overline{Pd}}",
    mass: 107973.4851237,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461170,
    name: "Pd117",
    latex: "^{117}\\mathrm{Pd}",
    mass: 108908.3866328,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461170,
    name: "Pd117~",
    latex: "^{117}\\mathrm{\\overline{Pd}}",
    mass: 108908.3866328,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461180,
    name: "Pd118",
    latex: "^{118}\\mathrm{Pd}",
    mass: 109840.9159059,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461180,
    name: "Pd118~",
    latex: "^{118}\\mathrm{\\overline{Pd}}",
    mass: 109840.9159059,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461190,
    name: "Pd119",
    latex: "^{119}\\mathrm{Pd}",
    mass: 110776.390936,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461190,
    name: "Pd119~",
    latex: "^{119}\\mathrm{\\overline{Pd}}",
    mass: 110776.390936,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461200,
    name: "Pd120",
    latex: "^{120}\\mathrm{Pd}",
    mass: 111709.0127996,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461200,
    name: "Pd120~",
    latex: "^{120}\\mathrm{\\overline{Pd}}",
    mass: 111709.0127996,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461210,
    name: "Pd121",
    latex: "^{121}\\mathrm{Pd}",
    mass: 112644.6038939,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461210,
    name: "Pd121~",
    latex: "^{121}\\mathrm{\\overline{Pd}}",
    mass: 112644.6038939,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461220,
    name: "Pd122",
    latex: "^{122}\\mathrm{Pd}",
    mass: 113577.6647707,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461220,
    name: "Pd122~",
    latex: "^{122}\\mathrm{\\overline{Pd}}",
    mass: 113577.6647707,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000461230,
    name: "Pd123",
    latex: "^{123}\\mathrm{Pd}",
    mass: 114513.3487349,
    width: undefined,
    charge: 46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000461230,
    name: "Pd123~",
    latex: "^{123}\\mathrm{\\overline{Pd}}",
    mass: 114513.3487349,
    width: undefined,
    charge: -46.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000470940,
    name: "Ag94",
    latex: "^{94}\\mathrm{Ag}",
    mass: 87508.0398913,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000470940,
    name: "Ag94~",
    latex: "^{94}\\mathrm{\\overline{Ag}}",
    mass: 87508.0398913,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000470950,
    name: "Ag95",
    latex: "^{95}\\mathrm{Ag}",
    mass: 88432.0354675,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000470950,
    name: "Ag95~",
    latex: "^{95}\\mathrm{\\overline{Ag}}",
    mass: 88432.0354675,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000470960,
    name: "Ag96",
    latex: "^{96}\\mathrm{Ag}",
    mass: 89358.9186754,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000470960,
    name: "Ag96~",
    latex: "^{96}\\mathrm{\\overline{Ag}}",
    mass: 89358.9186754,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000470970,
    name: "Ag97",
    latex: "^{97}\\mathrm{Ag}",
    mass: 90284.023661,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000470970,
    name: "Ag97~",
    latex: "^{97}\\mathrm{\\overline{Ag}}",
    mass: 90284.023661,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000470980,
    name: "Ag98",
    latex: "^{98}\\mathrm{Ag}",
    mass: 91213.3557669,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000470980,
    name: "Ag98~",
    latex: "^{98}\\mathrm{\\overline{Ag}}",
    mass: 91213.3557669,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000470990,
    name: "Ag99",
    latex: "^{99}\\mathrm{Ag}",
    mass: 92141.2040027,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000470990,
    name: "Ag99~",
    latex: "^{99}\\mathrm{\\overline{Ag}}",
    mass: 92141.2040027,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471000,
    name: "Ag100",
    latex: "^{100}\\mathrm{Ag}",
    mass: 93071.271989,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471000,
    name: "Ag100~",
    latex: "^{100}\\mathrm{\\overline{Ag}}",
    mass: 93071.271989,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471010,
    name: "Ag101",
    latex: "^{101}\\mathrm{Ag}",
    mass: 93999.5701364,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471010,
    name: "Ag101~",
    latex: "^{101}\\mathrm{\\overline{Ag}}",
    mass: 93999.5701364,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471020,
    name: "Ag102",
    latex: "^{102}\\mathrm{Ag}",
    mass: 94930.1523074,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471020,
    name: "Ag102~",
    latex: "^{102}\\mathrm{\\overline{Ag}}",
    mass: 94930.1523074,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471030,
    name: "Ag103",
    latex: "^{103}\\mathrm{Ag}",
    mass: 95859.0903913,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471030,
    name: "Ag103~",
    latex: "^{103}\\mathrm{\\overline{Ag}}",
    mass: 95859.0903913,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471040,
    name: "Ag104",
    latex: "^{104}\\mathrm{Ag}",
    mass: 96790.2705815,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471040,
    name: "Ag104~",
    latex: "^{104}\\mathrm{\\overline{Ag}}",
    mass: 96790.2705815,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471050,
    name: "Ag105",
    latex: "^{105}\\mathrm{Ag}",
    mass: 97719.8104106,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471050,
    name: "Ag105~",
    latex: "^{105}\\mathrm{\\overline{Ag}}",
    mass: 97719.8104106,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471060,
    name: "Ag106",
    latex: "^{106}\\mathrm{Ag}",
    mass: 98651.432129,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471060,
    name: "Ag106~",
    latex: "^{106}\\mathrm{\\overline{Ag}}",
    mass: 98651.432129,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471070,
    name: "Ag107",
    latex: "^{107}\\mathrm{Ag}",
    mass: 99581.4623897,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471070,
    name: "Ag107~",
    latex: "^{107}\\mathrm{\\overline{Ag}}",
    mass: 99581.4623897,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471080,
    name: "Ag108",
    latex: "^{108}\\mathrm{Ag}",
    mass: 100513.7563674,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471080,
    name: "Ag108~",
    latex: "^{108}\\mathrm{\\overline{Ag}}",
    mass: 100513.7563674,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471090,
    name: "Ag109",
    latex: "^{109}\\mathrm{Ag}",
    mass: 101444.1378946,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471090,
    name: "Ag109~",
    latex: "^{109}\\mathrm{\\overline{Ag}}",
    mass: 101444.1378946,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471100,
    name: "Ag110",
    latex: "^{110}\\mathrm{Ag}",
    mass: 102376.8940797,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471100,
    name: "Ag110~",
    latex: "^{110}\\mathrm{\\overline{Ag}}",
    mass: 102376.8940797,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471110,
    name: "Ag111",
    latex: "^{111}\\mathrm{Ag}",
    mass: 103307.6300404,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471110,
    name: "Ag111~",
    latex: "^{111}\\mathrm{\\overline{Ag}}",
    mass: 103307.6300404,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471120,
    name: "Ag112",
    latex: "^{112}\\mathrm{Ag}",
    mass: 104240.7558423,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471120,
    name: "Ag112~",
    latex: "^{112}\\mathrm{\\overline{Ag}}",
    mass: 104240.7558423,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471130,
    name: "Ag113",
    latex: "^{113}\\mathrm{Ag}",
    mass: 105171.8070206,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471130,
    name: "Ag113~",
    latex: "^{113}\\mathrm{\\overline{Ag}}",
    mass: 105171.8070206,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471140,
    name: "Ag114",
    latex: "^{114}\\mathrm{Ag}",
    mass: 106105.396986,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471140,
    name: "Ag114~",
    latex: "^{114}\\mathrm{\\overline{Ag}}",
    mass: 106105.396986,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471150,
    name: "Ag115",
    latex: "^{115}\\mathrm{Ag}",
    mass: 107036.8389261,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471150,
    name: "Ag115~",
    latex: "^{115}\\mathrm{\\overline{Ag}}",
    mass: 107036.8389261,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471160,
    name: "Ag116",
    latex: "^{116}\\mathrm{Ag}",
    mass: 107970.7735443,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471160,
    name: "Ag116~",
    latex: "^{116}\\mathrm{\\overline{Ag}}",
    mass: 107970.7735443,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471170,
    name: "Ag117",
    latex: "^{117}\\mathrm{Ag}",
    mass: 108902.6281363,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471170,
    name: "Ag117~",
    latex: "^{117}\\mathrm{\\overline{Ag}}",
    mass: 108902.6281363,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471180,
    name: "Ag118",
    latex: "^{118}\\mathrm{Ag}",
    mass: 109836.7504506,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471180,
    name: "Ag118~",
    latex: "^{118}\\mathrm{\\overline{Ag}}",
    mass: 109836.7504506,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471190,
    name: "Ag119",
    latex: "^{119}\\mathrm{Ag}",
    mass: 110769.1522953,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471190,
    name: "Ag119~",
    latex: "^{119}\\mathrm{\\overline{Ag}}",
    mass: 110769.1522953,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471200,
    name: "Ag120",
    latex: "^{120}\\mathrm{Ag}",
    mass: 111703.6411526,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471200,
    name: "Ag120~",
    latex: "^{120}\\mathrm{\\overline{Ag}}",
    mass: 111703.6411526,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471210,
    name: "Ag121",
    latex: "^{121}\\mathrm{Ag}",
    mass: 112636.3834584,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471210,
    name: "Ag121~",
    latex: "^{121}\\mathrm{\\overline{Ag}}",
    mass: 112636.3834584,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471220,
    name: "Ag122",
    latex: "^{122}\\mathrm{Ag}",
    mass: 113571.1703938,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471220,
    name: "Ag122~",
    latex: "^{122}\\mathrm{\\overline{Ag}}",
    mass: 113571.1703938,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471230,
    name: "Ag123",
    latex: "^{123}\\mathrm{Ag}",
    mass: 114504.2107777,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471230,
    name: "Ag123~",
    latex: "^{123}\\mathrm{\\overline{Ag}}",
    mass: 114504.2107777,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471240,
    name: "Ag124",
    latex: "^{124}\\mathrm{Ag}",
    mass: 115439.0396303,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471240,
    name: "Ag124~",
    latex: "^{124}\\mathrm{\\overline{Ag}}",
    mass: 115439.0396303,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471250,
    name: "Ag125",
    latex: "^{125}\\mathrm{Ag}",
    mass: 116372.2476832,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471250,
    name: "Ag125~",
    latex: "^{125}\\mathrm{\\overline{Ag}}",
    mass: 116372.2476832,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471260,
    name: "Ag126",
    latex: "^{126}\\mathrm{Ag}",
    mass: 117307.5329679,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471260,
    name: "Ag126~",
    latex: "^{126}\\mathrm{\\overline{Ag}}",
    mass: 117307.5329679,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000471270,
    name: "Ag127",
    latex: "^{127}\\mathrm{Ag}",
    mass: 118241.1043035,
    width: undefined,
    charge: 47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000471270,
    name: "Ag127~",
    latex: "^{127}\\mathrm{\\overline{Ag}}",
    mass: 118241.1043035,
    width: undefined,
    charge: -47.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000480960,
    name: "Cd96",
    latex: "^{96}\\mathrm{Cd}",
    mass: 89367.8610188,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000480960,
    name: "Cd96~",
    latex: "^{96}\\mathrm{\\overline{Cd}}",
    mass: 89367.8610188,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000480970,
    name: "Cd97",
    latex: "^{97}\\mathrm{Cd}",
    mass: 90294.1946451,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000480970,
    name: "Cd97~",
    latex: "^{97}\\mathrm{\\overline{Cd}}",
    mass: 90294.1946451,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000480980,
    name: "Cd98",
    latex: "^{98}\\mathrm{Cd}",
    mass: 91218.7863775,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000480980,
    name: "Cd98~",
    latex: "^{98}\\mathrm{\\overline{Cd}}",
    mass: 91218.7863775,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000480990,
    name: "Cd99",
    latex: "^{99}\\mathrm{Cd}",
    mass: 92147.9850935,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000480990,
    name: "Cd99~",
    latex: "^{99}\\mathrm{\\overline{Cd}}",
    mass: 92147.9850935,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481000,
    name: "Cd100",
    latex: "^{100}\\mathrm{Cd}",
    mass: 93075.2157487,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481000,
    name: "Cd100~",
    latex: "^{100}\\mathrm{\\overline{Cd}}",
    mass: 93075.2157487,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481010,
    name: "Cd101",
    latex: "^{101}\\mathrm{Cd}",
    mass: 94005.0680009,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481010,
    name: "Cd101~",
    latex: "^{101}\\mathrm{\\overline{Cd}}",
    mass: 94005.0680009,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481020,
    name: "Cd102",
    latex: "^{102}\\mathrm{Cd}",
    mass: 94932.7388802,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481020,
    name: "Cd102~",
    latex: "^{102}\\mathrm{\\overline{Cd}}",
    mass: 94932.7388802,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481030,
    name: "Cd103",
    latex: "^{103}\\mathrm{Cd}",
    mass: 95863.2410359,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481030,
    name: "Cd103~",
    latex: "^{103}\\mathrm{\\overline{Cd}}",
    mass: 95863.2410359,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481040,
    name: "Cd104",
    latex: "^{104}\\mathrm{Cd}",
    mass: 96791.4183685,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481040,
    name: "Cd104~",
    latex: "^{104}\\mathrm{\\overline{Cd}}",
    mass: 96791.4183685,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481050,
    name: "Cd105",
    latex: "^{105}\\mathrm{Cd}",
    mass: 97722.5470471,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481050,
    name: "Cd105~",
    latex: "^{105}\\mathrm{\\overline{Cd}}",
    mass: 97722.5470471,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481060,
    name: "Cd106",
    latex: "^{106}\\mathrm{Cd}",
    mass: 98651.2428494,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481060,
    name: "Cd106~",
    latex: "^{106}\\mathrm{\\overline{Cd}}",
    mass: 98651.2428494,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481070,
    name: "Cd107",
    latex: "^{107}\\mathrm{Cd}",
    mass: 99582.8787265,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481070,
    name: "Cd107~",
    latex: "^{107}\\mathrm{\\overline{Cd}}",
    mass: 99582.8787265,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481080,
    name: "Cd108",
    latex: "^{108}\\mathrm{Cd}",
    mass: 100512.11079,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481080,
    name: "Cd108~",
    latex: "^{108}\\mathrm{\\overline{Cd}}",
    mass: 100512.11079,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481090,
    name: "Cd109",
    latex: "^{109}\\mathrm{Cd}",
    mass: 101444.3529766,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481090,
    name: "Cd109~",
    latex: "^{109}\\mathrm{\\overline{Cd}}",
    mass: 101444.3529766,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481100,
    name: "Cd110",
    latex: "^{110}\\mathrm{Cd}",
    mass: 102374.0034672,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481100,
    name: "Cd110~",
    latex: "^{110}\\mathrm{\\overline{Cd}}",
    mass: 102374.0034672,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481110,
    name: "Cd111",
    latex: "^{111}\\mathrm{Cd}",
    mass: 103306.5932874,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481110,
    name: "Cd111~",
    latex: "^{111}\\mathrm{\\overline{Cd}}",
    mass: 103306.5932874,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481120,
    name: "Cd112",
    latex: "^{112}\\mathrm{Cd}",
    mass: 104236.7647627,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481120,
    name: "Cd112~",
    latex: "^{112}\\mathrm{\\overline{Cd}}",
    mass: 104236.7647627,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481130,
    name: "Cd113",
    latex: "^{113}\\mathrm{Cd}",
    mass: 105169.7904383,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481130,
    name: "Cd113~",
    latex: "^{113}\\mathrm{\\overline{Cd}}",
    mass: 105169.7904383,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481140,
    name: "Cd114",
    latex: "^{114}\\mathrm{Cd}",
    mass: 106100.3128912,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481140,
    name: "Cd114~",
    latex: "^{114}\\mathrm{\\overline{Cd}}",
    mass: 106100.3128912,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481150,
    name: "Cd115",
    latex: "^{115}\\mathrm{Cd}",
    mass: 107033.7374233,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481150,
    name: "Cd115~",
    latex: "^{115}\\mathrm{\\overline{Cd}}",
    mass: 107033.7374233,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481160,
    name: "Cd116",
    latex: "^{116}\\mathrm{Cd}",
    mass: 107964.6035416,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481160,
    name: "Cd116~",
    latex: "^{116}\\mathrm{\\overline{Cd}}",
    mass: 107964.6035416,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481170,
    name: "Cd117",
    latex: "^{117}\\mathrm{Cd}",
    mass: 108898.3917011,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481170,
    name: "Cd117~",
    latex: "^{117}\\mathrm{\\overline{Cd}}",
    mass: 108898.3917011,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481180,
    name: "Cd118",
    latex: "^{118}\\mathrm{Cd}",
    mass: 109829.6026306,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481180,
    name: "Cd118~",
    latex: "^{118}\\mathrm{\\overline{Cd}}",
    mass: 109829.6026306,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481190,
    name: "Cd119",
    latex: "^{119}\\mathrm{Cd}",
    mass: 110763.8241491,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481190,
    name: "Cd119~",
    latex: "^{119}\\mathrm{\\overline{Cd}}",
    mass: 110763.8241491,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481200,
    name: "Cd120",
    latex: "^{120}\\mathrm{Cd}",
    mass: 111695.3350197,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481200,
    name: "Cd120~",
    latex: "^{120}\\mathrm{\\overline{Cd}}",
    mass: 111695.3350197,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481210,
    name: "Cd121",
    latex: "^{121}\\mathrm{Cd}",
    mass: 112629.7127497,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481210,
    name: "Cd121~",
    latex: "^{121}\\mathrm{\\overline{Cd}}",
    mass: 112629.7127497,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481220,
    name: "Cd122",
    latex: "^{122}\\mathrm{Cd}",
    mass: 113561.6683156,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481220,
    name: "Cd122~",
    latex: "^{122}\\mathrm{\\overline{Cd}}",
    mass: 113561.6683156,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481230,
    name: "Cd123",
    latex: "^{123}\\mathrm{Cd}",
    mass: 114496.3606112,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481230,
    name: "Cd123~",
    latex: "^{123}\\mathrm{\\overline{Cd}}",
    mass: 114496.3606112,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481240,
    name: "Cd124",
    latex: "^{124}\\mathrm{Cd}",
    mass: 115428.5694503,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481240,
    name: "Cd124~",
    latex: "^{124}\\mathrm{\\overline{Cd}}",
    mass: 115428.5694503,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481250,
    name: "Cd125",
    latex: "^{125}\\mathrm{Cd}",
    mass: 116363.4152561,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481250,
    name: "Cd125~",
    latex: "^{125}\\mathrm{\\overline{Cd}}",
    mass: 116363.4152561,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481260,
    name: "Cd126",
    latex: "^{126}\\mathrm{Cd}",
    mass: 117296.0013504,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481260,
    name: "Cd126~",
    latex: "^{126}\\mathrm{\\overline{Cd}}",
    mass: 117296.0013504,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481270,
    name: "Cd127",
    latex: "^{127}\\mathrm{Cd}",
    mass: 118231.0097019,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481270,
    name: "Cd127~",
    latex: "^{127}\\mathrm{\\overline{Cd}}",
    mass: 118231.0097019,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481280,
    name: "Cd128",
    latex: "^{128}\\mathrm{Cd}",
    mass: 119164.0072371,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481280,
    name: "Cd128~",
    latex: "^{128}\\mathrm{\\overline{Cd}}",
    mass: 119164.0072371,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481290,
    name: "Cd129",
    latex: "^{129}\\mathrm{Cd}",
    mass: 120099.6176133,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481290,
    name: "Cd129~",
    latex: "^{129}\\mathrm{\\overline{Cd}}",
    mass: 120099.6176133,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000481300,
    name: "Cd130",
    latex: "^{130}\\mathrm{Cd}",
    mass: 121033.1162923,
    width: undefined,
    charge: 48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000481300,
    name: "Cd130~",
    latex: "^{130}\\mathrm{\\overline{Cd}}",
    mass: 121033.1162923,
    width: undefined,
    charge: -48.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000490980,
    name: "In98",
    latex: "^{98}\\mathrm{In}",
    mass: 91232.5166006,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000490980,
    name: "In98~",
    latex: "^{98}\\mathrm{\\overline{In}}",
    mass: 91232.5166006,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000490990,
    name: "In99",
    latex: "^{99}\\mathrm{In}",
    mass: 92156.5401216,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000490990,
    name: "In99~",
    latex: "^{99}\\mathrm{\\overline{In}}",
    mass: 92156.5401216,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491000,
    name: "In100",
    latex: "^{100}\\mathrm{In}",
    mass: 93085.2321979,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491000,
    name: "In100~",
    latex: "^{100}\\mathrm{\\overline{In}}",
    mass: 93085.2321979,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491010,
    name: "In101",
    latex: "^{101}\\mathrm{In}",
    mass: 94012.3595505,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491010,
    name: "In101~",
    latex: "^{101}\\mathrm{\\overline{In}}",
    mass: 94012.3595505,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491020,
    name: "In102",
    latex: "^{102}\\mathrm{In}",
    mass: 94941.7037658,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491020,
    name: "In102~",
    latex: "^{102}\\mathrm{\\overline{In}}",
    mass: 94941.7037658,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491030,
    name: "In103",
    latex: "^{103}\\mathrm{In}",
    mass: 95869.2604439,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491030,
    name: "In103~",
    latex: "^{103}\\mathrm{\\overline{In}}",
    mass: 95869.2604439,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491040,
    name: "In104",
    latex: "^{104}\\mathrm{In}",
    mass: 96799.2045415,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491040,
    name: "In104~",
    latex: "^{104}\\mathrm{\\overline{In}}",
    mass: 96799.2045415,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491050,
    name: "In105",
    latex: "^{105}\\mathrm{In}",
    mass: 97727.2400076,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491050,
    name: "In105~",
    latex: "^{105}\\mathrm{\\overline{In}}",
    mass: 97727.2400076,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491060,
    name: "In106",
    latex: "^{106}\\mathrm{In}",
    mass: 98657.7672204,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491060,
    name: "In106~",
    latex: "^{106}\\mathrm{\\overline{In}}",
    mass: 98657.7672204,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491070,
    name: "In107",
    latex: "^{107}\\mathrm{In}",
    mass: 99586.3019674,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491070,
    name: "In107~",
    latex: "^{107}\\mathrm{\\overline{In}}",
    mass: 99586.3019674,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491080,
    name: "In108",
    latex: "^{108}\\mathrm{In}",
    mass: 100517.2436951,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491080,
    name: "In108~",
    latex: "^{108}\\mathrm{\\overline{In}}",
    mass: 100517.2436951,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491090,
    name: "In109",
    latex: "^{109}\\mathrm{In}",
    mass: 101446.3680778,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491090,
    name: "In109~",
    latex: "^{109}\\mathrm{\\overline{In}}",
    mass: 101446.3680778,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491100,
    name: "In110",
    latex: "^{110}\\mathrm{In}",
    mass: 102377.8817429,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491100,
    name: "In110~",
    latex: "^{110}\\mathrm{\\overline{In}}",
    mass: 102377.8817429,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491110,
    name: "In111",
    latex: "^{111}\\mathrm{In}",
    mass: 103307.4532428,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491110,
    name: "In111~",
    latex: "^{111}\\mathrm{\\overline{In}}",
    mass: 103307.4532428,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491120,
    name: "In112",
    latex: "^{112}\\mathrm{In}",
    mass: 104239.3497519,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491120,
    name: "In112~",
    latex: "^{112}\\mathrm{\\overline{In}}",
    mass: 104239.3497519,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491130,
    name: "In113",
    latex: "^{113}\\mathrm{In}",
    mass: 105169.4665951,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491130,
    name: "In113~",
    latex: "^{113}\\mathrm{\\overline{In}}",
    mass: 105169.4665951,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491140,
    name: "In114",
    latex: "^{114}\\mathrm{In}",
    mass: 106101.7580112,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491140,
    name: "In114~",
    latex: "^{114}\\mathrm{\\overline{In}}",
    mass: 106101.7580112,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491150,
    name: "In115",
    latex: "^{115}\\mathrm{In}",
    mass: 107032.2855714,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491150,
    name: "In115~",
    latex: "^{115}\\mathrm{\\overline{In}}",
    mass: 107032.2855714,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491160,
    name: "In116",
    latex: "^{116}\\mathrm{In}",
    mass: 107965.0662707,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491160,
    name: "In116~",
    latex: "^{116}\\mathrm{\\overline{In}}",
    mass: 107965.0662707,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491170,
    name: "In117",
    latex: "^{117}\\mathrm{In}",
    mass: 108895.8673521,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491170,
    name: "In117~",
    latex: "^{117}\\mathrm{\\overline{In}}",
    mass: 108895.8673521,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491180,
    name: "In118",
    latex: "^{118}\\mathrm{In}",
    mass: 109829.0763364,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491180,
    name: "In118~",
    latex: "^{118}\\mathrm{\\overline{In}}",
    mass: 109829.0763364,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491190,
    name: "In119",
    latex: "^{119}\\mathrm{In}",
    mass: 110760.1000356,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491190,
    name: "In119~",
    latex: "^{119}\\mathrm{\\overline{In}}",
    mass: 110760.1000356,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491200,
    name: "In120",
    latex: "^{120}\\mathrm{In}",
    mass: 111693.5670439,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491200,
    name: "In120~",
    latex: "^{120}\\mathrm{\\overline{In}}",
    mass: 111693.5670439,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491210,
    name: "In121",
    latex: "^{121}\\mathrm{In}",
    mass: 112624.9521628,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491210,
    name: "In121~",
    latex: "^{121}\\mathrm{\\overline{In}}",
    mass: 112624.9521628,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491220,
    name: "In122",
    latex: "^{122}\\mathrm{In}",
    mass: 113558.7070027,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491220,
    name: "In122~",
    latex: "^{122}\\mathrm{\\overline{In}}",
    mass: 113558.7070027,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491230,
    name: "In123",
    latex: "^{123}\\mathrm{In}",
    mass: 114490.345488,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491230,
    name: "In123~",
    latex: "^{123}\\mathrm{\\overline{In}}",
    mass: 114490.345488,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491240,
    name: "In124",
    latex: "^{124}\\mathrm{In}",
    mass: 115424.396543,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491240,
    name: "In124~",
    latex: "^{124}\\mathrm{\\overline{In}}",
    mass: 115424.396543,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491250,
    name: "In125",
    latex: "^{125}\\mathrm{In}",
    mass: 116356.3506185,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491250,
    name: "In125~",
    latex: "^{125}\\mathrm{\\overline{In}}",
    mass: 116356.3506185,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491260,
    name: "In126",
    latex: "^{126}\\mathrm{In}",
    mass: 117290.4475031,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491260,
    name: "In126~",
    latex: "^{126}\\mathrm{\\overline{In}}",
    mass: 117290.4475031,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491270,
    name: "In127",
    latex: "^{127}\\mathrm{In}",
    mass: 118222.8712379,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491270,
    name: "In127~",
    latex: "^{127}\\mathrm{\\overline{In}}",
    mass: 118222.8712379,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491280,
    name: "In128",
    latex: "^{128}\\mathrm{In}",
    mass: 119157.055124,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491280,
    name: "In128~",
    latex: "^{128}\\mathrm{\\overline{In}}",
    mass: 119157.055124,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491290,
    name: "In129",
    latex: "^{129}\\mathrm{In}",
    mass: 120089.9044585,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491290,
    name: "In129~",
    latex: "^{129}\\mathrm{\\overline{In}}",
    mass: 120089.9044585,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491300,
    name: "In130",
    latex: "^{130}\\mathrm{In}",
    mass: 121024.3269934,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491300,
    name: "In130~",
    latex: "^{130}\\mathrm{\\overline{In}}",
    mass: 121024.3269934,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491310,
    name: "In131",
    latex: "^{131}\\mathrm{In}",
    mass: 121957.7031809,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491310,
    name: "In131~",
    latex: "^{131}\\mathrm{\\overline{In}}",
    mass: 121957.7031809,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491320,
    name: "In132",
    latex: "^{132}\\mathrm{In}",
    mass: 122894.8115859,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491320,
    name: "In132~",
    latex: "^{132}\\mathrm{\\overline{In}}",
    mass: 122894.8115859,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491330,
    name: "In133",
    latex: "^{133}\\mathrm{In}",
    mass: 123831.0283647,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491330,
    name: "In133~",
    latex: "^{133}\\mathrm{\\overline{In}}",
    mass: 123831.0283647,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000491340,
    name: "In134",
    latex: "^{134}\\mathrm{In}",
    mass: 124768.2418422,
    width: undefined,
    charge: 49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000491340,
    name: "In134~",
    latex: "^{134}\\mathrm{\\overline{In}}",
    mass: 124768.2418422,
    width: undefined,
    charge: -49.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501000,
    name: "Sn100",
    latex: "^{100}\\mathrm{Sn}",
    mass: 93092.2632086,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501000,
    name: "Sn100~",
    latex: "^{100}\\mathrm{\\overline{Sn}}",
    mass: 93092.2632086,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501010,
    name: "Sn101",
    latex: "^{101}\\mathrm{Sn}",
    mass: 94020.5995473,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501010,
    name: "Sn101~",
    latex: "^{101}\\mathrm{\\overline{Sn}}",
    mass: 94020.5995473,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501020,
    name: "Sn102",
    latex: "^{102}\\mathrm{Sn}",
    mass: 94947.4641253,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501020,
    name: "Sn102~",
    latex: "^{102}\\mathrm{\\overline{Sn}}",
    mass: 94947.4641253,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501030,
    name: "Sn103",
    latex: "^{103}\\mathrm{Sn}",
    mass: 95876.7971627,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501030,
    name: "Sn103~",
    latex: "^{103}\\mathrm{\\overline{Sn}}",
    mass: 95876.7971627,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501040,
    name: "Sn104",
    latex: "^{104}\\mathrm{Sn}",
    mass: 96803.7595476,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501040,
    name: "Sn104~",
    latex: "^{104}\\mathrm{\\overline{Sn}}",
    mass: 96803.7595476,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501050,
    name: "Sn105",
    latex: "^{105}\\mathrm{Sn}",
    mass: 97733.5424967,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501050,
    name: "Sn105~",
    latex: "^{105}\\mathrm{\\overline{Sn}}",
    mass: 97733.5424967,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501060,
    name: "Sn106",
    latex: "^{106}\\mathrm{Sn}",
    mass: 98661.0209293,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501060,
    name: "Sn106~",
    latex: "^{106}\\mathrm{\\overline{Sn}}",
    mass: 98661.0209293,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501070,
    name: "Sn107",
    latex: "^{107}\\mathrm{Sn}",
    mass: 99591.3571859,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501070,
    name: "Sn107~",
    latex: "^{107}\\mathrm{\\overline{Sn}}",
    mass: 99591.3571859,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501080,
    name: "Sn108",
    latex: "^{108}\\mathrm{Sn}",
    mass: 100519.2929821,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501080,
    name: "Sn108~",
    latex: "^{108}\\mathrm{\\overline{Sn}}",
    mass: 100519.2929821,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501090,
    name: "Sn109",
    latex: "^{109}\\mathrm{Sn}",
    mass: 101450.2272579,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501090,
    name: "Sn109~",
    latex: "^{109}\\mathrm{\\overline{Sn}}",
    mass: 101450.2272579,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501100,
    name: "Sn110",
    latex: "^{110}\\mathrm{Sn}",
    mass: 102378.5095699,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501100,
    name: "Sn110~",
    latex: "^{110}\\mathrm{\\overline{Sn}}",
    mass: 102378.5095699,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501110,
    name: "Sn111",
    latex: "^{111}\\mathrm{Sn}",
    mass: 103309.9067982,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501110,
    name: "Sn111~",
    latex: "^{111}\\mathrm{\\overline{Sn}}",
    mass: 103309.9067982,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501120,
    name: "Sn112",
    latex: "^{112}\\mathrm{Sn}",
    mass: 104238.684572,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501120,
    name: "Sn112~",
    latex: "^{112}\\mathrm{\\overline{Sn}}",
    mass: 104238.684572,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501130,
    name: "Sn113",
    latex: "^{113}\\mathrm{Sn}",
    mass: 105170.5056302,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501130,
    name: "Sn113~",
    latex: "^{113}\\mathrm{\\overline{Sn}}",
    mass: 105170.5056302,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501140,
    name: "Sn114",
    latex: "^{114}\\mathrm{Sn}",
    mass: 106099.7680882,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501140,
    name: "Sn114~",
    latex: "^{114}\\mathrm{\\overline{Sn}}",
    mass: 106099.7680882,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501150,
    name: "Sn115",
    latex: "^{115}\\mathrm{Sn}",
    mass: 107031.7880819,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501150,
    name: "Sn115~",
    latex: "^{115}\\mathrm{\\overline{Sn}}",
    mass: 107031.7880819,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501160,
    name: "Sn116",
    latex: "^{116}\\mathrm{Sn}",
    mass: 107961.7900569,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501160,
    name: "Sn116~",
    latex: "^{116}\\mathrm{\\overline{Sn}}",
    mass: 107961.7900569,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501170,
    name: "Sn117",
    latex: "^{117}\\mathrm{Sn}",
    mass: 108894.4123583,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501170,
    name: "Sn117~",
    latex: "^{117}\\mathrm{\\overline{Sn}}",
    mass: 108894.4123583,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501180,
    name: "Sn118",
    latex: "^{118}\\mathrm{Sn}",
    mass: 109824.6513668,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501180,
    name: "Sn118~",
    latex: "^{118}\\mathrm{\\overline{Sn}}",
    mass: 109824.6513668,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501190,
    name: "Sn119",
    latex: "^{119}\\mathrm{Sn}",
    mass: 110757.7333886,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501190,
    name: "Sn119~",
    latex: "^{119}\\mathrm{\\overline{Sn}}",
    mass: 110757.7333886,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501200,
    name: "Sn120",
    latex: "^{120}\\mathrm{Sn}",
    mass: 111688.1947448,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501200,
    name: "Sn120~",
    latex: "^{120}\\mathrm{\\overline{Sn}}",
    mass: 111688.1947448,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501210,
    name: "Sn121",
    latex: "^{121}\\mathrm{Sn}",
    mass: 112621.5899348,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501210,
    name: "Sn121~",
    latex: "^{121}\\mathrm{\\overline{Sn}}",
    mass: 112621.5899348,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501220,
    name: "Sn122",
    latex: "^{122}\\mathrm{Sn}",
    mass: 113552.3407062,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501220,
    name: "Sn122~",
    latex: "^{122}\\mathrm{\\overline{Sn}}",
    mass: 113552.3407062,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501230,
    name: "Sn123",
    latex: "^{123}\\mathrm{Sn}",
    mass: 114485.9601069,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501230,
    name: "Sn123~",
    latex: "^{123}\\mathrm{\\overline{Sn}}",
    mass: 114485.9601069,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501240,
    name: "Sn124",
    latex: "^{124}\\mathrm{Sn}",
    mass: 115417.037367,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501240,
    name: "Sn124~",
    latex: "^{124}\\mathrm{\\overline{Sn}}",
    mass: 115417.037367,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501250,
    name: "Sn125",
    latex: "^{125}\\mathrm{Sn}",
    mass: 116350.8693346,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501250,
    name: "Sn125~",
    latex: "^{125}\\mathrm{\\overline{Sn}}",
    mass: 116350.8693346,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501260,
    name: "Sn126",
    latex: "^{126}\\mathrm{Sn}",
    mass: 117282.2419715,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501260,
    name: "Sn126~",
    latex: "^{126}\\mathrm{\\overline{Sn}}",
    mass: 117282.2419715,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501270,
    name: "Sn127",
    latex: "^{127}\\mathrm{Sn}",
    mass: 118216.2818486,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501270,
    name: "Sn127~",
    latex: "^{127}\\mathrm{\\overline{Sn}}",
    mass: 118216.2818486,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501280,
    name: "Sn128",
    latex: "^{128}\\mathrm{Sn}",
    mass: 119147.8840056,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501280,
    name: "Sn128~",
    latex: "^{128}\\mathrm{\\overline{Sn}}",
    mass: 119147.8840056,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501290,
    name: "Sn129",
    latex: "^{129}\\mathrm{Sn}",
    mass: 120082.1483728,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501290,
    name: "Sn129~",
    latex: "^{129}\\mathrm{\\overline{Sn}}",
    mass: 120082.1483728,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501300,
    name: "Sn130",
    latex: "^{130}\\mathrm{Sn}",
    mass: 121014.1012374,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501300,
    name: "Sn130~",
    latex: "^{130}\\mathrm{\\overline{Sn}}",
    mass: 121014.1012374,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501310,
    name: "Sn131",
    latex: "^{131}\\mathrm{Sn}",
    mass: 121948.4629457,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501310,
    name: "Sn131~",
    latex: "^{131}\\mathrm{\\overline{Sn}}",
    mass: 121948.4629457,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501320,
    name: "Sn132",
    latex: "^{132}\\mathrm{Sn}",
    mass: 122880.6751382,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501320,
    name: "Sn132~",
    latex: "^{132}\\mathrm{\\overline{Sn}}",
    mass: 122880.6751382,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501330,
    name: "Sn133",
    latex: "^{133}\\mathrm{Sn}",
    mass: 123817.8419479,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501330,
    name: "Sn133~",
    latex: "^{133}\\mathrm{\\overline{Sn}}",
    mass: 123817.8419479,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501340,
    name: "Sn134",
    latex: "^{134}\\mathrm{Sn}",
    mass: 124753.7757388,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501340,
    name: "Sn134~",
    latex: "^{134}\\mathrm{\\overline{Sn}}",
    mass: 124753.7757388,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501350,
    name: "Sn135",
    latex: "^{135}\\mathrm{Sn}",
    mass: 125691.0721193,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501350,
    name: "Sn135~",
    latex: "^{135}\\mathrm{\\overline{Sn}}",
    mass: 125691.0721193,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501360,
    name: "Sn136",
    latex: "^{136}\\mathrm{Sn}",
    mass: 126627.0290113,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501360,
    name: "Sn136~",
    latex: "^{136}\\mathrm{\\overline{Sn}}",
    mass: 126627.0290113,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000501370,
    name: "Sn137",
    latex: "^{137}\\mathrm{Sn}",
    mass: 127564.5405669,
    width: undefined,
    charge: 50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000501370,
    name: "Sn137~",
    latex: "^{137}\\mathrm{\\overline{Sn}}",
    mass: 127564.5405669,
    width: undefined,
    charge: -50.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511030,
    name: "Sb103",
    latex: "^{103}\\mathrm{Sb}",
    mass: 95887.2205817,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511030,
    name: "Sb103~",
    latex: "^{103}\\mathrm{\\overline{Sb}}",
    mass: 95887.2205817,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511040,
    name: "Sb104",
    latex: "^{104}\\mathrm{Sb}",
    mass: 96816.0878721,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511040,
    name: "Sb104~",
    latex: "^{104}\\mathrm{\\overline{Sb}}",
    mass: 96816.0878721,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511050,
    name: "Sb105",
    latex: "^{105}\\mathrm{Sb}",
    mass: 97742.8658212,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511050,
    name: "Sb105~",
    latex: "^{105}\\mathrm{\\overline{Sb}}",
    mass: 97742.8658212,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511060,
    name: "Sb106",
    latex: "^{106}\\mathrm{Sb}",
    mass: 98671.9017119,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511060,
    name: "Sb106~",
    latex: "^{106}\\mathrm{\\overline{Sb}}",
    mass: 98671.9017119,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511070,
    name: "Sb107",
    latex: "^{107}\\mathrm{Sb}",
    mass: 99599.2162016,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511070,
    name: "Sb107~",
    latex: "^{107}\\mathrm{\\overline{Sb}}",
    mass: 99599.2162016,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511080,
    name: "Sb108",
    latex: "^{108}\\mathrm{Sb}",
    mass: 100528.9181107,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511080,
    name: "Sb108~",
    latex: "^{108}\\mathrm{\\overline{Sb}}",
    mass: 100528.9181107,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511090,
    name: "Sb109",
    latex: "^{109}\\mathrm{Sb}",
    mass: 101456.6061295,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511090,
    name: "Sb109~",
    latex: "^{109}\\mathrm{\\overline{Sb}}",
    mass: 101456.6061295,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511100,
    name: "Sb110",
    latex: "^{110}\\mathrm{Sb}",
    mass: 102386.9014003,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511100,
    name: "Sb110~",
    latex: "^{110}\\mathrm{\\overline{Sb}}",
    mass: 102386.9014003,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511110,
    name: "Sb111",
    latex: "^{111}\\mathrm{Sb}",
    mass: 103315.0085915,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511110,
    name: "Sb111~",
    latex: "^{111}\\mathrm{\\overline{Sb}}",
    mass: 103315.0085915,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511120,
    name: "Sb112",
    latex: "^{112}\\mathrm{Sb}",
    mass: 104245.740733,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511120,
    name: "Sb112~",
    latex: "^{112}\\mathrm{\\overline{Sb}}",
    mass: 104245.740733,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511130,
    name: "Sb113",
    latex: "^{113}\\mathrm{Sb}",
    mass: 105174.417067,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511130,
    name: "Sb113~",
    latex: "^{113}\\mathrm{\\overline{Sb}}",
    mass: 105174.417067,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511140,
    name: "Sb114",
    latex: "^{114}\\mathrm{Sb}",
    mass: 106105.8310623,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511140,
    name: "Sb114~",
    latex: "^{114}\\mathrm{\\overline{Sb}}",
    mass: 106105.8310623,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511150,
    name: "Sb115",
    latex: "^{115}\\mathrm{Sb}",
    mass: 107034.8185154,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511150,
    name: "Sb115~",
    latex: "^{115}\\mathrm{\\overline{Sb}}",
    mass: 107034.8185154,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511160,
    name: "Sb116",
    latex: "^{116}\\mathrm{Sb}",
    mass: 107966.4942604,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511160,
    name: "Sb116~",
    latex: "^{116}\\mathrm{\\overline{Sb}}",
    mass: 107966.4942604,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511170,
    name: "Sb117",
    latex: "^{117}\\mathrm{Sb}",
    mass: 108896.1710192,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511170,
    name: "Sb117~",
    latex: "^{117}\\mathrm{\\overline{Sb}}",
    mass: 108896.1710192,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511180,
    name: "Sb118",
    latex: "^{118}\\mathrm{Sb}",
    mass: 109828.3078538,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511180,
    name: "Sb118~",
    latex: "^{118}\\mathrm{\\overline{Sb}}",
    mass: 109828.3078538,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511190,
    name: "Sb119",
    latex: "^{119}\\mathrm{Sb}",
    mass: 110758.3227449,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511190,
    name: "Sb119~",
    latex: "^{119}\\mathrm{\\overline{Sb}}",
    mass: 110758.3227449,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511200,
    name: "Sb120",
    latex: "^{120}\\mathrm{Sb}",
    mass: 111690.8750259,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511200,
    name: "Sb120~",
    latex: "^{120}\\mathrm{\\overline{Sb}}",
    mass: 111690.8750259,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511210,
    name: "Sb121",
    latex: "^{121}\\mathrm{Sb}",
    mass: 112621.1874362,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511210,
    name: "Sb121~",
    latex: "^{121}\\mathrm{\\overline{Sb}}",
    mass: 112621.1874362,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511220,
    name: "Sb122",
    latex: "^{122}\\mathrm{Sb}",
    mass: 113553.9464158,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511220,
    name: "Sb122~",
    latex: "^{122}\\mathrm{\\overline{Sb}}",
    mass: 113553.9464158,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511230,
    name: "Sb123",
    latex: "^{123}\\mathrm{Sb}",
    mass: 114484.5518741,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511230,
    name: "Sb123~",
    latex: "^{123}\\mathrm{\\overline{Sb}}",
    mass: 114484.5518741,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511240,
    name: "Sb124",
    latex: "^{124}\\mathrm{Sb}",
    mass: 115417.6498244,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511240,
    name: "Sb124~",
    latex: "^{124}\\mathrm{\\overline{Sb}}",
    mass: 115417.6498244,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511250,
    name: "Sb125",
    latex: "^{125}\\mathrm{Sb}",
    mass: 116348.5079039,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511250,
    name: "Sb125~",
    latex: "^{125}\\mathrm{\\overline{Sb}}",
    mass: 116348.5079039,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511260,
    name: "Sb126",
    latex: "^{126}\\mathrm{Sb}",
    mass: 117281.8609904,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511260,
    name: "Sb126~",
    latex: "^{126}\\mathrm{\\overline{Sb}}",
    mass: 117281.8609904,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511270,
    name: "Sb127",
    latex: "^{127}\\mathrm{Sb}",
    mass: 118213.05329,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511270,
    name: "Sb127~",
    latex: "^{127}\\mathrm{\\overline{Sb}}",
    mass: 118213.05329,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511280,
    name: "Sb128",
    latex: "^{128}\\mathrm{Sb}",
    mass: 119146.6153107,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511280,
    name: "Sb128~",
    latex: "^{128}\\mathrm{\\overline{Sb}}",
    mass: 119146.6153107,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511290,
    name: "Sb129",
    latex: "^{129}\\mathrm{Sb}",
    mass: 120078.1103459,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511290,
    name: "Sb129~",
    latex: "^{129}\\mathrm{\\overline{Sb}}",
    mass: 120078.1103459,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511300,
    name: "Sb130",
    latex: "^{130}\\mathrm{Sb}",
    mass: 121011.9480888,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511300,
    name: "Sb130~",
    latex: "^{130}\\mathrm{\\overline{Sb}}",
    mass: 121011.9480888,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511310,
    name: "Sb131",
    latex: "^{131}\\mathrm{Sb}",
    mass: 121943.746139,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511310,
    name: "Sb131~",
    latex: "^{131}\\mathrm{\\overline{Sb}}",
    mass: 121943.746139,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511320,
    name: "Sb132",
    latex: "^{132}\\mathrm{Sb}",
    mass: 122877.5863969,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511320,
    name: "Sb132~",
    latex: "^{132}\\mathrm{\\overline{Sb}}",
    mass: 122877.5863969,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511330,
    name: "Sb133",
    latex: "^{133}\\mathrm{Sb}",
    mass: 123809.7921621,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511330,
    name: "Sb133~",
    latex: "^{133}\\mathrm{\\overline{Sb}}",
    mass: 123809.7921621,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511340,
    name: "Sb134",
    latex: "^{134}\\mathrm{Sb}",
    mass: 124746.1905823,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511340,
    name: "Sb134~",
    latex: "^{134}\\mathrm{\\overline{Sb}}",
    mass: 124746.1905823,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511350,
    name: "Sb135",
    latex: "^{135}\\mathrm{Sb}",
    mass: 125682.0137117,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511350,
    name: "Sb135~",
    latex: "^{135}\\mathrm{\\overline{Sb}}",
    mass: 125682.0137117,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511360,
    name: "Sb136",
    latex: "^{136}\\mathrm{Sb}",
    mass: 126618.6912075,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511360,
    name: "Sb136~",
    latex: "^{136}\\mathrm{\\overline{Sb}}",
    mass: 126618.6912075,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511370,
    name: "Sb137",
    latex: "^{137}\\mathrm{Sb}",
    mass: 127554.6294696,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511370,
    name: "Sb137~",
    latex: "^{137}\\mathrm{\\overline{Sb}}",
    mass: 127554.6294696,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511380,
    name: "Sb138",
    latex: "^{138}\\mathrm{Sb}",
    mass: 128491.5355541,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511380,
    name: "Sb138~",
    latex: "^{138}\\mathrm{\\overline{Sb}}",
    mass: 128491.5355541,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000511390,
    name: "Sb139",
    latex: "^{139}\\mathrm{Sb}",
    mass: 129427.6312387,
    width: undefined,
    charge: 51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000511390,
    name: "Sb139~",
    latex: "^{139}\\mathrm{\\overline{Sb}}",
    mass: 129427.6312387,
    width: undefined,
    charge: -51.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521060,
    name: "Te106",
    latex: "^{106}\\mathrm{Te}",
    mass: 98680.1566127,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521060,
    name: "Te106~",
    latex: "^{106}\\mathrm{\\overline{Te}}",
    mass: 98680.1566127,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521070,
    name: "Te107",
    latex: "^{107}\\mathrm{Te}",
    mass: 99609.2102019,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521070,
    name: "Te107~",
    latex: "^{107}\\mathrm{\\overline{Te}}",
    mass: 99609.2102019,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521080,
    name: "Te108",
    latex: "^{108}\\mathrm{Te}",
    mass: 100535.581088,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521080,
    name: "Te108~",
    latex: "^{108}\\mathrm{\\overline{Te}}",
    mass: 100535.581088,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521090,
    name: "Te109",
    latex: "^{109}\\mathrm{Te}",
    mass: 101465.1423415,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521090,
    name: "Te109~",
    latex: "^{109}\\mathrm{\\overline{Te}}",
    mass: 101465.1423415,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521100,
    name: "Te110",
    latex: "^{110}\\mathrm{Te}",
    mass: 102392.1214933,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521100,
    name: "Te110~",
    latex: "^{110}\\mathrm{\\overline{Te}}",
    mass: 102392.1214933,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521110,
    name: "Te111",
    latex: "^{111}\\mathrm{Te}",
    mass: 103322.2584101,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521110,
    name: "Te111~",
    latex: "^{111}\\mathrm{\\overline{Te}}",
    mass: 103322.2584101,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521120,
    name: "Te112",
    latex: "^{112}\\mathrm{Te}",
    mass: 104249.7722395,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521120,
    name: "Te112~",
    latex: "^{112}\\mathrm{\\overline{Te}}",
    mass: 104249.7722395,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521130,
    name: "Te113",
    latex: "^{113}\\mathrm{Te}",
    mass: 105180.4857511,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521130,
    name: "Te113~",
    latex: "^{113}\\mathrm{\\overline{Te}}",
    mass: 105180.4857511,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521140,
    name: "Te114",
    latex: "^{114}\\mathrm{Te}",
    mass: 106108.4383143,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521140,
    name: "Te114~",
    latex: "^{114}\\mathrm{\\overline{Te}}",
    mass: 106108.4383143,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521150,
    name: "Te115",
    latex: "^{115}\\mathrm{Te}",
    mass: 107039.7572971,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521150,
    name: "Te115~",
    latex: "^{115}\\mathrm{\\overline{Te}}",
    mass: 107039.7572971,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521160,
    name: "Te116",
    latex: "^{116}\\mathrm{Te}",
    mass: 107968.0526501,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521160,
    name: "Te116~",
    latex: "^{116}\\mathrm{\\overline{Te}}",
    mass: 107968.0526501,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521170,
    name: "Te117",
    latex: "^{117}\\mathrm{Te}",
    mass: 108899.7144227,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521170,
    name: "Te117~",
    latex: "^{117}\\mathrm{\\overline{Te}}",
    mass: 108899.7144227,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521180,
    name: "Te118",
    latex: "^{118}\\mathrm{Te}",
    mass: 109828.6133839,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521180,
    name: "Te118~",
    latex: "^{118}\\mathrm{\\overline{Te}}",
    mass: 109828.6133839,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521190,
    name: "Te119",
    latex: "^{119}\\mathrm{Te}",
    mass: 110760.6160834,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521190,
    name: "Te119~",
    latex: "^{119}\\mathrm{\\overline{Te}}",
    mass: 110760.6160834,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521200,
    name: "Te120",
    latex: "^{120}\\mathrm{Te}",
    mass: 111689.9303046,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521200,
    name: "Te120~",
    latex: "^{120}\\mathrm{\\overline{Te}}",
    mass: 111689.9303046,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521210,
    name: "Te121",
    latex: "^{121}\\mathrm{Te}",
    mass: 112622.2433779,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521210,
    name: "Te121~",
    latex: "^{121}\\mathrm{\\overline{Te}}",
    mass: 112622.2433779,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521220,
    name: "Te122",
    latex: "^{122}\\mathrm{Te}",
    mass: 113551.9673634,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521220,
    name: "Te122~",
    latex: "^{122}\\mathrm{\\overline{Te}}",
    mass: 113551.9673634,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521230,
    name: "Te123",
    latex: "^{123}\\mathrm{Te}",
    mass: 114484.6037583,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521230,
    name: "Te123~",
    latex: "^{123}\\mathrm{\\overline{Te}}",
    mass: 114484.6037583,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521240,
    name: "Te124",
    latex: "^{124}\\mathrm{Te}",
    mass: 115414.7446806,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521240,
    name: "Te124~",
    latex: "^{124}\\mathrm{\\overline{Te}}",
    mass: 115414.7446806,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521250,
    name: "Te125",
    latex: "^{125}\\mathrm{Te}",
    mass: 116347.7411911,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521250,
    name: "Te125~",
    latex: "^{125}\\mathrm{\\overline{Te}}",
    mass: 116347.7411911,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521260,
    name: "Te126",
    latex: "^{126}\\mathrm{Te}",
    mass: 117278.1928598,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521260,
    name: "Te126~",
    latex: "^{126}\\mathrm{\\overline{Te}}",
    mass: 117278.1928598,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521270,
    name: "Te127",
    latex: "^{127}\\mathrm{Te}",
    mass: 118211.4706816,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521270,
    name: "Te127~",
    latex: "^{127}\\mathrm{\\overline{Te}}",
    mass: 118211.4706816,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521280,
    name: "Te128",
    latex: "^{128}\\mathrm{Te}",
    mass: 119142.2514471,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521280,
    name: "Te128~",
    latex: "^{128}\\mathrm{\\overline{Te}}",
    mass: 119142.2514471,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521290,
    name: "Te129",
    latex: "^{129}\\mathrm{Te}",
    mass: 120075.734477,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521290,
    name: "Te129~",
    latex: "^{129}\\mathrm{\\overline{Te}}",
    mass: 120075.734477,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521300,
    name: "Te130",
    latex: "^{130}\\mathrm{Te}",
    mass: 121006.8805233,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521300,
    name: "Te130~",
    latex: "^{130}\\mathrm{\\overline{Te}}",
    mass: 121006.8805233,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521310,
    name: "Te131",
    latex: "^{131}\\mathrm{Te}",
    mass: 121940.5165651,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521310,
    name: "Te131~",
    latex: "^{131}\\mathrm{\\overline{Te}}",
    mass: 121940.5165651,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521320,
    name: "Te132",
    latex: "^{132}\\mathrm{Te}",
    mass: 122872.0337606,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521320,
    name: "Te132~",
    latex: "^{132}\\mathrm{\\overline{Te}}",
    mass: 122872.0337606,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521330,
    name: "Te133",
    latex: "^{133}\\mathrm{Te}",
    mass: 123805.7786335,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521330,
    name: "Te133~",
    latex: "^{133}\\mathrm{\\overline{Te}}",
    mass: 123805.7786335,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521340,
    name: "Te134",
    latex: "^{134}\\mathrm{Te}",
    mass: 124737.6761673,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521340,
    name: "Te134~",
    latex: "^{134}\\mathrm{\\overline{Te}}",
    mass: 124737.6761673,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521350,
    name: "Te135",
    latex: "^{135}\\mathrm{Te}",
    mass: 125673.9751971,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521350,
    name: "Te135~",
    latex: "^{135}\\mathrm{\\overline{Te}}",
    mass: 125673.9751971,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521360,
    name: "Te136",
    latex: "^{136}\\mathrm{Te}",
    mass: 126608.7728446,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521360,
    name: "Te136~",
    latex: "^{136}\\mathrm{\\overline{Te}}",
    mass: 126608.7728446,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521370,
    name: "Te137",
    latex: "^{137}\\mathrm{Te}",
    mass: 127545.3884892,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521370,
    name: "Te137~",
    latex: "^{137}\\mathrm{\\overline{Te}}",
    mass: 127545.3884892,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521380,
    name: "Te138",
    latex: "^{138}\\mathrm{Te}",
    mass: 128480.489897,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521380,
    name: "Te138~",
    latex: "^{138}\\mathrm{\\overline{Te}}",
    mass: 128480.489897,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521390,
    name: "Te139",
    latex: "^{139}\\mathrm{Te}",
    mass: 129417.4751585,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521390,
    name: "Te139~",
    latex: "^{139}\\mathrm{\\overline{Te}}",
    mass: 129417.4751585,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521400,
    name: "Te140",
    latex: "^{140}\\mathrm{Te}",
    mass: 130352.8070179,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521400,
    name: "Te140~",
    latex: "^{140}\\mathrm{\\overline{Te}}",
    mass: 130352.8070179,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521410,
    name: "Te141",
    latex: "^{141}\\mathrm{Te}",
    mass: 131289.9953451,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521410,
    name: "Te141~",
    latex: "^{141}\\mathrm{\\overline{Te}}",
    mass: 131289.9953451,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000521420,
    name: "Te142",
    latex: "^{142}\\mathrm{Te}",
    mass: 132225.6159677,
    width: undefined,
    charge: 52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000521420,
    name: "Te142~",
    latex: "^{142}\\mathrm{\\overline{Te}}",
    mass: 132225.6159677,
    width: undefined,
    charge: -52.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531080,
    name: "I108",
    latex: "^{108}\\mathrm{I}",
    mass: 100548.5940606,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531080,
    name: "I108~",
    latex: "^{108}\\mathrm{\\overline{I}}",
    mass: 100548.5940606,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531090,
    name: "I109",
    latex: "^{109}\\mathrm{I}",
    mass: 101475.1847794,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531090,
    name: "I109~",
    latex: "^{109}\\mathrm{\\overline{I}}",
    mass: 101475.1847794,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531100,
    name: "I110",
    latex: "^{110}\\mathrm{I}",
    mass: 102403.8881268,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531100,
    name: "I110~",
    latex: "^{110}\\mathrm{\\overline{I}}",
    mass: 102403.8881268,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531110,
    name: "I111",
    latex: "^{111}\\mathrm{I}",
    mass: 103330.8914974,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531110,
    name: "I111~",
    latex: "^{111}\\mathrm{\\overline{I}}",
    mass: 103330.8914974,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531120,
    name: "I112",
    latex: "^{112}\\mathrm{I}",
    mass: 104260.2766985,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531120,
    name: "I112~",
    latex: "^{112}\\mathrm{\\overline{I}}",
    mass: 104260.2766985,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531130,
    name: "I113",
    latex: "^{113}\\mathrm{I}",
    mass: 105187.7141454,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531130,
    name: "I113~",
    latex: "^{113}\\mathrm{\\overline{I}}",
    mass: 105187.7141454,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531140,
    name: "I114",
    latex: "^{114}\\mathrm{I}",
    mass: 106117.6889822,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531140,
    name: "I114~",
    latex: "^{114}\\mathrm{\\overline{I}}",
    mass: 106117.6889822,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531150,
    name: "I115",
    latex: "^{115}\\mathrm{I}",
    mass: 107045.4859858,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531150,
    name: "I115~",
    latex: "^{115}\\mathrm{\\overline{I}}",
    mass: 107045.4859858,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531160,
    name: "I116",
    latex: "^{116}\\mathrm{I}",
    mass: 107975.8995564,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531160,
    name: "I116~",
    latex: "^{116}\\mathrm{\\overline{I}}",
    mass: 107975.8995564,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531170,
    name: "I117",
    latex: "^{117}\\mathrm{I}",
    mass: 108904.3718932,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531170,
    name: "I117~",
    latex: "^{117}\\mathrm{\\overline{I}}",
    mass: 108904.3718932,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531180,
    name: "I118",
    latex: "^{118}\\mathrm{I}",
    mass: 109835.3331823,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531180,
    name: "I118~",
    latex: "^{118}\\mathrm{\\overline{I}}",
    mass: 109835.3331823,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531190,
    name: "I119",
    latex: "^{119}\\mathrm{I}",
    mass: 110764.0206943,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531190,
    name: "I119~",
    latex: "^{119}\\mathrm{\\overline{I}}",
    mass: 110764.0206943,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531200,
    name: "I120",
    latex: "^{120}\\mathrm{I}",
    mass: 111695.5455373,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531200,
    name: "I120~",
    latex: "^{120}\\mathrm{\\overline{I}}",
    mass: 111695.5455373,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531210,
    name: "I121",
    latex: "^{121}\\mathrm{I}",
    mass: 112624.5404424,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531210,
    name: "I121~",
    latex: "^{121}\\mathrm{\\overline{I}}",
    mass: 112624.5404424,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531220,
    name: "I122",
    latex: "^{122}\\mathrm{I}",
    mass: 113556.2012835,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531220,
    name: "I122~",
    latex: "^{122}\\mathrm{\\overline{I}}",
    mass: 113556.2012835,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531230,
    name: "I123",
    latex: "^{123}\\mathrm{I}",
    mass: 114485.8323991,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531230,
    name: "I123~",
    latex: "^{123}\\mathrm{\\overline{I}}",
    mass: 114485.8323991,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531240,
    name: "I124",
    latex: "^{124}\\mathrm{I}",
    mass: 115417.9043086,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531240,
    name: "I124~",
    latex: "^{124}\\mathrm{\\overline{I}}",
    mass: 115417.9043086,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531250,
    name: "I125",
    latex: "^{125}\\mathrm{I}",
    mass: 116347.926931,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531250,
    name: "I125~",
    latex: "^{125}\\mathrm{\\overline{I}}",
    mass: 116347.926931,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531260,
    name: "I126",
    latex: "^{126}\\mathrm{I}",
    mass: 117280.346381,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531260,
    name: "I126~",
    latex: "^{126}\\mathrm{\\overline{I}}",
    mass: 117280.346381,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531270,
    name: "I127",
    latex: "^{127}\\mathrm{I}",
    mass: 118210.768335,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531270,
    name: "I127~",
    latex: "^{127}\\mathrm{\\overline{I}}",
    mass: 118210.768335,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531280,
    name: "I128",
    latex: "^{128}\\mathrm{I}",
    mass: 119143.5069149,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531280,
    name: "I128~",
    latex: "^{128}\\mathrm{\\overline{I}}",
    mass: 119143.5069149,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531290,
    name: "I129",
    latex: "^{129}\\mathrm{I}",
    mass: 120074.2325359,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531290,
    name: "I129~",
    latex: "^{129}\\mathrm{\\overline{I}}",
    mass: 120074.2325359,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531300,
    name: "I130",
    latex: "^{130}\\mathrm{I}",
    mass: 121007.2971387,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531300,
    name: "I130~",
    latex: "^{130}\\mathrm{\\overline{I}}",
    mass: 121007.2971387,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531310,
    name: "I131",
    latex: "^{131}\\mathrm{I}",
    mass: 121938.2848822,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531310,
    name: "I131~",
    latex: "^{131}\\mathrm{\\overline{I}}",
    mass: 121938.2848822,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531320,
    name: "I132",
    latex: "^{132}\\mathrm{I}",
    mass: 122871.5186443,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531320,
    name: "I132~",
    latex: "^{132}\\mathrm{\\overline{I}}",
    mass: 122871.5186443,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531330,
    name: "I133",
    latex: "^{133}\\mathrm{I}",
    mass: 123802.85812,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531330,
    name: "I133~",
    latex: "^{133}\\mathrm{\\overline{I}}",
    mass: 123802.85812,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531340,
    name: "I134",
    latex: "^{134}\\mathrm{I}",
    mass: 124736.1667743,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531340,
    name: "I134~",
    latex: "^{134}\\mathrm{\\overline{I}}",
    mass: 124736.1667743,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531350,
    name: "I135",
    latex: "^{135}\\mathrm{I}",
    mass: 125667.9248634,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531350,
    name: "I135~",
    latex: "^{135}\\mathrm{\\overline{I}}",
    mass: 125667.9248634,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531360,
    name: "I136",
    latex: "^{136}\\mathrm{I}",
    mass: 126603.6531667,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531360,
    name: "I136~",
    latex: "^{136}\\mathrm{\\overline{I}}",
    mass: 126603.6531667,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531370,
    name: "I137",
    latex: "^{137}\\mathrm{I}",
    mass: 127538.3357748,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531370,
    name: "I137~",
    latex: "^{137}\\mathrm{\\overline{I}}",
    mass: 127538.3357748,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531380,
    name: "I138",
    latex: "^{138}\\mathrm{I}",
    mass: 128474.2060378,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531380,
    name: "I138~",
    latex: "^{138}\\mathrm{\\overline{I}}",
    mass: 128474.2060378,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531390,
    name: "I139",
    latex: "^{139}\\mathrm{I}",
    mass: 129409.2090798,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531390,
    name: "I139~",
    latex: "^{139}\\mathrm{\\overline{I}}",
    mass: 129409.2090798,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531400,
    name: "I140",
    latex: "^{140}\\mathrm{I}",
    mass: 130345.5683772,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531400,
    name: "I140~",
    latex: "^{140}\\mathrm{\\overline{I}}",
    mass: 130345.5683772,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531410,
    name: "I141",
    latex: "^{141}\\mathrm{I}",
    mass: 131280.7418826,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531410,
    name: "I141~",
    latex: "^{141}\\mathrm{\\overline{I}}",
    mass: 131280.7418826,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531420,
    name: "I142",
    latex: "^{142}\\mathrm{I}",
    mass: 132217.3601354,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531420,
    name: "I142~",
    latex: "^{142}\\mathrm{\\overline{I}}",
    mass: 132217.3601354,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531430,
    name: "I143",
    latex: "^{143}\\mathrm{I}",
    mass: 133152.8717732,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531430,
    name: "I143~",
    latex: "^{143}\\mathrm{\\overline{I}}",
    mass: 133152.8717732,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000531440,
    name: "I144",
    latex: "^{144}\\mathrm{I}",
    mass: 134089.8244324,
    width: undefined,
    charge: 53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000531440,
    name: "I144~",
    latex: "^{144}\\mathrm{\\overline{I}}",
    mass: 134089.8244324,
    width: undefined,
    charge: -53.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541100,
    name: "Xe110",
    latex: "^{110}\\mathrm{Xe}",
    mass: 102412.4299277,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541100,
    name: "Xe110~",
    latex: "^{110}\\mathrm{\\overline{Xe}}",
    mass: 102412.4299277,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541110,
    name: "Xe111",
    latex: "^{111}\\mathrm{Xe}",
    mass: 103341.3251629,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541110,
    name: "Xe111~",
    latex: "^{111}\\mathrm{\\overline{Xe}}",
    mass: 103341.3251629,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541120,
    name: "Xe112",
    latex: "^{112}\\mathrm{Xe}",
    mass: 104267.3132049,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541120,
    name: "Xe112~",
    latex: "^{112}\\mathrm{\\overline{Xe}}",
    mass: 104267.3132049,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541130,
    name: "Xe113",
    latex: "^{113}\\mathrm{Xe}",
    mass: 105196.6304069,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541130,
    name: "Xe113~",
    latex: "^{113}\\mathrm{\\overline{Xe}}",
    mass: 105196.6304069,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541140,
    name: "Xe114",
    latex: "^{114}\\mathrm{Xe}",
    mass: 106123.2416186,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541140,
    name: "Xe114~",
    latex: "^{114}\\mathrm{\\overline{Xe}}",
    mass: 106123.2416186,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541150,
    name: "Xe115",
    latex: "^{115}\\mathrm{Xe}",
    mass: 107053.1652232,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541150,
    name: "Xe115~",
    latex: "^{115}\\mathrm{\\overline{Xe}}",
    mass: 107053.1652232,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541160,
    name: "Xe116",
    latex: "^{116}\\mathrm{Xe}",
    mass: 107980.2691952,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541160,
    name: "Xe116~",
    latex: "^{116}\\mathrm{\\overline{Xe}}",
    mass: 107980.2691952,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541170,
    name: "Xe117",
    latex: "^{117}\\mathrm{Xe}",
    mass: 108910.6250132,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541170,
    name: "Xe117~",
    latex: "^{117}\\mathrm{\\overline{Xe}}",
    mass: 108910.6250132,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541180,
    name: "Xe118",
    latex: "^{118}\\mathrm{Xe}",
    mass: 109838.2254715,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541180,
    name: "Xe118~",
    latex: "^{118}\\mathrm{\\overline{Xe}}",
    mass: 109838.2254715,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541190,
    name: "Xe119",
    latex: "^{119}\\mathrm{Xe}",
    mass: 110769.0041878,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541190,
    name: "Xe119~",
    latex: "^{119}\\mathrm{\\overline{Xe}}",
    mass: 110769.0041878,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541200,
    name: "Xe120",
    latex: "^{120}\\mathrm{Xe}",
    mass: 111697.1197624,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541200,
    name: "Xe120~",
    latex: "^{120}\\mathrm{\\overline{Xe}}",
    mass: 111697.1197624,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541210,
    name: "Xe121",
    latex: "^{121}\\mathrm{Xe}",
    mass: 112628.3055415,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541210,
    name: "Xe121~",
    latex: "^{121}\\mathrm{\\overline{Xe}}",
    mass: 112628.3055415,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541220,
    name: "Xe122",
    latex: "^{122}\\mathrm{Xe}",
    mass: 113556.925986,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541220,
    name: "Xe122~",
    latex: "^{122}\\mathrm{\\overline{Xe}}",
    mass: 113556.925986,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541230,
    name: "Xe123",
    latex: "^{123}\\mathrm{Xe}",
    mass: 114488.52628,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541230,
    name: "Xe123~",
    latex: "^{123}\\mathrm{\\overline{Xe}}",
    mass: 114488.52628,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541240,
    name: "Xe124",
    latex: "^{124}\\mathrm{Xe}",
    mass: 115417.6014798,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541240,
    name: "Xe124~",
    latex: "^{124}\\mathrm{\\overline{Xe}}",
    mass: 115417.6014798,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541250,
    name: "Xe125",
    latex: "^{125}\\mathrm{Xe}",
    mass: 116349.5635662,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541250,
    name: "Xe125~",
    latex: "^{125}\\mathrm{\\overline{Xe}}",
    mass: 116349.5635662,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541260,
    name: "Xe126",
    latex: "^{126}\\mathrm{Xe}",
    mass: 117279.1106814,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541260,
    name: "Xe126~",
    latex: "^{126}\\mathrm{\\overline{Xe}}",
    mass: 117279.1106814,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541270,
    name: "Xe127",
    latex: "^{127}\\mathrm{Xe}",
    mass: 118211.4306273,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541270,
    name: "Xe127~",
    latex: "^{127}\\mathrm{\\overline{Xe}}",
    mass: 118211.4306273,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541280,
    name: "Xe128",
    latex: "^{128}\\mathrm{Xe}",
    mass: 119141.3847412,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541280,
    name: "Xe128~",
    latex: "^{128}\\mathrm{\\overline{Xe}}",
    mass: 119141.3847412,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541290,
    name: "Xe129",
    latex: "^{129}\\mathrm{Xe}",
    mass: 120074.0433094,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541290,
    name: "Xe129~",
    latex: "^{129}\\mathrm{\\overline{Xe}}",
    mass: 120074.0433094,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541300,
    name: "Xe130",
    latex: "^{130}\\mathrm{Xe}",
    mass: 121004.3530091,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541300,
    name: "Xe130~",
    latex: "^{130}\\mathrm{\\overline{Xe}}",
    mass: 121004.3530091,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541310,
    name: "Xe131",
    latex: "^{131}\\mathrm{Xe}",
    mass: 121937.314012,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541310,
    name: "Xe131~",
    latex: "^{131}\\mathrm{\\overline{Xe}}",
    mass: 121937.314012,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541320,
    name: "Xe132",
    latex: "^{132}\\mathrm{Xe}",
    mass: 122867.9427158,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541320,
    name: "Xe132~",
    latex: "^{132}\\mathrm{\\overline{Xe}}",
    mass: 122867.9427158,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541330,
    name: "Xe133",
    latex: "^{133}\\mathrm{Xe}",
    mass: 123801.0721664,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541330,
    name: "Xe133~",
    latex: "^{133}\\mathrm{\\overline{Xe}}",
    mass: 123801.0721664,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541340,
    name: "Xe134",
    latex: "^{134}\\mathrm{Xe}",
    mass: 124732.0840636,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541340,
    name: "Xe134~",
    latex: "^{134}\\mathrm{\\overline{Xe}}",
    mass: 124732.0840636,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541350,
    name: "Xe135",
    latex: "^{135}\\mathrm{Xe}",
    mass: 125665.2902255,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541350,
    name: "Xe135~",
    latex: "^{135}\\mathrm{\\overline{Xe}}",
    mass: 125665.2902255,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541360,
    name: "Xe136",
    latex: "^{136}\\mathrm{Xe}",
    mass: 126596.7689353,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541360,
    name: "Xe136~",
    latex: "^{136}\\mathrm{\\overline{Xe}}",
    mass: 126596.7689353,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541370,
    name: "Xe137",
    latex: "^{137}\\mathrm{Xe}",
    mass: 127532.3087937,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541370,
    name: "Xe137~",
    latex: "^{137}\\mathrm{\\overline{Xe}}",
    mass: 127532.3087937,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541380,
    name: "Xe138",
    latex: "^{138}\\mathrm{Xe}",
    mass: 128466.2138184,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541380,
    name: "Xe138~",
    latex: "^{138}\\mathrm{\\overline{Xe}}",
    mass: 128466.2138184,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541390,
    name: "Xe139",
    latex: "^{139}\\mathrm{Xe}",
    mass: 129402.03583,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541390,
    name: "Xe139~",
    latex: "^{139}\\mathrm{\\overline{Xe}}",
    mass: 129402.03583,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541400,
    name: "Xe140",
    latex: "^{140}\\mathrm{Xe}",
    mass: 130336.1880453,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541400,
    name: "Xe140~",
    latex: "^{140}\\mathrm{\\overline{Xe}}",
    mass: 130336.1880453,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541410,
    name: "Xe141",
    latex: "^{141}\\mathrm{Xe}",
    mass: 131272.4711465,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541410,
    name: "Xe141~",
    latex: "^{141}\\mathrm{\\overline{Xe}}",
    mass: 131272.4711465,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541420,
    name: "Xe142",
    latex: "^{142}\\mathrm{Xe}",
    mass: 132206.9330836,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541420,
    name: "Xe142~",
    latex: "^{142}\\mathrm{\\overline{Xe}}",
    mass: 132206.9330836,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541430,
    name: "Xe143",
    latex: "^{143}\\mathrm{Xe}",
    mass: 133143.4543678,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541430,
    name: "Xe143~",
    latex: "^{143}\\mathrm{\\overline{Xe}}",
    mass: 133143.4543678,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541440,
    name: "Xe144",
    latex: "^{144}\\mathrm{Xe}",
    mass: 134078.278563,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541440,
    name: "Xe144~",
    latex: "^{144}\\mathrm{\\overline{Xe}}",
    mass: 134078.278563,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541450,
    name: "Xe145",
    latex: "^{145}\\mathrm{Xe}",
    mass: 135015.1520451,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541450,
    name: "Xe145~",
    latex: "^{145}\\mathrm{\\overline{Xe}}",
    mass: 135015.1520451,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541460,
    name: "Xe146",
    latex: "^{146}\\mathrm{Xe}",
    mass: 135950.1839635,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541460,
    name: "Xe146~",
    latex: "^{146}\\mathrm{\\overline{Xe}}",
    mass: 135950.1839635,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000541470,
    name: "Xe147",
    latex: "^{147}\\mathrm{Xe}",
    mass: 136887.231635,
    width: undefined,
    charge: 54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000541470,
    name: "Xe147~",
    latex: "^{147}\\mathrm{\\overline{Xe}}",
    mass: 136887.231635,
    width: undefined,
    charge: -54.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551120,
    name: "Cs112",
    latex: "^{112}\\mathrm{Cs}",
    mass: 104280.9232653,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551120,
    name: "Cs112~",
    latex: "^{112}\\mathrm{\\overline{Cs}}",
    mass: 104280.9232653,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551130,
    name: "Cs113",
    latex: "^{113}\\mathrm{Cs}",
    mass: 105207.0687299,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551130,
    name: "Cs113~",
    latex: "^{113}\\mathrm{\\overline{Cs}}",
    mass: 105207.0687299,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551140,
    name: "Cs114",
    latex: "^{114}\\mathrm{Cs}",
    mass: 106135.6398051,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551140,
    name: "Cs114~",
    latex: "^{114}\\mathrm{\\overline{Cs}}",
    mass: 106135.6398051,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551150,
    name: "Cs115",
    latex: "^{115}\\mathrm{Cs}",
    mass: 107062.1224705,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551150,
    name: "Cs115~",
    latex: "^{115}\\mathrm{\\overline{Cs}}",
    mass: 107062.1224705,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551160,
    name: "Cs116",
    latex: "^{116}\\mathrm{Cs}",
    mass: 107991.278524,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551160,
    name: "Cs116~",
    latex: "^{116}\\mathrm{\\overline{Cs}}",
    mass: 107991.278524,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551170,
    name: "Cs117",
    latex: "^{117}\\mathrm{Cs}",
    mass: 108918.3200859,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551170,
    name: "Cs117~",
    latex: "^{117}\\mathrm{\\overline{Cs}}",
    mass: 108918.3200859,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551180,
    name: "Cs118",
    latex: "^{118}\\mathrm{Cs}",
    mass: 109847.8953118,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551180,
    name: "Cs118~",
    latex: "^{118}\\mathrm{\\overline{Cs}}",
    mass: 109847.8953118,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551190,
    name: "Cs119",
    latex: "^{119}\\mathrm{Cs}",
    mass: 110775.4929757,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551190,
    name: "Cs119~",
    latex: "^{119}\\mathrm{\\overline{Cs}}",
    mass: 110775.4929757,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551200,
    name: "Cs120",
    latex: "^{120}\\mathrm{Cs}",
    mass: 111705.4035394,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551200,
    name: "Cs120~",
    latex: "^{120}\\mathrm{\\overline{Cs}}",
    mass: 111705.4035394,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551210,
    name: "Cs121",
    latex: "^{121}\\mathrm{Cs}",
    mass: 112633.6839885,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551210,
    name: "Cs121~",
    latex: "^{121}\\mathrm{\\overline{Cs}}",
    mass: 112633.6839885,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551220,
    name: "Cs122",
    latex: "^{122}\\mathrm{Cs}",
    mass: 113564.1376133,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551220,
    name: "Cs122~",
    latex: "^{122}\\mathrm{\\overline{Cs}}",
    mass: 113564.1376133,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551230,
    name: "Cs123",
    latex: "^{123}\\mathrm{Cs}",
    mass: 114492.7310444,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551230,
    name: "Cs123~",
    latex: "^{123}\\mathrm{\\overline{Cs}}",
    mass: 114492.7310444,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551240,
    name: "Cs124",
    latex: "^{124}\\mathrm{Cs}",
    mass: 115423.527459,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551240,
    name: "Cs124~",
    latex: "^{124}\\mathrm{\\overline{Cs}}",
    mass: 115423.527459,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551250,
    name: "Cs125",
    latex: "^{125}\\mathrm{Cs}",
    mass: 116352.6732661,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551250,
    name: "Cs125~",
    latex: "^{125}\\mathrm{\\overline{Cs}}",
    mass: 116352.6732661,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551260,
    name: "Cs126",
    latex: "^{126}\\mathrm{Cs}",
    mass: 117283.9065515,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551260,
    name: "Cs126~",
    latex: "^{126}\\mathrm{\\overline{Cs}}",
    mass: 117283.9065515,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551270,
    name: "Cs127",
    latex: "^{127}\\mathrm{Cs}",
    mass: 118213.5115851,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551270,
    name: "Cs127~",
    latex: "^{127}\\mathrm{\\overline{Cs}}",
    mass: 118213.5115851,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551280,
    name: "Cs128",
    latex: "^{128}\\mathrm{Cs}",
    mass: 119145.3130819,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551280,
    name: "Cs128~",
    latex: "^{128}\\mathrm{\\overline{Cs}}",
    mass: 119145.3130819,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551290,
    name: "Cs129",
    latex: "^{129}\\mathrm{Cs}",
    mass: 120075.2404126,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551290,
    name: "Cs129~",
    latex: "^{129}\\mathrm{\\overline{Cs}}",
    mass: 120075.2404126,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551300,
    name: "Cs130",
    latex: "^{130}\\mathrm{Cs}",
    mass: 121007.333467,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551300,
    name: "Cs130~",
    latex: "^{130}\\mathrm{\\overline{Cs}}",
    mass: 121007.333467,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551310,
    name: "Cs131",
    latex: "^{131}\\mathrm{Cs}",
    mass: 121937.672015,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551310,
    name: "Cs131~",
    latex: "^{131}\\mathrm{\\overline{Cs}}",
    mass: 121937.672015,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551320,
    name: "Cs132",
    latex: "^{132}\\mathrm{Cs}",
    mass: 122870.0689601,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551320,
    name: "Cs132~",
    latex: "^{132}\\mathrm{\\overline{Cs}}",
    mass: 122870.0689601,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551330,
    name: "Cs133",
    latex: "^{133}\\mathrm{Cs}",
    mass: 123800.6448519,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551330,
    name: "Cs133~",
    latex: "^{133}\\mathrm{\\overline{Cs}}",
    mass: 123800.6448519,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551340,
    name: "Cs134",
    latex: "^{134}\\mathrm{Cs}",
    mass: 124733.3187329,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551340,
    name: "Cs134~",
    latex: "^{134}\\mathrm{\\overline{Cs}}",
    mass: 124733.3187329,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551350,
    name: "Cs135",
    latex: "^{135}\\mathrm{Cs}",
    mass: 125664.1220387,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551350,
    name: "Cs135~",
    latex: "^{135}\\mathrm{\\overline{Cs}}",
    mass: 125664.1220387,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551360,
    name: "Cs136",
    latex: "^{136}\\mathrm{Cs}",
    mass: 126596.8592213,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551360,
    name: "Cs136~",
    latex: "^{136}\\mathrm{\\overline{Cs}}",
    mass: 126596.8592213,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551370,
    name: "Cs137",
    latex: "^{137}\\mathrm{Cs}",
    mass: 127528.1464402,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551370,
    name: "Cs137~",
    latex: "^{137}\\mathrm{\\overline{Cs}}",
    mass: 127528.1464402,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551380,
    name: "Cs138",
    latex: "^{138}\\mathrm{Cs}",
    mass: 128463.2991733,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551380,
    name: "Cs138~",
    latex: "^{138}\\mathrm{\\overline{Cs}}",
    mass: 128463.2991733,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551390,
    name: "Cs139",
    latex: "^{139}\\mathrm{Cs}",
    mass: 129396.9794937,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551390,
    name: "Cs139~",
    latex: "^{139}\\mathrm{\\overline{Cs}}",
    mass: 129396.9794937,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551400,
    name: "Cs140",
    latex: "^{140}\\mathrm{Cs}",
    mass: 130332.1250543,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551400,
    name: "Cs140~",
    latex: "^{140}\\mathrm{\\overline{Cs}}",
    mass: 130332.1250543,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551410,
    name: "Cs141",
    latex: "^{141}\\mathrm{Cs}",
    mass: 131266.1910133,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551410,
    name: "Cs141~",
    latex: "^{141}\\mathrm{\\overline{Cs}}",
    mass: 131266.1910133,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551420,
    name: "Cs142",
    latex: "^{142}\\mathrm{Cs}",
    mass: 132201.6486244,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551420,
    name: "Cs142~",
    latex: "^{142}\\mathrm{\\overline{Cs}}",
    mass: 132201.6486244,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551430,
    name: "Cs143",
    latex: "^{143}\\mathrm{Cs}",
    mass: 133135.9809906,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551430,
    name: "Cs143~",
    latex: "^{143}\\mathrm{\\overline{Cs}}",
    mass: 133135.9809906,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551440,
    name: "Cs144",
    latex: "^{144}\\mathrm{Cs}",
    mass: 134071.8791985,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551440,
    name: "Cs144~",
    latex: "^{144}\\mathrm{\\overline{Cs}}",
    mass: 134071.8791985,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551450,
    name: "Cs145",
    latex: "^{145}\\mathrm{Cs}",
    mass: 135006.5906828,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551450,
    name: "Cs145~",
    latex: "^{145}\\mathrm{\\overline{Cs}}",
    mass: 135006.5906828,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551460,
    name: "Cs146",
    latex: "^{146}\\mathrm{Cs}",
    mass: 135942.828886,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551460,
    name: "Cs146~",
    latex: "^{146}\\mathrm{\\overline{Cs}}",
    mass: 135942.828886,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551470,
    name: "Cs147",
    latex: "^{147}\\mathrm{Cs}",
    mass: 136877.7136283,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551470,
    name: "Cs147~",
    latex: "^{147}\\mathrm{\\overline{Cs}}",
    mass: 136877.7136283,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551480,
    name: "Cs148",
    latex: "^{148}\\mathrm{Cs}",
    mass: 137814.2163758,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551480,
    name: "Cs148~",
    latex: "^{148}\\mathrm{\\overline{Cs}}",
    mass: 137814.2163758,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551490,
    name: "Cs149",
    latex: "^{149}\\mathrm{Cs}",
    mass: 138749.3256081,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551490,
    name: "Cs149~",
    latex: "^{149}\\mathrm{\\overline{Cs}}",
    mass: 138749.3256081,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551500,
    name: "Cs150",
    latex: "^{150}\\mathrm{Cs}",
    mass: 139685.9429294,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551500,
    name: "Cs150~",
    latex: "^{150}\\mathrm{\\overline{Cs}}",
    mass: 139685.9429294,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000551510,
    name: "Cs151",
    latex: "^{151}\\mathrm{Cs}",
    mass: 140621.3306785,
    width: undefined,
    charge: 55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000551510,
    name: "Cs151~",
    latex: "^{151}\\mathrm{\\overline{Cs}}",
    mass: 140621.3306785,
    width: undefined,
    charge: -55.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561140,
    name: "Ba114",
    latex: "^{114}\\mathrm{Ba}",
    mass: 106144.4237945,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561140,
    name: "Ba114~",
    latex: "^{114}\\mathrm{\\overline{Ba}}",
    mass: 106144.4237945,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561150,
    name: "Ba115",
    latex: "^{115}\\mathrm{Ba}",
    mass: 107072.8998573,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561150,
    name: "Ba115~",
    latex: "^{115}\\mathrm{\\overline{Ba}}",
    mass: 107072.8998573,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561160,
    name: "Ba116",
    latex: "^{116}\\mathrm{Ba}",
    mass: 107998.9354056,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561160,
    name: "Ba116~",
    latex: "^{116}\\mathrm{\\overline{Ba}}",
    mass: 107998.9354056,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561170,
    name: "Ba117",
    latex: "^{117}\\mathrm{Ba}",
    mass: 108927.3555788,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561170,
    name: "Ba117~",
    latex: "^{117}\\mathrm{\\overline{Ba}}",
    mass: 108927.3555788,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561180,
    name: "Ba118",
    latex: "^{118}\\mathrm{Ba}",
    mass: 109854.1083775,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561180,
    name: "Ba118~",
    latex: "^{118}\\mathrm{\\overline{Ba}}",
    mass: 109854.1083775,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561190,
    name: "Ba119",
    latex: "^{119}\\mathrm{Ba}",
    mass: 110783.2085414,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561190,
    name: "Ba119~",
    latex: "^{119}\\mathrm{\\overline{Ba}}",
    mass: 110783.2085414,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561200,
    name: "Ba120",
    latex: "^{120}\\mathrm{Ba}",
    mass: 111710.3991423,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561200,
    name: "Ba120~",
    latex: "^{120}\\mathrm{\\overline{Ba}}",
    mass: 111710.3991423,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561210,
    name: "Ba121",
    latex: "^{121}\\mathrm{Ba}",
    mass: 112640.0395728,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561210,
    name: "Ba121~",
    latex: "^{121}\\mathrm{\\overline{Ba}}",
    mass: 112640.0395728,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561220,
    name: "Ba122",
    latex: "^{122}\\mathrm{Ba}",
    mass: 113567.667976,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561220,
    name: "Ba122~",
    latex: "^{122}\\mathrm{\\overline{Ba}}",
    mass: 113567.667976,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561230,
    name: "Ba123",
    latex: "^{123}\\mathrm{Ba}",
    mass: 114498.1197378,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561230,
    name: "Ba123~",
    latex: "^{123}\\mathrm{\\overline{Ba}}",
    mass: 114498.1197378,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561240,
    name: "Ba124",
    latex: "^{124}\\mathrm{Ba}",
    mass: 115426.1794227,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561240,
    name: "Ba124~",
    latex: "^{124}\\mathrm{\\overline{Ba}}",
    mass: 115426.1794227,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561250,
    name: "Ba125",
    latex: "^{125}\\mathrm{Ba}",
    mass: 116357.0941371,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561250,
    name: "Ba125~",
    latex: "^{125}\\mathrm{\\overline{Ba}}",
    mass: 116357.0941371,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561260,
    name: "Ba126",
    latex: "^{126}\\mathrm{Ba}",
    mass: 117285.5869668,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561260,
    name: "Ba126~",
    latex: "^{126}\\mathrm{\\overline{Ba}}",
    mass: 117285.5869668,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561270,
    name: "Ba127",
    latex: "^{127}\\mathrm{Ba}",
    mass: 118216.932963,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561270,
    name: "Ba127~",
    latex: "^{127}\\mathrm{\\overline{Ba}}",
    mass: 118216.932963,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561280,
    name: "Ba128",
    latex: "^{128}\\mathrm{Ba}",
    mass: 119145.876077,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561280,
    name: "Ba128~",
    latex: "^{128}\\mathrm{\\overline{Ba}}",
    mass: 119145.876077,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561290,
    name: "Ba129",
    latex: "^{129}\\mathrm{Ba}",
    mass: 120077.6781326,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561290,
    name: "Ba129~",
    latex: "^{129}\\mathrm{\\overline{Ba}}",
    mass: 120077.6781326,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561300,
    name: "Ba130",
    latex: "^{130}\\mathrm{Ba}",
    mass: 121006.9767047,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561300,
    name: "Ba130~",
    latex: "^{130}\\mathrm{\\overline{Ba}}",
    mass: 121006.9767047,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561310,
    name: "Ba131",
    latex: "^{131}\\mathrm{Ba}",
    mass: 121939.0486143,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561310,
    name: "Ba131~",
    latex: "^{131}\\mathrm{\\overline{Ba}}",
    mass: 121939.0486143,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561320,
    name: "Ba132",
    latex: "^{132}\\mathrm{Ba}",
    mass: 122868.7867584,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561320,
    name: "Ba132~",
    latex: "^{132}\\mathrm{\\overline{Ba}}",
    mass: 122868.7867584,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561330,
    name: "Ba133",
    latex: "^{133}\\mathrm{Ba}",
    mass: 123801.1622419,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561330,
    name: "Ba133~",
    latex: "^{133}\\mathrm{\\overline{Ba}}",
    mass: 123801.1622419,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561340,
    name: "Ba134",
    latex: "^{134}\\mathrm{Ba}",
    mass: 124731.2598962,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561340,
    name: "Ba134~",
    latex: "^{134}\\mathrm{\\overline{Ba}}",
    mass: 124731.2598962,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561350,
    name: "Ba135",
    latex: "^{135}\\mathrm{Ba}",
    mass: 125663.8533493,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561350,
    name: "Ba135~",
    latex: "^{135}\\mathrm{\\overline{Ba}}",
    mass: 125663.8533493,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561360,
    name: "Ba136",
    latex: "^{136}\\mathrm{Ba}",
    mass: 126594.3110261,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561360,
    name: "Ba136~",
    latex: "^{136}\\mathrm{\\overline{Ba}}",
    mass: 126594.3110261,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561370,
    name: "Ba137",
    latex: "^{137}\\mathrm{Ba}",
    mass: 127526.9708108,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561370,
    name: "Ba137~",
    latex: "^{137}\\mathrm{\\overline{Ba}}",
    mass: 127526.9708108,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561380,
    name: "Ba138",
    latex: "^{138}\\mathrm{Ba}",
    mass: 128457.9245082,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561380,
    name: "Ba138~",
    latex: "^{138}\\mathrm{\\overline{Ba}}",
    mass: 128457.9245082,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561390,
    name: "Ba139",
    latex: "^{139}\\mathrm{Ba}",
    mass: 129392.7664949,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561390,
    name: "Ba139~",
    latex: "^{139}\\mathrm{\\overline{Ba}}",
    mass: 129392.7664949,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561400,
    name: "Ba140",
    latex: "^{140}\\mathrm{Ba}",
    mass: 130325.9063997,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561400,
    name: "Ba140~",
    latex: "^{140}\\mathrm{\\overline{Ba}}",
    mass: 130325.9063997,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561410,
    name: "Ba141",
    latex: "^{141}\\mathrm{Ba}",
    mass: 131260.936455,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561410,
    name: "Ba141~",
    latex: "^{141}\\mathrm{\\overline{Ba}}",
    mass: 131260.936455,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561420,
    name: "Ba142",
    latex: "^{142}\\mathrm{Ba}",
    mass: 132194.3205603,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561420,
    name: "Ba142~",
    latex: "^{142}\\mathrm{\\overline{Ba}}",
    mass: 132194.3205603,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561430,
    name: "Ba143",
    latex: "^{143}\\mathrm{Ba}",
    mass: 133129.7194873,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561430,
    name: "Ba143~",
    latex: "^{143}\\mathrm{\\overline{Ba}}",
    mass: 133129.7194873,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561440,
    name: "Ba144",
    latex: "^{144}\\mathrm{Ba}",
    mass: 134063.3839723,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561440,
    name: "Ba144~",
    latex: "^{144}\\mathrm{\\overline{Ba}}",
    mass: 134063.3839723,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561450,
    name: "Ba145",
    latex: "^{145}\\mathrm{Ba}",
    mass: 134999.1284836,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561450,
    name: "Ba145~",
    latex: "^{145}\\mathrm{\\overline{Ba}}",
    mass: 134999.1284836,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561460,
    name: "Ba146",
    latex: "^{146}\\mathrm{Ba}",
    mass: 135933.2728743,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561460,
    name: "Ba146~",
    latex: "^{146}\\mathrm{\\overline{Ba}}",
    mass: 135933.2728743,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561470,
    name: "Ba147",
    latex: "^{147}\\mathrm{Ba}",
    mass: 136869.3693041,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561470,
    name: "Ba147~",
    latex: "^{147}\\mathrm{\\overline{Ba}}",
    mass: 136869.3693041,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561480,
    name: "Ba148",
    latex: "^{148}\\mathrm{Ba}",
    mass: 137803.5824391,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561480,
    name: "Ba148~",
    latex: "^{148}\\mathrm{\\overline{Ba}}",
    mass: 137803.5824391,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561490,
    name: "Ba149",
    latex: "^{149}\\mathrm{Ba}",
    mass: 138739.7908345,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561490,
    name: "Ba149~",
    latex: "^{149}\\mathrm{\\overline{Ba}}",
    mass: 138739.7908345,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561500,
    name: "Ba150",
    latex: "^{150}\\mathrm{Ba}",
    mass: 139674.2256651,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561500,
    name: "Ba150~",
    latex: "^{150}\\mathrm{\\overline{Ba}}",
    mass: 139674.2256651,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561510,
    name: "Ba151",
    latex: "^{151}\\mathrm{Ba}",
    mass: 140610.6743859,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561510,
    name: "Ba151~",
    latex: "^{151}\\mathrm{\\overline{Ba}}",
    mass: 140610.6743859,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561520,
    name: "Ba152",
    latex: "^{152}\\mathrm{Ba}",
    mass: 141545.4939236,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561520,
    name: "Ba152~",
    latex: "^{152}\\mathrm{\\overline{Ba}}",
    mass: 141545.4939236,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000561530,
    name: "Ba153",
    latex: "^{153}\\mathrm{Ba}",
    mass: 142482.1298748,
    width: undefined,
    charge: 56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000561530,
    name: "Ba153~",
    latex: "^{153}\\mathrm{\\overline{Ba}}",
    mass: 142482.1298748,
    width: undefined,
    charge: -56.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571170,
    name: "La117",
    latex: "^{117}\\mathrm{La}",
    mass: 108938.5428229,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571170,
    name: "La117~",
    latex: "^{117}\\mathrm{\\overline{La}}",
    mass: 108938.5428229,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571180,
    name: "La118",
    latex: "^{118}\\mathrm{La}",
    mass: 109866.6835479,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571180,
    name: "La118~",
    latex: "^{118}\\mathrm{\\overline{La}}",
    mass: 109866.6835479,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571190,
    name: "La119",
    latex: "^{119}\\mathrm{La}",
    mass: 110792.7749858,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571190,
    name: "La119~",
    latex: "^{119}\\mathrm{\\overline{La}}",
    mass: 110792.7749858,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571200,
    name: "La120",
    latex: "^{120}\\mathrm{La}",
    mass: 111721.7261106,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571200,
    name: "La120~",
    latex: "^{120}\\mathrm{\\overline{La}}",
    mass: 111721.7261106,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571210,
    name: "La121",
    latex: "^{121}\\mathrm{La}",
    mass: 112648.6000036,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571210,
    name: "La121~",
    latex: "^{121}\\mathrm{\\overline{La}}",
    mass: 112648.6000036,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571220,
    name: "La122",
    latex: "^{122}\\mathrm{La}",
    mass: 113577.7374272,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571220,
    name: "La122~",
    latex: "^{122}\\mathrm{\\overline{La}}",
    mass: 113577.7374272,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571230,
    name: "La123",
    latex: "^{123}\\mathrm{La}",
    mass: 114505.1236419,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571230,
    name: "La123~",
    latex: "^{123}\\mathrm{\\overline{La}}",
    mass: 114505.1236419,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571240,
    name: "La124",
    latex: "^{124}\\mathrm{La}",
    mass: 115435.0062609,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571240,
    name: "La124~",
    latex: "^{124}\\mathrm{\\overline{La}}",
    mass: 115435.0062609,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571250,
    name: "La125",
    latex: "^{125}\\mathrm{La}",
    mass: 116363.0035357,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571250,
    name: "La125~",
    latex: "^{125}\\mathrm{\\overline{La}}",
    mass: 116363.0035357,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571260,
    name: "La126",
    latex: "^{126}\\mathrm{La}",
    mass: 117293.2811081,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571260,
    name: "La126~",
    latex: "^{126}\\mathrm{\\overline{La}}",
    mass: 117293.2811081,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571270,
    name: "La127",
    latex: "^{127}\\mathrm{La}",
    mass: 118221.8549778,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571270,
    name: "La127~",
    latex: "^{127}\\mathrm{\\overline{La}}",
    mass: 118221.8549778,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571280,
    name: "La128",
    latex: "^{128}\\mathrm{La}",
    mass: 119152.6178587,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571280,
    name: "La128~",
    latex: "^{128}\\mathrm{\\overline{La}}",
    mass: 119152.6178587,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571290,
    name: "La129",
    latex: "^{129}\\mathrm{La}",
    mass: 120081.4162185,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571290,
    name: "La129~",
    latex: "^{129}\\mathrm{\\overline{La}}",
    mass: 120081.4162185,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571300,
    name: "La130",
    latex: "^{130}\\mathrm{La}",
    mass: 121012.6057236,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571300,
    name: "La130~",
    latex: "^{130}\\mathrm{\\overline{La}}",
    mass: 121012.6057236,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571310,
    name: "La131",
    latex: "^{131}\\mathrm{La}",
    mass: 121941.9583224,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571310,
    name: "La131~",
    latex: "^{131}\\mathrm{\\overline{La}}",
    mass: 121941.9583224,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571320,
    name: "La132",
    latex: "^{132}\\mathrm{La}",
    mass: 122873.4990008,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571320,
    name: "La132~",
    latex: "^{132}\\mathrm{\\overline{La}}",
    mass: 122873.4990008,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571330,
    name: "La133",
    latex: "^{133}\\mathrm{La}",
    mass: 123803.2232657,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571330,
    name: "La133~",
    latex: "^{133}\\mathrm{\\overline{La}}",
    mass: 123803.2232657,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571340,
    name: "La134",
    latex: "^{134}\\mathrm{La}",
    mass: 124734.9912287,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571340,
    name: "La134~",
    latex: "^{134}\\mathrm{\\overline{La}}",
    mass: 124734.9912287,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571350,
    name: "La135",
    latex: "^{135}\\mathrm{La}",
    mass: 125665.0601465,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571350,
    name: "La135~",
    latex: "^{135}\\mathrm{\\overline{La}}",
    mass: 125665.0601465,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571360,
    name: "La136",
    latex: "^{136}\\mathrm{La}",
    mass: 126597.1559954,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571360,
    name: "La136~",
    latex: "^{136}\\mathrm{\\overline{La}}",
    mass: 126597.1559954,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571370,
    name: "La137",
    latex: "^{137}\\mathrm{La}",
    mass: 127527.5513086,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571370,
    name: "La137~",
    latex: "^{137}\\mathrm{\\overline{La}}",
    mass: 127527.5513086,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571380,
    name: "La138",
    latex: "^{138}\\mathrm{La}",
    mass: 128459.6728668,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571380,
    name: "La138~",
    latex: "^{138}\\mathrm{\\overline{La}}",
    mass: 128459.6728668,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571390,
    name: "La139",
    latex: "^{139}\\mathrm{La}",
    mass: 129390.4580103,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571390,
    name: "La139~",
    latex: "^{139}\\mathrm{\\overline{La}}",
    mass: 129390.4580103,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571400,
    name: "La140",
    latex: "^{140}\\mathrm{La}",
    mass: 130324.8624742,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571400,
    name: "La140~",
    latex: "^{140}\\mathrm{\\overline{La}}",
    mass: 130324.8624742,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571410,
    name: "La141",
    latex: "^{141}\\mathrm{La}",
    mass: 131257.7386358,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571410,
    name: "La141~",
    latex: "^{141}\\mathrm{\\overline{La}}",
    mass: 131257.7386358,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571420,
    name: "La142",
    latex: "^{142}\\mathrm{La}",
    mass: 132192.1390011,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571420,
    name: "La142~",
    latex: "^{142}\\mathrm{\\overline{La}}",
    mass: 132192.1390011,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571430,
    name: "La143",
    latex: "^{143}\\mathrm{La}",
    mass: 133125.4849151,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571430,
    name: "La143~",
    latex: "^{143}\\mathrm{\\overline{La}}",
    mass: 133125.4849151,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571440,
    name: "La144",
    latex: "^{144}\\mathrm{La}",
    mass: 134060.3016583,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571440,
    name: "La144~",
    latex: "^{144}\\mathrm{\\overline{La}}",
    mass: 134060.3016583,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571450,
    name: "La145",
    latex: "^{145}\\mathrm{La}",
    mass: 134993.8096522,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571450,
    name: "La145~",
    latex: "^{145}\\mathrm{\\overline{La}}",
    mass: 134993.8096522,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571460,
    name: "La146",
    latex: "^{146}\\mathrm{La}",
    mass: 135928.9179531,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571460,
    name: "La146~",
    latex: "^{146}\\mathrm{\\overline{La}}",
    mass: 135928.9179531,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571470,
    name: "La147",
    latex: "^{147}\\mathrm{La}",
    mass: 136862.9550357,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571470,
    name: "La147~",
    latex: "^{147}\\mathrm{\\overline{La}}",
    mass: 136862.9550357,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571480,
    name: "La148",
    latex: "^{148}\\mathrm{La}",
    mass: 137798.4182358,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571480,
    name: "La148~",
    latex: "^{148}\\mathrm{\\overline{La}}",
    mass: 137798.4182358,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571490,
    name: "La149",
    latex: "^{149}\\mathrm{La}",
    mass: 138732.4003603,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571490,
    name: "La149~",
    latex: "^{149}\\mathrm{\\overline{La}}",
    mass: 138732.4003603,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571500,
    name: "La150",
    latex: "^{150}\\mathrm{La}",
    mass: 139667.8044105,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571500,
    name: "La150~",
    latex: "^{150}\\mathrm{\\overline{La}}",
    mass: 139667.8044105,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571510,
    name: "La151",
    latex: "^{151}\\mathrm{La}",
    mass: 140602.3002539,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571510,
    name: "La151~",
    latex: "^{151}\\mathrm{\\overline{La}}",
    mass: 140602.3002539,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571520,
    name: "La152",
    latex: "^{152}\\mathrm{La}",
    mass: 141537.8184122,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571520,
    name: "La152~",
    latex: "^{152}\\mathrm{\\overline{La}}",
    mass: 141537.8184122,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571530,
    name: "La153",
    latex: "^{153}\\mathrm{La}",
    mass: 142472.5354855,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571530,
    name: "La153~",
    latex: "^{153}\\mathrm{\\overline{La}}",
    mass: 142472.5354855,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571540,
    name: "La154",
    latex: "^{154}\\mathrm{La}",
    mass: 143408.5659655,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571540,
    name: "La154~",
    latex: "^{154}\\mathrm{\\overline{La}}",
    mass: 143408.5659655,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000571550,
    name: "La155",
    latex: "^{155}\\mathrm{La}",
    mass: 144343.6556365,
    width: undefined,
    charge: 57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000571550,
    name: "La155~",
    latex: "^{155}\\mathrm{\\overline{La}}",
    mass: 144343.6556365,
    width: undefined,
    charge: -57.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581190,
    name: "Ce119",
    latex: "^{119}\\mathrm{Ce}",
    mass: 110803.9808599,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581190,
    name: "Ce119~",
    latex: "^{119}\\mathrm{\\overline{Ce}}",
    mass: 110803.9808599,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581200,
    name: "Ce120",
    latex: "^{120}\\mathrm{Ce}",
    mass: 111729.559976,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581200,
    name: "Ce120~",
    latex: "^{120}\\mathrm{\\overline{Ce}}",
    mass: 111729.559976,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581210,
    name: "Ce121",
    latex: "^{121}\\mathrm{Ce}",
    mass: 112658.1012434,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581210,
    name: "Ce121~",
    latex: "^{121}\\mathrm{\\overline{Ce}}",
    mass: 112658.1012434,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581220,
    name: "Ce122",
    latex: "^{122}\\mathrm{Ce}",
    mass: 113584.406925,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581220,
    name: "Ce122~",
    latex: "^{122}\\mathrm{\\overline{Ce}}",
    mass: 113584.406925,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581230,
    name: "Ce123",
    latex: "^{123}\\mathrm{Ce}",
    mass: 114513.488459,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581230,
    name: "Ce123~",
    latex: "^{123}\\mathrm{\\overline{Ce}}",
    mass: 114513.488459,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581240,
    name: "Ce124",
    latex: "^{124}\\mathrm{Ce}",
    mass: 115440.353037,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581240,
    name: "Ce124~",
    latex: "^{124}\\mathrm{\\overline{Ce}}",
    mass: 115440.353037,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581250,
    name: "Ce125",
    latex: "^{125}\\mathrm{Ce}",
    mass: 116370.1052468,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581250,
    name: "Ce125~",
    latex: "^{125}\\mathrm{\\overline{Ce}}",
    mass: 116370.1052468,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581260,
    name: "Ce126",
    latex: "^{126}\\mathrm{Ce}",
    mass: 117297.4355718,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581260,
    name: "Ce126~",
    latex: "^{126}\\mathrm{\\overline{Ce}}",
    mass: 117297.4355718,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581270,
    name: "Ce127",
    latex: "^{127}\\mathrm{Ce}",
    mass: 118227.7746229,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581270,
    name: "Ce127~",
    latex: "^{127}\\mathrm{\\overline{Ce}}",
    mass: 118227.7746229,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581280,
    name: "Ce128",
    latex: "^{128}\\mathrm{Ce}",
    mass: 119155.7104191,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581280,
    name: "Ce128~",
    latex: "^{128}\\mathrm{\\overline{Ce}}",
    mass: 119155.7104191,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581290,
    name: "Ce129",
    latex: "^{129}\\mathrm{Ce}",
    mass: 120086.4500126,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581290,
    name: "Ce129~",
    latex: "^{129}\\mathrm{\\overline{Ce}}",
    mass: 120086.4500126,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581300,
    name: "Ce130",
    latex: "^{130}\\mathrm{Ce}",
    mass: 121014.8142961,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581300,
    name: "Ce130~",
    latex: "^{130}\\mathrm{\\overline{Ce}}",
    mass: 121014.8142961,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581310,
    name: "Ce131",
    latex: "^{131}\\mathrm{Ce}",
    mass: 121946.0196367,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581310,
    name: "Ce131~",
    latex: "^{131}\\mathrm{\\overline{Ce}}",
    mass: 121946.0196367,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581320,
    name: "Ce132",
    latex: "^{132}\\mathrm{Ce}",
    mass: 122874.7527919,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581320,
    name: "Ce132~",
    latex: "^{132}\\mathrm{\\overline{Ce}}",
    mass: 122874.7527919,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581330,
    name: "Ce133",
    latex: "^{133}\\mathrm{Ce}",
    mass: 123806.2971963,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581330,
    name: "Ce133~",
    latex: "^{133}\\mathrm{\\overline{Ce}}",
    mass: 123806.2971963,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581340,
    name: "Ce134",
    latex: "^{134}\\mathrm{Ce}",
    mass: 124735.3768673,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581340,
    name: "Ce134~",
    latex: "^{134}\\mathrm{\\overline{Ce}}",
    mass: 124735.3768673,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581350,
    name: "Ce135",
    latex: "^{135}\\mathrm{Ce}",
    mass: 125667.0880091,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581350,
    name: "Ce135~",
    latex: "^{135}\\mathrm{\\overline{Ce}}",
    mass: 125667.0880091,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581360,
    name: "Ce136",
    latex: "^{136}\\mathrm{Ce}",
    mass: 126596.6895963,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581360,
    name: "Ce136~",
    latex: "^{136}\\mathrm{\\overline{Ce}}",
    mass: 126596.6895963,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581370,
    name: "Ce137",
    latex: "^{137}\\mathrm{Ce}",
    mass: 127528.7734289,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581370,
    name: "Ce137~",
    latex: "^{137}\\mathrm{\\overline{Ce}}",
    mass: 127528.7734289,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581380,
    name: "Ce138",
    latex: "^{138}\\mathrm{Ce}",
    mass: 128458.6204647,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581380,
    name: "Ce138~",
    latex: "^{138}\\mathrm{\\overline{Ce}}",
    mass: 128458.6204647,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581390,
    name: "Ce139",
    latex: "^{139}\\mathrm{Ce}",
    mass: 129390.7226478,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581390,
    name: "Ce139~",
    latex: "^{139}\\mathrm{\\overline{Ce}}",
    mass: 129390.7226478,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581400,
    name: "Ce140",
    latex: "^{140}\\mathrm{Ce}",
    mass: 130321.1002627,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581400,
    name: "Ce140~",
    latex: "^{140}\\mathrm{\\overline{Ce}}",
    mass: 130321.1002627,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581410,
    name: "Ce141",
    latex: "^{141}\\mathrm{Ce}",
    mass: 131255.2375741,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581410,
    name: "Ce141~",
    latex: "^{141}\\mathrm{\\overline{Ce}}",
    mass: 131255.2375741,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581420,
    name: "Ce142",
    latex: "^{142}\\mathrm{Ce}",
    mass: 132187.6298244,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581420,
    name: "Ce142~",
    latex: "^{142}\\mathrm{\\overline{Ce}}",
    mass: 132187.6298244,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581430,
    name: "Ce143",
    latex: "^{143}\\mathrm{Ce}",
    mass: 133122.0504963,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581430,
    name: "Ce143~",
    latex: "^{143}\\mathrm{\\overline{Ce}}",
    mass: 133122.0504963,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581440,
    name: "Ce144",
    latex: "^{144}\\mathrm{Ce}",
    mass: 134054.7192141,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581440,
    name: "Ce144~",
    latex: "^{144}\\mathrm{\\overline{Ce}}",
    mass: 134054.7192141,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581450,
    name: "Ce145",
    latex: "^{145}\\mathrm{Ce}",
    mass: 134989.582532,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581450,
    name: "Ce145~",
    latex: "^{145}\\mathrm{\\overline{Ce}}",
    mass: 134989.582532,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581460,
    name: "Ce146",
    latex: "^{146}\\mathrm{Ce}",
    mass: 135922.5129996,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581460,
    name: "Ce146~",
    latex: "^{146}\\mathrm{\\overline{Ce}}",
    mass: 135922.5129996,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581470,
    name: "Ce147",
    latex: "^{147}\\mathrm{Ce}",
    mass: 136857.6194375,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581470,
    name: "Ce147~",
    latex: "^{147}\\mathrm{\\overline{Ce}}",
    mass: 136857.6194375,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581480,
    name: "Ce148",
    latex: "^{148}\\mathrm{Ce}",
    mass: 137790.728752,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581480,
    name: "Ce148~",
    latex: "^{148}\\mathrm{\\overline{Ce}}",
    mass: 137790.728752,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581490,
    name: "Ce149",
    latex: "^{149}\\mathrm{Ce}",
    mass: 138725.9516266,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581490,
    name: "Ce149~",
    latex: "^{149}\\mathrm{\\overline{Ce}}",
    mass: 138725.9516266,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581500,
    name: "Ce150",
    latex: "^{150}\\mathrm{Ce}",
    mass: 139659.2686643,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581500,
    name: "Ce150~",
    latex: "^{150}\\mathrm{\\overline{Ce}}",
    mass: 139659.2686643,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581510,
    name: "Ce151",
    latex: "^{151}\\mathrm{Ce}",
    mass: 140594.3844171,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581510,
    name: "Ce151~",
    latex: "^{151}\\mathrm{\\overline{Ce}}",
    mass: 140594.3844171,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581520,
    name: "Ce152",
    latex: "^{152}\\mathrm{Ce}",
    mass: 141528.1215586,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581520,
    name: "Ce152~",
    latex: "^{152}\\mathrm{\\overline{Ce}}",
    mass: 141528.1215586,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581530,
    name: "Ce153",
    latex: "^{153}\\mathrm{Ce}",
    mass: 142463.6862915,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581530,
    name: "Ce153~",
    latex: "^{153}\\mathrm{\\overline{Ce}}",
    mass: 142463.6862915,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581540,
    name: "Ce154",
    latex: "^{154}\\mathrm{Ce}",
    mass: 143397.8724132,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581540,
    name: "Ce154~",
    latex: "^{154}\\mathrm{\\overline{Ce}}",
    mass: 143397.8724132,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581550,
    name: "Ce155",
    latex: "^{155}\\mathrm{Ce}",
    mass: 144333.8097438,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581550,
    name: "Ce155~",
    latex: "^{155}\\mathrm{\\overline{Ce}}",
    mass: 144333.8097438,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581560,
    name: "Ce156",
    latex: "^{156}\\mathrm{Ce}",
    mass: 145268.2566838,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581560,
    name: "Ce156~",
    latex: "^{156}\\mathrm{\\overline{Ce}}",
    mass: 145268.2566838,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000581570,
    name: "Ce157",
    latex: "^{157}\\mathrm{Ce}",
    mass: 146204.6411316,
    width: undefined,
    charge: 58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000581570,
    name: "Ce157~",
    latex: "^{157}\\mathrm{\\overline{Ce}}",
    mass: 146204.6411316,
    width: undefined,
    charge: -58.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591210,
    name: "Pr121",
    latex: "^{121}\\mathrm{Pr}",
    mass: 112669.232598,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591210,
    name: "Pr121~",
    latex: "^{121}\\mathrm{\\overline{Pr}}",
    mass: 112669.232598,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591220,
    name: "Pr122",
    latex: "^{122}\\mathrm{Pr}",
    mass: 113597.5037321,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591220,
    name: "Pr122~",
    latex: "^{122}\\mathrm{\\overline{Pr}}",
    mass: 113597.5037321,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591230,
    name: "Pr123",
    latex: "^{123}\\mathrm{Pr}",
    mass: 114523.5485953,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591230,
    name: "Pr123~",
    latex: "^{123}\\mathrm{\\overline{Pr}}",
    mass: 114523.5485953,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591240,
    name: "Pr124",
    latex: "^{124}\\mathrm{Pr}",
    mass: 115452.1178075,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591240,
    name: "Pr124~",
    latex: "^{124}\\mathrm{\\overline{Pr}}",
    mass: 115452.1178075,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591250,
    name: "Pr125",
    latex: "^{125}\\mathrm{Pr}",
    mass: 116378.6936224,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591250,
    name: "Pr125~",
    latex: "^{125}\\mathrm{\\overline{Pr}}",
    mass: 116378.6936224,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591260,
    name: "Pr126",
    latex: "^{126}\\mathrm{Pr}",
    mass: 117307.9335104,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591260,
    name: "Pr126~",
    latex: "^{126}\\mathrm{\\overline{Pr}}",
    mass: 117307.9335104,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591270,
    name: "Pr127",
    latex: "^{127}\\mathrm{Pr}",
    mass: 118235.2079458,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591270,
    name: "Pr127~",
    latex: "^{127}\\mathrm{\\overline{Pr}}",
    mass: 118235.2079458,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591280,
    name: "Pr128",
    latex: "^{128}\\mathrm{Pr}",
    mass: 119164.9135809,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591280,
    name: "Pr128~",
    latex: "^{128}\\mathrm{\\overline{Pr}}",
    mass: 119164.9135809,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591290,
    name: "Pr129",
    latex: "^{129}\\mathrm{Pr}",
    mass: 120092.9704713,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591290,
    name: "Pr129~",
    latex: "^{129}\\mathrm{\\overline{Pr}}",
    mass: 120092.9704713,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591300,
    name: "Pr130",
    latex: "^{130}\\mathrm{Pr}",
    mass: 121023.0580189,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591300,
    name: "Pr130~",
    latex: "^{130}\\mathrm{\\overline{Pr}}",
    mass: 121023.0580189,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591310,
    name: "Pr131",
    latex: "^{131}\\mathrm{Pr}",
    mass: 121951.4223025,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591310,
    name: "Pr131~",
    latex: "^{131}\\mathrm{\\overline{Pr}}",
    mass: 121951.4223025,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591320,
    name: "Pr132",
    latex: "^{132}\\mathrm{Pr}",
    mass: 122881.994227,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591320,
    name: "Pr132~",
    latex: "^{132}\\mathrm{\\overline{Pr}}",
    mass: 122881.994227,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591330,
    name: "Pr133",
    latex: "^{133}\\mathrm{Pr}",
    mass: 123810.7786144,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591330,
    name: "Pr133~",
    latex: "^{133}\\mathrm{\\overline{Pr}}",
    mass: 123810.7786144,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591340,
    name: "Pr134",
    latex: "^{134}\\mathrm{Pr}",
    mass: 124741.6821509,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591340,
    name: "Pr134~",
    latex: "^{134}\\mathrm{\\overline{Pr}}",
    mass: 124741.6821509,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591350,
    name: "Pr135",
    latex: "^{135}\\mathrm{Pr}",
    mass: 125670.7683423,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591350,
    name: "Pr135~",
    latex: "^{135}\\mathrm{\\overline{Pr}}",
    mass: 125670.7683423,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591360,
    name: "Pr136",
    latex: "^{136}\\mathrm{Pr}",
    mass: 126601.8572461,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591360,
    name: "Pr136~",
    latex: "^{136}\\mathrm{\\overline{Pr}}",
    mass: 126601.8572461,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591370,
    name: "Pr137",
    latex: "^{137}\\mathrm{Pr}",
    mass: 127531.4902246,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591370,
    name: "Pr137~",
    latex: "^{137}\\mathrm{\\overline{Pr}}",
    mass: 127531.4902246,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591380,
    name: "Pr138",
    latex: "^{138}\\mathrm{Pr}",
    mass: 128463.0569849,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591380,
    name: "Pr138~",
    latex: "^{138}\\mathrm{\\overline{Pr}}",
    mass: 128463.0569849,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591390,
    name: "Pr139",
    latex: "^{139}\\mathrm{Pr}",
    mass: 129392.8520433,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591390,
    name: "Pr139~",
    latex: "^{139}\\mathrm{\\overline{Pr}}",
    mass: 129392.8520433,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591400,
    name: "Pr140",
    latex: "^{140}\\mathrm{Pr}",
    mass: 130324.4886657,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591400,
    name: "Pr140~",
    latex: "^{140}\\mathrm{\\overline{Pr}}",
    mass: 130324.4886657,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591410,
    name: "Pr141",
    latex: "^{141}\\mathrm{Pr}",
    mass: 131254.6540862,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591410,
    name: "Pr141~",
    latex: "^{141}\\mathrm{\\overline{Pr}}",
    mass: 131254.6540862,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591420,
    name: "Pr142",
    latex: "^{142}\\mathrm{Pr}",
    mass: 132188.3763238,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591420,
    name: "Pr142~",
    latex: "^{142}\\mathrm{\\overline{Pr}}",
    mass: 132188.3763238,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591430,
    name: "Pr143",
    latex: "^{143}\\mathrm{Pr}",
    mass: 133120.5886095,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591430,
    name: "Pr143~",
    latex: "^{143}\\mathrm{\\overline{Pr}}",
    mass: 133120.5886095,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591440,
    name: "Pr144",
    latex: "^{144}\\mathrm{Pr}",
    mass: 134054.4003637,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591440,
    name: "Pr144~",
    latex: "^{144}\\mathrm{\\overline{Pr}}",
    mass: 134054.4003637,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591450,
    name: "Pr145",
    latex: "^{145}\\mathrm{Pr}",
    mass: 134987.0190602,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591450,
    name: "Pr145~",
    latex: "^{145}\\mathrm{\\overline{Pr}}",
    mass: 134987.0190602,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591460,
    name: "Pr146",
    latex: "^{146}\\mathrm{Pr}",
    mass: 135921.4678632,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591460,
    name: "Pr146~",
    latex: "^{146}\\mathrm{\\overline{Pr}}",
    mass: 135921.4678632,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591470,
    name: "Pr147",
    latex: "^{147}\\mathrm{Pr}",
    mass: 136854.1887447,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591470,
    name: "Pr147~",
    latex: "^{147}\\mathrm{\\overline{Pr}}",
    mass: 136854.1887447,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591480,
    name: "Pr148",
    latex: "^{148}\\mathrm{Pr}",
    mass: 137788.5919045,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591480,
    name: "Pr148~",
    latex: "^{148}\\mathrm{\\overline{Pr}}",
    mass: 137788.5919045,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591490,
    name: "Pr149",
    latex: "^{149}\\mathrm{Pr}",
    mass: 138721.5819877,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591490,
    name: "Pr149~",
    latex: "^{149}\\mathrm{\\overline{Pr}}",
    mass: 138721.5819877,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591500,
    name: "Pr150",
    latex: "^{150}\\mathrm{Pr}",
    mass: 139655.8146841,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591500,
    name: "Pr150~",
    latex: "^{150}\\mathrm{\\overline{Pr}}",
    mass: 139655.8146841,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591510,
    name: "Pr151",
    latex: "^{151}\\mathrm{Pr}",
    mass: 140588.8299177,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591510,
    name: "Pr151~",
    latex: "^{151}\\mathrm{\\overline{Pr}}",
    mass: 140588.8299177,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591520,
    name: "Pr152",
    latex: "^{152}\\mathrm{Pr}",
    mass: 141523.3457883,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591520,
    name: "Pr152~",
    latex: "^{152}\\mathrm{\\overline{Pr}}",
    mass: 141523.3457883,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591530,
    name: "Pr153",
    latex: "^{153}\\mathrm{Pr}",
    mass: 142457.0298347,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591530,
    name: "Pr153~",
    latex: "^{153}\\mathrm{\\overline{Pr}}",
    mass: 142457.0298347,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591540,
    name: "Pr154",
    latex: "^{154}\\mathrm{Pr}",
    mass: 143392.2368739,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591540,
    name: "Pr154~",
    latex: "^{154}\\mathrm{\\overline{Pr}}",
    mass: 143392.2368739,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591550,
    name: "Pr155",
    latex: "^{155}\\mathrm{Pr}",
    mass: 144326.1705607,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591550,
    name: "Pr155~",
    latex: "^{155}\\mathrm{\\overline{Pr}}",
    mass: 144326.1705607,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591560,
    name: "Pr156",
    latex: "^{156}\\mathrm{Pr}",
    mass: 145261.6308731,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591560,
    name: "Pr156~",
    latex: "^{156}\\mathrm{\\overline{Pr}}",
    mass: 145261.6308731,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591570,
    name: "Pr157",
    latex: "^{157}\\mathrm{Pr}",
    mass: 146196.1393849,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591570,
    name: "Pr157~",
    latex: "^{157}\\mathrm{\\overline{Pr}}",
    mass: 146196.1393849,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591580,
    name: "Pr158",
    latex: "^{158}\\mathrm{Pr}",
    mass: 147131.915567,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591580,
    name: "Pr158~",
    latex: "^{158}\\mathrm{\\overline{Pr}}",
    mass: 147131.915567,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000591590,
    name: "Pr159",
    latex: "^{159}\\mathrm{Pr}",
    mass: 148066.7909943,
    width: undefined,
    charge: 59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000591590,
    name: "Pr159~",
    latex: "^{159}\\mathrm{\\overline{Pr}}",
    mass: 148066.7909943,
    width: undefined,
    charge: -59.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601260,
    name: "Nd126",
    latex: "^{126}\\mathrm{Nd}",
    mass: 117314.8731415,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601260,
    name: "Nd126~",
    latex: "^{126}\\mathrm{\\overline{Nd}}",
    mass: 117314.8731415,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601270,
    name: "Nd127",
    latex: "^{127}\\mathrm{Nd}",
    mass: 118243.8428962,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601270,
    name: "Nd127~",
    latex: "^{127}\\mathrm{\\overline{Nd}}",
    mass: 118243.8428962,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601280,
    name: "Nd128",
    latex: "^{128}\\mathrm{Nd}",
    mass: 119170.7167891,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601280,
    name: "Nd128~",
    latex: "^{128}\\mathrm{\\overline{Nd}}",
    mass: 119170.7167891,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601290,
    name: "Nd129",
    latex: "^{129}\\mathrm{Nd}",
    mass: 120100.3665345,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601290,
    name: "Nd129~",
    latex: "^{129}\\mathrm{\\overline{Nd}}",
    mass: 120100.3665345,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601300,
    name: "Nd130",
    latex: "^{130}\\mathrm{Nd}",
    mass: 121027.6409699,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601300,
    name: "Nd130~",
    latex: "^{130}\\mathrm{\\overline{Nd}}",
    mass: 121027.6409699,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601310,
    name: "Nd131",
    latex: "^{131}\\mathrm{Nd}",
    mass: 121957.9595281,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601310,
    name: "Nd131~",
    latex: "^{131}\\mathrm{\\overline{Nd}}",
    mass: 121957.9595281,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601320,
    name: "Nd132",
    latex: "^{132}\\mathrm{Nd}",
    mass: 122885.7956545,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601320,
    name: "Nd132~",
    latex: "^{132}\\mathrm{\\overline{Nd}}",
    mass: 122885.7956545,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601330,
    name: "Nd133",
    latex: "^{133}\\mathrm{Nd}",
    mass: 123816.3852774,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601330,
    name: "Nd133~",
    latex: "^{133}\\mathrm{\\overline{Nd}}",
    mass: 123816.3852774,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601340,
    name: "Nd134",
    latex: "^{134}\\mathrm{Nd}",
    mass: 124744.5632621,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601340,
    name: "Nd134~",
    latex: "^{134}\\mathrm{\\overline{Nd}}",
    mass: 124744.5632621,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601350,
    name: "Nd135",
    latex: "^{135}\\mathrm{Nd}",
    mass: 125675.4900859,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601350,
    name: "Nd135~",
    latex: "^{135}\\mathrm{\\overline{Nd}}",
    mass: 125675.4900859,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601360,
    name: "Nd136",
    latex: "^{136}\\mathrm{Nd}",
    mass: 126603.9987511,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601360,
    name: "Nd136~",
    latex: "^{136}\\mathrm{\\overline{Nd}}",
    mass: 126603.9987511,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601370,
    name: "Nd137",
    latex: "^{137}\\mathrm{Nd}",
    mass: 127535.1081477,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601370,
    name: "Nd137~",
    latex: "^{137}\\mathrm{\\overline{Nd}}",
    mass: 127535.1081477,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601380,
    name: "Nd138",
    latex: "^{138}\\mathrm{Nd}",
    mass: 128464.1691888,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601380,
    name: "Nd138~",
    latex: "^{138}\\mathrm{\\overline{Nd}}",
    mass: 128464.1691888,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601390,
    name: "Nd139",
    latex: "^{139}\\mathrm{Nd}",
    mass: 129395.6632925,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601390,
    name: "Nd139~",
    latex: "^{139}\\mathrm{\\overline{Nd}}",
    mass: 129395.6632925,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601400,
    name: "Nd140",
    latex: "^{140}\\mathrm{Nd}",
    mass: 130324.9171529,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601400,
    name: "Nd140~",
    latex: "^{140}\\mathrm{\\overline{Nd}}",
    mass: 130324.9171529,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601410,
    name: "Nd141",
    latex: "^{141}\\mathrm{Nd}",
    mass: 131256.4773927,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601410,
    name: "Nd141~",
    latex: "^{141}\\mathrm{\\overline{Nd}}",
    mass: 131256.4773927,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601420,
    name: "Nd142",
    latex: "^{142}\\mathrm{Nd}",
    mass: 132186.2126493,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601420,
    name: "Nd142~",
    latex: "^{142}\\mathrm{\\overline{Nd}}",
    mass: 132186.2126493,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601430,
    name: "Nd143",
    latex: "^{143}\\mathrm{Nd}",
    mass: 133119.6545072,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601430,
    name: "Nd143~",
    latex: "^{143}\\mathrm{\\overline{Nd}}",
    mass: 133119.6545072,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601440,
    name: "Nd144",
    latex: "^{144}\\mathrm{Nd}",
    mass: 134051.4029088,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601440,
    name: "Nd144~",
    latex: "^{144}\\mathrm{\\overline{Nd}}",
    mass: 134051.4029088,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601450,
    name: "Nd145",
    latex: "^{145}\\mathrm{Nd}",
    mass: 134985.2130795,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601450,
    name: "Nd145~",
    latex: "^{145}\\mathrm{\\overline{Nd}}",
    mass: 134985.2130795,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601460,
    name: "Nd146",
    latex: "^{146}\\mathrm{Nd}",
    mass: 135917.2132639,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601460,
    name: "Nd146~",
    latex: "^{146}\\mathrm{\\overline{Nd}}",
    mass: 135917.2132639,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601470,
    name: "Nd147",
    latex: "^{147}\\mathrm{Nd}",
    mass: 136851.4864803,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601470,
    name: "Nd147~",
    latex: "^{147}\\mathrm{\\overline{Nd}}",
    mass: 136851.4864803,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601480,
    name: "Nd148",
    latex: "^{148}\\mathrm{Nd}",
    mass: 137783.7192588,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601480,
    name: "Nd148~",
    latex: "^{148}\\mathrm{\\overline{Nd}}",
    mass: 137783.7192588,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601490,
    name: "Nd149",
    latex: "^{149}\\mathrm{Nd}",
    mass: 138718.2459348,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601490,
    name: "Nd149~",
    latex: "^{149}\\mathrm{\\overline{Nd}}",
    mass: 138718.2459348,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601500,
    name: "Nd150",
    latex: "^{150}\\mathrm{Nd}",
    mass: 139650.4355851,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601500,
    name: "Nd150~",
    latex: "^{150}\\mathrm{\\overline{Nd}}",
    mass: 139650.4355851,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601510,
    name: "Nd151",
    latex: "^{151}\\mathrm{Nd}",
    mass: 140584.6665117,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601510,
    name: "Nd151~",
    latex: "^{151}\\mathrm{\\overline{Nd}}",
    mass: 140584.6665117,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601520,
    name: "Nd152",
    latex: "^{152}\\mathrm{Nd}",
    mass: 141516.9538758,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601520,
    name: "Nd152~",
    latex: "^{152}\\mathrm{\\overline{Nd}}",
    mass: 141516.9538758,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601530,
    name: "Nd153",
    latex: "^{153}\\mathrm{Nd}",
    mass: 142451.267519,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601530,
    name: "Nd153~",
    latex: "^{153}\\mathrm{\\overline{Nd}}",
    mass: 142451.267519,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601540,
    name: "Nd154",
    latex: "^{154}\\mathrm{Nd}",
    mass: 143384.5123659,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601540,
    name: "Nd154~",
    latex: "^{154}\\mathrm{\\overline{Nd}}",
    mass: 143384.5123659,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601550,
    name: "Nd155",
    latex: "^{155}\\mathrm{Nd}",
    mass: 144319.3026546,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601550,
    name: "Nd155~",
    latex: "^{155}\\mathrm{\\overline{Nd}}",
    mass: 144319.3026546,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601560,
    name: "Nd156",
    latex: "^{156}\\mathrm{Nd}",
    mass: 145252.8780888,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601560,
    name: "Nd156~",
    latex: "^{156}\\mathrm{\\overline{Nd}}",
    mass: 145252.8780888,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601570,
    name: "Nd157",
    latex: "^{157}\\mathrm{Nd}",
    mass: 146188.0801911,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601570,
    name: "Nd157~",
    latex: "^{157}\\mathrm{\\overline{Nd}}",
    mass: 146188.0801911,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601580,
    name: "Nd158",
    latex: "^{158}\\mathrm{Nd}",
    mass: 147122.2332447,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601580,
    name: "Nd158~",
    latex: "^{158}\\mathrm{\\overline{Nd}}",
    mass: 147122.2332447,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601590,
    name: "Nd159",
    latex: "^{159}\\mathrm{Nd}",
    mass: 148057.839336,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601590,
    name: "Nd159~",
    latex: "^{159}\\mathrm{\\overline{Nd}}",
    mass: 148057.839336,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601600,
    name: "Nd160",
    latex: "^{160}\\mathrm{Nd}",
    mass: 148992.3328507,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601600,
    name: "Nd160~",
    latex: "^{160}\\mathrm{\\overline{Nd}}",
    mass: 148992.3328507,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000601610,
    name: "Nd161",
    latex: "^{161}\\mathrm{Nd}",
    mass: 149928.316756,
    width: undefined,
    charge: 60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000601610,
    name: "Nd161~",
    latex: "^{161}\\mathrm{\\overline{Nd}}",
    mass: 149928.316756,
    width: undefined,
    charge: -60.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611280,
    name: "Pm128",
    latex: "^{128}\\mathrm{Pm}",
    mass: 119183.0218262,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611280,
    name: "Pm128~",
    latex: "^{128}\\mathrm{\\overline{Pm}}",
    mass: 119183.0218262,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611290,
    name: "Pm129",
    latex: "^{129}\\mathrm{Pm}",
    mass: 120109.5603813,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611290,
    name: "Pm129~",
    latex: "^{129}\\mathrm{\\overline{Pm}}",
    mass: 120109.5603813,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611300,
    name: "Pm130",
    latex: "^{130}\\mathrm{Pm}",
    mass: 121038.7630095,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611300,
    name: "Pm130~",
    latex: "^{130}\\mathrm{\\overline{Pm}}",
    mass: 121038.7630095,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611310,
    name: "Pm131",
    latex: "^{131}\\mathrm{Pm}",
    mass: 121965.9536105,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611310,
    name: "Pm131~",
    latex: "^{131}\\mathrm{\\overline{Pm}}",
    mass: 121965.9536105,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611320,
    name: "Pm132",
    latex: "^{132}\\mathrm{Pm}",
    mass: 122895.5940409,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611320,
    name: "Pm132~",
    latex: "^{132}\\mathrm{\\overline{Pm}}",
    mass: 122895.5940409,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611330,
    name: "Pm133",
    latex: "^{133}\\mathrm{Pm}",
    mass: 123823.3062786,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611330,
    name: "Pm133~",
    latex: "^{133}\\mathrm{\\overline{Pm}}",
    mass: 123823.3062786,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611340,
    name: "Pm134",
    latex: "^{134}\\mathrm{Pm}",
    mass: 124753.4497159,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611340,
    name: "Pm134~",
    latex: "^{134}\\mathrm{\\overline{Pm}}",
    mass: 124753.4497159,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611350,
    name: "Pm135",
    latex: "^{135}\\mathrm{Pm}",
    mass: 125681.6463305,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611350,
    name: "Pm135~",
    latex: "^{135}\\mathrm{\\overline{Pm}}",
    mass: 125681.6463305,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611360,
    name: "Pm136",
    latex: "^{136}\\mathrm{Pm}",
    mass: 126612.0319562,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611360,
    name: "Pm136~",
    latex: "^{136}\\mathrm{\\overline{Pm}}",
    mass: 126612.0319562,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611370,
    name: "Pm137",
    latex: "^{137}\\mathrm{Pm}",
    mass: 127540.6197983,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611370,
    name: "Pm137~",
    latex: "^{137}\\mathrm{\\overline{Pm}}",
    mass: 127540.6197983,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611380,
    name: "Pm138",
    latex: "^{138}\\mathrm{Pm}",
    mass: 128471.2718314,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611380,
    name: "Pm138~",
    latex: "^{138}\\mathrm{\\overline{Pm}}",
    mass: 128471.2718314,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611390,
    name: "Pm139",
    latex: "^{139}\\mathrm{Pm}",
    mass: 129400.179176,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611390,
    name: "Pm139~",
    latex: "^{139}\\mathrm{\\overline{Pm}}",
    mass: 129400.179176,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611400,
    name: "Pm140",
    latex: "^{140}\\mathrm{Pm}",
    mass: 130330.9625497,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611400,
    name: "Pm140~",
    latex: "^{140}\\mathrm{\\overline{Pm}}",
    mass: 130330.9625497,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611410,
    name: "Pm141",
    latex: "^{141}\\mathrm{Pm}",
    mass: 131260.1456165,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611410,
    name: "Pm141~",
    latex: "^{141}\\mathrm{\\overline{Pm}}",
    mass: 131260.1456165,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611420,
    name: "Pm142",
    latex: "^{142}\\mathrm{Pm}",
    mass: 132191.0212082,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611420,
    name: "Pm142~",
    latex: "^{142}\\mathrm{\\overline{Pm}}",
    mass: 132191.0212082,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611430,
    name: "Pm143",
    latex: "^{143}\\mathrm{Pm}",
    mass: 133120.6961039,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611430,
    name: "Pm143~",
    latex: "^{143}\\mathrm{\\overline{Pm}}",
    mass: 133120.6961039,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611440,
    name: "Pm144",
    latex: "^{144}\\mathrm{Pm}",
    mass: 134053.7346248,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611440,
    name: "Pm144~",
    latex: "^{144}\\mathrm{\\overline{Pm}}",
    mass: 134053.7346248,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611450,
    name: "Pm145",
    latex: "^{145}\\mathrm{Pm}",
    mass: 134985.3777676,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611450,
    name: "Pm145~",
    latex: "^{145}\\mathrm{\\overline{Pm}}",
    mass: 134985.3777676,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611460,
    name: "Pm146",
    latex: "^{146}\\mathrm{Pm}",
    mass: 135918.6845589,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611460,
    name: "Pm146~",
    latex: "^{146}\\mathrm{\\overline{Pm}}",
    mass: 135918.6845589,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611470,
    name: "Pm147",
    latex: "^{147}\\mathrm{Pm}",
    mass: 136850.5912213,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611470,
    name: "Pm147~",
    latex: "^{147}\\mathrm{\\overline{Pm}}",
    mass: 136850.5912213,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611480,
    name: "Pm148",
    latex: "^{148}\\mathrm{Pm}",
    mass: 137784.2613884,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611480,
    name: "Pm148~",
    latex: "^{148}\\mathrm{\\overline{Pm}}",
    mass: 137784.2613884,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611490,
    name: "Pm149",
    latex: "^{149}\\mathrm{Pm}",
    mass: 138716.5570428,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611490,
    name: "Pm149~",
    latex: "^{149}\\mathrm{\\overline{Pm}}",
    mass: 138716.5570428,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611500,
    name: "Pm150",
    latex: "^{150}\\mathrm{Pm}",
    mass: 139650.5182087,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611500,
    name: "Pm150~",
    latex: "^{150}\\mathrm{\\overline{Pm}}",
    mass: 139650.5182087,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611510,
    name: "Pm151",
    latex: "^{151}\\mathrm{Pm}",
    mass: 140582.2237615,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611510,
    name: "Pm151~",
    latex: "^{151}\\mathrm{\\overline{Pm}}",
    mass: 140582.2237615,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611520,
    name: "Pm152",
    latex: "^{152}\\mathrm{Pm}",
    mass: 141515.8491238,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611520,
    name: "Pm152~",
    latex: "^{152}\\mathrm{\\overline{Pm}}",
    mass: 141515.8491238,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611530,
    name: "Pm153",
    latex: "^{153}\\mathrm{Pm}",
    mass: 142447.9496301,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611530,
    name: "Pm153~",
    latex: "^{153}\\mathrm{\\overline{Pm}}",
    mass: 142447.9496301,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611540,
    name: "Pm154",
    latex: "^{154}\\mathrm{Pm}",
    mass: 143381.8255643,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611540,
    name: "Pm154~",
    latex: "^{154}\\mathrm{\\overline{Pm}}",
    mass: 143381.8255643,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611550,
    name: "Pm155",
    latex: "^{155}\\mathrm{Pm}",
    mass: 144314.6461156,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611550,
    name: "Pm155~",
    latex: "^{155}\\mathrm{\\overline{Pm}}",
    mass: 144314.6461156,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611560,
    name: "Pm156",
    latex: "^{156}\\mathrm{Pm}",
    mass: 145248.9133704,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611560,
    name: "Pm156~",
    latex: "^{156}\\mathrm{\\overline{Pm}}",
    mass: 145248.9133704,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611570,
    name: "Pm157",
    latex: "^{157}\\mathrm{Pm}",
    mass: 146182.2768897,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611570,
    name: "Pm157~",
    latex: "^{157}\\mathrm{\\overline{Pm}}",
    mass: 146182.2768897,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611580,
    name: "Pm158",
    latex: "^{158}\\mathrm{Pm}",
    mass: 147116.962199,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611580,
    name: "Pm158~",
    latex: "^{158}\\mathrm{\\overline{Pm}}",
    mass: 147116.962199,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611590,
    name: "Pm159",
    latex: "^{159}\\mathrm{Pm}",
    mass: 148051.0077582,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611590,
    name: "Pm159~",
    latex: "^{159}\\mathrm{\\overline{Pm}}",
    mass: 148051.0077582,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611600,
    name: "Pm160",
    latex: "^{160}\\mathrm{Pm}",
    mass: 148986.1619817,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611600,
    name: "Pm160~",
    latex: "^{160}\\mathrm{\\overline{Pm}}",
    mass: 148986.1619817,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611610,
    name: "Pm161",
    latex: "^{161}\\mathrm{Pm}",
    mass: 149920.4642607,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611610,
    name: "Pm161~",
    latex: "^{161}\\mathrm{\\overline{Pm}}",
    mass: 149920.4642607,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611620,
    name: "Pm162",
    latex: "^{162}\\mathrm{Pm}",
    mass: 150856.0010489,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611620,
    name: "Pm162~",
    latex: "^{162}\\mathrm{\\overline{Pm}}",
    mass: 150856.0010489,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000611630,
    name: "Pm163",
    latex: "^{163}\\mathrm{Pm}",
    mass: 151790.5783981,
    width: undefined,
    charge: 61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000611630,
    name: "Pm163~",
    latex: "^{163}\\mathrm{\\overline{Pm}}",
    mass: 151790.5783981,
    width: undefined,
    charge: -61.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621300,
    name: "Sm130",
    latex: "^{130}\\mathrm{Sm}",
    mass: 121046.5316704,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621300,
    name: "Sm130~",
    latex: "^{130}\\mathrm{\\overline{Sm}}",
    mass: 121046.5316704,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621310,
    name: "Sm131",
    latex: "^{131}\\mathrm{Sm}",
    mass: 121975.4455354,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621310,
    name: "Sm131~",
    latex: "^{131}\\mathrm{\\overline{Sm}}",
    mass: 121975.4455354,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621320,
    name: "Sm132",
    latex: "^{132}\\mathrm{Sm}",
    mass: 122902.0865549,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621320,
    name: "Sm132~",
    latex: "^{132}\\mathrm{\\overline{Sm}}",
    mass: 122902.0865549,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621330,
    name: "Sm133",
    latex: "^{133}\\mathrm{Sm}",
    mass: 123831.4847968,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621330,
    name: "Sm133~",
    latex: "^{133}\\mathrm{\\overline{Sm}}",
    mass: 123831.4847968,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621340,
    name: "Sm134",
    latex: "^{134}\\mathrm{Sm}",
    mass: 124758.8337518,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621340,
    name: "Sm134~",
    latex: "^{134}\\mathrm{\\overline{Sm}}",
    mass: 124758.8337518,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621350,
    name: "Sm135",
    latex: "^{135}\\mathrm{Sm}",
    mass: 125688.8467799,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621350,
    name: "Sm135~",
    latex: "^{135}\\mathrm{\\overline{Sm}}",
    mass: 125688.8467799,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621360,
    name: "Sm136",
    latex: "^{136}\\mathrm{Sm}",
    mass: 126616.3876226,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621360,
    name: "Sm136~",
    latex: "^{136}\\mathrm{\\overline{Sm}}",
    mass: 126616.3876226,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621370,
    name: "Sm137",
    latex: "^{137}\\mathrm{Sm}",
    mass: 127546.7024548,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621370,
    name: "Sm137~",
    latex: "^{137}\\mathrm{\\overline{Sm}}",
    mass: 127546.7024548,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621380,
    name: "Sm138",
    latex: "^{138}\\mathrm{Sm}",
    mass: 128474.6885517,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621380,
    name: "Sm138~",
    latex: "^{138}\\mathrm{\\overline{Sm}}",
    mass: 128474.6885517,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621390,
    name: "Sm139",
    latex: "^{139}\\mathrm{Sm}",
    mass: 129405.3005305,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621390,
    name: "Sm139~",
    latex: "^{139}\\mathrm{\\overline{Sm}}",
    mass: 129405.3005305,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621400,
    name: "Sm140",
    latex: "^{140}\\mathrm{Sm}",
    mass: 130333.7188407,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621400,
    name: "Sm140~",
    latex: "^{140}\\mathrm{\\overline{Sm}}",
    mass: 130333.7188407,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621410,
    name: "Sm141",
    latex: "^{141}\\mathrm{Sm}",
    mass: 131264.735088,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621410,
    name: "Sm141~",
    latex: "^{141}\\mathrm{\\overline{Sm}}",
    mass: 131264.735088,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621420,
    name: "Sm142",
    latex: "^{142}\\mathrm{Sm}",
    mass: 132193.1807841,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621420,
    name: "Sm142~",
    latex: "^{142}\\mathrm{\\overline{Sm}}",
    mass: 132193.1807841,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621430,
    name: "Sm143",
    latex: "^{143}\\mathrm{Sm}",
    mass: 133124.1396513,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621430,
    name: "Sm143~",
    latex: "^{143}\\mathrm{\\overline{Sm}}",
    mass: 133124.1396513,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621440,
    name: "Sm144",
    latex: "^{144}\\mathrm{Sm}",
    mass: 134053.1853228,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621440,
    name: "Sm144~",
    latex: "^{144}\\mathrm{\\overline{Sm}}",
    mass: 134053.1853228,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621450,
    name: "Sm145",
    latex: "^{145}\\mathrm{Sm}",
    mass: 134985.9936715,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621450,
    name: "Sm145~",
    latex: "^{145}\\mathrm{\\overline{Sm}}",
    mass: 134985.9936715,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621460,
    name: "Sm146",
    latex: "^{146}\\mathrm{Sm}",
    mass: 135917.1429361,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621460,
    name: "Sm146~",
    latex: "^{146}\\mathrm{\\overline{Sm}}",
    mass: 135917.1429361,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621470,
    name: "Sm147",
    latex: "^{147}\\mathrm{Sm}",
    mass: 136850.367197,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621470,
    name: "Sm147~",
    latex: "^{147}\\mathrm{\\overline{Sm}}",
    mass: 136850.367197,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621480,
    name: "Sm148",
    latex: "^{148}\\mathrm{Sm}",
    mass: 137781.7912523,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621480,
    name: "Sm148~",
    latex: "^{148}\\mathrm{\\overline{Sm}}",
    mass: 137781.7912523,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621490,
    name: "Sm149",
    latex: "^{149}\\mathrm{Sm}",
    mass: 138715.4855451,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621490,
    name: "Sm149~",
    latex: "^{149}\\mathrm{\\overline{Sm}}",
    mass: 138715.4855451,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621500,
    name: "Sm150",
    latex: "^{150}\\mathrm{Sm}",
    mass: 139647.0642285,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621500,
    name: "Sm150~",
    latex: "^{150}\\mathrm{\\overline{Sm}}",
    mass: 139647.0642285,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621510,
    name: "Sm151",
    latex: "^{151}\\mathrm{Sm}",
    mass: 140581.0332189,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621510,
    name: "Sm151~",
    latex: "^{151}\\mathrm{\\overline{Sm}}",
    mass: 140581.0332189,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621520,
    name: "Sm152",
    latex: "^{152}\\mathrm{Sm}",
    mass: 141512.3407444,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621520,
    name: "Sm152~",
    latex: "^{152}\\mathrm{\\overline{Sm}}",
    mass: 141512.3407444,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621530,
    name: "Sm153",
    latex: "^{153}\\mathrm{Sm}",
    mass: 142446.0378316,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621530,
    name: "Sm153~",
    latex: "^{153}\\mathrm{\\overline{Sm}}",
    mass: 142446.0378316,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621540,
    name: "Sm154",
    latex: "^{154}\\mathrm{Sm}",
    mass: 143377.636449,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621540,
    name: "Sm154~",
    latex: "^{154}\\mathrm{\\overline{Sm}}",
    mass: 143377.636449,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621550,
    name: "Sm155",
    latex: "^{155}\\mathrm{Sm}",
    mass: 144311.3948286,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621550,
    name: "Sm155~",
    latex: "^{155}\\mathrm{\\overline{Sm}}",
    mass: 144311.3948286,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621560,
    name: "Sm156",
    latex: "^{156}\\mathrm{Sm}",
    mass: 145243.7192661,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621560,
    name: "Sm156~",
    latex: "^{156}\\mathrm{\\overline{Sm}}",
    mass: 145243.7192661,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621570,
    name: "Sm157",
    latex: "^{157}\\mathrm{Sm}",
    mass: 146177.8970044,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621570,
    name: "Sm157~",
    latex: "^{157}\\mathrm{\\overline{Sm}}",
    mass: 146177.8970044,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621580,
    name: "Sm158",
    latex: "^{158}\\mathrm{Sm}",
    mass: 147110.8162941,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621580,
    name: "Sm158~",
    latex: "^{158}\\mathrm{\\overline{Sm}}",
    mass: 147110.8162941,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621590,
    name: "Sm159",
    latex: "^{159}\\mathrm{Sm}",
    mass: 148045.3545205,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621590,
    name: "Sm159~",
    latex: "^{159}\\mathrm{\\overline{Sm}}",
    mass: 148045.3545205,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621600,
    name: "Sm160",
    latex: "^{160}\\mathrm{Sm}",
    mass: 148978.8233917,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621600,
    name: "Sm160~",
    latex: "^{160}\\mathrm{\\overline{Sm}}",
    mass: 148978.8233917,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621610,
    name: "Sm161",
    latex: "^{161}\\mathrm{Sm}",
    mass: 149913.8785974,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621610,
    name: "Sm161~",
    latex: "^{161}\\mathrm{\\overline{Sm}}",
    mass: 149913.8785974,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621620,
    name: "Sm162",
    latex: "^{162}\\mathrm{Sm}",
    mass: 150847.6660396,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621620,
    name: "Sm162~",
    latex: "^{162}\\mathrm{\\overline{Sm}}",
    mass: 150847.6660396,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621630,
    name: "Sm163",
    latex: "^{163}\\mathrm{Sm}",
    mass: 151782.9392149,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621630,
    name: "Sm163~",
    latex: "^{163}\\mathrm{\\overline{Sm}}",
    mass: 151782.9392149,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621640,
    name: "Sm164",
    latex: "^{164}\\mathrm{Sm}",
    mass: 152717.1076382,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621640,
    name: "Sm164~",
    latex: "^{164}\\mathrm{\\overline{Sm}}",
    mass: 152717.1076382,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000621650,
    name: "Sm165",
    latex: "^{165}\\mathrm{Sm}",
    mass: 153653.017024,
    width: undefined,
    charge: 62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000621650,
    name: "Sm165~",
    latex: "^{165}\\mathrm{\\overline{Sm}}",
    mass: 153653.017024,
    width: undefined,
    charge: -62.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631320,
    name: "Eu132",
    latex: "^{132}\\mathrm{Eu}",
    mass: 122915.025008,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631320,
    name: "Eu132~",
    latex: "^{132}\\mathrm{\\overline{Eu}}",
    mass: 122915.025008,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631330,
    name: "Eu133",
    latex: "^{133}\\mathrm{Eu}",
    mass: 123841.4797286,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631330,
    name: "Eu133~",
    latex: "^{133}\\mathrm{\\overline{Eu}}",
    mass: 123841.4797286,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631340,
    name: "Eu134",
    latex: "^{134}\\mathrm{Eu}",
    mass: 124770.4122235,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631340,
    name: "Eu134~",
    latex: "^{134}\\mathrm{\\overline{Eu}}",
    mass: 124770.4122235,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631350,
    name: "Eu135",
    latex: "^{135}\\mathrm{Eu}",
    mass: 125697.5562498,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631350,
    name: "Eu135~",
    latex: "^{135}\\mathrm{\\overline{Eu}}",
    mass: 125697.5562498,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631360,
    name: "Eu136",
    latex: "^{136}\\mathrm{Eu}",
    mass: 126626.9544917,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631360,
    name: "Eu136~",
    latex: "^{136}\\mathrm{\\overline{Eu}}",
    mass: 126626.9544917,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631370,
    name: "Eu137",
    latex: "^{137}\\mathrm{Eu}",
    mass: 127554.5465667,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631370,
    name: "Eu137~",
    latex: "^{137}\\mathrm{\\overline{Eu}}",
    mass: 127554.5465667,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631380,
    name: "Eu138",
    latex: "^{138}\\mathrm{Eu}",
    mass: 128484.437569,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631380,
    name: "Eu138~",
    latex: "^{138}\\mathrm{\\overline{Eu}}",
    mass: 128484.437569,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631390,
    name: "Eu139",
    latex: "^{139}\\mathrm{Eu}",
    mass: 129412.2820788,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631390,
    name: "Eu139~",
    latex: "^{139}\\mathrm{\\overline{Eu}}",
    mass: 129412.2820788,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631400,
    name: "Eu140",
    latex: "^{140}\\mathrm{Eu}",
    mass: 130342.1907796,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631400,
    name: "Eu140~",
    latex: "^{140}\\mathrm{\\overline{Eu}}",
    mass: 130342.1907796,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631410,
    name: "Eu141",
    latex: "^{141}\\mathrm{Eu}",
    mass: 131270.7432249,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631410,
    name: "Eu141~",
    latex: "^{141}\\mathrm{\\overline{Eu}}",
    mass: 131270.7432249,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631420,
    name: "Eu142",
    latex: "^{142}\\mathrm{Eu}",
    mass: 132200.8568544,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631420,
    name: "Eu142~",
    latex: "^{142}\\mathrm{\\overline{Eu}}",
    mass: 132200.8568544,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631430,
    name: "Eu143",
    latex: "^{143}\\mathrm{Eu}",
    mass: 133129.4158202,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631430,
    name: "Eu143~",
    latex: "^{143}\\mathrm{\\overline{Eu}}",
    mass: 133129.4158202,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631440,
    name: "Eu144",
    latex: "^{144}\\mathrm{Eu}",
    mass: 134059.5313126,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631440,
    name: "Eu144~",
    latex: "^{144}\\mathrm{\\overline{Eu}}",
    mass: 134059.5313126,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631450,
    name: "Eu145",
    latex: "^{145}\\mathrm{Eu}",
    mass: 134988.6538324,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631450,
    name: "Eu145~",
    latex: "^{145}\\mathrm{\\overline{Eu}}",
    mass: 134988.6538324,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631460,
    name: "Eu146",
    latex: "^{146}\\mathrm{Eu}",
    mass: 135921.0216776,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631460,
    name: "Eu146~",
    latex: "^{146}\\mathrm{\\overline{Eu}}",
    mass: 135921.0216776,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631470,
    name: "Eu147",
    latex: "^{147}\\mathrm{Eu}",
    mass: 136852.0885981,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631470,
    name: "Eu147~",
    latex: "^{147}\\mathrm{\\overline{Eu}}",
    mass: 136852.0885981,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631480,
    name: "Eu148",
    latex: "^{148}\\mathrm{Eu}",
    mass: 137784.8295998,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631480,
    name: "Eu148~",
    latex: "^{148}\\mathrm{\\overline{Eu}}",
    mass: 137784.8295998,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631490,
    name: "Eu149",
    latex: "^{149}\\mathrm{Eu}",
    mass: 138716.1802534,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631490,
    name: "Eu149~",
    latex: "^{149}\\mathrm{\\overline{Eu}}",
    mass: 138716.1802534,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631500,
    name: "Eu150",
    latex: "^{150}\\mathrm{Eu}",
    mass: 139649.3231017,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631500,
    name: "Eu150~",
    latex: "^{150}\\mathrm{\\overline{Eu}}",
    mass: 139649.3231017,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631510,
    name: "Eu151",
    latex: "^{151}\\mathrm{Eu}",
    mass: 140580.956557,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631510,
    name: "Eu151~",
    latex: "^{151}\\mathrm{\\overline{Eu}}",
    mass: 140580.956557,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631520,
    name: "Eu152",
    latex: "^{152}\\mathrm{Eu}",
    mass: 141514.2152831,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631520,
    name: "Eu152~",
    latex: "^{152}\\mathrm{\\overline{Eu}}",
    mass: 141514.2152831,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631530,
    name: "Eu153",
    latex: "^{153}\\mathrm{Eu}",
    mass: 142445.2304126,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631530,
    name: "Eu153~",
    latex: "^{153}\\mathrm{\\overline{Eu}}",
    mass: 142445.2304126,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631540,
    name: "Eu154",
    latex: "^{154}\\mathrm{Eu}",
    mass: 143378.3536063,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631540,
    name: "Eu154~",
    latex: "^{154}\\mathrm{\\overline{Eu}}",
    mass: 143378.3536063,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631550,
    name: "Eu155",
    latex: "^{155}\\mathrm{Eu}",
    mass: 144309.7676947,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631550,
    name: "Eu155~",
    latex: "^{155}\\mathrm{\\overline{Eu}}",
    mass: 144309.7676947,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631560,
    name: "Eu156",
    latex: "^{156}\\mathrm{Eu}",
    mass: 145242.9973582,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631560,
    name: "Eu156~",
    latex: "^{156}\\mathrm{\\overline{Eu}}",
    mass: 145242.9973582,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631570,
    name: "Eu157",
    latex: "^{157}\\mathrm{Eu}",
    mass: 146175.115563,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631570,
    name: "Eu157~",
    latex: "^{157}\\mathrm{\\overline{Eu}}",
    mass: 146175.115563,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631580,
    name: "Eu158",
    latex: "^{158}\\mathrm{Eu}",
    mass: 147108.7979327,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631580,
    name: "Eu158~",
    latex: "^{158}\\mathrm{\\overline{Eu}}",
    mass: 147108.7979327,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631590,
    name: "Eu159",
    latex: "^{159}\\mathrm{Eu}",
    mass: 148041.5195593,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631590,
    name: "Eu159~",
    latex: "^{159}\\mathrm{\\overline{Eu}}",
    mass: 148041.5195593,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631600,
    name: "Eu160",
    latex: "^{160}\\mathrm{Eu}",
    mass: 148975.5631624,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631600,
    name: "Eu160~",
    latex: "^{160}\\mathrm{\\overline{Eu}}",
    mass: 148975.5631624,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631610,
    name: "Eu161",
    latex: "^{161}\\mathrm{Eu}",
    mass: 149908.7591058,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631610,
    name: "Eu161~",
    latex: "^{161}\\mathrm{\\overline{Eu}}",
    mass: 149908.7591058,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631620,
    name: "Eu162",
    latex: "^{162}\\mathrm{Eu}",
    mass: 150843.3218306,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631620,
    name: "Eu162~",
    latex: "^{162}\\mathrm{\\overline{Eu}}",
    mass: 150843.3218306,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631630,
    name: "Eu163",
    latex: "^{163}\\mathrm{Eu}",
    mass: 151776.9650775,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631630,
    name: "Eu163~",
    latex: "^{163}\\mathrm{\\overline{Eu}}",
    mass: 151776.9650775,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631640,
    name: "Eu164",
    latex: "^{164}\\mathrm{Eu}",
    mass: 152711.8008232,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631640,
    name: "Eu164~",
    latex: "^{164}\\mathrm{\\overline{Eu}}",
    mass: 152711.8008232,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631650,
    name: "Eu165",
    latex: "^{165}\\mathrm{Eu}",
    mass: 153645.7979447,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631650,
    name: "Eu165~",
    latex: "^{165}\\mathrm{\\overline{Eu}}",
    mass: 153645.7979447,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631660,
    name: "Eu166",
    latex: "^{166}\\mathrm{Eu}",
    mass: 154581.2695282,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631660,
    name: "Eu166~",
    latex: "^{166}\\mathrm{\\overline{Eu}}",
    mass: 154581.2695282,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000631670,
    name: "Eu167",
    latex: "^{167}\\mathrm{Eu}",
    mass: 155515.7444131,
    width: undefined,
    charge: 63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000631670,
    name: "Eu167~",
    latex: "^{167}\\mathrm{\\overline{Eu}}",
    mass: 155515.7444131,
    width: undefined,
    charge: -63.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641360,
    name: "Gd136",
    latex: "^{136}\\mathrm{Gd}",
    mass: 126634.1083665,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641360,
    name: "Gd136~",
    latex: "^{136}\\mathrm{\\overline{Gd}}",
    mass: 126634.1083665,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641370,
    name: "Gd137",
    latex: "^{137}\\mathrm{Gd}",
    mass: 127563.4786636,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641370,
    name: "Gd137~",
    latex: "^{137}\\mathrm{\\overline{Gd}}",
    mass: 127563.4786636,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641380,
    name: "Gd138",
    latex: "^{138}\\mathrm{Gd}",
    mass: 128490.5295405,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641380,
    name: "Gd138~",
    latex: "^{138}\\mathrm{\\overline{Gd}}",
    mass: 128490.5295405,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641390,
    name: "Gd139",
    latex: "^{139}\\mathrm{Gd}",
    mass: 129420.0488767,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641390,
    name: "Gd139~",
    latex: "^{139}\\mathrm{\\overline{Gd}}",
    mass: 129420.0488767,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641400,
    name: "Gd140",
    latex: "^{140}\\mathrm{Gd}",
    mass: 130347.3885167,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641400,
    name: "Gd140~",
    latex: "^{140}\\mathrm{\\overline{Gd}}",
    mass: 130347.3885167,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641410,
    name: "Gd141",
    latex: "^{141}\\mathrm{Gd}",
    mass: 131277.4443935,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641410,
    name: "Gd141~",
    latex: "^{141}\\mathrm{\\overline{Gd}}",
    mass: 131277.4443935,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641420,
    name: "Gd142",
    latex: "^{142}\\mathrm{Gd}",
    mass: 132205.2069319,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641420,
    name: "Gd142~",
    latex: "^{142}\\mathrm{\\overline{Gd}}",
    mass: 132205.2069319,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641430,
    name: "Gd143",
    latex: "^{143}\\mathrm{Gd}",
    mass: 133135.4248887,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641430,
    name: "Gd143~",
    latex: "^{143}\\mathrm{\\overline{Gd}}",
    mass: 133135.4248887,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641440,
    name: "Gd144",
    latex: "^{144}\\mathrm{Gd}",
    mass: 134063.3886297,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641440,
    name: "Gd144~",
    latex: "^{144}\\mathrm{\\overline{Gd}}",
    mass: 134063.3886297,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641450,
    name: "Gd145",
    latex: "^{145}\\mathrm{Gd}",
    mass: 134993.7183658,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641450,
    name: "Gd145~",
    latex: "^{145}\\mathrm{\\overline{Gd}}",
    mass: 134993.7183658,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641460,
    name: "Gd146",
    latex: "^{146}\\mathrm{Gd}",
    mass: 135922.053773,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641460,
    name: "Gd146~",
    latex: "^{146}\\mathrm{\\overline{Gd}}",
    mass: 135922.053773,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641470,
    name: "Gd147",
    latex: "^{147}\\mathrm{Gd}",
    mass: 136854.2763051,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641470,
    name: "Gd147~",
    latex: "^{147}\\mathrm{\\overline{Gd}}",
    mass: 136854.2763051,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641480,
    name: "Gd148",
    latex: "^{148}\\mathrm{Gd}",
    mass: 137784.8579172,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641480,
    name: "Gd148~",
    latex: "^{148}\\mathrm{\\overline{Gd}}",
    mass: 137784.8579172,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641490,
    name: "Gd149",
    latex: "^{149}\\mathrm{Gd}",
    mass: 138717.4945916,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641490,
    name: "Gd149~",
    latex: "^{149}\\mathrm{\\overline{Gd}}",
    mass: 138717.4945916,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641500,
    name: "Gd150",
    latex: "^{150}\\mathrm{Gd}",
    mass: 139648.3515534,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641500,
    name: "Gd150~",
    latex: "^{150}\\mathrm{\\overline{Gd}}",
    mass: 139648.3515534,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641510,
    name: "Gd151",
    latex: "^{151}\\mathrm{Gd}",
    mass: 140581.4208136,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641510,
    name: "Gd151~",
    latex: "^{151}\\mathrm{\\overline{Gd}}",
    mass: 140581.4208136,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641520,
    name: "Gd152",
    latex: "^{152}\\mathrm{Gd}",
    mass: 141512.3964477,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641520,
    name: "Gd152~",
    latex: "^{152}\\mathrm{\\overline{Gd}}",
    mass: 141512.3964477,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641530,
    name: "Gd153",
    latex: "^{153}\\mathrm{Gd}",
    mass: 142445.7148826,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641530,
    name: "Gd153~",
    latex: "^{153}\\mathrm{\\overline{Gd}}",
    mass: 142445.7148826,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641540,
    name: "Gd154",
    latex: "^{154}\\mathrm{Gd}",
    mass: 143376.3856387,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641540,
    name: "Gd154~",
    latex: "^{154}\\mathrm{\\overline{Gd}}",
    mass: 143376.3856387,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641550,
    name: "Gd155",
    latex: "^{155}\\mathrm{Gd}",
    mass: 144309.5158187,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641550,
    name: "Gd155~",
    latex: "^{155}\\mathrm{\\overline{Gd}}",
    mass: 144309.5158187,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641560,
    name: "Gd156",
    latex: "^{156}\\mathrm{Gd}",
    mass: 145240.5448274,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641560,
    name: "Gd156~",
    latex: "^{156}\\mathrm{\\overline{Gd}}",
    mass: 145240.5448274,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641570,
    name: "Gd157",
    latex: "^{157}\\mathrm{Gd}",
    mass: 146173.7503652,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641570,
    name: "Gd157~",
    latex: "^{157}\\mathrm{\\overline{Gd}}",
    mass: 146173.7503652,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641580,
    name: "Gd158",
    latex: "^{158}\\mathrm{Gd}",
    mass: 147105.3784178,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641580,
    name: "Gd158~",
    latex: "^{158}\\mathrm{\\overline{Gd}}",
    mass: 147105.3784178,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641590,
    name: "Gd159",
    latex: "^{159}\\mathrm{Gd}",
    mass: 148039.0006129,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641590,
    name: "Gd159~",
    latex: "^{159}\\mathrm{\\overline{Gd}}",
    mass: 148039.0006129,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641600,
    name: "Gd160",
    latex: "^{160}\\mathrm{Gd}",
    mass: 148971.1145328,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641600,
    name: "Gd160~",
    latex: "^{160}\\mathrm{\\overline{Gd}}",
    mass: 148971.1145328,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641610,
    name: "Gd161",
    latex: "^{161}\\mathrm{Gd}",
    mass: 149905.0445868,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641610,
    name: "Gd161~",
    latex: "^{161}\\mathrm{\\overline{Gd}}",
    mass: 149905.0445868,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641620,
    name: "Gd162",
    latex: "^{162}\\mathrm{Gd}",
    mass: 150837.7642573,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641620,
    name: "Gd162~",
    latex: "^{162}\\mathrm{\\overline{Gd}}",
    mass: 150837.7642573,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641630,
    name: "Gd163",
    latex: "^{163}\\mathrm{Gd}",
    mass: 151772.1502776,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641630,
    name: "Gd163~",
    latex: "^{163}\\mathrm{\\overline{Gd}}",
    mass: 151772.1502776,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641640,
    name: "Gd164",
    latex: "^{164}\\mathrm{Gd}",
    mass: 152705.339328,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641640,
    name: "Gd164~",
    latex: "^{164}\\mathrm{\\overline{Gd}}",
    mass: 152705.339328,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641650,
    name: "Gd165",
    latex: "^{165}\\mathrm{Gd}",
    mass: 153640.00135,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641650,
    name: "Gd165~",
    latex: "^{165}\\mathrm{\\overline{Gd}}",
    mass: 153640.00135,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641660,
    name: "Gd166",
    latex: "^{166}\\mathrm{Gd}",
    mass: 154573.650279,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641660,
    name: "Gd166~",
    latex: "^{166}\\mathrm{\\overline{Gd}}",
    mass: 154573.650279,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641670,
    name: "Gd167",
    latex: "^{167}\\mathrm{Gd}",
    mass: 155508.7395774,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641670,
    name: "Gd167~",
    latex: "^{167}\\mathrm{\\overline{Gd}}",
    mass: 155508.7395774,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641680,
    name: "Gd168",
    latex: "^{168}\\mathrm{Gd}",
    mass: 156442.8604945,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641680,
    name: "Gd168~",
    latex: "^{168}\\mathrm{\\overline{Gd}}",
    mass: 156442.8604945,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000641690,
    name: "Gd169",
    latex: "^{169}\\mathrm{Gd}",
    mass: 157378.6115263,
    width: undefined,
    charge: 64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000641690,
    name: "Gd169~",
    latex: "^{169}\\mathrm{\\overline{Gd}}",
    mass: 157378.6115263,
    width: undefined,
    charge: -64.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651380,
    name: "Tb138",
    latex: "^{138}\\mathrm{Tb}",
    mass: 128502.5830742,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651380,
    name: "Tb138~",
    latex: "^{138}\\mathrm{\\overline{Tb}}",
    mass: 128502.5830742,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651390,
    name: "Tb139",
    latex: "^{139}\\mathrm{Tb}",
    mass: 129429.5501165,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651390,
    name: "Tb139~",
    latex: "^{139}\\mathrm{\\overline{Tb}}",
    mass: 129429.5501165,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651400,
    name: "Tb140",
    latex: "^{140}\\mathrm{Tb}",
    mass: 130358.6968551,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651400,
    name: "Tb140~",
    latex: "^{140}\\mathrm{\\overline{Tb}}",
    mass: 130358.6968551,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651410,
    name: "Tb141",
    latex: "^{141}\\mathrm{Tb}",
    mass: 131286.1296445,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651410,
    name: "Tb141~",
    latex: "^{141}\\mathrm{\\overline{Tb}}",
    mass: 131286.1296445,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651420,
    name: "Tb142",
    latex: "^{142}\\mathrm{Tb}",
    mass: 132215.6024061,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651420,
    name: "Tb142~",
    latex: "^{142}\\mathrm{\\overline{Tb}}",
    mass: 132215.6024061,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651430,
    name: "Tb143",
    latex: "^{143}\\mathrm{Tb}",
    mass: 133143.2401242,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651430,
    name: "Tb143~",
    latex: "^{143}\\mathrm{\\overline{Tb}}",
    mass: 133143.2401242,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651440,
    name: "Tb144",
    latex: "^{144}\\mathrm{Tb}",
    mass: 134072.7874052,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651440,
    name: "Tb144~",
    latex: "^{144}\\mathrm{\\overline{Tb}}",
    mass: 134072.7874052,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651450,
    name: "Tb145",
    latex: "^{145}\\mathrm{Tb}",
    mass: 135000.2481395,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651450,
    name: "Tb145~",
    latex: "^{145}\\mathrm{\\overline{Tb}}",
    mass: 135000.2481395,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651460,
    name: "Tb146",
    latex: "^{146}\\mathrm{Tb}",
    mass: 135930.3729469,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651460,
    name: "Tb146~",
    latex: "^{146}\\mathrm{\\overline{Tb}}",
    mass: 135930.3729469,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651470,
    name: "Tb147",
    latex: "^{147}\\mathrm{Tb}",
    mass: 136858.8909269,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651470,
    name: "Tb147~",
    latex: "^{147}\\mathrm{\\overline{Tb}}",
    mass: 136858.8909269,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651480,
    name: "Tb148",
    latex: "^{148}\\mathrm{Tb}",
    mass: 137790.5899593,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651480,
    name: "Tb148~",
    latex: "^{148}\\mathrm{\\overline{Tb}}",
    mass: 137790.5899593,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651490,
    name: "Tb149",
    latex: "^{149}\\mathrm{Tb}",
    mass: 138721.1330076,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651490,
    name: "Tb149~",
    latex: "^{149}\\mathrm{\\overline{Tb}}",
    mass: 138721.1330076,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651500,
    name: "Tb150",
    latex: "^{150}\\mathrm{Tb}",
    mass: 139653.0099554,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651500,
    name: "Tb150~",
    latex: "^{150}\\mathrm{\\overline{Tb}}",
    mass: 139653.0099554,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651510,
    name: "Tb151",
    latex: "^{151}\\mathrm{Tb}",
    mass: 140583.9861484,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651510,
    name: "Tb151~",
    latex: "^{151}\\mathrm{\\overline{Tb}}",
    mass: 140583.9861484,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651520,
    name: "Tb152",
    latex: "^{152}\\mathrm{Tb}",
    mass: 141516.3847329,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651520,
    name: "Tb152~",
    latex: "^{152}\\mathrm{\\overline{Tb}}",
    mass: 141516.3847329,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651530,
    name: "Tb153",
    latex: "^{153}\\mathrm{Tb}",
    mass: 142447.2845433,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651530,
    name: "Tb153~",
    latex: "^{153}\\mathrm{\\overline{Tb}}",
    mass: 142447.2845433,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651540,
    name: "Tb154",
    latex: "^{154}\\mathrm{Tb}",
    mass: 143379.9318368,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651540,
    name: "Tb154~",
    latex: "^{154}\\mathrm{\\overline{Tb}}",
    mass: 143379.9318368,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651550,
    name: "Tb155",
    latex: "^{155}\\mathrm{Tb}",
    mass: 144310.3360924,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651550,
    name: "Tb155~",
    latex: "^{155}\\mathrm{\\overline{Tb}}",
    mass: 144310.3360924,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651560,
    name: "Tb156",
    latex: "^{156}\\mathrm{Tb}",
    mass: 145242.9889748,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651560,
    name: "Tb156~",
    latex: "^{156}\\mathrm{\\overline{Tb}}",
    mass: 145242.9889748,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651570,
    name: "Tb157",
    latex: "^{157}\\mathrm{Tb}",
    mass: 146173.8104466,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651570,
    name: "Tb157~",
    latex: "^{157}\\mathrm{\\overline{Tb}}",
    mass: 146173.8104466,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651580,
    name: "Tb158",
    latex: "^{158}\\mathrm{Tb}",
    mass: 147106.5974641,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651580,
    name: "Tb158~",
    latex: "^{158}\\mathrm{\\overline{Tb}}",
    mass: 147106.5974641,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651590,
    name: "Tb159",
    latex: "^{159}\\mathrm{Tb}",
    mass: 148038.0299029,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651590,
    name: "Tb159~",
    latex: "^{159}\\mathrm{\\overline{Tb}}",
    mass: 148038.0299029,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651600,
    name: "Tb160",
    latex: "^{160}\\mathrm{Tb}",
    mass: 148971.2201643,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651600,
    name: "Tb160~",
    latex: "^{160}\\mathrm{\\overline{Tb}}",
    mass: 148971.2201643,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651610,
    name: "Tb161",
    latex: "^{161}\\mathrm{Tb}",
    mass: 149903.0889149,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651610,
    name: "Tb161~",
    latex: "^{161}\\mathrm{\\overline{Tb}}",
    mass: 149903.0889149,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651620,
    name: "Tb162",
    latex: "^{162}\\mathrm{Tb}",
    mass: 150836.1652545,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651620,
    name: "Tb162~",
    latex: "^{162}\\mathrm{\\overline{Tb}}",
    mass: 150836.1652545,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651630,
    name: "Tb163",
    latex: "^{163}\\mathrm{Tb}",
    mass: 151768.943516,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651630,
    name: "Tb163~",
    latex: "^{163}\\mathrm{\\overline{Tb}}",
    mass: 151768.943516,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651640,
    name: "Tb164",
    latex: "^{164}\\mathrm{Tb}",
    mass: 152702.9280624,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651640,
    name: "Tb164~",
    latex: "^{164}\\mathrm{\\overline{Tb}}",
    mass: 152702.9280624,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651650,
    name: "Tb165",
    latex: "^{165}\\mathrm{Tb}",
    mass: 153635.9382659,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651650,
    name: "Tb165~",
    latex: "^{165}\\mathrm{\\overline{Tb}}",
    mass: 153635.9382659,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651660,
    name: "Tb166",
    latex: "^{166}\\mathrm{Tb}",
    mass: 154570.2124138,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651660,
    name: "Tb166~",
    latex: "^{166}\\mathrm{\\overline{Tb}}",
    mass: 154570.2124138,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651670,
    name: "Tb167",
    latex: "^{167}\\mathrm{Tb}",
    mass: 155503.6321952,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651670,
    name: "Tb167~",
    latex: "^{167}\\mathrm{\\overline{Tb}}",
    mass: 155503.6321952,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651680,
    name: "Tb168",
    latex: "^{168}\\mathrm{Tb}",
    mass: 156438.2281743,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651680,
    name: "Tb168~",
    latex: "^{168}\\mathrm{\\overline{Tb}}",
    mass: 156438.2281743,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651690,
    name: "Tb169",
    latex: "^{169}\\mathrm{Tb}",
    mass: 157372.025863,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651690,
    name: "Tb169~",
    latex: "^{169}\\mathrm{\\overline{Tb}}",
    mass: 157372.025863,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651700,
    name: "Tb170",
    latex: "^{170}\\mathrm{Tb}",
    mass: 158307.2925178,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651700,
    name: "Tb170~",
    latex: "^{170}\\mathrm{\\overline{Tb}}",
    mass: 158307.2925178,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000651710,
    name: "Tb171",
    latex: "^{171}\\mathrm{Tb}",
    mass: 159241.7208279,
    width: undefined,
    charge: 65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000651710,
    name: "Tb171~",
    latex: "^{171}\\mathrm{\\overline{Tb}}",
    mass: 159241.7208279,
    width: undefined,
    charge: -65.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661400,
    name: "Dy140",
    latex: "^{140}\\mathrm{Dy}",
    mass: 130366.3444217,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661400,
    name: "Dy140~",
    latex: "^{140}\\mathrm{\\overline{Dy}}",
    mass: 130366.3444217,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661410,
    name: "Dy141",
    latex: "^{141}\\mathrm{Dy}",
    mass: 131295.2862316,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661410,
    name: "Dy141~",
    latex: "^{141}\\mathrm{\\overline{Dy}}",
    mass: 131295.2862316,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661420,
    name: "Dy142",
    latex: "^{142}\\mathrm{Dy}",
    mass: 132222.0390303,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661420,
    name: "Dy142~",
    latex: "^{142}\\mathrm{\\overline{Dy}}",
    mass: 132222.0390303,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661430,
    name: "Dy143",
    latex: "^{143}\\mathrm{Dy}",
    mass: 133151.487573,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661430,
    name: "Dy143~",
    latex: "^{143}\\mathrm{\\overline{Dy}}",
    mass: 133151.487573,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661440,
    name: "Dy144",
    latex: "^{144}\\mathrm{Dy}",
    mass: 134078.5812986,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661440,
    name: "Dy144~",
    latex: "^{144}\\mathrm{\\overline{Dy}}",
    mass: 134078.5812986,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661450,
    name: "Dy145",
    latex: "^{145}\\mathrm{Dy}",
    mass: 135008.4024389,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661450,
    name: "Dy145~",
    latex: "^{145}\\mathrm{\\overline{Dy}}",
    mass: 135008.4024389,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661460,
    name: "Dy146",
    latex: "^{146}\\mathrm{Dy}",
    mass: 135935.5846564,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661460,
    name: "Dy146~",
    latex: "^{146}\\mathrm{\\overline{Dy}}",
    mass: 135935.5846564,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661470,
    name: "Dy147",
    latex: "^{147}\\mathrm{Dy}",
    mass: 136865.4374675,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661470,
    name: "Dy147~",
    latex: "^{147}\\mathrm{\\overline{Dy}}",
    mass: 136865.4374675,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661480,
    name: "Dy148",
    latex: "^{148}\\mathrm{Dy}",
    mass: 137793.2680049,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661480,
    name: "Dy148~",
    latex: "^{148}\\mathrm{\\overline{Dy}}",
    mass: 137793.2680049,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661490,
    name: "Dy149",
    latex: "^{149}\\mathrm{Dy}",
    mass: 138724.9279146,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661490,
    name: "Dy149~",
    latex: "^{149}\\mathrm{\\overline{Dy}}",
    mass: 138724.9279146,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661500,
    name: "Dy150",
    latex: "^{150}\\mathrm{Dy}",
    mass: 139654.805876,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661500,
    name: "Dy150~",
    latex: "^{150}\\mathrm{\\overline{Dy}}",
    mass: 139654.805876,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661510,
    name: "Dy151",
    latex: "^{151}\\mathrm{Dy}",
    mass: 140586.8570132,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661510,
    name: "Dy151~",
    latex: "^{151}\\mathrm{\\overline{Dy}}",
    mass: 140586.8570132,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661520,
    name: "Dy152",
    latex: "^{152}\\mathrm{Dy}",
    mass: 141516.9855466,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661520,
    name: "Dy152~",
    latex: "^{152}\\mathrm{\\overline{Dy}}",
    mass: 141516.9855466,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661530,
    name: "Dy153",
    latex: "^{153}\\mathrm{Dy}",
    mass: 142449.4549246,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661530,
    name: "Dy153~",
    latex: "^{153}\\mathrm{\\overline{Dy}}",
    mass: 142449.4549246,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661540,
    name: "Dy154",
    latex: "^{154}\\mathrm{Dy}",
    mass: 143379.6980317,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661540,
    name: "Dy154~",
    latex: "^{154}\\mathrm{\\overline{Dy}}",
    mass: 143379.6980317,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661550,
    name: "Dy155",
    latex: "^{155}\\mathrm{Dy}",
    mass: 144312.4300911,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661550,
    name: "Dy155~",
    latex: "^{155}\\mathrm{\\overline{Dy}}",
    mass: 144312.4300911,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661560,
    name: "Dy156",
    latex: "^{156}\\mathrm{Dy}",
    mass: 145242.5507999,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661560,
    name: "Dy156~",
    latex: "^{156}\\mathrm{\\overline{Dy}}",
    mass: 145242.5507999,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661570,
    name: "Dy157",
    latex: "^{157}\\mathrm{Dy}",
    mass: 146175.1500283,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661570,
    name: "Dy157~",
    latex: "^{157}\\mathrm{\\overline{Dy}}",
    mass: 146175.1500283,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661580,
    name: "Dy158",
    latex: "^{158}\\mathrm{Dy}",
    mass: 147105.6612194,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661580,
    name: "Dy158~",
    latex: "^{158}\\mathrm{\\overline{Dy}}",
    mass: 147105.6612194,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661590,
    name: "Dy159",
    latex: "^{159}\\mathrm{Dy}",
    mass: 148038.3952349,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661590,
    name: "Dy159~",
    latex: "^{159}\\mathrm{\\overline{Dy}}",
    mass: 148038.3952349,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661600,
    name: "Dy160",
    latex: "^{160}\\mathrm{Dy}",
    mass: 148969.3841894,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661600,
    name: "Dy160~",
    latex: "^{160}\\mathrm{\\overline{Dy}}",
    mass: 148969.3841894,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661610,
    name: "Dy161",
    latex: "^{161}\\mathrm{Dy}",
    mass: 149902.4951806,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661610,
    name: "Dy161~",
    latex: "^{161}\\mathrm{\\overline{Dy}}",
    mass: 149902.4951806,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661620,
    name: "Dy162",
    latex: "^{162}\\mathrm{Dy}",
    mass: 150833.8636257,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661620,
    name: "Dy162~",
    latex: "^{162}\\mathrm{\\overline{Dy}}",
    mass: 150833.8636257,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661630,
    name: "Dy163",
    latex: "^{163}\\mathrm{Dy}",
    mass: 151767.1580281,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661630,
    name: "Dy163~",
    latex: "^{163}\\mathrm{\\overline{Dy}}",
    mass: 151767.1580281,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661640,
    name: "Dy164",
    latex: "^{164}\\mathrm{Dy}",
    mass: 152699.0653426,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661640,
    name: "Dy164~",
    latex: "^{164}\\mathrm{\\overline{Dy}}",
    mass: 152699.0653426,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661650,
    name: "Dy165",
    latex: "^{165}\\mathrm{Dy}",
    mass: 153632.9148223,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661650,
    name: "Dy165~",
    latex: "^{165}\\mathrm{\\overline{Dy}}",
    mass: 153632.9148223,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661660,
    name: "Dy166",
    latex: "^{166}\\mathrm{Dy}",
    mass: 154565.4367366,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661660,
    name: "Dy166~",
    latex: "^{166}\\mathrm{\\overline{Dy}}",
    mass: 154565.4367366,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661670,
    name: "Dy167",
    latex: "^{167}\\mathrm{Dy}",
    mass: 155499.6034832,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661670,
    name: "Dy167~",
    latex: "^{167}\\mathrm{\\overline{Dy}}",
    mass: 155499.6034832,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661680,
    name: "Dy168",
    latex: "^{168}\\mathrm{Dy}",
    mass: 156432.4463904,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661680,
    name: "Dy168~",
    latex: "^{168}\\mathrm{\\overline{Dy}}",
    mass: 156432.4463904,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661690,
    name: "Dy169",
    latex: "^{169}\\mathrm{Dy}",
    mass: 157366.9119603,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661690,
    name: "Dy169~",
    latex: "^{169}\\mathrm{\\overline{Dy}}",
    mass: 157366.9119603,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661700,
    name: "Dy170",
    latex: "^{170}\\mathrm{Dy}",
    mass: 158300.2876821,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661700,
    name: "Dy170~",
    latex: "^{170}\\mathrm{\\overline{Dy}}",
    mass: 158300.2876821,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661710,
    name: "Dy171",
    latex: "^{171}\\mathrm{Dy}",
    mass: 159235.4798174,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661710,
    name: "Dy171~",
    latex: "^{171}\\mathrm{\\overline{Dy}}",
    mass: 159235.4798174,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661720,
    name: "Dy172",
    latex: "^{172}\\mathrm{Dy}",
    mass: 160169.2281369,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661720,
    name: "Dy172~",
    latex: "^{172}\\mathrm{\\overline{Dy}}",
    mass: 160169.2281369,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000661730,
    name: "Dy173",
    latex: "^{173}\\mathrm{Dy}",
    mass: 161104.7369802,
    width: undefined,
    charge: 66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000661730,
    name: "Dy173~",
    latex: "^{173}\\mathrm{\\overline{Dy}}",
    mass: 161104.7369802,
    width: undefined,
    charge: -66.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671420,
    name: "Ho142",
    latex: "^{142}\\mathrm{Ho}",
    mass: 132234.9122788,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671420,
    name: "Ho142~",
    latex: "^{142}\\mathrm{\\overline{Ho}}",
    mass: 132234.9122788,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671430,
    name: "Ho143",
    latex: "^{143}\\mathrm{Ho}",
    mass: 133161.6091879,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671430,
    name: "Ho143~",
    latex: "^{143}\\mathrm{\\overline{Ho}}",
    mass: 133161.6091879,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671440,
    name: "Ho144",
    latex: "^{144}\\mathrm{Ho}",
    mass: 134090.5416828,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671440,
    name: "Ho144~",
    latex: "^{144}\\mathrm{\\overline{Ho}}",
    mass: 134090.5416828,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671450,
    name: "Ho145",
    latex: "^{145}\\mathrm{Ho}",
    mass: 135017.5245606,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671450,
    name: "Ho145~",
    latex: "^{145}\\mathrm{\\overline{Ho}}",
    mass: 135017.5245606,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671460,
    name: "Ho146",
    latex: "^{146}\\mathrm{Ho}",
    mass: 135946.9013782,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671460,
    name: "Ho146~",
    latex: "^{146}\\mathrm{\\overline{Ho}}",
    mass: 135946.9013782,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671470,
    name: "Ho147",
    latex: "^{147}\\mathrm{Ho}",
    mass: 136873.8758726,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671470,
    name: "Ho147~",
    latex: "^{147}\\mathrm{\\overline{Ho}}",
    mass: 136873.8758726,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671480,
    name: "Ho148",
    latex: "^{148}\\mathrm{Ho}",
    mass: 137803.1325275,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671480,
    name: "Ho148~",
    latex: "^{148}\\mathrm{\\overline{Ho}}",
    mass: 137803.1325275,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671490,
    name: "Ho149",
    latex: "^{149}\\mathrm{Ho}",
    mass: 138730.9751743,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671490,
    name: "Ho149~",
    latex: "^{149}\\mathrm{\\overline{Ho}}",
    mass: 138730.9751743,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671500,
    name: "Ho150",
    latex: "^{150}\\mathrm{Ho}",
    mass: 139662.1693369,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671500,
    name: "Ho150~",
    latex: "^{150}\\mathrm{\\overline{Ho}}",
    mass: 139662.1693369,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671510,
    name: "Ho151",
    latex: "^{151}\\mathrm{Ho}",
    mass: 140591.9867512,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671510,
    name: "Ho151~",
    latex: "^{151}\\mathrm{\\overline{Ho}}",
    mass: 140591.9867512,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671520,
    name: "Ho152",
    latex: "^{152}\\mathrm{Ho}",
    mass: 141523.4994848,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671520,
    name: "Ho152~",
    latex: "^{152}\\mathrm{\\overline{Ho}}",
    mass: 141523.4994848,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671530,
    name: "Ho153",
    latex: "^{153}\\mathrm{Ho}",
    mass: 142453.586101,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671530,
    name: "Ho153~",
    latex: "^{153}\\mathrm{\\overline{Ho}}",
    mass: 142453.586101,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671540,
    name: "Ho154",
    latex: "^{154}\\mathrm{Ho}",
    mass: 143385.4528023,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671540,
    name: "Ho154~",
    latex: "^{154}\\mathrm{\\overline{Ho}}",
    mass: 143385.4528023,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671550,
    name: "Ho155",
    latex: "^{155}\\mathrm{Ho}",
    mass: 144315.5459389,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671550,
    name: "Ho155~",
    latex: "^{155}\\mathrm{\\overline{Ho}}",
    mass: 144315.5459389,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671560,
    name: "Ho156",
    latex: "^{156}\\mathrm{Ho}",
    mass: 145247.540255,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671560,
    name: "Ho156~",
    latex: "^{156}\\mathrm{\\overline{Ho}}",
    mass: 145247.540255,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671570,
    name: "Ho157",
    latex: "^{157}\\mathrm{Ho}",
    mass: 146177.7414449,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671570,
    name: "Ho157~",
    latex: "^{157}\\mathrm{\\overline{Ho}}",
    mass: 146177.7414449,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671580,
    name: "Ho158",
    latex: "^{158}\\mathrm{Ho}",
    mass: 147109.881074,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671580,
    name: "Ho158~",
    latex: "^{158}\\mathrm{\\overline{Ho}}",
    mass: 147109.881074,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671590,
    name: "Ho159",
    latex: "^{159}\\mathrm{Ho}",
    mass: 148040.2331659,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671590,
    name: "Ho159~",
    latex: "^{159}\\mathrm{\\overline{Ho}}",
    mass: 148040.2331659,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671600,
    name: "Ho160",
    latex: "^{160}\\mathrm{Ho}",
    mass: 148972.6745992,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671600,
    name: "Ho160~",
    latex: "^{160}\\mathrm{\\overline{Ho}}",
    mass: 148972.6745992,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671610,
    name: "Ho161",
    latex: "^{161}\\mathrm{Ho}",
    mass: 149903.3543907,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671610,
    name: "Ho161~",
    latex: "^{161}\\mathrm{\\overline{Ho}}",
    mass: 149903.3543907,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671620,
    name: "Ho162",
    latex: "^{162}\\mathrm{Ho}",
    mass: 150836.0046649,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671620,
    name: "Ho162~",
    latex: "^{162}\\mathrm{\\overline{Ho}}",
    mass: 150836.0046649,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671630,
    name: "Ho163",
    latex: "^{163}\\mathrm{Ho}",
    mass: 151767.1609157,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671630,
    name: "Ho163~",
    latex: "^{163}\\mathrm{\\overline{Ho}}",
    mass: 151767.1609157,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671640,
    name: "Ho164",
    latex: "^{164}\\mathrm{Ho}",
    mass: 152700.0524469,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671640,
    name: "Ho164~",
    latex: "^{164}\\mathrm{\\overline{Ho}}",
    mass: 152700.0524469,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671650,
    name: "Ho165",
    latex: "^{165}\\mathrm{Ho}",
    mass: 153631.629081,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671650,
    name: "Ho165~",
    latex: "^{165}\\mathrm{\\overline{Ho}}",
    mass: 153631.629081,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671660,
    name: "Ho166",
    latex: "^{166}\\mathrm{Ho}",
    mass: 154564.9508693,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671660,
    name: "Ho166~",
    latex: "^{166}\\mathrm{\\overline{Ho}}",
    mass: 154564.9508693,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671670,
    name: "Ho167",
    latex: "^{167}\\mathrm{Ho}",
    mass: 155497.2356252,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671670,
    name: "Ho167~",
    latex: "^{167}\\mathrm{\\overline{Ho}}",
    mass: 155497.2356252,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671680,
    name: "Ho168",
    latex: "^{168}\\mathrm{Ho}",
    mass: 156430.9466849,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671680,
    name: "Ho168~",
    latex: "^{168}\\mathrm{\\overline{Ho}}",
    mass: 156430.9466849,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671690,
    name: "Ho169",
    latex: "^{169}\\mathrm{Ho}",
    mass: 157363.7076206,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671690,
    name: "Ho169~",
    latex: "^{169}\\mathrm{\\overline{Ho}}",
    mass: 157363.7076206,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671700,
    name: "Ho170",
    latex: "^{170}\\mathrm{Ho}",
    mass: 158297.7633331,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671700,
    name: "Ho170~",
    latex: "^{170}\\mathrm{\\overline{Ho}}",
    mass: 158297.7633331,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671710,
    name: "Ho171",
    latex: "^{171}\\mathrm{Ho}",
    mass: 159230.971386,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671710,
    name: "Ho171~",
    latex: "^{171}\\mathrm{\\overline{Ho}}",
    mass: 159230.971386,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671720,
    name: "Ho172",
    latex: "^{172}\\mathrm{Ho}",
    mass: 160165.5021605,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671720,
    name: "Ho172~",
    latex: "^{172}\\mathrm{\\overline{Ho}}",
    mass: 160165.5021605,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671730,
    name: "Ho173",
    latex: "^{173}\\mathrm{Ho}",
    mass: 161099.1293857,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671730,
    name: "Ho173~",
    latex: "^{173}\\mathrm{\\overline{Ho}}",
    mass: 161099.1293857,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671740,
    name: "Ho174",
    latex: "^{174}\\mathrm{Ho}",
    mass: 162034.1072774,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671740,
    name: "Ho174~",
    latex: "^{174}\\mathrm{\\overline{Ho}}",
    mass: 162034.1072774,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000671750,
    name: "Ho175",
    latex: "^{175}\\mathrm{Ho}",
    mass: 162968.1723048,
    width: undefined,
    charge: 67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000671750,
    name: "Ho175~",
    latex: "^{175}\\mathrm{\\overline{Ho}}",
    mass: 162968.1723048,
    width: undefined,
    charge: -67.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681440,
    name: "Er144",
    latex: "^{144}\\mathrm{Er}",
    mass: 134098.5432172,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681440,
    name: "Er144~",
    latex: "^{144}\\mathrm{\\overline{Er}}",
    mass: 134098.5432172,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681450,
    name: "Er145",
    latex: "^{145}\\mathrm{Er}",
    mass: 135027.4011926,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681450,
    name: "Er145~",
    latex: "^{145}\\mathrm{\\overline{Er}}",
    mass: 135027.4011926,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681460,
    name: "Er146",
    latex: "^{146}\\mathrm{Er}",
    mass: 135953.8167905,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681460,
    name: "Er146~",
    latex: "^{146}\\mathrm{\\overline{Er}}",
    mass: 135953.8167905,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681470,
    name: "Er147",
    latex: "^{147}\\mathrm{Er}",
    mass: 136883.0212817,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681470,
    name: "Er147~",
    latex: "^{147}\\mathrm{\\overline{Er}}",
    mass: 136883.0212817,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681480,
    name: "Er148",
    latex: "^{148}\\mathrm{Er}",
    mass: 137809.6483287,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681480,
    name: "Er148~",
    latex: "^{148}\\mathrm{\\overline{Er}}",
    mass: 137809.6483287,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681490,
    name: "Er149",
    latex: "^{149}\\mathrm{Er}",
    mass: 138738.8835592,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681490,
    name: "Er149~",
    latex: "^{149}\\mathrm{\\overline{Er}}",
    mass: 138738.8835592,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681500,
    name: "Er150",
    latex: "^{150}\\mathrm{Er}",
    mass: 139666.2846779,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681500,
    name: "Er150~",
    latex: "^{150}\\mathrm{\\overline{Er}}",
    mass: 139666.2846779,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681510,
    name: "Er151",
    latex: "^{151}\\mathrm{Er}",
    mass: 140597.3437738,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681510,
    name: "Er151~",
    latex: "^{151}\\mathrm{\\overline{Er}}",
    mass: 140597.3437738,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681520,
    name: "Er152",
    latex: "^{152}\\mathrm{Er}",
    mass: 141526.6032232,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681520,
    name: "Er152~",
    latex: "^{152}\\mathrm{\\overline{Er}}",
    mass: 141526.6032232,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681530,
    name: "Er153",
    latex: "^{153}\\mathrm{Er}",
    mass: 142458.1308607,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681530,
    name: "Er153~",
    latex: "^{153}\\mathrm{\\overline{Er}}",
    mass: 142458.1308607,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681540,
    name: "Er154",
    latex: "^{154}\\mathrm{Er}",
    mass: 143387.4871854,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681540,
    name: "Er154~",
    latex: "^{154}\\mathrm{\\overline{Er}}",
    mass: 143387.4871854,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681550,
    name: "Er155",
    latex: "^{155}\\mathrm{Er}",
    mass: 144319.3771742,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681550,
    name: "Er155~",
    latex: "^{155}\\mathrm{\\overline{Er}}",
    mass: 144319.3771742,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681560,
    name: "Er156",
    latex: "^{156}\\mathrm{Er}",
    mass: 145248.8685656,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681560,
    name: "Er156~",
    latex: "^{156}\\mathrm{\\overline{Er}}",
    mass: 145248.8685656,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681570,
    name: "Er157",
    latex: "^{157}\\mathrm{Er}",
    mass: 146181.1609597,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681570,
    name: "Er157~",
    latex: "^{157}\\mathrm{\\overline{Er}}",
    mass: 146181.1609597,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681580,
    name: "Er158",
    latex: "^{158}\\mathrm{Er}",
    mass: 147110.7641304,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681580,
    name: "Er158~",
    latex: "^{158}\\mathrm{\\overline{Er}}",
    mass: 147110.7641304,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681590,
    name: "Er159",
    latex: "^{159}\\mathrm{Er}",
    mass: 148043.0015664,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681590,
    name: "Er159~",
    latex: "^{159}\\mathrm{\\overline{Er}}",
    mass: 148043.0015664,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681600,
    name: "Er160",
    latex: "^{160}\\mathrm{Er}",
    mass: 148972.9922387,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681600,
    name: "Er160~",
    latex: "^{160}\\mathrm{\\overline{Er}}",
    mass: 148972.9922387,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681610,
    name: "Er161",
    latex: "^{161}\\mathrm{Er}",
    mass: 149905.3498374,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681610,
    name: "Er161~",
    latex: "^{161}\\mathrm{\\overline{Er}}",
    mass: 149905.3498374,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681620,
    name: "Er162",
    latex: "^{162}\\mathrm{Er}",
    mass: 150835.7105922,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681620,
    name: "Er162~",
    latex: "^{162}\\mathrm{\\overline{Er}}",
    mass: 150835.7105922,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681630,
    name: "Er163",
    latex: "^{163}\\mathrm{Er}",
    mass: 151768.3715786,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681630,
    name: "Er163~",
    latex: "^{163}\\mathrm{\\overline{Er}}",
    mass: 151768.3715786,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681640,
    name: "Er164",
    latex: "^{164}\\mathrm{Er}",
    mass: 152699.0903998,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681640,
    name: "Er164~",
    latex: "^{164}\\mathrm{\\overline{Er}}",
    mass: 152699.0903998,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681650,
    name: "Er165",
    latex: "^{165}\\mathrm{Er}",
    mass: 153632.0057772,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681650,
    name: "Er165~",
    latex: "^{165}\\mathrm{\\overline{Er}}",
    mass: 153632.0057772,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681660,
    name: "Er166",
    latex: "^{166}\\mathrm{Er}",
    mass: 154563.0971029,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681660,
    name: "Er166~",
    latex: "^{166}\\mathrm{\\overline{Er}}",
    mass: 154563.0971029,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681670,
    name: "Er167",
    latex: "^{167}\\mathrm{Er}",
    mass: 155496.2260719,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681670,
    name: "Er167~",
    latex: "^{167}\\mathrm{\\overline{Er}}",
    mass: 155496.2260719,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681680,
    name: "Er168",
    latex: "^{168}\\mathrm{Er}",
    mass: 156428.0201913,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681680,
    name: "Er168~",
    latex: "^{168}\\mathrm{\\overline{Er}}",
    mass: 156428.0201913,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681690,
    name: "Er169",
    latex: "^{169}\\mathrm{Er}",
    mass: 157361.5823237,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681690,
    name: "Er169~",
    latex: "^{169}\\mathrm{\\overline{Er}}",
    mass: 157361.5823237,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681700,
    name: "Er170",
    latex: "^{170}\\mathrm{Er}",
    mass: 158293.8900875,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681700,
    name: "Er170~",
    latex: "^{170}\\mathrm{\\overline{Er}}",
    mass: 158293.8900875,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681710,
    name: "Er171",
    latex: "^{171}\\mathrm{Er}",
    mass: 159227.7739393,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681710,
    name: "Er171~",
    latex: "^{171}\\mathrm{\\overline{Er}}",
    mass: 159227.7739393,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681720,
    name: "Er172",
    latex: "^{172}\\mathrm{Er}",
    mass: 160160.5028316,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681720,
    name: "Er172~",
    latex: "^{172}\\mathrm{\\overline{Er}}",
    mass: 160160.5028316,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681730,
    name: "Er173",
    latex: "^{173}\\mathrm{Er}",
    mass: 161094.8258829,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681730,
    name: "Er173~",
    latex: "^{173}\\mathrm{\\overline{Er}}",
    mass: 161094.8258829,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681740,
    name: "Er174",
    latex: "^{174}\\mathrm{Er}",
    mass: 162028.0246209,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681740,
    name: "Er174~",
    latex: "^{174}\\mathrm{\\overline{Er}}",
    mass: 162028.0246209,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681750,
    name: "Er175",
    latex: "^{175}\\mathrm{Er}",
    mass: 162962.8162137,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681750,
    name: "Er175~",
    latex: "^{175}\\mathrm{\\overline{Er}}",
    mass: 162962.8162137,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681760,
    name: "Er176",
    latex: "^{176}\\mathrm{Er}",
    mass: 163896.3316596,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681760,
    name: "Er176~",
    latex: "^{176}\\mathrm{\\overline{Er}}",
    mass: 163896.3316596,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000681770,
    name: "Er177",
    latex: "^{177}\\mathrm{Er}",
    mass: 164831.5983145,
    width: undefined,
    charge: 68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000681770,
    name: "Er177~",
    latex: "^{177}\\mathrm{\\overline{Er}}",
    mass: 164831.5983145,
    width: undefined,
    charge: -68.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691460,
    name: "Tm146",
    latex: "^{146}\\mathrm{Tm}",
    mass: 135967.0831295,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691460,
    name: "Tm146~",
    latex: "^{146}\\mathrm{\\overline{Tm}}",
    mass: 135967.0831295,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691470,
    name: "Tm147",
    latex: "^{147}\\mathrm{Tm}",
    mass: 136893.6589443,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691470,
    name: "Tm147~",
    latex: "^{147}\\mathrm{\\overline{Tm}}",
    mass: 136893.6589443,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691480,
    name: "Tm148",
    latex: "^{148}\\mathrm{Tm}",
    mass: 137822.3622917,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691480,
    name: "Tm148~",
    latex: "^{148}\\mathrm{\\overline{Tm}}",
    mass: 137822.3622917,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691490,
    name: "Tm149",
    latex: "^{149}\\mathrm{Tm}",
    mass: 138748.6828772,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691490,
    name: "Tm149~",
    latex: "^{149}\\mathrm{\\overline{Tm}}",
    mass: 138748.6828772,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691500,
    name: "Tm150",
    latex: "^{150}\\mathrm{Tm}",
    mass: 139677.6246871,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691500,
    name: "Tm150~",
    latex: "^{150}\\mathrm{\\overline{Tm}}",
    mass: 139677.6246871,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691510,
    name: "Tm151",
    latex: "^{151}\\mathrm{Tm}",
    mass: 140604.8376439,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691510,
    name: "Tm151~",
    latex: "^{151}\\mathrm{\\overline{Tm}}",
    mass: 140604.8376439,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691520,
    name: "Tm152",
    latex: "^{152}\\mathrm{Tm}",
    mass: 141535.3872126,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691520,
    name: "Tm152~",
    latex: "^{152}\\mathrm{\\overline{Tm}}",
    mass: 141535.3872126,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691530,
    name: "Tm153",
    latex: "^{153}\\mathrm{Tm}",
    mass: 142464.6252376,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691530,
    name: "Tm153~",
    latex: "^{153}\\mathrm{\\overline{Tm}}",
    mass: 142464.6252376,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691540,
    name: "Tm154",
    latex: "^{154}\\mathrm{Tm}",
    mass: 143395.6647722,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691540,
    name: "Tm154~",
    latex: "^{154}\\mathrm{\\overline{Tm}}",
    mass: 143395.6647722,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691550,
    name: "Tm155",
    latex: "^{155}\\mathrm{Tm}",
    mass: 144324.9605498,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691550,
    name: "Tm155~",
    latex: "^{155}\\mathrm{\\overline{Tm}}",
    mass: 144324.9605498,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691560,
    name: "Tm156",
    latex: "^{156}\\mathrm{Tm}",
    mass: 145256.2459989,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691560,
    name: "Tm156~",
    latex: "^{156}\\mathrm{\\overline{Tm}}",
    mass: 145256.2459989,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691570,
    name: "Tm157",
    latex: "^{157}\\mathrm{Tm}",
    mass: 146185.8622105,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691570,
    name: "Tm157~",
    latex: "^{157}\\mathrm{\\overline{Tm}}",
    mass: 146185.8622105,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691580,
    name: "Tm158",
    latex: "^{158}\\mathrm{Tm}",
    mass: 147117.3656291,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691580,
    name: "Tm158~",
    latex: "^{158}\\mathrm{\\overline{Tm}}",
    mass: 147117.3656291,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691590,
    name: "Tm159",
    latex: "^{159}\\mathrm{Tm}",
    mass: 148046.9967446,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691590,
    name: "Tm159~",
    latex: "^{159}\\mathrm{\\overline{Tm}}",
    mass: 148046.9967446,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691600,
    name: "Tm160",
    latex: "^{160}\\mathrm{Tm}",
    mass: 148978.7516667,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691600,
    name: "Tm160~",
    latex: "^{160}\\mathrm{\\overline{Tm}}",
    mass: 148978.7516667,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691610,
    name: "Tm161",
    latex: "^{161}\\mathrm{Tm}",
    mass: 149908.6529155,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691610,
    name: "Tm161~",
    latex: "^{161}\\mathrm{\\overline{Tm}}",
    mass: 149908.6529155,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691620,
    name: "Tm162",
    latex: "^{162}\\mathrm{Tm}",
    mass: 150840.5671231,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691620,
    name: "Tm162~",
    latex: "^{162}\\mathrm{\\overline{Tm}}",
    mass: 150840.5671231,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691630,
    name: "Tm163",
    latex: "^{163}\\mathrm{Tm}",
    mass: 151770.8102302,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691630,
    name: "Tm163~",
    latex: "^{163}\\mathrm{\\overline{Tm}}",
    mass: 151770.8102302,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691640,
    name: "Tm164",
    latex: "^{164}\\mathrm{Tm}",
    mass: 152703.1240487,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691640,
    name: "Tm164~",
    latex: "^{164}\\mathrm{\\overline{Tm}}",
    mass: 152703.1240487,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691650,
    name: "Tm165",
    latex: "^{165}\\mathrm{Tm}",
    mass: 153633.5970486,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691650,
    name: "Tm165~",
    latex: "^{165}\\mathrm{\\overline{Tm}}",
    mass: 153633.5970486,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691660,
    name: "Tm166",
    latex: "^{166}\\mathrm{Tm}",
    mass: 154566.134612,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691660,
    name: "Tm166~",
    latex: "^{166}\\mathrm{\\overline{Tm}}",
    mass: 154566.134612,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691670,
    name: "Tm167",
    latex: "^{167}\\mathrm{Tm}",
    mass: 155496.9721987,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691670,
    name: "Tm167~",
    latex: "^{167}\\mathrm{\\overline{Tm}}",
    mass: 155496.9721987,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691680,
    name: "Tm168",
    latex: "^{168}\\mathrm{Tm}",
    mass: 156429.6970856,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691680,
    name: "Tm168~",
    latex: "^{168}\\mathrm{\\overline{Tm}}",
    mass: 156429.6970856,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691690,
    name: "Tm169",
    latex: "^{169}\\mathrm{Tm}",
    mass: 157361.2289148,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691690,
    name: "Tm169~",
    latex: "^{169}\\mathrm{\\overline{Tm}}",
    mass: 157361.2289148,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691700,
    name: "Tm170",
    latex: "^{170}\\mathrm{Tm}",
    mass: 158294.2023243,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691700,
    name: "Tm170~",
    latex: "^{170}\\mathrm{\\overline{Tm}}",
    mass: 158294.2023243,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691710,
    name: "Tm171",
    latex: "^{171}\\mathrm{Tm}",
    mass: 159226.2814995,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691710,
    name: "Tm171~",
    latex: "^{171}\\mathrm{\\overline{Tm}}",
    mass: 159226.2814995,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691720,
    name: "Tm172",
    latex: "^{172}\\mathrm{Tm}",
    mass: 160159.6123233,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691720,
    name: "Tm172~",
    latex: "^{172}\\mathrm{\\overline{Tm}}",
    mass: 160159.6123233,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691730,
    name: "Tm173",
    latex: "^{173}\\mathrm{Tm}",
    mass: 161092.2242199,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691730,
    name: "Tm173~",
    latex: "^{173}\\mathrm{\\overline{Tm}}",
    mass: 161092.2242199,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691740,
    name: "Tm174",
    latex: "^{174}\\mathrm{Tm}",
    mass: 162026.105743,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691740,
    name: "Tm174~",
    latex: "^{174}\\mathrm{\\overline{Tm}}",
    mass: 162026.105743,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691750,
    name: "Tm175",
    latex: "^{175}\\mathrm{Tm}",
    mass: 162959.1554419,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691750,
    name: "Tm175~",
    latex: "^{175}\\mathrm{\\overline{Tm}}",
    mass: 162959.1554419,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691760,
    name: "Tm176",
    latex: "^{176}\\mathrm{Tm}",
    mass: 163893.593067,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691760,
    name: "Tm176~",
    latex: "^{176}\\mathrm{\\overline{Tm}}",
    mass: 163893.593067,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691770,
    name: "Tm177",
    latex: "^{177}\\mathrm{Tm}",
    mass: 164826.8849543,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691770,
    name: "Tm177~",
    latex: "^{177}\\mathrm{\\overline{Tm}}",
    mass: 164826.8849543,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691780,
    name: "Tm178",
    latex: "^{178}\\mathrm{Tm}",
    mass: 165761.7138069,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691780,
    name: "Tm178~",
    latex: "^{178}\\mathrm{\\overline{Tm}}",
    mass: 165761.7138069,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000691790,
    name: "Tm179",
    latex: "^{179}\\mathrm{Tm}",
    mass: 166695.5459608,
    width: undefined,
    charge: 69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000691790,
    name: "Tm179~",
    latex: "^{179}\\mathrm{\\overline{Tm}}",
    mass: 166695.5459608,
    width: undefined,
    charge: -69.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701480,
    name: "Yb148",
    latex: "^{148}\\mathrm{Yb}",
    mass: 137830.9003667,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701480,
    name: "Yb148~",
    latex: "^{148}\\mathrm{\\overline{Yb}}",
    mass: 137830.9003667,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701490,
    name: "Yb149",
    latex: "^{149}\\mathrm{Yb}",
    mass: 138759.292595,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701490,
    name: "Yb149~",
    latex: "^{149}\\mathrm{\\overline{Yb}}",
    mass: 138759.292595,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701500,
    name: "Yb150",
    latex: "^{150}\\mathrm{Yb}",
    mass: 139685.2815686,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701500,
    name: "Yb150~",
    latex: "^{150}\\mathrm{\\overline{Yb}}",
    mass: 139685.2815686,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701510,
    name: "Yb151",
    latex: "^{151}\\mathrm{Yb}",
    mass: 140614.0650245,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701510,
    name: "Yb151~",
    latex: "^{151}\\mathrm{\\overline{Yb}}",
    mass: 140614.0650245,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701520,
    name: "Yb152",
    latex: "^{152}\\mathrm{Yb}",
    mass: 141540.8364531,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701520,
    name: "Yb152~",
    latex: "^{152}\\mathrm{\\overline{Yb}}",
    mass: 141540.8364531,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701530,
    name: "Yb153",
    latex: "^{153}\\mathrm{Yb}",
    mass: 142471.4363225,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701530,
    name: "Yb153~",
    latex: "^{153}\\mathrm{\\overline{Yb}}",
    mass: 142471.4363225,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701540,
    name: "Yb154",
    latex: "^{154}\\mathrm{Yb}",
    mass: 143400.1601627,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701540,
    name: "Yb154~",
    latex: "^{154}\\mathrm{\\overline{Yb}}",
    mass: 143400.1601627,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701550,
    name: "Yb155",
    latex: "^{155}\\mathrm{Yb}",
    mass: 144331.0832606,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701550,
    name: "Yb155~",
    latex: "^{155}\\mathrm{\\overline{Yb}}",
    mass: 144331.0832606,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701560,
    name: "Yb156",
    latex: "^{156}\\mathrm{Yb}",
    mass: 145259.8145528,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701560,
    name: "Yb156~",
    latex: "^{156}\\mathrm{\\overline{Yb}}",
    mass: 145259.8145528,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701570,
    name: "Yb157",
    latex: "^{157}\\mathrm{Yb}",
    mass: 146191.1540285,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701570,
    name: "Yb157~",
    latex: "^{157}\\mathrm{\\overline{Yb}}",
    mass: 146191.1540285,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701580,
    name: "Yb158",
    latex: "^{158}\\mathrm{Yb}",
    mass: 147120.0585786,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701580,
    name: "Yb158~",
    latex: "^{158}\\mathrm{\\overline{Yb}}",
    mass: 147120.0585786,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701590,
    name: "Yb159",
    latex: "^{159}\\mathrm{Yb}",
    mass: 148051.7287347,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701590,
    name: "Yb159~",
    latex: "^{159}\\mathrm{\\overline{Yb}}",
    mass: 148051.7287347,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701600,
    name: "Yb160",
    latex: "^{160}\\mathrm{Yb}",
    mass: 148980.8931716,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701600,
    name: "Yb160~",
    latex: "^{160}\\mathrm{\\overline{Yb}}",
    mass: 148980.8931716,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701610,
    name: "Yb161",
    latex: "^{161}\\mathrm{Yb}",
    mass: 149912.7160928,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701610,
    name: "Yb161~",
    latex: "^{161}\\mathrm{\\overline{Yb}}",
    mass: 149912.7160928,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701620,
    name: "Yb162",
    latex: "^{162}\\mathrm{Yb}",
    mass: 150842.2233196,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701620,
    name: "Yb162~",
    latex: "^{162}\\mathrm{\\overline{Yb}}",
    mass: 150842.2233196,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701630,
    name: "Yb163",
    latex: "^{163}\\mathrm{Yb}",
    mass: 151774.244649,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701630,
    name: "Yb163~",
    latex: "^{163}\\mathrm{\\overline{Yb}}",
    mass: 151774.244649,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701640,
    name: "Yb164",
    latex: "^{164}\\mathrm{Yb}",
    mass: 152704.0210775,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701640,
    name: "Yb164~",
    latex: "^{164}\\mathrm{\\overline{Yb}}",
    mass: 152704.0210775,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701650,
    name: "Yb165",
    latex: "^{165}\\mathrm{Yb}",
    mass: 153636.2315002,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701650,
    name: "Yb165~",
    latex: "^{165}\\mathrm{\\overline{Yb}}",
    mass: 153636.2315002,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701660,
    name: "Yb166",
    latex: "^{166}\\mathrm{Yb}",
    mass: 154566.4271012,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701660,
    name: "Yb166~",
    latex: "^{166}\\mathrm{\\overline{Yb}}",
    mass: 154566.4271012,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701670,
    name: "Yb167",
    latex: "^{167}\\mathrm{Yb}",
    mass: 155498.9253555,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701670,
    name: "Yb167~",
    latex: "^{167}\\mathrm{\\overline{Yb}}",
    mass: 155498.9253555,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701680,
    name: "Yb168",
    latex: "^{168}\\mathrm{Yb}",
    mass: 156429.4295605,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701680,
    name: "Yb168~",
    latex: "^{168}\\mathrm{\\overline{Yb}}",
    mass: 156429.4295605,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701690,
    name: "Yb169",
    latex: "^{169}\\mathrm{Yb}",
    mass: 157362.1280022,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701690,
    name: "Yb169~",
    latex: "^{169}\\mathrm{\\overline{Yb}}",
    mass: 157362.1280022,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701700,
    name: "Yb170",
    latex: "^{170}\\mathrm{Yb}",
    mass: 158293.2337036,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701700,
    name: "Yb170~",
    latex: "^{170}\\mathrm{\\overline{Yb}}",
    mass: 158293.2337036,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701710,
    name: "Yb171",
    latex: "^{171}\\mathrm{Yb}",
    mass: 159226.1849175,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701710,
    name: "Yb171~",
    latex: "^{171}\\mathrm{\\overline{Yb}}",
    mass: 159226.1849175,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701720,
    name: "Yb172",
    latex: "^{172}\\mathrm{Yb}",
    mass: 160157.7303829,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701720,
    name: "Yb172~",
    latex: "^{172}\\mathrm{\\overline{Yb}}",
    mass: 160157.7303829,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701730,
    name: "Yb173",
    latex: "^{173}\\mathrm{Yb}",
    mass: 161090.9287091,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701730,
    name: "Yb173~",
    latex: "^{173}\\mathrm{\\overline{Yb}}",
    mass: 161090.9287091,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701740,
    name: "Yb174",
    latex: "^{174}\\mathrm{Yb}",
    mass: 162023.0295266,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701740,
    name: "Yb174~",
    latex: "^{174}\\mathrm{\\overline{Yb}}",
    mass: 162023.0295266,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701750,
    name: "Yb175",
    latex: "^{175}\\mathrm{Yb}",
    mass: 162956.7725961,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701750,
    name: "Yb175~",
    latex: "^{175}\\mathrm{\\overline{Yb}}",
    mass: 162956.7725961,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701760,
    name: "Yb176",
    latex: "^{176}\\mathrm{Yb}",
    mass: 163889.4709317,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701760,
    name: "Yb176~",
    latex: "^{176}\\mathrm{\\overline{Yb}}",
    mass: 163889.4709317,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701770,
    name: "Yb177",
    latex: "^{177}\\mathrm{Yb}",
    mass: 164823.4699572,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701770,
    name: "Yb177~",
    latex: "^{177}\\mathrm{\\overline{Yb}}",
    mass: 164823.4699572,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701780,
    name: "Yb178",
    latex: "^{178}\\mathrm{Yb}",
    mass: 165756.2729499,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701780,
    name: "Yb178~",
    latex: "^{178}\\mathrm{\\overline{Yb}}",
    mass: 165756.2729499,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701790,
    name: "Yb179",
    latex: "^{179}\\mathrm{Yb}",
    mass: 166690.8046559,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701790,
    name: "Yb179~",
    latex: "^{179}\\mathrm{\\overline{Yb}}",
    mass: 166690.8046559,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701800,
    name: "Yb180",
    latex: "^{180}\\mathrm{Yb}",
    mass: 167624.2176374,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701800,
    name: "Yb180~",
    latex: "^{180}\\mathrm{\\overline{Yb}}",
    mass: 167624.2176374,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000701810,
    name: "Yb181",
    latex: "^{181}\\mathrm{Yb}",
    mass: 168559.3445681,
    width: undefined,
    charge: 70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000701810,
    name: "Yb181~",
    latex: "^{181}\\mathrm{\\overline{Yb}}",
    mass: 168559.3445681,
    width: undefined,
    charge: -70.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711500,
    name: "Lu150",
    latex: "^{150}\\mathrm{Lu}",
    mass: 139699.3471296,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711500,
    name: "Lu150~",
    latex: "^{150}\\mathrm{\\overline{Lu}}",
    mass: 139699.3471296,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711510,
    name: "Lu151",
    latex: "^{151}\\mathrm{Lu}",
    mass: 140625.3081583,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711510,
    name: "Lu151~",
    latex: "^{151}\\mathrm{\\overline{Lu}}",
    mass: 140625.3081583,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711520,
    name: "Lu152",
    latex: "^{152}\\mathrm{Lu}",
    mass: 141553.6817568,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711520,
    name: "Lu152~",
    latex: "^{152}\\mathrm{\\overline{Lu}}",
    mass: 141553.6817568,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711530,
    name: "Lu153",
    latex: "^{153}\\mathrm{Lu}",
    mass: 142480.2203119,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711530,
    name: "Lu153~",
    latex: "^{153}\\mathrm{\\overline{Lu}}",
    mass: 142480.2203119,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711540,
    name: "Lu154",
    latex: "^{154}\\mathrm{Lu}",
    mass: 143410.4289537,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711540,
    name: "Lu154~",
    latex: "^{154}\\mathrm{\\overline{Lu}}",
    mass: 143410.4289537,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711550,
    name: "Lu155",
    latex: "^{155}\\mathrm{Lu}",
    mass: 144339.0410147,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711550,
    name: "Lu155~",
    latex: "^{155}\\mathrm{\\overline{Lu}}",
    mass: 144339.0410147,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711560,
    name: "Lu156",
    latex: "^{156}\\mathrm{Lu}",
    mass: 145269.3837917,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711560,
    name: "Lu156~",
    latex: "^{156}\\mathrm{\\overline{Lu}}",
    mass: 145269.3837917,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711570,
    name: "Lu157",
    latex: "^{157}\\mathrm{Lu}",
    mass: 146198.1346453,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711570,
    name: "Lu157~",
    latex: "^{157}\\mathrm{\\overline{Lu}}",
    mass: 146198.1346453,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711580,
    name: "Lu158",
    latex: "^{158}\\mathrm{Lu}",
    mass: 147128.8565404,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711580,
    name: "Lu158~",
    latex: "^{158}\\mathrm{\\overline{Lu}}",
    mass: 147128.8565404,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711590,
    name: "Lu159",
    latex: "^{159}\\mathrm{Lu}",
    mass: 148057.8579659,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711590,
    name: "Lu159~",
    latex: "^{159}\\mathrm{\\overline{Lu}}",
    mass: 148057.8579659,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711600,
    name: "Lu160",
    latex: "^{160}\\mathrm{Lu}",
    mass: 148988.7838582,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711600,
    name: "Lu160~",
    latex: "^{160}\\mathrm{\\overline{Lu}}",
    mass: 148988.7838582,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711610,
    name: "Lu161",
    latex: "^{161}\\mathrm{Lu}",
    mass: 149917.9864864,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711610,
    name: "Lu161~",
    latex: "^{161}\\mathrm{\\overline{Lu}}",
    mass: 149917.9864864,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711620,
    name: "Lu162",
    latex: "^{162}\\mathrm{Lu}",
    mass: 150849.2104568,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711620,
    name: "Lu162~",
    latex: "^{162}\\mathrm{\\overline{Lu}}",
    mass: 150849.2104568,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711630,
    name: "Lu163",
    latex: "^{163}\\mathrm{Lu}",
    mass: 151778.7484229,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711630,
    name: "Lu163~",
    latex: "^{163}\\mathrm{\\overline{Lu}}",
    mass: 151778.7484229,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711640,
    name: "Lu164",
    latex: "^{164}\\mathrm{Lu}",
    mass: 152710.3915657,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711640,
    name: "Lu164~",
    latex: "^{164}\\mathrm{\\overline{Lu}}",
    mass: 152710.3915657,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711650,
    name: "Lu165",
    latex: "^{165}\\mathrm{Lu}",
    mass: 153640.0850913,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711650,
    name: "Lu165~",
    latex: "^{165}\\mathrm{\\overline{Lu}}",
    mass: 153640.0850913,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711660,
    name: "Lu166",
    latex: "^{166}\\mathrm{Lu}",
    mass: 154572.0011619,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711660,
    name: "Lu166~",
    latex: "^{166}\\mathrm{\\overline{Lu}}",
    mass: 154572.0011619,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711670,
    name: "Lu167",
    latex: "^{167}\\mathrm{Lu}",
    mass: 155501.9862452,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711670,
    name: "Lu167~",
    latex: "^{167}\\mathrm{\\overline{Lu}}",
    mass: 155501.9862452,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711680,
    name: "Lu168",
    latex: "^{168}\\mathrm{Lu}",
    mass: 156433.936781,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711680,
    name: "Lu168~",
    latex: "^{168}\\mathrm{\\overline{Lu}}",
    mass: 156433.936781,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711690,
    name: "Lu169",
    latex: "^{169}\\mathrm{Lu}",
    mass: 157364.4211451,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711690,
    name: "Lu169~",
    latex: "^{169}\\mathrm{\\overline{Lu}}",
    mass: 157364.4211451,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711700,
    name: "Lu170",
    latex: "^{170}\\mathrm{Lu}",
    mass: 158296.6911834,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711700,
    name: "Lu170~",
    latex: "^{170}\\mathrm{\\overline{Lu}}",
    mass: 158296.6911834,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711710,
    name: "Lu171",
    latex: "^{171}\\mathrm{Lu}",
    mass: 159227.6632778,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711710,
    name: "Lu171~",
    latex: "^{171}\\mathrm{\\overline{Lu}}",
    mass: 159227.6632778,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711720,
    name: "Lu172",
    latex: "^{172}\\mathrm{Lu}",
    mass: 160160.2497447,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711720,
    name: "Lu172~",
    latex: "^{172}\\mathrm{\\overline{Lu}}",
    mass: 160160.2497447,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711730,
    name: "Lu173",
    latex: "^{173}\\mathrm{Lu}",
    mass: 161091.5989079,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711730,
    name: "Lu173~",
    latex: "^{173}\\mathrm{\\overline{Lu}}",
    mass: 161091.5989079,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711740,
    name: "Lu174",
    latex: "^{174}\\mathrm{Lu}",
    mass: 162024.403717,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711740,
    name: "Lu174~",
    latex: "^{174}\\mathrm{\\overline{Lu}}",
    mass: 162024.403717,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711750,
    name: "Lu175",
    latex: "^{175}\\mathrm{Lu}",
    mass: 162956.3024617,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711750,
    name: "Lu175~",
    latex: "^{175}\\mathrm{\\overline{Lu}}",
    mass: 162956.3024617,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711760,
    name: "Lu176",
    latex: "^{176}\\mathrm{Lu}",
    mass: 163889.5799109,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711760,
    name: "Lu176~",
    latex: "^{176}\\mathrm{\\overline{Lu}}",
    mass: 163889.5799109,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711770,
    name: "Lu177",
    latex: "^{177}\\mathrm{Lu}",
    mass: 164822.0724832,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711770,
    name: "Lu177~",
    latex: "^{177}\\mathrm{\\overline{Lu}}",
    mass: 164822.0724832,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711780,
    name: "Lu178",
    latex: "^{178}\\mathrm{Lu}",
    mass: 165755.6126137,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711780,
    name: "Lu178~",
    latex: "^{178}\\mathrm{\\overline{Lu}}",
    mass: 165755.6126137,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711790,
    name: "Lu179",
    latex: "^{179}\\mathrm{Lu}",
    mass: 166688.3855657,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711790,
    name: "Lu179~",
    latex: "^{179}\\mathrm{\\overline{Lu}}",
    mass: 166688.3855657,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711800,
    name: "Lu180",
    latex: "^{180}\\mathrm{Lu}",
    mass: 167622.2614998,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711800,
    name: "Lu180~",
    latex: "^{180}\\mathrm{\\overline{Lu}}",
    mass: 167622.2614998,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711810,
    name: "Lu181",
    latex: "^{181}\\mathrm{Lu}",
    mass: 168555.6372216,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711810,
    name: "Lu181~",
    latex: "^{181}\\mathrm{\\overline{Lu}}",
    mass: 168555.6372216,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711820,
    name: "Lu182",
    latex: "^{182}\\mathrm{Lu}",
    mass: 169490.1586812,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711820,
    name: "Lu182~",
    latex: "^{182}\\mathrm{\\overline{Lu}}",
    mass: 169490.1586812,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711830,
    name: "Lu183",
    latex: "^{183}\\mathrm{Lu}",
    mass: 170423.7020719,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711830,
    name: "Lu183~",
    latex: "^{183}\\mathrm{\\overline{Lu}}",
    mass: 170423.7020719,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000711840,
    name: "Lu184",
    latex: "^{184}\\mathrm{Lu}",
    mass: 171358.614759,
    width: undefined,
    charge: 71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000711840,
    name: "Lu184~",
    latex: "^{184}\\mathrm{\\overline{Lu}}",
    mass: 171358.614759,
    width: undefined,
    charge: -71.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721540,
    name: "Hf154",
    latex: "^{154}\\mathrm{Hf}",
    mass: 143417.3592699,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721540,
    name: "Hf154~",
    latex: "^{154}\\mathrm{\\overline{Hf}}",
    mass: 143417.3592699,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721550,
    name: "Hf155",
    latex: "^{155}\\mathrm{Hf}",
    mass: 144347.2791485,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721550,
    name: "Hf155~",
    latex: "^{155}\\mathrm{\\overline{Hf}}",
    mass: 144347.2791485,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721560,
    name: "Hf156",
    latex: "^{156}\\mathrm{Hf}",
    mass: 145275.2615195,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721560,
    name: "Hf156~",
    latex: "^{156}\\mathrm{\\overline{Hf}}",
    mass: 145275.2615195,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721570,
    name: "Hf157",
    latex: "^{157}\\mathrm{Hf}",
    mass: 146205.7216647,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721570,
    name: "Hf157~",
    latex: "^{157}\\mathrm{\\overline{Hf}}",
    mass: 146205.7216647,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721580,
    name: "Hf158",
    latex: "^{158}\\mathrm{Hf}",
    mass: 147133.9657855,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721580,
    name: "Hf158~",
    latex: "^{158}\\mathrm{\\overline{Hf}}",
    mass: 147133.9657855,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721590,
    name: "Hf159",
    latex: "^{159}\\mathrm{Hf}",
    mass: 148064.7100365,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721590,
    name: "Hf159~",
    latex: "^{159}\\mathrm{\\overline{Hf}}",
    mass: 148064.7100365,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721600,
    name: "Hf160",
    latex: "^{160}\\mathrm{Hf}",
    mass: 148993.1181003,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721600,
    name: "Hf160~",
    latex: "^{160}\\mathrm{\\overline{Hf}}",
    mass: 148993.1181003,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721610,
    name: "Hf161",
    latex: "^{161}\\mathrm{Hf}",
    mass: 149924.2349489,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721610,
    name: "Hf161~",
    latex: "^{161}\\mathrm{\\overline{Hf}}",
    mass: 149924.2349489,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721620,
    name: "Hf162",
    latex: "^{162}\\mathrm{Hf}",
    mass: 150852.8768176,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721620,
    name: "Hf162~",
    latex: "^{162}\\mathrm{\\overline{Hf}}",
    mass: 150852.8768176,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721630,
    name: "Hf163",
    latex: "^{163}\\mathrm{Hf}",
    mass: 151784.2693885,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721630,
    name: "Hf163~",
    latex: "^{163}\\mathrm{\\overline{Hf}}",
    mass: 151784.2693885,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721640,
    name: "Hf164",
    latex: "^{164}\\mathrm{Hf}",
    mass: 152713.2149243,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721640,
    name: "Hf164~",
    latex: "^{164}\\mathrm{\\overline{Hf}}",
    mass: 152713.2149243,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721650,
    name: "Hf165",
    latex: "^{165}\\mathrm{Hf}",
    mass: 153644.8943954,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721650,
    name: "Hf165~",
    latex: "^{165}\\mathrm{\\overline{Hf}}",
    mass: 153644.8943954,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721660,
    name: "Hf166",
    latex: "^{166}\\mathrm{Hf}",
    mass: 154574.1622282,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721660,
    name: "Hf166~",
    latex: "^{166}\\mathrm{\\overline{Hf}}",
    mass: 154574.1622282,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721670,
    name: "Hf167",
    latex: "^{167}\\mathrm{Hf}",
    mass: 155506.0475594,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721670,
    name: "Hf167~",
    latex: "^{167}\\mathrm{\\overline{Hf}}",
    mass: 155506.0475594,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721680,
    name: "Hf168",
    latex: "^{168}\\mathrm{Hf}",
    mass: 156435.6507301,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721680,
    name: "Hf168~",
    latex: "^{168}\\mathrm{\\overline{Hf}}",
    mass: 156435.6507301,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721690,
    name: "Hf169",
    latex: "^{169}\\mathrm{Hf}",
    mass: 157367.7875648,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721690,
    name: "Hf169~",
    latex: "^{169}\\mathrm{\\overline{Hf}}",
    mass: 157367.7875648,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721700,
    name: "Hf170",
    latex: "^{170}\\mathrm{Hf}",
    mass: 158297.7447032,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721700,
    name: "Hf170~",
    latex: "^{170}\\mathrm{\\overline{Hf}}",
    mass: 158297.7447032,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721710,
    name: "Hf171",
    latex: "^{171}\\mathrm{Hf}",
    mass: 159230.0585218,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721710,
    name: "Hf171~",
    latex: "^{171}\\mathrm{\\overline{Hf}}",
    mass: 159230.0585218,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721720,
    name: "Hf172",
    latex: "^{172}\\mathrm{Hf}",
    mass: 160160.5838716,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721720,
    name: "Hf172~",
    latex: "^{172}\\mathrm{\\overline{Hf}}",
    mass: 160160.5838716,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721730,
    name: "Hf173",
    latex: "^{173}\\mathrm{Hf}",
    mass: 161093.0653591,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721730,
    name: "Hf173~",
    latex: "^{173}\\mathrm{\\overline{Hf}}",
    mass: 161093.0653591,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721740,
    name: "Hf174",
    latex: "^{174}\\mathrm{Hf}",
    mass: 162024.1294851,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721740,
    name: "Hf174~",
    latex: "^{174}\\mathrm{\\overline{Hf}}",
    mass: 162024.1294851,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721750,
    name: "Hf175",
    latex: "^{175}\\mathrm{Hf}",
    mass: 162956.9863647,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721750,
    name: "Hf175~",
    latex: "^{175}\\mathrm{\\overline{Hf}}",
    mass: 162956.9863647,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721760,
    name: "Hf176",
    latex: "^{176}\\mathrm{Hf}",
    mass: 163888.3858286,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721760,
    name: "Hf176~",
    latex: "^{176}\\mathrm{\\overline{Hf}}",
    mass: 163888.3858286,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721770,
    name: "Hf177",
    latex: "^{177}\\mathrm{Hf}",
    mass: 164821.5756242,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721770,
    name: "Hf177~",
    latex: "^{177}\\mathrm{\\overline{Hf}}",
    mass: 164821.5756242,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721780,
    name: "Hf178",
    latex: "^{178}\\mathrm{Hf}",
    mass: 165753.5150753,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721780,
    name: "Hf178~",
    latex: "^{178}\\mathrm{\\overline{Hf}}",
    mass: 165753.5150753,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721790,
    name: "Hf179",
    latex: "^{179}\\mathrm{Hf}",
    mass: 166686.9815246,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721790,
    name: "Hf179~",
    latex: "^{179}\\mathrm{\\overline{Hf}}",
    mass: 166686.9815246,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721800,
    name: "Hf180",
    latex: "^{180}\\mathrm{Hf}",
    mass: 167619.1591587,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721800,
    name: "Hf180~",
    latex: "^{180}\\mathrm{\\overline{Hf}}",
    mass: 167619.1591587,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721810,
    name: "Hf181",
    latex: "^{181}\\mathrm{Hf}",
    mass: 168553.0297833,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721810,
    name: "Hf181~",
    latex: "^{181}\\mathrm{\\overline{Hf}}",
    mass: 168553.0297833,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721820,
    name: "Hf182",
    latex: "^{182}\\mathrm{Hf}",
    mass: 169485.8775343,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721820,
    name: "Hf182~",
    latex: "^{182}\\mathrm{\\overline{Hf}}",
    mass: 169485.8775343,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721830,
    name: "Hf183",
    latex: "^{183}\\mathrm{Hf}",
    mass: 170420.1344495,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721830,
    name: "Hf183~",
    latex: "^{183}\\mathrm{\\overline{Hf}}",
    mass: 170420.1344495,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721840,
    name: "Hf184",
    latex: "^{184}\\mathrm{Hf}",
    mass: 171353.4170219,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721840,
    name: "Hf184~",
    latex: "^{184}\\mathrm{\\overline{Hf}}",
    mass: 171353.4170219,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721850,
    name: "Hf185",
    latex: "^{185}\\mathrm{Hf}",
    mass: 172288.0875205,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721850,
    name: "Hf185~",
    latex: "^{185}\\mathrm{\\overline{Hf}}",
    mass: 172288.0875205,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000721860,
    name: "Hf186",
    latex: "^{186}\\mathrm{Hf}",
    mass: 173221.4818722,
    width: undefined,
    charge: 72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000721860,
    name: "Hf186~",
    latex: "^{186}\\mathrm{\\overline{Hf}}",
    mass: 173221.4818722,
    width: undefined,
    charge: -72.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731560,
    name: "Ta156",
    latex: "^{156}\\mathrm{Ta}",
    mass: 145287.0821797,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731560,
    name: "Ta156~",
    latex: "^{156}\\mathrm{\\overline{Ta}}",
    mass: 145287.0821797,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731570,
    name: "Ta157",
    latex: "^{157}\\mathrm{Ta}",
    mass: 146214.9807161,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731570,
    name: "Ta157~",
    latex: "^{157}\\mathrm{\\overline{Ta}}",
    mass: 146214.9807161,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731580,
    name: "Ta158",
    latex: "^{158}\\mathrm{Ta}",
    mass: 147144.9471695,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731580,
    name: "Ta158~",
    latex: "^{158}\\mathrm{\\overline{Ta}}",
    mass: 147144.9471695,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731590,
    name: "Ta159",
    latex: "^{159}\\mathrm{Ta}",
    mass: 148073.1232912,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731590,
    name: "Ta159~",
    latex: "^{159}\\mathrm{\\overline{Ta}}",
    mass: 148073.1232912,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731600,
    name: "Ta160",
    latex: "^{160}\\mathrm{Ta}",
    mass: 149003.2313317,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731600,
    name: "Ta160~",
    latex: "^{160}\\mathrm{\\overline{Ta}}",
    mass: 149003.2313317,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731610,
    name: "Ta161",
    latex: "^{161}\\mathrm{Ta}",
    mass: 149931.7716677,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731610,
    name: "Ta161~",
    latex: "^{161}\\mathrm{\\overline{Ta}}",
    mass: 149931.7716677,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731620,
    name: "Ta162",
    latex: "^{162}\\mathrm{Ta}",
    mass: 150862.2606892,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731620,
    name: "Ta162~",
    latex: "^{162}\\mathrm{\\overline{Ta}}",
    mass: 150862.2606892,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731630,
    name: "Ta163",
    latex: "^{163}\\mathrm{Ta}",
    mass: 151791.0068854,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731630,
    name: "Ta163~",
    latex: "^{163}\\mathrm{\\overline{Ta}}",
    mass: 151791.0068854,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731640,
    name: "Ta164",
    latex: "^{164}\\mathrm{Ta}",
    mass: 152721.7464788,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731640,
    name: "Ta164~",
    latex: "^{164}\\mathrm{\\overline{Ta}}",
    mass: 152721.7464788,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731650,
    name: "Ta165",
    latex: "^{165}\\mathrm{Ta}",
    mass: 153650.6789738,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731650,
    name: "Ta165~",
    latex: "^{165}\\mathrm{\\overline{Ta}}",
    mass: 153650.6789738,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731660,
    name: "Ta166",
    latex: "^{166}\\mathrm{Ta}",
    mass: 154581.9215741,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731660,
    name: "Ta166~",
    latex: "^{166}\\mathrm{\\overline{Ta}}",
    mass: 154581.9215741,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731670,
    name: "Ta167",
    latex: "^{167}\\mathrm{Ta}",
    mass: 155511.1614621,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731670,
    name: "Ta167~",
    latex: "^{167}\\mathrm{\\overline{Ta}}",
    mass: 155511.1614621,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731680,
    name: "Ta168",
    latex: "^{168}\\mathrm{Ta}",
    mass: 156442.618306,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731680,
    name: "Ta168~",
    latex: "^{168}\\mathrm{\\overline{Ta}}",
    mass: 156442.618306,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731690,
    name: "Ta169",
    latex: "^{169}\\mathrm{Ta}",
    mass: 157372.2121618,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731690,
    name: "Ta169~",
    latex: "^{169}\\mathrm{\\overline{Ta}}",
    mass: 157372.2121618,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731700,
    name: "Ta170",
    latex: "^{170}\\mathrm{Ta}",
    mass: 158303.8646195,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731700,
    name: "Ta170~",
    latex: "^{170}\\mathrm{\\overline{Ta}}",
    mass: 158303.8646195,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731710,
    name: "Ta171",
    latex: "^{171}\\mathrm{Ta}",
    mass: 159233.7751832,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731710,
    name: "Ta171~",
    latex: "^{171}\\mathrm{\\overline{Ta}}",
    mass: 159233.7751832,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731720,
    name: "Ta172",
    latex: "^{172}\\mathrm{Ta}",
    mass: 160165.6605145,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731720,
    name: "Ta172~",
    latex: "^{172}\\mathrm{\\overline{Ta}}",
    mass: 160165.6605145,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731730,
    name: "Ta173",
    latex: "^{173}\\mathrm{Ta}",
    mass: 161096.0834,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731730,
    name: "Ta173~",
    latex: "^{173}\\mathrm{\\overline{Ta}}",
    mass: 161096.0834,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731740,
    name: "Ta174",
    latex: "^{174}\\mathrm{Ta}",
    mass: 162028.2295496,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731740,
    name: "Ta174~",
    latex: "^{174}\\mathrm{\\overline{Ta}}",
    mass: 162028.2295496,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731750,
    name: "Ta175",
    latex: "^{175}\\mathrm{Ta}",
    mass: 162959.0622925,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731750,
    name: "Ta175~",
    latex: "^{175}\\mathrm{\\overline{Ta}}",
    mass: 162959.0622925,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731760,
    name: "Ta176",
    latex: "^{176}\\mathrm{Ta}",
    mass: 163891.5996696,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731760,
    name: "Ta176~",
    latex: "^{176}\\mathrm{\\overline{Ta}}",
    mass: 163891.5996696,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731770,
    name: "Ta177",
    latex: "^{177}\\mathrm{Ta}",
    mass: 164822.7416685,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731770,
    name: "Ta177~",
    latex: "^{177}\\mathrm{\\overline{Ta}}",
    mass: 164822.7416685,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731780,
    name: "Ta178",
    latex: "^{178}\\mathrm{Ta}",
    mass: 165755.3517022,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731780,
    name: "Ta178~",
    latex: "^{178}\\mathrm{\\overline{Ta}}",
    mass: 165755.3517022,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731790,
    name: "Ta179",
    latex: "^{179}\\mathrm{Ta}",
    mass: 166687.087156,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731790,
    name: "Ta179~",
    latex: "^{179}\\mathrm{\\overline{Ta}}",
    mass: 166687.087156,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731800,
    name: "Ta180",
    latex: "^{180}\\mathrm{Ta}",
    mass: 167620.0050485,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731800,
    name: "Ta180~",
    latex: "^{180}\\mathrm{\\overline{Ta}}",
    mass: 167620.0050485,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731810,
    name: "Ta181",
    latex: "^{181}\\mathrm{Ta}",
    mass: 168551.9936824,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731810,
    name: "Ta181~",
    latex: "^{181}\\mathrm{\\overline{Ta}}",
    mass: 168551.9936824,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731820,
    name: "Ta182",
    latex: "^{182}\\mathrm{Ta}",
    mass: 169485.4961806,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731820,
    name: "Ta182~",
    latex: "^{182}\\mathrm{\\overline{Ta}}",
    mass: 169485.4961806,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731830,
    name: "Ta183",
    latex: "^{183}\\mathrm{Ta}",
    mass: 170418.1274523,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731830,
    name: "Ta183~",
    latex: "^{183}\\mathrm{\\overline{Ta}}",
    mass: 170418.1274523,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731840,
    name: "Ta184",
    latex: "^{184}\\mathrm{Ta}",
    mass: 171352.0756704,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731840,
    name: "Ta184~",
    latex: "^{184}\\mathrm{\\overline{Ta}}",
    mass: 171352.0756704,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731850,
    name: "Ta185",
    latex: "^{185}\\mathrm{Ta}",
    mass: 172285.0145215,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731850,
    name: "Ta185~",
    latex: "^{185}\\mathrm{\\overline{Ta}}",
    mass: 172285.0145215,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731860,
    name: "Ta186",
    latex: "^{186}\\mathrm{Ta}",
    mass: 173219.2928611,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731860,
    name: "Ta186~",
    latex: "^{186}\\mathrm{\\overline{Ta}}",
    mass: 173219.2928611,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731870,
    name: "Ta187",
    latex: "^{187}\\mathrm{Ta}",
    mass: 174152.5009139,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731870,
    name: "Ta187~",
    latex: "^{187}\\mathrm{\\overline{Ta}}",
    mass: 174152.5009139,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000731880,
    name: "Ta188",
    latex: "^{188}\\mathrm{Ta}",
    mass: 175086.9851137,
    width: undefined,
    charge: 73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000731880,
    name: "Ta188~",
    latex: "^{188}\\mathrm{\\overline{Ta}}",
    mass: 175086.9851137,
    width: undefined,
    charge: -73.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741580,
    name: "W158",
    latex: "^{158}\\mathrm{W}",
    mass: 147152.3804925,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741580,
    name: "W158~",
    latex: "^{158}\\mathrm{\\overline{W}}",
    mass: 147152.3804925,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741590,
    name: "W159",
    latex: "^{159}\\mathrm{W}",
    mass: 148082.1327022,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741590,
    name: "W159~",
    latex: "^{159}\\mathrm{\\overline{W}}",
    mass: 148082.1327022,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741600,
    name: "W160",
    latex: "^{160}\\mathrm{W}",
    mass: 149009.7238456,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741600,
    name: "W160~",
    latex: "^{160}\\mathrm{\\overline{W}}",
    mass: 149009.7238456,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741610,
    name: "W161",
    latex: "^{161}\\mathrm{W}",
    mass: 149940.0442668,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741610,
    name: "W161~",
    latex: "^{161}\\mathrm{\\overline{W}}",
    mass: 149940.0442668,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741620,
    name: "W162",
    latex: "^{162}\\mathrm{W}",
    mass: 150868.0452676,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741620,
    name: "W162~",
    latex: "^{162}\\mathrm{\\overline{W}}",
    mass: 150868.0452676,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741630,
    name: "W163",
    latex: "^{163}\\mathrm{W}",
    mass: 151798.6265071,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741630,
    name: "W163~",
    latex: "^{163}\\mathrm{\\overline{W}}",
    mass: 151798.6265071,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741640,
    name: "W164",
    latex: "^{164}\\mathrm{W}",
    mass: 152726.7970399,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741640,
    name: "W164~",
    latex: "^{164}\\mathrm{\\overline{W}}",
    mass: 152726.7970399,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741650,
    name: "W165",
    latex: "^{165}\\mathrm{W}",
    mass: 153657.6661111,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741650,
    name: "W165~",
    latex: "^{165}\\mathrm{\\overline{W}}",
    mass: 153657.6661111,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741660,
    name: "W166",
    latex: "^{166}\\mathrm{W}",
    mass: 154586.1337904,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741660,
    name: "W166~",
    latex: "^{166}\\mathrm{\\overline{W}}",
    mass: 154586.1337904,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741670,
    name: "W167",
    latex: "^{167}\\mathrm{W}",
    mass: 155517.4220339,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741670,
    name: "W167~",
    latex: "^{167}\\mathrm{\\overline{W}}",
    mass: 155517.4220339,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741680,
    name: "W168",
    latex: "^{168}\\mathrm{W}",
    mass: 156446.1160664,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741680,
    name: "W168~",
    latex: "^{168}\\mathrm{\\overline{W}}",
    mass: 156446.1160664,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741690,
    name: "W169",
    latex: "^{169}\\mathrm{W}",
    mass: 157377.5859513,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741690,
    name: "W169~",
    latex: "^{169}\\mathrm{\\overline{W}}",
    mass: 157377.5859513,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741700,
    name: "W170",
    latex: "^{170}\\mathrm{W}",
    mass: 158306.706608,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741700,
    name: "W170~",
    latex: "^{170}\\mathrm{\\overline{W}}",
    mass: 158306.706608,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741710,
    name: "W171",
    latex: "^{171}\\mathrm{W}",
    mass: 159238.4047089,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741710,
    name: "W171~",
    latex: "^{171}\\mathrm{\\overline{W}}",
    mass: 159238.4047089,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741720,
    name: "W172",
    latex: "^{172}\\mathrm{W}",
    mass: 160167.8867854,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741720,
    name: "W172~",
    latex: "^{172}\\mathrm{\\overline{W}}",
    mass: 160167.8867854,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741730,
    name: "W173",
    latex: "^{173}\\mathrm{W}",
    mass: 161099.7534867,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741730,
    name: "W173~",
    latex: "^{173}\\mathrm{\\overline{W}}",
    mass: 161099.7534867,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741740,
    name: "W174",
    latex: "^{174}\\mathrm{W}",
    mass: 162029.747885,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741740,
    name: "W174~",
    latex: "^{174}\\mathrm{\\overline{W}}",
    mass: 162029.747885,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741750,
    name: "W175",
    latex: "^{175}\\mathrm{W}",
    mass: 162961.8381449,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741750,
    name: "W175~",
    latex: "^{175}\\mathrm{\\overline{W}}",
    mass: 162961.8381449,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741760,
    name: "W176",
    latex: "^{176}\\mathrm{W}",
    mass: 163892.31692,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741760,
    name: "W176~",
    latex: "^{176}\\mathrm{\\overline{W}}",
    mass: 163892.31692,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741770,
    name: "W177",
    latex: "^{177}\\mathrm{W}",
    mass: 164824.7518328,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741770,
    name: "W177~",
    latex: "^{177}\\mathrm{\\overline{W}}",
    mass: 164824.7518328,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741780,
    name: "W178",
    latex: "^{178}\\mathrm{W}",
    mass: 165755.54359,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741780,
    name: "W178~",
    latex: "^{178}\\mathrm{\\overline{W}}",
    mass: 165755.54359,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741790,
    name: "W179",
    latex: "^{179}\\mathrm{W}",
    mass: 166688.1489662,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741790,
    name: "W179~",
    latex: "^{179}\\mathrm{\\overline{W}}",
    mass: 166688.1489662,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741800,
    name: "W180",
    latex: "^{180}\\mathrm{W}",
    mass: 167619.3024225,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741800,
    name: "W180~",
    latex: "^{180}\\mathrm{\\overline{W}}",
    mass: 167619.3024225,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741810,
    name: "W181",
    latex: "^{181}\\mathrm{W}",
    mass: 168552.1987974,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741810,
    name: "W181~",
    latex: "^{181}\\mathrm{\\overline{W}}",
    mass: 168552.1987974,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741820,
    name: "W182",
    latex: "^{182}\\mathrm{W}",
    mass: 169483.6806986,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741820,
    name: "W182~",
    latex: "^{182}\\mathrm{\\overline{W}}",
    mass: 169483.6806986,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741830,
    name: "W183",
    latex: "^{183}\\mathrm{W}",
    mass: 170417.0553026,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741830,
    name: "W183~",
    latex: "^{183}\\mathrm{\\overline{W}}",
    mass: 170417.0553026,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741840,
    name: "W184",
    latex: "^{184}\\mathrm{W}",
    mass: 171349.2096493,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741840,
    name: "W184~",
    latex: "^{184}\\mathrm{\\overline{W}}",
    mass: 171349.2096493,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741850,
    name: "W185",
    latex: "^{185}\\mathrm{W}",
    mass: 172283.0213104,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741850,
    name: "W185~",
    latex: "^{185}\\mathrm{\\overline{W}}",
    mass: 172283.0213104,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741860,
    name: "W186",
    latex: "^{186}\\mathrm{W}",
    mass: 173215.3946514,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741860,
    name: "W186~",
    latex: "^{186}\\mathrm{\\overline{W}}",
    mass: 173215.3946514,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741870,
    name: "W187",
    latex: "^{187}\\mathrm{W}",
    mass: 174149.4933058,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741870,
    name: "W187~",
    latex: "^{187}\\mathrm{\\overline{W}}",
    mass: 174149.4933058,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741880,
    name: "W188",
    latex: "^{188}\\mathrm{W}",
    mass: 175082.2233159,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741880,
    name: "W188~",
    latex: "^{188}\\mathrm{\\overline{W}}",
    mass: 175082.2233159,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741890,
    name: "W189",
    latex: "^{189}\\mathrm{W}",
    mass: 176016.5789695,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741890,
    name: "W189~",
    latex: "^{189}\\mathrm{\\overline{W}}",
    mass: 176016.5789695,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000741900,
    name: "W190",
    latex: "^{190}\\mathrm{W}",
    mass: 176949.5075741,
    width: undefined,
    charge: 74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000741900,
    name: "W190~",
    latex: "^{190}\\mathrm{\\overline{W}}",
    mass: 176949.5075741,
    width: undefined,
    charge: -74.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751600,
    name: "Re160",
    latex: "^{160}\\mathrm{Re}",
    mass: 149022.1779218,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751600,
    name: "Re160~",
    latex: "^{160}\\mathrm{\\overline{Re}}",
    mass: 149022.1779218,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751610,
    name: "Re161",
    latex: "^{161}\\mathrm{Re}",
    mass: 149949.7038606,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751610,
    name: "Re161~",
    latex: "^{161}\\mathrm{\\overline{Re}}",
    mass: 149949.7038606,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751620,
    name: "Re162",
    latex: "^{162}\\mathrm{Re}",
    mass: 150879.5957945,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751620,
    name: "Re162~",
    latex: "^{162}\\mathrm{\\overline{Re}}",
    mass: 150879.5957945,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751630,
    name: "Re163",
    latex: "^{163}\\mathrm{Re}",
    mass: 151807.5362482,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751630,
    name: "Re163~",
    latex: "^{163}\\mathrm{\\overline{Re}}",
    mass: 151807.5362482,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751640,
    name: "Re164",
    latex: "^{164}\\mathrm{Re}",
    mass: 152737.5632487,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751640,
    name: "Re164~",
    latex: "^{164}\\mathrm{\\overline{Re}}",
    mass: 152737.5632487,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751650,
    name: "Re165",
    latex: "^{165}\\mathrm{Re}",
    mass: 153665.8679166,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751650,
    name: "Re165~",
    latex: "^{165}\\mathrm{\\overline{Re}}",
    mass: 153665.8679166,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751660,
    name: "Re166",
    latex: "^{166}\\mathrm{Re}",
    mass: 154596.1827488,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751660,
    name: "Re166~",
    latex: "^{166}\\mathrm{\\overline{Re}}",
    mass: 154596.1827488,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751670,
    name: "Re167",
    latex: "^{167}\\mathrm{Re}",
    mass: 155524.6774415,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751670,
    name: "Re167~",
    latex: "^{167}\\mathrm{\\overline{Re}}",
    mass: 155524.6774415,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751680,
    name: "Re168",
    latex: "^{168}\\mathrm{Re}",
    mass: 156455.2121063,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751680,
    name: "Re168~",
    latex: "^{168}\\mathrm{\\overline{Re}}",
    mass: 156455.2121063,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751690,
    name: "Re169",
    latex: "^{169}\\mathrm{Re}",
    mass: 157384.0943006,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751690,
    name: "Re169~",
    latex: "^{169}\\mathrm{\\overline{Re}}",
    mass: 157384.0943006,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751700,
    name: "Re170",
    latex: "^{170}\\mathrm{Re}",
    mass: 158315.0937809,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751700,
    name: "Re170~",
    latex: "^{170}\\mathrm{\\overline{Re}}",
    mass: 158315.0937809,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751710,
    name: "Re171",
    latex: "^{171}\\mathrm{Re}",
    mass: 159244.245177,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751710,
    name: "Re171~",
    latex: "^{171}\\mathrm{\\overline{Re}}",
    mass: 159244.245177,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751720,
    name: "Re172",
    latex: "^{172}\\mathrm{Re}",
    mass: 160175.4225727,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751720,
    name: "Re172~",
    latex: "^{172}\\mathrm{\\overline{Re}}",
    mass: 160175.4225727,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751730,
    name: "Re173",
    latex: "^{173}\\mathrm{Re}",
    mass: 161104.923279,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751730,
    name: "Re173~",
    latex: "^{173}\\mathrm{\\overline{Re}}",
    mass: 161104.923279,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751740,
    name: "Re174",
    latex: "^{174}\\mathrm{Re}",
    mass: 162036.3056034,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751740,
    name: "Re174~",
    latex: "^{174}\\mathrm{\\overline{Re}}",
    mass: 162036.3056034,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751750,
    name: "Re175",
    latex: "^{175}\\mathrm{Re}",
    mass: 162966.1789074,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751750,
    name: "Re175~",
    latex: "^{175}\\mathrm{\\overline{Re}}",
    mass: 162966.1789074,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751760,
    name: "Re176",
    latex: "^{176}\\mathrm{Re}",
    mass: 163897.8965697,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751760,
    name: "Re176~",
    latex: "^{176}\\mathrm{\\overline{Re}}",
    mass: 163897.8965697,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751770,
    name: "Re177",
    latex: "^{177}\\mathrm{Re}",
    mass: 164828.1890461,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751770,
    name: "Re177~",
    latex: "^{177}\\mathrm{\\overline{Re}}",
    mass: 164828.1890461,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751780,
    name: "Re178",
    latex: "^{178}\\mathrm{Re}",
    mass: 165760.2979359,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751780,
    name: "Re178~",
    latex: "^{178}\\mathrm{\\overline{Re}}",
    mass: 165760.2979359,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751790,
    name: "Re179",
    latex: "^{179}\\mathrm{Re}",
    mass: 166690.8605455,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751790,
    name: "Re179~",
    latex: "^{179}\\mathrm{\\overline{Re}}",
    mass: 166690.8605455,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751800,
    name: "Re180",
    latex: "^{180}\\mathrm{Re}",
    mass: 167623.1017075,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751800,
    name: "Re180~",
    latex: "^{180}\\mathrm{\\overline{Re}}",
    mass: 167623.1017075,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751810,
    name: "Re181",
    latex: "^{181}\\mathrm{Re}",
    mass: 168553.9158205,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751810,
    name: "Re181~",
    latex: "^{181}\\mathrm{\\overline{Re}}",
    mass: 168553.9158205,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751820,
    name: "Re182",
    latex: "^{182}\\mathrm{Re}",
    mass: 169486.4792795,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751820,
    name: "Re182~",
    latex: "^{182}\\mathrm{\\overline{Re}}",
    mass: 169486.4792795,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751830,
    name: "Re183",
    latex: "^{183}\\mathrm{Re}",
    mass: 170417.611032,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751830,
    name: "Re183~",
    latex: "^{183}\\mathrm{\\overline{Re}}",
    mass: 170417.611032,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751840,
    name: "Re184",
    latex: "^{184}\\mathrm{Re}",
    mass: 171350.6951961,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751840,
    name: "Re184~",
    latex: "^{184}\\mathrm{\\overline{Re}}",
    mass: 171350.6951961,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751850,
    name: "Re185",
    latex: "^{185}\\mathrm{Re}",
    mass: 172282.5901218,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751850,
    name: "Re185~",
    latex: "^{185}\\mathrm{\\overline{Re}}",
    mass: 172282.5901218,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751860,
    name: "Re186",
    latex: "^{186}\\mathrm{Re}",
    mass: 173215.9759969,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751860,
    name: "Re186~",
    latex: "^{186}\\mathrm{\\overline{Re}}",
    mass: 173215.9759969,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751870,
    name: "Re187",
    latex: "^{187}\\mathrm{Re}",
    mass: 174148.1808306,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751870,
    name: "Re187~",
    latex: "^{187}\\mathrm{\\overline{Re}}",
    mass: 174148.1808306,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751880,
    name: "Re188",
    latex: "^{188}\\mathrm{Re}",
    mass: 175081.8746576,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751880,
    name: "Re188~",
    latex: "^{188}\\mathrm{\\overline{Re}}",
    mass: 175081.8746576,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751890,
    name: "Re189",
    latex: "^{189}\\mathrm{Re}",
    mass: 176014.4067252,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751890,
    name: "Re189~",
    latex: "^{189}\\mathrm{\\overline{Re}}",
    mass: 176014.4067252,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751900,
    name: "Re190",
    latex: "^{190}\\mathrm{Re}",
    mass: 176948.2966318,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751900,
    name: "Re190~",
    latex: "^{190}\\mathrm{\\overline{Re}}",
    mass: 176948.2966318,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751910,
    name: "Re191",
    latex: "^{191}\\mathrm{Re}",
    mass: 177881.0231022,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751910,
    name: "Re191~",
    latex: "^{191}\\mathrm{\\overline{Re}}",
    mass: 177881.0231022,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000751920,
    name: "Re192",
    latex: "^{192}\\mathrm{Re}",
    mass: 178815.2809489,
    width: undefined,
    charge: 75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000751920,
    name: "Re192~",
    latex: "^{192}\\mathrm{\\overline{Re}}",
    mass: 178815.2809489,
    width: undefined,
    charge: -75.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761620,
    name: "Os162",
    latex: "^{162}\\mathrm{Os}",
    mass: 150887.5414392,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761620,
    name: "Os162~",
    latex: "^{162}\\mathrm{\\overline{Os}}",
    mass: 150887.5414392,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761630,
    name: "Os163",
    latex: "^{163}\\mathrm{Os}",
    mass: 151817.2004995,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761630,
    name: "Os163~",
    latex: "^{163}\\mathrm{\\overline{Os}}",
    mass: 151817.2004995,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761640,
    name: "Os164",
    latex: "^{164}\\mathrm{Os}",
    mass: 152744.6053442,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761640,
    name: "Os164~",
    latex: "^{164}\\mathrm{\\overline{Os}}",
    mass: 152744.6053442,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761650,
    name: "Os165",
    latex: "^{165}\\mathrm{Os}",
    mass: 153674.7767262,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761650,
    name: "Os165~",
    latex: "^{165}\\mathrm{\\overline{Os}}",
    mass: 153674.7767262,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761660,
    name: "Os166",
    latex: "^{166}\\mathrm{Os}",
    mass: 154602.5895653,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761660,
    name: "Os166~",
    latex: "^{166}\\mathrm{\\overline{Os}}",
    mass: 154602.5895653,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761670,
    name: "Os167",
    latex: "^{167}\\mathrm{Os}",
    mass: 155533.0143138,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761670,
    name: "Os167~",
    latex: "^{167}\\mathrm{\\overline{Os}}",
    mass: 155533.0143138,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761680,
    name: "Os168",
    latex: "^{168}\\mathrm{Os}",
    mass: 156461.0143831,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761680,
    name: "Os168~",
    latex: "^{168}\\mathrm{\\overline{Os}}",
    mass: 156461.0143831,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761690,
    name: "Os169",
    latex: "^{169}\\mathrm{Os}",
    mass: 157391.7809899,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761690,
    name: "Os169~",
    latex: "^{169}\\mathrm{\\overline{Os}}",
    mass: 157391.7809899,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761700,
    name: "Os170",
    latex: "^{170}\\mathrm{Os}",
    mass: 158320.0716854,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761700,
    name: "Os170~",
    latex: "^{170}\\mathrm{\\overline{Os}}",
    mass: 158320.0716854,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761710,
    name: "Os171",
    latex: "^{171}\\mathrm{Os}",
    mass: 159251.194123,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761710,
    name: "Os171~",
    latex: "^{171}\\mathrm{\\overline{Os}}",
    mass: 159251.194123,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761720,
    name: "Os172",
    latex: "^{172}\\mathrm{Os}",
    mass: 160179.7419108,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761720,
    name: "Os172~",
    latex: "^{172}\\mathrm{\\overline{Os}}",
    mass: 160179.7419108,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761730,
    name: "Os173",
    latex: "^{173}\\mathrm{Os}",
    mass: 161111.0413323,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761730,
    name: "Os173~",
    latex: "^{173}\\mathrm{\\overline{Os}}",
    mass: 161111.0413323,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761740,
    name: "Os174",
    latex: "^{174}\\mathrm{Os}",
    mass: 162039.9784847,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761740,
    name: "Os174~",
    latex: "^{174}\\mathrm{\\overline{Os}}",
    mass: 162039.9784847,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761750,
    name: "Os175",
    latex: "^{175}\\mathrm{Os}",
    mass: 162971.3626721,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761750,
    name: "Os175~",
    latex: "^{175}\\mathrm{\\overline{Os}}",
    mass: 162971.3626721,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761760,
    name: "Os176",
    latex: "^{176}\\mathrm{Os}",
    mass: 163900.8307762,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761760,
    name: "Os176~",
    latex: "^{176}\\mathrm{\\overline{Os}}",
    mass: 163900.8307762,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761770,
    name: "Os177",
    latex: "^{177}\\mathrm{Os}",
    mass: 164832.5000008,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761770,
    name: "Os177~",
    latex: "^{177}\\mathrm{\\overline{Os}}",
    mass: 164832.5000008,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761780,
    name: "Os178",
    latex: "^{178}\\mathrm{Os}",
    mass: 165762.405907,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761780,
    name: "Os178~",
    latex: "^{178}\\mathrm{\\overline{Os}}",
    mass: 165762.405907,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761790,
    name: "Os179",
    latex: "^{179}\\mathrm{Os}",
    mass: 166694.4244419,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761790,
    name: "Os179~",
    latex: "^{179}\\mathrm{\\overline{Os}}",
    mass: 166694.4244419,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761800,
    name: "Os180",
    latex: "^{180}\\mathrm{Os}",
    mass: 167624.5827831,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761800,
    name: "Os180~",
    latex: "^{180}\\mathrm{\\overline{Os}}",
    mass: 167624.5827831,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761810,
    name: "Os181",
    latex: "^{181}\\mathrm{Os}",
    mass: 168556.8826292,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761810,
    name: "Os181~",
    latex: "^{181}\\mathrm{\\overline{Os}}",
    mass: 168556.8826292,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761820,
    name: "Os182",
    latex: "^{182}\\mathrm{Os}",
    mass: 169487.3176242,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761820,
    name: "Os182~",
    latex: "^{182}\\mathrm{\\overline{Os}}",
    mass: 169487.3176242,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761830,
    name: "Os183",
    latex: "^{183}\\mathrm{Os}",
    mass: 170419.7618519,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761830,
    name: "Os183~",
    latex: "^{183}\\mathrm{\\overline{Os}}",
    mass: 170419.7618519,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761840,
    name: "Os184",
    latex: "^{184}\\mathrm{Os}",
    mass: 171350.6625007,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761840,
    name: "Os184~",
    latex: "^{184}\\mathrm{\\overline{Os}}",
    mass: 171350.6625007,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761850,
    name: "Os185",
    latex: "^{185}\\mathrm{Os}",
    mass: 172283.6033079,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761850,
    name: "Os185~",
    latex: "^{185}\\mathrm{\\overline{Os}}",
    mass: 172283.6033079,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761860,
    name: "Os186",
    latex: "^{186}\\mathrm{Os}",
    mass: 173214.9032882,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761860,
    name: "Os186~",
    latex: "^{186}\\mathrm{\\overline{Os}}",
    mass: 173214.9032882,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761870,
    name: "Os187",
    latex: "^{187}\\mathrm{Os}",
    mass: 174148.1784087,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761870,
    name: "Os187~",
    latex: "^{187}\\mathrm{\\overline{Os}}",
    mass: 174148.1784087,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761880,
    name: "Os188",
    latex: "^{188}\\mathrm{Os}",
    mass: 175079.7542044,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761880,
    name: "Os188~",
    latex: "^{188}\\mathrm{\\overline{Os}}",
    mass: 175079.7542044,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761890,
    name: "Os189",
    latex: "^{189}\\mathrm{Os}",
    mass: 176013.3987554,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761890,
    name: "Os189~",
    latex: "^{189}\\mathrm{\\overline{Os}}",
    mass: 176013.3987554,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761900,
    name: "Os190",
    latex: "^{190}\\mathrm{Os}",
    mass: 176945.1718416,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761900,
    name: "Os190~",
    latex: "^{190}\\mathrm{\\overline{Os}}",
    mass: 176945.1718416,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761910,
    name: "Os191",
    latex: "^{191}\\mathrm{Os}",
    mass: 177878.9785658,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761910,
    name: "Os191~",
    latex: "^{191}\\mathrm{\\overline{Os}}",
    mass: 177878.9785658,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761920,
    name: "Os192",
    latex: "^{192}\\mathrm{Os}",
    mass: 178810.9856433,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761920,
    name: "Os192~",
    latex: "^{192}\\mathrm{\\overline{Os}}",
    mass: 178810.9856433,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761930,
    name: "Os193",
    latex: "^{193}\\mathrm{Os}",
    mass: 179744.9675815,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761930,
    name: "Os193~",
    latex: "^{193}\\mathrm{\\overline{Os}}",
    mass: 179744.9675815,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761940,
    name: "Os194",
    latex: "^{194}\\mathrm{Os}",
    mass: 180677.4209378,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761940,
    name: "Os194~",
    latex: "^{194}\\mathrm{\\overline{Os}}",
    mass: 180677.4209378,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761950,
    name: "Os195",
    latex: "^{195}\\mathrm{Os}",
    mass: 181611.8404919,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761950,
    name: "Os195~",
    latex: "^{195}\\mathrm{\\overline{Os}}",
    mass: 181611.8404919,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000761960,
    name: "Os196",
    latex: "^{196}\\mathrm{Os}",
    mass: 182544.5641679,
    width: undefined,
    charge: 76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000761960,
    name: "Os196~",
    latex: "^{196}\\mathrm{\\overline{Os}}",
    mass: 182544.5641679,
    width: undefined,
    charge: -76.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771650,
    name: "Ir165",
    latex: "^{165}\\mathrm{Ir}",
    mass: 153684.930012,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771650,
    name: "Ir165~",
    latex: "^{165}\\mathrm{\\overline{Ir}}",
    mass: 153684.930012,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771660,
    name: "Ir166",
    latex: "^{166}\\mathrm{Ir}",
    mass: 154614.7194815,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771660,
    name: "Ir166~",
    latex: "^{166}\\mathrm{\\overline{Ir}}",
    mass: 154614.7194815,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771670,
    name: "Ir167",
    latex: "^{167}\\mathrm{Ir}",
    mass: 155542.4428971,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771670,
    name: "Ir167~",
    latex: "^{167}\\mathrm{\\overline{Ir}}",
    mass: 155542.4428971,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771680,
    name: "Ir168",
    latex: "^{168}\\mathrm{Ir}",
    mass: 156472.3422829,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771680,
    name: "Ir168~",
    latex: "^{168}\\mathrm{\\overline{Ir}}",
    mass: 156472.3422829,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771690,
    name: "Ir169",
    latex: "^{169}\\mathrm{Ir}",
    mass: 157400.4103513,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771690,
    name: "Ir169~",
    latex: "^{169}\\mathrm{\\overline{Ir}}",
    mass: 157400.4103513,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771700,
    name: "Ir170",
    latex: "^{170}\\mathrm{Ir}",
    mass: 158330.8127439,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771700,
    name: "Ir170~",
    latex: "^{170}\\mathrm{\\overline{Ir}}",
    mass: 158330.8127439,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771710,
    name: "Ir171",
    latex: "^{171}\\mathrm{Ir}",
    mass: 159259.083878,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771710,
    name: "Ir171~",
    latex: "^{171}\\mathrm{\\overline{Ir}}",
    mass: 159259.083878,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771720,
    name: "Ir172",
    latex: "^{172}\\mathrm{Ir}",
    mass: 160189.6092279,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771720,
    name: "Ir172~",
    latex: "^{172}\\mathrm{\\overline{Ir}}",
    mass: 160189.6092279,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771730,
    name: "Ir173",
    latex: "^{173}\\mathrm{Ir}",
    mass: 161118.2110424,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771730,
    name: "Ir173~",
    latex: "^{173}\\mathrm{\\overline{Ir}}",
    mass: 161118.2110424,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771740,
    name: "Ir174",
    latex: "^{174}\\mathrm{Ir}",
    mass: 162049.1881669,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771740,
    name: "Ir174~",
    latex: "^{174}\\mathrm{\\overline{Ir}}",
    mass: 162049.1881669,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771750,
    name: "Ir175",
    latex: "^{175}\\mathrm{Ir}",
    mass: 162978.0740871,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771750,
    name: "Ir175~",
    latex: "^{175}\\mathrm{\\overline{Ir}}",
    mass: 162978.0740871,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771760,
    name: "Ir176",
    latex: "^{176}\\mathrm{Ir}",
    mass: 163909.0800879,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771760,
    name: "Ir176~",
    latex: "^{176}\\mathrm{\\overline{Ir}}",
    mass: 163909.0800879,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771770,
    name: "Ir177",
    latex: "^{177}\\mathrm{Ir}",
    mass: 164838.4093994,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771770,
    name: "Ir177~",
    latex: "^{177}\\mathrm{\\overline{Ir}}",
    mass: 164838.4093994,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771780,
    name: "Ir178",
    latex: "^{178}\\mathrm{Ir}",
    mass: 165769.6957799,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771780,
    name: "Ir178~",
    latex: "^{178}\\mathrm{\\overline{Ir}}",
    mass: 165769.6957799,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771790,
    name: "Ir179",
    latex: "^{179}\\mathrm{Ir}",
    mass: 166699.3632237,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771790,
    name: "Ir179~",
    latex: "^{179}\\mathrm{\\overline{Ir}}",
    mass: 166699.3632237,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771800,
    name: "Ir180",
    latex: "^{180}\\mathrm{Ir}",
    mass: 167630.9607232,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771800,
    name: "Ir180~",
    latex: "^{180}\\mathrm{\\overline{Ir}}",
    mass: 167630.9607232,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771810,
    name: "Ir181",
    latex: "^{181}\\mathrm{Ir}",
    mass: 168560.9700254,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771810,
    name: "Ir181~",
    latex: "^{181}\\mathrm{\\overline{Ir}}",
    mass: 168560.9700254,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771820,
    name: "Ir182",
    latex: "^{182}\\mathrm{Ir}",
    mass: 169492.874918,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771820,
    name: "Ir182~",
    latex: "^{182}\\mathrm{\\overline{Ir}}",
    mass: 169492.874918,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771830,
    name: "Ir183",
    latex: "^{183}\\mathrm{Ir}",
    mass: 170423.2186265,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771830,
    name: "Ir183~",
    latex: "^{183}\\mathrm{\\overline{Ir}}",
    mass: 170423.2186265,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771840,
    name: "Ir184",
    latex: "^{184}\\mathrm{Ir}",
    mass: 171355.3079549,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771840,
    name: "Ir184~",
    latex: "^{184}\\mathrm{\\overline{Ir}}",
    mass: 171355.3079549,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771850,
    name: "Ir185",
    latex: "^{185}\\mathrm{Ir}",
    mass: 172286.0754932,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771850,
    name: "Ir185~",
    latex: "^{185}\\mathrm{\\overline{Ir}}",
    mass: 172286.0754932,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771860,
    name: "Ir186",
    latex: "^{186}\\mathrm{Ir}",
    mass: 173218.7311701,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771860,
    name: "Ir186~",
    latex: "^{186}\\mathrm{\\overline{Ir}}",
    mass: 173218.7311701,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771870,
    name: "Ir187",
    latex: "^{187}\\mathrm{Ir}",
    mass: 174149.8461557,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771870,
    name: "Ir187~",
    latex: "^{187}\\mathrm{\\overline{Ir}}",
    mass: 174149.8461557,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771880,
    name: "Ir188",
    latex: "^{188}\\mathrm{Ir}",
    mass: 175082.5465443,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771880,
    name: "Ir188~",
    latex: "^{188}\\mathrm{\\overline{Ir}}",
    mass: 175082.5465443,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771890,
    name: "Ir189",
    latex: "^{189}\\mathrm{Ir}",
    mass: 176013.9363207,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771890,
    name: "Ir189~",
    latex: "^{189}\\mathrm{\\overline{Ir}}",
    mass: 176013.9363207,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771900,
    name: "Ir190",
    latex: "^{190}\\mathrm{Ir}",
    mass: 176947.1261163,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771900,
    name: "Ir190~",
    latex: "^{190}\\mathrm{\\overline{Ir}}",
    mass: 176947.1261163,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771910,
    name: "Ir191",
    latex: "^{191}\\mathrm{Ir}",
    mass: 177878.6650249,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771910,
    name: "Ir191~",
    latex: "^{191}\\mathrm{\\overline{Ir}}",
    mass: 177878.6650249,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771920,
    name: "Ir192",
    latex: "^{192}\\mathrm{Ir}",
    mass: 178812.0322701,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771920,
    name: "Ir192~",
    latex: "^{192}\\mathrm{\\overline{Ir}}",
    mass: 178812.0322701,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771930,
    name: "Ir193",
    latex: "^{193}\\mathrm{Ir}",
    mass: 179743.825756,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771930,
    name: "Ir193~",
    latex: "^{193}\\mathrm{\\overline{Ir}}",
    mass: 179743.825756,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771940,
    name: "Ir194",
    latex: "^{194}\\mathrm{Ir}",
    mass: 180677.3243419,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771940,
    name: "Ir194~",
    latex: "^{194}\\mathrm{\\overline{Ir}}",
    mass: 180677.3243419,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771950,
    name: "Ir195",
    latex: "^{195}\\mathrm{Ir}",
    mass: 181609.6579081,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771950,
    name: "Ir195~",
    latex: "^{195}\\mathrm{\\overline{Ir}}",
    mass: 181609.6579081,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771960,
    name: "Ir196",
    latex: "^{196}\\mathrm{Ir}",
    mass: 182543.4091152,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771960,
    name: "Ir196~",
    latex: "^{196}\\mathrm{\\overline{Ir}}",
    mass: 182543.4091152,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771970,
    name: "Ir197",
    latex: "^{197}\\mathrm{Ir}",
    mass: 183476.074107,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771970,
    name: "Ir197~",
    latex: "^{197}\\mathrm{\\overline{Ir}}",
    mass: 183476.074107,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771980,
    name: "Ir198",
    latex: "^{198}\\mathrm{Ir}",
    mass: 184410.123299,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771980,
    name: "Ir198~",
    latex: "^{198}\\mathrm{\\overline{Ir}}",
    mass: 184410.123299,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000771990,
    name: "Ir199",
    latex: "^{199}\\mathrm{Ir}",
    mass: 185342.9308094,
    width: undefined,
    charge: 77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000771990,
    name: "Ir199~",
    latex: "^{199}\\mathrm{\\overline{Ir}}",
    mass: 185342.9308094,
    width: undefined,
    charge: -77.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781680,
    name: "Pt168",
    latex: "^{168}\\mathrm{Pt}",
    mass: 156479.9991644,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781680,
    name: "Pt168~",
    latex: "^{168}\\mathrm{\\overline{Pt}}",
    mass: 156479.9991644,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781690,
    name: "Pt169",
    latex: "^{169}\\mathrm{Pt}",
    mass: 157410.0401373,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781690,
    name: "Pt169~",
    latex: "^{169}\\mathrm{\\overline{Pt}}",
    mass: 157410.0401373,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781700,
    name: "Pt170",
    latex: "^{170}\\mathrm{Pt}",
    mass: 158337.6983483,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781700,
    name: "Pt170~",
    latex: "^{170}\\mathrm{\\overline{Pt}}",
    mass: 158337.6983483,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781710,
    name: "Pt171",
    latex: "^{171}\\mathrm{Pt}",
    mass: 159268.0262214,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781710,
    name: "Pt171~",
    latex: "^{171}\\mathrm{\\overline{Pt}}",
    mass: 159268.0262214,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781720,
    name: "Pt172",
    latex: "^{172}\\mathrm{Pt}",
    mass: 160195.8791147,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781720,
    name: "Pt172~",
    latex: "^{172}\\mathrm{\\overline{Pt}}",
    mass: 160195.8791147,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781730,
    name: "Pt173",
    latex: "^{173}\\mathrm{Pt}",
    mass: 161126.5432572,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781730,
    name: "Pt173~",
    latex: "^{173}\\mathrm{\\overline{Pt}}",
    mass: 161126.5432572,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781740,
    name: "Pt174",
    latex: "^{174}\\mathrm{Pt}",
    mass: 162054.6560373,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781740,
    name: "Pt174~",
    latex: "^{174}\\mathrm{\\overline{Pt}}",
    mass: 162054.6560373,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781750,
    name: "Pt175",
    latex: "^{175}\\mathrm{Pt}",
    mass: 162985.759845,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781750,
    name: "Pt175~",
    latex: "^{175}\\mathrm{\\overline{Pt}}",
    mass: 162985.759845,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781760,
    name: "Pt176",
    latex: "^{176}\\mathrm{Pt}",
    mass: 163914.0281846,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781760,
    name: "Pt176~",
    latex: "^{176}\\mathrm{\\overline{Pt}}",
    mass: 163914.0281846,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781770,
    name: "Pt177",
    latex: "^{177}\\mathrm{Pt}",
    mass: 164845.0863491,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781770,
    name: "Pt177~",
    latex: "^{177}\\mathrm{\\overline{Pt}}",
    mass: 164845.0863491,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781780,
    name: "Pt178",
    latex: "^{178}\\mathrm{Pt}",
    mass: 165773.9527079,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781780,
    name: "Pt178~",
    latex: "^{178}\\mathrm{\\overline{Pt}}",
    mass: 165773.9527079,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781790,
    name: "Pt179",
    latex: "^{179}\\mathrm{Pt}",
    mass: 166705.1766784,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781790,
    name: "Pt179~",
    latex: "^{179}\\mathrm{\\overline{Pt}}",
    mass: 166705.1766784,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781800,
    name: "Pt180",
    latex: "^{180}\\mathrm{Pt}",
    mass: 167634.5087843,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781800,
    name: "Pt180~",
    latex: "^{180}\\mathrm{\\overline{Pt}}",
    mass: 167634.5087843,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781810,
    name: "Pt181",
    latex: "^{181}\\mathrm{Pt}",
    mass: 168566.0513257,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781810,
    name: "Pt181~",
    latex: "^{181}\\mathrm{\\overline{Pt}}",
    mass: 168566.0513257,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781820,
    name: "Pt182",
    latex: "^{182}\\mathrm{Pt}",
    mass: 169495.7588237,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781820,
    name: "Pt182~",
    latex: "^{182}\\mathrm{\\overline{Pt}}",
    mass: 169495.7588237,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781830,
    name: "Pt183",
    latex: "^{183}\\mathrm{Pt}",
    mass: 170427.6478809,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781830,
    name: "Pt183~",
    latex: "^{183}\\mathrm{\\overline{Pt}}",
    mass: 170427.6478809,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781840,
    name: "Pt184",
    latex: "^{184}\\mathrm{Pt}",
    mass: 171357.5826635,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781840,
    name: "Pt184~",
    latex: "^{184}\\mathrm{\\overline{Pt}}",
    mass: 171357.5826635,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781850,
    name: "Pt185",
    latex: "^{185}\\mathrm{Pt}",
    mass: 172289.7213612,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781850,
    name: "Pt185~",
    latex: "^{185}\\mathrm{\\overline{Pt}}",
    mass: 172289.7213612,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781860,
    name: "Pt186",
    latex: "^{186}\\mathrm{Pt}",
    mass: 173220.0389878,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781860,
    name: "Pt186~",
    latex: "^{186}\\mathrm{\\overline{Pt}}",
    mass: 173220.0389878,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781870,
    name: "Pt187",
    latex: "^{187}\\mathrm{Pt}",
    mass: 174152.7123631,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781870,
    name: "Pt187~",
    latex: "^{187}\\mathrm{\\overline{Pt}}",
    mass: 174152.7123631,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781880,
    name: "Pt188",
    latex: "^{188}\\mathrm{Pt}",
    mass: 175083.0709755,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781880,
    name: "Pt188~",
    latex: "^{188}\\mathrm{\\overline{Pt}}",
    mass: 175083.0709755,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781890,
    name: "Pt189",
    latex: "^{189}\\mathrm{Pt}",
    mass: 176015.9157457,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781890,
    name: "Pt189~",
    latex: "^{189}\\mathrm{\\overline{Pt}}",
    mass: 176015.9157457,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781900,
    name: "Pt190",
    latex: "^{190}\\mathrm{Pt}",
    mass: 176946.5731814,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781900,
    name: "Pt190~",
    latex: "^{190}\\mathrm{\\overline{Pt}}",
    mass: 176946.5731814,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781910,
    name: "Pt191",
    latex: "^{191}\\mathrm{Pt}",
    mass: 177879.6752302,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781910,
    name: "Pt191~",
    latex: "^{191}\\mathrm{\\overline{Pt}}",
    mass: 177879.6752302,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781920,
    name: "Pt192",
    latex: "^{192}\\mathrm{Pt}",
    mass: 178810.5794187,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781920,
    name: "Pt192~",
    latex: "^{192}\\mathrm{\\overline{Pt}}",
    mass: 178810.5794187,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781930,
    name: "Pt193",
    latex: "^{193}\\mathrm{Pt}",
    mass: 179743.8822977,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781930,
    name: "Pt193~",
    latex: "^{193}\\mathrm{\\overline{Pt}}",
    mass: 179743.8822977,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781940,
    name: "Pt194",
    latex: "^{194}\\mathrm{Pt}",
    mass: 180675.0960217,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781940,
    name: "Pt194~",
    latex: "^{194}\\mathrm{\\overline{Pt}}",
    mass: 180675.0960217,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781950,
    name: "Pt195",
    latex: "^{195}\\mathrm{Pt}",
    mass: 181608.5563232,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781950,
    name: "Pt195~",
    latex: "^{195}\\mathrm{\\overline{Pt}}",
    mass: 181608.5563232,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781960,
    name: "Pt196",
    latex: "^{196}\\mathrm{Pt}",
    mass: 182540.1997454,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781960,
    name: "Pt196~",
    latex: "^{196}\\mathrm{\\overline{Pt}}",
    mass: 182540.1997454,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781970,
    name: "Pt197",
    latex: "^{197}\\mathrm{Pt}",
    mass: 183473.9186296,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781970,
    name: "Pt197~",
    latex: "^{197}\\mathrm{\\overline{Pt}}",
    mass: 183473.9186296,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781980,
    name: "Pt198",
    latex: "^{198}\\mathrm{Pt}",
    mass: 184405.9285016,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781980,
    name: "Pt198~",
    latex: "^{198}\\mathrm{\\overline{Pt}}",
    mass: 184405.9285016,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000781990,
    name: "Pt199",
    latex: "^{199}\\mathrm{Pt}",
    mass: 185339.9379189,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000781990,
    name: "Pt199~",
    latex: "^{199}\\mathrm{\\overline{Pt}}",
    mass: 185339.9379189,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000782000,
    name: "Pt200",
    latex: "^{200}\\mathrm{Pt}",
    mass: 186272.2219296,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000782000,
    name: "Pt200~",
    latex: "^{200}\\mathrm{\\overline{Pt}}",
    mass: 186272.2219296,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000782010,
    name: "Pt201",
    latex: "^{201}\\mathrm{Pt}",
    mass: 187206.5710627,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000782010,
    name: "Pt201~",
    latex: "^{201}\\mathrm{\\overline{Pt}}",
    mass: 187206.5710627,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000782020,
    name: "Pt202",
    latex: "^{202}\\mathrm{Pt}",
    mass: 188139.1168233,
    width: undefined,
    charge: 78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000782020,
    name: "Pt202~",
    latex: "^{202}\\mathrm{\\overline{Pt}}",
    mass: 188139.1168233,
    width: undefined,
    charge: -78.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791710,
    name: "Au171",
    latex: "^{171}\\mathrm{Au}",
    mass: 159277.9298667,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791710,
    name: "Au171~",
    latex: "^{171}\\mathrm{\\overline{Au}}",
    mass: 159277.9298667,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791720,
    name: "Au172",
    latex: "^{172}\\mathrm{Au}",
    mass: 160207.6708986,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791720,
    name: "Au172~",
    latex: "^{172}\\mathrm{\\overline{Au}}",
    mass: 160207.6708986,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791730,
    name: "Au173",
    latex: "^{173}\\mathrm{Au}",
    mass: 161135.6476805,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791730,
    name: "Au173~",
    latex: "^{173}\\mathrm{\\overline{Au}}",
    mass: 161135.6476805,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791740,
    name: "Au174",
    latex: "^{174}\\mathrm{Au}",
    mass: 162065.917801,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791740,
    name: "Au174~",
    latex: "^{174}\\mathrm{\\overline{Au}}",
    mass: 162065.917801,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791750,
    name: "Au175",
    latex: "^{175}\\mathrm{Au}",
    mass: 162994.0678409,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791750,
    name: "Au175~",
    latex: "^{175}\\mathrm{\\overline{Au}}",
    mass: 162994.0678409,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791760,
    name: "Au176",
    latex: "^{176}\\mathrm{Au}",
    mass: 163924.4441517,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791760,
    name: "Au176~",
    latex: "^{176}\\mathrm{\\overline{Au}}",
    mass: 163924.4441517,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791770,
    name: "Au177",
    latex: "^{177}\\mathrm{Au}",
    mass: 164852.9108996,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791770,
    name: "Au177~",
    latex: "^{177}\\mathrm{\\overline{Au}}",
    mass: 164852.9108996,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791780,
    name: "Au178",
    latex: "^{178}\\mathrm{Au}",
    mass: 165783.6476986,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791780,
    name: "Au178~",
    latex: "^{178}\\mathrm{\\overline{Au}}",
    mass: 165783.6476986,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791790,
    name: "Au179",
    latex: "^{179}\\mathrm{Au}",
    mass: 166712.4563048,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791790,
    name: "Au179~",
    latex: "^{179}\\mathrm{\\overline{Au}}",
    mass: 166712.4563048,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791800,
    name: "Au180",
    latex: "^{180}\\mathrm{Au}",
    mass: 167643.3132665,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791800,
    name: "Au180~",
    latex: "^{180}\\mathrm{\\overline{Au}}",
    mass: 167643.3132665,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791810,
    name: "Au181",
    latex: "^{181}\\mathrm{Au}",
    mass: 168572.561538,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791810,
    name: "Au181~",
    latex: "^{181}\\mathrm{\\overline{Au}}",
    mass: 168572.561538,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791820,
    name: "Au182",
    latex: "^{182}\\mathrm{Au}",
    mass: 169503.6224969,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791820,
    name: "Au182~",
    latex: "^{182}\\mathrm{\\overline{Au}}",
    mass: 169503.6224969,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791830,
    name: "Au183",
    latex: "^{183}\\mathrm{Au}",
    mass: 170433.2293936,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791830,
    name: "Au183~",
    latex: "^{183}\\mathrm{\\overline{Au}}",
    mass: 170433.2293936,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791840,
    name: "Au184",
    latex: "^{184}\\mathrm{Au}",
    mass: 171364.5968141,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791840,
    name: "Au184~",
    latex: "^{184}\\mathrm{\\overline{Au}}",
    mass: 171364.5968141,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791850,
    name: "Au185",
    latex: "^{185}\\mathrm{Au}",
    mass: 172294.5510649,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791850,
    name: "Au185~",
    latex: "^{185}\\mathrm{\\overline{Au}}",
    mass: 172294.5510649,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791860,
    name: "Au186",
    latex: "^{186}\\mathrm{Au}",
    mass: 173226.1887119,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791860,
    name: "Au186~",
    latex: "^{186}\\mathrm{\\overline{Au}}",
    mass: 173226.1887119,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791870,
    name: "Au187",
    latex: "^{187}\\mathrm{Au}",
    mass: 174156.3684774,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791870,
    name: "Au187~",
    latex: "^{187}\\mathrm{\\overline{Au}}",
    mass: 174156.3684774,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791880,
    name: "Au188",
    latex: "^{188}\\mathrm{Au}",
    mass: 175088.520216,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791880,
    name: "Au188~",
    latex: "^{188}\\mathrm{\\overline{Au}}",
    mass: 175088.520216,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791890,
    name: "Au189",
    latex: "^{189}\\mathrm{Au}",
    mass: 176018.8033774,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791890,
    name: "Au189~",
    latex: "^{189}\\mathrm{\\overline{Au}}",
    mass: 176018.8033774,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791900,
    name: "Au190",
    latex: "^{190}\\mathrm{Au}",
    mass: 176951.0464024,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791900,
    name: "Au190~",
    latex: "^{190}\\mathrm{\\overline{Au}}",
    mass: 176951.0464024,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791910,
    name: "Au191",
    latex: "^{191}\\mathrm{Au}",
    mass: 177881.5754782,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791910,
    name: "Au191~",
    latex: "^{191}\\mathrm{\\overline{Au}}",
    mass: 177881.5754782,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791920,
    name: "Au192",
    latex: "^{192}\\mathrm{Au}",
    mass: 178814.0960884,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791920,
    name: "Au192~",
    latex: "^{192}\\mathrm{\\overline{Au}}",
    mass: 178814.0960884,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791930,
    name: "Au193",
    latex: "^{193}\\mathrm{Au}",
    mass: 179744.9567761,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791930,
    name: "Au193~",
    latex: "^{193}\\mathrm{\\overline{Au}}",
    mass: 179744.9567761,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791940,
    name: "Au194",
    latex: "^{194}\\mathrm{Au}",
    mass: 180677.644217,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791940,
    name: "Au194~",
    latex: "^{194}\\mathrm{\\overline{Au}}",
    mass: 180677.644217,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791950,
    name: "Au195",
    latex: "^{195}\\mathrm{Au}",
    mass: 181608.783142,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791950,
    name: "Au195~",
    latex: "^{195}\\mathrm{\\overline{Au}}",
    mass: 181608.783142,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791960,
    name: "Au196",
    latex: "^{196}\\mathrm{Au}",
    mass: 182541.7054124,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791960,
    name: "Au196~",
    latex: "^{196}\\mathrm{\\overline{Au}}",
    mass: 182541.7054124,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791970,
    name: "Au197",
    latex: "^{197}\\mathrm{Au}",
    mass: 183473.1986778,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791970,
    name: "Au197~",
    latex: "^{197}\\mathrm{\\overline{Au}}",
    mass: 183473.1986778,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791980,
    name: "Au198",
    latex: "^{198}\\mathrm{Au}",
    mass: 184406.2517301,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791980,
    name: "Au198~",
    latex: "^{198}\\mathrm{\\overline{Au}}",
    mass: 184406.2517301,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000791990,
    name: "Au199",
    latex: "^{199}\\mathrm{Au}",
    mass: 185338.2329121,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000791990,
    name: "Au199~",
    latex: "^{199}\\mathrm{\\overline{Au}}",
    mass: 185338.2329121,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000792000,
    name: "Au200",
    latex: "^{200}\\mathrm{Au}",
    mass: 186271.5810616,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000792000,
    name: "Au200~",
    latex: "^{200}\\mathrm{\\overline{Au}}",
    mass: 186271.5810616,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000792010,
    name: "Au201",
    latex: "^{201}\\mathrm{Au}",
    mass: 187203.9144415,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000792010,
    name: "Au201~",
    latex: "^{201}\\mathrm{\\overline{Au}}",
    mass: 187203.9144415,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000792020,
    name: "Au202",
    latex: "^{202}\\mathrm{Au}",
    mass: 188137.4559693,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000792020,
    name: "Au202~",
    latex: "^{202}\\mathrm{\\overline{Au}}",
    mass: 188137.4559693,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000792030,
    name: "Au203",
    latex: "^{203}\\mathrm{Au}",
    mass: 189070.1591524,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000792030,
    name: "Au203~",
    latex: "^{203}\\mathrm{\\overline{Au}}",
    mass: 189070.1591524,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000792040,
    name: "Au204",
    latex: "^{204}\\mathrm{Au}",
    mass: 190004.4067527,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000792040,
    name: "Au204~",
    latex: "^{204}\\mathrm{\\overline{Au}}",
    mass: 190004.4067527,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000792050,
    name: "Au205",
    latex: "^{205}\\mathrm{Au}",
    mass: 190937.7172699,
    width: undefined,
    charge: 79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000792050,
    name: "Au205~",
    latex: "^{205}\\mathrm{\\overline{Au}}",
    mass: 190937.7172699,
    width: undefined,
    charge: -79.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801750,
    name: "Hg175",
    latex: "^{175}\\mathrm{Hg}",
    mass: 163003.4945612,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801750,
    name: "Hg175~",
    latex: "^{175}\\mathrm{\\overline{Hg}}",
    mass: 163003.4945612,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801760,
    name: "Hg176",
    latex: "^{176}\\mathrm{Hg}",
    mass: 163931.1779226,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801760,
    name: "Hg176~",
    latex: "^{176}\\mathrm{\\overline{Hg}}",
    mass: 163931.1779226,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801770,
    name: "Hg177",
    latex: "^{177}\\mathrm{Hg}",
    mass: 164861.6762591,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801770,
    name: "Hg177~",
    latex: "^{177}\\mathrm{\\overline{Hg}}",
    mass: 164861.6762591,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801780,
    name: "Hg178",
    latex: "^{178}\\mathrm{Hg}",
    mass: 165789.6353427,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801780,
    name: "Hg178~",
    latex: "^{178}\\mathrm{\\overline{Hg}}",
    mass: 165789.6353427,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801790,
    name: "Hg179",
    latex: "^{179}\\mathrm{Hg}",
    mass: 166720.5100028,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801790,
    name: "Hg179~",
    latex: "^{179}\\mathrm{\\overline{Hg}}",
    mass: 166720.5100028,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801800,
    name: "Hg180",
    latex: "^{180}\\mathrm{Hg}",
    mass: 167648.6879875,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801800,
    name: "Hg180~",
    latex: "^{180}\\mathrm{\\overline{Hg}}",
    mass: 167648.6879875,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801810,
    name: "Hg181",
    latex: "^{181}\\mathrm{Hg}",
    mass: 168579.7713023,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801810,
    name: "Hg181~",
    latex: "^{181}\\mathrm{\\overline{Hg}}",
    mass: 168579.7713023,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801820,
    name: "Hg182",
    latex: "^{182}\\mathrm{Hg}",
    mass: 169508.3498295,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801820,
    name: "Hg182~",
    latex: "^{182}\\mathrm{\\overline{Hg}}",
    mass: 169508.3498295,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801830,
    name: "Hg183",
    latex: "^{183}\\mathrm{Hg}",
    mass: 170439.6166487,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801830,
    name: "Hg183~",
    latex: "^{183}\\mathrm{\\overline{Hg}}",
    mass: 170439.6166487,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801840,
    name: "Hg184",
    latex: "^{184}\\mathrm{Hg}",
    mass: 171368.570568,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801840,
    name: "Hg184~",
    latex: "^{184}\\mathrm{\\overline{Hg}}",
    mass: 171368.570568,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801850,
    name: "Hg185",
    latex: "^{185}\\mathrm{Hg}",
    mass: 172300.2258202,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801850,
    name: "Hg185~",
    latex: "^{185}\\mathrm{\\overline{Hg}}",
    mass: 172300.2258202,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801860,
    name: "Hg186",
    latex: "^{186}\\mathrm{Hg}",
    mass: 173229.3641753,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801860,
    name: "Hg186~",
    latex: "^{186}\\mathrm{\\overline{Hg}}",
    mass: 173229.3641753,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801870,
    name: "Hg187",
    latex: "^{187}\\mathrm{Hg}",
    mass: 174161.2793144,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801870,
    name: "Hg187~",
    latex: "^{187}\\mathrm{\\overline{Hg}}",
    mass: 174161.2793144,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801880,
    name: "Hg188",
    latex: "^{188}\\mathrm{Hg}",
    mass: 175090.6933917,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801880,
    name: "Hg188~",
    latex: "^{188}\\mathrm{\\overline{Hg}}",
    mass: 175090.6933917,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801890,
    name: "Hg189",
    latex: "^{189}\\mathrm{Hg}",
    mass: 176022.7547754,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801890,
    name: "Hg189~",
    latex: "^{189}\\mathrm{\\overline{Hg}}",
    mass: 176022.7547754,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801900,
    name: "Hg190",
    latex: "^{190}\\mathrm{Hg}",
    mass: 176952.5088481,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801900,
    name: "Hg190~",
    latex: "^{190}\\mathrm{\\overline{Hg}}",
    mass: 176952.5088481,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801910,
    name: "Hg191",
    latex: "^{191}\\mathrm{Hg}",
    mass: 177884.7816809,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801910,
    name: "Hg191~",
    latex: "^{191}\\mathrm{\\overline{Hg}}",
    mass: 177884.7816809,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801920,
    name: "Hg192",
    latex: "^{192}\\mathrm{Hg}",
    mass: 178814.8561876,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801920,
    name: "Hg192~",
    latex: "^{192}\\mathrm{\\overline{Hg}}",
    mass: 178814.8561876,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801930,
    name: "Hg193",
    latex: "^{193}\\mathrm{Hg}",
    mass: 179747.2994838,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801930,
    name: "Hg193~",
    latex: "^{193}\\mathrm{\\overline{Hg}}",
    mass: 179747.2994838,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801940,
    name: "Hg194",
    latex: "^{194}\\mathrm{Hg}",
    mass: 180677.6720686,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801940,
    name: "Hg194~",
    latex: "^{194}\\mathrm{\\overline{Hg}}",
    mass: 180677.6720686,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801950,
    name: "Hg195",
    latex: "^{195}\\mathrm{Hg}",
    mass: 181610.3370604,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801950,
    name: "Hg195~",
    latex: "^{195}\\mathrm{\\overline{Hg}}",
    mass: 181610.3370604,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801960,
    name: "Hg196",
    latex: "^{196}\\mathrm{Hg}",
    mass: 182541.0179698,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801960,
    name: "Hg196~",
    latex: "^{196}\\mathrm{\\overline{Hg}}",
    mass: 182541.0179698,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801970,
    name: "Hg197",
    latex: "^{197}\\mathrm{Hg}",
    mass: 183473.7984669,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801970,
    name: "Hg197~",
    latex: "^{197}\\mathrm{\\overline{Hg}}",
    mass: 183473.7984669,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801980,
    name: "Hg198",
    latex: "^{198}\\mathrm{Hg}",
    mass: 184404.878242,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801980,
    name: "Hg198~",
    latex: "^{198}\\mathrm{\\overline{Hg}}",
    mass: 184404.878242,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000801990,
    name: "Hg199",
    latex: "^{199}\\mathrm{Hg}",
    mass: 185337.7805785,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000801990,
    name: "Hg199~",
    latex: "^{199}\\mathrm{\\overline{Hg}}",
    mass: 185337.7805785,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000802000,
    name: "Hg200",
    latex: "^{200}\\mathrm{Hg}",
    mass: 186269.3174378,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000802000,
    name: "Hg200~",
    latex: "^{200}\\mathrm{\\overline{Hg}}",
    mass: 186269.3174378,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000802010,
    name: "Hg201",
    latex: "^{201}\\mathrm{Hg}",
    mass: 187202.6523602,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000802010,
    name: "Hg201~",
    latex: "^{201}\\mathrm{\\overline{Hg}}",
    mass: 187202.6523602,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000802020,
    name: "Hg202",
    latex: "^{202}\\mathrm{Hg}",
    mass: 188134.4636376,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000802020,
    name: "Hg202~",
    latex: "^{202}\\mathrm{\\overline{Hg}}",
    mass: 188134.4636376,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000802030,
    name: "Hg203",
    latex: "^{203}\\mathrm{Hg}",
    mass: 189068.0338554,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000802030,
    name: "Hg203~",
    latex: "^{203}\\mathrm{\\overline{Hg}}",
    mass: 189068.0338554,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000802040,
    name: "Hg204",
    latex: "^{204}\\mathrm{Hg}",
    mass: 190000.1069759,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000802040,
    name: "Hg204~",
    latex: "^{204}\\mathrm{\\overline{Hg}}",
    mass: 190000.1069759,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000802050,
    name: "Hg205",
    latex: "^{205}\\mathrm{Hg}",
    mass: 190934.0034029,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000802050,
    name: "Hg205~",
    latex: "^{205}\\mathrm{\\overline{Hg}}",
    mass: 190934.0034029,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000802060,
    name: "Hg206",
    latex: "^{206}\\mathrm{Hg}",
    mass: 191866.8397896,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000802060,
    name: "Hg206~",
    latex: "^{206}\\mathrm{\\overline{Hg}}",
    mass: 191866.8397896,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000802070,
    name: "Hg207",
    latex: "^{207}\\mathrm{Hg}",
    mass: 192802.7920241,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000802070,
    name: "Hg207~",
    latex: "^{207}\\mathrm{\\overline{Hg}}",
    mass: 192802.7920241,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000802080,
    name: "Hg208",
    latex: "^{208}\\mathrm{Hg}",
    mass: 193737.5090974,
    width: undefined,
    charge: 80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000802080,
    name: "Hg208~",
    latex: "^{208}\\mathrm{\\overline{Hg}}",
    mass: 193737.5090974,
    width: undefined,
    charge: -80.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811770,
    name: "Tl177",
    latex: "^{177}\\mathrm{Tl}",
    mass: 164871.1160203,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811770,
    name: "Tl177~",
    latex: "^{177}\\mathrm{\\overline{Tl}}",
    mass: 164871.1160203,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811780,
    name: "Tl178",
    latex: "^{178}\\mathrm{Tl}",
    mass: 165801.3395661,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811780,
    name: "Tl178~",
    latex: "^{178}\\mathrm{\\overline{Tl}}",
    mass: 165801.3395661,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811790,
    name: "Tl179",
    latex: "^{179}\\mathrm{Tl}",
    mass: 166729.172898,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811790,
    name: "Tl179~",
    latex: "^{179}\\mathrm{\\overline{Tl}}",
    mass: 166729.172898,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811800,
    name: "Tl180",
    latex: "^{180}\\mathrm{Tl}",
    mass: 167659.5492088,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811800,
    name: "Tl180~",
    latex: "^{180}\\mathrm{\\overline{Tl}}",
    mass: 167659.5492088,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811810,
    name: "Tl181",
    latex: "^{181}\\mathrm{Tl}",
    mass: 168587.6340441,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811810,
    name: "Tl181~",
    latex: "^{181}\\mathrm{\\overline{Tl}}",
    mass: 168587.6340441,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811820,
    name: "Tl182",
    latex: "^{182}\\mathrm{Tl}",
    mass: 169518.5999906,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811820,
    name: "Tl182~",
    latex: "^{182}\\mathrm{\\overline{Tl}}",
    mass: 169518.5999906,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811830,
    name: "Tl183",
    latex: "^{183}\\mathrm{Tl}",
    mass: 170446.833865,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811830,
    name: "Tl183~",
    latex: "^{183}\\mathrm{\\overline{Tl}}",
    mass: 170446.833865,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811840,
    name: "Tl184",
    latex: "^{184}\\mathrm{Tl}",
    mass: 171378.0317536,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811840,
    name: "Tl184~",
    latex: "^{184}\\mathrm{\\overline{Tl}}",
    mass: 171378.0317536,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811850,
    name: "Tl185",
    latex: "^{185}\\mathrm{Tl}",
    mass: 172306.6512665,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811850,
    name: "Tl185~",
    latex: "^{185}\\mathrm{\\overline{Tl}}",
    mass: 172306.6512665,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811860,
    name: "Tl186",
    latex: "^{186}\\mathrm{Tl}",
    mass: 173238.02055,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811860,
    name: "Tl186~",
    latex: "^{186}\\mathrm{\\overline{Tl}}",
    mass: 173238.02055,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811870,
    name: "Tl187",
    latex: "^{187}\\mathrm{Tl}",
    mass: 174166.9530449,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811870,
    name: "Tl187~",
    latex: "^{187}\\mathrm{\\overline{Tl}}",
    mass: 174166.9530449,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811880,
    name: "Tl188",
    latex: "^{188}\\mathrm{Tl}",
    mass: 175098.5542705,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811880,
    name: "Tl188~",
    latex: "^{188}\\mathrm{\\overline{Tl}}",
    mass: 175098.5542705,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811890,
    name: "Tl189",
    latex: "^{189}\\mathrm{Tl}",
    mass: 176027.7699396,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811890,
    name: "Tl189~",
    latex: "^{189}\\mathrm{\\overline{Tl}}",
    mass: 176027.7699396,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811900,
    name: "Tl190",
    latex: "^{190}\\mathrm{Tl}",
    mass: 176959.5136838,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811900,
    name: "Tl190~",
    latex: "^{190}\\mathrm{\\overline{Tl}}",
    mass: 176959.5136838,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811910,
    name: "Tl191",
    latex: "^{191}\\mathrm{Tl}",
    mass: 177889.0907726,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811910,
    name: "Tl191~",
    latex: "^{191}\\mathrm{\\overline{Tl}}",
    mass: 177889.0907726,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811920,
    name: "Tl192",
    latex: "^{192}\\mathrm{Tl}",
    mass: 178821.0003227,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811920,
    name: "Tl192~",
    latex: "^{192}\\mathrm{\\overline{Tl}}",
    mass: 178821.0003227,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811930,
    name: "Tl193",
    latex: "^{193}\\mathrm{Tl}",
    mass: 179750.8848046,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811930,
    name: "Tl193~",
    latex: "^{193}\\mathrm{\\overline{Tl}}",
    mass: 179750.8848046,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811940,
    name: "Tl194",
    latex: "^{194}\\mathrm{Tl}",
    mass: 180682.9182434,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811940,
    name: "Tl194~",
    latex: "^{194}\\mathrm{\\overline{Tl}}",
    mass: 180682.9182434,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811950,
    name: "Tl195",
    latex: "^{195}\\mathrm{Tl}",
    mass: 181613.1948843,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811950,
    name: "Tl195~",
    latex: "^{195}\\mathrm{\\overline{Tl}}",
    mass: 181613.1948843,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811960,
    name: "Tl196",
    latex: "^{196}\\mathrm{Tl}",
    mass: 182545.3475544,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811960,
    name: "Tl196~",
    latex: "^{196}\\mathrm{\\overline{Tl}}",
    mass: 182545.3475544,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811970,
    name: "Tl197",
    latex: "^{197}\\mathrm{Tl}",
    mass: 183475.983752,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811970,
    name: "Tl197~",
    latex: "^{197}\\mathrm{\\overline{Tl}}",
    mass: 183475.983752,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811980,
    name: "Tl198",
    latex: "^{198}\\mathrm{Tl}",
    mass: 184408.304091,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811980,
    name: "Tl198~",
    latex: "^{198}\\mathrm{\\overline{Tl}}",
    mass: 184408.304091,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000811990,
    name: "Tl199",
    latex: "^{199}\\mathrm{Tl}",
    mass: 185339.2700376,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000811990,
    name: "Tl199~",
    latex: "^{199}\\mathrm{\\overline{Tl}}",
    mass: 185339.2700376,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000812000,
    name: "Tl200",
    latex: "^{200}\\mathrm{Tl}",
    mass: 186271.7738809,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000812000,
    name: "Tl200~",
    latex: "^{200}\\mathrm{\\overline{Tl}}",
    mass: 186271.7738809,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000812010,
    name: "Tl201",
    latex: "^{201}\\mathrm{Tl}",
    mass: 187203.1338495,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000812010,
    name: "Tl201~",
    latex: "^{201}\\mathrm{\\overline{Tl}}",
    mass: 187203.1338495,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000812020,
    name: "Tl202",
    latex: "^{202}\\mathrm{Tl}",
    mass: 188135.828556,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000812020,
    name: "Tl202~",
    latex: "^{202}\\mathrm{\\overline{Tl}}",
    mass: 188135.828556,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000812030,
    name: "Tl203",
    latex: "^{203}\\mathrm{Tl}",
    mass: 189067.5417471,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000812030,
    name: "Tl203~",
    latex: "^{203}\\mathrm{\\overline{Tl}}",
    mass: 189067.5417471,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000812040,
    name: "Tl204",
    latex: "^{204}\\mathrm{Tl}",
    mass: 190000.4510698,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000812040,
    name: "Tl204~",
    latex: "^{204}\\mathrm{\\overline{Tl}}",
    mass: 190000.4510698,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000812050,
    name: "Tl205",
    latex: "^{205}\\mathrm{Tl}",
    mass: 190932.470443,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000812050,
    name: "Tl205~",
    latex: "^{205}\\mathrm{\\overline{Tl}}",
    mass: 190932.470443,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000812060,
    name: "Tl206",
    latex: "^{206}\\mathrm{Tl}",
    mass: 191865.532065,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000812060,
    name: "Tl206~",
    latex: "^{206}\\mathrm{\\overline{Tl}}",
    mass: 191865.532065,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000812070,
    name: "Tl207",
    latex: "^{207}\\mathrm{Tl}",
    mass: 192798.2454014,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000812070,
    name: "Tl207~",
    latex: "^{207}\\mathrm{\\overline{Tl}}",
    mass: 192798.2454014,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000812080,
    name: "Tl208",
    latex: "^{208}\\mathrm{Tl}",
    mass: 193734.0234465,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000812080,
    name: "Tl208~",
    latex: "^{208}\\mathrm{\\overline{Tl}}",
    mass: 193734.0234465,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000812090,
    name: "Tl209",
    latex: "^{209}\\mathrm{Tl}",
    mass: 194668.6231515,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000812090,
    name: "Tl209~",
    latex: "^{209}\\mathrm{\\overline{Tl}}",
    mass: 194668.6231515,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000812100,
    name: "Tl210",
    latex: "^{210}\\mathrm{Tl}",
    mass: 195604.5148389,
    width: undefined,
    charge: 81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000812100,
    name: "Tl210~",
    latex: "^{210}\\mathrm{\\overline{Tl}}",
    mass: 195604.5148389,
    width: undefined,
    charge: -81.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821810,
    name: "Pb181",
    latex: "^{181}\\mathrm{Pb}",
    mass: 168597.3215828,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821810,
    name: "Pb181~",
    latex: "^{181}\\mathrm{\\overline{Pb}}",
    mass: 168597.3215828,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821820,
    name: "Pb182",
    latex: "^{182}\\mathrm{Pb}",
    mass: 169525.102751,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821820,
    name: "Pb182~",
    latex: "^{182}\\mathrm{\\overline{Pb}}",
    mass: 169525.102751,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821830,
    name: "Pb183",
    latex: "^{183}\\mathrm{Pb}",
    mass: 170455.8386185,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821830,
    name: "Pb183~",
    latex: "^{183}\\mathrm{\\overline{Pb}}",
    mass: 170455.8386185,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821840,
    name: "Pb184",
    latex: "^{184}\\mathrm{Pb}",
    mass: 171383.8638382,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821840,
    name: "Pb184~",
    latex: "^{184}\\mathrm{\\overline{Pb}}",
    mass: 171383.8638382,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821850,
    name: "Pb185",
    latex: "^{185}\\mathrm{Pb}",
    mass: 172314.867976,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821850,
    name: "Pb185~",
    latex: "^{185}\\mathrm{\\overline{Pb}}",
    mass: 172314.867976,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821860,
    name: "Pb186",
    latex: "^{186}\\mathrm{Pb}",
    mass: 173243.2220131,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821860,
    name: "Pb186~",
    latex: "^{186}\\mathrm{\\overline{Pb}}",
    mass: 173243.2220131,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821870,
    name: "Pb187",
    latex: "^{187}\\mathrm{Pb}",
    mass: 174174.4105867,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821870,
    name: "Pb187~",
    latex: "^{187}\\mathrm{\\overline{Pb}}",
    mass: 174174.4105867,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821880,
    name: "Pb188",
    latex: "^{188}\\mathrm{Pb}",
    mass: 175103.0804003,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821880,
    name: "Pb188~",
    latex: "^{188}\\mathrm{\\overline{Pb}}",
    mass: 175103.0804003,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821890,
    name: "Pb189",
    latex: "^{189}\\mathrm{Pb}",
    mass: 176034.5419018,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821890,
    name: "Pb189~",
    latex: "^{189}\\mathrm{\\overline{Pb}}",
    mass: 176034.5419018,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821900,
    name: "Pb190",
    latex: "^{190}\\mathrm{Pb}",
    mass: 176963.4632188,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821900,
    name: "Pb190~",
    latex: "^{190}\\mathrm{\\overline{Pb}}",
    mass: 176963.4632188,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821910,
    name: "Pb191",
    latex: "^{191}\\mathrm{Pb}",
    mass: 177895.0821427,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821910,
    name: "Pb191~",
    latex: "^{191}\\mathrm{\\overline{Pb}}",
    mass: 177895.0821427,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821920,
    name: "Pb192",
    latex: "^{192}\\mathrm{Pb}",
    mass: 178824.3164417,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821920,
    name: "Pb192~",
    latex: "^{192}\\mathrm{\\overline{Pb}}",
    mass: 178824.3164417,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821930,
    name: "Pb193",
    latex: "^{193}\\mathrm{Pb}",
    mass: 179756.1328424,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821930,
    name: "Pb193~",
    latex: "^{193}\\mathrm{\\overline{Pb}}",
    mass: 179756.1328424,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821940,
    name: "Pb194",
    latex: "^{194}\\mathrm{Pb}",
    mass: 180685.6484526,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821940,
    name: "Pb194~",
    latex: "^{194}\\mathrm{\\overline{Pb}}",
    mass: 180685.6484526,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821950,
    name: "Pb195",
    latex: "^{195}\\mathrm{Pb}",
    mass: 181617.6120294,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821950,
    name: "Pb195~",
    latex: "^{195}\\mathrm{\\overline{Pb}}",
    mass: 181617.6120294,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821960,
    name: "Pb196",
    latex: "^{196}\\mathrm{Pb}",
    mass: 182547.4965113,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821960,
    name: "Pb196~",
    latex: "^{196}\\mathrm{\\overline{Pb}}",
    mass: 182547.4965113,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821970,
    name: "Pb197",
    latex: "^{197}\\mathrm{Pb}",
    mass: 183479.5932917,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821970,
    name: "Pb197~",
    latex: "^{197}\\mathrm{\\overline{Pb}}",
    mass: 183479.5932917,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821980,
    name: "Pb198",
    latex: "^{198}\\mathrm{Pb}",
    mass: 184409.7646738,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821980,
    name: "Pb198~",
    latex: "^{198}\\mathrm{\\overline{Pb}}",
    mass: 184409.7646738,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000821990,
    name: "Pb199",
    latex: "^{199}\\mathrm{Pb}",
    mass: 185342.0952592,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000821990,
    name: "Pb199~",
    latex: "^{199}\\mathrm{\\overline{Pb}}",
    mass: 185342.0952592,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822000,
    name: "Pb200",
    latex: "^{200}\\mathrm{Pb}",
    mass: 186272.5703084,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822000,
    name: "Pb200~",
    latex: "^{200}\\mathrm{\\overline{Pb}}",
    mass: 186272.5703084,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822010,
    name: "Pb201",
    latex: "^{201}\\mathrm{Pb}",
    mass: 187205.0434124,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822010,
    name: "Pb201~",
    latex: "^{201}\\mathrm{\\overline{Pb}}",
    mass: 187205.0434124,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822020,
    name: "Pb202",
    latex: "^{202}\\mathrm{Pb}",
    mass: 188135.8687034,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822020,
    name: "Pb202~",
    latex: "^{202}\\mathrm{\\overline{Pb}}",
    mass: 188135.8687034,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822030,
    name: "Pb203",
    latex: "^{203}\\mathrm{Pb}",
    mass: 189068.5169283,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822030,
    name: "Pb203~",
    latex: "^{203}\\mathrm{\\overline{Pb}}",
    mass: 189068.5169283,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822040,
    name: "Pb204",
    latex: "^{204}\\mathrm{Pb}",
    mass: 189999.6873378,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822040,
    name: "Pb204~",
    latex: "^{204}\\mathrm{\\overline{Pb}}",
    mass: 189999.6873378,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822050,
    name: "Pb205",
    latex: "^{205}\\mathrm{Pb}",
    mass: 190932.5211163,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822050,
    name: "Pb205~",
    latex: "^{205}\\mathrm{\\overline{Pb}}",
    mass: 190932.5211163,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822060,
    name: "Pb206",
    latex: "^{206}\\mathrm{Pb}",
    mass: 191863.9998504,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822060,
    name: "Pb206~",
    latex: "^{206}\\mathrm{\\overline{Pb}}",
    mass: 191863.9998504,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822070,
    name: "Pb207",
    latex: "^{207}\\mathrm{Pb}",
    mass: 192796.8274811,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822070,
    name: "Pb207~",
    latex: "^{207}\\mathrm{\\overline{Pb}}",
    mass: 192796.8274811,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822080,
    name: "Pb208",
    latex: "^{208}\\mathrm{Pb}",
    mass: 193729.0250491,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822080,
    name: "Pb208~",
    latex: "^{208}\\mathrm{\\overline{Pb}}",
    mass: 193729.0250491,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822090,
    name: "Pb209",
    latex: "^{209}\\mathrm{Pb}",
    mass: 194664.6531237,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822090,
    name: "Pb209~",
    latex: "^{209}\\mathrm{\\overline{Pb}}",
    mass: 194664.6531237,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822100,
    name: "Pb210",
    latex: "^{210}\\mathrm{Pb}",
    mass: 195599.0333687,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822100,
    name: "Pb210~",
    latex: "^{210}\\mathrm{\\overline{Pb}}",
    mass: 195599.0333687,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822110,
    name: "Pb211",
    latex: "^{211}\\mathrm{Pb}",
    mass: 196534.762883,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822110,
    name: "Pb211~",
    latex: "^{211}\\mathrm{\\overline{Pb}}",
    mass: 196534.762883,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822120,
    name: "Pb212",
    latex: "^{212}\\mathrm{Pb}",
    mass: 197469.201067,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822120,
    name: "Pb212~",
    latex: "^{212}\\mathrm{\\overline{Pb}}",
    mass: 197469.201067,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822130,
    name: "Pb213",
    latex: "^{213}\\mathrm{Pb}",
    mass: 198405.0406838,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822130,
    name: "Pb213~",
    latex: "^{213}\\mathrm{\\overline{Pb}}",
    mass: 198405.0406838,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000822140,
    name: "Pb214",
    latex: "^{214}\\mathrm{Pb}",
    mass: 199339.5551572,
    width: undefined,
    charge: 82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000822140,
    name: "Pb214~",
    latex: "^{214}\\mathrm{\\overline{Pb}}",
    mass: 199339.5551572,
    width: undefined,
    charge: -82.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831850,
    name: "Bi185",
    latex: "^{185}\\mathrm{Bi}",
    mass: 172324.1736021,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831850,
    name: "Bi185~",
    latex: "^{185}\\mathrm{\\overline{Bi}}",
    mass: 172324.1736021,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831860,
    name: "Bi186",
    latex: "^{186}\\mathrm{Bi}",
    mass: 173254.7576361,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831860,
    name: "Bi186~",
    latex: "^{186}\\mathrm{\\overline{Bi}}",
    mass: 173254.7576361,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831870,
    name: "Bi187",
    latex: "^{187}\\mathrm{Bi}",
    mass: 174183.0138663,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831870,
    name: "Bi187~",
    latex: "^{187}\\mathrm{\\overline{Bi}}",
    mass: 174183.0138663,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831880,
    name: "Bi188",
    latex: "^{188}\\mathrm{Bi}",
    mass: 175113.6966386,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831880,
    name: "Bi188~",
    latex: "^{188}\\mathrm{\\overline{Bi}}",
    mass: 175113.6966386,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831890,
    name: "Bi189",
    latex: "^{189}\\mathrm{Bi}",
    mass: 176042.320809,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831890,
    name: "Bi189~",
    latex: "^{189}\\mathrm{\\overline{Bi}}",
    mass: 176042.320809,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831900,
    name: "Bi190",
    latex: "^{190}\\mathrm{Bi}",
    mass: 176973.2839611,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831900,
    name: "Bi190~",
    latex: "^{190}\\mathrm{\\overline{Bi}}",
    mass: 176973.2839611,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831910,
    name: "Bi191",
    latex: "^{191}\\mathrm{Bi}",
    mass: 177902.1344846,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831910,
    name: "Bi191~",
    latex: "^{191}\\mathrm{\\overline{Bi}}",
    mass: 177902.1344846,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831920,
    name: "Bi192",
    latex: "^{192}\\mathrm{Bi}",
    mass: 178833.3333046,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831920,
    name: "Bi192~",
    latex: "^{192}\\mathrm{\\overline{Bi}}",
    mass: 178833.3333046,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831930,
    name: "Bi193",
    latex: "^{193}\\mathrm{Bi}",
    mass: 179762.4772487,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831930,
    name: "Bi193~",
    latex: "^{193}\\mathrm{\\overline{Bi}}",
    mass: 179762.4772487,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831940,
    name: "Bi194",
    latex: "^{194}\\mathrm{Bi}",
    mass: 180693.8334913,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831940,
    name: "Bi194~",
    latex: "^{194}\\mathrm{\\overline{Bi}}",
    mass: 180693.8334913,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831950,
    name: "Bi195",
    latex: "^{195}\\mathrm{Bi}",
    mass: 181623.3248827,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831950,
    name: "Bi195~",
    latex: "^{195}\\mathrm{\\overline{Bi}}",
    mass: 181623.3248827,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831960,
    name: "Bi196",
    latex: "^{196}\\mathrm{Bi}",
    mass: 182554.8357533,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831960,
    name: "Bi196~",
    latex: "^{196}\\mathrm{\\overline{Bi}}",
    mass: 182554.8357533,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831970,
    name: "Bi197",
    latex: "^{197}\\mathrm{Bi}",
    mass: 183484.6513047,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831970,
    name: "Bi197~",
    latex: "^{197}\\mathrm{\\overline{Bi}}",
    mass: 183484.6513047,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831980,
    name: "Bi198",
    latex: "^{198}\\mathrm{Bi}",
    mass: 184416.4583904,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831980,
    name: "Bi198~",
    latex: "^{198}\\mathrm{\\overline{Bi}}",
    mass: 184416.4583904,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000831990,
    name: "Bi199",
    latex: "^{199}\\mathrm{Bi}",
    mass: 185346.5291711,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000831990,
    name: "Bi199~",
    latex: "^{199}\\mathrm{\\overline{Bi}}",
    mass: 185346.5291711,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832000,
    name: "Bi200",
    latex: "^{200}\\mathrm{Bi}",
    mass: 186278.4498992,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832000,
    name: "Bi200~",
    latex: "^{200}\\mathrm{\\overline{Bi}}",
    mass: 186278.4498992,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832010,
    name: "Bi201",
    latex: "^{201}\\mathrm{Bi}",
    mass: 187208.8858256,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832010,
    name: "Bi201~",
    latex: "^{201}\\mathrm{\\overline{Bi}}",
    mass: 187208.8858256,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832020,
    name: "Bi202",
    latex: "^{202}\\mathrm{Bi}",
    mass: 188141.058057,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832020,
    name: "Bi202~",
    latex: "^{202}\\mathrm{\\overline{Bi}}",
    mass: 188141.058057,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832030,
    name: "Bi203",
    latex: "^{203}\\mathrm{Bi}",
    mass: 189071.7780891,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832030,
    name: "Bi203~",
    latex: "^{203}\\mathrm{\\overline{Bi}}",
    mass: 189071.7780891,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832040,
    name: "Bi204",
    latex: "^{204}\\mathrm{Bi}",
    mass: 190004.1515233,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832040,
    name: "Bi204~",
    latex: "^{204}\\mathrm{\\overline{Bi}}",
    mass: 190004.1515233,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832050,
    name: "Bi205",
    latex: "^{205}\\mathrm{Bi}",
    mass: 190935.2255232,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832050,
    name: "Bi205~",
    latex: "^{205}\\mathrm{\\overline{Bi}}",
    mass: 190935.2255232,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832060,
    name: "Bi206",
    latex: "^{206}\\mathrm{Bi}",
    mass: 191867.7573113,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832060,
    name: "Bi206~",
    latex: "^{206}\\mathrm{\\overline{Bi}}",
    mass: 191867.7573113,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832070,
    name: "Bi207",
    latex: "^{207}\\mathrm{Bi}",
    mass: 192799.2249606,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832070,
    name: "Bi207~",
    latex: "^{207}\\mathrm{\\overline{Bi}}",
    mass: 192799.2249606,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832080,
    name: "Bi208",
    latex: "^{208}\\mathrm{Bi}",
    mass: 193731.9034591,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832080,
    name: "Bi208~",
    latex: "^{208}\\mathrm{\\overline{Bi}}",
    mass: 193731.9034591,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832090,
    name: "Bi209",
    latex: "^{209}\\mathrm{Bi}",
    mass: 194664.0090887,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832090,
    name: "Bi209~",
    latex: "^{209}\\mathrm{\\overline{Bi}}",
    mass: 194664.0090887,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832100,
    name: "Bi210",
    latex: "^{210}\\mathrm{Bi}",
    mass: 195598.9698408,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832100,
    name: "Bi210~",
    latex: "^{210}\\mathrm{\\overline{Bi}}",
    mass: 195598.9698408,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832110,
    name: "Bi211",
    latex: "^{211}\\mathrm{Bi}",
    mass: 196533.3970332,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832110,
    name: "Bi211~",
    latex: "^{211}\\mathrm{\\overline{Bi}}",
    mass: 196533.3970332,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832120,
    name: "Bi212",
    latex: "^{212}\\mathrm{Bi}",
    mass: 197468.6320172,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832120,
    name: "Bi212~",
    latex: "^{212}\\mathrm{\\overline{Bi}}",
    mass: 197468.6320172,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832130,
    name: "Bi213",
    latex: "^{213}\\mathrm{Bi}",
    mass: 198403.0128212,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832130,
    name: "Bi213~",
    latex: "^{213}\\mathrm{\\overline{Bi}}",
    mass: 198403.0128212,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832140,
    name: "Bi214",
    latex: "^{214}\\mathrm{Bi}",
    mass: 199338.5374999,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832140,
    name: "Bi214~",
    latex: "^{214}\\mathrm{\\overline{Bi}}",
    mass: 199338.5374999,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832150,
    name: "Bi215",
    latex: "^{215}\\mathrm{Bi}",
    mass: 200272.8614827,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832150,
    name: "Bi215~",
    latex: "^{215}\\mathrm{\\overline{Bi}}",
    mass: 200272.8614827,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000832160,
    name: "Bi216",
    latex: "^{216}\\mathrm{Bi}",
    mass: 201208.600405,
    width: undefined,
    charge: 83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000832160,
    name: "Bi216~",
    latex: "^{216}\\mathrm{\\overline{Bi}}",
    mass: 201208.600405,
    width: undefined,
    charge: -83.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000841900,
    name: "Po190",
    latex: "^{190}\\mathrm{Po}",
    mass: 176979.3172484,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000841900,
    name: "Po190~",
    latex: "^{190}\\mathrm{\\overline{Po}}",
    mass: 176979.3172484,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000841910,
    name: "Po191",
    latex: "^{191}\\mathrm{Po}",
    mass: 177910.3046193,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000841910,
    name: "Po191~",
    latex: "^{191}\\mathrm{\\overline{Po}}",
    mass: 177910.3046193,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000841920,
    name: "Po192",
    latex: "^{192}\\mathrm{Po}",
    mass: 178838.801175,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000841920,
    name: "Po192~",
    latex: "^{192}\\mathrm{\\overline{Po}}",
    mass: 178838.801175,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000841930,
    name: "Po193",
    latex: "^{193}\\mathrm{Po}",
    mass: 179770.0363234,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000841930,
    name: "Po193~",
    latex: "^{193}\\mathrm{\\overline{Po}}",
    mass: 179770.0363234,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000841940,
    name: "Po194",
    latex: "^{194}\\mathrm{Po}",
    mass: 180698.8514501,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000841940,
    name: "Po194~",
    latex: "^{194}\\mathrm{\\overline{Po}}",
    mass: 180698.8514501,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000841950,
    name: "Po195",
    latex: "^{195}\\mathrm{Po}",
    mass: 181630.2337745,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000841950,
    name: "Po195~",
    latex: "^{195}\\mathrm{\\overline{Po}}",
    mass: 181630.2337745,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000841960,
    name: "Po196",
    latex: "^{196}\\mathrm{Po}",
    mass: 182559.3758556,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000841960,
    name: "Po196~",
    latex: "^{196}\\mathrm{\\overline{Po}}",
    mass: 182559.3758556,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000841970,
    name: "Po197",
    latex: "^{197}\\mathrm{Po}",
    mass: 183490.9454103,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000841970,
    name: "Po197~",
    latex: "^{197}\\mathrm{\\overline{Po}}",
    mass: 183490.9454103,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000841980,
    name: "Po198",
    latex: "^{198}\\mathrm{Po}",
    mass: 184420.3594877,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000841980,
    name: "Po198~",
    latex: "^{198}\\mathrm{\\overline{Po}}",
    mass: 184420.3594877,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000841990,
    name: "Po199",
    latex: "^{199}\\mathrm{Po}",
    mass: 185352.0873965,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000841990,
    name: "Po199~",
    latex: "^{199}\\mathrm{\\overline{Po}}",
    mass: 185352.0873965,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842000,
    name: "Po200",
    latex: "^{200}\\mathrm{Po}",
    mass: 186281.878729,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842000,
    name: "Po200~",
    latex: "^{200}\\mathrm{\\overline{Po}}",
    mass: 186281.878729,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842010,
    name: "Po201",
    latex: "^{201}\\mathrm{Po}",
    mass: 187213.793868,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842010,
    name: "Po201~",
    latex: "^{201}\\mathrm{\\overline{Po}}",
    mass: 187213.793868,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842020,
    name: "Po202",
    latex: "^{202}\\mathrm{Po}",
    mass: 188143.8674432,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842020,
    name: "Po202~",
    latex: "^{202}\\mathrm{\\overline{Po}}",
    mass: 188143.8674432,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842030,
    name: "Po203",
    latex: "^{203}\\mathrm{Po}",
    mass: 189075.9921684,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842030,
    name: "Po203~",
    latex: "^{203}\\mathrm{\\overline{Po}}",
    mass: 189075.9921684,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842040,
    name: "Po204",
    latex: "^{204}\\mathrm{Po}",
    mass: 190006.4560397,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842040,
    name: "Po204~",
    latex: "^{204}\\mathrm{\\overline{Po}}",
    mass: 190006.4560397,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842050,
    name: "Po205",
    latex: "^{205}\\mathrm{Po}",
    mass: 190938.7698582,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842050,
    name: "Po205~",
    latex: "^{205}\\mathrm{\\overline{Po}}",
    mass: 190938.7698582,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842060,
    name: "Po206",
    latex: "^{206}\\mathrm{Po}",
    mass: 191869.5970122,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842060,
    name: "Po206~",
    latex: "^{206}\\mathrm{\\overline{Po}}",
    mass: 191869.5970122,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842070,
    name: "Po207",
    latex: "^{207}\\mathrm{Po}",
    mass: 192802.1334578,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842070,
    name: "Po207~",
    latex: "^{207}\\mathrm{\\overline{Po}}",
    mass: 192802.1334578,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842080,
    name: "Po208",
    latex: "^{208}\\mathrm{Po}",
    mass: 193733.304333,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842080,
    name: "Po208~",
    latex: "^{208}\\mathrm{\\overline{Po}}",
    mass: 193733.304333,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842090,
    name: "Po209",
    latex: "^{209}\\mathrm{Po}",
    mass: 194665.9016984,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842090,
    name: "Po209~",
    latex: "^{209}\\mathrm{\\overline{Po}}",
    mass: 194665.9016984,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842100,
    name: "Po210",
    latex: "^{210}\\mathrm{Po}",
    mass: 195597.8087334,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842100,
    name: "Po210~",
    latex: "^{210}\\mathrm{\\overline{Po}}",
    mass: 195597.8087334,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842110,
    name: "Po211",
    latex: "^{211}\\mathrm{Po}",
    mass: 196532.8234191,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842110,
    name: "Po211~",
    latex: "^{211}\\mathrm{\\overline{Po}}",
    mass: 196532.8234191,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842120,
    name: "Po212",
    latex: "^{212}\\mathrm{Po}",
    mass: 197466.380596,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842120,
    name: "Po212~",
    latex: "^{212}\\mathrm{\\overline{Po}}",
    mass: 197466.380596,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842130,
    name: "Po213",
    latex: "^{213}\\mathrm{Po}",
    mass: 198401.5904297,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842130,
    name: "Po213~",
    latex: "^{213}\\mathrm{\\overline{Po}}",
    mass: 198401.5904297,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842140,
    name: "Po214",
    latex: "^{214}\\mathrm{Po}",
    mass: 199335.268235,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842140,
    name: "Po214~",
    latex: "^{214}\\mathrm{\\overline{Po}}",
    mass: 199335.268235,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842150,
    name: "Po215",
    latex: "^{215}\\mathrm{Po}",
    mass: 200270.6905425,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842150,
    name: "Po215~",
    latex: "^{215}\\mathrm{\\overline{Po}}",
    mass: 200270.6905425,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842160,
    name: "Po216",
    latex: "^{216}\\mathrm{Po}",
    mass: 201204.508724,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842160,
    name: "Po216~",
    latex: "^{216}\\mathrm{\\overline{Po}}",
    mass: 201204.508724,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842170,
    name: "Po217",
    latex: "^{217}\\mathrm{Po}",
    mass: 202140.1038237,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842170,
    name: "Po217~",
    latex: "^{217}\\mathrm{\\overline{Po}}",
    mass: 202140.1038237,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000842180,
    name: "Po218",
    latex: "^{218}\\mathrm{Po}",
    mass: 203074.0712306,
    width: undefined,
    charge: 84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000842180,
    name: "Po218~",
    latex: "^{218}\\mathrm{\\overline{Po}}",
    mass: 203074.0712306,
    width: undefined,
    charge: -84.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000851930,
    name: "At193",
    latex: "^{193}\\mathrm{At}",
    mass: 179778.2949501,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000851930,
    name: "At193~",
    latex: "^{193}\\mathrm{\\overline{At}}",
    mass: 179778.2949501,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000851940,
    name: "At194",
    latex: "^{194}\\mathrm{At}",
    mass: 180709.1398024,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000851940,
    name: "At194~",
    latex: "^{194}\\mathrm{\\overline{At}}",
    mass: 180709.1398024,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000851950,
    name: "At195",
    latex: "^{195}\\mathrm{At}",
    mass: 181637.8794781,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000851950,
    name: "At195~",
    latex: "^{195}\\mathrm{\\overline{At}}",
    mass: 181637.8794781,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000851960,
    name: "At196",
    latex: "^{196}\\mathrm{At}",
    mass: 182568.9320536,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000851960,
    name: "At196~",
    latex: "^{196}\\mathrm{\\overline{At}}",
    mass: 182568.9320536,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000851970,
    name: "At197",
    latex: "^{197}\\mathrm{At}",
    mass: 183497.9828483,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000851970,
    name: "At197~",
    latex: "^{197}\\mathrm{\\overline{At}}",
    mass: 183497.9828483,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000851980,
    name: "At198",
    latex: "^{198}\\mathrm{At}",
    mass: 184429.1239157,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000851980,
    name: "At198~",
    latex: "^{198}\\mathrm{\\overline{At}}",
    mass: 184429.1239157,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000851990,
    name: "At199",
    latex: "^{199}\\mathrm{At}",
    mass: 185358.5035278,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000851990,
    name: "At199~",
    latex: "^{199}\\mathrm{\\overline{At}}",
    mass: 185358.5035278,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852000,
    name: "At200",
    latex: "^{200}\\mathrm{At}",
    mass: 186289.8327571,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852000,
    name: "At200~",
    latex: "^{200}\\mathrm{\\overline{At}}",
    mass: 186289.8327571,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852010,
    name: "At201",
    latex: "^{201}\\mathrm{At}",
    mass: 187219.5253512,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852010,
    name: "At201~",
    latex: "^{201}\\mathrm{\\overline{At}}",
    mass: 187219.5253512,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852020,
    name: "At202",
    latex: "^{202}\\mathrm{At}",
    mass: 188151.2141372,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852020,
    name: "At202~",
    latex: "^{202}\\mathrm{\\overline{At}}",
    mass: 188151.2141372,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852030,
    name: "At203",
    latex: "^{203}\\mathrm{At}",
    mass: 189081.1405364,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852030,
    name: "At203~",
    latex: "^{203}\\mathrm{\\overline{At}}",
    mass: 189081.1405364,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852040,
    name: "At204",
    latex: "^{204}\\mathrm{At}",
    mass: 190012.9215403,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852040,
    name: "At204~",
    latex: "^{204}\\mathrm{\\overline{At}}",
    mass: 190012.9215403,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852050,
    name: "At205",
    latex: "^{205}\\mathrm{At}",
    mass: 190943.307166,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852050,
    name: "At205~",
    latex: "^{205}\\mathrm{\\overline{At}}",
    mass: 190943.307166,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852060,
    name: "At206",
    latex: "^{206}\\mathrm{At}",
    mass: 191875.3461938,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852060,
    name: "At206~",
    latex: "^{206}\\mathrm{\\overline{At}}",
    mass: 191875.3461938,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852070,
    name: "At207",
    latex: "^{207}\\mathrm{At}",
    mass: 192806.0522535,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852070,
    name: "At207~",
    latex: "^{207}\\mathrm{\\overline{At}}",
    mass: 192806.0522535,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852080,
    name: "At208",
    latex: "^{208}\\mathrm{At}",
    mass: 193738.3036619,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852080,
    name: "At208~",
    latex: "^{208}\\mathrm{\\overline{At}}",
    mass: 193738.3036619,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852090,
    name: "At209",
    latex: "^{209}\\mathrm{At}",
    mass: 194669.3841822,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852090,
    name: "At209~",
    latex: "^{209}\\mathrm{\\overline{At}}",
    mass: 194669.3841822,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852100,
    name: "At210",
    latex: "^{210}\\mathrm{At}",
    mass: 195601.7892872,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852100,
    name: "At210~",
    latex: "^{210}\\mathrm{\\overline{At}}",
    mass: 195601.7892872,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852110,
    name: "At211",
    latex: "^{211}\\mathrm{At}",
    mass: 196533.6086686,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852110,
    name: "At211~",
    latex: "^{211}\\mathrm{\\overline{At}}",
    mass: 196533.6086686,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852120,
    name: "At212",
    latex: "^{212}\\mathrm{At}",
    mass: 197468.1218379,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852120,
    name: "At212~",
    latex: "^{212}\\mathrm{\\overline{At}}",
    mass: 197468.1218379,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852130,
    name: "At213",
    latex: "^{213}\\mathrm{At}",
    mass: 198401.6649492,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852130,
    name: "At213~",
    latex: "^{213}\\mathrm{\\overline{At}}",
    mass: 198401.6649492,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852140,
    name: "At214",
    latex: "^{214}\\mathrm{At}",
    mass: 199336.3587352,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852140,
    name: "At214~",
    latex: "^{214}\\mathrm{\\overline{At}}",
    mass: 199336.3587352,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852150,
    name: "At215",
    latex: "^{215}\\mathrm{At}",
    mass: 200269.9757139,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852150,
    name: "At215~",
    latex: "^{215}\\mathrm{\\overline{At}}",
    mass: 200269.9757139,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852160,
    name: "At216",
    latex: "^{216}\\mathrm{At}",
    mass: 201204.9834134,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852160,
    name: "At216~",
    latex: "^{216}\\mathrm{\\overline{At}}",
    mass: 201204.9834134,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852170,
    name: "At217",
    latex: "^{217}\\mathrm{At}",
    mass: 202138.6152961,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852170,
    name: "At217~",
    latex: "^{217}\\mathrm{\\overline{At}}",
    mass: 202138.6152961,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852180,
    name: "At218",
    latex: "^{218}\\mathrm{At}",
    mass: 203073.8148834,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852180,
    name: "At218~",
    latex: "^{218}\\mathrm{\\overline{At}}",
    mass: 203073.8148834,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852190,
    name: "At219",
    latex: "^{219}\\mathrm{At}",
    mass: 204007.6051201,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852190,
    name: "At219~",
    latex: "^{219}\\mathrm{\\overline{At}}",
    mass: 204007.6051201,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852200,
    name: "At220",
    latex: "^{220}\\mathrm{At}",
    mass: 204943.0785666,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852200,
    name: "At220~",
    latex: "^{220}\\mathrm{\\overline{At}}",
    mass: 204943.0785666,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852210,
    name: "At221",
    latex: "^{221}\\mathrm{At}",
    mass: 205876.9796511,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852210,
    name: "At221~",
    latex: "^{221}\\mathrm{\\overline{At}}",
    mass: 205876.9796511,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852220,
    name: "At222",
    latex: "^{222}\\mathrm{At}",
    mass: 206812.6440539,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852220,
    name: "At222~",
    latex: "^{222}\\mathrm{\\overline{At}}",
    mass: 206812.6440539,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000852230,
    name: "At223",
    latex: "^{223}\\mathrm{At}",
    mass: 207746.6131374,
    width: undefined,
    charge: 85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000852230,
    name: "At223~",
    latex: "^{223}\\mathrm{\\overline{At}}",
    mass: 207746.6131374,
    width: undefined,
    charge: -85.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000861960,
    name: "Rn196",
    latex: "^{196}\\mathrm{Rn}",
    mass: 182574.8190963,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000861960,
    name: "Rn196~",
    latex: "^{196}\\mathrm{\\overline{Rn}}",
    mass: 182574.8190963,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000861970,
    name: "Rn197",
    latex: "^{197}\\mathrm{Rn}",
    mass: 183505.8483845,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000861970,
    name: "Rn197~",
    latex: "^{197}\\mathrm{\\overline{Rn}}",
    mass: 183505.8483845,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000861980,
    name: "Rn198",
    latex: "^{198}\\mathrm{Rn}",
    mass: 184434.6020326,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000861980,
    name: "Rn198~",
    latex: "^{198}\\mathrm{\\overline{Rn}}",
    mass: 184434.6020326,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000861990,
    name: "Rn199",
    latex: "^{199}\\mathrm{Rn}",
    mass: 185365.7663874,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000861990,
    name: "Rn199~",
    latex: "^{199}\\mathrm{\\overline{Rn}}",
    mass: 185365.7663874,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862000,
    name: "Rn200",
    latex: "^{200}\\mathrm{Rn}",
    mass: 186294.8199765,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862000,
    name: "Rn200~",
    latex: "^{200}\\mathrm{\\overline{Rn}}",
    mass: 186294.8199765,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862010,
    name: "Rn201",
    latex: "^{201}\\mathrm{Rn}",
    mass: 187226.2078899,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862010,
    name: "Rn201~",
    latex: "^{201}\\mathrm{\\overline{Rn}}",
    mass: 187226.2078899,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862020,
    name: "Rn202",
    latex: "^{202}\\mathrm{Rn}",
    mass: 188155.5344069,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862020,
    name: "Rn202~",
    latex: "^{202}\\mathrm{\\overline{Rn}}",
    mass: 188155.5344069,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862030,
    name: "Rn203",
    latex: "^{203}\\mathrm{Rn}",
    mass: 189087.1188655,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862030,
    name: "Rn203~",
    latex: "^{203}\\mathrm{\\overline{Rn}}",
    mass: 189087.1188655,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862040,
    name: "Rn204",
    latex: "^{204}\\mathrm{Rn}",
    mass: 190016.827295,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862040,
    name: "Rn204~",
    latex: "^{204}\\mathrm{\\overline{Rn}}",
    mass: 190016.827295,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862050,
    name: "Rn205",
    latex: "^{205}\\mathrm{Rn}",
    mass: 190948.5812856,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862050,
    name: "Rn205~",
    latex: "^{205}\\mathrm{\\overline{Rn}}",
    mass: 190948.5812856,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862060,
    name: "Rn206",
    latex: "^{206}\\mathrm{Rn}",
    mass: 191878.6520663,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862060,
    name: "Rn206~",
    latex: "^{206}\\mathrm{\\overline{Rn}}",
    mass: 191878.6520663,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862070,
    name: "Rn207",
    latex: "^{207}\\mathrm{Rn}",
    mass: 192810.6445194,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862070,
    name: "Rn207~",
    latex: "^{207}\\mathrm{\\overline{Rn}}",
    mass: 192810.6445194,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862080,
    name: "Rn208",
    latex: "^{208}\\mathrm{Rn}",
    mass: 193741.1186371,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862080,
    name: "Rn208~",
    latex: "^{208}\\mathrm{\\overline{Rn}}",
    mass: 193741.1186371,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862090,
    name: "Rn209",
    latex: "^{209}\\mathrm{Rn}",
    mass: 194673.3262653,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862090,
    name: "Rn209~",
    latex: "^{209}\\mathrm{\\overline{Rn}}",
    mass: 194673.3262653,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862100,
    name: "Rn210",
    latex: "^{210}\\mathrm{Rn}",
    mass: 195604.1571452,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862100,
    name: "Rn210~",
    latex: "^{210}\\mathrm{\\overline{Rn}}",
    mass: 195604.1571452,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862110,
    name: "Rn211",
    latex: "^{211}\\mathrm{Rn}",
    mass: 196536.5007715,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862110,
    name: "Rn211~",
    latex: "^{211}\\mathrm{\\overline{Rn}}",
    mass: 196536.5007715,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862120,
    name: "Rn212",
    latex: "^{212}\\mathrm{Rn}",
    mass: 197468.0908191,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862120,
    name: "Rn212~",
    latex: "^{212}\\mathrm{\\overline{Rn}}",
    mass: 197468.0908191,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862130,
    name: "Rn213",
    latex: "^{213}\\mathrm{Rn}",
    mass: 198402.5480056,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862130,
    name: "Rn213~",
    latex: "^{213}\\mathrm{\\overline{Rn}}",
    mass: 198402.5480056,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862140,
    name: "Rn214",
    latex: "^{214}\\mathrm{Rn}",
    mass: 199335.4188576,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862140,
    name: "Rn214~",
    latex: "^{214}\\mathrm{\\overline{Rn}}",
    mass: 199335.4188576,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862150,
    name: "Rn215",
    latex: "^{215}\\mathrm{Rn}",
    mass: 200270.0632744,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862150,
    name: "Rn215~",
    latex: "^{215}\\mathrm{\\overline{Rn}}",
    mass: 200270.0632744,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862160,
    name: "Rn216",
    latex: "^{216}\\mathrm{Rn}",
    mass: 201202.9797696,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862160,
    name: "Rn216~",
    latex: "^{216}\\mathrm{\\overline{Rn}}",
    mass: 201202.9797696,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862170,
    name: "Rn217",
    latex: "^{217}\\mathrm{Rn}",
    mass: 202137.8794158,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862170,
    name: "Rn217~",
    latex: "^{217}\\mathrm{\\overline{Rn}}",
    mass: 202137.8794158,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862180,
    name: "Rn218",
    latex: "^{218}\\mathrm{Rn}",
    mass: 203070.9320023,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862180,
    name: "Rn218~",
    latex: "^{218}\\mathrm{\\overline{Rn}}",
    mass: 203070.9320023,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862190,
    name: "Rn219",
    latex: "^{219}\\mathrm{Rn}",
    mass: 204006.0380675,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862190,
    name: "Rn219~",
    latex: "^{219}\\mathrm{\\overline{Rn}}",
    mass: 204006.0380675,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862200,
    name: "Rn220",
    latex: "^{220}\\mathrm{Rn}",
    mass: 204939.3147715,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862200,
    name: "Rn220~",
    latex: "^{220}\\mathrm{\\overline{Rn}}",
    mass: 204939.3147715,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862210,
    name: "Rn221",
    latex: "^{221}\\mathrm{Rn}",
    mass: 205874.6686142,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862210,
    name: "Rn221~",
    latex: "^{221}\\mathrm{\\overline{Rn}}",
    mass: 205874.6686142,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862220,
    name: "Rn222",
    latex: "^{222}\\mathrm{Rn}",
    mass: 206808.0629659,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862220,
    name: "Rn222~",
    latex: "^{222}\\mathrm{\\overline{Rn}}",
    mass: 206808.0629659,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862230,
    name: "Rn223",
    latex: "^{223}\\mathrm{Rn}",
    mass: 207743.5746037,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862230,
    name: "Rn223~",
    latex: "^{223}\\mathrm{\\overline{Rn}}",
    mass: 207743.5746037,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862240,
    name: "Rn224",
    latex: "^{224}\\mathrm{Rn}",
    mass: 208677.1245149,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862240,
    name: "Rn224~",
    latex: "^{224}\\mathrm{\\overline{Rn}}",
    mass: 208677.1245149,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862250,
    name: "Rn225",
    latex: "^{225}\\mathrm{Rn}",
    mass: 209612.7078777,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862250,
    name: "Rn225~",
    latex: "^{225}\\mathrm{\\overline{Rn}}",
    mass: 209612.7078777,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862260,
    name: "Rn226",
    latex: "^{226}\\mathrm{Rn}",
    mass: 210546.4142799,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862260,
    name: "Rn226~",
    latex: "^{226}\\mathrm{\\overline{Rn}}",
    mass: 210546.4142799,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862270,
    name: "Rn227",
    latex: "^{227}\\mathrm{Rn}",
    mass: 211482.047012,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862270,
    name: "Rn227~",
    latex: "^{227}\\mathrm{\\overline{Rn}}",
    mass: 211482.047012,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000862280,
    name: "Rn228",
    latex: "^{228}\\mathrm{Rn}",
    mass: 212415.8987272,
    width: undefined,
    charge: 86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000862280,
    name: "Rn228~",
    latex: "^{228}\\mathrm{\\overline{Rn}}",
    mass: 212415.8987272,
    width: undefined,
    charge: -86.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872000,
    name: "Fr200",
    latex: "^{200}\\mathrm{Fr}",
    mass: 186304.9499749,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872000,
    name: "Fr200~",
    latex: "^{200}\\mathrm{\\overline{Fr}}",
    mass: 186304.9499749,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872010,
    name: "Fr201",
    latex: "^{201}\\mathrm{Fr}",
    mass: 187233.9029627,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872010,
    name: "Fr201~",
    latex: "^{201}\\mathrm{\\overline{Fr}}",
    mass: 187233.9029627,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872020,
    name: "Fr202",
    latex: "^{202}\\mathrm{Fr}",
    mass: 188164.9108265,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872020,
    name: "Fr202~",
    latex: "^{202}\\mathrm{\\overline{Fr}}",
    mass: 188164.9108265,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872030,
    name: "Fr203",
    latex: "^{203}\\mathrm{Fr}",
    mass: 189094.1795908,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872030,
    name: "Fr203~",
    latex: "^{203}\\mathrm{\\overline{Fr}}",
    mass: 189094.1795908,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872040,
    name: "Fr204",
    latex: "^{204}\\mathrm{Fr}",
    mass: 190025.4044927,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872040,
    name: "Fr204~",
    latex: "^{204}\\mathrm{\\overline{Fr}}",
    mass: 190025.4044927,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872050,
    name: "Fr205",
    latex: "^{205}\\mathrm{Fr}",
    mass: 190954.9815816,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872050,
    name: "Fr205~",
    latex: "^{205}\\mathrm{\\overline{Fr}}",
    mass: 190954.9815816,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872060,
    name: "Fr206",
    latex: "^{206}\\mathrm{Fr}",
    mass: 191886.5380954,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872060,
    name: "Fr206~",
    latex: "^{206}\\mathrm{\\overline{Fr}}",
    mass: 191886.5380954,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872070,
    name: "Fr207",
    latex: "^{207}\\mathrm{Fr}",
    mass: 192816.4300293,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872070,
    name: "Fr207~",
    latex: "^{207}\\mathrm{\\overline{Fr}}",
    mass: 192816.4300293,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872080,
    name: "Fr208",
    latex: "^{208}\\mathrm{Fr}",
    mass: 193748.1085688,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872080,
    name: "Fr208~",
    latex: "^{208}\\mathrm{\\overline{Fr}}",
    mass: 193748.1085688,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872090,
    name: "Fr209",
    latex: "^{209}\\mathrm{Fr}",
    mass: 194678.4858111,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872090,
    name: "Fr209~",
    latex: "^{209}\\mathrm{\\overline{Fr}}",
    mass: 194678.4858111,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872100,
    name: "Fr210",
    latex: "^{210}\\mathrm{Fr}",
    mass: 195610.4186486,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872100,
    name: "Fr210~",
    latex: "^{210}\\mathrm{\\overline{Fr}}",
    mass: 195610.4186486,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872110,
    name: "Fr211",
    latex: "^{211}\\mathrm{Fr}",
    mass: 196541.1153933,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872110,
    name: "Fr211~",
    latex: "^{211}\\mathrm{\\overline{Fr}}",
    mass: 196541.1153933,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872120,
    name: "Fr212",
    latex: "^{212}\\mathrm{Fr}",
    mass: 197473.2335981,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872120,
    name: "Fr212~",
    latex: "^{212}\\mathrm{\\overline{Fr}}",
    mass: 197473.2335981,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872130,
    name: "Fr213",
    latex: "^{213}\\mathrm{Fr}",
    mass: 198404.6895106,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872130,
    name: "Fr213~",
    latex: "^{213}\\mathrm{\\overline{Fr}}",
    mass: 198404.6895106,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872140,
    name: "Fr214",
    latex: "^{214}\\mathrm{Fr}",
    mass: 199338.7796883,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872140,
    name: "Fr214~",
    latex: "^{214}\\mathrm{\\overline{Fr}}",
    mass: 199338.7796883,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872150,
    name: "Fr215",
    latex: "^{215}\\mathrm{Fr}",
    mass: 200271.5508705,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872150,
    name: "Fr215~",
    latex: "^{215}\\mathrm{\\overline{Fr}}",
    mass: 200271.5508705,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872160,
    name: "Fr216",
    latex: "^{216}\\mathrm{Fr}",
    mass: 201205.6978694,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872160,
    name: "Fr216~",
    latex: "^{216}\\mathrm{\\overline{Fr}}",
    mass: 201205.6978694,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872170,
    name: "Fr217",
    latex: "^{217}\\mathrm{Fr}",
    mass: 202138.5351876,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872170,
    name: "Fr217~",
    latex: "^{217}\\mathrm{\\overline{Fr}}",
    mass: 202138.5351876,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872180,
    name: "Fr218",
    latex: "^{218}\\mathrm{Fr}",
    mass: 203072.7744045,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872180,
    name: "Fr218~",
    latex: "^{218}\\mathrm{\\overline{Fr}}",
    mass: 203072.7744045,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872190,
    name: "Fr219",
    latex: "^{219}\\mathrm{Fr}",
    mass: 204005.8259663,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872190,
    name: "Fr219~",
    latex: "^{219}\\mathrm{\\overline{Fr}}",
    mass: 204005.8259663,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872200,
    name: "Fr220",
    latex: "^{220}\\mathrm{Fr}",
    mass: 204940.1853459,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872200,
    name: "Fr220~",
    latex: "^{220}\\mathrm{\\overline{Fr}}",
    mass: 204940.1853459,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872210,
    name: "Fr221",
    latex: "^{221}\\mathrm{Fr}",
    mass: 205873.4744388,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872210,
    name: "Fr221~",
    latex: "^{221}\\mathrm{\\overline{Fr}}",
    mass: 205873.4744388,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872220,
    name: "Fr222",
    latex: "^{222}\\mathrm{Fr}",
    mass: 206808.0694863,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872220,
    name: "Fr222~",
    latex: "^{222}\\mathrm{\\overline{Fr}}",
    mass: 206808.0694863,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872230,
    name: "Fr223",
    latex: "^{223}\\mathrm{Fr}",
    mass: 207741.5674202,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872230,
    name: "Fr223~",
    latex: "^{223}\\mathrm{\\overline{Fr}}",
    mass: 207741.5674202,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872240,
    name: "Fr224",
    latex: "^{224}\\mathrm{Fr}",
    mass: 208676.4277573,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872240,
    name: "Fr224~",
    latex: "^{224}\\mathrm{\\overline{Fr}}",
    mass: 208676.4277573,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872250,
    name: "Fr225",
    latex: "^{225}\\mathrm{Fr}",
    mass: 209609.9935039,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872250,
    name: "Fr225~",
    latex: "^{225}\\mathrm{\\overline{Fr}}",
    mass: 209609.9935039,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872260,
    name: "Fr226",
    latex: "^{226}\\mathrm{Fr}",
    mass: 210545.1884337,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872260,
    name: "Fr226~",
    latex: "^{226}\\mathrm{\\overline{Fr}}",
    mass: 210545.1884337,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872270,
    name: "Fr227",
    latex: "^{227}\\mathrm{Fr}",
    mass: 211478.8436037,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872270,
    name: "Fr227~",
    latex: "^{227}\\mathrm{\\overline{Fr}}",
    mass: 211478.8436037,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872280,
    name: "Fr228",
    latex: "^{228}\\mathrm{Fr}",
    mass: 212414.039465,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872280,
    name: "Fr228~",
    latex: "^{228}\\mathrm{\\overline{Fr}}",
    mass: 212414.039465,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872290,
    name: "Fr229",
    latex: "^{229}\\mathrm{Fr}",
    mass: 213347.8175923,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872290,
    name: "Fr229~",
    latex: "^{229}\\mathrm{\\overline{Fr}}",
    mass: 213347.8175923,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872300,
    name: "Fr230",
    latex: "^{230}\\mathrm{Fr}",
    mass: 214283.1308218,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872300,
    name: "Fr230~",
    latex: "^{230}\\mathrm{\\overline{Fr}}",
    mass: 214283.1308218,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872310,
    name: "Fr231",
    latex: "^{231}\\mathrm{Fr}",
    mass: 215217.2182051,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872310,
    name: "Fr231~",
    latex: "^{231}\\mathrm{\\overline{Fr}}",
    mass: 215217.2182051,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000872320,
    name: "Fr232",
    latex: "^{232}\\mathrm{Fr}",
    mass: 216152.7046926,
    width: undefined,
    charge: 87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000872320,
    name: "Fr232~",
    latex: "^{232}\\mathrm{\\overline{Fr}}",
    mass: 216152.7046926,
    width: undefined,
    charge: -87.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882030,
    name: "Ra203",
    latex: "^{203}\\mathrm{Ra}",
    mass: 189101.9044714,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882030,
    name: "Ra203~",
    latex: "^{203}\\mathrm{\\overline{Ra}}",
    mass: 189101.9044714,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882040,
    name: "Ra204",
    latex: "^{204}\\mathrm{Ra}",
    mass: 190030.8583907,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882040,
    name: "Ra204~",
    latex: "^{204}\\mathrm{\\overline{Ra}}",
    mass: 190030.8583907,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882050,
    name: "Ra205",
    latex: "^{205}\\mathrm{Ra}",
    mass: 190962.0954021,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882050,
    name: "Ra205~",
    latex: "^{205}\\mathrm{\\overline{Ra}}",
    mass: 190962.0954021,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882060,
    name: "Ra206",
    latex: "^{206}\\mathrm{Ra}",
    mass: 191891.3511255,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882060,
    name: "Ra206~",
    latex: "^{206}\\mathrm{\\overline{Ra}}",
    mass: 191891.3511255,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882070,
    name: "Ra207",
    latex: "^{207}\\mathrm{Ra}",
    mass: 192822.7912025,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882070,
    name: "Ra207~",
    latex: "^{207}\\mathrm{\\overline{Ra}}",
    mass: 192822.7912025,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882080,
    name: "Ra208",
    latex: "^{208}\\mathrm{Ra}",
    mass: 193752.501495,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882080,
    name: "Ra208~",
    latex: "^{208}\\mathrm{\\overline{Ra}}",
    mass: 193752.501495,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882090,
    name: "Ra209",
    latex: "^{209}\\mathrm{Ra}",
    mass: 194684.1260079,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882090,
    name: "Ra209~",
    latex: "^{209}\\mathrm{\\overline{Ra}}",
    mass: 194684.1260079,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882100,
    name: "Ra210",
    latex: "^{210}\\mathrm{Ra}",
    mass: 195614.2042406,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882100,
    name: "Ra210~",
    latex: "^{210}\\mathrm{\\overline{Ra}}",
    mass: 195614.2042406,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882110,
    name: "Ra211",
    latex: "^{211}\\mathrm{Ra}",
    mass: 196546.0877089,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882110,
    name: "Ra211~",
    latex: "^{211}\\mathrm{\\overline{Ra}}",
    mass: 196546.0877089,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882120,
    name: "Ra212",
    latex: "^{212}\\mathrm{Ra}",
    mass: 197476.5515801,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882120,
    name: "Ra212~",
    latex: "^{212}\\mathrm{\\overline{Ra}}",
    mass: 197476.5515801,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882130,
    name: "Ra213",
    latex: "^{213}\\mathrm{Ra}",
    mass: 198408.5896764,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882130,
    name: "Ra213~",
    latex: "^{213}\\mathrm{\\overline{Ra}}",
    mass: 198408.5896764,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882140,
    name: "Ra214",
    latex: "^{214}\\mathrm{Ra}",
    mass: 199339.8313452,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882140,
    name: "Ra214~",
    latex: "^{214}\\mathrm{\\overline{Ra}}",
    mass: 199339.8313452,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882150,
    name: "Ra215",
    latex: "^{215}\\mathrm{Ra}",
    mass: 200273.7641005,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882150,
    name: "Ra215~",
    latex: "^{215}\\mathrm{\\overline{Ra}}",
    mass: 200273.7641005,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882160,
    name: "Ra216",
    latex: "^{216}\\mathrm{Ra}",
    mass: 201206.0183034,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882160,
    name: "Ra216~",
    latex: "^{216}\\mathrm{\\overline{Ra}}",
    mass: 201206.0183034,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882170,
    name: "Ra217",
    latex: "^{217}\\mathrm{Ra}",
    mass: 202140.1103441,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882170,
    name: "Ra217~",
    latex: "^{217}\\mathrm{\\overline{Ra}}",
    mass: 202140.1103441,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882180,
    name: "Ra218",
    latex: "^{218}\\mathrm{Ra}",
    mass: 203072.3598896,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882180,
    name: "Ra218~",
    latex: "^{218}\\mathrm{\\overline{Ra}}",
    mass: 203072.3598896,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882190,
    name: "Ra219",
    latex: "^{219}\\mathrm{Ra}",
    mass: 204006.6028324,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882190,
    name: "Ra219~",
    latex: "^{219}\\mathrm{\\overline{Ra}}",
    mass: 204006.6028324,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882200,
    name: "Ra220",
    latex: "^{220}\\mathrm{Ra}",
    mass: 204938.9753351,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882200,
    name: "Ra220~",
    latex: "^{220}\\mathrm{\\overline{Ra}}",
    mass: 204938.9753351,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882210,
    name: "Ra221",
    latex: "^{221}\\mathrm{Ra}",
    mass: 205873.1605252,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882210,
    name: "Ra221~",
    latex: "^{221}\\mathrm{\\overline{Ra}}",
    mass: 205873.1605252,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882220,
    name: "Ra222",
    latex: "^{222}\\mathrm{Ra}",
    mass: 206806.0108844,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882220,
    name: "Ra222~",
    latex: "^{222}\\mathrm{\\overline{Ra}}",
    mass: 206806.0108844,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882230,
    name: "Ra223",
    latex: "^{223}\\mathrm{Ra}",
    mass: 207740.4183291,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882230,
    name: "Ra223~",
    latex: "^{223}\\mathrm{\\overline{Ra}}",
    mass: 207740.4183291,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882240,
    name: "Ra224",
    latex: "^{224}\\mathrm{Ra}",
    mass: 208673.5051014,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882240,
    name: "Ra224~",
    latex: "^{224}\\mathrm{\\overline{Ra}}",
    mass: 208673.5051014,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882250,
    name: "Ra225",
    latex: "^{225}\\mathrm{Ra}",
    mass: 209608.1663782,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882250,
    name: "Ra225~",
    latex: "^{225}\\mathrm{\\overline{Ra}}",
    mass: 209608.1663782,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882260,
    name: "Ra226",
    latex: "^{226}\\mathrm{Ra}",
    mass: 210541.3350289,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882260,
    name: "Ra226~",
    latex: "^{226}\\mathrm{\\overline{Ra}}",
    mass: 210541.3350289,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882270,
    name: "Ra227",
    latex: "^{227}\\mathrm{Ra}",
    mass: 211476.3390024,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882270,
    name: "Ra227~",
    latex: "^{227}\\mathrm{\\overline{Ra}}",
    mass: 211476.3390024,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882280,
    name: "Ra228",
    latex: "^{228}\\mathrm{Ra}",
    mass: 212409.5958655,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882280,
    name: "Ra228~",
    latex: "^{228}\\mathrm{\\overline{Ra}}",
    mass: 212409.5958655,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882290,
    name: "Ra229",
    latex: "^{229}\\mathrm{Ra}",
    mass: 213344.7119909,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882290,
    name: "Ra229~",
    latex: "^{229}\\mathrm{\\overline{Ra}}",
    mass: 213344.7119909,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882300,
    name: "Ra230",
    latex: "^{230}\\mathrm{Ra}",
    mass: 214278.1603693,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882300,
    name: "Ra230~",
    latex: "^{230}\\mathrm{\\overline{Ra}}",
    mass: 214278.1603693,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882310,
    name: "Ra231",
    latex: "^{231}\\mathrm{Ra}",
    mass: 215213.3543676,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882310,
    name: "Ra231~",
    latex: "^{231}\\mathrm{\\overline{Ra}}",
    mass: 215213.3543676,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882320,
    name: "Ra232",
    latex: "^{232}\\mathrm{Ra}",
    mass: 216147.1287689,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882320,
    name: "Ra232~",
    latex: "^{232}\\mathrm{\\overline{Ra}}",
    mass: 216147.1287689,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882330,
    name: "Ra233",
    latex: "^{233}\\mathrm{Ra}",
    mass: 217082.4606283,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882330,
    name: "Ra233~",
    latex: "^{233}\\mathrm{\\overline{Ra}}",
    mass: 217082.4606283,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000882340,
    name: "Ra234",
    latex: "^{234}\\mathrm{Ra}",
    mass: 218016.5508061,
    width: undefined,
    charge: 88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000882340,
    name: "Ra234~",
    latex: "^{234}\\mathrm{\\overline{Ra}}",
    mass: 218016.5508061,
    width: undefined,
    charge: -88.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892070,
    name: "Ac207",
    latex: "^{207}\\mathrm{Ac}",
    mass: 192830.4294542,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892070,
    name: "Ac207~",
    latex: "^{207}\\mathrm{\\overline{Ac}}",
    mass: 192830.4294542,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892080,
    name: "Ac208",
    latex: "^{208}\\mathrm{Ac}",
    mass: 193761.5323304,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892080,
    name: "Ac208~",
    latex: "^{208}\\mathrm{\\overline{Ac}}",
    mass: 193761.5323304,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892090,
    name: "Ac209",
    latex: "^{209}\\mathrm{Ac}",
    mass: 194691.1168712,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892090,
    name: "Ac209~",
    latex: "^{209}\\mathrm{\\overline{Ac}}",
    mass: 194691.1168712,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892100,
    name: "Ac210",
    latex: "^{210}\\mathrm{Ac}",
    mass: 195622.5271404,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892100,
    name: "Ac210~",
    latex: "^{210}\\mathrm{\\overline{Ac}}",
    mass: 195622.5271404,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892110,
    name: "Ac211",
    latex: "^{211}\\mathrm{Ac}",
    mass: 196552.4004444,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892110,
    name: "Ac211~",
    latex: "^{211}\\mathrm{\\overline{Ac}}",
    mass: 196552.4004444,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892120,
    name: "Ac212",
    latex: "^{212}\\mathrm{Ac}",
    mass: 197484.0491761,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892120,
    name: "Ac212~",
    latex: "^{212}\\mathrm{\\overline{Ac}}",
    mass: 197484.0491761,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892130,
    name: "Ac213",
    latex: "^{213}\\mathrm{Ac}",
    mass: 198414.3854327,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892130,
    name: "Ac213~",
    latex: "^{213}\\mathrm{\\overline{Ac}}",
    mass: 198414.3854327,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892140,
    name: "Ac214",
    latex: "^{214}\\mathrm{Ac}",
    mass: 199346.1710941,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892140,
    name: "Ac214~",
    latex: "^{214}\\mathrm{\\overline{Ac}}",
    mass: 199346.1710941,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892150,
    name: "Ac215",
    latex: "^{215}\\mathrm{Ac}",
    mass: 200277.2627923,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892150,
    name: "Ac215~",
    latex: "^{215}\\mathrm{\\overline{Ac}}",
    mass: 200277.2627923,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892160,
    name: "Ac216",
    latex: "^{216}\\mathrm{Ac}",
    mass: 201210.8760451,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892160,
    name: "Ac216~",
    latex: "^{216}\\mathrm{\\overline{Ac}}",
    mass: 201210.8760451,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892170,
    name: "Ac217",
    latex: "^{217}\\mathrm{Ac}",
    mass: 202142.9225248,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892170,
    name: "Ac217~",
    latex: "^{217}\\mathrm{\\overline{Ac}}",
    mass: 202142.9225248,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892180,
    name: "Ac218",
    latex: "^{218}\\mathrm{Ac}",
    mass: 203076.566517,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892180,
    name: "Ac218~",
    latex: "^{218}\\mathrm{\\overline{Ac}}",
    mass: 203076.566517,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892190,
    name: "Ac219",
    latex: "^{219}\\mathrm{Ac}",
    mass: 204008.7778711,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892190,
    name: "Ac219~",
    latex: "^{219}\\mathrm{\\overline{Ac}}",
    mass: 204008.7778711,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892200,
    name: "Ac220",
    latex: "^{220}\\mathrm{Ac}",
    mass: 204942.4470136,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892200,
    name: "Ac220~",
    latex: "^{220}\\mathrm{\\overline{Ac}}",
    mass: 204942.4470136,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892210,
    name: "Ac221",
    latex: "^{221}\\mathrm{Ac}",
    mass: 205874.7282298,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892210,
    name: "Ac221~",
    latex: "^{221}\\mathrm{\\overline{Ac}}",
    mass: 205874.7282298,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892220,
    name: "Ac222",
    latex: "^{222}\\mathrm{Ac}",
    mass: 206808.3126063,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892220,
    name: "Ac222~",
    latex: "^{222}\\mathrm{\\overline{Ac}}",
    mass: 206808.3126063,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892230,
    name: "Ac223",
    latex: "^{223}\\mathrm{Ac}",
    mass: 207741.0102004,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892230,
    name: "Ac223~",
    latex: "^{223}\\mathrm{\\overline{Ac}}",
    mass: 207741.0102004,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892240,
    name: "Ac224",
    latex: "^{224}\\mathrm{Ac}",
    mass: 208674.9131479,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892240,
    name: "Ac224~",
    latex: "^{224}\\mathrm{\\overline{Ac}}",
    mass: 208674.9131479,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892250,
    name: "Ac225",
    latex: "^{225}\\mathrm{Ac}",
    mass: 209607.8110132,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892250,
    name: "Ac225~",
    latex: "^{225}\\mathrm{\\overline{Ac}}",
    mass: 209607.8110132,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892260,
    name: "Ac226",
    latex: "^{226}\\mathrm{Ac}",
    mass: 210541.976642,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892260,
    name: "Ac226~",
    latex: "^{226}\\mathrm{\\overline{Ac}}",
    mass: 210541.976642,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892270,
    name: "Ac227",
    latex: "^{227}\\mathrm{Ac}",
    mass: 211475.0110644,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892270,
    name: "Ac227~",
    latex: "^{227}\\mathrm{\\overline{Ac}}",
    mass: 211475.0110644,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892280,
    name: "Ac228",
    latex: "^{228}\\mathrm{Ac}",
    mass: 212409.5503155,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892280,
    name: "Ac228~",
    latex: "^{228}\\mathrm{\\overline{Ac}}",
    mass: 212409.5503155,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892290,
    name: "Ac229",
    latex: "^{229}\\mathrm{Ac}",
    mass: 213342.8396878,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892290,
    name: "Ac229~",
    latex: "^{229}\\mathrm{\\overline{Ac}}",
    mass: 213342.8396878,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892300,
    name: "Ac230",
    latex: "^{230}\\mathrm{Ac}",
    mass: 214277.4822416,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892300,
    name: "Ac230~",
    latex: "^{230}\\mathrm{\\overline{Ac}}",
    mass: 214277.4822416,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892310,
    name: "Ac231",
    latex: "^{231}\\mathrm{Ac}",
    mass: 215210.9008121,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892310,
    name: "Ac231~",
    latex: "^{231}\\mathrm{\\overline{Ac}}",
    mass: 215210.9008121,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892320,
    name: "Ac232",
    latex: "^{232}\\mathrm{Ac}",
    mass: 216145.7864859,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892320,
    name: "Ac232~",
    latex: "^{232}\\mathrm{\\overline{Ac}}",
    mass: 216145.7864859,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892330,
    name: "Ac233",
    latex: "^{233}\\mathrm{Ac}",
    mass: 217079.434204,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892330,
    name: "Ac233~",
    latex: "^{233}\\mathrm{\\overline{Ac}}",
    mass: 217079.434204,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892340,
    name: "Ac234",
    latex: "^{234}\\mathrm{Ac}",
    mass: 218014.4614648,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892340,
    name: "Ac234~",
    latex: "^{234}\\mathrm{\\overline{Ac}}",
    mass: 218014.4614648,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892350,
    name: "Ac235",
    latex: "^{235}\\mathrm{Ac}",
    mass: 218948.4715341,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892350,
    name: "Ac235~",
    latex: "^{235}\\mathrm{\\overline{Ac}}",
    mass: 218948.4715341,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000892360,
    name: "Ac236",
    latex: "^{236}\\mathrm{Ac}",
    mass: 219883.8313383,
    width: undefined,
    charge: 89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000892360,
    name: "Ac236~",
    latex: "^{236}\\mathrm{\\overline{Ac}}",
    mass: 219883.8313383,
    width: undefined,
    charge: -89.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902100,
    name: "Th210",
    latex: "^{210}\\mathrm{Th}",
    mass: 195627.8217529,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902100,
    name: "Th210~",
    latex: "^{210}\\mathrm{\\overline{Th}}",
    mass: 195627.8217529,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902110,
    name: "Th211",
    latex: "^{211}\\mathrm{Th}",
    mass: 196559.1351468,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902110,
    name: "Th211~",
    latex: "^{211}\\mathrm{\\overline{Th}}",
    mass: 196559.1351468,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902120,
    name: "Th212",
    latex: "^{212}\\mathrm{Th}",
    mass: 197488.8612747,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902120,
    name: "Th212~",
    latex: "^{212}\\mathrm{\\overline{Th}}",
    mass: 197488.8612747,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902130,
    name: "Th213",
    latex: "^{213}\\mathrm{Th}",
    mass: 198420.3637618,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902130,
    name: "Th213~",
    latex: "^{213}\\mathrm{\\overline{Th}}",
    mass: 198420.3637618,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902140,
    name: "Th214",
    latex: "^{214}\\mathrm{Th}",
    mass: 199350.4326796,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902140,
    name: "Th214~",
    latex: "^{214}\\mathrm{\\overline{Th}}",
    mass: 199350.4326796,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902150,
    name: "Th215",
    latex: "^{215}\\mathrm{Th}",
    mass: 200282.1540679,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902150,
    name: "Th215~",
    latex: "^{215}\\mathrm{\\overline{Th}}",
    mass: 200282.1540679,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902160,
    name: "Th216",
    latex: "^{216}\\mathrm{Th}",
    mass: 201213.025002,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902160,
    name: "Th216~",
    latex: "^{216}\\mathrm{\\overline{Th}}",
    mass: 201213.025002,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902170,
    name: "Th217",
    latex: "^{217}\\mathrm{Th}",
    mass: 202146.4258742,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902170,
    name: "Th217~",
    latex: "^{217}\\mathrm{\\overline{Th}}",
    mass: 202146.4258742,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902180,
    name: "Th218",
    latex: "^{218}\\mathrm{Th}",
    mass: 203078.0811264,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902180,
    name: "Th218~",
    latex: "^{218}\\mathrm{\\overline{Th}}",
    mass: 203078.0811264,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902190,
    name: "Th219",
    latex: "^{219}\\mathrm{Th}",
    mass: 204011.6748178,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902190,
    name: "Th219~",
    latex: "^{219}\\mathrm{\\overline{Th}}",
    mass: 204011.6748178,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902200,
    name: "Th220",
    latex: "^{220}\\mathrm{Th}",
    mass: 204943.3924801,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902200,
    name: "Th220~",
    latex: "^{220}\\mathrm{\\overline{Th}}",
    mass: 204943.3924801,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902210,
    name: "Th221",
    latex: "^{221}\\mathrm{Th}",
    mass: 205877.1370736,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902210,
    name: "Th221~",
    latex: "^{221}\\mathrm{\\overline{Th}}",
    mass: 205877.1370736,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902220,
    name: "Th222",
    latex: "^{222}\\mathrm{Th}",
    mass: 206808.8938586,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902220,
    name: "Th222~",
    latex: "^{222}\\mathrm{\\overline{Th}}",
    mass: 206808.8938586,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902230,
    name: "Th223",
    latex: "^{223}\\mathrm{Th}",
    mass: 207742.570453,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902230,
    name: "Th223~",
    latex: "^{223}\\mathrm{\\overline{Th}}",
    mass: 207742.570453,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902240,
    name: "Th224",
    latex: "^{224}\\mathrm{Th}",
    mass: 208674.6746854,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902240,
    name: "Th224~",
    latex: "^{224}\\mathrm{\\overline{Th}}",
    mass: 208674.6746854,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902250,
    name: "Th225",
    latex: "^{225}\\mathrm{Th}",
    mass: 209608.483552,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902250,
    name: "Th225~",
    latex: "^{225}\\mathrm{\\overline{Th}}",
    mass: 209608.483552,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902260,
    name: "Th226",
    latex: "^{226}\\mathrm{Th}",
    mass: 210540.8653696,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902260,
    name: "Th226~",
    latex: "^{226}\\mathrm{\\overline{Th}}",
    mass: 210540.8653696,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902270,
    name: "Th227",
    latex: "^{227}\\mathrm{Th}",
    mass: 211474.9662595,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902270,
    name: "Th227~",
    latex: "^{227}\\mathrm{\\overline{Th}}",
    mass: 211474.9662595,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902280,
    name: "Th228",
    latex: "^{228}\\mathrm{Th}",
    mass: 212407.4265089,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902280,
    name: "Th228~",
    latex: "^{228}\\mathrm{\\overline{Th}}",
    mass: 212407.4265089,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902290,
    name: "Th229",
    latex: "^{229}\\mathrm{Th}",
    mass: 213341.7353084,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902290,
    name: "Th229~",
    latex: "^{229}\\mathrm{\\overline{Th}}",
    mass: 213341.7353084,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902300,
    name: "Th230",
    latex: "^{230}\\mathrm{Th}",
    mass: 214274.5063974,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902300,
    name: "Th230~",
    latex: "^{230}\\mathrm{\\overline{Th}}",
    mass: 214274.5063974,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902310,
    name: "Th231",
    latex: "^{231}\\mathrm{Th}",
    mass: 215208.9538031,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902310,
    name: "Th231~",
    latex: "^{231}\\mathrm{\\overline{Th}}",
    mass: 215208.9538031,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902320,
    name: "Th232",
    latex: "^{232}\\mathrm{Th}",
    mass: 216142.0787667,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902320,
    name: "Th232~",
    latex: "^{232}\\mathrm{\\overline{Th}}",
    mass: 216142.0787667,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902330,
    name: "Th233",
    latex: "^{233}\\mathrm{Th}",
    mass: 217076.8577844,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902330,
    name: "Th233~",
    latex: "^{233}\\mathrm{\\overline{Th}}",
    mass: 217076.8577844,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902340,
    name: "Th234",
    latex: "^{234}\\mathrm{Th}",
    mass: 218010.2332268,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902340,
    name: "Th234~",
    latex: "^{234}\\mathrm{\\overline{Th}}",
    mass: 218010.2332268,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902350,
    name: "Th235",
    latex: "^{235}\\mathrm{Th}",
    mass: 218945.1321277,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902350,
    name: "Th235~",
    latex: "^{235}\\mathrm{\\overline{Th}}",
    mass: 218945.1321277,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902360,
    name: "Th236",
    latex: "^{236}\\mathrm{Th}",
    mass: 219878.8636803,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902360,
    name: "Th236~",
    latex: "^{236}\\mathrm{\\overline{Th}}",
    mass: 219878.8636803,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902370,
    name: "Th237",
    latex: "^{237}\\mathrm{Th}",
    mass: 220814.0576786,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902370,
    name: "Th237~",
    latex: "^{237}\\mathrm{\\overline{Th}}",
    mass: 220814.0576786,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000902380,
    name: "Th238",
    latex: "^{238}\\mathrm{Th}",
    mass: 221748.1236375,
    width: undefined,
    charge: 90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000902380,
    name: "Th238~",
    latex: "^{238}\\mathrm{\\overline{Th}}",
    mass: 221748.1236375,
    width: undefined,
    charge: -90.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912130,
    name: "Pa213",
    latex: "^{213}\\mathrm{Pa}",
    mass: 198427.8986176,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912130,
    name: "Pa213~",
    latex: "^{213}\\mathrm{\\overline{Pa}}",
    mass: 198427.8986176,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912140,
    name: "Pa214",
    latex: "^{214}\\mathrm{Pa}",
    mass: 199359.1971076,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912140,
    name: "Pa214~",
    latex: "^{214}\\mathrm{\\overline{Pa}}",
    mass: 199359.1971076,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912150,
    name: "Pa215",
    latex: "^{215}\\mathrm{Pa}",
    mass: 200289.0331518,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912150,
    name: "Pa215~",
    latex: "^{215}\\mathrm{\\overline{Pa}}",
    mass: 200289.0331518,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912160,
    name: "Pa216",
    latex: "^{216}\\mathrm{Pa}",
    mass: 201220.5505429,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912160,
    name: "Pa216~",
    latex: "^{216}\\mathrm{\\overline{Pa}}",
    mass: 201220.5505429,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912170,
    name: "Pa217",
    latex: "^{217}\\mathrm{Pa}",
    mass: 202151.2752325,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912170,
    name: "Pa217~",
    latex: "^{217}\\mathrm{\\overline{Pa}}",
    mass: 202151.2752325,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912180,
    name: "Pa218",
    latex: "^{218}\\mathrm{Pa}",
    mass: 203084.3640541,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912180,
    name: "Pa218~",
    latex: "^{218}\\mathrm{\\overline{Pa}}",
    mass: 203084.3640541,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912190,
    name: "Pa219",
    latex: "^{219}\\mathrm{Pa}",
    mass: 204015.7920217,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912190,
    name: "Pa219~",
    latex: "^{219}\\mathrm{\\overline{Pa}}",
    mass: 204015.7920217,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912200,
    name: "Pa220",
    latex: "^{220}\\mathrm{Pa}",
    mass: 204948.9814447,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912200,
    name: "Pa220~",
    latex: "^{220}\\mathrm{\\overline{Pa}}",
    mass: 204948.9814447,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912210,
    name: "Pa221",
    latex: "^{221}\\mathrm{Pa}",
    mass: 205880.5686979,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912210,
    name: "Pa221~",
    latex: "^{221}\\mathrm{\\overline{Pa}}",
    mass: 205880.5686979,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912220,
    name: "Pa222",
    latex: "^{222}\\mathrm{Pa}",
    mass: 206813.7581208,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912220,
    name: "Pa222~",
    latex: "^{222}\\mathrm{\\overline{Pa}}",
    mass: 206813.7581208,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912230,
    name: "Pa223",
    latex: "^{223}\\mathrm{Pa}",
    mass: 207745.5223578,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912230,
    name: "Pa223~",
    latex: "^{223}\\mathrm{\\overline{Pa}}",
    mass: 207745.5223578,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912240,
    name: "Pa224",
    latex: "^{224}\\mathrm{Pa}",
    mass: 208678.5413174,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912240,
    name: "Pa224~",
    latex: "^{224}\\mathrm{\\overline{Pa}}",
    mass: 208678.5413174,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912250,
    name: "Pa225",
    latex: "^{225}\\mathrm{Pa}",
    mass: 209610.5319075,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912250,
    name: "Pa225~",
    latex: "^{225}\\mathrm{\\overline{Pa}}",
    mass: 209610.5319075,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912260,
    name: "Pa226",
    latex: "^{226}\\mathrm{Pa}",
    mass: 210543.7008376,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912260,
    name: "Pa226~",
    latex: "^{226}\\mathrm{\\overline{Pa}}",
    mass: 210543.7008376,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912270,
    name: "Pa227",
    latex: "^{227}\\mathrm{Pa}",
    mass: 211475.9923003,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912270,
    name: "Pa227~",
    latex: "^{227}\\mathrm{\\overline{Pa}}",
    mass: 211475.9923003,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912280,
    name: "Pa228",
    latex: "^{228}\\mathrm{Pa}",
    mass: 212409.5794712,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912280,
    name: "Pa228~",
    latex: "^{228}\\mathrm{\\overline{Pa}}",
    mass: 212409.5794712,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912290,
    name: "Pa229",
    latex: "^{229}\\mathrm{Pa}",
    mass: 213342.0469863,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912290,
    name: "Pa229~",
    latex: "^{229}\\mathrm{\\overline{Pa}}",
    mass: 213342.0469863,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912300,
    name: "Pa230",
    latex: "^{230}\\mathrm{Pa}",
    mass: 214275.8176616,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912300,
    name: "Pa230~",
    latex: "^{230}\\mathrm{\\overline{Pa}}",
    mass: 214275.8176616,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912310,
    name: "Pa231",
    latex: "^{231}\\mathrm{Pa}",
    mass: 215208.5622962,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912310,
    name: "Pa231~",
    latex: "^{231}\\mathrm{\\overline{Pa}}",
    mass: 215208.5622962,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912320,
    name: "Pa232",
    latex: "^{232}\\mathrm{Pa}",
    mass: 216142.5784202,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912320,
    name: "Pa232~",
    latex: "^{232}\\mathrm{\\overline{Pa}}",
    mass: 216142.5784202,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912330,
    name: "Pa233",
    latex: "^{233}\\mathrm{Pa}",
    mass: 217075.6155439,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912330,
    name: "Pa233~",
    latex: "^{233}\\mathrm{\\overline{Pa}}",
    mass: 217075.6155439,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912340,
    name: "Pa234",
    latex: "^{234}\\mathrm{Pa}",
    mass: 218009.9595538,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912340,
    name: "Pa234~",
    latex: "^{234}\\mathrm{\\overline{Pa}}",
    mass: 218009.9595538,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912350,
    name: "Pa235",
    latex: "^{235}\\mathrm{Pa}",
    mass: 218943.4032747,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912350,
    name: "Pa235~",
    latex: "^{235}\\mathrm{\\overline{Pa}}",
    mass: 218943.4032747,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912360,
    name: "Pa236",
    latex: "^{236}\\mathrm{Pa}",
    mass: 219877.9424326,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912360,
    name: "Pa236~",
    latex: "^{236}\\mathrm{\\overline{Pa}}",
    mass: 219877.9424326,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912370,
    name: "Pa237",
    latex: "^{237}\\mathrm{Pa}",
    mass: 220811.630205,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912370,
    name: "Pa237~",
    latex: "^{237}\\mathrm{\\overline{Pa}}",
    mass: 220811.630205,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912380,
    name: "Pa238",
    latex: "^{238}\\mathrm{Pa}",
    mass: 221746.4907284,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912380,
    name: "Pa238~",
    latex: "^{238}\\mathrm{\\overline{Pa}}",
    mass: 221746.4907284,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912390,
    name: "Pa239",
    latex: "^{239}\\mathrm{Pa}",
    mass: 222680.4281411,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912390,
    name: "Pa239~",
    latex: "^{239}\\mathrm{\\overline{Pa}}",
    mass: 222680.4281411,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000912400,
    name: "Pa240",
    latex: "^{240}\\mathrm{Pa}",
    mass: 223615.5923316,
    width: undefined,
    charge: 91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000912400,
    name: "Pa240~",
    latex: "^{240}\\mathrm{\\overline{Pa}}",
    mass: 223615.5923316,
    width: undefined,
    charge: -91.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922180,
    name: "U218",
    latex: "^{218}\\mathrm{U}",
    mass: 203087.6093796,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922180,
    name: "U218~",
    latex: "^{218}\\mathrm{\\overline{U}}",
    mass: 203087.6093796,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922190,
    name: "U219",
    latex: "^{219}\\mathrm{U}",
    mass: 204020.5044504,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922190,
    name: "U219~",
    latex: "^{219}\\mathrm{\\overline{U}}",
    mass: 204020.5044504,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922200,
    name: "U220",
    latex: "^{220}\\mathrm{U}",
    mass: 204951.7200374,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922200,
    name: "U220~",
    latex: "^{220}\\mathrm{\\overline{U}}",
    mass: 204951.7200374,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922210,
    name: "U221",
    latex: "^{221}\\mathrm{U}",
    mass: 205884.7138466,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922210,
    name: "U221~",
    latex: "^{221}\\mathrm{\\overline{U}}",
    mass: 205884.7138466,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922220,
    name: "U222",
    latex: "^{222}\\mathrm{U}",
    mass: 206815.9657619,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922220,
    name: "U222~",
    latex: "^{222}\\mathrm{\\overline{U}}",
    mass: 206815.9657619,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922230,
    name: "U223",
    latex: "^{223}\\mathrm{U}",
    mass: 207749.2297044,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922230,
    name: "U223~",
    latex: "^{223}\\mathrm{\\overline{U}}",
    mass: 207749.2297044,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922240,
    name: "U224",
    latex: "^{224}\\mathrm{U}",
    mass: 208680.422004,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922240,
    name: "U224~",
    latex: "^{224}\\mathrm{\\overline{U}}",
    mass: 208680.422004,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922250,
    name: "U225",
    latex: "^{225}\\mathrm{U}",
    mass: 209613.5452909,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922250,
    name: "U225~",
    latex: "^{225}\\mathrm{\\overline{U}}",
    mass: 209613.5452909,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922260,
    name: "U226",
    latex: "^{226}\\mathrm{U}",
    mass: 210544.9965459,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922260,
    name: "U226~",
    latex: "^{226}\\mathrm{\\overline{U}}",
    mass: 210544.9965459,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922270,
    name: "U227",
    latex: "^{227}\\mathrm{U}",
    mass: 211478.2064618,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922270,
    name: "U227~",
    latex: "^{227}\\mathrm{\\overline{U}}",
    mass: 211478.2064618,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922280,
    name: "U228",
    latex: "^{228}\\mathrm{U}",
    mass: 212409.8756864,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922280,
    name: "U228~",
    latex: "^{228}\\mathrm{\\overline{U}}",
    mass: 212409.8756864,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922290,
    name: "U229",
    latex: "^{229}\\mathrm{U}",
    mass: 213343.360393,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922290,
    name: "U229~",
    latex: "^{229}\\mathrm{\\overline{U}}",
    mass: 213343.360393,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922300,
    name: "U230",
    latex: "^{230}\\mathrm{U}",
    mass: 214275.2587652,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922300,
    name: "U230~",
    latex: "^{230}\\mathrm{\\overline{U}}",
    mass: 214275.2587652,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922310,
    name: "U231",
    latex: "^{231}\\mathrm{U}",
    mass: 215208.9439293,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922310,
    name: "U231~",
    latex: "^{231}\\mathrm{\\overline{U}}",
    mass: 215208.9439293,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922320,
    name: "U232",
    latex: "^{232}\\mathrm{U}",
    mass: 216141.2415398,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922320,
    name: "U232~",
    latex: "^{232}\\mathrm{\\overline{U}}",
    mass: 216141.2415398,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922330,
    name: "U233",
    latex: "^{233}\\mathrm{U}",
    mass: 217075.0452832,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922330,
    name: "U233~",
    latex: "^{233}\\mathrm{\\overline{U}}",
    mass: 217075.0452832,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922340,
    name: "U234",
    latex: "^{234}\\mathrm{U}",
    mass: 218007.7652331,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922340,
    name: "U234~",
    latex: "^{234}\\mathrm{\\overline{U}}",
    mass: 218007.7652331,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922350,
    name: "U235",
    latex: "^{235}\\mathrm{U}",
    mass: 218942.03314,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922350,
    name: "U235~",
    latex: "^{235}\\mathrm{\\overline{U}}",
    mass: 218942.03314,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922360,
    name: "U236",
    latex: "^{236}\\mathrm{U}",
    mass: 219875.0530311,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922360,
    name: "U236~",
    latex: "^{236}\\mathrm{\\overline{U}}",
    mass: 219875.0530311,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922370,
    name: "U237",
    latex: "^{237}\\mathrm{U}",
    mass: 220809.4927054,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922370,
    name: "U237~",
    latex: "^{237}\\mathrm{\\overline{U}}",
    mass: 220809.4927054,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922380,
    name: "U238",
    latex: "^{238}\\mathrm{U}",
    mass: 221742.9043829,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922380,
    name: "U238~",
    latex: "^{238}\\mathrm{\\overline{U}}",
    mass: 221742.9043829,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922390,
    name: "U239",
    latex: "^{239}\\mathrm{U}",
    mass: 222677.6634666,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922390,
    name: "U239~",
    latex: "^{239}\\mathrm{\\overline{U}}",
    mass: 222677.6634666,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922400,
    name: "U240",
    latex: "^{240}\\mathrm{U}",
    mass: 223611.3003794,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922400,
    name: "U240~",
    latex: "^{240}\\mathrm{\\overline{U}}",
    mass: 223611.3003794,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922410,
    name: "U241",
    latex: "^{241}\\mathrm{U}",
    mass: 224546.2760355,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922410,
    name: "U241~",
    latex: "^{241}\\mathrm{\\overline{U}}",
    mass: 224546.2760355,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000922420,
    name: "U242",
    latex: "^{242}\\mathrm{U}",
    mass: 225480.1920238,
    width: undefined,
    charge: 92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000922420,
    name: "U242~",
    latex: "^{242}\\mathrm{\\overline{U}}",
    mass: 225480.1920238,
    width: undefined,
    charge: -92.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932250,
    name: "Np225",
    latex: "^{225}\\mathrm{Np}",
    mass: 209617.7882466,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932250,
    name: "Np225~",
    latex: "^{225}\\mathrm{\\overline{Np}}",
    mass: 209617.7882466,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932260,
    name: "Np226",
    latex: "^{226}\\mathrm{Np}",
    mass: 210550.4839777,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932260,
    name: "Np226~",
    latex: "^{226}\\mathrm{\\overline{Np}}",
    mass: 210550.4839777,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932270,
    name: "Np227",
    latex: "^{227}\\mathrm{Np}",
    mass: 211481.7452079,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932270,
    name: "Np227~",
    latex: "^{227}\\mathrm{\\overline{Np}}",
    mass: 211481.7452079,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932280,
    name: "Np228",
    latex: "^{228}\\mathrm{Np}",
    mass: 212414.4781987,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932280,
    name: "Np228~",
    latex: "^{228}\\mathrm{\\overline{Np}}",
    mass: 212414.4781987,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932290,
    name: "Np229",
    latex: "^{229}\\mathrm{Np}",
    mass: 213345.9536726,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932290,
    name: "Np229~",
    latex: "^{229}\\mathrm{\\overline{Np}}",
    mass: 213345.9536726,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932300,
    name: "Np230",
    latex: "^{230}\\mathrm{Np}",
    mass: 214278.8822772,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932300,
    name: "Np230~",
    latex: "^{230}\\mathrm{\\overline{Np}}",
    mass: 214278.8822772,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932310,
    name: "Np231",
    latex: "^{231}\\mathrm{Np}",
    mass: 215210.7582935,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932310,
    name: "Np231~",
    latex: "^{231}\\mathrm{\\overline{Np}}",
    mass: 215210.7582935,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932320,
    name: "Np232",
    latex: "^{232}\\mathrm{Np}",
    mass: 216143.9942912,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932320,
    name: "Np232~",
    latex: "^{232}\\mathrm{\\overline{Np}}",
    mass: 216143.9942912,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932330,
    name: "Np233",
    latex: "^{233}\\mathrm{Np}",
    mass: 217076.0752362,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932330,
    name: "Np233~",
    latex: "^{233}\\mathrm{\\overline{Np}}",
    mass: 217076.0752362,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932340,
    name: "Np234",
    latex: "^{234}\\mathrm{Np}",
    mass: 218009.5748467,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932340,
    name: "Np234~",
    latex: "^{234}\\mathrm{\\overline{Np}}",
    mass: 218009.5748467,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932350,
    name: "Np235",
    latex: "^{235}\\mathrm{Np}",
    mass: 218942.1574013,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932350,
    name: "Np235~",
    latex: "^{235}\\mathrm{\\overline{Np}}",
    mass: 218942.1574013,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932360,
    name: "Np236",
    latex: "^{236}\\mathrm{Np}",
    mass: 219875.988158,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932360,
    name: "Np236~",
    latex: "^{236}\\mathrm{\\overline{Np}}",
    mass: 219875.988158,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932370,
    name: "Np237",
    latex: "^{237}\\mathrm{Np}",
    mass: 220808.9741427,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932370,
    name: "Np237~",
    latex: "^{237}\\mathrm{\\overline{Np}}",
    mass: 220808.9741427,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932380,
    name: "Np238",
    latex: "^{238}\\mathrm{Np}",
    mass: 221743.0512795,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932380,
    name: "Np238~",
    latex: "^{238}\\mathrm{\\overline{Np}}",
    mass: 221743.0512795,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932390,
    name: "Np239",
    latex: "^{239}\\mathrm{Np}",
    mass: 222676.4017579,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932390,
    name: "Np239~",
    latex: "^{239}\\mathrm{\\overline{Np}}",
    mass: 222676.4017579,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932400,
    name: "Np240",
    latex: "^{240}\\mathrm{Np}",
    mass: 223610.9013273,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932400,
    name: "Np240~",
    latex: "^{240}\\mathrm{\\overline{Np}}",
    mass: 223610.9013273,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932410,
    name: "Np241",
    latex: "^{241}\\mathrm{Np}",
    mass: 224544.3944174,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932410,
    name: "Np241~",
    latex: "^{241}\\mathrm{\\overline{Np}}",
    mass: 224544.3944174,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932420,
    name: "Np242",
    latex: "^{242}\\mathrm{Np}",
    mass: 225478.9903964,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932420,
    name: "Np242~",
    latex: "^{242}\\mathrm{\\overline{Np}}",
    mass: 225478.9903964,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932430,
    name: "Np243",
    latex: "^{243}\\mathrm{Np}",
    mass: 226412.8691251,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932430,
    name: "Np243~",
    latex: "^{243}\\mathrm{\\overline{Np}}",
    mass: 226412.8691251,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000932440,
    name: "Np244",
    latex: "^{244}\\mathrm{Np}",
    mass: 227347.800442,
    width: undefined,
    charge: 93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000932440,
    name: "Np244~",
    latex: "^{244}\\mathrm{\\overline{Np}}",
    mass: 227347.800442,
    width: undefined,
    charge: -93.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942280,
    name: "Pu228",
    latex: "^{228}\\mathrm{Pu}",
    mass: 212416.7631538,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942280,
    name: "Pu228~",
    latex: "^{228}\\mathrm{\\overline{Pu}}",
    mass: 212416.7631538,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942290,
    name: "Pu229",
    latex: "^{229}\\mathrm{Pu}",
    mass: 213349.5492398,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942290,
    name: "Pu229~",
    latex: "^{229}\\mathrm{\\overline{Pu}}",
    mass: 213349.5492398,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942300,
    name: "Pu230",
    latex: "^{230}\\mathrm{Pu}",
    mass: 214280.5757335,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942300,
    name: "Pu230~",
    latex: "^{230}\\mathrm{\\overline{Pu}}",
    mass: 214280.5757335,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942310,
    name: "Pu231",
    latex: "^{231}\\mathrm{Pu}",
    mass: 215213.4465855,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942310,
    name: "Pu231~",
    latex: "^{231}\\mathrm{\\overline{Pu}}",
    mass: 215213.4465855,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942320,
    name: "Pu232",
    latex: "^{232}\\mathrm{Pu}",
    mass: 216144.9928529,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942320,
    name: "Pu232~",
    latex: "^{232}\\mathrm{\\overline{Pu}}",
    mass: 216144.9928529,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942330,
    name: "Pu233",
    latex: "^{233}\\mathrm{Pu}",
    mass: 217078.1804129,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942330,
    name: "Pu233~",
    latex: "^{233}\\mathrm{\\overline{Pu}}",
    mass: 217078.1804129,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942340,
    name: "Pu234",
    latex: "^{234}\\mathrm{Pu}",
    mass: 218009.9698002,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942340,
    name: "Pu234~",
    latex: "^{234}\\mathrm{\\overline{Pu}}",
    mass: 218009.9698002,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942350,
    name: "Pu235",
    latex: "^{235}\\mathrm{Pu}",
    mass: 218943.2970844,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942350,
    name: "Pu235~",
    latex: "^{235}\\mathrm{\\overline{Pu}}",
    mass: 218943.2970844,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942360,
    name: "Pu236",
    latex: "^{236}\\mathrm{Pu}",
    mass: 219875.5100221,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942360,
    name: "Pu236~",
    latex: "^{236}\\mathrm{\\overline{Pu}}",
    mass: 219875.5100221,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942370,
    name: "Pu237",
    latex: "^{237}\\mathrm{Pu}",
    mass: 220809.1942547,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942370,
    name: "Pu237~",
    latex: "^{237}\\mathrm{\\overline{Pu}}",
    mass: 220809.1942547,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942380,
    name: "Pu238",
    latex: "^{238}\\mathrm{Pu}",
    mass: 221741.7598561,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942380,
    name: "Pu238~",
    latex: "^{238}\\mathrm{\\overline{Pu}}",
    mass: 221741.7598561,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942390,
    name: "Pu239",
    latex: "^{239}\\mathrm{Pu}",
    mass: 222675.6790116,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942390,
    name: "Pu239~",
    latex: "^{239}\\mathrm{\\overline{Pu}}",
    mass: 222675.6790116,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942400,
    name: "Pu240",
    latex: "^{240}\\mathrm{Pu}",
    mass: 223608.7101737,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942400,
    name: "Pu240~",
    latex: "^{240}\\mathrm{\\overline{Pu}}",
    mass: 223608.7101737,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942410,
    name: "Pu241",
    latex: "^{241}\\mathrm{Pu}",
    mass: 224543.0341565,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942410,
    name: "Pu241~",
    latex: "^{241}\\mathrm{\\overline{Pu}}",
    mass: 224543.0341565,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942420,
    name: "Pu242",
    latex: "^{242}\\mathrm{Pu}",
    mass: 225476.289995,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942420,
    name: "Pu242~",
    latex: "^{242}\\mathrm{\\overline{Pu}}",
    mass: 225476.289995,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942430,
    name: "Pu243",
    latex: "^{243}\\mathrm{Pu}",
    mass: 226410.8217942,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942430,
    name: "Pu243~",
    latex: "^{243}\\mathrm{\\overline{Pu}}",
    mass: 226410.8217942,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942440,
    name: "Pu244",
    latex: "^{244}\\mathrm{Pu}",
    mass: 227344.3673274,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942440,
    name: "Pu244~",
    latex: "^{244}\\mathrm{\\overline{Pu}}",
    mass: 227344.3673274,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942450,
    name: "Pu245",
    latex: "^{245}\\mathrm{Pu}",
    mass: 228279.2339986,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942450,
    name: "Pu245~",
    latex: "^{245}\\mathrm{\\overline{Pu}}",
    mass: 228279.2339986,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942460,
    name: "Pu246",
    latex: "^{246}\\mathrm{Pu}",
    mass: 229212.9441268,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942460,
    name: "Pu246~",
    latex: "^{246}\\mathrm{\\overline{Pu}}",
    mass: 229212.9441268,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000942470,
    name: "Pu247",
    latex: "^{247}\\mathrm{Pu}",
    mass: 230148.2536304,
    width: undefined,
    charge: 94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000942470,
    name: "Pu247~",
    latex: "^{247}\\mathrm{\\overline{Pu}}",
    mass: 230148.2536304,
    width: undefined,
    charge: -94.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952310,
    name: "Am231",
    latex: "^{231}\\mathrm{Am}",
    mass: 215217.5488855,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952310,
    name: "Am231~",
    latex: "^{231}\\mathrm{\\overline{Am}}",
    mass: 215217.5488855,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952320,
    name: "Am232",
    latex: "^{232}\\mathrm{Am}",
    mass: 216150.0490029,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952320,
    name: "Am232~",
    latex: "^{232}\\mathrm{\\overline{Am}}",
    mass: 216150.0490029,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952330,
    name: "Am233",
    latex: "^{233}\\mathrm{Am}",
    mass: 217081.4126974,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952330,
    name: "Am233~",
    latex: "^{233}\\mathrm{\\overline{Am}}",
    mass: 217081.4126974,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952340,
    name: "Am234",
    latex: "^{234}\\mathrm{Am}",
    mass: 218014.0804837,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952340,
    name: "Am234~",
    latex: "^{234}\\mathrm{\\overline{Am}}",
    mass: 218014.0804837,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952350,
    name: "Am235",
    latex: "^{235}\\mathrm{Am}",
    mass: 218945.7422564,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952350,
    name: "Am235~",
    latex: "^{235}\\mathrm{\\overline{Am}}",
    mass: 218945.7422564,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952360,
    name: "Am236",
    latex: "^{236}\\mathrm{Am}",
    mass: 219878.6522311,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952360,
    name: "Am236~",
    latex: "^{236}\\mathrm{\\overline{Am}}",
    mass: 219878.6522311,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952370,
    name: "Am237",
    latex: "^{237}\\mathrm{Am}",
    mass: 220810.6772865,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952370,
    name: "Am237~",
    latex: "^{237}\\mathrm{\\overline{Am}}",
    mass: 220810.6772865,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952380,
    name: "Am238",
    latex: "^{238}\\mathrm{Am}",
    mass: 221744.0157485,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952380,
    name: "Am238~",
    latex: "^{238}\\mathrm{\\overline{Am}}",
    mass: 221744.0157485,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952390,
    name: "Am239",
    latex: "^{239}\\mathrm{Am}",
    mass: 222676.4811212,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952390,
    name: "Am239~",
    latex: "^{239}\\mathrm{\\overline{Am}}",
    mass: 222676.4811212,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952400,
    name: "Am240",
    latex: "^{240}\\mathrm{Am}",
    mass: 223610.0946534,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952400,
    name: "Am240~",
    latex: "^{240}\\mathrm{\\overline{Am}}",
    mass: 223610.0946534,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952410,
    name: "Am241",
    latex: "^{241}\\mathrm{Am}",
    mass: 224543.0132911,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952410,
    name: "Am241~",
    latex: "^{241}\\mathrm{\\overline{Am}}",
    mass: 224543.0132911,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952420,
    name: "Am242",
    latex: "^{242}\\mathrm{Am}",
    mass: 225477.0411519,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952420,
    name: "Am242~",
    latex: "^{242}\\mathrm{\\overline{Am}}",
    mass: 225477.0411519,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952430,
    name: "Am243",
    latex: "^{243}\\mathrm{Am}",
    mass: 226410.2422185,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952430,
    name: "Am243~",
    latex: "^{243}\\mathrm{\\overline{Am}}",
    mass: 226410.2422185,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952440,
    name: "Am244",
    latex: "^{244}\\mathrm{Am}",
    mass: 227344.4404497,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952440,
    name: "Am244~",
    latex: "^{244}\\mathrm{\\overline{Am}}",
    mass: 227344.4404497,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952450,
    name: "Am245",
    latex: "^{245}\\mathrm{Am}",
    mass: 228277.9558024,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952450,
    name: "Am245~",
    latex: "^{245}\\mathrm{\\overline{Am}}",
    mass: 228277.9558024,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952460,
    name: "Am246",
    latex: "^{246}\\mathrm{Am}",
    mass: 229212.5435844,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952460,
    name: "Am246~",
    latex: "^{246}\\mathrm{\\overline{Am}}",
    mass: 229212.5435844,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952470,
    name: "Am247",
    latex: "^{247}\\mathrm{Am}",
    mass: 230146.1950284,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952470,
    name: "Am247~",
    latex: "^{247}\\mathrm{\\overline{Am}}",
    mass: 230146.1950284,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952480,
    name: "Am248",
    latex: "^{248}\\mathrm{Am}",
    mass: 231081.0984006,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952480,
    name: "Am248~",
    latex: "^{248}\\mathrm{\\overline{Am}}",
    mass: 231081.0984006,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000952490,
    name: "Am249",
    latex: "^{249}\\mathrm{Am}",
    mass: 232015.1354832,
    width: undefined,
    charge: 95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000952490,
    name: "Am249~",
    latex: "^{249}\\mathrm{\\overline{Am}}",
    mass: 232015.1354832,
    width: undefined,
    charge: -95.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962330,
    name: "Cm233",
    latex: "^{233}\\mathrm{Cm}",
    mass: 217085.4181221,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962330,
    name: "Cm233~",
    latex: "^{233}\\mathrm{\\overline{Cm}}",
    mass: 217085.4181221,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962340,
    name: "Cm234",
    latex: "^{234}\\mathrm{Cm}",
    mass: 218016.3430829,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962340,
    name: "Cm234~",
    latex: "^{234}\\mathrm{\\overline{Cm}}",
    mass: 218016.3430829,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962350,
    name: "Cm235",
    latex: "^{235}\\mathrm{Cm}",
    mass: 218949.1328949,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962350,
    name: "Cm235~",
    latex: "^{235}\\mathrm{\\overline{Cm}}",
    mass: 218949.1328949,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962360,
    name: "Cm236",
    latex: "^{236}\\mathrm{Cm}",
    mass: 219880.4611927,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962360,
    name: "Cm236~",
    latex: "^{236}\\mathrm{\\overline{Cm}}",
    mass: 219880.4611927,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962370,
    name: "Cm237",
    latex: "^{237}\\mathrm{Cm}",
    mass: 220813.3506746,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962370,
    name: "Cm237~",
    latex: "^{237}\\mathrm{\\overline{Cm}}",
    mass: 220813.3506746,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962380,
    name: "Cm238",
    latex: "^{238}\\mathrm{Cm}",
    mass: 221745.042255,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962380,
    name: "Cm238~",
    latex: "^{238}\\mathrm{\\overline{Cm}}",
    mass: 221745.042255,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962390,
    name: "Cm239",
    latex: "^{239}\\mathrm{Cm}",
    mass: 222678.23913,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962390,
    name: "Cm239~",
    latex: "^{239}\\mathrm{\\overline{Cm}}",
    mass: 222678.23913,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962400,
    name: "Cm240",
    latex: "^{240}\\mathrm{Cm}",
    mass: 223610.3090833,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962400,
    name: "Cm240~",
    latex: "^{240}\\mathrm{\\overline{Cm}}",
    mass: 223610.3090833,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962410,
    name: "Cm241",
    latex: "^{241}\\mathrm{Cm}",
    mass: 224543.780749,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962410,
    name: "Cm241~",
    latex: "^{241}\\mathrm{\\overline{Cm}}",
    mass: 224543.780749,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962420,
    name: "Cm242",
    latex: "^{242}\\mathrm{Cm}",
    mass: 225476.3768103,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962420,
    name: "Cm242~",
    latex: "^{242}\\mathrm{\\overline{Cm}}",
    mass: 225476.3768103,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962430,
    name: "Cm243",
    latex: "^{243}\\mathrm{Cm}",
    mass: 226410.2491116,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962430,
    name: "Cm243~",
    latex: "^{243}\\mathrm{\\overline{Cm}}",
    mass: 226410.2491116,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962440,
    name: "Cm244",
    latex: "^{244}\\mathrm{Cm}",
    mass: 227343.0131212,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962440,
    name: "Cm244~",
    latex: "^{244}\\mathrm{\\overline{Cm}}",
    mass: 227343.0131212,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962450,
    name: "Cm245",
    latex: "^{245}\\mathrm{Cm}",
    mass: 228277.0598914,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962450,
    name: "Cm245~",
    latex: "^{245}\\mathrm{\\overline{Cm}}",
    mass: 228277.0598914,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962460,
    name: "Cm246",
    latex: "^{246}\\mathrm{Cm}",
    mass: 229210.1664114,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962460,
    name: "Cm246~",
    latex: "^{246}\\mathrm{\\overline{Cm}}",
    mass: 229210.1664114,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962470,
    name: "Cm247",
    latex: "^{247}\\mathrm{Cm}",
    mass: 230144.5770232,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962470,
    name: "Cm247~",
    latex: "^{247}\\mathrm{\\overline{Cm}}",
    mass: 230144.5770232,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962480,
    name: "Cm248",
    latex: "^{248}\\mathrm{Cm}",
    mass: 231077.9304823,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962480,
    name: "Cm248~",
    latex: "^{248}\\mathrm{\\overline{Cm}}",
    mass: 231077.9304823,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962490,
    name: "Cm249",
    latex: "^{249}\\mathrm{Cm}",
    mass: 232012.7825291,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962490,
    name: "Cm249~",
    latex: "^{249}\\mathrm{\\overline{Cm}}",
    mass: 232012.7825291,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962500,
    name: "Cm250",
    latex: "^{250}\\mathrm{Cm}",
    mass: 232946.5159446,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962500,
    name: "Cm250~",
    latex: "^{250}\\mathrm{\\overline{Cm}}",
    mass: 232946.5159446,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962510,
    name: "Cm251",
    latex: "^{251}\\mathrm{Cm}",
    mass: 233881.6680257,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962510,
    name: "Cm251~",
    latex: "^{251}\\mathrm{\\overline{Cm}}",
    mass: 233881.6680257,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000962520,
    name: "Cm252",
    latex: "^{252}\\mathrm{Cm}",
    mass: 234815.5700417,
    width: undefined,
    charge: 96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000962520,
    name: "Cm252~",
    latex: "^{252}\\mathrm{\\overline{Cm}}",
    mass: 234815.5700417,
    width: undefined,
    charge: -96.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972350,
    name: "Bk235",
    latex: "^{235}\\mathrm{Bk}",
    mass: 218953.8835148,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972350,
    name: "Bk235~",
    latex: "^{235}\\mathrm{\\overline{Bk}}",
    mass: 218953.8835148,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972360,
    name: "Bk236",
    latex: "^{236}\\mathrm{Bk}",
    mass: 219886.1507587,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972360,
    name: "Bk236~",
    latex: "^{236}\\mathrm{\\overline{Bk}}",
    mass: 219886.1507587,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972370,
    name: "Bk237",
    latex: "^{237}\\mathrm{Bk}",
    mass: 220817.3095245,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972370,
    name: "Bk237~",
    latex: "^{237}\\mathrm{\\overline{Bk}}",
    mass: 220817.3095245,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972380,
    name: "Bk238",
    latex: "^{238}\\mathrm{Bk}",
    mass: 221749.8096419,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972380,
    name: "Bk238~",
    latex: "^{238}\\mathrm{\\overline{Bk}}",
    mass: 221749.8096419,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972390,
    name: "Bk239",
    latex: "^{239}\\mathrm{Bk}",
    mass: 222681.3410053,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972390,
    name: "Bk239~",
    latex: "^{239}\\mathrm{\\overline{Bk}}",
    mass: 222681.3410053,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972400,
    name: "Bk240",
    latex: "^{240}\\mathrm{Bk}",
    mass: 223614.2509801,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972400,
    name: "Bk240~",
    latex: "^{240}\\mathrm{\\overline{Bk}}",
    mass: 223614.2509801,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972410,
    name: "Bk241",
    latex: "^{241}\\mathrm{Bk}",
    mass: 224546.0617918,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972410,
    name: "Bk241~",
    latex: "^{241}\\mathrm{\\overline{Bk}}",
    mass: 224546.0617918,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972420,
    name: "Bk242",
    latex: "^{242}\\mathrm{Bk}",
    mass: 225479.3257343,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972420,
    name: "Bk242~",
    latex: "^{242}\\mathrm{\\overline{Bk}}",
    mass: 225479.3257343,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972430,
    name: "Bk243",
    latex: "^{243}\\mathrm{Bk}",
    mass: 226411.7569211,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972430,
    name: "Bk243~",
    latex: "^{243}\\mathrm{\\overline{Bk}}",
    mass: 226411.7569211,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972440,
    name: "Bk244",
    latex: "^{244}\\mathrm{Bk}",
    mass: 227345.2751615,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972440,
    name: "Bk244~",
    latex: "^{244}\\mathrm{\\overline{Bk}}",
    mass: 227345.2751615,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972450,
    name: "Bk245",
    latex: "^{245}\\mathrm{Bk}",
    mass: 228277.8691735,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972450,
    name: "Bk245~",
    latex: "^{245}\\mathrm{\\overline{Bk}}",
    mass: 228277.8691735,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972460,
    name: "Bk246",
    latex: "^{246}\\mathrm{Bk}",
    mass: 229211.5152149,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972460,
    name: "Bk246~",
    latex: "^{246}\\mathrm{\\overline{Bk}}",
    mass: 229211.5152149,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972470,
    name: "Bk247",
    latex: "^{247}\\mathrm{Bk}",
    mass: 230144.5332429,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972470,
    name: "Bk247~",
    latex: "^{247}\\mathrm{\\overline{Bk}}",
    mass: 230144.5332429,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972480,
    name: "Bk248",
    latex: "^{248}\\mathrm{Bk}",
    mass: 231078.667201,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972480,
    name: "Bk248~",
    latex: "^{248}\\mathrm{\\overline{Bk}}",
    mass: 231078.667201,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972490,
    name: "Bk249",
    latex: "^{249}\\mathrm{Bk}",
    mass: 232011.8781415,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972490,
    name: "Bk249~",
    latex: "^{249}\\mathrm{\\overline{Bk}}",
    mass: 232011.8781415,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972500,
    name: "Bk250",
    latex: "^{250}\\mathrm{Bk}",
    mass: 232946.4777534,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972500,
    name: "Bk250~",
    latex: "^{250}\\mathrm{\\overline{Bk}}",
    mass: 232946.4777534,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972510,
    name: "Bk251",
    latex: "^{251}\\mathrm{Bk}",
    mass: 233880.2484287,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972510,
    name: "Bk251~",
    latex: "^{251}\\mathrm{\\overline{Bk}}",
    mass: 233880.2484287,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972520,
    name: "Bk252",
    latex: "^{252}\\mathrm{Bk}",
    mass: 234815.048405,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972520,
    name: "Bk252~",
    latex: "^{252}\\mathrm{\\overline{Bk}}",
    mass: 234815.048405,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972530,
    name: "Bk253",
    latex: "^{253}\\mathrm{Bk}",
    mass: 235748.9364485,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972530,
    name: "Bk253~",
    latex: "^{253}\\mathrm{\\overline{Bk}}",
    mass: 235748.9364485,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000972540,
    name: "Bk254",
    latex: "^{254}\\mathrm{Bk}",
    mass: 236683.8957103,
    width: undefined,
    charge: 97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000972540,
    name: "Bk254~",
    latex: "^{254}\\mathrm{\\overline{Bk}}",
    mass: 236683.8957103,
    width: undefined,
    charge: -97.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982370,
    name: "Cf237",
    latex: "^{237}\\mathrm{Cf}",
    mass: 220822.0415146,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982370,
    name: "Cf237~",
    latex: "^{237}\\mathrm{\\overline{Cf}}",
    mass: 220822.0415146,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982380,
    name: "Cf238",
    latex: "^{238}\\mathrm{Cf}",
    mass: 221752.8742575,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982380,
    name: "Cf238~",
    latex: "^{238}\\mathrm{\\overline{Cf}}",
    mass: 221752.8742575,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982390,
    name: "Cf239",
    latex: "^{239}\\mathrm{Cf}",
    mass: 222685.2905403,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982390,
    name: "Cf239~",
    latex: "^{239}\\mathrm{\\overline{Cf}}",
    mass: 222685.2905403,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982400,
    name: "Cf240",
    latex: "^{240}\\mathrm{Cf}",
    mass: 223616.5731949,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982400,
    name: "Cf240~",
    latex: "^{240}\\mathrm{\\overline{Cf}}",
    mass: 223616.5731949,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982410,
    name: "Cf241",
    latex: "^{241}\\mathrm{Cf}",
    mass: 224549.4058556,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982410,
    name: "Cf241~",
    latex: "^{241}\\mathrm{\\overline{Cf}}",
    mass: 224549.4058556,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982420,
    name: "Cf242",
    latex: "^{242}\\mathrm{Cf}",
    mass: 225480.9605065,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982420,
    name: "Cf242~",
    latex: "^{242}\\mathrm{\\overline{Cf}}",
    mass: 225480.9605065,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982430,
    name: "Cf243",
    latex: "^{243}\\mathrm{Cf}",
    mass: 226414.0614375,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982430,
    name: "Cf243~",
    latex: "^{243}\\mathrm{\\overline{Cf}}",
    mass: 226414.0614375,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982440,
    name: "Cf244",
    latex: "^{244}\\mathrm{Cf}",
    mass: 227346.0393593,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982440,
    name: "Cf244~",
    latex: "^{244}\\mathrm{\\overline{Cf}}",
    mass: 227346.0393593,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982450,
    name: "Cf245",
    latex: "^{245}\\mathrm{Cf}",
    mass: 228279.440604,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982450,
    name: "Cf245~",
    latex: "^{245}\\mathrm{\\overline{Cf}}",
    mass: 228279.440604,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982460,
    name: "Cf246",
    latex: "^{246}\\mathrm{Cf}",
    mass: 229211.6397556,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982460,
    name: "Cf246~",
    latex: "^{246}\\mathrm{\\overline{Cf}}",
    mass: 229211.6397556,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982470,
    name: "Cf247",
    latex: "^{247}\\mathrm{Cf}",
    mass: 230145.1526865,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982470,
    name: "Cf247~",
    latex: "^{247}\\mathrm{\\overline{Cf}}",
    mass: 230145.1526865,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982480,
    name: "Cf248",
    latex: "^{248}\\mathrm{Cf}",
    mass: 231077.7757611,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982480,
    name: "Cf248~",
    latex: "^{248}\\mathrm{\\overline{Cf}}",
    mass: 231077.7757611,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982490,
    name: "Cf249",
    latex: "^{249}\\mathrm{Cf}",
    mass: 232011.7545322,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982490,
    name: "Cf249~",
    latex: "^{249}\\mathrm{\\overline{Cf}}",
    mass: 232011.7545322,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982500,
    name: "Cf250",
    latex: "^{250}\\mathrm{Cf}",
    mass: 232944.6962709,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982500,
    name: "Cf250~",
    latex: "^{250}\\mathrm{\\overline{Cf}}",
    mass: 232944.6962709,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982510,
    name: "Cf251",
    latex: "^{251}\\mathrm{Cf}",
    mass: 233879.1548546,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982510,
    name: "Cf251~",
    latex: "^{251}\\mathrm{\\overline{Cf}}",
    mass: 233879.1548546,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982520,
    name: "Cf252",
    latex: "^{252}\\mathrm{Cf}",
    mass: 234812.5487405,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982520,
    name: "Cf252~",
    latex: "^{252}\\mathrm{\\overline{Cf}}",
    mass: 234812.5487405,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982530,
    name: "Cf253",
    latex: "^{253}\\mathrm{Cf}",
    mass: 235747.3100598,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982530,
    name: "Cf253~",
    latex: "^{253}\\mathrm{\\overline{Cf}}",
    mass: 235747.3100598,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982540,
    name: "Cf254",
    latex: "^{254}\\mathrm{Cf}",
    mass: 236680.8441356,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982540,
    name: "Cf254~",
    latex: "^{254}\\mathrm{\\overline{Cf}}",
    mass: 236680.8441356,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982550,
    name: "Cf255",
    latex: "^{255}\\mathrm{Cf}",
    mass: 237615.8089864,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982550,
    name: "Cf255~",
    latex: "^{255}\\mathrm{\\overline{Cf}}",
    mass: 237615.8089864,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000982560,
    name: "Cf256",
    latex: "^{256}\\mathrm{Cf}",
    mass: 238549.529361,
    width: undefined,
    charge: 98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000982560,
    name: "Cf256~",
    latex: "^{256}\\mathrm{\\overline{Cf}}",
    mass: 238549.529361,
    width: undefined,
    charge: -98.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992400,
    name: "Es240",
    latex: "^{240}\\mathrm{Es}",
    mass: 223622.8114109,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992400,
    name: "Es240~",
    latex: "^{240}\\mathrm{\\overline{Es}}",
    mass: 223622.8114109,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992410,
    name: "Es241",
    latex: "^{241}\\mathrm{Es}",
    mass: 224553.9701767,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992410,
    name: "Es241~",
    latex: "^{241}\\mathrm{\\overline{Es}}",
    mass: 224553.9701767,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992420,
    name: "Es242",
    latex: "^{242}\\mathrm{Es}",
    mass: 225486.3771447,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992420,
    name: "Es242~",
    latex: "^{242}\\mathrm{\\overline{Es}}",
    mass: 225486.3771447,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992430,
    name: "Es243",
    latex: "^{243}\\mathrm{Es}",
    mass: 226417.8153588,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992430,
    name: "Es243~",
    latex: "^{243}\\mathrm{\\overline{Es}}",
    mass: 226417.8153588,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992440,
    name: "Es244",
    latex: "^{244}\\mathrm{Es}",
    mass: 227350.5856094,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992440,
    name: "Es244~",
    latex: "^{244}\\mathrm{\\overline{Es}}",
    mass: 227350.5856094,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992450,
    name: "Es245",
    latex: "^{245}\\mathrm{Es}",
    mass: 228282.3684763,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992450,
    name: "Es245~",
    latex: "^{245}\\mathrm{\\overline{Es}}",
    mass: 228282.3684763,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992460,
    name: "Es246",
    latex: "^{246}\\mathrm{Es}",
    mass: 229215.3716005,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992460,
    name: "Es246~",
    latex: "^{246}\\mathrm{\\overline{Es}}",
    mass: 229215.3716005,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992470,
    name: "Es247",
    latex: "^{247}\\mathrm{Es}",
    mass: 230147.6220774,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992470,
    name: "Es247~",
    latex: "^{247}\\mathrm{\\overline{Es}}",
    mass: 230147.6220774,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992480,
    name: "Es248",
    latex: "^{248}\\mathrm{Es}",
    mass: 231080.8375822,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992480,
    name: "Es248~",
    latex: "^{248}\\mathrm{\\overline{Es}}",
    mass: 231080.8375822,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992490,
    name: "Es249",
    latex: "^{249}\\mathrm{Es}",
    mass: 232013.2072904,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992490,
    name: "Es249~",
    latex: "^{249}\\mathrm{\\overline{Es}}",
    mass: 232013.2072904,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992500,
    name: "Es250",
    latex: "^{250}\\mathrm{Es}",
    mass: 232946.7506811,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992500,
    name: "Es250~",
    latex: "^{250}\\mathrm{\\overline{Es}}",
    mass: 232946.7506811,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992510,
    name: "Es251",
    latex: "^{251}\\mathrm{Es}",
    mass: 233879.5311782,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992510,
    name: "Es251~",
    latex: "^{251}\\mathrm{\\overline{Es}}",
    mass: 233879.5311782,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992520,
    name: "Es252",
    latex: "^{252}\\mathrm{Es}",
    mass: 234813.8095178,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992520,
    name: "Es252~",
    latex: "^{252}\\mathrm{\\overline{Es}}",
    mass: 234813.8095178,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992530,
    name: "Es253",
    latex: "^{253}\\mathrm{Es}",
    mass: 235747.0186885,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992530,
    name: "Es253~",
    latex: "^{253}\\mathrm{\\overline{Es}}",
    mass: 235747.0186885,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992540,
    name: "Es254",
    latex: "^{254}\\mathrm{Es}",
    mass: 236681.4961815,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992540,
    name: "Es254~",
    latex: "^{254}\\mathrm{\\overline{Es}}",
    mass: 236681.4961815,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992550,
    name: "Es255",
    latex: "^{255}\\mathrm{Es}",
    mass: 237615.086147,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992550,
    name: "Es255~",
    latex: "^{255}\\mathrm{\\overline{Es}}",
    mass: 237615.086147,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992560,
    name: "Es256",
    latex: "^{256}\\mathrm{Es}",
    mass: 238549.6784001,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992560,
    name: "Es256~",
    latex: "^{256}\\mathrm{\\overline{Es}}",
    mass: 238549.6784001,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1000992570,
    name: "Es257",
    latex: "^{257}\\mathrm{Es}",
    mass: 239483.3894597,
    width: undefined,
    charge: 99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1000992570,
    name: "Es257~",
    latex: "^{257}\\mathrm{\\overline{Es}}",
    mass: 239483.3894597,
    width: undefined,
    charge: -99.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002420,
    name: "Fm242",
    latex: "^{242}\\mathrm{Fm}",
    mass: 225489.9727119,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002420,
    name: "Fm242~",
    latex: "^{242}\\mathrm{\\overline{Fm}}",
    mass: 225489.9727119,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002430,
    name: "Fm243",
    latex: "^{243}\\mathrm{Fm}",
    mass: 226422.3796799,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002430,
    name: "Fm243~",
    latex: "^{243}\\mathrm{\\overline{Fm}}",
    mass: 226422.3796799,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002440,
    name: "Fm244",
    latex: "^{244}\\mathrm{Fm}",
    mass: 227353.5291308,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002440,
    name: "Fm244~",
    latex: "^{244}\\mathrm{\\overline{Fm}}",
    mass: 227353.5291308,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002450,
    name: "Fm245",
    latex: "^{245}\\mathrm{Fm}",
    mass: 228286.2434918,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002450,
    name: "Fm245~",
    latex: "^{245}\\mathrm{\\overline{Fm}}",
    mass: 228286.2434918,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002460,
    name: "Fm246",
    latex: "^{246}\\mathrm{Fm}",
    mass: 229217.74039,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002460,
    name: "Fm246~",
    latex: "^{246}\\mathrm{\\overline{Fm}}",
    mass: 229217.74039,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002470,
    name: "Fm247",
    latex: "^{247}\\mathrm{Fm}",
    mass: 230150.7127748,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002470,
    name: "Fm247~",
    latex: "^{247}\\mathrm{\\overline{Fm}}",
    mass: 230150.7127748,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002480,
    name: "Fm248",
    latex: "^{248}\\mathrm{Fm}",
    mass: 231082.4350946,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002480,
    name: "Fm248~",
    latex: "^{248}\\mathrm{\\overline{Fm}}",
    mass: 231082.4350946,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002490,
    name: "Fm249",
    latex: "^{249}\\mathrm{Fm}",
    mass: 232015.5509296,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002490,
    name: "Fm249~",
    latex: "^{249}\\mathrm{\\overline{Fm}}",
    mass: 232015.5509296,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002500,
    name: "Fm250",
    latex: "^{250}\\mathrm{Fm}",
    mass: 232947.5983408,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002500,
    name: "Fm250~",
    latex: "^{250}\\mathrm{\\overline{Fm}}",
    mass: 232947.5983408,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002510,
    name: "Fm251",
    latex: "^{251}\\mathrm{Fm}",
    mass: 233880.97872,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002510,
    name: "Fm251~",
    latex: "^{251}\\mathrm{\\overline{Fm}}",
    mass: 233880.97872,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002520,
    name: "Fm252",
    latex: "^{252}\\mathrm{Fm}",
    mass: 234813.3307298,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002520,
    name: "Fm252~",
    latex: "^{252}\\mathrm{\\overline{Fm}}",
    mass: 234813.3307298,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002530,
    name: "Fm253",
    latex: "^{253}\\mathrm{Fm}",
    mass: 235747.3537469,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002530,
    name: "Fm253~",
    latex: "^{253}\\mathrm{\\overline{Fm}}",
    mass: 235747.3537469,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002540,
    name: "Fm254",
    latex: "^{254}\\mathrm{Fm}",
    mass: 236680.404843,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002540,
    name: "Fm254~",
    latex: "^{254}\\mathrm{\\overline{Fm}}",
    mass: 236680.404843,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002550,
    name: "Fm255",
    latex: "^{255}\\mathrm{Fm}",
    mass: 237614.7964523,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002550,
    name: "Fm255~",
    latex: "^{255}\\mathrm{\\overline{Fm}}",
    mass: 237614.7964523,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002560,
    name: "Fm256",
    latex: "^{256}\\mathrm{Fm}",
    mass: 238547.9756288,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002560,
    name: "Fm256~",
    latex: "^{256}\\mathrm{\\overline{Fm}}",
    mass: 238547.9756288,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002570,
    name: "Fm257",
    latex: "^{257}\\mathrm{Fm}",
    mass: 239482.5744024,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002570,
    name: "Fm257~",
    latex: "^{257}\\mathrm{\\overline{Fm}}",
    mass: 239482.5744024,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002580,
    name: "Fm258",
    latex: "^{258}\\mathrm{Fm}",
    mass: 240415.908207,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002580,
    name: "Fm258~",
    latex: "^{258}\\mathrm{\\overline{Fm}}",
    mass: 240415.908207,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001002590,
    name: "Fm259",
    latex: "^{259}\\mathrm{Fm}",
    mass: 241350.6811699,
    width: undefined,
    charge: 100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001002590,
    name: "Fm259~",
    latex: "^{259}\\mathrm{\\overline{Fm}}",
    mass: 241350.6811699,
    width: undefined,
    charge: -100.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012450,
    name: "Md245",
    latex: "^{245}\\mathrm{Md}",
    mass: 228291.3760243,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012450,
    name: "Md245~",
    latex: "^{245}\\mathrm{\\overline{Md}}",
    mass: 228291.3760243,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012460,
    name: "Md246",
    latex: "^{246}\\mathrm{Md}",
    mass: 229223.661898,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012460,
    name: "Md246~",
    latex: "^{246}\\mathrm{\\overline{Md}}",
    mass: 229223.661898,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012470,
    name: "Md247",
    latex: "^{247}\\mathrm{Md}",
    mass: 230154.9790178,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012470,
    name: "Md247~",
    latex: "^{247}\\mathrm{\\overline{Md}}",
    mass: 230154.9790178,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012480,
    name: "Md248",
    latex: "^{248}\\mathrm{Md}",
    mass: 231087.4884501,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012480,
    name: "Md248~",
    latex: "^{248}\\mathrm{\\overline{Md}}",
    mass: 231087.4884501,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012490,
    name: "Md249",
    latex: "^{249}\\mathrm{Md}",
    mass: 232019.2154274,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012490,
    name: "Md249~",
    latex: "^{249}\\mathrm{\\overline{Md}}",
    mass: 232019.2154274,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012500,
    name: "Md250",
    latex: "^{250}\\mathrm{Md}",
    mass: 232951.9204734,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012500,
    name: "Md250~",
    latex: "^{250}\\mathrm{\\overline{Md}}",
    mass: 232951.9204734,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012510,
    name: "Md251",
    latex: "^{251}\\mathrm{Md}",
    mass: 233883.9865145,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012510,
    name: "Md251~",
    latex: "^{251}\\mathrm{\\overline{Md}}",
    mass: 233883.9865145,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012520,
    name: "Md252",
    latex: "^{252}\\mathrm{Md}",
    mass: 234816.9859127,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012520,
    name: "Md252~",
    latex: "^{252}\\mathrm{\\overline{Md}}",
    mass: 234816.9859127,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012530,
    name: "Md253",
    latex: "^{253}\\mathrm{Md}",
    mass: 235749.178637,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012530,
    name: "Md253~",
    latex: "^{253}\\mathrm{\\overline{Md}}",
    mass: 235749.178637,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012540,
    name: "Md254",
    latex: "^{254}\\mathrm{Md}",
    mass: 236682.9549013,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012540,
    name: "Md254~",
    latex: "^{254}\\mathrm{\\overline{Md}}",
    mass: 236682.9549013,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012550,
    name: "Md255",
    latex: "^{255}\\mathrm{Md}",
    mass: 237615.8387942,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012550,
    name: "Md255~",
    latex: "^{255}\\mathrm{\\overline{Md}}",
    mass: 237615.8387942,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012560,
    name: "Md256",
    latex: "^{256}\\mathrm{Md}",
    mass: 238549.9485334,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012560,
    name: "Md256~",
    latex: "^{256}\\mathrm{\\overline{Md}}",
    mass: 238549.9485334,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012570,
    name: "Md257",
    latex: "^{257}\\mathrm{Md}",
    mass: 239482.9770873,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012570,
    name: "Md257~",
    latex: "^{257}\\mathrm{\\overline{Md}}",
    mass: 239482.9770873,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012580,
    name: "Md258",
    latex: "^{258}\\mathrm{Md}",
    mass: 240417.16945,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012580,
    name: "Md258~",
    latex: "^{258}\\mathrm{\\overline{Md}}",
    mass: 240417.16945,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012590,
    name: "Md259",
    latex: "^{259}\\mathrm{Md}",
    mass: 241350.5414458,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012590,
    name: "Md259~",
    latex: "^{259}\\mathrm{\\overline{Md}}",
    mass: 241350.5414458,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001012600,
    name: "Md260",
    latex: "^{260}\\mathrm{Md}",
    mass: 242285.0163307,
    width: undefined,
    charge: 101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001012600,
    name: "Md260~",
    latex: "^{260}\\mathrm{\\overline{Md}}",
    mass: 242285.0163307,
    width: undefined,
    charge: -101.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022490,
    name: "No249",
    latex: "^{249}\\mathrm{No}",
    mass: 232023.8170082,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022490,
    name: "No249~",
    latex: "^{249}\\mathrm{\\overline{No}}",
    mass: 232023.8170082,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022500,
    name: "No250",
    latex: "^{250}\\mathrm{No}",
    mass: 232955.0968683,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022500,
    name: "No250~",
    latex: "^{250}\\mathrm{\\overline{No}}",
    mass: 232955.0968683,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022510,
    name: "No251",
    latex: "^{251}\\mathrm{No}",
    mass: 233887.8671189,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022510,
    name: "No251~",
    latex: "^{251}\\mathrm{\\overline{No}}",
    mass: 233887.8671189,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022520,
    name: "No252",
    latex: "^{252}\\mathrm{No}",
    mass: 234819.3854415,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022520,
    name: "No252~",
    latex: "^{252}\\mathrm{\\overline{No}}",
    mass: 234819.3854415,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022530,
    name: "No253",
    latex: "^{253}\\mathrm{No}",
    mass: 235752.3671413,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022530,
    name: "No253~",
    latex: "^{253}\\mathrm{\\overline{No}}",
    mass: 235752.3671413,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022540,
    name: "No254",
    latex: "^{254}\\mathrm{No}",
    mass: 236684.2254592,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022540,
    name: "No254~",
    latex: "^{254}\\mathrm{\\overline{No}}",
    mass: 236684.2254592,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022550,
    name: "No255",
    latex: "^{255}\\mathrm{No}",
    mass: 237617.8079727,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022550,
    name: "No255~",
    latex: "^{255}\\mathrm{\\overline{No}}",
    mass: 237617.8079727,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022560,
    name: "No256",
    latex: "^{256}\\mathrm{No}",
    mass: 238550.313679,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022560,
    name: "No256~",
    latex: "^{256}\\mathrm{\\overline{No}}",
    mass: 238550.313679,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022570,
    name: "No257",
    latex: "^{257}\\mathrm{No}",
    mass: 239484.2315304,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022570,
    name: "No257~",
    latex: "^{257}\\mathrm{\\overline{No}}",
    mass: 239484.2315304,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022580,
    name: "No258",
    latex: "^{258}\\mathrm{No}",
    mass: 240416.9607953,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022580,
    name: "No258~",
    latex: "^{258}\\mathrm{\\overline{No}}",
    mass: 240416.9607953,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022590,
    name: "No259",
    latex: "^{259}\\mathrm{No}",
    mass: 241351.0519046,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022590,
    name: "No259~",
    latex: "^{259}\\mathrm{\\overline{No}}",
    mass: 241351.0519046,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022600,
    name: "No260",
    latex: "^{260}\\mathrm{No}",
    mass: 242284.0755216,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022600,
    name: "No260~",
    latex: "^{260}\\mathrm{\\overline{No}}",
    mass: 242284.0755216,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022610,
    name: "No261",
    latex: "^{261}\\mathrm{No}",
    mass: 243218.4199973,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022610,
    name: "No261~",
    latex: "^{261}\\mathrm{\\overline{No}}",
    mass: 243218.4199973,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001022620,
    name: "No262",
    latex: "^{262}\\mathrm{No}",
    mass: 244151.5535307,
    width: undefined,
    charge: 102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001022620,
    name: "No262~",
    latex: "^{262}\\mathrm{\\overline{No}}",
    mass: 244151.5535307,
    width: undefined,
    charge: -102.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032510,
    name: "Lr251",
    latex: "^{251}\\mathrm{Lr}",
    mass: 233892.8506124,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032510,
    name: "Lr251~",
    latex: "^{251}\\mathrm{\\overline{Lr}}",
    mass: 233892.8506124,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032520,
    name: "Lr252",
    latex: "^{252}\\mathrm{Lr}",
    mass: 234825.0526516,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032520,
    name: "Lr252~",
    latex: "^{252}\\mathrm{\\overline{Lr}}",
    mass: 234825.0526516,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032530,
    name: "Lr253",
    latex: "^{253}\\mathrm{Lr}",
    mass: 235756.5281255,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032530,
    name: "Lr253~",
    latex: "^{253}\\mathrm{\\overline{Lr}}",
    mass: 235756.5281255,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032540,
    name: "Lr254",
    latex: "^{254}\\mathrm{Lr}",
    mass: 236689.1493371,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032540,
    name: "Lr254~",
    latex: "^{254}\\mathrm{\\overline{Lr}}",
    mass: 236689.1493371,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032550,
    name: "Lr255",
    latex: "^{255}\\mathrm{Lr}",
    mass: 237620.9433819,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032550,
    name: "Lr255~",
    latex: "^{255}\\mathrm{\\overline{Lr}}",
    mass: 237620.9433819,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032560,
    name: "Lr256",
    latex: "^{256}\\mathrm{Lr}",
    mass: 238554.2334062,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032560,
    name: "Lr256~",
    latex: "^{256}\\mathrm{\\overline{Lr}}",
    mass: 238554.2334062,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032570,
    name: "Lr257",
    latex: "^{257}\\mathrm{Lr}",
    mass: 239486.6496891,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032570,
    name: "Lr257~",
    latex: "^{257}\\mathrm{\\overline{Lr}}",
    mass: 239486.6496891,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032580,
    name: "Lr258",
    latex: "^{258}\\mathrm{Lr}",
    mass: 240420.2582844,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032580,
    name: "Lr258~",
    latex: "^{258}\\mathrm{\\overline{Lr}}",
    mass: 240420.2582844,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032590,
    name: "Lr259",
    latex: "^{259}\\mathrm{Lr}",
    mass: 241352.8236064,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032590,
    name: "Lr259~",
    latex: "^{259}\\mathrm{\\overline{Lr}}",
    mass: 241352.8236064,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032600,
    name: "Lr260",
    latex: "^{260}\\mathrm{Lr}",
    mass: 242286.7395948,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032600,
    name: "Lr260~",
    latex: "^{260}\\mathrm{\\overline{Lr}}",
    mass: 242286.7395948,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032610,
    name: "Lr261",
    latex: "^{261}\\mathrm{Lr}",
    mass: 243219.5191604,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032610,
    name: "Lr261~",
    latex: "^{261}\\mathrm{\\overline{Lr}}",
    mass: 243219.5191604,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032620,
    name: "Lr262",
    latex: "^{262}\\mathrm{Lr}",
    mass: 244153.5655579,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032620,
    name: "Lr262~",
    latex: "^{262}\\mathrm{\\overline{Lr}}",
    mass: 244153.5655579,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001032630,
    name: "Lr263",
    latex: "^{263}\\mathrm{Lr}",
    mass: 245086.6152568,
    width: undefined,
    charge: 103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001032630,
    name: "Lr263~",
    latex: "^{263}\\mathrm{\\overline{Lr}}",
    mass: 245086.6152568,
    width: undefined,
    charge: -103.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042530,
    name: "Rf253",
    latex: "^{253}\\mathrm{Rf}",
    mass: 235761.651343,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042530,
    name: "Rf253~",
    latex: "^{253}\\mathrm{\\overline{Rf}}",
    mass: 235761.651343,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042540,
    name: "Rf254",
    latex: "^{254}\\mathrm{Rf}",
    mass: 236692.7076445,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042540,
    name: "Rf254~",
    latex: "^{254}\\mathrm{\\overline{Rf}}",
    mass: 236692.7076445,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042550,
    name: "Rf255",
    latex: "^{255}\\mathrm{Rf}",
    mass: 237625.3288561,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042550,
    name: "Rf255~",
    latex: "^{255}\\mathrm{\\overline{Rf}}",
    mass: 237625.3288561,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042560,
    name: "Rf256",
    latex: "^{256}\\mathrm{Rf}",
    mass: 238556.712112,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042560,
    name: "Rf256~",
    latex: "^{256}\\mathrm{\\overline{Rf}}",
    mass: 238556.712112,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042570,
    name: "Rf257",
    latex: "^{257}\\mathrm{Rf}",
    mass: 239489.8512343,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042570,
    name: "Rf257~",
    latex: "^{257}\\mathrm{\\overline{Rf}}",
    mass: 239489.8512343,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042580,
    name: "Rf258",
    latex: "^{258}\\mathrm{Rf}",
    mass: 240421.8231945,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042580,
    name: "Rf258~",
    latex: "^{258}\\mathrm{\\overline{Rf}}",
    mass: 240421.8231945,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042590,
    name: "Rf259",
    latex: "^{259}\\mathrm{Rf}",
    mass: 241355.3386405,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042590,
    name: "Rf259~",
    latex: "^{259}\\mathrm{\\overline{Rf}}",
    mass: 241355.3386405,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042600,
    name: "Rf260",
    latex: "^{260}\\mathrm{Rf}",
    mass: 242287.6151992,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042600,
    name: "Rf260~",
    latex: "^{260}\\mathrm{\\overline{Rf}}",
    mass: 242287.6151992,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042610,
    name: "Rf261",
    latex: "^{261}\\mathrm{Rf}",
    mass: 243221.2796842,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042610,
    name: "Rf261~",
    latex: "^{261}\\mathrm{\\overline{Rf}}",
    mass: 243221.2796842,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042620,
    name: "Rf262",
    latex: "^{262}\\mathrm{Rf}",
    mass: 244153.8450061,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042620,
    name: "Rf262~",
    latex: "^{262}\\mathrm{\\overline{Rf}}",
    mass: 244153.8450061,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042630,
    name: "Rf263",
    latex: "^{263}\\mathrm{Rf}",
    mass: 245087.7051049,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042630,
    name: "Rf263~",
    latex: "^{263}\\mathrm{\\overline{Rf}}",
    mass: 245087.7051049,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001042640,
    name: "Rf264",
    latex: "^{264}\\mathrm{Rf}",
    mass: 246020.5219302,
    width: undefined,
    charge: 104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001042640,
    name: "Rf264~",
    latex: "^{264}\\mathrm{\\overline{Rf}}",
    mass: 246020.5219302,
    width: undefined,
    charge: -104.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001052550,
    name: "Db255",
    latex: "^{255}\\mathrm{Db}",
    mass: 237630.5917978,
    width: undefined,
    charge: 105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001052550,
    name: "Db255~",
    latex: "^{255}\\mathrm{\\overline{Db}}",
    mass: 237630.5917978,
    width: undefined,
    charge: -105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001052560,
    name: "Db256",
    latex: "^{256}\\mathrm{Db}",
    mass: 238562.7845221,
    width: undefined,
    charge: 105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001052560,
    name: "Db256~",
    latex: "^{256}\\mathrm{\\overline{Db}}",
    mass: 238562.7845221,
    width: undefined,
    charge: -105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001052570,
    name: "Db257",
    latex: "^{257}\\mathrm{Db}",
    mass: 239494.1389017,
    width: undefined,
    charge: 105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001052570,
    name: "Db257~",
    latex: "^{257}\\mathrm{\\overline{Db}}",
    mass: 239494.1389017,
    width: undefined,
    charge: -105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001052580,
    name: "Db258",
    latex: "^{258}\\mathrm{Db}",
    mass: 240426.9836719,
    width: undefined,
    charge: 105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001052580,
    name: "Db258~",
    latex: "^{258}\\mathrm{\\overline{Db}}",
    mass: 240426.9836719,
    width: undefined,
    charge: -105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001052590,
    name: "Db259",
    latex: "^{259}\\mathrm{Db}",
    mass: 241358.9621525,
    width: undefined,
    charge: 105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001052590,
    name: "Db259~",
    latex: "^{259}\\mathrm{\\overline{Db}}",
    mass: 241358.9621525,
    width: undefined,
    charge: -105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001052600,
    name: "Db260",
    latex: "^{260}\\mathrm{Db}",
    mass: 242292.1422606,
    width: undefined,
    charge: 105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001052600,
    name: "Db260~",
    latex: "^{260}\\mathrm{\\overline{Db}}",
    mass: 242292.1422606,
    width: undefined,
    charge: -105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001052610,
    name: "Db261",
    latex: "^{261}\\mathrm{Db}",
    mass: 243224.2697803,
    width: undefined,
    charge: 105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001052610,
    name: "Db261~",
    latex: "^{261}\\mathrm{\\overline{Db}}",
    mass: 243224.2697803,
    width: undefined,
    charge: -105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001052620,
    name: "Db262",
    latex: "^{262}\\mathrm{Db}",
    mass: 244157.7107067,
    width: undefined,
    charge: 105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001052620,
    name: "Db262~",
    latex: "^{262}\\mathrm{\\overline{Db}}",
    mass: 244157.7107067,
    width: undefined,
    charge: -105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001052630,
    name: "Db263",
    latex: "^{263}\\mathrm{Db}",
    mass: 245090.061785,
    width: undefined,
    charge: 105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001052630,
    name: "Db263~",
    latex: "^{263}\\mathrm{\\overline{Db}}",
    mass: 245090.061785,
    width: undefined,
    charge: -105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001052640,
    name: "Db264",
    latex: "^{264}\\mathrm{Db}",
    mass: 246023.7076401,
    width: undefined,
    charge: 105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001052640,
    name: "Db264~",
    latex: "^{264}\\mathrm{\\overline{Db}}",
    mass: 246023.7076401,
    width: undefined,
    charge: -105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001052650,
    name: "Db265",
    latex: "^{265}\\mathrm{Db}",
    mass: 246956.3195367,
    width: undefined,
    charge: 105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001052650,
    name: "Db265~",
    latex: "^{265}\\mathrm{\\overline{Db}}",
    mass: 246956.3195367,
    width: undefined,
    charge: -105.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001062580,
    name: "Sg258",
    latex: "^{258}\\mathrm{Sg}",
    mass: 240430.7748529,
    width: undefined,
    charge: 106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001062580,
    name: "Sg258~",
    latex: "^{258}\\mathrm{\\overline{Sg}}",
    mass: 240430.7748529,
    width: undefined,
    charge: -106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001062590,
    name: "Sg259",
    latex: "^{259}\\mathrm{Sg}",
    mass: 241363.4892139,
    width: undefined,
    charge: 106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001062590,
    name: "Sg259~",
    latex: "^{259}\\mathrm{\\overline{Sg}}",
    mass: 241363.4892139,
    width: undefined,
    charge: -106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001062600,
    name: "Sg260",
    latex: "^{260}\\mathrm{Sg}",
    mass: 242295.0140569,
    width: undefined,
    charge: 106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001062600,
    name: "Sg260~",
    latex: "^{260}\\mathrm{\\overline{Sg}}",
    mass: 242295.0140569,
    width: undefined,
    charge: -106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001062610,
    name: "Sg261",
    latex: "^{261}\\mathrm{Sg}",
    mass: 243227.9659489,
    width: undefined,
    charge: 106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001062610,
    name: "Sg261~",
    latex: "^{261}\\mathrm{\\overline{Sg}}",
    mass: 243227.9659489,
    width: undefined,
    charge: -106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001062620,
    name: "Sg262",
    latex: "^{262}\\mathrm{Sg}",
    mass: 244159.8242668,
    width: undefined,
    charge: 106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001062620,
    name: "Sg262~",
    latex: "^{262}\\mathrm{\\overline{Sg}}",
    mass: 244159.8242668,
    width: undefined,
    charge: -106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001062630,
    name: "Sg263",
    latex: "^{263}\\mathrm{Sg}",
    mass: 245093.1450305,
    width: undefined,
    charge: 106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001062630,
    name: "Sg263~",
    latex: "^{263}\\mathrm{\\overline{Sg}}",
    mass: 245093.1450305,
    width: undefined,
    charge: -106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001062640,
    name: "Sg264",
    latex: "^{264}\\mathrm{Sg}",
    mass: 246025.2259755,
    width: undefined,
    charge: 106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001062640,
    name: "Sg264~",
    latex: "^{264}\\mathrm{\\overline{Sg}}",
    mass: 246025.2259755,
    width: undefined,
    charge: -106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001062650,
    name: "Sg265",
    latex: "^{265}\\mathrm{Sg}",
    mass: 246958.7321064,
    width: undefined,
    charge: 106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001062650,
    name: "Sg265~",
    latex: "^{265}\\mathrm{\\overline{Sg}}",
    mass: 246958.7321064,
    width: undefined,
    charge: -106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001062660,
    name: "Sg266",
    latex: "^{266}\\mathrm{Sg}",
    mass: 247891.045925,
    width: undefined,
    charge: 106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001062660,
    name: "Sg266~",
    latex: "^{266}\\mathrm{\\overline{Sg}}",
    mass: 247891.045925,
    width: undefined,
    charge: -106.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001072600,
    name: "Bh260",
    latex: "^{260}\\mathrm{Bh}",
    mass: 242301.5876108,
    width: undefined,
    charge: 107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001072600,
    name: "Bh260~",
    latex: "^{260}\\mathrm{\\overline{Bh}}",
    mass: 242301.5876108,
    width: undefined,
    charge: -107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001072610,
    name: "Bh261",
    latex: "^{261}\\mathrm{Bh}",
    mass: 243233.0444547,
    width: undefined,
    charge: 107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001072610,
    name: "Bh261~",
    latex: "^{261}\\mathrm{\\overline{Bh}}",
    mass: 243233.0444547,
    width: undefined,
    charge: -107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001072620,
    name: "Bh262",
    latex: "^{262}\\mathrm{Bh}",
    mass: 244165.7029261,
    width: undefined,
    charge: 107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001072620,
    name: "Bh262~",
    latex: "^{262}\\mathrm{\\overline{Bh}}",
    mass: 244165.7029261,
    width: undefined,
    charge: -107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001072630,
    name: "Bh263",
    latex: "^{263}\\mathrm{Bh}",
    mass: 245097.4485332,
    width: undefined,
    charge: 107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001072630,
    name: "Bh263~",
    latex: "^{263}\\mathrm{\\overline{Bh}}",
    mass: 245097.4485332,
    width: undefined,
    charge: -107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001072640,
    name: "Bh264",
    latex: "^{264}\\mathrm{Bh}",
    mass: 246030.4050827,
    width: undefined,
    charge: 107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001072640,
    name: "Bh264~",
    latex: "^{264}\\mathrm{\\overline{Bh}}",
    mass: 246030.4050827,
    width: undefined,
    charge: -107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001072650,
    name: "Bh265",
    latex: "^{265}\\mathrm{Bh}",
    mass: 246962.3369886,
    width: undefined,
    charge: 107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001072650,
    name: "Bh265~",
    latex: "^{265}\\mathrm{\\overline{Bh}}",
    mass: 246962.3369886,
    width: undefined,
    charge: -107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001072660,
    name: "Bh266",
    latex: "^{266}\\mathrm{Bh}",
    mass: 247895.5357265,
    width: undefined,
    charge: 107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001072660,
    name: "Bh266~",
    latex: "^{266}\\mathrm{\\overline{Bh}}",
    mass: 247895.5357265,
    width: undefined,
    charge: -107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001072670,
    name: "Bh267",
    latex: "^{267}\\mathrm{Bh}",
    mass: 248827.6911911,
    width: undefined,
    charge: 107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001072670,
    name: "Bh267~",
    latex: "^{267}\\mathrm{\\overline{Bh}}",
    mass: 248827.6911911,
    width: undefined,
    charge: -107.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001082630,
    name: "Hs263",
    latex: "^{263}\\mathrm{Hs}",
    mass: 245102.6276404,
    width: undefined,
    charge: 108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001082630,
    name: "Hs263~",
    latex: "^{263}\\mathrm{\\overline{Hs}}",
    mass: 245102.6276404,
    width: undefined,
    charge: -108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001082640,
    name: "Hs264",
    latex: "^{264}\\mathrm{Hs}",
    mass: 246034.0099649,
    width: undefined,
    charge: 108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001082640,
    name: "Hs264~",
    latex: "^{264}\\mathrm{\\overline{Hs}}",
    mass: 246034.0099649,
    width: undefined,
    charge: -108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001082650,
    name: "Hs265",
    latex: "^{265}\\mathrm{Hs}",
    mass: 246966.8379681,
    width: undefined,
    charge: 108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001082650,
    name: "Hs265~",
    latex: "^{265}\\mathrm{\\overline{Hs}}",
    mass: 246966.8379681,
    width: undefined,
    charge: -108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001082660,
    name: "Hs266",
    latex: "^{266}\\mathrm{Hs}",
    mass: 247898.5714658,
    width: undefined,
    charge: 108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001082660,
    name: "Hs266~",
    latex: "^{266}\\mathrm{\\overline{Hs}}",
    mass: 247898.5714658,
    width: undefined,
    charge: -108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001082670,
    name: "Hs267",
    latex: "^{267}\\mathrm{Hs}",
    mass: 248831.5848364,
    width: undefined,
    charge: 108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001082670,
    name: "Hs267~",
    latex: "^{267}\\mathrm{\\overline{Hs}}",
    mass: 248831.5848364,
    width: undefined,
    charge: -108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001082680,
    name: "Hs268",
    latex: "^{268}\\mathrm{Hs}",
    mass: 249763.3863332,
    width: undefined,
    charge: 108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001082680,
    name: "Hs268~",
    latex: "^{268}\\mathrm{\\overline{Hs}}",
    mass: 249763.3863332,
    width: undefined,
    charge: -108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001082690,
    name: "Hs269",
    latex: "^{269}\\mathrm{Hs}",
    mass: 250696.4080873,
    width: undefined,
    charge: 108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001082690,
    name: "Hs269~",
    latex: "^{269}\\mathrm{\\overline{Hs}}",
    mass: 250696.4080873,
    width: undefined,
    charge: -108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001082770,
    name: "Hs277",
    latex: "^{277}\\mathrm{Hs}",
    mass: 258165.2395902,
    width: undefined,
    charge: 108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001082770,
    name: "Hs277~",
    latex: "^{277}\\mathrm{\\overline{Hs}}",
    mass: 258165.2395902,
    width: undefined,
    charge: -108.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001092650,
    name: "Mt265",
    latex: "^{265}\\mathrm{Mt}",
    mass: 246972.5647939,
    width: undefined,
    charge: 109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001092650,
    name: "Mt265~",
    latex: "^{265}\\mathrm{\\overline{Mt}}",
    mass: 246972.5647939,
    width: undefined,
    charge: -109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001092660,
    name: "Mt266",
    latex: "^{266}\\mathrm{Mt}",
    mass: 247905.102171,
    width: undefined,
    charge: 109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001092660,
    name: "Mt266~",
    latex: "^{266}\\mathrm{\\overline{Mt}}",
    mass: 247905.102171,
    width: undefined,
    charge: -109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001092670,
    name: "Mt267",
    latex: "^{267}\\mathrm{Mt}",
    mass: 248836.7173689,
    width: undefined,
    charge: 109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001092670,
    name: "Mt267~",
    latex: "^{267}\\mathrm{\\overline{Mt}}",
    mass: 248836.7173689,
    width: undefined,
    charge: -109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001092680,
    name: "Mt268",
    latex: "^{268}\\mathrm{Mt}",
    mass: 249769.5714541,
    width: undefined,
    charge: 109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001092680,
    name: "Mt268~",
    latex: "^{268}\\mathrm{\\overline{Mt}}",
    mass: 249769.5714541,
    width: undefined,
    charge: -109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001092690,
    name: "Mt269",
    latex: "^{269}\\mathrm{Mt}",
    mass: 250701.2145968,
    width: undefined,
    charge: 109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001092690,
    name: "Mt269~",
    latex: "^{269}\\mathrm{\\overline{Mt}}",
    mass: 250701.2145968,
    width: undefined,
    charge: -109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001092700,
    name: "Mt270",
    latex: "^{270}\\mathrm{Mt}",
    mass: 251634.1152566,
    width: undefined,
    charge: 109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001092700,
    name: "Mt270~",
    latex: "^{270}\\mathrm{\\overline{Mt}}",
    mass: 251634.1152566,
    width: undefined,
    charge: -109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001092710,
    name: "Mt271",
    latex: "^{271}\\mathrm{Mt}",
    mass: 252566.0005879,
    width: undefined,
    charge: 109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001092710,
    name: "Mt271~",
    latex: "^{271}\\mathrm{\\overline{Mt}}",
    mass: 252566.0005879,
    width: undefined,
    charge: -109.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001102670,
    name: "Ds267",
    latex: "^{267}\\mathrm{Ds}",
    mass: 248842.8093404,
    width: undefined,
    charge: 110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001102670,
    name: "Ds267~",
    latex: "^{267}\\mathrm{\\overline{Ds}}",
    mass: 248842.8093404,
    width: undefined,
    charge: -110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001102680,
    name: "Ds268",
    latex: "^{268}\\mathrm{Ds}",
    mass: 249774.0705706,
    width: undefined,
    charge: 110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001102680,
    name: "Ds268~",
    latex: "^{268}\\mathrm{\\overline{Ds}}",
    mass: 249774.0705706,
    width: undefined,
    charge: -110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001102690,
    name: "Ds269",
    latex: "^{269}\\mathrm{Ds}",
    mass: 250706.7476718,
    width: undefined,
    charge: 110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001102690,
    name: "Ds269~",
    latex: "^{269}\\mathrm{\\overline{Ds}}",
    mass: 250706.7476718,
    width: undefined,
    charge: -110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001102700,
    name: "Ds270",
    latex: "^{270}\\mathrm{Ds}",
    mass: 251638.0927365,
    width: undefined,
    charge: 110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001102700,
    name: "Ds270~",
    latex: "^{270}\\mathrm{\\overline{Ds}}",
    mass: 251638.0927365,
    width: undefined,
    charge: -110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001102710,
    name: "Ds271",
    latex: "^{271}\\mathrm{Ds}",
    mass: 252570.8536722,
    width: undefined,
    charge: 110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001102710,
    name: "Ds271~",
    latex: "^{271}\\mathrm{\\overline{Ds}}",
    mass: 252570.8536722,
    width: undefined,
    charge: -110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001102720,
    name: "Ds272",
    latex: "^{272}\\mathrm{Ds}",
    mass: 253502.4781851,
    width: undefined,
    charge: 110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001102720,
    name: "Ds272~",
    latex: "^{272}\\mathrm{\\overline{Ds}}",
    mass: 253502.4781851,
    width: undefined,
    charge: -110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001102730,
    name: "Ds273",
    latex: "^{273}\\mathrm{Ds}",
    mass: 254436.1799298,
    width: undefined,
    charge: 110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001102730,
    name: "Ds273~",
    latex: "^{273}\\mathrm{\\overline{Ds}}",
    mass: 254436.1799298,
    width: undefined,
    charge: -110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001102810,
    name: "Ds281",
    latex: "^{281}\\mathrm{Ds}",
    mass: 261903.1204997,
    width: undefined,
    charge: 110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001102810,
    name: "Ds281~",
    latex: "^{281}\\mathrm{\\overline{Ds}}",
    mass: 261903.1204997,
    width: undefined,
    charge: -110.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001112720,
    name: "Rg272",
    latex: "^{272}\\mathrm{Rg}",
    mass: 253509.1663127,
    width: undefined,
    charge: 111.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001112720,
    name: "Rg272~",
    latex: "^{272}\\mathrm{\\overline{Rg}}",
    mass: 253509.1663127,
    width: undefined,
    charge: -111.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001122850,
    name: "Cn285",
    latex: "^{285}\\mathrm{Cn}",
    mass: 265640.9082598,
    width: undefined,
    charge: 112.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001122850,
    name: "Cn285~",
    latex: "^{285}\\mathrm{\\overline{Cn}}",
    mass: 265640.9082598,
    width: undefined,
    charge: -112.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001132860,
    name: "Nh286",
    latex: "^{286}\\mathrm{Nh}",
    mass: 266577.2740777,
    width: undefined,
    charge: 113.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001132860,
    name: "Nh286~",
    latex: "^{286}\\mathrm{\\overline{Nh}}",
    mass: 266577.2740777,
    width: undefined,
    charge: -113.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001142890,
    name: "Fl289",
    latex: "^{289}\\mathrm{Fl}",
    mass: 269379.2642313,
    width: undefined,
    charge: 114.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001142890,
    name: "Fl289~",
    latex: "^{289}\\mathrm{\\overline{Fl}}",
    mass: 269379.2642313,
    width: undefined,
    charge: -114.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001152890,
    name: "Mc289",
    latex: "^{289}\\mathrm{Mc}",
    mass: 269382.477886,
    width: undefined,
    charge: 115.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001152890,
    name: "Mc289~",
    latex: "^{289}\\mathrm{\\overline{Mc}}",
    mass: 269382.477886,
    width: undefined,
    charge: -115.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001162930,
    name: "Lv293",
    latex: "^{293}\\mathrm{Lv}",
    mass: 273118.3374533,
    width: undefined,
    charge: 116.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001162930,
    name: "Lv293~",
    latex: "^{293}\\mathrm{\\overline{Lv}}",
    mass: 273118.3374533,
    width: undefined,
    charge: -116.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001172940,
    name: "Ts294",
    latex: "^{294}\\mathrm{Ts}",
    mass: 274055.6627101,
    width: undefined,
    charge: 117.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001172940,
    name: "Ts294~",
    latex: "^{294}\\mathrm{\\overline{Ts}}",
    mass: 274055.6627101,
    width: undefined,
    charge: -117.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: 1001182940,
    name: "Og294",
    latex: "^{294}\\mathrm{Og}",
    mass: 274058.5876016,
    width: undefined,
    charge: 118.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  },
  {
    pdg: -1001182940,
    name: "Og294~",
    latex: "^{294}\\mathrm{\\overline{Og}}",
    mass: 274058.5876016,
    width: undefined,
    charge: -118.0,
    iValue: undefined,
    gValue: 5,
    cValue: 5,
    pValue: 5,
    anti: true
  }
];

exports.data = data;
/* No side effect */
